function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("2WNCY", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>(parcelRequire("f2M3o")).VersionDetailSpa);
    var $f2M3o;
});
parcelRegister("f2M3o", function(module, exports) {
    $parcel$export(module.exports, "VersionDetailSpa", ()=>$fe2055dca29e8a0e$export$4232c14770c47725);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $gEFwt;
    var $39xOx;
    var $koVbs;
    var $dAfqg;
    var $ao2h1;
    var $kt0pG;
    var $chANy;
    var $9id9B;
    var $9dbF6;
    var $9NiTW;
    var $doZTA;
    var $b6w0L;
    var $49dAD;
    const $fe2055dca29e8a0e$export$4232c14770c47725 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ match: match }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const projectKey = match.params.projectKey ?? '';
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const onExperienceFail = (0, (0, parcelRequire("chANy")).useViewVersionDetailsPageExperienceFail)();
        const { queryReference: queryReference } = (0, (0, parcelRequire("ao2h1")).useRelayResource)((0, (0, parcelRequire("kt0pG")).versionDetailsRelayResourceCustom));
        const releasesHomeUrl = `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin%3Arelease-page`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("chANy")).VersionDetailsPageExperienceStart), {
            experienceId: projectKey
        }), queryReference === null ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "pageContent",
            packageName: "jiraSpaAppsSoftwareReleasesVersionDetails",
            teamName: "fusion-solaris",
            extraEventData: {
                isSimplifiedProject: projectContext?.simplified ?? false
            },
            onError: (location, error)=>{
                onExperienceFail(location, error, {
                    isNetworkError: (0, (0, parcelRequire("49dAD")).isNetworkError)(error)
                });
            },
            attributes: (error)=>({
                    isNetworkError: (0, (0, parcelRequire("49dAD")).isNetworkError)(error),
                    isSimplifiedProject: projectContext?.simplified ?? false
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "software"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEFwt")).default), {
            baseUrl: "",
            projectKey: projectKey,
            projectName: projectContext?.projectName ?? ''
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                text: formatMessage((0, (0, parcelRequire("b6w0L")).default).releases),
                href: releasesHomeUrl
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9id9B")).VersionDetail), {
            queryReference: queryReference
        }))))));
    };
});
parcelRegister("chANy", function(module, exports) {
    $parcel$export(module.exports, "VersionDetailsPageExperienceStart", ()=>$9214ece296a6e241$export$87a9bc4e7a50039a);
    $parcel$export(module.exports, "useViewVersionDetailsPageExperienceFail", ()=>$9214ece296a6e241$export$f9fb921f60393679);
    $parcel$export(module.exports, "ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker", ()=>$9214ece296a6e241$export$c2bfafdc422ffc0a);
    var $5uXOq = parcelRequire("5uXOq");
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    var $kL4o0;
    const $9214ece296a6e241$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME = 'viewVersionDetailsPage';
    const $9214ece296a6e241$export$87a9bc4e7a50039a = ({ experienceId: experienceId })=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaHBi")).ExperienceStart), {
            experienceId: experienceId,
            experience: $9214ece296a6e241$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
            analyticsSource: "versionDetails",
            edition: appEditions.software,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE)
        });
    };
    const $9214ece296a6e241$export$f9fb921f60393679 = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $9214ece296a6e241$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
        });
    const $9214ece296a6e241$export$1a84e8ad118354e4 = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: $9214ece296a6e241$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
        });
    const $9214ece296a6e241$export$c2bfafdc422ffc0a = ({ reason: reason })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: $9214ece296a6e241$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
            attributes: {
                reason: reason
            }
        });
    const $9214ece296a6e241$export$ab0e4c71ad46eacd = ()=>{
        const projectInfo = (0, (0, parcelRequire("kL4o0")).useProjectAnalyticsAttributes)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: $9214ece296a6e241$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
            attributes: {
                ...projectInfo
            }
        });
    };
});
parcelRegister("kL4o0", function(module, exports) {
    $parcel$export(module.exports, "useProjectContextResource", ()=>$1b87a11fa464d7a3$export$a3138047c831fa4e);
    $parcel$export(module.exports, "useProjectContext", ()=>$1b87a11fa464d7a3$export$8f31c2503e1efa93);
    $parcel$export(module.exports, "useProjectAnalyticsAttributes", ()=>$1b87a11fa464d7a3$export$b6a91b2d78273787);
    var $kUACW;
    var $dxCvy;
    var $g5X3G;
    var $2YP9W;
    const $1b87a11fa464d7a3$export$a3138047c831fa4e = (0, (0, parcelRequire("kUACW")).withSuspense)(()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource)));
    const $1b87a11fa464d7a3$export$8f31c2503e1efa93 = ()=>{
        const { data: data, error: error } = $1b87a11fa464d7a3$export$a3138047c831fa4e();
        if (data == null) throw new Error(`data of useProjectContext via withSuspense shouldn't be null. If projectContext is null, this means an invalid project key was provided and the page should return a 404 and useProjectContext should never be called. error: ${error !== null ? error.message : 'null'}`);
        return {
            ...data,
            projectKey: (0, (0, parcelRequire("g5X3G")).toProjectKey)(data.projectKey),
            projectId: (0, (0, parcelRequire("g5X3G")).toProjectId)(data.projectId.toString())
        };
    };
    const $1b87a11fa464d7a3$export$b6a91b2d78273787 = ()=>{
        const { projectId: projectId, isProjectAdmin: isProjectAdmin, simplified: simplified } = $1b87a11fa464d7a3$export$8f31c2503e1efa93();
        return {
            isSimplified: simplified,
            isProjectAdmin: isProjectAdmin,
            projectId: projectId
        };
    };
});
parcelRegister("kUACW", function(module, exports) {
    $parcel$export(module.exports, "withSuspense", ()=>$4c5a941fc6e9229e$export$a3bce93d4fb4eda6);
    const $4c5a941fc6e9229e$var$isDataEmpty = (data)=>data == null;
    function $4c5a941fc6e9229e$export$a3bce93d4fb4eda6(theHook) {
        return (...args)=>{
            const result = theHook(...args);
            if (!false && $4c5a941fc6e9229e$var$isDataEmpty(result.data) && result.loading) throw result.promise;
            return result;
        };
    }
});
parcelRegister("9id9B", function(module, exports) {
    $parcel$export(module.exports, "VersionDetail", ()=>$971a1d1547e83ef9$export$7ef104a5ca9287b8);
    var $fl8Ey;
    var $kCzfF;
    var $eRSB5;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $gwIPs;
    var $beRD7;
    var $jcw0u;
    var $4R6GH;
    var $ew1Lk;
    var $koVbs;
    var $1othz;
    var $lfTZh;
    var $dXq4S;
    var $jDrwg;
    var $iXVV6;
    var $5oFIy;
    var $btxzI;
    var $ajHh6;
    var $4UYYD;
    var $8qTNX;
    var $kfztd;
    var $93kRE;
    var $jX1s1;
    var $b940d;
    var $4c6NH;
    var $2vbty;
    var $dE7QH;
    var $4btcM;
    var $3hn4w;
    var $20fNh;
    var $dLRv1;
    var $kKpgF;
    var $4i4ip;
    var $4MIM1;
    var $gvbk2;
    var $iMhWR;
    var $koeKL;
    var $cCXos;
    var $fCXaV;
    var $gpsfL;
    var $lODMY;
    var $bmKPg;
    var $kHzKl;
    var $gl1Tm;
    var $47ffb;
    var $chANy;
    var $kL4o0;
    var $greDE;
    var $jpznh;
    var $fs1tp;
    var $6rc5u;
    var $dcsLh;
    const $971a1d1547e83ef9$var$getVersionIdState = (versionId)=>{
        const correctedVersionId = versionId.replace(/\D/g, '');
        if (correctedVersionId.length === 0) return {
            state: 'INVALID'
        };
        if (correctedVersionId.length !== versionId.length) return {
            state: 'CORRECTED',
            correctedVersionId: correctedVersionId
        };
        return {
            state: 'VALID'
        };
    };
    const $971a1d1547e83ef9$export$d5910e6123a77411 = ({ jiraVersion: jiraVersion, devOps: devOps })=>{
        const [state] = (0, (0, parcelRequire("2vbty")).useSidebarStore)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [designQueryRef, loadDesignQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("4UYYD")).default));
        const [relatedWorkQueryRef, loadRelatedWorkQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("ajHh6")).default));
        const [versionProgressQueryRef, loadVersionProgressQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("btxzI")).default));
        const onViewRelatedWorkExperienceFail = (0, (0, parcelRequire("4i4ip")).useViewVersionRelatedWorkExperienceFail)();
        const onLaunchCardExperienceFail = (0, (0, parcelRequire("4btcM")).useLaunchCardExperienceFail)();
        const onVersionApproversCardExperienceFail = (0, (0, parcelRequire("b940d")).useVersionApproversCardExperienceFail)();
        const onIssueAssociatedDesignsExperienceFail = (0, (0, parcelRequire("cCXos")).useIssueAssociatedDesignsExperienceFail)();
        const { currentTabId: currentTabId } = (0, (0, parcelRequire("47ffb")).useCurrentTab)();
        const devOpsData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("eRSB5")).default), devOps);
        const [version, refetch] = (0, $8Uumt.useRefetchableFragment)((0, (0, parcelRequire("kCzfF")).default), jiraVersion);
        const designProviderLength = (devOpsData?.providers?.designProviders ?? []).length;
        (0, $5uXOq.useEffect)(()=>{
            if (designProviderLength > 0 && designQueryRef == null) {
                loadDesignQuery({
                    versionAri: version.id,
                    cloudAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira',
                        resourceType: 'site',
                        resourceId: cloudId
                    })
                });
                loadRelatedWorkQuery({
                    versionAri: version.id,
                    isDevopsFeatureDisabledInFedRamp: (0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)()
                });
                loadVersionProgressQuery({
                    versionAri: version.id,
                    isDevopsFeatureDisabledInFedRamp: (0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)()
                });
            }
        }, [
            cloudId,
            designProviderLength,
            designQueryRef,
            loadDesignQuery,
            loadRelatedWorkQuery,
            loadVersionProgressQuery,
            version.id
        ]);
        const { filters: filters, sortBy: sortBy } = (0, (0, parcelRequire("20fNh")).useVersionIssuesGraphQLVariables)();
        const [suspenselessRefetch, isRefetchLoading] = (0, (0, parcelRequire("1othz")).useSuspenselessRefetch)((0, (0, parcelRequire("8qTNX")).default), refetch, {
            fetchPolicy: 'network-only'
        });
        const [debouncedRefetchVersion] = (0, (0, parcelRequire("jDrwg")).default)(()=>{
            suspenselessRefetch({
                id: version.id,
                isDevopsFeatureDisabledInFedRamp: (0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)(),
                isIssueSummarisedDeploymentsMigratedToAgs: (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re'),
                shouldIncludeDevOpsFieldsViaAgs: !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re'),
                ...(0, (0, parcelRequire("gl1Tm")).convertTabToQueryVariables)(currentTabId),
                filters: filters,
                sortBy: sortBy
            });
        }, 500);
        const ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED = 'software-version-detail-embed';
        const isEmbedRoute = (0, (0, parcelRequire("lODMY")).useIsActiveRoute)(ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED);
        const isIssueClosed = state.status === 'CLOSED';
        const isIssueSectionCollapsed = (version.collapsedUis ?? []).includes('ISSUES');
        const issueListFooterRef = (0, $5uXOq.useRef)(null);
        const [isIssueListFooterPinned, setIsIssueListFooterPinned] = (0, $5uXOq.useState)(false);
        const handleScroll = ()=>{
            const issueListFooter = issueListFooterRef.current;
            if (issueListFooter) {
                const footerRect = issueListFooter.getBoundingClientRect();
                setIsIssueListFooterPinned(footerRect.top + footerRect.height >= window.innerHeight);
            }
        };
        const issueListContent = (0, ($parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$IssueListMinHeightContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dLRv1")).IssueListWithHeaderWithErrorBoundary), {
            jiraVersion: version
        }), !isIssueSectionCollapsed && version?.canAddAndRemoveIssues && version?.allIssues?.totalCount ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            fallback: "flag",
            eventLocation: "addIssuesToVersion"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$IssueListFooterContentWrapper, {
            isPinned: isIssueListFooterPinned,
            ref: issueListFooterRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX1s1")).AddIssuesToVersion), {
            appearance: "subtle",
            isIssueListFooterButton: true,
            jiraVersion: version,
            showIcon: true
        }))) : null);
        const shouldRenderDesignSection = !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && designProviderLength > 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$VersionDetailsWrapper, {
            isIssueClosed: isIssueClosed,
            onScroll: handleScroll
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kKpgF")).RefetchContext).Provider, {
            value: {
                isLoading: isRefetchLoading,
                refetch: debouncedRefetchVersion
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4btcM")).LaunchCardExperienceStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$ContainerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$MainContentContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fs1tp")).Header), {
            jiraVersion: version,
            shouldShowBreadcrumbs: !isEmbedRoute,
            shouldShowAutomationButton: !isEmbedRoute,
            shouldShowFeedbackButton: !isEmbedRoute,
            shouldShowGraphButton: !isEmbedRoute
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            fallback: "flag",
            eventLocation: "richTextSection"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iMhWR")).AsyncVersionRichTextSection), {
            jiraVersion: version
        })), !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            fallback: "flag",
            eventLocation: "relatedWork",
            onError: onViewRelatedWorkExperienceFail
        }, relatedWorkQueryRef == null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gvbk2")).RelatedWorkLoadingSkeleton), null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jira-releases-version-details-related-work",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gvbk2")).RelatedWorkLoadingSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4MIM1")).RelatedWork), {
            queryRef: relatedWorkQueryRef
        }))), shouldRenderDesignSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            fallback: "flag",
            eventLocation: "issueAssociatedDesigns",
            onError: onIssueAssociatedDesignsExperienceFail
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cCXos")).IssueAssociatedDesignsExperienceStart), null), designQueryRef == null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCXaV")).DesignSectionSkeleton), null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jira-releases-version-details-designs",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCXaV")).DesignSectionSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fCXaV")).IssueAssociatedDesigns), {
            queryRef: designQueryRef
        }))), issueListContent), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dcsLh")).RightSidebar), {
            jiraVersion: version
        }, isIssueClosed && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            fallback: "flag",
            eventLocation: "launchCard",
            onError: onLaunchCardExperienceFail
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$SidebarCard, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3hn4w")).LaunchCard), {
            jiraVersion: version
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            fallback: "flag",
            eventLocation: "approversCard",
            onError: onVersionApproversCardExperienceFail
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b940d")).VersionApproversCardExperienceStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$SidebarCard, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4c6NH")).Approvers), {
            jiraVersion: version
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            fallback: "flag",
            eventLocation: "progressCard"
        }, versionProgressQueryRef != null && (0, ($parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$SidebarCard, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jira-releases-version-details-progress-indicator",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gpsfL")).VersionProgress), {
            queryRef: versionProgressQueryRef
        }))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            fallback: "flag",
            eventLocation: "issueSidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dE7QH")).IssueSidebar), null))))));
    };
    const $971a1d1547e83ef9$export$7ef104a5ca9287b8 = ({ queryReference: queryReference })=>{
        const hasFiredErrorAnalytics = (0, $5uXOq.useRef)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: projectContext } = (0, (0, parcelRequire("kL4o0")).useProjectContextResource)();
        const { jira: jira, devOps: devOps } = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("fl8Ey")).default), queryReference);
        const [versionId, setVersionId] = (0, (0, parcelRequire("bmKPg")).usePathParam)('versionId');
        (0, $5uXOq.useEffect)(()=>{
            if (versionId != null) {
                const versionIdState = $971a1d1547e83ef9$var$getVersionIdState(versionId);
                if (versionIdState.state === 'CORRECTED') setVersionId(versionIdState.correctedVersionId, 'replace');
                if (versionIdState.state === 'INVALID' && !hasFiredErrorAnalytics.current) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'jira.releases.version.detail.invalid.version.id',
                            packageName: 'jiraSoftwareReleasesVersionDetail',
                            teamName: 'fusion-solaris'
                        },
                        error: Error(`Invalid version id in path param. Version id: ${String(versionId)}`),
                        sendToPrivacyUnsafeSplunk: true
                    });
                    hasFiredErrorAnalytics.current = true;
                }
            }
        }, [
            setVersionId,
            versionId
        ]);
        if (projectContext == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).NotFoundErrorPageAsync), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("chANy")).ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker), {
            reason: "No Project found"
        }));
        if (!jira && versionId != null && $971a1d1547e83ef9$var$getVersionIdState(versionId).state === 'INVALID') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).NotFoundErrorPageAsync), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("chANy")).ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker), {
            reason: "No Version found"
        }));
        if (!jira) throw Error("Relay: Missing @required value at path 'jira' in 'uiVersionDetailsQuery'");
        const { version: version } = jira;
        if (version.__typename !== 'JiraVersion') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).NotFoundErrorPageAsync), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("chANy")).ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker), {
            reason: "No Version found"
        }));
        const { simplified: simplified, isProjectAdmin: isProjectAdmin, projectId: projectId, projectKey: projectKey, projectName: projectName } = projectContext;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jpznh")).AccessCheck), {
            jiraVersion: version
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            attributes: {
                simplified: simplified,
                isProjectAdmin: isProjectAdmin,
                projectId: projectId,
                versionStatus: version.status
            },
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "versionDetails"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("greDE")).PerformanceTracker), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4i4ip")).VersionRelatedWorkExperienceStart), {
            experienceId: projectKey
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("93kRE")).ViewFeatureFlagsEmptyStateExperienceExperienceStart), {
            experienceId: projectKey
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$export$d5910e6123a77411, {
            jiraVersion: version,
            devOps: devOps ?? null
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("6rc5u")).default).browserTitle, {
                projectName: projectName,
                versionName: version.name
            })
        })));
    };
    const $971a1d1547e83ef9$var$ISSUE_HEADER_AND_FILTERS_SECTION_OFFSET = (0, (0, parcelRequire("gwIPs")).gridSize) * 14.75;
    const $971a1d1547e83ef9$var$LEFT_CONTAINER_MIN_WIDTH = 496;
    const $971a1d1547e83ef9$var$ContainerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _kqswh2mm _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _c71l1osq _4t3i1osq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $971a1d1547e83ef9$var$MainContentContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul91dft _19bvzwfg _u5f31tcg _1reo15vq _18m91wug _16jlkb7n _1o9zkb7n _i0dl1osq",
                __cmplp.className
            ])
        });
    });
    const $971a1d1547e83ef9$var$IssueListMinHeightContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1tke1aj4",
                __cmplp.className
            ])
        });
    });
    const $971a1d1547e83ef9$var$VersionDetailsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isIssueClosed: isIssueClosed, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_c71l1osq _4t3i1osq _1e0c1txw _2lx21bp4",
                __cmplp.isIssueClosed ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
                __cmplp.className
            ])
        });
    });
    const $971a1d1547e83ef9$var$SidebarCard = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1l7b _189et94y _1dqonqa1 _1h6dhloo",
                __cmplp.className
            ])
        });
    });
    const $971a1d1547e83ef9$var$IssueListFooterContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isPinned: isPinned, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q75w2r _94n5idpf _1e0c1txw _2lx21bp4 _4t3it9kd _1bah1h6o _kqsw1if8 _1bsb1osq",
                __cmplp.isPinned ? "_x3do1l7n" : "_x3doglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fl8Ey", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2dc798c18cd35135$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    const $2dc798c18cd35135$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filters"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isIssueSummarisedDeploymentsMigratedToAgs"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldIncludeDevOpsFieldsViaAgs"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sortBy"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionAri"
        }, v8 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "versionAri"
            }
        ], v9 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v10 = {
            "kind": "ScalarField",
            "name": "name"
        }, v11 = {
            "kind": "ScalarField",
            "name": "status"
        }, v12 = {
            "kind": "ScalarField",
            "name": "id"
        }, v13 = {
            "kind": "ScalarField",
            "name": "collapsedUis"
        }, v14 = {
            "kind": "Literal",
            "name": "filter",
            "value": "ALL"
        }, v15 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v16 = [
            v15
        ], v17 = {
            "kind": "ScalarField",
            "name": "canEdit"
        }, v18 = {
            "kind": "ScalarField",
            "name": "key"
        }, v19 = {
            "kind": "ScalarField",
            "name": "accountId"
        }, v20 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v21 = {
            "kind": "ScalarField",
            "name": "description"
        }, v22 = [
            v14,
            {
                "kind": "Variable",
                "name": "filters",
                "variableName": "filters"
            },
            {
                "kind": "Literal",
                "name": "first",
                "value": 20
            },
            {
                "kind": "Variable",
                "name": "sortBy",
                "variableName": "sortBy"
            }
        ], v23 = {
            "kind": "ScalarField",
            "name": "count"
        }, v24 = {
            "kind": "ScalarField",
            "name": "state"
        }, v25 = {
            "concreteType": "DevOpsSummarisedBuildState",
            "kind": "LinkedField",
            "name": "buildStates",
            "plural": true,
            "selections": [
                v24,
                v23
            ]
        }, v26 = [
            v23
        ], v27 = {
            "concreteType": "DevOpsSummarisedFeatureFlags",
            "kind": "LinkedField",
            "name": "summarisedFeatureFlags",
            "plural": false,
            "selections": [
                v15,
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantDisplayName"
                },
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantEnabled"
                },
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantRolloutPercentage"
                }
            ]
        }, v28 = {
            "kind": "ScalarField",
            "name": "title"
        }, v29 = [
            v23,
            v12
        ], v30 = {
            "concreteType": "DevOpsSummarisedDeployments",
            "kind": "LinkedField",
            "name": "summarisedDeployments",
            "plural": false,
            "selections": v29
        }, v31 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v32 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v33 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 100
            }
        ], v34 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7
                ],
                "kind": "Fragment",
                "name": "uiVersionDetailsQuery",
                "selections": [
                    {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_devOps"
                            }
                        ]
                    },
                    {
                        "condition": "skip",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v8,
                                                "kind": "LinkedField",
                                                "name": "version",
                                                "plural": false,
                                                "selections": [
                                                    v9,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v10,
                                                            v11,
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                                                            },
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "accessCheck_softwareReleasesVersionDetail"
                                                            }
                                                        ],
                                                        "type": "JiraVersion"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.version"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v7,
                    v5,
                    v6,
                    v1,
                    v2,
                    v3,
                    v4
                ],
                "kind": "Operation",
                "name": "uiVersionDetailsQuery",
                "selections": [
                    {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "isDevopsFeatureDisabledInFedRamp",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "id",
                                                "variableName": "cloudAri"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "providerTypes",
                                                "value": [
                                                    "DESIGN"
                                                ]
                                            }
                                        ],
                                        "concreteType": "DevOpsProviders",
                                        "kind": "LinkedField",
                                        "name": "providers",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "DevOpsDesignProvider",
                                                "kind": "LinkedField",
                                                "name": "designProviders",
                                                "plural": true,
                                                "selections": [
                                                    v9,
                                                    v12
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "skip",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8,
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v9,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v10,
                                                    v11,
                                                    v12,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "canAddAndRemoveIssues"
                                                    },
                                                    v13,
                                                    {
                                                        "alias": "allIssues",
                                                        "args": [
                                                            v14
                                                        ],
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": v16,
                                                        "storageKey": "issues(filter:\"ALL\")"
                                                    },
                                                    v17,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "startDate"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "releaseDate"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "versionId"
                                                    },
                                                    {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                            v18,
                                                            v12,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "projectId"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "cloudId"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraVersionDriverResult",
                                                        "kind": "LinkedField",
                                                        "name": "driverData",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "driver",
                                                                "plural": false,
                                                                "selections": [
                                                                    v9,
                                                                    v19,
                                                                    v10,
                                                                    v20,
                                                                    v12
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "QueryError",
                                                                "kind": "LinkedField",
                                                                "name": "queryError",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "message"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v21,
                                                    {
                                                        "concreteType": "JiraVersionWarningConfig",
                                                        "kind": "LinkedField",
                                                        "name": "warningConfig",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "openPullRequest"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "openReview"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "unreviewedCode"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "failingBuild"
                                                            },
                                                            v17
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraVersionConnectAddonIframeData",
                                                        "kind": "LinkedField",
                                                        "name": "connectAddonIframeData",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "appKey"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "moduleKey"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "appName"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "location"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "options"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "canViewDevTools"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "versionIssueTableHiddenColumns"
                                                    },
                                                    {
                                                        "alias": "issuesForList",
                                                        "args": v22,
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": [
                                                            v15,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "jql"
                                                            },
                                                            {
                                                                "concreteType": "JiraIssueEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v18,
                                                                            v12,
                                                                            {
                                                                                "args": [
                                                                                    {
                                                                                        "kind": "Literal",
                                                                                        "name": "ids",
                                                                                        "value": [
                                                                                            "priority",
                                                                                            "summary",
                                                                                            "assignee",
                                                                                            "status",
                                                                                            "issuetype"
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "fieldsById",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v9,
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "fieldId"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraStatus",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "status",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "concreteType": "JiraStatusCategory",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "statusCategory",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "ScalarField",
                                                                                                                                "name": "statusCategoryId"
                                                                                                                            },
                                                                                                                            v12
                                                                                                                        ]
                                                                                                                    },
                                                                                                                    v12,
                                                                                                                    v10,
                                                                                                                    v21
                                                                                                                ]
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraStatusField"
                                                                                                    },
                                                                                                    v12,
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "user",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v9,
                                                                                                                    v20,
                                                                                                                    v10,
                                                                                                                    v12
                                                                                                                ]
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraSingleSelectUserPickerField"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "text"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraSingleLineTextField"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraIssueType",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "issueType",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v10,
                                                                                                                    {
                                                                                                                        "concreteType": "JiraAvatar",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "avatar",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "ScalarField",
                                                                                                                                "name": "xsmall"
                                                                                                                            }
                                                                                                                        ]
                                                                                                                    },
                                                                                                                    v12
                                                                                                                ]
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraIssueTypeField"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraPriority",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "priority",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v10,
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "iconUrl"
                                                                                                                    },
                                                                                                                    v12
                                                                                                                ]
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraPriorityField"
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "issueId"
                                                                            },
                                                                            v9,
                                                                            {
                                                                                "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                                "kind": "Condition",
                                                                                "passingValue": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "DevOpsSummarisedEntities",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "devOpsSummarisedEntities",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "DevOpsSummarisedBuilds",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "summarisedBuilds",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v23,
                                                                                                    v25,
                                                                                                    v12
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "DevOpsSummarisedDeployments",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "summarisedDeployments",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "DevOpsEnvironment",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "deploymentEnvironment",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "category"
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "deploymentState"
                                                                                                    },
                                                                                                    v12
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                                                "kind": "Condition",
                                                                                                "passingValue": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "DevOpsSummarisedDeployments",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "summarisedDeployments",
                                                                                                        "plural": false,
                                                                                                        "selections": v26
                                                                                                    },
                                                                                                    v27
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraIssueDevSummaryResult",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "devSummaryCache",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueDevSummary",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "devSummary",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "pullrequest",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "overall",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v23,
                                                                                                                    v24
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "branch",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraIssueBranchDevSummary",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "overall",
                                                                                                                "plural": false,
                                                                                                                "selections": v26
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "review",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraIssueReviewDevSummary",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "overall",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v23,
                                                                                                                    v24,
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "lastUpdated"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "stateCount"
                                                                                                                    }
                                                                                                                ]
                                                                                                            },
                                                                                                            {
                                                                                                                "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "summaryByProvider",
                                                                                                                "plural": true,
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "providerId"
                                                                                                                    },
                                                                                                                    v10,
                                                                                                                    v23
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "commit",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraIssueCommitDevSummary",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "overall",
                                                                                                                "plural": false,
                                                                                                                "selections": v26
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "build",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraIssueBuildDevSummary",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "overall",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v23,
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "failedBuildCount"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "successfulBuildCount"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "unknownBuildCount"
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "deploymentEnvironments",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "overall",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "topEnvironments",
                                                                                                                        "plural": true,
                                                                                                                        "selections": [
                                                                                                                            v11,
                                                                                                                            v28
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                                        "kind": "Condition",
                                                                                        "passingValue": true,
                                                                                        "selections": [
                                                                                            v30,
                                                                                            {
                                                                                                "concreteType": "DevOpsSummarisedBuilds",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "summarisedBuilds",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v25,
                                                                                                    v23,
                                                                                                    v12
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                                        "kind": "Condition",
                                                                                        "passingValue": true,
                                                                                        "selections": [
                                                                                            v27
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": [
                                                                                    v30,
                                                                                    {
                                                                                        "concreteType": "DevOpsSummarisedBuilds",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "summarisedBuilds",
                                                                                        "plural": false,
                                                                                        "selections": v29
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "summarisedFeatureFlags",
                                                                                        "plural": false,
                                                                                        "selections": v16
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v31
                                                                ]
                                                            },
                                                            v32
                                                        ]
                                                    },
                                                    {
                                                        "alias": "issuesForList",
                                                        "args": v22,
                                                        "filters": [
                                                            "filter",
                                                            "sortBy",
                                                            "filters"
                                                        ],
                                                        "handle": "connection",
                                                        "key": "ListVersion_issuesForList",
                                                        "kind": "LinkedHandle",
                                                        "name": "issues"
                                                    },
                                                    {
                                                        "alias": "allIssuesRedesignTemp",
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": v16
                                                    },
                                                    v13,
                                                    {
                                                        "args": v33,
                                                        "concreteType": "JiraVersionApproverConnection",
                                                        "kind": "LinkedField",
                                                        "name": "approvers",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraVersionApproverEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersionApprover",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v12,
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "user",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v9,
                                                                                    v10,
                                                                                    v20,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "extendedProfile",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "jobTitle"
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ],
                                                                                        "type": "AtlassianAccountUser"
                                                                                    },
                                                                                    v12,
                                                                                    v19
                                                                                ]
                                                                            },
                                                                            v11,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "declineReason"
                                                                            },
                                                                            v21,
                                                                            v34,
                                                                            v9
                                                                        ]
                                                                    },
                                                                    v31
                                                                ]
                                                            },
                                                            v32
                                                        ],
                                                        "storageKey": "approvers(first:100)"
                                                    },
                                                    {
                                                        "args": v33,
                                                        "handle": "connection",
                                                        "key": "version_approvers",
                                                        "kind": "LinkedHandle",
                                                        "name": "approvers"
                                                    },
                                                    {
                                                        "concreteType": "JiraVersionRichTextSection",
                                                        "kind": "LinkedField",
                                                        "name": "richTextSection",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraADF",
                                                                "kind": "LinkedField",
                                                                "name": "content",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "json"
                                                                    }
                                                                ]
                                                            },
                                                            v28
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "canViewVersionDetailsPage"
                                                    },
                                                    {
                                                        "condition": "isDevopsFeatureDisabledInFedRamp",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "DevOpsSummarisedEntities",
                                                                "kind": "LinkedField",
                                                                "name": "devOpsSummarisedEntities",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsProviders",
                                                                        "kind": "LinkedField",
                                                                        "name": "providers",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "DevOpsFeatureFlagProvider",
                                                                                "kind": "LinkedField",
                                                                                "name": "featureFlagProviders",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v9,
                                                                                    v12,
                                                                                    v10,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "createFeatureFlagTemplateUrl"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "connectFeatureFlagTemplateUrl"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "logoUrl"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v34
                                                ],
                                                "type": "JiraVersion"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v12
                                                ],
                                                "type": "Node",
                                                "abstractKey": "__isNode"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "82741647e71f2cf9a8f9e0329b8b9192cd671f81a20c453bd333c79575469f60",
                "metadata": {},
                "name": "uiVersionDetailsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $2dc798c18cd35135$var$node.hash = "bd9f49cde5ae44cf7400b66e88a88e94";
    (0, $eiowN.PreloadableQueryRegistry).set($2dc798c18cd35135$var$node.params.id, $2dc798c18cd35135$var$node);
    var $2dc798c18cd35135$export$2e2bcd8739ae039 = $2dc798c18cd35135$var$node;
});
parcelRegister("kCzfF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27d857720731a78f$export$2e2bcd8739ae039);
    var $8qTNX;
    const $27d857720731a78f$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "filters"
            },
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            },
            {
                "kind": "RootArgument",
                "name": "isIssueSummarisedDeploymentsMigratedToAgs"
            },
            {
                "kind": "RootArgument",
                "name": "shouldIncludeDevOpsFieldsViaAgs"
            },
            {
                "kind": "RootArgument",
                "name": "sortBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, (0, parcelRequire("8qTNX")).default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "canAddAndRemoveIssues"
            },
            {
                "kind": "ScalarField",
                "name": "collapsedUis"
            },
            {
                "alias": "allIssues",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": "ALL"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    }
                ],
                "storageKey": "issues(filter:\"ALL\")"
            },
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesLaunchCard_LaunchCard"
            },
            {
                "kind": "FragmentSpread",
                "name": "header_softwareReleasesVersionDetail"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesApprovers_Approvers"
            },
            {
                "kind": "FragmentSpread",
                "name": "rightSidebar_softwareReleasesVersionDetail"
            },
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection"
            }
        ],
        "type": "JiraVersion"
    };
    $27d857720731a78f$var$node.hash = "18efada2730a05c083b285addf6cb338";
    var $27d857720731a78f$export$2e2bcd8739ae039 = $27d857720731a78f$var$node;
});
parcelRegister("8qTNX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b84c6917019bd5ee$export$2e2bcd8739ae039);
    const $b84c6917019bd5ee$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filters"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isIssueSummarisedDeploymentsMigratedToAgs"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldIncludeDevOpsFieldsViaAgs"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sortBy"
        }, v6 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
            }
        ], v7 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v8 = {
            "kind": "ScalarField",
            "name": "id"
        }, v9 = {
            "kind": "ScalarField",
            "name": "collapsedUis"
        }, v10 = {
            "kind": "Literal",
            "name": "filter",
            "value": "ALL"
        }, v11 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v12 = [
            v11
        ], v13 = {
            "kind": "ScalarField",
            "name": "canEdit"
        }, v14 = {
            "kind": "ScalarField",
            "name": "status"
        }, v15 = {
            "kind": "ScalarField",
            "name": "key"
        }, v16 = {
            "kind": "ScalarField",
            "name": "accountId"
        }, v17 = {
            "kind": "ScalarField",
            "name": "name"
        }, v18 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v19 = {
            "kind": "ScalarField",
            "name": "description"
        }, v20 = [
            v10,
            {
                "kind": "Variable",
                "name": "filters",
                "variableName": "filters"
            },
            {
                "kind": "Literal",
                "name": "first",
                "value": 20
            },
            {
                "kind": "Variable",
                "name": "sortBy",
                "variableName": "sortBy"
            }
        ], v21 = {
            "kind": "ScalarField",
            "name": "count"
        }, v22 = {
            "kind": "ScalarField",
            "name": "state"
        }, v23 = {
            "concreteType": "DevOpsSummarisedBuildState",
            "kind": "LinkedField",
            "name": "buildStates",
            "plural": true,
            "selections": [
                v22,
                v21
            ]
        }, v24 = [
            v21
        ], v25 = {
            "concreteType": "DevOpsSummarisedFeatureFlags",
            "kind": "LinkedField",
            "name": "summarisedFeatureFlags",
            "plural": false,
            "selections": [
                v11,
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantDisplayName"
                },
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantEnabled"
                },
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantRolloutPercentage"
                }
            ]
        }, v26 = {
            "kind": "ScalarField",
            "name": "title"
        }, v27 = [
            v21,
            v8
        ], v28 = {
            "concreteType": "DevOpsSummarisedDeployments",
            "kind": "LinkedField",
            "name": "summarisedDeployments",
            "plural": false,
            "selections": v27
        }, v29 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v30 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v31 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 100
            }
        ], v32 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5
                ],
                "kind": "Fragment",
                "name": "versionDetailPageRefetchQuery",
                "selections": [
                    {
                        "args": v6,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v2,
                    v3,
                    v4,
                    v5,
                    v1
                ],
                "kind": "Operation",
                "name": "versionDetailPageRefetchQuery",
                "selections": [
                    {
                        "args": v6,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v7,
                            v8,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "canAddAndRemoveIssues"
                                    },
                                    v9,
                                    {
                                        "alias": "allIssues",
                                        "args": [
                                            v10
                                        ],
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issues",
                                        "plural": false,
                                        "selections": v12,
                                        "storageKey": "issues(filter:\"ALL\")"
                                    },
                                    v13,
                                    {
                                        "kind": "ScalarField",
                                        "name": "startDate"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "releaseDate"
                                    },
                                    v14,
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionId"
                                    },
                                    {
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": [
                                            v15,
                                            v8,
                                            {
                                                "kind": "ScalarField",
                                                "name": "projectId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cloudId"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraVersionDriverResult",
                                        "kind": "LinkedField",
                                        "name": "driverData",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "driver",
                                                "plural": false,
                                                "selections": [
                                                    v7,
                                                    v16,
                                                    v17,
                                                    v18,
                                                    v8
                                                ]
                                            },
                                            {
                                                "concreteType": "QueryError",
                                                "kind": "LinkedField",
                                                "name": "queryError",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "message"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v19,
                                    v17,
                                    {
                                        "concreteType": "JiraVersionWarningConfig",
                                        "kind": "LinkedField",
                                        "name": "warningConfig",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "openPullRequest"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "openReview"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "unreviewedCode"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "failingBuild"
                                            },
                                            v13
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraVersionConnectAddonIframeData",
                                        "kind": "LinkedField",
                                        "name": "connectAddonIframeData",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "appKey"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "moduleKey"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "appName"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "location"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "options"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "canViewDevTools"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionIssueTableHiddenColumns"
                                    },
                                    {
                                        "alias": "issuesForList",
                                        "args": v20,
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issues",
                                        "plural": false,
                                        "selections": [
                                            v11,
                                            {
                                                "kind": "ScalarField",
                                                "name": "jql"
                                            },
                                            {
                                                "concreteType": "JiraIssueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v15,
                                                            v8,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "ids",
                                                                        "value": [
                                                                            "priority",
                                                                            "summary",
                                                                            "assignee",
                                                                            "status",
                                                                            "issuetype"
                                                                        ]
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueFieldConnection",
                                                                "kind": "LinkedField",
                                                                "name": "fieldsById",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v7,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "fieldId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraStatus",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "status",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraStatusCategory",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "statusCategory",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "statusCategoryId"
                                                                                                            },
                                                                                                            v8
                                                                                                        ]
                                                                                                    },
                                                                                                    v8,
                                                                                                    v17,
                                                                                                    v19
                                                                                                ]
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraStatusField"
                                                                                    },
                                                                                    v8,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "user",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v7,
                                                                                                    v18,
                                                                                                    v17,
                                                                                                    v8
                                                                                                ]
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraSingleSelectUserPickerField"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "text"
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraSingleLineTextField"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueType",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "issueType",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v17,
                                                                                                    {
                                                                                                        "concreteType": "JiraAvatar",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "avatar",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "xsmall"
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    v8
                                                                                                ]
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraIssueTypeField"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraPriority",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "priority",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v17,
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "iconUrl"
                                                                                                    },
                                                                                                    v8
                                                                                                ]
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraPriorityField"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "issueId"
                                                            },
                                                            v7,
                                                            {
                                                                "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                "kind": "Condition",
                                                                "passingValue": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSummarisedEntities",
                                                                        "kind": "LinkedField",
                                                                        "name": "devOpsSummarisedEntities",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "DevOpsSummarisedBuilds",
                                                                                "kind": "LinkedField",
                                                                                "name": "summarisedBuilds",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v21,
                                                                                    v23,
                                                                                    v8
                                                                                ]
                                                                            },
                                                                            {
                                                                                "concreteType": "DevOpsSummarisedDeployments",
                                                                                "kind": "LinkedField",
                                                                                "name": "summarisedDeployments",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "DevOpsEnvironment",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "deploymentEnvironment",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "category"
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "deploymentState"
                                                                                    },
                                                                                    v8
                                                                                ]
                                                                            },
                                                                            {
                                                                                "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                                "kind": "Condition",
                                                                                "passingValue": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "DevOpsSummarisedDeployments",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "summarisedDeployments",
                                                                                        "plural": false,
                                                                                        "selections": v24
                                                                                    },
                                                                                    v25
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraIssueDevSummaryResult",
                                                                        "kind": "LinkedField",
                                                                        "name": "devSummaryCache",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueDevSummary",
                                                                                "kind": "LinkedField",
                                                                                "name": "devSummary",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "pullrequest",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "overall",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v21,
                                                                                                    v22
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "branch",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueBranchDevSummary",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "overall",
                                                                                                "plural": false,
                                                                                                "selections": v24
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "review",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueReviewDevSummary",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "overall",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v21,
                                                                                                    v22,
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "lastUpdated"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "stateCount"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "summaryByProvider",
                                                                                                "plural": true,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "providerId"
                                                                                                    },
                                                                                                    v17,
                                                                                                    v21
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "commit",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueCommitDevSummary",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "overall",
                                                                                                "plural": false,
                                                                                                "selections": v24
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "build",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueBuildDevSummary",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "overall",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v21,
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "failedBuildCount"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "successfulBuildCount"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "unknownBuildCount"
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "deploymentEnvironments",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "overall",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "topEnvironments",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            v14,
                                                                                                            v26
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            v28,
                                                                            {
                                                                                "concreteType": "DevOpsSummarisedBuilds",
                                                                                "kind": "LinkedField",
                                                                                "name": "summarisedBuilds",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v23,
                                                                                    v21,
                                                                                    v8
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            v25
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    v28,
                                                                    {
                                                                        "concreteType": "DevOpsSummarisedBuilds",
                                                                        "kind": "LinkedField",
                                                                        "name": "summarisedBuilds",
                                                                        "plural": false,
                                                                        "selections": v27
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                        "kind": "LinkedField",
                                                                        "name": "summarisedFeatureFlags",
                                                                        "plural": false,
                                                                        "selections": v12
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v29
                                                ]
                                            },
                                            v30
                                        ]
                                    },
                                    {
                                        "alias": "issuesForList",
                                        "args": v20,
                                        "filters": [
                                            "filter",
                                            "sortBy",
                                            "filters"
                                        ],
                                        "handle": "connection",
                                        "key": "ListVersion_issuesForList",
                                        "kind": "LinkedHandle",
                                        "name": "issues"
                                    },
                                    {
                                        "alias": "allIssuesRedesignTemp",
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issues",
                                        "plural": false,
                                        "selections": v12
                                    },
                                    v9,
                                    {
                                        "args": v31,
                                        "concreteType": "JiraVersionApproverConnection",
                                        "kind": "LinkedField",
                                        "name": "approvers",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraVersionApproverEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionApprover",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v7,
                                                                    v17,
                                                                    v18,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                                "kind": "LinkedField",
                                                                                "name": "extendedProfile",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "jobTitle"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "type": "AtlassianAccountUser"
                                                                    },
                                                                    v8,
                                                                    v16
                                                                ]
                                                            },
                                                            v14,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "declineReason"
                                                            },
                                                            v19,
                                                            v32,
                                                            v7
                                                        ]
                                                    },
                                                    v29
                                                ]
                                            },
                                            v30
                                        ],
                                        "storageKey": "approvers(first:100)"
                                    },
                                    {
                                        "args": v31,
                                        "handle": "connection",
                                        "key": "version_approvers",
                                        "kind": "LinkedHandle",
                                        "name": "approvers"
                                    },
                                    {
                                        "concreteType": "JiraVersionRichTextSection",
                                        "kind": "LinkedField",
                                        "name": "richTextSection",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraADF",
                                                "kind": "LinkedField",
                                                "name": "content",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "json"
                                                    }
                                                ]
                                            },
                                            v26
                                        ]
                                    },
                                    {
                                        "condition": "isDevopsFeatureDisabledInFedRamp",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "concreteType": "DevOpsSummarisedEntities",
                                                "kind": "LinkedField",
                                                "name": "devOpsSummarisedEntities",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "DevOpsProviders",
                                                        "kind": "LinkedField",
                                                        "name": "providers",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "DevOpsFeatureFlagProvider",
                                                                "kind": "LinkedField",
                                                                "name": "featureFlagProviders",
                                                                "plural": true,
                                                                "selections": [
                                                                    v7,
                                                                    v8,
                                                                    v17,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "createFeatureFlagTemplateUrl"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "connectFeatureFlagTemplateUrl"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "logoUrl"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v32
                                ],
                                "type": "JiraVersion"
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "122e17b7a0863b5998f34b455c3bdf1c137b3dde9e7c6a1f96968769eb5d6ead",
                "metadata": {},
                "name": "versionDetailPageRefetchQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $b84c6917019bd5ee$var$node.hash = "18efada2730a05c083b285addf6cb338";
    var $b84c6917019bd5ee$export$2e2bcd8739ae039 = $b84c6917019bd5ee$var$node;
});
parcelRegister("eRSB5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c680c4cc86913a8$export$2e2bcd8739ae039);
    const $6c680c4cc86913a8$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudAri"
            },
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_devOps",
        "selections": [
            {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "id",
                                "variableName": "cloudAri"
                            },
                            {
                                "kind": "Literal",
                                "name": "providerTypes",
                                "value": [
                                    "DESIGN"
                                ]
                            }
                        ],
                        "concreteType": "DevOpsProviders",
                        "kind": "LinkedField",
                        "name": "providers",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "DevOpsDesignProvider",
                                "kind": "LinkedField",
                                "name": "designProviders",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "DevOps"
    };
    $6c680c4cc86913a8$var$node.hash = "72d5936bbd25e3ba21b829d9fbc1ac05";
    var $6c680c4cc86913a8$export$2e2bcd8739ae039 = $6c680c4cc86913a8$var$node;
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("1othz", function(module, exports) {
    $parcel$export(module.exports, "useSuspenselessRefetch", ()=>$7714fce489d6815b$export$c7ce5f64dc007896);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $biQrn;
    const $7714fce489d6815b$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
        const inFlightRequestsRef = (0, $5uXOq.useRef)([]);
        return (0, $5uXOq.useMemo)(()=>({
                onNewRequest: (request)=>{
                    inFlightRequestsRef.current.push(request);
                },
                onRequestFinish: (request, onIfRequestIsRelevant)=>{
                    const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                    if (inFlightRequestIndex !== -1) {
                        onIfRequestIsRelevant?.();
                        inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                        setIsLoading?.(!!inFlightRequestsRef.current.length);
                    }
                }
            }), [
            setIsLoading
        ]);
    };
    const $7714fce489d6815b$export$ae1adabf094b2244 = (query, refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const isMounted = (0, (0, parcelRequire("biQrn")).useIsMounted)();
        const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $7714fce489d6815b$var$useInFlightRequests({
            setIsLoading: setIsLoading
        });
        return (0, $5uXOq.useCallback)((variables)=>{
            if (isMounted.current) setIsLoading?.(true);
            onNewRequest(variables);
            return (0, $8Uumt.fetchQuery)(environment, query, variables, {
                fetchPolicy: fetchPolicy,
                networkCacheConfig: networkCacheConfig
            }).subscribe({
                complete () {
                    if (isMounted.current) {
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>refetch(variables, {
                                fetchPolicy: 'store-only'
                            }));
                    }
                },
                error (e) {
                    if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
                }
            });
        }, [
            environment,
            fetchPolicy,
            isMounted,
            networkCacheConfig,
            onNewRequest,
            onRequestFinish,
            query,
            refetch,
            setIsLoading,
            setLastFetchError
        ]);
    };
    const $7714fce489d6815b$export$c7ce5f64dc007896 = (query, refetch, options)=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [lastFetchError, setLastFetchError] = (0, $5uXOq.useState)(null);
        const refetchFunction = $7714fce489d6815b$export$ae1adabf094b2244(query, refetch, {
            ...options,
            setIsLoading: setIsLoading,
            setLastFetchError: setLastFetchError
        });
        return [
            refetchFunction,
            isLoading,
            lastFetchError
        ];
    };
});
parcelRegister("biQrn", function(module, exports) {
    $parcel$export(module.exports, "useIsMounted", ()=>$c6adaed2787020bf$export$80c2a3957bcb42ea);
    var $5uXOq = parcelRequire("5uXOq");
    const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
        const isMounted = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
            };
        }, [
            isMounted
        ]);
        return isMounted;
    };
});
parcelRegister("jDrwg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$049f084810e3e7c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
        const optionsRef = (0, $5uXOq.useRef)(options);
        const callbackRef = (0, $5uXOq.useRef)((...args)=>{
            callback(...args);
        });
        callbackRef.current = callback;
        const debouncedCallBack = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
            delay
        ]);
        (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
            debouncedCallBack
        ]);
        return [
            debouncedCallBack,
            debouncedCallBack.cancel
        ];
    }
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("btxzI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b5b47d858c9ff0d$export$2e2bcd8739ae039);
    const $1b5b47d858c9ff0d$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionAri"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "versionAri"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = [
            {
                "kind": "ScalarField",
                "name": "totalCount"
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "id"
        }, v6 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 100
            }
        ], v7 = [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "ui_softwareReleasesVersionProgressQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_versionProgress_VersionProgress"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.version"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "ui_softwareReleasesVersionProgressQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": "doneIssuesRedesignTemp",
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "filters",
                                                        "value": {
                                                            "statusCategories": [
                                                                "DONE"
                                                            ]
                                                        }
                                                    }
                                                ],
                                                "concreteType": "JiraIssueConnection",
                                                "kind": "LinkedField",
                                                "name": "issues",
                                                "plural": false,
                                                "selections": v4,
                                                "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                                            },
                                            {
                                                "alias": "inProgressIssuesRedesignTemp",
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "filters",
                                                        "value": {
                                                            "statusCategories": [
                                                                "IN_PROGRESS"
                                                            ]
                                                        }
                                                    }
                                                ],
                                                "concreteType": "JiraIssueConnection",
                                                "kind": "LinkedField",
                                                "name": "issues",
                                                "plural": false,
                                                "selections": v4,
                                                "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                                            },
                                            {
                                                "alias": "todoIssuesRedesignTemp",
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "filters",
                                                        "value": {
                                                            "statusCategories": [
                                                                "TODO"
                                                            ]
                                                        }
                                                    }
                                                ],
                                                "concreteType": "JiraIssueConnection",
                                                "kind": "LinkedField",
                                                "name": "issues",
                                                "plural": false,
                                                "selections": v4,
                                                "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                                            },
                                            {
                                                "concreteType": "JiraVersionWarningConfig",
                                                "kind": "LinkedField",
                                                "name": "warningConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "failingBuild"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "openPullRequest"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "openReview"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "unreviewedCode"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "warningsCount"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "collapsedUis"
                                            },
                                            v5,
                                            {
                                                "condition": "isDevopsFeatureDisabledInFedRamp",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "args": v6,
                                                        "concreteType": "JiraVersionRelatedWorkV2Connection",
                                                        "kind": "LinkedField",
                                                        "name": "relatedWorkV2",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraVersionRelatedWorkV2Edge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v3,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v7,
                                                                                "type": "JiraVersionRelatedWorkGenericLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v7,
                                                                                "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "cursor"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "PageInfo",
                                                                "kind": "LinkedField",
                                                                "name": "pageInfo",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "endCursor"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "hasNextPage"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "storageKey": "relatedWorkV2(first:100)"
                                                    },
                                                    {
                                                        "args": v6,
                                                        "handle": "connection",
                                                        "key": "version_relatedWorkV2",
                                                        "kind": "LinkedHandle",
                                                        "name": "relatedWorkV2"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraVersion"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v5
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "913fbb0382cf9cf095f853f6b818d4e8a47f615cd232275e0519fc5ae4eb57f1",
                "metadata": {},
                "name": "ui_softwareReleasesVersionProgressQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $1b5b47d858c9ff0d$var$node.hash = "67f2e201e7debdeea53f08cb0f8bb7b1";
    var $1b5b47d858c9ff0d$export$2e2bcd8739ae039 = $1b5b47d858c9ff0d$var$node;
});
parcelRegister("ajHh6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65583ade615fc325$export$2e2bcd8739ae039);
    const $65583ade615fc325$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionAri"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "versionAri"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 100
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "id"
        }, v6 = {
            "kind": "ScalarField",
            "name": "url"
        }, v7 = {
            "kind": "ScalarField",
            "name": "relatedWorkId"
        }, v8 = {
            "kind": "ScalarField",
            "name": "title"
        }, v9 = {
            "kind": "ScalarField",
            "name": "fieldId"
        }, v10 = {
            "kind": "ScalarField",
            "name": "name"
        }, v11 = {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "ids",
                            "value": [
                                "assignee",
                                "status"
                            ]
                        }
                    ],
                    "concreteType": "JiraIssueFieldConnection",
                    "kind": "LinkedField",
                    "name": "fieldsById",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v3,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v9,
                                                {
                                                    "concreteType": "JiraStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": [
                                                        v10,
                                                        {
                                                            "concreteType": "JiraStatusCategory",
                                                            "kind": "LinkedField",
                                                            "name": "statusCategory",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusCategoryId"
                                                                },
                                                                v5
                                                            ]
                                                        },
                                                        v5
                                                    ]
                                                }
                                            ],
                                            "type": "JiraStatusField"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v9,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                        v3,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v10,
                                                        v5
                                                    ]
                                                }
                                            ],
                                            "type": "JiraSingleSelectUserPickerField"
                                        },
                                        v5
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "fieldsById(ids:[\"assignee\",\"status\"])"
                }
            ]
        }, v12 = {
            "kind": "ScalarField",
            "name": "__id"
        }, v13 = {
            "kind": "ClientExtension",
            "selections": [
                v12,
                {
                    "kind": "ScalarField",
                    "name": "isSaving"
                }
            ]
        }, v14 = {
            "kind": "ClientExtension",
            "selections": [
                v12
            ]
        }, v15 = {
            "kind": "InlineFragment",
            "selections": [
                v14
            ],
            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
        }, v16 = {
            "kind": "InlineFragment",
            "selections": [
                v11,
                v15,
                v13
            ],
            "type": "JiraVersionRelatedWorkV2",
            "abstractKey": "__isJiraVersionRelatedWorkV2"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "condition": "isDevopsFeatureDisabledInFedRamp",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ui_softwareReleasesVersionRelatedWork_RelatedWork"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.version"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "condition": "isDevopsFeatureDisabledInFedRamp",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "args": v4,
                                                        "concreteType": "JiraVersionRelatedWorkV2Connection",
                                                        "kind": "LinkedField",
                                                        "name": "relatedWorkV2",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraVersionRelatedWorkV2Edge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    v3,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v3,
                                                                            {
                                                                                "kind": "TypeDiscriminator",
                                                                                "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "category"
                                                                            },
                                                                            {
                                                                                "concreteType": "JiraIssue",
                                                                                "kind": "LinkedField",
                                                                                "name": "issue",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v3,
                                                                                    v5
                                                                                ]
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v6,
                                                                                    v7,
                                                                                    v8,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v11,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v13
                                                                                                        ],
                                                                                                        "type": "JiraVersionRelatedWorkV2",
                                                                                                        "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                                                    },
                                                                                                    v14
                                                                                                ],
                                                                                                "type": "JiraVersionRelatedWorkGenericLink"
                                                                                            },
                                                                                            v15,
                                                                                            v13
                                                                                        ],
                                                                                        "type": "JiraVersionRelatedWorkV2",
                                                                                        "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                                    },
                                                                                    v14
                                                                                ],
                                                                                "type": "JiraVersionRelatedWorkGenericLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v7,
                                                                                    v6,
                                                                                    v8,
                                                                                    v16
                                                                                ],
                                                                                "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v8,
                                                                                    v16
                                                                                ],
                                                                                "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                                                                            },
                                                                            v14
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "cursor"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "PageInfo",
                                                                "kind": "LinkedField",
                                                                "name": "pageInfo",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "endCursor"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "hasNextPage"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "storageKey": "relatedWorkV2(first:100)"
                                                    },
                                                    {
                                                        "args": v4,
                                                        "handle": "connection",
                                                        "key": "version_relatedWorkV2",
                                                        "kind": "LinkedHandle",
                                                        "name": "relatedWorkV2"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "status"
                                                    },
                                                    v5,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "canEditRelatedWork"
                                                    },
                                                    {
                                                        "alias": "allIssues",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "filter",
                                                                "value": "ALL"
                                                            }
                                                        ],
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "totalCount"
                                                            }
                                                        ],
                                                        "storageKey": "issues(filter:\"ALL\")"
                                                    },
                                                    {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                            v5,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "projectId"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "versionId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "collapsedUis"
                                                    },
                                                    v14
                                                ],
                                                "type": "JiraVersion"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v5
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "9db46cbf2997d3ea44fe2ed14a797a64a0c1e3fb3cc94655c212c7e3245cef16",
                "metadata": {},
                "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $65583ade615fc325$var$node.hash = "d8d66158505126260b0811b2a2af5336";
    var $65583ade615fc325$export$2e2bcd8739ae039 = $65583ade615fc325$var$node;
});
parcelRegister("4UYYD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79c5edf8588bba6e$export$2e2bcd8739ae039);
    const $79c5edf8588bba6e$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudAri"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "versionAri"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "versionAri"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v3 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 6
            },
            {
                "kind": "Literal",
                "name": "sort",
                "value": {
                    "createdAt": {
                        "direction": "DESC",
                        "priority": 1
                    }
                }
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v5 = {
            "kind": "ScalarField",
            "name": "id"
        }, v6 = {
            "kind": "InlineFragment",
            "selections": [
                v5
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v1,
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v2,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "designCarousel_versionIssueAssociatedDesigns"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "args": v3,
                                                            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueAssociatedDesigns",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4,
                                                                    "action": "THROW",
                                                                    "path": "jira.version.issueAssociatedDesigns.totalCount"
                                                                }
                                                            ],
                                                            "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.version.issueAssociatedDesigns"
                                                    }
                                                ],
                                                "type": "JiraVersion"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.version"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "collapsedUis"
                                            },
                                            v5,
                                            {
                                                "args": v3,
                                                "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                                "kind": "LinkedField",
                                                "name": "issueAssociatedDesigns",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v2,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v5,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "url"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "displayName"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "lastUpdated"
                                                                            },
                                                                            {
                                                                                "args": [
                                                                                    {
                                                                                        "kind": "Variable",
                                                                                        "name": "id",
                                                                                        "variableName": "cloudAri"
                                                                                    }
                                                                                ],
                                                                                "kind": "LinkedField",
                                                                                "name": "provider",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v2,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "logoUrl"
                                                                                    },
                                                                                    v5
                                                                                ]
                                                                            },
                                                                            {
                                                                                "args": [
                                                                                    {
                                                                                        "kind": "Literal",
                                                                                        "name": "first",
                                                                                        "value": 2
                                                                                    }
                                                                                ],
                                                                                "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "associatedIssues",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v5,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "key"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "webUrl"
                                                                                                            },
                                                                                                            {
                                                                                                                "args": [
                                                                                                                    {
                                                                                                                        "kind": "Literal",
                                                                                                                        "name": "idsOrAliases",
                                                                                                                        "value": [
                                                                                                                            "issuetype",
                                                                                                                            "summary"
                                                                                                                        ]
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "Literal",
                                                                                                                        "name": "ignoreMissingFields",
                                                                                                                        "value": true
                                                                                                                    }
                                                                                                                ],
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "fieldsByIdOrAlias",
                                                                                                                "plural": true,
                                                                                                                "selections": [
                                                                                                                    v2,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "concreteType": "JiraIssueType",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "issueType",
                                                                                                                                "plural": false,
                                                                                                                                "selections": [
                                                                                                                                    {
                                                                                                                                        "kind": "ScalarField",
                                                                                                                                        "name": "name"
                                                                                                                                    },
                                                                                                                                    {
                                                                                                                                        "concreteType": "JiraAvatar",
                                                                                                                                        "kind": "LinkedField",
                                                                                                                                        "name": "avatar",
                                                                                                                                        "plural": false,
                                                                                                                                        "selections": [
                                                                                                                                            {
                                                                                                                                                "kind": "ScalarField",
                                                                                                                                                "name": "xsmall"
                                                                                                                                            }
                                                                                                                                        ]
                                                                                                                                    },
                                                                                                                                    v5
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraIssueTypeField"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "ScalarField",
                                                                                                                                "name": "text"
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraSingleLineTextField"
                                                                                                                    },
                                                                                                                    v5
                                                                                                                ],
                                                                                                                "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraIssue"
                                                                                                    },
                                                                                                    v2,
                                                                                                    v6
                                                                                                ]
                                                                                            },
                                                                                            v5
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "storageKey": "associatedIssues(first:2)"
                                                                            }
                                                                        ],
                                                                        "type": "DevOpsDesign"
                                                                    },
                                                                    v6
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "cursor"
                                                            },
                                                            v5
                                                        ]
                                                    },
                                                    v4,
                                                    {
                                                        "concreteType": "PageInfo",
                                                        "kind": "LinkedField",
                                                        "name": "pageInfo",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "endCursor"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "hasNextPage"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                                            },
                                            {
                                                "args": v3,
                                                "filters": [
                                                    "sort"
                                                ],
                                                "handle": "connection",
                                                "key": "DesignSlider_issueAssociatedDesigns",
                                                "kind": "LinkedHandle",
                                                "name": "issueAssociatedDesigns"
                                            },
                                            {
                                                "args": v3,
                                                "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                                "kind": "LinkedField",
                                                "name": "issueAssociatedDesigns",
                                                "plural": false,
                                                "selections": [
                                                    v4
                                                ],
                                                "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                                            }
                                        ],
                                        "type": "JiraVersion"
                                    },
                                    v6
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "ad0719c42dbb9679eb14945f0da1b989acf96db76cad39643540ecdce4c84b0c",
                "metadata": {},
                "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $79c5edf8588bba6e$var$node.hash = "6385dc34956a666103b9e7e3b549a2e3";
    var $79c5edf8588bba6e$export$2e2bcd8739ae039 = $79c5edf8588bba6e$var$node;
});
parcelRegister("93kRE", function(module, exports) {
    $parcel$export(module.exports, "ViewFeatureFlagsEmptyStateExperienceExperienceStart", ()=>$76212686d9cece5d$export$dba6cce392699a2b);
    $parcel$export(module.exports, "useViewFeatureFlagsEmptyStateExperienceExperienceFail", ()=>$76212686d9cece5d$export$b0017a8c5a092f54);
    $parcel$export(module.exports, "ViewFeatureFlagsEmptyStateExperienceExperienceSuccessTracker", ()=>$76212686d9cece5d$export$c49eaa8e4e389a94);
    var $5uXOq = parcelRequire("5uXOq");
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $dAfqg;
    var $efvDm;
    var $k9JTq;
    const $76212686d9cece5d$var$EXPERIENCE_NAME = 'viewFeatureFlagsEmptyStateExperience';
    const $76212686d9cece5d$export$dba6cce392699a2b = ({ experienceId: experienceId })=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaHBi")).ExperienceStart), {
            experienceId: experienceId,
            experience: $76212686d9cece5d$var$EXPERIENCE_NAME,
            analyticsSource: "featureFlagsEmptyStateExperience",
            edition: appEditions.software,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE)
        });
    };
    const $76212686d9cece5d$export$b0017a8c5a092f54 = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $76212686d9cece5d$var$EXPERIENCE_NAME
        });
    const $76212686d9cece5d$export$c49eaa8e4e389a94 = ()=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: $76212686d9cece5d$var$EXPERIENCE_NAME,
            attributes: projectContext != null ? {
                projectId: projectContext.projectId,
                isProjectAdmin: projectContext.isProjectAdmin,
                simplified: projectContext.simplified
            } : undefined
        });
    };
});
parcelRegister("jX1s1", function(module, exports) {
    $parcel$export(module.exports, "AddIssuesToVersion", ()=>$fe3599186565f7a3$export$bae9d11b7896e3f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $7ymNM;
    var $koVbs;
    var $lfTZh;
    var $kxZPA;
    var $fO0qz;
    const $fe3599186565f7a3$var$LazyAddIssuesToVersion = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("edgdX")).then((module)=>module.AddIssuesToVersion), {
        moduleId: "./src/packages/releases/add-issues-to-version/src/ui/index.tsx"
    });
    const $fe3599186565f7a3$export$bae9d11b7896e3f7 = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const PlaceholderButton = props.isIssueListFooterButton ? $fe3599186565f7a3$var$IssueListFooterButton : (0, (0, parcelRequire("fVnbM")).default);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "add-issues-to-version",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement(PlaceholderButton, {
                onClick: undefined,
                appearance: props.appearance,
                type: "button",
                iconBefore: props.showIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7ymNM"))))), {
                    label: "",
                    size: "small"
                }) : undefined
            }, formatMessage((0, (0, parcelRequire("fO0qz")).default).addButton))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($fe3599186565f7a3$var$LazyAddIssuesToVersion, props));
    };
    const $fe3599186565f7a3$var$IssueListFooterButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1kba1h6o _btpd1osq _1n7d1ylp _14741e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fO0qz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$89135d3517433fff$export$2e2bcd8739ae039);
    var $7VHMR;
    var $89135d3517433fff$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addButton: {
            "id": "software-releases-add-issues-to-version.add-button",
            "defaultMessage": "Add issues"
        },
        errorFlagTitle: {
            "id": "software-releases-add-issues-to-version.error-flag-title",
            "defaultMessage": "Can't add {totalCount, plural, one {issue} other {# issues}} to version"
        },
        errorFlagDescription: {
            "id": "software-releases-add-issues-to-version.error-flag-description",
            "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
        },
        successFlagDescription: {
            "id": "software-releases-add-issues-to-version.success-flag-description",
            "defaultMessage": "{issueCount, plural, one {# issue has been added} other {# issues have been added}}."
        },
        partialIssueFailureFlagTitle: {
            "id": "software-releases-add-issues-to-version.partial-issue-failure-flag-title",
            "defaultMessage": "{failedIssueCount} out of {totalCount} issues not added to version."
        },
        singleIssueMissingResolvePermFlagDescription: {
            "id": "software-releases-add-issues-to-version.single-issue-missing-resolve-perm-flag-description",
            "defaultMessage": "You don't have permission to resolve {issueKey}, so it wasn't added."
        },
        singleIssueMissingEditPermFlagDescription: {
            "id": "software-releases-add-issues-to-version.single-issue-missing-edit-perm-flag-description",
            "defaultMessage": "You don't have permission to edit {issueKey}, so it wasn't added."
        },
        singleIssueMissingPermsFlagDescription: {
            "id": "software-releases-add-issues-to-version.single-issue-missing-perms-flag-description",
            "defaultMessage": "You don't have permission to edit or resolve {issueKey}, so it wasn't added."
        },
        twoIssuesMissingResolvePermFlagDescription: {
            "id": "software-releases-add-issues-to-version.two-issues-missing-resolve-perm-flag-description",
            "defaultMessage": "You don't have permission to resolve {issueKey1} and {issueKey2}, so they weren't added."
        },
        twoIssuesMissingEditPermFlagDescription: {
            "id": "software-releases-add-issues-to-version.two-issues-missing-edit-perm-flag-description",
            "defaultMessage": "You don't have permission to edit {issueKey1} and {issueKey2}, so they weren't added."
        },
        twoIssuesMissingPermsFlagDescription: {
            "id": "software-releases-add-issues-to-version.two-issues-missing-perms-flag-description",
            "defaultMessage": "You don't have permission to edit or resolve {issueKey1} and {issueKey2}, so they weren't added."
        },
        multipleIssuesMissingResolvePermFlagDescription: {
            "id": "software-releases-add-issues-to-version.multiple-issues-missing-resolve-perm-flag-description",
            "defaultMessage": "You don't have permission to resolve {failedCount, plural, one {issue} other {# issues}}, so they weren't added."
        },
        multipleIssuesMissingEditPermFlagDescription: {
            "id": "software-releases-add-issues-to-version.multiple-issues-missing-edit-perm-flag-description",
            "defaultMessage": "You don't have permission to edit {failedCount, plural, one {issue} other {# issues}}, so they weren't added."
        },
        multipleIssuesMissingPermsFlagDescription: {
            "id": "software-releases-add-issues-to-version.multiple-issues-missing-perms-flag-description",
            "defaultMessage": "You don't have permission to edit or resolve {failedCount, plural, one {issue} other {# issues}}, so they weren't added."
        }
    });
});
parcelRegister("edgdX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bKYm1").then(()=>parcelRequire('bZwwy'));
});
parcelRegister("b940d", function(module, exports) {
    $parcel$export(module.exports, "VersionApproversCardExperienceStart", ()=>$139197404d60f68f$export$e45410483a7f75f3);
    $parcel$export(module.exports, "VersionApproversCardExperienceSuccess", ()=>$139197404d60f68f$export$664bc979971dec26);
    $parcel$export(module.exports, "useVersionApproversCardExperienceFail", ()=>$139197404d60f68f$export$3edb8e7637e1d4cc);
    var $5uXOq = parcelRequire("5uXOq");
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    const $139197404d60f68f$export$52919046b94109dc = 'jiraVersionApproversCard';
    const $139197404d60f68f$var$ANALYTICS_SOURCE = 'versionDetails';
    const $139197404d60f68f$export$e45410483a7f75f3 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaHBi")).ExperienceStart), {
            experienceId: `${Date.now()}`,
            experience: $139197404d60f68f$export$52919046b94109dc,
            analyticsSource: $139197404d60f68f$var$ANALYTICS_SOURCE,
            edition: appEditions.software,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE)
        });
    };
    const $139197404d60f68f$export$664bc979971dec26 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: $139197404d60f68f$export$52919046b94109dc
        });
    const $139197404d60f68f$export$3edb8e7637e1d4cc = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $139197404d60f68f$export$52919046b94109dc
        });
});
parcelRegister("4c6NH", function(module, exports) {
    $parcel$export(module.exports, "Approvers", ()=>$f0127c9f5b8d1b62$export$52f716ccfb37fc43);
    var $hdVaF;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $7ymNM;
    var $iwwXK;
    var $gwIPs;
    var $koVbs;
    var $lfTZh;
    var $kxZPA;
    var $j7rCb;
    var $krCkj;
    const $f0127c9f5b8d1b62$var$PADDING_SIZE = (0, (0, parcelRequire("gwIPs")).gridSize) * 3;
    const $f0127c9f5b8d1b62$var$BORDER_SIZE = 1;
    const $f0127c9f5b8d1b62$var$WIDTH_OFFSET = ($f0127c9f5b8d1b62$var$PADDING_SIZE + $f0127c9f5b8d1b62$var$BORDER_SIZE) * 2;
    const $f0127c9f5b8d1b62$var$LazyApprovers = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("6JTJs")).then((module)=>module.Approvers), {
        ssr: false,
        moduleId: "./src/packages/releases/approvers/src/ui/index.tsx"
    });
    const $f0127c9f5b8d1b62$export$52f716ccfb37fc43 = ({ jiraVersion: jiraVersion })=>{
        const { startNextPhase: startNextPhase } = (0, (0, parcelRequire("j7rCb")).useLazyPhase)();
        (0, $5uXOq.useEffect)(()=>{
            startNextPhase();
        }, [
            startNextPhase
        ]);
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("hdVaF")).default), jiraVersion);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const numberOfApproversToShow = (0, $06faf2097c277710$export$ab69ec32c8e056d0);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "releases-approvers",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($f0127c9f5b8d1b62$var$ApproversCardWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($f0127c9f5b8d1b62$var$Header, null, (0, ($parcel$interopDefault($5uXOq))).createElement($f0127c9f5b8d1b62$var$ApproversTitle, null, formatMessage((0, (0, parcelRequire("krCkj")).default).approversTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7ymNM"))))), {
                    size: "small",
                    label: ""
                }),
                appearance: "subtle"
            })), [
                ...Array(numberOfApproversToShow).keys()
            ].map((i)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
                    key: i,
                    isShimmering: true,
                    hasAvatar: true
                })))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f0127c9f5b8d1b62$var$LazyApprovers, {
            jiraVersion: version
        }));
    };
    const $f0127c9f5b8d1b62$var$ApproversTitle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1wybdlk8 _k48pni7l _syaz14xw",
                __cmplp.className
            ])
        });
    });
    const $f0127c9f5b8d1b62$var$Header = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4",
                __cmplp.className
            ])
        });
    });
    const $f0127c9f5b8d1b62$var$ApproversCardWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_zulppxbi _p12fpjzf _c71l842n _1reo1wug _18m91wug _1yt41ejb",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hdVaF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6754aa24323dee89$export$2e2bcd8739ae039);
    const $6754aa24323dee89$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "async_softwareReleasesApprovers_Approvers",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesApprovers_Approvers"
            }
        ],
        "type": "JiraVersion"
    };
    $6754aa24323dee89$var$node.hash = "b54447a983203e9751ad03d69a14f12e";
    var $6754aa24323dee89$export$2e2bcd8739ae039 = $6754aa24323dee89$var$node;
});
const $06faf2097c277710$export$ab69ec32c8e056d0 = 5;
parcelRegister("krCkj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$919b5d8330f71df6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $919b5d8330f71df6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        approversTitle: {
            "id": "software-releases-approvers.approvers-title",
            "defaultMessage": "Approvers"
        },
        noApproversMessage: {
            "id": "software-releases-approvers.no-approvers-message",
            "defaultMessage": "No approvers have been added"
        },
        showMore: {
            "id": "software-releases-approvers.show-more",
            "defaultMessage": "Show all approvers"
        },
        showLess: {
            "id": "software-releases-approvers.show-less",
            "defaultMessage": "Show less"
        }
    });
});
parcelRegister("6JTJs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6DQT4").then(()=>parcelRequire('84x8K'));
});
parcelRegister("2vbty", function(module, exports) {
    $parcel$export(module.exports, "useSidebarStore", ()=>$a9dfbd5d9e01d206$export$118f45a8309a4356);
    $parcel$export(module.exports, "useSidebarActions", ()=>$a9dfbd5d9e01d206$export$685a45ff9d61633f);
    var $dp66m;
    var $3sQ5x;
    var $iXqE5;
    const { CLOSED: $a9dfbd5d9e01d206$var$CLOSED, SHOWING_ISSUE: $a9dfbd5d9e01d206$var$SHOWING_ISSUE } = (0, (0, parcelRequire("dp66m")).SidebarStatuses);
    const $a9dfbd5d9e01d206$var$initialState = {
        state: {
            status: $a9dfbd5d9e01d206$var$CLOSED
        }
    };
    const $a9dfbd5d9e01d206$export$e324594224ef24da = {
        close: ()=>({ setState: setState })=>setState({
                    state: {
                        status: $a9dfbd5d9e01d206$var$CLOSED
                    }
                }),
        showIssue: (issueKey)=>({ setState: setState })=>setState({
                    state: {
                        status: $a9dfbd5d9e01d206$var$SHOWING_ISSUE,
                        issueKey: issueKey
                    }
                })
    };
    const $a9dfbd5d9e01d206$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'versionDetailsSidebarStore',
        initialState: $a9dfbd5d9e01d206$var$initialState,
        actions: $a9dfbd5d9e01d206$export$e324594224ef24da
    });
    const $a9dfbd5d9e01d206$var$useStore = (0, (0, parcelRequire("3sQ5x")).createHook)($a9dfbd5d9e01d206$var$Store);
    const $a9dfbd5d9e01d206$export$118f45a8309a4356 = ()=>{
        const [{ state: state }, sidebarActions] = $a9dfbd5d9e01d206$var$useStore();
        return [
            state,
            sidebarActions
        ];
    };
    const $a9dfbd5d9e01d206$var$useSidebarWithoutState = (0, (0, parcelRequire("3sQ5x")).createHook)($a9dfbd5d9e01d206$var$Store, {
        selector: null
    });
    const $a9dfbd5d9e01d206$export$685a45ff9d61633f = ()=>{
        const [, sidebarActions] = $a9dfbd5d9e01d206$var$useSidebarWithoutState();
        return sidebarActions;
    };
});
parcelRegister("dp66m", function(module, exports) {
    $parcel$export(module.exports, "SidebarStatuses", ()=>$7e7556a6438b4b2c$export$a4b0bca2b71ad188);
    const $7e7556a6438b4b2c$var$CLOSED = 'CLOSED';
    const $7e7556a6438b4b2c$var$SHOWING_ISSUE = 'SHOWING_ISSUE';
    const $7e7556a6438b4b2c$export$a4b0bca2b71ad188 = {
        CLOSED: $7e7556a6438b4b2c$var$CLOSED,
        SHOWING_ISSUE: $7e7556a6438b4b2c$var$SHOWING_ISSUE
    };
});
parcelRegister("dE7QH", function(module, exports) {
    $parcel$export(module.exports, "IssueSidebar", ()=>$c7a774ba2f2aa644$export$cd07ab049c87f027);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dp66m;
    var $2vbty;
    var $ktiFr;
    const $c7a774ba2f2aa644$export$cd07ab049c87f027 = ()=>{
        const [sidebarState] = (0, (0, parcelRequire("2vbty")).useSidebarStore)();
        const isOpen = sidebarState.status !== (0, (0, parcelRequire("dp66m")).SidebarStatuses).CLOSED;
        return isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement($c7a774ba2f2aa644$var$IssueSidebarContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ktiFr")).SidebarContent), null)) : null;
    };
    const $c7a774ba2f2aa644$var$IssueSidebarContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _kqswh2mm _1yt410cz _vchhusvi _bfhktxrc _1bsblti4 _p12flti4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ktiFr", function(module, exports) {
    $parcel$export(module.exports, "SidebarContent", ()=>$a343c38fb8374b1b$export$49e8f7b58a4df4ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $dp66m;
    var $2vbty;
    var $aYjcO;
    const $a343c38fb8374b1b$export$49e8f7b58a4df4ea = ()=>{
        const [sidebarState, sidebarActions] = (0, (0, parcelRequire("2vbty")).useSidebarStore)();
        const onClose = sidebarActions.close;
        switch(sidebarState.status){
            case (0, (0, parcelRequire("dp66m")).SidebarStatuses).CLOSED:
                return null;
            case (0, (0, parcelRequire("dp66m")).SidebarStatuses).SHOWING_ISSUE:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aYjcO")).Issue), {
                    issueKey: sidebarState.issueKey,
                    onClose: onClose
                });
            default:
                sidebarState.status;
                throw Error('Unhandled sidebar status');
        }
    };
});
parcelRegister("aYjcO", function(module, exports) {
    $parcel$export(module.exports, "Issue", ()=>$ef71174f682e4944$export$c175600e334513b4);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lfTZh;
    var $iXVV6;
    var $kKpgF;
    var $kxZPA;
    const $ef71174f682e4944$var$IssueApp = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("jO7eF")), {
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
    });
    const $ef71174f682e4944$export$c175600e334513b4 = ({ issueKey: issueKey, onClose: onClose })=>{
        const { refetch: refetch } = (0, (0, parcelRequire("kKpgF")).useRefetchContext)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "versionDetailsIssue"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef71174f682e4944$var$DetailsWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-app",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef71174f682e4944$var$IssueApp, {
            viewModeOptions: {
                viewMode: 'SIDEBAR'
            },
            issueKey: issueKey,
            shouldSetInitialFocus: true,
            shouldShowCloseButton: true,
            onChange: (event)=>{
                if (event.type === 'FIELD_CHANGED') refetch();
            },
            onIssueDeleteSuccess: refetch,
            onClose: onClose,
            isLoadedWithPage: false,
            isSpaEnabled: false,
            analyticsSource: (0, $fcf97b7a09088940$export$5b73d694a6048002)
        }))));
    };
    const $ef71174f682e4944$var$DetailsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _1reo15vq",
                __cmplp.className
            ])
        });
    });
});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
parcelRegister("kKpgF", function(module, exports) {
    $parcel$export(module.exports, "RefetchContext", ()=>$9e925a1cf010fb08$export$9943e630ea9ac16a);
    $parcel$export(module.exports, "useRefetchContext", ()=>$9e925a1cf010fb08$export$947d5554caab689a);
    var $5uXOq = parcelRequire("5uXOq");
    const $9e925a1cf010fb08$export$9943e630ea9ac16a = (0, $5uXOq.createContext)(null);
    const $9e925a1cf010fb08$export$947d5554caab689a = ()=>{
        const refetchContext = (0, $5uXOq.useContext)($9e925a1cf010fb08$export$9943e630ea9ac16a);
        if (refetchContext == null) throw new Error('Version details refetch provider was not found');
        return refetchContext;
    };
});
parcelRegister("jO7eF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("i5RRW"),
        $6fhBS("dsiAd"),
        $6fhBS("kWrFZ"),
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cggv6")
    ]).then(()=>parcelRequire('6qbjz'));
});
parcelRegister("4btcM", function(module, exports) {
    $parcel$export(module.exports, "LaunchCardExperienceStart", ()=>$03d3abf56366107f$export$5715f82a8f696e44);
    $parcel$export(module.exports, "LaunchCardExperienceSuccess", ()=>$03d3abf56366107f$export$8e01269c24812c16);
    $parcel$export(module.exports, "useLaunchCardExperienceFail", ()=>$03d3abf56366107f$export$207918c16c60fcae);
    var $5uXOq = parcelRequire("5uXOq");
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    const $03d3abf56366107f$export$52919046b94109dc = 'launchCard';
    const $03d3abf56366107f$var$ANALYTICS_SOURCE = 'versionDetails';
    const $03d3abf56366107f$export$5715f82a8f696e44 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaHBi")).ExperienceStart), {
            experienceId: `${Date.now()}`,
            experience: $03d3abf56366107f$export$52919046b94109dc,
            analyticsSource: $03d3abf56366107f$var$ANALYTICS_SOURCE,
            edition: appEditions.software,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE)
        });
    };
    const $03d3abf56366107f$export$8e01269c24812c16 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: $03d3abf56366107f$export$52919046b94109dc
        });
    const $03d3abf56366107f$export$207918c16c60fcae = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $03d3abf56366107f$export$52919046b94109dc
        });
});
parcelRegister("3hn4w", function(module, exports) {
    $parcel$export(module.exports, "LaunchCard", ()=>$2aeba785f1edbf18$export$1c9fa03e23146e86);
    var $iQkgm;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $lfTZh;
    var $kxZPA;
    var $j7rCb;
    var $dOfO1;
    var $oH05V;
    const $2aeba785f1edbf18$var$LazyLaunchCard = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>Promise.resolve((parcelRequire("dOfO1"))).then((module)=>module.LaunchCard), {
        ssr: false,
        moduleId: "./src/packages/releases/launch-card/src/ui/index.tsx"
    });
    const $2aeba785f1edbf18$export$669f6ea7d267feaf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).LoadingWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dOfO1")).BaseWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dOfO1")).MainContentWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).StatusLoading), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).TwoColumnFieldWrapper), {
            height: 63
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).FieldLoadingWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).FieldLabelLoading), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).FieldContentLoading), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).FieldLoadingWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).FieldLabelLoading), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).FieldContentLoading), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).TwoColumnFieldWrapper), {
            height: 52
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).FieldLoadingWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).FieldLabelLoading), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).FieldContentLoading), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).FieldLoadingWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).FieldLabelLoading), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).FieldContentLoading), null))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("oH05V")).LatestDeploymentLoading), null));
    const $2aeba785f1edbf18$export$1c9fa03e23146e86 = ({ jiraVersion: jiraVersion })=>{
        const { startNextPhase: startNextPhase } = (0, (0, parcelRequire("j7rCb")).useLazyPhase)();
        (0, $5uXOq.useEffect)(()=>{
            startNextPhase();
        }, [
            startNextPhase
        ]);
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("iQkgm")).default), jiraVersion);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "version-detail-launch-card",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($2aeba785f1edbf18$export$669f6ea7d267feaf, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2aeba785f1edbf18$var$LazyLaunchCard, {
            jiraVersion: version
        }));
    };
});
parcelRegister("iQkgm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55a744d530504a92$export$2e2bcd8739ae039);
    const $55a744d530504a92$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "async_softwareReleasesLaunchCard_LaunchCard",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesLaunchCard_LaunchCard"
            }
        ],
        "type": "JiraVersion"
    };
    $55a744d530504a92$var$node.hash = "ed744d145282aafc0de30b038a930975";
    var $55a744d530504a92$export$2e2bcd8739ae039 = $55a744d530504a92$var$node;
});
parcelRegister("dOfO1", function(module, exports) {
    $parcel$export(module.exports, "LaunchCard", ()=>$47690f766058ef99$export$1c9fa03e23146e86);
    $parcel$export(module.exports, "BaseWrapper", ()=>$47690f766058ef99$export$c07bd9612bb2b971);
    $parcel$export(module.exports, "MainContentWrapper", ()=>$47690f766058ef99$export$7f55214bcae58e5d);
    var $84BNJ;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $lfTZh;
    var $iXVV6;
    var $5oFIy;
    var $5ZT5S;
    var $UvyUC;
    var $kfztd;
    var $j4AZh;
    var $g08V3;
    var $gBkhv;
    var $6eRDX;
    var $4btcM;
    var $gl90z;
    var $aRLM0;
    var $gPH8i;
    var $lFoXK;
    const $47690f766058ef99$export$1c9fa03e23146e86 = ({ jiraVersion: jiraVersion })=>{
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("84BNJ")).default), jiraVersion);
        const [contributorsQueryRef, loadContributorsQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("5ZT5S")).default));
        const [preconditionQueryRef, loadPreconditionQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("UvyUC")).default));
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)()) {
                loadContributorsQuery({
                    versionId: version.id
                });
                loadPreconditionQuery({
                    cloudId: version.project.cloudId,
                    projectKey: version.project.key
                });
            }
        }, [
            loadPreconditionQuery,
            loadContributorsQuery,
            version.project.cloudId,
            version.project.key,
            version.id
        ]);
        const hasDriver = version.driverData?.driver?.id;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "launchCard"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                hasDriver: Boolean(hasDriver),
                versionAri: version.id
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($47690f766058ef99$export$c07bd9612bb2b971, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4btcM")).LaunchCardExperienceSuccess), null), (0, ($parcel$interopDefault($5uXOq))).createElement($47690f766058ef99$export$7f55214bcae58e5d, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lFoXK")).AsyncVersionStatus), {
            jiraVersion: version
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gPH8i")).VersionDates), {
            jiraVersion: version
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($47690f766058ef99$var$UserFieldsContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($47690f766058ef99$var$FieldWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6eRDX")).NonCriticalErrorBoundary), {
            eventLocation: "launchCardDriverField",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j4AZh")).DriverField), {
            jiraVersion: version,
            width: (0, (0, parcelRequire("gBkhv")).FIRST_COLUMN_MIN_WIDTH),
            isDisabled: !version.canEdit
        }))), !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && contributorsQueryRef && (0, ($parcel$interopDefault($5uXOq))).createElement($47690f766058ef99$var$FieldWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6eRDX")).NonCriticalErrorBoundary), {
            eventLocation: "launchCardContributorsField",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "version-contributors-section",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRLM0")).VersionContributorsSectionSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRLM0")).AsyncVersionContributors), {
            queryRef: contributorsQueryRef
        }))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g08V3")).VersionSummaryDescription), {
            jiraVersion: version
        })), !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && preconditionQueryRef && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6eRDX")).NonCriticalErrorBoundary), {
            eventLocation: "launchCardLatestDeployment",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "latest-deployment",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gl90z")).LatestDeployment), {
            jiraVersion: version,
            preconditionQueryRef: preconditionQueryRef
        })))));
    };
    const $47690f766058ef99$export$c07bd9612bb2b971 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _1tke18pt",
                __cmplp.className
            ])
        });
    });
    const $47690f766058ef99$export$7f55214bcae58e5d = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _1yt41ejb _zulppxbi",
                __cmplp.className
            ])
        });
    });
    const $47690f766058ef99$var$UserFieldsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _zulpu2gc _1bah1yb4",
                __cmplp.className
            ])
        });
    });
    const $47690f766058ef99$var$FieldWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _prventd2",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("84BNJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b6ca2060ba85a7a$export$2e2bcd8739ae039);
    const $2b6ca2060ba85a7a$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "isDevopsFeatureDisabledInFedRamp"
                }
            ],
            "kind": "Fragment",
            "name": "ui_softwareReleasesLaunchCard_LaunchCard",
            "selections": [
                {
                    "condition": "isDevopsFeatureDisabledInFedRamp",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "latestDeployment_softwareReleasesLaunchCard_jiraVersion"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "versionDates_softwareReleasesLaunchCard"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "async_softwareReleasesLaunchCard_AsyncVersionStatus"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ui_softwareReleasesVersionDriverField_DriverField"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription"
                },
                {
                    "kind": "RequiredField",
                    "field": v0,
                    "action": "THROW",
                    "path": "id"
                },
                {
                    "concreteType": "JiraVersionDriverResult",
                    "kind": "LinkedField",
                    "name": "driverData",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "driver",
                            "plural": false,
                            "selections": [
                                v0
                            ]
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "canEdit"
                    },
                    "action": "THROW",
                    "path": "canEdit"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "cloudId"
                                },
                                "action": "THROW",
                                "path": "project.cloudId"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                "action": "THROW",
                                "path": "project.key"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "project"
                }
            ],
            "type": "JiraVersion"
        };
    }();
    $2b6ca2060ba85a7a$var$node.hash = "d06ed52a13ffedc171f425ef28503077";
    var $2b6ca2060ba85a7a$export$2e2bcd8739ae039 = $2b6ca2060ba85a7a$var$node;
});
parcelRegister("5ZT5S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ad75b9326d93548$export$2e2bcd8739ae039);
    const $0ad75b9326d93548$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "versionId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "versionId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v3 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "async_softwareReleasesVersionContributorsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v1,
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "async_softwareReleasesLaunchCard_AsyncVersionContributors"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.version"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "async_softwareReleasesVersionContributorsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "JiraVersionContributorConnection",
                                                "kind": "LinkedField",
                                                "name": "contributors",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionContributorEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v2,
                                                                    v3,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "name"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "picture"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                                "kind": "LinkedField",
                                                                                "name": "extendedProfile",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "jobTitle"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "type": "AtlassianAccountUser"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraVersion"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v3
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b199f8523e8b333f650adf93ec0ebc73c3b0927f50a3fec2c9c3769918fbeb9b",
                "metadata": {},
                "name": "async_softwareReleasesVersionContributorsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $0ad75b9326d93548$var$node.hash = "0dd2c9bd66e5b70949d165995607196b";
    var $0ad75b9326d93548$export$2e2bcd8739ae039 = $0ad75b9326d93548$var$node;
});
parcelRegister("UvyUC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4dcda02f1d11bab$export$2e2bcd8739ae039);
    const $e4dcda02f1d11bab$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            }
        ], v1 = {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "deploymentsFeaturePreconditionByProjectKey"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "latestDeploymentForVersionPreconditionQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": v1,
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "latestDeploymentForVersionPreconditionQuery",
                "selections": [
                    v1
                ]
            },
            "params": {
                "id": "73bb0607fa286f014e98ee150a452d0808aff2ce4aa135ef04b8f21d5ea34326",
                "metadata": {},
                "name": "latestDeploymentForVersionPreconditionQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $e4dcda02f1d11bab$var$node.hash = "af15b08c11e01f89f1bd0ec84b873d12";
    var $e4dcda02f1d11bab$export$2e2bcd8739ae039 = $e4dcda02f1d11bab$var$node;
});
parcelRegister("j4AZh", function(module, exports) {
    $parcel$export(module.exports, "DriverFieldStateless", ()=>$03e02fffe7dd8b75$export$9ede53742ae13d69);
    $parcel$export(module.exports, "DriverField", ()=>$03e02fffe7dd8b75$export$4de1488fc0a2d937);
    var $ikYP0;
    var $5U9u0;
    var $iZZEz;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $cgL5K;
    var $cr0SA;
    var $gwIPs;
    var $jcw0u;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $koeKL;
    var $4bzfE;
    var $arKXI;
    const $03e02fffe7dd8b75$var$isOptionData = (val)=>val != null && typeof val.name === 'string' && typeof val.id === 'string';
    const $03e02fffe7dd8b75$var$createLoadQueryFunc = (environment, cloudId, projectAri)=>(searchText)=>(0, $8Uumt.fetchQuery)(environment, (0, (0, parcelRequire("iZZEz")).default), {
                projectAri: projectAri,
                searchText: searchText
            }, {
                fetchPolicy: 'store-or-network'
            }).toPromise().then((response)=>{
                const edges = response.jira.jiraProject.suggestedDriversForJiraVersion?.edges ?? [];
                return edges.filter(Boolean).map((edge)=>edge?.node).map((user)=>user == null ? null : {
                        avatarUrl: user.picture,
                        name: user.name,
                        id: user.accountId,
                        byline: user?.extendedProfile?.jobTitle ?? '',
                        type: 'user'
                    }).filter($03e02fffe7dd8b75$var$isOptionData);
            }).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'ui_versionDriverFieldQuery',
                        packageName: 'jiraSoftwareReleasesVersionDriverField'
                    },
                    error: error
                });
                return [];
            });
    const $03e02fffe7dd8b75$export$9ede53742ae13d69 = ({ width: width, projectId: projectId, initialDriverValue: initialDriverValue, onChange: onChange, isDisplayLabel: isDisplayLabel = true, isRenderedInModal: isRenderedInModal = false, menuPortalTargetRef: menuPortalTargetRef, isDisabled: isDisabled = false, isDisplayBorder: isDisplayBorder = false, ariaLabelledBy: ariaLabelledBy })=>{
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const menuPortalTarget = menuPortalTargetRef && menuPortalTargetRef.current;
        const loadOptions = $03e02fffe7dd8b75$var$createLoadQueryFunc(environment, cloudId, `ari:cloud:jira:${cloudId}:project/${projectId}`);
        const experienceStart = (0, (0, parcelRequire("4bzfE")).useUpdateDriverExperienceStart)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($03e02fffe7dd8b75$var$Wrapper, null, isDisplayLabel && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            weight: "bold",
            color: "color.text.subtle",
            as: "p"
        }, formatMessage((0, (0, parcelRequire("arKXI")).default).fieldLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement($03e02fffe7dd8b75$var$PlacholderStyleOverrider, {
            isDisplayBorder: isDisplayBorder
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cr0SA")).UserPicker), {
            fieldId: "jiraVersionDriver",
            ariaLabelledBy: ariaLabelledBy,
            loadOptions: loadOptions,
            isDisabled: isDisabled,
            width: width,
            menuPortalTarget: isRenderedInModal ? menuPortalTarget || document.body : undefined,
            styles: isRenderedInModal && !menuPortalTarget ? {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999
                    })
            } : undefined,
            menuMinWidth: 33 * (0, (0, parcelRequire("gwIPs")).gridSize),
            defaultValue: initialDriverValue,
            placeholder: formatMessage((0, (0, parcelRequire("arKXI")).default).unassigned),
            onChange: (value)=>{
                if (Array.isArray(value)) return;
                onChange?.(value == null ? null : value);
            },
            onFocus: ()=>experienceStart(),
            onClear: ()=>experienceStart()
        })));
    };
    const $03e02fffe7dd8b75$export$4de1488fc0a2d937 = ({ jiraVersion: jiraVersion, width: width, onChange: onChange, isDisplayLabel: isDisplayLabel = true, isRenderedInModal: isRenderedInModal = false, isDisabled: isDisabled = false, isDisplayBorder: isDisplayBorder = false, ariaLabelledBy: ariaLabelledBy })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const experienceFail = (0, (0, parcelRequire("4bzfE")).useUpdateDriverExperienceFail)();
        const experienceSuccess = (0, (0, parcelRequire("4bzfE")).useUpdateDriverExperienceSuccess)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("5U9u0")).default), jiraVersion);
        const versionAri = version.id;
        const { projectId: projectId } = version.project;
        const onMutationError = (error)=>{
            experienceFail('graphql error', error);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'jira.releases.release-modals-relay.create-release-modal',
                    packageName: 'jiraSoftwareReleasesVersionDriverField',
                    teamName: 'fusion-solaris'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            showFlag({
                title: formatMessage((0, (0, parcelRequire("arKXI")).default).genericErrorFlagTitle),
                description: formatMessage((0, (0, parcelRequire("arKXI")).default).genericErrorFlagDescription),
                type: 'error'
            });
        };
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const analyticEvent = createAnalyticsEvent({
            action: 'updated',
            actionSubject: 'versionDriver'
        });
        const [updateDriverOnVersion] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("ikYP0")).default));
        const driverError = version.driverData?.queryError?.message;
        if (driverError != null) throw new Error('Received QueryError when fetching driver');
        const driver = version?.driverData?.driver;
        console.log('driver', driver);
        const currentlySetDriver = driver == null ? undefined : {
            avatarUrl: driver.picture,
            name: driver.name,
            id: driver.accountId
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($03e02fffe7dd8b75$export$9ede53742ae13d69, {
            width: width,
            ariaLabelledBy: ariaLabelledBy,
            projectId: projectId,
            initialDriverValue: currentlySetDriver,
            isDisplayLabel: isDisplayLabel,
            isRenderedInModal: isRenderedInModal,
            isDisabled: isDisabled,
            isDisplayBorder: isDisplayBorder,
            onChange: (newDriver)=>{
                updateDriverOnVersion({
                    variables: {
                        input: {
                            id: versionAri,
                            driver: newDriver?.id
                        }
                    },
                    onCompleted: (data)=>{
                        if (data.jira?.updateJiraVersionDriver?.success !== true) {
                            const responseErrors = data?.jira?.updateJiraVersionDriver?.errors;
                            const errorMessage = responseErrors?.[0]?.message ?? 'updateJiraVersionDriver graphql mutation failed';
                            onMutationError(new Error(errorMessage));
                            return;
                        }
                        experienceSuccess();
                        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticEvent, 'versionDriver updated', {
                            isDriverSet: Boolean(newDriver?.id)
                        });
                    },
                    onError: (error)=>{
                        onMutationError(error);
                    }
                });
                onChange?.(newDriver);
            }
        });
    };
    const $03e02fffe7dd8b75$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1fhb",
                __cmplp.className
            ])
        });
    });
    const $03e02fffe7dd8b75$var$PlacholderStyleOverrider = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isDisplayBorder: isDisplayBorder, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1owr16oo _1q5411p5 _16vph2mm _14od1wug _1etn1wug _1ospglyw _djrp1mxx",
                !__cmplp.isDisplayBorder && "_18u0196n _hfmuglyw _16daglyw _wadh1otk",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ikYP0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7805576ba101a14b$export$2e2bcd8739ae039);
    const $7805576ba101a14b$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "kind": "ScalarField",
            "name": "statusCode"
        }, v4 = {
            "kind": "ScalarField",
            "name": "errorType"
        }, v5 = {
            "kind": "ScalarField",
            "name": "message"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "ui_updateDriverMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateJiraVersionDriver",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    v4
                                                ]
                                            },
                                            v5
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "ui_updateDriverMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateJiraVersionDriver",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v3,
                                                    v4,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ],
                                                        "type": "BulkMutationErrorExtension"
                                                    }
                                                ]
                                            },
                                            v5
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "3cad693b4ea2b82d83662a6f0beed697af820a42940984a0b7163b2529d57855",
                "metadata": {},
                "name": "ui_updateDriverMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $7805576ba101a14b$var$node.hash = "08128527381c648c0856caf35f97d544";
    var $7805576ba101a14b$export$2e2bcd8739ae039 = $7805576ba101a14b$var$node;
});
parcelRegister("5U9u0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$365e59b576a32814$export$2e2bcd8739ae039);
    const $365e59b576a32814$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_softwareReleasesVersionDriverField_DriverField",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "projectId"
                            },
                            "action": "THROW",
                            "path": "project.projectId"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            },
            {
                "concreteType": "JiraVersionDriverResult",
                "kind": "LinkedField",
                "name": "driverData",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "driver",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                "action": "THROW",
                                "path": "driverData.driver.accountId"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                "action": "THROW",
                                "path": "driverData.driver.name"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "picture"
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "queryError",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraVersion"
    };
    $365e59b576a32814$var$node.hash = "699193bd41c7f6c4d596a3dd505592df";
    var $365e59b576a32814$export$2e2bcd8739ae039 = $365e59b576a32814$var$node;
});
parcelRegister("iZZEz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cc7275cef8e6e23$export$2e2bcd8739ae039);
    const $6cc7275cef8e6e23$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectAri"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "searchText"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectAri"
            }
        ], v2 = [
            {
                "kind": "Variable",
                "name": "searchText",
                "variableName": "searchText"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "accountId"
        }, v4 = {
            "kind": "ScalarField",
            "name": "name"
        }, v5 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v6 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "AtlassianAccountUserExtendedProfile",
                    "kind": "LinkedField",
                    "name": "extendedProfile",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "jobTitle"
                        }
                    ]
                }
            ],
            "type": "AtlassianAccountUser"
        }, v7 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "ui_versionDriverFieldQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v1,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": v2,
                                                "concreteType": "JiraVersionDriverConnection",
                                                "kind": "LinkedField",
                                                "name": "suggestedDriversForJiraVersion",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionDriverEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v3,
                                                                            "action": "THROW",
                                                                            "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node.accountId"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v4,
                                                                            "action": "THROW",
                                                                            "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node.name"
                                                                        },
                                                                        v5,
                                                                        v6
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraProject"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "ui_versionDriverFieldQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProject",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2,
                                        "concreteType": "JiraVersionDriverConnection",
                                        "kind": "LinkedField",
                                        "name": "suggestedDriversForJiraVersion",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraVersionDriverEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__typename"
                                                            },
                                                            v3,
                                                            v4,
                                                            v5,
                                                            v6,
                                                            v7
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v7
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "5e4bfaa8a1dd598e42c24a483ee126347ef0d95303b3b6ad086a329116bc4bfc",
                "metadata": {},
                "name": "ui_versionDriverFieldQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $6cc7275cef8e6e23$var$node.hash = "43d45f30b77d193c46e6ddd3e1cb725a";
    var $6cc7275cef8e6e23$export$2e2bcd8739ae039 = $6cc7275cef8e6e23$var$node;
});
parcelRegister("cr0SA", function(module, exports) {
    $parcel$export(module.exports, "UserPicker", ()=>$ee13645786fb45b4$export$83e0c73b09b3a9cd);
    var $cb25w;
    var $iOwNT;
    var $7K5PP;
    var $jZA09;
    var $5uXOq = parcelRequire("5uXOq");
    var $d3gzD;
    var $2wgOn;
    var $dyegP;
    var $fuG1P;
    var $hcX3V;
    var $hrO1B;
    var $2vFqP;
    var $pk97C;
    var $7Jxgt = parcelRequire("7Jxgt");
    class $ee13645786fb45b4$export$164f4d95e5d7e2f5 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.ufoId = (0, $7Jxgt.v4)();
            const experienceForId = (0, (0, parcelRequire("pk97C")).userPickerRenderedUfoExperience).getInstance(this.ufoId);
            experienceForId.start();
        }
        static{
            this.defaultProps = {
                width: 350,
                isMulti: false
            };
        }
        componentDidMount() {
            const experienceForId = (0, (0, parcelRequire("pk97C")).userPickerRenderedUfoExperience).getInstance(this.ufoId);
            if ([
                (0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id,
                (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
            ].includes(experienceForId.state.id)) experienceForId.success();
        }
        render() {
            const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false } = this.props;
            const width = this.props.width;
            const SelectComponent = allowEmail ? (0, (0, parcelRequire("iOwNT")).default) : (0, (0, parcelRequire("7K5PP")).default);
            const creatableProps = suggestEmailsForDomain ? (0, (0, parcelRequire("hcX3V")).getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, (0, parcelRequire("fuG1P")).getCreatableProps)(isValidEmail);
            const defaultPickerProps = {
                closeMenuOnScroll: closeMenuOnScroll,
                menuPortalTarget: menuPortalTarget,
                menuPosition: menuPosition,
                menuShouldBlockScroll: menuShouldBlockScroll,
                captureMenuScroll: captureMenuScroll,
                required: required
            };
            const pickerProps = allowEmail ? {
                ...defaultPickerProps,
                ...creatableProps,
                emailLabel: emailLabel
            } : {
                ...defaultPickerProps
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("pk97C")).UfoErrorBoundary), {
                id: this.ufoId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hrO1B")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2vFqP")).ExusUserSourceProvider), {
                fetchUserSource: loadUserSource
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d3gzD")).BaseUserPickerWithoutAnalytics), {
                ...this.props,
                width: width,
                SelectComponent: SelectComponent,
                styles: (0, (0, parcelRequire("2wgOn")).getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, this.props.isInvalid),
                components: (0, (0, parcelRequire("dyegP")).getComponents)(isMulti, anchor),
                pickerProps: pickerProps
            }))));
        }
    }
    const $ee13645786fb45b4$export$83e0c73b09b3a9cd = (0, (0, parcelRequire("cb25w")).default)()($ee13645786fb45b4$export$164f4d95e5d7e2f5);
});
parcelRegister("iOwNT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59b6485f0cb008dd$export$2e2bcd8739ae039);
    var $9OU1i;
    var $3c98u;
    const $59b6485f0cb008dd$var$CreatableSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("9OU1i")).default));
    var $59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;
});
parcelRegister("9OU1i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b29f1caecd9c7d5a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useCreatable", ()=>(parcelRequire("2HH7Y")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $2HH7Y;
    var $9uJ4X;
    const $b29f1caecd9c7d5a$var$CreatableSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const creatableProps = (0, (0, parcelRequire("9uJ4X")).default)(props);
        const selectProps = (0, (0, parcelRequire("2HH7Y")).default)(creatableProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;
});
parcelRegister("2QhWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e863683b34816f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $aCMCu;
    var $eEtcC;
    var $bChGW;
    var $jtVgE;
    var $9cRAr;
    var $galqx;
    var $81i5b;
    var $aA8TC;
    var $5JAlL;
    var $7VXAu;
    var $5HBcW;
    var $gyjU7;
    const $d8e863683b34816f$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("5JAlL")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("eEtcC")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("eEtcC")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("eEtcC")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("eEtcC")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("gyjU7")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true
    };
    function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
        const label = $d8e863683b34816f$var$getOptionLabel(props, option);
        const value = $d8e863683b34816f$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("gyjU7")).notNullish));
    }
    function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
        return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
    }
    function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
        return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
    }
    function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $d8e863683b34816f$var$instanceId = 1;
    class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props), this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            }, this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, this.isAppleDevice = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("aCMCu")).isSafari)() : (0, (0, parcelRequire("aCMCu")).isAppleDevice)(), this.controlRef = null, this.getControlRef = (ref)=>{
                this.controlRef = ref;
            }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            }, this.inputRef = null, this.getInputRef = (ref)=>{
                this.inputRef = ref;
            }, this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            }, this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            }, this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            }, this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            }, this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("gyjU7")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            }, this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            }, this.getFocusedOptionId = (focusedOption)=>{
                return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            }, this.getFocusableOptionsWithIds = ()=>{
                return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, (0, parcelRequire("gyjU7")).classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
                return $d8e863683b34816f$var$getOptionLabel(this.props, data);
            }, this.getOptionValue = (data)=>{
                return $d8e863683b34816f$var$getOptionValue(this.props, data);
            }, this.getStyles = (key, props)=>{
                const base = (0, (0, parcelRequire("7VXAu")).defaultStyles)[key](props);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            }, this.getComponents = ()=>{
                return (0, (0, parcelRequire("bChGW")).defaultComponents)(this.props);
            }, this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            }, this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            }, this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            }, this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            }, this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            }, this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            }, this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("gyjU7")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            }, this.onCompositionStart = ()=>{
                this.isComposing = true;
            }, this.onCompositionEnd = ()=>{
                this.isComposing = false;
            }, this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            }, this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            }, this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            }, this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            }, this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            }, this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            }, this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            }, this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            }, this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            }, this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            }, this.shouldHideSelectedOptions = ()=>{
                return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
            }, this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            }, this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("5HBcW")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("5HBcW")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("5HBcW")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtVgE")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("gyjU7")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aA8TC")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("galqx")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cRAr")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81i5b")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("aCMCu", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$150018e79a44f2ed$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$150018e79a44f2ed$export$e1865c3bedcd822b);
    function $150018e79a44f2ed$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $150018e79a44f2ed$export$186c6964ca17d99() {
        return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
    }
    function $150018e79a44f2ed$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $150018e79a44f2ed$export$9ac100e40613ea10() {
        return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
    }
    function $150018e79a44f2ed$export$7bef049ce92e4224() {
        return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $150018e79a44f2ed$export$fedb369cb70207f1() {
        return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
    }
    function $150018e79a44f2ed$export$e1865c3bedcd822b() {
        return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
    }
});
parcelRegister("eEtcC", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$1a3d0f2eb875e1af$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$1a3d0f2eb875e1af$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$1a3d0f2eb875e1af$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$1a3d0f2eb875e1af$export$56bd0c8d90db075);
    const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
    const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
    const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
    const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("bChGW", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$ea75c1778b4e3ad2$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$ea75c1778b4e3ad2$export$71abc632aa29e6fe);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("95iuW")).ClearIndicator),
        Control: (0, (0, parcelRequire("eZFhY")).default),
        DropdownIndicator: (0, (0, parcelRequire("95iuW")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("95iuW")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("95iuW")).CrossIcon),
        Group: (0, (0, parcelRequire("i48X9")).default),
        GroupHeading: (0, (0, parcelRequire("i48X9")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("h1QWG")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("95iuW")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("dS5G5")).default),
        LoadingIndicator: (0, (0, parcelRequire("95iuW")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("aA8TC")).default),
        MenuList: (0, (0, parcelRequire("aA8TC")).MenuList),
        MenuPortal: (0, (0, parcelRequire("aA8TC")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("aA8TC")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("aA8TC")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hqcPo")).default),
        MultiValueContainer: (0, (0, parcelRequire("hqcPo")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hqcPo")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hqcPo")).MultiValueRemove),
        Option: (0, (0, parcelRequire("8l2RA")).default),
        Placeholder: (0, (0, parcelRequire("kKm82")).default),
        SelectContainer: (0, (0, parcelRequire("h1QWG")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("hpcbi")).default),
        ValueContainer: (0, (0, parcelRequire("h1QWG")).ValueContainer)
    };
    const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
            ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("h1QWG", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$78186faf13ea75d3$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$78186faf13ea75d3$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$78186faf13ea75d3$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$78186faf13ea75d3$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$78186faf13ea75d3$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$78186faf13ea75d3$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $gyjU7;
    const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
        });
    const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("gyjU7", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$109d3f9af5469308$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$109d3f9af5469308$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$109d3f9af5469308$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$109d3f9af5469308$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$109d3f9af5469308$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$109d3f9af5469308$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$109d3f9af5469308$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$109d3f9af5469308$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$109d3f9af5469308$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$109d3f9af5469308$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$109d3f9af5469308$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$109d3f9af5469308$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$109d3f9af5469308$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$109d3f9af5469308$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$109d3f9af5469308$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$109d3f9af5469308$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$109d3f9af5469308$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$109d3f9af5469308$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$109d3f9af5469308$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$109d3f9af5469308$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$109d3f9af5469308$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$109d3f9af5469308$export$4213b25a1c4e877);
    const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
    const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
    function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
        if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $109d3f9af5469308$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $109d3f9af5469308$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
        const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
            $109d3f9af5469308$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $109d3f9af5469308$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $109d3f9af5469308$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $109d3f9af5469308$var$passiveOptionAccessed = false;
    const $109d3f9af5469308$var$options = {
        get passive () {
            return $109d3f9af5469308$var$passiveOptionAccessed = true;
        }
    };
    const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
    if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
        $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
        $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
    }
    const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
    function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("eZFhY", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$728816cb4150b6bc$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$728816cb4150b6bc$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } })=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
            borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
            borderRadius: borderRadius,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
            '&:hover': {
                borderColor: isFocused ? colors.primary : colors.neutral30
            }
        });
    const $728816cb4150b6bc$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;
});
parcelRegister("i48X9", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$902e86f4b4fe337b$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$902e86f4b4fe337b$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$902e86f4b4fe337b$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$902e86f4b4fe337b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $902e86f4b4fe337b$export$b6794329c1460634 = ({ theme: { spacing: spacing } })=>({
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        });
    const $902e86f4b4fe337b$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } })=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            color: colors.neutral40,
            fontSize: '75%',
            fontWeight: 500,
            marginBottom: '0.25em',
            paddingLeft: spacing.baseUnit * 3,
            paddingRight: spacing.baseUnit * 3,
            textTransform: 'uppercase'
        });
    const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;
});
parcelRegister("95iuW", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$13f090f36c42825d$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$13f090f36c42825d$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$13f090f36c42825d$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$13f090f36c42825d$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$13f090f36c42825d$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$13f090f36c42825d$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$13f090f36c42825d$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$13f090f36c42825d$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$13f090f36c42825d$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$13f090f36c42825d$export$7c20be4c1d342248);
    var $f8Sb3;
    var $gyjU7;
    function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13f090f36c42825d$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $13f090f36c42825d$var$styles,
            ...props
        });
    const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $13f090f36c42825d$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2,
            ':hover': {
                color: isFocused ? colors.neutral80 : colors.neutral40
            }
        });
    const $13f090f36c42825d$export$e1687335805e1230 = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
    };
    const $13f090f36c42825d$export$9c0419fd944c1def = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
    };
    const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
            marginBottom: baseUnit * 2,
            marginTop: baseUnit * 2
        });
    const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $13f090f36c42825d$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } })=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2
        });
    const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("dS5G5", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$1c949ac6f5985b40$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$1c949ac6f5985b40$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } })=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$1c949ac6f5985b40$var$containerStyle,
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: colors.neutral80
        });
    const $1c949ac6f5985b40$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $1c949ac6f5985b40$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$1c949ac6f5985b40$var$spacingStyle
        }
    };
    const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$1c949ac6f5985b40$var$spacingStyle
        });
    const $1c949ac6f5985b40$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $1c949ac6f5985b40$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;
});
parcelRegister("aA8TC", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$1fde8cb844828ae2$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$1fde8cb844828ae2$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$1fde8cb844828ae2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$1fde8cb844828ae2$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$1fde8cb844828ae2$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$1fde8cb844828ae2$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$1fde8cb844828ae2$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$1fde8cb844828ae2$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$1fde8cb844828ae2$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$1fde8cb844828ae2$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $gyjU7;
    function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("gyjU7")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("gyjU7")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("gyjU7")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $1fde8cb844828ae2$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } })=>({
            label: 'menu',
            [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            backgroundColor: colors.neutral0,
            borderRadius: borderRadius,
            boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter
        });
    const $1fde8cb844828ae2$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $1fde8cb844828ae2$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
    const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } })=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            paddingBottom: baseUnit,
            paddingTop: baseUnit
        });
    const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            textAlign: 'center',
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        });
    const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("gyjU7")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hqcPo", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$20933ad7b05a0c37$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$20933ad7b05a0c37$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$20933ad7b05a0c37$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$20933ad7b05a0c37$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$20933ad7b05a0c37$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$20933ad7b05a0c37$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    var $95iuW;
    const $20933ad7b05a0c37$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } })=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            backgroundColor: colors.neutral10,
            borderRadius: borderRadius / 2,
            margin: spacing.baseUnit / 2
        });
    const $20933ad7b05a0c37$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis })=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            borderRadius: borderRadius / 2,
            color: colors.neutral80,
            fontSize: '85%',
            padding: 3,
            paddingLeft: 6
        });
    const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused })=>({
            alignItems: 'center',
            display: 'flex',
            borderRadius: borderRadius / 2,
            backgroundColor: isFocused ? colors.dangerLight : undefined,
            paddingLeft: spacing.baseUnit,
            paddingRight: spacing.baseUnit,
            ':hover': {
                backgroundColor: colors.dangerLight,
                color: colors.danger
            }
        });
    const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("95iuW")).CrossIcon), {
            size: 14
        }));
    }
    const $20933ad7b05a0c37$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;
});
parcelRegister("8l2RA", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$6e6d67a90b457dc1$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$6e6d67a90b457dc1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } })=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
            color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
            padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
            }
        });
    const $6e6d67a90b457dc1$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;
});
parcelRegister("kKm82", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$889d652a9d0dc097$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$889d652a9d0dc097$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } })=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            color: colors.neutral50,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        });
    const $889d652a9d0dc097$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;
});
parcelRegister("hpcbi", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$aff94346c62a222f$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$aff94346c62a222f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } })=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: isDisabled ? colors.neutral40 : colors.neutral80,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        });
    const $aff94346c62a222f$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;
});
parcelRegister("jtVgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe53037961824c2$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $afe53037961824c2$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("gyjU7")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $afe53037961824c2$var$dummyInputStyles
        });
    }
});
parcelRegister("9cRAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a388fa48a9e96271$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eGmKJ;
    function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a388fa48a9e96271$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $a388fa48a9e96271$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("eGmKJ")).default)
        });
    var $a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;
});
parcelRegister("galqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15a49c0b3452f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $59IMp;
    var $3jzRI;
    function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15a49c0b3452f71$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("59IMp")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("3jzRI")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $e15a49c0b3452f71$var$blurSelectInput,
            css: $e15a49c0b3452f71$var$styles
        }), children(targetRef));
    }
});
parcelRegister("59IMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c08116303d9e3a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    const $96c08116303d9e3a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("gyjU7")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("3jzRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840302f0f43020c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $840302f0f43020c5$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $840302f0f43020c5$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $840302f0f43020c5$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $840302f0f43020c5$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $840302f0f43020c5$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $840302f0f43020c5$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $840302f0f43020c5$var$activeScrollLocks = 0;
    const $840302f0f43020c5$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                    const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
            $840302f0f43020c5$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("81i5b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3ccfcdca5695e58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dQlbw;
    var $bEd7d;
    const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("dQlbw")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;
});
parcelRegister("dQlbw", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$d3258ad64818881e$export$a7265767c78f9bae);
    var $VSDnB;
    const $d3258ad64818881e$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bEd7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc43afa82d3c33b$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7cc43afa82d3c33b$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $7cc43afa82d3c33b$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7cc43afa82d3c33b$var$styles,
            ...props
        });
    var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;
});
parcelRegister("5JAlL", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $bXu2O;
    const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("bXu2O")).stripDiacritics));
    const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("bXu2O")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("bXu2O", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$df93339199dda18e$export$b5bee4b27048330b);
    const $df93339199dda18e$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $df93339199dda18e$var$diacriticToBase = {};
    for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
        let diacritic = $df93339199dda18e$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
        return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
    };
});
parcelRegister("7VXAu", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$11d0fd648d1f51c0$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$11d0fd648d1f51c0$export$e618dc39ac9ad607);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("95iuW")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("h1QWG")).containerCSS),
        control: (0, (0, parcelRequire("eZFhY")).css),
        dropdownIndicator: (0, (0, parcelRequire("95iuW")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("i48X9")).groupCSS),
        groupHeading: (0, (0, parcelRequire("i48X9")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("h1QWG")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("95iuW")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("dS5G5")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("95iuW")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("aA8TC")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("aA8TC")).menuCSS),
        menuList: (0, (0, parcelRequire("aA8TC")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("aA8TC")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hqcPo")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hqcPo")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hqcPo")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("aA8TC")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("8l2RA")).optionCSS),
        placeholder: (0, (0, parcelRequire("kKm82")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("hpcbi")).css),
        valueContainer: (0, (0, parcelRequire("h1QWG")).valueContainerCSS)
    };
    function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("5HBcW", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$f64b5780144c9fe8$export$164de7ab8df77ef0);
    const $f64b5780144c9fe8$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $f64b5780144c9fe8$var$borderRadius = 4;
    const $f64b5780144c9fe8$var$baseUnit = 4;
    const $f64b5780144c9fe8$var$controlHeight = 38;
    const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
    const $f64b5780144c9fe8$export$5458b64234d1333c = {
        baseUnit: $f64b5780144c9fe8$var$baseUnit,
        controlHeight: $f64b5780144c9fe8$var$controlHeight,
        menuGutter: $f64b5780144c9fe8$var$menuGutter
    };
    const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
        borderRadius: $f64b5780144c9fe8$var$borderRadius,
        colors: $f64b5780144c9fe8$export$8f45430ccf837300,
        spacing: $f64b5780144c9fe8$export$5458b64234d1333c
    };
});
parcelRegister("2HH7Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$994aeb783b6f955a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eEtcC;
    var $gyjU7;
    const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
        const candidate = String(inputValue).toLowerCase();
        const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
        const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
        return optionValue === candidate || optionLabel === candidate;
    };
    const $994aeb783b6f955a$var$builtins = {
        formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
        isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
        getNewOptionData: (inputValue, optionLabel)=>({
                label: optionLabel,
                value: inputValue,
                __isNew__: true
            })
    };
    function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
        const { getOptionValue: getOptionValue = (0, (0, parcelRequire("eEtcC")).getOptionValue), getOptionLabel: getOptionLabel = (0, (0, parcelRequire("eEtcC")).getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
        const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, (0, parcelRequire("gyjU7")).cleanValue)(value), propsOptions, {
                getOptionValue: getOptionValue,
                getOptionLabel: getOptionLabel
            }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
            formatCreateLabel,
            getNewOptionData,
            getOptionLabel,
            getOptionValue,
            inputValue,
            isValidNewOption,
            propsOptions,
            value
        ]);
        const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
                newOption,
                ...propsOptions
            ] : [
                ...propsOptions,
                newOption
            ] : propsOptions, [
            allowCreateWhileLoading,
            createOptionPosition,
            isLoading,
            newOption,
            propsOptions
        ]);
        const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
            const valueArray = Array.isArray(newValue) ? newValue : [
                newValue
            ];
            if (valueArray[valueArray.length - 1] === newOption) {
                if (onCreateOption) onCreateOption(inputValue);
                else {
                    const newOptionData = getNewOptionData(inputValue, inputValue);
                    const newActionMeta = {
                        action: 'create-option',
                        name: name,
                        option: newOptionData
                    };
                    propsOnChange((0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, [
                        ...(0, (0, parcelRequire("gyjU7")).cleanValue)(value),
                        newOptionData
                    ], newOptionData), newActionMeta);
                }
                return;
            }
            propsOnChange(newValue, actionMeta);
        }, [
            getNewOptionData,
            inputValue,
            isMulti,
            name,
            newOption,
            onCreateOption,
            propsOnChange,
            value
        ]);
        return {
            ...restSelectProps,
            options: options,
            onChange: onChange
        };
    }
});
parcelRegister("9uJ4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b6d9d338d10de1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("3c98u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$628a0199069e875a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VXAu;
    var $l4W7r;
    var $1k2at;
    var $j1GDZ;
    var $bA56e;
    var $eaXSR;
    var $1DATb;
    function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("l4W7r")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("l4W7r")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("l4W7r")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("1k2at")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("1k2at")).IndicatorSeparator,
                    Input: (0, parcelRequire("j1GDZ")).Input,
                    NoOptionsMessage: (0, parcelRequire("bA56e")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("1DATb")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles),
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("l4W7r", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$9145857df3efc9da$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$9145857df3efc9da$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$9145857df3efc9da$export$7c20be4c1d342248);
    var $f8Sb3;
    var $c8Oei;
    var $cQz2U;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $eZJjh;
    const $9145857df3efc9da$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $9145857df3efc9da$var$dropdownWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075'
    });
    const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $9145857df3efc9da$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $9145857df3efc9da$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })));
    };
});
parcelRegister("cQz2U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));
    var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
    function $95a586bfe482ffec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>$95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
        }, props));
    $95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;
});
parcelRegister("47etd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ff30a5d9a7d32b6$var$_UNSAFE_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>$2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("1k2at", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$5fdfa3c8145f4e13$export$bd638c2ba7915668);
    var $f8Sb3;
    var $673MF;
    var $bjGSs;
    var $VSDnB;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $l4W7r;
    function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5fdfa3c8145f4e13$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $5fdfa3c8145f4e13$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("673MF"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;
});
parcelRegister("bjGSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83d2ba975692c1a3$var$_UNSAFE_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83d2ba975692c1a3$var$CrossIcon = (props)=>$83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
    var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;
});
parcelRegister("j1GDZ", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$4cb02513bf42b58e$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("bA56e", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$eeac7d0aa054dce2$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $bChGW;
    const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("eaXSR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7eb841defe611e3$export$2e2bcd8739ae039);
    var $VSDnB;
    function $b7eb841defe611e3$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $829f609a65d26a98$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("1DATb", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$a998ee34d66f3da7$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$a998ee34d66f3da7$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$a998ee34d66f3da7$export$8ee33f304118fce4);
    function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("7K5PP", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$c2d344e1481a2d3b$export$2e2bcd8739ae039);
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $eAthk;
    var $3c98u;
    const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
    const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
    const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    const $c2d344e1481a2d3b$var$Select = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'select',
        packageName: $c2d344e1481a2d3b$var$packageName,
        packageVersion: $c2d344e1481a2d3b$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $c2d344e1481a2d3b$var$packageName,
                packageVersion: $c2d344e1481a2d3b$var$packageVersion
            }
        })
    })($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
    var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;
});
parcelRegister("eAthk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d0cf20527a3a891$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("iaInK")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $9uJ4X;
    const $6d0cf20527a3a891$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("iaInK")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("9uJ4X")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;
});
parcelRegister("iaInK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e85c90096c52fe4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("gyjU7")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("jZA09", function(module, exports) {
    $parcel$export(module.exports, "UFOExperienceState", ()=>$175f7a63840c5fab$export$81b70111112841a0);
    const $175f7a63840c5fab$export$81b70111112841a0 = {
        NOT_STARTED: {
            id: 'NOT_STARTED',
            final: true
        },
        STARTED: {
            id: 'STARTED'
        },
        IN_PROGRESS: {
            id: 'IN_PROGRESS'
        },
        BLOCKED: {
            id: 'BLOCKED'
        },
        RECOVERED: {
            id: 'RECOVERED'
        },
        SUCCEEDED: {
            id: 'SUCCEEDED',
            final: true,
            success: true
        },
        SUCCEEDED_WAITING_FOR_DEPS: {
            id: 'SUCCEEDED_WAITING_FOR_DEPS'
        },
        FAILED: {
            id: 'FAILED',
            final: true
        },
        ABORTED: {
            id: 'ABORTED',
            final: true
        }
    };
});
parcelRegister("d3gzD", function(module, exports) {
    $parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", ()=>$d045e9522a427a64$export$b4ff48c8d43b18c3);
    var $cb25w;
    var $jZA09;
    var $lFKmC = parcelRequire("lFKmC");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $fUmMr;
    var $78Gdn;
    var $8fG8p;
    var $3smIt;
    var $pk97C;
    const $d045e9522a427a64$var$loadingMessage = ()=>null;
    const $d045e9522a427a64$var$classNamePrefix = 'fabric-user-picker';
    class $d045e9522a427a64$export$b4ff48c8d43b18c3 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isMulti: false,
                subtle: false,
                noBorder: false,
                textFieldBackgroundColor: false,
                isClearable: true,
                loadOptionsErrorMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("8fG8p")).messages).errorMessage),
                openMenuOnClick: false
            };
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            const derivedState = {};
            if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
            if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
            if (nextProps.value !== undefined) derivedState.value = (0, (0, parcelRequire("3smIt")).optionToSelectableOptions)(nextProps.value);
            else if ((0, (0, parcelRequire("3smIt")).isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
                derivedState.value = (0, (0, parcelRequire("3smIt")).optionToSelectableOptions)(nextProps.defaultValue);
                derivedState.isDefaultSet = true;
            }
            if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
            if (nextProps.options !== undefined) derivedState.options = nextProps.options;
            return derivedState;
        }
        constructor(props){
            super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                    if (this.selectRef) callback(this.selectRef);
                }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
                if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
            }, this.blur = ()=>{
                if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
            }, this.selectOption = this.withSelectRef((select)=>{
                const focusedOption = select.state.focusedOption;
                select.selectOption(focusedOption);
            }), this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
                if (removedValue && removedValue.data.fixed) return;
                this.resetInputState();
                const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
                (0, (0, parcelRequire("3smIt")).callCallback)(onChange, (0, (0, parcelRequire("3smIt")).extractOptionValue)(value), action);
                switch(action){
                    case 'select-option':
                        if (value) (0, (0, parcelRequire("3smIt")).callCallback)(onSelection, (0, (0, parcelRequire("3smIt")).extractOptionValue)(value), this.getSessionId(), this);
                        this.fireEvent((0, (0, parcelRequire("fUmMr")).selectEvent), isMulti ? option : value);
                        this.session = isMulti ? (0, (0, parcelRequire("fUmMr")).startSession)() : undefined;
                        break;
                    case 'clear':
                        (0, (0, parcelRequire("3smIt")).callCallback)(onClear);
                        this.fireEvent((0, (0, parcelRequire("fUmMr")).clearEvent));
                        break;
                    case 'remove-value':
                    case 'pop-value':
                        if (removedValue) this.fireEvent((0, (0, parcelRequire("fUmMr")).deleteEvent), removedValue.data);
                        break;
                }
                this.fireEvent((0, (0, parcelRequire("fUmMr")).searchedEvent));
                if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                    const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                    this.setState({
                        value: remainingValues ? remainingValues : [],
                        menuIsOpen: true
                    });
                }
                if (!this.props.value) this.setState({
                    value: value ? value : []
                });
            }, this.handleSelectRef = (ref)=>{
                this.selectRef = ref;
            }, this.addOptions = (0, (0, parcelRequire("78Gdn")).batchByKey)((request, newOptions)=>{
                const { resolving: resolving } = this.state;
                this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                    if (inflightRequest.toString() === request) return {
                        options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                        count: count - newOptions.length,
                        resolving: count - newOptions.length !== 0
                    };
                    return null;
                });
            }), this.handleLoadOptionsError = ()=>{
                const { count: count } = this.state;
                const newCount = count - 1;
                const resolving = newCount !== 0;
                let showError = false;
                if (!resolving) showError = true;
                this.setState({
                    count: newCount,
                    resolving: resolving,
                    showError: showError
                });
                this.fireEvent((0, (0, parcelRequire("fUmMr")).failedEvent));
            }, this.debouncedLoadOptions = (0, ($parcel$interopDefault($lFKmC)))((search)=>{
                const { loadOptions: loadOptions } = this.props;
                if (loadOptions) this.setState(({ inflightRequest: previousRequest })=>{
                    const inflightRequest = previousRequest + 1;
                    const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                    const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                    let count = 0;
                    if ((0, (0, parcelRequire("3smIt")).isIterable)(result)) for (const value of result){
                        Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                        count++;
                    }
                    else {
                        Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                        count++;
                    }
                    return {
                        inflightRequest: inflightRequest,
                        count: count,
                        resolving: count !== 0,
                        options: []
                    };
                });
            }, 200), this.abortOptionsShownUfoExperience = ()=>{
                if (this.optionsShownUfoExperienceInstance.state.id === (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id) this.optionsShownUfoExperienceInstance.abort();
            }, this.startOptionsShownUfoExperience = ()=>{
                this.abortOptionsShownUfoExperience();
                this.optionsShownUfoExperienceInstance.start();
            }, this.executeLoadOptions = (search)=>{
                const { loadOptions: loadOptions } = this.props;
                if (loadOptions) this.setState({
                    resolving: true,
                    showError: false
                }, ()=>this.debouncedLoadOptions(search));
            }, this.handleFocus = (event)=>{
                const { value: value, menuIsOpen: menuIsOpen } = this.state;
                if (!menuIsOpen || !this.session) this.startSession();
                this.startOptionsShownUfoExperience();
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onFocus, this.getSessionId());
                if (!this.isMenuOpenOnClickForSingleSelect) {
                    this.setState({
                        menuIsOpen: true
                    });
                    if (!this.props.isMulti && (0, (0, parcelRequire("3smIt")).isSingleValue)(value)) {
                        const input = event.target;
                        this.setState({
                            inputValue: value.label
                        }, ()=>{
                            if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                        });
                    }
                }
            }, this.resetInputState = ()=>{
                this.setState({
                    inputValue: ''
                });
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onInputChange, '', this.getSessionId());
            }, this.handleBlur = ()=>{
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onBlur, this.getSessionId());
                if ((0, (0, parcelRequire("3smIt")).isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
                this.resetInputState();
                this.abortOptionsShownUfoExperience();
                this.setState({
                    menuIsOpen: false,
                    initialFocusHandled: false,
                    options: []
                });
            }, this.handleOpen = ()=>{
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onOpen, this.getSessionId());
                this.setState({
                    menuIsOpen: true
                });
            }, this.handleClose = ()=>{
                this.resetInputState();
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onClose, this.getSessionId());
                this.setState({
                    menuIsOpen: false,
                    options: []
                });
            }, this.handleInputChange = (search, { action: action })=>{
                if (action === 'input-change' || action === 'set-value') {
                    (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onInputChange, search, this.getSessionId());
                    this.setState({
                        inputValue: search
                    });
                    this.startOptionsShownUfoExperience();
                }
            }, this.fireEvent = (eventCreator, ...args)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                if (createAnalyticsEvent) (0, (0, parcelRequire("fUmMr")).createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
            }, this.startSession = ()=>{
                this.session = (0, (0, parcelRequire("fUmMr")).startSession)();
                this.journeyId = this.getSessionId();
                this.fireEvent((0, (0, parcelRequire("fUmMr")).focusEvent));
            }, this.handleKeyDown = (event)=>{
                if (!this.isMenuOpenOnClickForSingleSelect) {
                    if (event.keyCode === 27) this.blur();
                    if (event.keyCode === 32 && !this.state.inputValue) {
                        event.preventDefault();
                        !this.props.disableInput && this.setState({
                            inputValue: ' '
                        });
                    }
                }
                if (this.session) {
                    this.session.lastKey = event.keyCode;
                    switch(event.keyCode){
                        case 38:
                            this.session.upCount++;
                            break;
                        case 40:
                            this.session.downCount++;
                            break;
                    }
                }
                this.props.onKeyDown && this.props.onKeyDown(event);
            }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
                this.setState({
                    hoveringClearIndicator: hoveringClearIndicator
                });
            }, this.getOptions = ()=>{
                const options = (0, (0, parcelRequire("3smIt")).getOptions)(this.state.options) || [];
                const { maxOptions: maxOptions, isMulti: isMulti } = this.props;
                if (maxOptions === 0) return [];
                if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                    const { value: value } = this.state;
                    let filteredOptions = options;
                    if (isMulti && Array.isArray(value)) {
                        const valueIds = value.map((item)=>item.data.id);
                        filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                    }
                    return filteredOptions.slice(0, maxOptions);
                }
                return options;
            }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
                if (this.state.initialFocusHandled) {
                    if (this.state.menuIsOpen) this.handleClose();
                    else this.handleOpen();
                } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                    this.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            this.state = {
                options: [],
                isDefaultSet: false,
                inflightRequest: 0,
                count: 0,
                hoveringClearIndicator: false,
                menuIsOpen: !!this.props.open,
                inputValue: props.search || '',
                resolving: false,
                showError: false,
                initialFocusHandled: false
            };
            this.optionsShownUfoExperienceInstance = (0, (0, parcelRequire("pk97C")).userPickerOptionsShownUfoExperience).getInstance((0, $7Jxgt.v4)());
        }
        get isMenuOpenOnClickForSingleSelect() {
            return this.props.openMenuOnClick && !this.props.isMulti;
        }
        componentDidMount() {
            const { open: open, search: search } = this.props;
            if (open) {
                if (!this.session) this.startSession();
                this.executeLoadOptions(search);
            }
        }
        componentDidUpdate(_, prevState) {
            const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
            if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
            if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
            if (!menuIsOpen && prevState.menuIsOpen && this.session) {
                this.fireEvent((0, (0, parcelRequire("fUmMr")).cancelEvent), prevState);
                this.session = undefined;
            }
            if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, (0, parcelRequire("fUmMr")).searchedEvent));
            if (this.state.inputValue !== prevState.inputValue) {
                if (this.session) this.session.inputChangeTime = Date.now();
            }
            if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
                (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id,
                (0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
        }
        get ariaProps() {
            const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
            const props = {
                ...this.props
            };
            return ariaLabels.reduce((obj, key)=>({
                    ...obj,
                    [key]: props[key]
                }), {});
        }
        render() {
            const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
            const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
            const appearance = this.getAppearance();
            const menuOpenDeciderProps = {
                ...!this.isMenuOpenOnClickForSingleSelect && {
                    menuIsOpen: menuIsOpen,
                    blurInputOnSelect: !isMulti,
                    openMenuOnFocus: true
                }
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
                name: name,
                value: value,
                autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
                "aria-labelledby": ariaLabelledBy,
                "aria-label": ariaLabel,
                "aria-live": ariaLive,
                "aria-required": required,
                required: required,
                ref: this.handleSelectRef,
                isMulti: isMulti,
                options: this.getOptions(),
                styles: styles,
                enableAnimation: isMulti,
                components: components,
                inputValue: inputValue,
                isLoading: count > 0 || resolving || isLoading,
                loadingMessage: $d045e9522a427a64$var$loadingMessage,
                menuPlacement: "auto",
                placeholder: placeholder ?? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("8fG8p")).messages).placeholder),
                addMoreMessage: addMoreMessage,
                classNamePrefix: $d045e9522a427a64$var$classNamePrefix,
                hoveringClearIndicator: hoveringClearIndicator,
                appearance: appearance,
                isClearable: isClearable,
                noBorder: noBorder,
                subtle: subtle,
                closeMenuOnSelect: !isMulti,
                noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
                footer: footer,
                isDisabled: isDisabled,
                isInvalid: isInvalid,
                isFocused: menuIsOpen,
                backspaceRemovesValue: isMulti,
                filterOption: null,
                clearValueLabel: clearValueLabel,
                menuMinWidth: menuMinWidth,
                menuPortalTarget: menuPortalTarget,
                disableInput: disableInput || isDisabled,
                instanceId: fieldId,
                inputId: inputId,
                onChange: this.handleChange,
                onMenuOpen: this.handleOpen,
                onFocus: this.handleFocus,
                onBlur: this.handleBlur,
                onMenuClose: this.handleClose,
                onInputChange: this.handleInputChange,
                onClearIndicatorHover: this.handleClearIndicatorHover,
                onKeyDown: this.handleKeyDown,
                maxPickerHeight: maxPickerHeight,
                textFieldBackgroundColor: textFieldBackgroundColor,
                header: header,
                placeholderAvatar: placeholderAvatar,
                ...this.ariaProps,
                ...pickerProps,
                ...UNSAFE_hasDraggableParentComponent && {
                    onValueContainerClick: this.handleClickDraggableParentComponent
                },
                ...menuOpenDeciderProps
            });
        }
    }
    const $d045e9522a427a64$export$d099ade7b4f4d2a4 = (0, (0, parcelRequire("cb25w")).default)()($d045e9522a427a64$export$b4ff48c8d43b18c3);
});
parcelRegister("fUmMr", function(module, exports) {
    $parcel$export(module.exports, "startSession", ()=>$e345c0b18a65d683$export$c0d84948cecf78d8);
    $parcel$export(module.exports, "createAndFireEventInElementsChannel", ()=>$e345c0b18a65d683$export$53eef0dcd9611650);
    $parcel$export(module.exports, "focusEvent", ()=>$e345c0b18a65d683$export$e7818c470f37c4bd);
    $parcel$export(module.exports, "clearEvent", ()=>$e345c0b18a65d683$export$7b5800e732182efb);
    $parcel$export(module.exports, "deleteEvent", ()=>$e345c0b18a65d683$export$95711ec6c6227e9a);
    $parcel$export(module.exports, "cancelEvent", ()=>$e345c0b18a65d683$export$e9caaaecfee38128);
    $parcel$export(module.exports, "selectEvent", ()=>$e345c0b18a65d683$export$48143d759475d90f);
    $parcel$export(module.exports, "searchedEvent", ()=>$e345c0b18a65d683$export$911fb7184b6037eb);
    $parcel$export(module.exports, "failedEvent", ()=>$e345c0b18a65d683$export$c2aec355fef65c9c);
    $parcel$export(module.exports, "userInfoEvent", ()=>$e345c0b18a65d683$export$f541f04954b0c11e);
    var $gB4mS;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $3smIt;
    const $e345c0b18a65d683$var$packageName = "platform-pkg";
    const $e345c0b18a65d683$var$packageVersion = "0.0.0-use.local";
    const $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
    const $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
    const $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
    const $e345c0b18a65d683$export$c0d84948cecf78d8 = ()=>({
            id: (0, $7Jxgt.v4)(),
            start: Date.now(),
            inputChangeTime: Date.now(),
            upCount: 0,
            downCount: 0,
            lastKey: undefined
        });
    const $e345c0b18a65d683$export$53eef0dcd9611650 = (0, (0, parcelRequire("gB4mS")).default)('fabric-elements');
    const $e345c0b18a65d683$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
            eventType: eventType,
            action: action,
            actionSubject: actionSubject,
            attributes: {
                packageName: $e345c0b18a65d683$var$packageName,
                packageVersion: $e345c0b18a65d683$var$packageVersion,
                ...attributes
            }
        });
    const $e345c0b18a65d683$var$checkValidId = (id)=>{
        return $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
    };
    const $e345c0b18a65d683$var$optionData2Analytics = (option)=>{
        const { id: id, type: type } = option;
        const validatedData = {
            id: $e345c0b18a65d683$var$checkValidId(id) ? id : null,
            type: type || null
        };
        if ((0, (0, parcelRequire("3smIt")).isExternalUser)(option)) return {
            ...validatedData,
            type: 'external_user',
            sources: option.sources,
            externalUserType: option.externalUserType
        };
        if ((0, (0, parcelRequire("3smIt")).isCustom)(option) && option.analyticsType) return {
            ...validatedData,
            type: option.analyticsType
        };
        return validatedData;
    };
    const $e345c0b18a65d683$var$buildValueForAnalytics = (value)=>{
        if (value) {
            const valueToConvert = Array.isArray(value) ? value : [
                value
            ];
            return valueToConvert.map(({ data: data })=>$e345c0b18a65d683$var$optionData2Analytics(data));
        }
        return [];
    };
    const $e345c0b18a65d683$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
            context: props.fieldId,
            sessionId: $e345c0b18a65d683$var$sessionId(session),
            pickerType: $e345c0b18a65d683$var$pickerType(props),
            journeyId: journeyId
        });
    const $e345c0b18a65d683$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'focused', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            values: $e345c0b18a65d683$var$buildValueForAnalytics(state.value)
        });
    const $e345c0b18a65d683$export$7b5800e732182efb = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'cleared', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            pickerOpen: state.menuIsOpen,
            values: $e345c0b18a65d683$var$values(state)
        });
    const $e345c0b18a65d683$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'deleted', 'userPickerItem', {
            context: props.fieldId,
            sessionId: $e345c0b18a65d683$var$sessionId(session),
            journeyId: journeyId,
            value: $e345c0b18a65d683$var$optionData2Analytics(args[0]),
            pickerOpen: state.menuIsOpen
        });
    const $e345c0b18a65d683$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'cancelled', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
            queryLength: $e345c0b18a65d683$var$queryLength(args[0]),
            spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(args[0]),
            upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
            downKeyCount: $e345c0b18a65d683$var$downKeyCount(session)
        });
    const $e345c0b18a65d683$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
        return $e345c0b18a65d683$var$createEvent('ui', $e345c0b18a65d683$var$selectEventType(session), 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
            position: $e345c0b18a65d683$var$position(state, args[0]),
            queryLength: $e345c0b18a65d683$var$queryLength(state),
            spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(state),
            upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
            downKeyCount: $e345c0b18a65d683$var$downKeyCount(session),
            result: $e345c0b18a65d683$var$result(args[0]),
            numberOfResults: $e345c0b18a65d683$var$numberOfResults(state)
        });
    };
    const $e345c0b18a65d683$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
        const searchResults = $e345c0b18a65d683$var$results(state);
        return $e345c0b18a65d683$var$createEvent('operational', 'searched', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
            durationSinceInputChange: $e345c0b18a65d683$var$durationSinceInputChange(session),
            queryLength: $e345c0b18a65d683$var$queryLength(state),
            isLoading: $e345c0b18a65d683$var$isLoading(props, state),
            results: searchResults,
            numberOfResults: searchResults.length
        });
    };
    const $e345c0b18a65d683$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$e345c0b18a65d683$var$createEvent('operational', 'failed', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId)
        });
    const $e345c0b18a65d683$export$f541f04954b0c11e = (sources, accountId)=>$e345c0b18a65d683$var$createEvent('ui', 'displayed', 'userInfo', {
            sources: sources,
            accountId: $e345c0b18a65d683$var$checkValidId(accountId) ? accountId : null
        });
    function $e345c0b18a65d683$var$queryLength(state) {
        return state.inputValue.length;
    }
    function $e345c0b18a65d683$var$selectEventType(session) {
        return session && session.lastKey === 13 ? 'pressed' : 'clicked';
    }
    function $e345c0b18a65d683$var$upKeyCount(session) {
        return session ? session.upCount : null;
    }
    function $e345c0b18a65d683$var$downKeyCount(session) {
        return session ? session.downCount : null;
    }
    function $e345c0b18a65d683$var$spaceInQuery(state) {
        return state.inputValue.indexOf(' ') !== -1;
    }
    function $e345c0b18a65d683$var$sessionDuration(session) {
        return session ? Date.now() - session.start : null;
    }
    function $e345c0b18a65d683$var$durationSinceInputChange(session) {
        return session ? Date.now() - session.inputChangeTime : null;
    }
    function $e345c0b18a65d683$var$sessionId(session) {
        return session && session.id;
    }
    function $e345c0b18a65d683$var$position(state, value) {
        return value ? state.options.findIndex((option)=>option === value.data) : -1;
    }
    function $e345c0b18a65d683$var$pickerType(props) {
        return props.isMulti ? 'multi' : 'single';
    }
    function $e345c0b18a65d683$var$result(option) {
        return option ? $e345c0b18a65d683$var$optionData2Analytics(option.data) : null;
    }
    function $e345c0b18a65d683$var$results(state) {
        return (state.options || []).map($e345c0b18a65d683$var$optionData2Analytics);
    }
    function $e345c0b18a65d683$var$isLoading(props, state) {
        return state.count > 0 || props.isLoading;
    }
    function $e345c0b18a65d683$var$values(state) {
        return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$e345c0b18a65d683$var$optionData2Analytics(option.data)) : [
            $e345c0b18a65d683$var$optionData2Analytics(state.value.data)
        ] : [];
    }
    function $e345c0b18a65d683$var$numberOfResults(state) {
        return (state.options || []).length;
    }
});
parcelRegister("3smIt", function(module, exports) {
    $parcel$export(module.exports, "isExternalUser", ()=>$02015d62698c11ec$export$f6058dbcb5980cb);
    $parcel$export(module.exports, "isUser", ()=>$02015d62698c11ec$export$2e44165f1da65304);
    $parcel$export(module.exports, "isTeam", ()=>$02015d62698c11ec$export$f8c4277cb588611f);
    $parcel$export(module.exports, "isGroup", ()=>$02015d62698c11ec$export$d7976824e9f55785);
    $parcel$export(module.exports, "isEmail", ()=>$02015d62698c11ec$export$7fbbfbca30081d0);
    $parcel$export(module.exports, "isCustom", ()=>$02015d62698c11ec$export$d3a8f0b77e9737fc);
    $parcel$export(module.exports, "isDefaultValuePopulated", ()=>$02015d62698c11ec$export$d6978985a41b0c8);
    $parcel$export(module.exports, "extractOptionValue", ()=>$02015d62698c11ec$export$7ae97131df521bff);
    $parcel$export(module.exports, "isIterable", ()=>$02015d62698c11ec$export$9652023d9040757);
    $parcel$export(module.exports, "getOptions", ()=>$02015d62698c11ec$export$d2312e68e1f5ad00);
    $parcel$export(module.exports, "optionToSelectableOptions", ()=>$02015d62698c11ec$export$e6fda14a194bcbcc);
    $parcel$export(module.exports, "getAvatarSize", ()=>$02015d62698c11ec$export$695fb564e621339a);
    $parcel$export(module.exports, "isChildInput", ()=>$02015d62698c11ec$export$3c62cf9a01367f27);
    $parcel$export(module.exports, "isSingleValue", ()=>$02015d62698c11ec$export$203c2bd2662d1ca2);
    $parcel$export(module.exports, "hasValue", ()=>$02015d62698c11ec$export$96bdbc84526f3739);
    $parcel$export(module.exports, "callCallback", ()=>$02015d62698c11ec$export$df325aa844b03c31);
    $parcel$export(module.exports, "getAvatarUrl", ()=>$02015d62698c11ec$export$b4f8f1f54acec99b);
    $parcel$export(module.exports, "isPopupUserPickerByComponent", ()=>$02015d62698c11ec$export$4f60a74234178416);
    $parcel$export(module.exports, "isLozengeText", ()=>$02015d62698c11ec$export$5419897287f5f1c7);
    var $8QpSo;
    var $b9dFI;
    const $02015d62698c11ec$export$f6058dbcb5980cb = (option)=>option.type === (0, $f93312f7d4958f08$export$50042ec1d2e00e63) || Boolean(option.isExternal);
    const $02015d62698c11ec$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $f93312f7d4958f08$export$8436e53e45ffe15b);
    const $02015d62698c11ec$export$f8c4277cb588611f = (option)=>option.type === (0, $f93312f7d4958f08$export$26bc40b960693765);
    const $02015d62698c11ec$export$d7976824e9f55785 = (option)=>option.type === (0, $f93312f7d4958f08$export$d460f747b73abb10);
    const $02015d62698c11ec$export$7fbbfbca30081d0 = (option)=>option.type === (0, $f93312f7d4958f08$export$6662b3461398ef8c);
    const $02015d62698c11ec$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $f93312f7d4958f08$export$eafd0979afa5b224);
    const $02015d62698c11ec$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
    const $02015d62698c11ec$var$isOptionData = (option)=>option.name !== undefined;
    const $02015d62698c11ec$export$3f993c492bd6c728 = (option)=>{
        if ($02015d62698c11ec$var$isOptionData(option)) return {
            data: option,
            isDisabled: option.isDisabled,
            label: option.name,
            value: option.id
        };
        else return {
            data: {
                ...option,
                name: option.id
            },
            isDisabled: option.isDisabled,
            label: option.id,
            value: option.id
        };
    };
    const $02015d62698c11ec$export$7ae97131df521bff = (value)=>{
        if (!value) return undefined;
        if (Array.isArray(value)) return value.map(({ data: option })=>option);
        return value.data;
    };
    const $02015d62698c11ec$export$9652023d9040757 = (a)=>typeof a[Symbol.iterator] === 'function';
    const $02015d62698c11ec$export$d2312e68e1f5ad00 = (0, (0, parcelRequire("8QpSo")).default)((options)=>options.map($02015d62698c11ec$export$3f993c492bd6c728));
    const $02015d62698c11ec$export$e6fda14a194bcbcc = (0, (0, parcelRequire("8QpSo")).default)((defaultValue)=>{
        if (!defaultValue) return null;
        if (Array.isArray(defaultValue)) return defaultValue.map($02015d62698c11ec$export$3f993c492bd6c728);
        return $02015d62698c11ec$export$3f993c492bd6c728(defaultValue);
    });
    const $02015d62698c11ec$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
    const $02015d62698c11ec$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
    const $02015d62698c11ec$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
    const $02015d62698c11ec$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
    const $02015d62698c11ec$export$df325aa844b03c31 = (callback, ...args)=>{
        if (typeof callback === 'function') try {
            return callback(...args);
        } catch (error) {
            console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
        }
    };
    const $02015d62698c11ec$export$b4f8f1f54acec99b = (optionData)=>{
        if ($02015d62698c11ec$export$2e44165f1da65304(optionData) || $02015d62698c11ec$export$f8c4277cb588611f(optionData) || $02015d62698c11ec$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
        return undefined;
    };
    const $02015d62698c11ec$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, (0, parcelRequire("b9dFI")).default);
    const $02015d62698c11ec$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
    const $02015d62698c11ec$export$5419897287f5f1c7 = (lozengeProp)=>{
        return lozengeProp?.hasOwnProperty('text') || false;
    };
});
const $f93312f7d4958f08$export$8436e53e45ffe15b = 'user';
const $f93312f7d4958f08$export$50042ec1d2e00e63 = 'external_user';
const $f93312f7d4958f08$export$26bc40b960693765 = 'team';
const $f93312f7d4958f08$export$d460f747b73abb10 = 'group';
const $f93312f7d4958f08$export$6662b3461398ef8c = 'email';
const $f93312f7d4958f08$export$eafd0979afa5b224 = 'custom';
parcelRegister("b9dFI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$768d8504b373d7ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $7nsd3 = parcelRequire("7nsd3");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $5n5w4;
    var $283js;
    var $iGDLS;
    var $4wJSY = parcelRequire("4wJSY");
    var $9KnKW;
    var $7VXAu;
    var $7K5PP;
    var $eaXSR;
    var $1DATb;
    var $hT6ku;
    const $768d8504b373d7ff$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
    const $768d8504b373d7ff$var$modifiers = [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            enabled: true,
            options: {
                padding: 5,
                boundary: 'clippingParents',
                altAxis: true,
                altBoundary: true
            }
        }
    ];
    const $768d8504b373d7ff$var$defaultPopperProps = {
        modifiers: $768d8504b373d7ff$var$modifiers,
        placement: 'bottom-start'
    };
    const $768d8504b373d7ff$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
    class $768d8504b373d7ff$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                closeMenuOnSelect: true,
                shouldCloseMenuOnTab: true,
                components: {},
                maxMenuHeight: 300,
                maxMenuWidth: 440,
                minMenuWidth: 220,
                popperProps: {},
                isSearchable: true,
                searchThreshold: 5,
                styles: {},
                options: []
            };
        }
        static getDerivedStateFromProps(props, state) {
            const newState = {};
            const mergedPopperProps = {
                ...$768d8504b373d7ff$var$defaultPopperProps,
                ...props.popperProps
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
            const mergedComponents = {
                ...(0, (0, parcelRequire("hT6ku")).defaultComponents),
                ...props.components
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
            if (!$768d8504b373d7ff$var$isEmpty(newState)) return newState;
            return null;
        }
        componentDidMount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'click',
                listener: this.handleClick,
                options: {
                    capture: true
                }
            });
        }
        componentWillUnmount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick?.();
            this.unbindWindowClick = null;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }
        componentDidUpdate(prevProps) {
            const { isOpen: isOpen } = this.props;
            if (prevProps.isOpen !== isOpen) {
                if (isOpen === true) this.open({
                    controlOverride: true
                });
                else if (isOpen === false) this.close({
                    controlOverride: true
                });
            }
        }
        render() {
            const { target: target } = this.props;
            const { isOpen: isOpen } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5n5w4")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9KnKW")).IdProvider), {
                postfix: "-popup-select"
            }, ({ id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iGDLS")).Reference), null, ({ ref: ref })=>target && target({
                        isOpen: isOpen,
                        onKeyDown: this.handleTargetKeyDown,
                        ref: this.resolveTargetRef(ref),
                        'aria-haspopup': 'true',
                        'aria-expanded': isOpen,
                        'aria-controls': isOpen ? id : undefined
                    })), this.renderSelect(id))));
        }
        constructor(...args){
            super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
                groupHeading: (provided)=>({
                        ...provided,
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`
                    })
            }), this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
                focusLockEnabled: false,
                isOpen: this.defaultOpenState ?? false,
                mergedComponents: (0, (0, parcelRequire("hT6ku")).defaultComponents),
                mergedPopperProps: $768d8504b373d7ff$var$defaultPopperProps
            }, this.handleTargetKeyDown = (event)=>{
                switch(event.key){
                    case 'ArrowDown':
                        this.open();
                        break;
                    default:
                }
            }, this.handleKeyDown = (event)=>{
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
                switch(event.key){
                    case 'Escape':
                    case 'Esc':
                        this.close();
                        break;
                    default:
                }
                if (this.props.onKeyDown) this.props.onKeyDown(event);
            }, this.handleClick = ({ target: target })=>{
                const { isOpen: isOpen } = this.state;
                if (!(target instanceof Element)) return;
                if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
                if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
            }, this.handleSelectChange = (value, actionMeta)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
                if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
                if (onChange) onChange(value, actionMeta);
            }, this.handleFirstPopperUpdate = ()=>{
                this.setState({
                    focusLockEnabled: true
                });
            }, this.open = (options)=>{
                const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onOpen) onOpen();
                if (onMenuOpen) onMenuOpen();
                this.setState({
                    isOpen: true
                }, ()=>{
                    if (this.selectRef) this.selectRef.select?.openMenu('first');
                });
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: 'keydown',
                    listener: this.handleKeyDown,
                    options: {
                        capture: true
                    }
                });
            }, this.close = (options)=>{
                const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onClose) onClose();
                if (onMenuClose) onMenuClose();
                this.setState({
                    isOpen: false
                });
                this.setState({
                    focusLockEnabled: false
                });
                if (this.targetRef != null) this.targetRef.focus();
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown?.();
                this.unbindWindowKeydown = null;
            }, this.resolveTargetRef = (popperRef)=>(ref)=>{
                    if (!this.targetRef && popperRef && ref) {
                        this.targetRef = ref;
                        if (typeof popperRef === 'function') popperRef(ref);
                        else popperRef.current = ref;
                    }
                }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                    this.menuRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }, this.getSelectRef = (ref)=>{
                this.selectRef = ref;
            }, this.getItemCount = ()=>{
                const { options: options } = this.props;
                let count = 0;
                options.forEach((groupOrOption)=>{
                    if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                    else count++;
                });
                return count;
            }, this.getMaxHeight = ()=>{
                const { maxMenuHeight: maxMenuHeight } = this.props;
                if (!this.selectRef) return maxMenuHeight;
                const showSearchControl = this.showSearchControl();
                const controlRef = this.selectRef.select?.controlRef;
                const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
                const maxHeight = maxMenuHeight - offsetHeight;
                return maxHeight;
            }, this.showSearchControl = ()=>{
                const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
                return isSearchable && this.getItemCount() > searchThreshold;
            }, this.renderSelect = (id)=>{
                const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
                const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
                const showSearchControl = this.showSearchControl();
                const portalDestination = $768d8504b373d7ff$var$canUseDOM() ? document.body : null;
                if (!portalDestination || !isOpen) return null;
                const selectComponents = {
                    ...mergedComponents,
                    Control: showSearchControl ? mergedComponents.Control : (0, (0, parcelRequire("hT6ku")).DummyControl)
                };
                const getLabel = ()=>{
                    if (label) return label;
                    else if (typeof placeholder === 'string') return placeholder;
                };
                const providedAriaLabel = getLabel();
                const updateInputAriaLabel = (ariaLabelText)=>{
                    if (this.selectRef?.select?.inputRef) {
                        if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                        this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                    }
                };
                const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                    const { focused: focused } = onFocusProps;
                    const options = props?.options || [];
                    const totalLength = options?.length;
                    const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                    const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                    const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                    return ariaLabelText;
                };
                const onReactSelectFocus = (onFocusProps)=>{
                    const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                    let ariaLabelText = '';
                    let ariaLiveMessage = '';
                    if (props.options?.length) {
                        if ((0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options)) {
                            const totalLength = (0, (0, parcelRequire("1DATb")).countAllOptions)(props.options);
                            ariaLiveMessage = (0, (0, parcelRequire("1DATb")).onFocus)(onFocusProps, props.options);
                            ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                        } else {
                            ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                            ariaLiveMessage = ariaLabelText;
                        }
                        updateInputAriaLabel(ariaLabelText);
                        return ariaLiveMessage;
                    }
                    return ariaLiveMessage;
                };
                const popper = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("283js")).Popper), {
                    ...mergedPopperProps,
                    onFirstUpdate: (state)=>{
                        this.handleFirstPopperUpdate();
                        mergedPopperProps.onFirstUpdate?.(state);
                    }
                }, ({ placement: placement, ref: ref, style: style })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hT6ku")).MenuDialog), {
                        style: style,
                        "data-placement": placement,
                        minWidth: minMenuWidth,
                        maxWidth: maxMenuWidth,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
                        disabled: !focusLockEnabled,
                        returnFocus: true
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                        "aria-label": providedAriaLabel,
                        backspaceRemovesValue: false,
                        controlShouldRenderValue: false,
                        isClearable: false,
                        tabSelectsValue: false,
                        menuIsOpen: true,
                        placeholder: placeholder,
                        ref: this.getSelectRef,
                        ...props,
                        isSearchable: showSearchControl,
                        styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)(this.defaultStyles, props.styles || {}),
                        maxMenuHeight: this.getMaxHeight(),
                        components: selectComponents,
                        onChange: this.handleSelectChange,
                        ariaLiveMessages: !showSearchControl ? {
                            onFocus: onReactSelectFocus,
                            ...props.ariaLiveMessages
                        } : props.ariaLiveMessages
                    }), footer)));
                return mergedPopperProps.strategy === 'fixed' ? popper : (0, $7nsd3.createPortal)(popper, portalDestination);
            };
        }
    }
});
parcelRegister("5n5w4", function(module, exports) {
    $parcel$export(module.exports, "ManagerReferenceNodeContext", ()=>$3e93612641040812$export$3dbd3405086fec7b);
    $parcel$export(module.exports, "ManagerReferenceNodeSetterContext", ()=>$3e93612641040812$export$cbabb21c2529b130);
    $parcel$export(module.exports, "Manager", ()=>$3e93612641040812$export$d0d38e7dec7a1a61);
    var $5uXOq = parcelRequire("5uXOq");
    var $3e93612641040812$export$3dbd3405086fec7b = $5uXOq.createContext();
    var $3e93612641040812$export$cbabb21c2529b130 = $5uXOq.createContext();
    function $3e93612641040812$export$d0d38e7dec7a1a61(_ref) {
        var children = _ref.children;
        var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
        var hasUnmounted = $5uXOq.useRef(false);
        $5uXOq.useEffect(function() {
            return function() {
                hasUnmounted.current = true;
            };
        }, []);
        var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
            if (!hasUnmounted.current) setReferenceNode(node);
        }, []);
        return $5uXOq.createElement($3e93612641040812$export$3dbd3405086fec7b.Provider, {
            value: referenceNode
        }, $5uXOq.createElement($3e93612641040812$export$cbabb21c2529b130.Provider, {
            value: handleSetReferenceNode
        }, children));
    }
});
parcelRegister("283js", function(module, exports) {
    $parcel$export(module.exports, "Popper", ()=>$18cee5f949ac4034$export$badac9ada3a0bdf9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5n5w4;
    var $eclLw;
    var $fNOWl;
    var $18cee5f949ac4034$var$NOOP = function NOOP() {
        return void 0;
    };
    var $18cee5f949ac4034$var$NOOP_PROMISE = function NOOP_PROMISE() {
        return Promise.resolve(null);
    };
    var $18cee5f949ac4034$var$EMPTY_MODIFIERS = [];
    function $18cee5f949ac4034$export$badac9ada3a0bdf9(_ref) {
        var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $18cee5f949ac4034$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
        var referenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeContext));
        var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
        var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
        $5uXOq.useEffect(function() {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, popperElement);
        }, [
            innerRef,
            popperElement
        ]);
        var options = $5uXOq.useMemo(function() {
            return {
                placement: placement,
                strategy: strategy,
                onFirstUpdate: onFirstUpdate,
                modifiers: [].concat(modifiers, [
                    {
                        name: 'arrow',
                        enabled: arrowElement != null,
                        options: {
                            element: arrowElement
                        }
                    }
                ])
            };
        }, [
            placement,
            strategy,
            onFirstUpdate,
            modifiers,
            arrowElement
        ]);
        var _usePopper = (0, (0, parcelRequire("fNOWl")).usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
        var childrenProps = $5uXOq.useMemo(function() {
            return {
                ref: setPopperElement,
                style: styles.popper,
                placement: state ? state.placement : placement,
                hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
                isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
                arrowProps: {
                    style: styles.arrow,
                    ref: setArrowElement
                },
                forceUpdate: forceUpdate || $18cee5f949ac4034$var$NOOP,
                update: update || $18cee5f949ac4034$var$NOOP_PROMISE
            };
        }, [
            setPopperElement,
            setArrowElement,
            placement,
            state,
            styles,
            update,
            forceUpdate
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)(childrenProps);
    }
});
parcelRegister("eclLw", function(module, exports) {
    $parcel$export(module.exports, "unwrapArray", ()=>$a56311d537d20f47$export$f52c55943429c8b6);
    $parcel$export(module.exports, "safeInvoke", ()=>$a56311d537d20f47$export$3dfa7c28635fe028);
    $parcel$export(module.exports, "setRef", ()=>$a56311d537d20f47$export$4bb192c7cacf928f);
    $parcel$export(module.exports, "fromEntries", ()=>$a56311d537d20f47$export$5150077fc2e7c662);
    $parcel$export(module.exports, "useIsomorphicLayoutEffect", ()=>$a56311d537d20f47$export$700979bc83e7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $a56311d537d20f47$export$f52c55943429c8b6 = function unwrapArray(arg) {
        return Array.isArray(arg) ? arg[0] : arg;
    };
    var $a56311d537d20f47$export$3dfa7c28635fe028 = function safeInvoke(fn) {
        if (typeof fn === 'function') {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return fn.apply(void 0, args);
        }
    };
    var $a56311d537d20f47$export$4bb192c7cacf928f = function setRef(ref, node) {
        if (typeof ref === 'function') return $a56311d537d20f47$export$3dfa7c28635fe028(ref, node);
        else if (ref != null) ref.current = node;
    };
    var $a56311d537d20f47$export$5150077fc2e7c662 = function fromEntries(entries) {
        return entries.reduce(function(acc, _ref) {
            var key = _ref[0], value = _ref[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    var $a56311d537d20f47$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
});
parcelRegister("fNOWl", function(module, exports) {
    $parcel$export(module.exports, "usePopper", ()=>$b812f23d0bbb9e85$export$f4d5bf230a36dd6e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $8Pv9O;
    var $lHrkK = parcelRequire("lHrkK");
    var $eclLw;
    var $b812f23d0bbb9e85$var$EMPTY_MODIFIERS = [];
    var $b812f23d0bbb9e85$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
        if (options === void 0) options = {};
        var prevOptions = $5uXOq.useRef(null);
        var optionsWithDefaults = {
            onFirstUpdate: options.onFirstUpdate,
            placement: options.placement || 'bottom',
            strategy: options.strategy || 'absolute',
            modifiers: options.modifiers || $b812f23d0bbb9e85$var$EMPTY_MODIFIERS
        };
        var _React$useState = $5uXOq.useState({
            styles: {
                popper: {
                    position: optionsWithDefaults.strategy,
                    left: '0',
                    top: '0'
                },
                arrow: {
                    position: 'absolute'
                }
            },
            attributes: {}
        }), state = _React$useState[0], setState = _React$useState[1];
        var updateStateModifier = $5uXOq.useMemo(function() {
            return {
                name: 'updateState',
                enabled: true,
                phase: 'write',
                fn: function fn(_ref) {
                    var state = _ref.state;
                    var elements = Object.keys(state.elements);
                    $7nsd3.flushSync(function() {
                        setState({
                            styles: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.styles[element] || {}
                                ];
                            })),
                            attributes: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.attributes[element]
                                ];
                            }))
                        });
                    });
                },
                requires: [
                    'computeStyles'
                ]
            };
        }, []);
        var popperOptions = $5uXOq.useMemo(function() {
            var newOptions = {
                onFirstUpdate: optionsWithDefaults.onFirstUpdate,
                placement: optionsWithDefaults.placement,
                strategy: optionsWithDefaults.strategy,
                modifiers: [].concat(optionsWithDefaults.modifiers, [
                    updateStateModifier,
                    {
                        name: 'applyStyles',
                        enabled: false
                    }
                ])
            };
            if ((0, ($parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
            else {
                prevOptions.current = newOptions;
                return newOptions;
            }
        }, [
            optionsWithDefaults.onFirstUpdate,
            optionsWithDefaults.placement,
            optionsWithDefaults.strategy,
            optionsWithDefaults.modifiers,
            updateStateModifier
        ]);
        var popperInstanceRef = $5uXOq.useRef();
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
        }, [
            popperOptions
        ]);
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (referenceElement == null || popperElement == null) return;
            var createPopper = options.createPopper || (0, (0, parcelRequire("8Pv9O")).createPopper);
            var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
            popperInstanceRef.current = popperInstance;
            return function() {
                popperInstance.destroy();
                popperInstanceRef.current = null;
            };
        }, [
            referenceElement,
            popperElement,
            options.createPopper
        ]);
        return {
            state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
            styles: state.styles,
            attributes: state.attributes,
            update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
            forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
        };
    };
});
parcelRegister("8Pv9O", function(module, exports) {
    $parcel$export(module.exports, "createPopper", ()=>$66db415bc009fd50$export$8f7491d57c8f97a9);
    var $dsn8Y;
    var $4TVC8;
    var $j8nKB;
    var $baic6;
    var $1AoLg;
    var $gy4Xr;
    var $3dDWl;
    var $1DdSC;
    var $gzAfz;
    var $6iLAT;
    var $66db415bc009fd50$export$d34966752335dd47 = [
        (0, (0, parcelRequire("4TVC8")).default),
        (0, (0, parcelRequire("j8nKB")).default),
        (0, (0, parcelRequire("baic6")).default),
        (0, (0, parcelRequire("1AoLg")).default),
        (0, (0, parcelRequire("gy4Xr")).default),
        (0, (0, parcelRequire("3dDWl")).default),
        (0, (0, parcelRequire("1DdSC")).default),
        (0, (0, parcelRequire("gzAfz")).default),
        (0, (0, parcelRequire("6iLAT")).default)
    ];
    var $66db415bc009fd50$export$8f7491d57c8f97a9 = (0, (0, parcelRequire("dsn8Y")).popperGenerator)({
        defaultModifiers: $66db415bc009fd50$export$d34966752335dd47
    });
});
parcelRegister("dsn8Y", function(module, exports) {
    $parcel$export(module.exports, "popperGenerator", ()=>$9cbfd7bdb6a4f3f1$export$ed5e13716264f202);
    var $gvlia;
    var $jkGDj;
    var $2r6BH;
    var $gbHJy;
    var $kcmIg;
    var $a8clb;
    var $i9xH7;
    var $gmkfg;
    var $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS = {
        placement: 'bottom',
        modifiers: [],
        strategy: 'absolute'
    };
    function $9cbfd7bdb6a4f3f1$var$areValidElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return !args.some(function(element) {
            return !(element && typeof element.getBoundingClientRect === 'function');
        });
    }
    function $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(generatorOptions) {
        if (generatorOptions === void 0) generatorOptions = {};
        var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS : _generatorOptions$def2;
        return function createPopper(reference, popper, options) {
            if (options === void 0) options = defaultOptions;
            var state = {
                placement: 'bottom',
                orderedModifiers: [],
                options: Object.assign({}, $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS, defaultOptions),
                modifiersData: {},
                elements: {
                    reference: reference,
                    popper: popper
                },
                attributes: {},
                styles: {}
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
                state: state,
                setOptions: function setOptions(setOptionsAction) {
                    var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                    cleanupModifierEffects();
                    state.options = Object.assign({}, defaultOptions, state.options, options);
                    state.scrollParents = {
                        reference: (0, (0, parcelRequire("gmkfg")).isElement)(reference) ? (0, (0, parcelRequire("2r6BH")).default)(reference) : reference.contextElement ? (0, (0, parcelRequire("2r6BH")).default)(reference.contextElement) : [],
                        popper: (0, (0, parcelRequire("2r6BH")).default)(popper)
                    };
                    var orderedModifiers = (0, (0, parcelRequire("kcmIg")).default)((0, (0, parcelRequire("i9xH7")).default)([].concat(defaultModifiers, state.options.modifiers)));
                    state.orderedModifiers = orderedModifiers.filter(function(m) {
                        return m.enabled;
                    });
                    runModifierEffects();
                    return instance.update();
                },
                forceUpdate: function forceUpdate() {
                    if (isDestroyed) return;
                    var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
                    if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return;
                    state.rects = {
                        reference: (0, (0, parcelRequire("gvlia")).default)(reference, (0, (0, parcelRequire("gbHJy")).default)(popper), state.options.strategy === 'fixed'),
                        popper: (0, (0, parcelRequire("jkGDj")).default)(popper)
                    };
                    state.reset = false;
                    state.placement = state.options.placement;
                    state.orderedModifiers.forEach(function(modifier) {
                        return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                    });
                    for(var index = 0; index < state.orderedModifiers.length; index++){
                        if (state.reset === true) {
                            state.reset = false;
                            index = -1;
                            continue;
                        }
                        var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                        if (typeof fn === 'function') state = fn({
                            state: state,
                            options: _options,
                            name: name,
                            instance: instance
                        }) || state;
                    }
                },
                update: (0, (0, parcelRequire("a8clb")).default)(function() {
                    return new Promise(function(resolve) {
                        instance.forceUpdate();
                        resolve(state);
                    });
                }),
                destroy: function destroy() {
                    cleanupModifierEffects();
                    isDestroyed = true;
                }
            };
            if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return instance;
            instance.setOptions(options).then(function(state) {
                if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
            });
            function runModifierEffects() {
                state.orderedModifiers.forEach(function(_ref) {
                    var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                    if (typeof effect === 'function') {
                        var cleanupFn = effect({
                            state: state,
                            name: name,
                            instance: instance,
                            options: options
                        });
                        var noopFn = function noopFn() {};
                        effectCleanupFns.push(cleanupFn || noopFn);
                    }
                });
            }
            function cleanupModifierEffects() {
                effectCleanupFns.forEach(function(fn) {
                    return fn();
                });
                effectCleanupFns = [];
            }
            return instance;
        };
    }
    var $9cbfd7bdb6a4f3f1$export$8f7491d57c8f97a9 = $9cbfd7bdb6a4f3f1$export$ed5e13716264f202();
});
parcelRegister("gvlia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0400ebb908e52cb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $9FFjG;
    var $f5IBt;
    var $gmkfg;
    var $imzt5;
    var $eVELE;
    var $c6EdA;
    var $90xPK;
    function $c0400ebb908e52cb$var$isElementScaled(element) {
        var rect = element.getBoundingClientRect();
        var scaleX = (0, (0, parcelRequire("90xPK")).round)(rect.width) / element.offsetWidth || 1;
        var scaleY = (0, (0, parcelRequire("90xPK")).round)(rect.height) / element.offsetHeight || 1;
        return scaleX !== 1 || scaleY !== 1;
    }
    function $c0400ebb908e52cb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
        if (isFixed === void 0) isFixed = false;
        var isOffsetParentAnElement = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent);
        var offsetParentIsScaled = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent) && $c0400ebb908e52cb$var$isElementScaled(offsetParent);
        var documentElement = (0, (0, parcelRequire("eVELE")).default)(offsetParent);
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
        var scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        var offsets = {
            x: 0,
            y: 0
        };
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) !== 'body' || (0, (0, parcelRequire("c6EdA")).default)(documentElement)) scroll = (0, (0, parcelRequire("9FFjG")).default)(offsetParent);
            if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent)) {
                offsets = (0, (0, parcelRequire("g2O7Z")).default)(offsetParent, true);
                offsets.x += offsetParent.clientLeft;
                offsets.y += offsetParent.clientTop;
            } else if (documentElement) offsets.x = (0, (0, parcelRequire("imzt5")).default)(documentElement);
        }
        return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height
        };
    }
});
parcelRegister("g2O7Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bae3b796a534b2cf$export$2e2bcd8739ae039);
    var $gmkfg;
    var $90xPK;
    var $1Prpe;
    var $d8bsQ;
    function $bae3b796a534b2cf$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        var clientRect = element.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (includeScale && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            scaleX = element.offsetWidth > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.width) / element.offsetWidth || 1 : 1;
            scaleY = element.offsetHeight > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.height) / element.offsetHeight || 1 : 1;
        }
        var _ref = (0, (0, parcelRequire("gmkfg")).isElement)(element) ? (0, (0, parcelRequire("1Prpe")).default)(element) : window, visualViewport = _ref.visualViewport;
        var addVisualOffsets = !(0, (0, parcelRequire("d8bsQ")).default)() && isFixedStrategy;
        var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
        var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
        var width = clientRect.width / scaleX;
        var height = clientRect.height / scaleY;
        return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y
        };
    }
});
parcelRegister("gmkfg", function(module, exports) {
    $parcel$export(module.exports, "isElement", ()=>$be8e67adfa808002$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$be8e67adfa808002$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isShadowRoot", ()=>$be8e67adfa808002$export$af51f0f06c0f328a);
    var $1Prpe;
    function $be8e67adfa808002$export$45a5e7f76e0caa8d(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).Element;
        return node instanceof OwnElement || node instanceof Element;
    }
    function $be8e67adfa808002$export$1b3bfaa9684536aa(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).HTMLElement;
        return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function $be8e67adfa808002$export$af51f0f06c0f328a(node) {
        if (typeof ShadowRoot === 'undefined') return false;
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).ShadowRoot;
        return node instanceof OwnElement || node instanceof ShadowRoot;
    }
});
parcelRegister("1Prpe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$154fd01b154b825f$export$2e2bcd8739ae039);
    function $154fd01b154b825f$export$2e2bcd8739ae039(node) {
        if (node == null) return window;
        if (node.toString() !== '[object Window]') {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
        }
        return node;
    }
});
parcelRegister("90xPK", function(module, exports) {
    $parcel$export(module.exports, "max", ()=>$68ee5bce69e9df7e$export$8960430cfd85939f);
    $parcel$export(module.exports, "min", ()=>$68ee5bce69e9df7e$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "round", ()=>$68ee5bce69e9df7e$export$2077e0241d6afd3c);
    var $68ee5bce69e9df7e$export$8960430cfd85939f = Math.max;
    var $68ee5bce69e9df7e$export$96ec731ed4dcb222 = Math.min;
    var $68ee5bce69e9df7e$export$2077e0241d6afd3c = Math.round;
});
parcelRegister("d8bsQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98f4ea48bb7f7060$export$2e2bcd8739ae039);
    var $j5Xhq;
    function $98f4ea48bb7f7060$export$2e2bcd8739ae039() {
        return !/^((?!chrome|android).)*safari/i.test((0, (0, parcelRequire("j5Xhq")).default)());
    }
});
parcelRegister("j5Xhq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de6c77c242bcf4cf$export$2e2bcd8739ae039);
    function $de6c77c242bcf4cf$export$2e2bcd8739ae039() {
        var uaData = navigator.userAgentData;
        if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
            return item.brand + "/" + item.version;
        }).join(' ');
        return navigator.userAgent;
    }
});
parcelRegister("9FFjG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70a7fdf85bb2e8b8$export$2e2bcd8739ae039);
    var $8YTLN;
    var $1Prpe;
    var $gmkfg;
    var $i1ad3;
    function $70a7fdf85bb2e8b8$export$2e2bcd8739ae039(node) {
        if (node === (0, (0, parcelRequire("1Prpe")).default)(node) || !(0, (0, parcelRequire("gmkfg")).isHTMLElement)(node)) return (0, (0, parcelRequire("8YTLN")).default)(node);
        else return (0, (0, parcelRequire("i1ad3")).default)(node);
    }
});
parcelRegister("8YTLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$689f300ec0defb42$export$2e2bcd8739ae039);
    var $1Prpe;
    function $689f300ec0defb42$export$2e2bcd8739ae039(node) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(node);
        var scrollLeft = win.pageXOffset;
        var scrollTop = win.pageYOffset;
        return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        };
    }
});
parcelRegister("i1ad3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1e03d69dfb9832f$export$2e2bcd8739ae039);
    function $d1e03d69dfb9832f$export$2e2bcd8739ae039(element) {
        return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
    }
});
parcelRegister("f5IBt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afc9ebf0aa1487e4$export$2e2bcd8739ae039);
    function $afc9ebf0aa1487e4$export$2e2bcd8739ae039(element) {
        return element ? (element.nodeName || '').toLowerCase() : null;
    }
});
parcelRegister("imzt5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5e5cb506db8cdcb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $eVELE;
    var $8YTLN;
    function $d5e5cb506db8cdcb$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("g2O7Z")).default)((0, (0, parcelRequire("eVELE")).default)(element)).left + (0, (0, parcelRequire("8YTLN")).default)(element).scrollLeft;
    }
});
parcelRegister("eVELE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ade6032ba4b824fe$export$2e2bcd8739ae039);
    var $gmkfg;
    function $ade6032ba4b824fe$export$2e2bcd8739ae039(element) {
        return (((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
    }
});
parcelRegister("c6EdA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d053e13cecc73ee$export$2e2bcd8739ae039);
    var $1ix2F;
    function $8d053e13cecc73ee$export$2e2bcd8739ae039(element) {
        var _getComputedStyle = (0, (0, parcelRequire("1ix2F")).default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
});
parcelRegister("1ix2F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f211a5db2cb1d1b$export$2e2bcd8739ae039);
    var $1Prpe;
    function $0f211a5db2cb1d1b$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("1Prpe")).default)(element).getComputedStyle(element);
    }
});
parcelRegister("jkGDj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e130f49f6e9ebcb4$export$2e2bcd8739ae039);
    var $g2O7Z;
    function $e130f49f6e9ebcb4$export$2e2bcd8739ae039(element) {
        var clientRect = (0, (0, parcelRequire("g2O7Z")).default)(element);
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
        if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
        return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height
        };
    }
});
parcelRegister("2r6BH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c633a6ac170841a$export$2e2bcd8739ae039);
    var $k82dT;
    var $eTUzl;
    var $1Prpe;
    var $c6EdA;
    function $1c633a6ac170841a$export$2e2bcd8739ae039(element, list) {
        var _element$ownerDocumen;
        if (list === void 0) list = [];
        var scrollParent = (0, (0, parcelRequire("k82dT")).default)(element);
        var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
        var win = (0, (0, parcelRequire("1Prpe")).default)(scrollParent);
        var target = isBody ? [
            win
        ].concat(win.visualViewport || [], (0, (0, parcelRequire("c6EdA")).default)(scrollParent) ? scrollParent : []) : scrollParent;
        var updatedList = list.concat(target);
        return isBody ? updatedList : updatedList.concat($1c633a6ac170841a$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(target)));
    }
});
parcelRegister("k82dT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea7647704a508683$export$2e2bcd8739ae039);
    var $eTUzl;
    var $c6EdA;
    var $f5IBt;
    var $gmkfg;
    function $ea7647704a508683$export$2e2bcd8739ae039(node) {
        if ([
            'html',
            'body',
            '#document'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(node)) >= 0) return node.ownerDocument.body;
        if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(node) && (0, (0, parcelRequire("c6EdA")).default)(node)) return node;
        return $ea7647704a508683$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(node));
    }
});
parcelRegister("eTUzl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad921528f26834dd$export$2e2bcd8739ae039);
    var $f5IBt;
    var $eVELE;
    var $gmkfg;
    function $ad921528f26834dd$export$2e2bcd8739ae039(element) {
        if ((0, (0, parcelRequire("f5IBt")).default)(element) === 'html') return element;
        return (element.assignedSlot || element.parentNode || ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(element) ? element.host : null) || (0, (0, parcelRequire("eVELE")).default)(element));
    }
});
parcelRegister("gbHJy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc8f9908a1e4106f$export$2e2bcd8739ae039);
    var $1Prpe;
    var $f5IBt;
    var $1ix2F;
    var $gmkfg;
    var $6hs9X;
    var $eTUzl;
    var $j5Xhq;
    function $bc8f9908a1e4106f$var$getTrueOffsetParent(element) {
        if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || (0, (0, parcelRequire("1ix2F")).default)(element).position === 'fixed') return null;
        return element.offsetParent;
    }
    function $bc8f9908a1e4106f$var$getContainingBlock(element) {
        var isFirefox = /firefox/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        var isIE = /Trident/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        if (isIE && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            var elementCss = (0, (0, parcelRequire("1ix2F")).default)(element);
            if (elementCss.position === 'fixed') return null;
        }
        var currentNode = (0, (0, parcelRequire("eTUzl")).default)(element);
        if ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(currentNode)) currentNode = currentNode.host;
        while((0, (0, parcelRequire("gmkfg")).isHTMLElement)(currentNode) && [
            'html',
            'body'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(currentNode)) < 0){
            var css = (0, (0, parcelRequire("1ix2F")).default)(currentNode);
            if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
                'transform',
                'perspective'
            ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
            else currentNode = currentNode.parentNode;
        }
        return null;
    }
    function $bc8f9908a1e4106f$export$2e2bcd8739ae039(element) {
        var window = (0, (0, parcelRequire("1Prpe")).default)(element);
        var offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(element);
        while(offsetParent && (0, (0, parcelRequire("6hs9X")).default)(offsetParent) && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(offsetParent);
        if (offsetParent && ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'html' || (0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'body' && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')) return window;
        return offsetParent || $bc8f9908a1e4106f$var$getContainingBlock(element) || window;
    }
});
parcelRegister("6hs9X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$492a2c861940c94d$export$2e2bcd8739ae039);
    var $f5IBt;
    function $492a2c861940c94d$export$2e2bcd8739ae039(element) {
        return [
            'table',
            'td',
            'th'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(element)) >= 0;
    }
});
parcelRegister("kcmIg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb468bf0752088cc$export$2e2bcd8739ae039);
    var $kJPed;
    function $eb468bf0752088cc$var$order(modifiers) {
        var map = new Map();
        var visited = new Set();
        var result = [];
        modifiers.forEach(function(modifier) {
            map.set(modifier.name, modifier);
        });
        function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
            requires.forEach(function(dep) {
                if (!visited.has(dep)) {
                    var depModifier = map.get(dep);
                    if (depModifier) sort(depModifier);
                }
            });
            result.push(modifier);
        }
        modifiers.forEach(function(modifier) {
            if (!visited.has(modifier.name)) sort(modifier);
        });
        return result;
    }
    function $eb468bf0752088cc$export$2e2bcd8739ae039(modifiers) {
        var orderedModifiers = $eb468bf0752088cc$var$order(modifiers);
        return (0, (0, parcelRequire("kJPed")).modifierPhases).reduce(function(acc, phase) {
            return acc.concat(orderedModifiers.filter(function(modifier) {
                return modifier.phase === phase;
            }));
        }, []);
    }
});
parcelRegister("kJPed", function(module, exports) {
    $parcel$export(module.exports, "top", ()=>$f18fbf7b212a7c8e$export$1e95b668f3b82d);
    $parcel$export(module.exports, "bottom", ()=>$f18fbf7b212a7c8e$export$40e543e69a8b3fbb);
    $parcel$export(module.exports, "right", ()=>$f18fbf7b212a7c8e$export$79ffe56a765070d2);
    $parcel$export(module.exports, "left", ()=>$f18fbf7b212a7c8e$export$eabcd2c8791e7bf4);
    $parcel$export(module.exports, "auto", ()=>$f18fbf7b212a7c8e$export$dfb5619354ba860);
    $parcel$export(module.exports, "basePlacements", ()=>$f18fbf7b212a7c8e$export$aec2ce47c367b8c3);
    $parcel$export(module.exports, "start", ()=>$f18fbf7b212a7c8e$export$b3571188c770cc5a);
    $parcel$export(module.exports, "end", ()=>$f18fbf7b212a7c8e$export$bd5df0f255a350f8);
    $parcel$export(module.exports, "clippingParents", ()=>$f18fbf7b212a7c8e$export$390fd549c5303b4d);
    $parcel$export(module.exports, "viewport", ()=>$f18fbf7b212a7c8e$export$d7b7311ec04a3e8f);
    $parcel$export(module.exports, "popper", ()=>$f18fbf7b212a7c8e$export$ae5ab1c730825774);
    $parcel$export(module.exports, "reference", ()=>$f18fbf7b212a7c8e$export$ca50aac9f3ba507f);
    $parcel$export(module.exports, "variationPlacements", ()=>$f18fbf7b212a7c8e$export$368f9a87e87fa4e1);
    $parcel$export(module.exports, "placements", ()=>$f18fbf7b212a7c8e$export$803cd8101b6c182b);
    $parcel$export(module.exports, "modifierPhases", ()=>$f18fbf7b212a7c8e$export$d087d3878fdf71d5);
    var $f18fbf7b212a7c8e$export$1e95b668f3b82d = 'top';
    var $f18fbf7b212a7c8e$export$40e543e69a8b3fbb = 'bottom';
    var $f18fbf7b212a7c8e$export$79ffe56a765070d2 = 'right';
    var $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4 = 'left';
    var $f18fbf7b212a7c8e$export$dfb5619354ba860 = 'auto';
    var $f18fbf7b212a7c8e$export$aec2ce47c367b8c3 = [
        $f18fbf7b212a7c8e$export$1e95b668f3b82d,
        $f18fbf7b212a7c8e$export$40e543e69a8b3fbb,
        $f18fbf7b212a7c8e$export$79ffe56a765070d2,
        $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4
    ];
    var $f18fbf7b212a7c8e$export$b3571188c770cc5a = 'start';
    var $f18fbf7b212a7c8e$export$bd5df0f255a350f8 = 'end';
    var $f18fbf7b212a7c8e$export$390fd549c5303b4d = 'clippingParents';
    var $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f = 'viewport';
    var $f18fbf7b212a7c8e$export$ae5ab1c730825774 = 'popper';
    var $f18fbf7b212a7c8e$export$ca50aac9f3ba507f = 'reference';
    var $f18fbf7b212a7c8e$export$368f9a87e87fa4e1 = $f18fbf7b212a7c8e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
        return acc.concat([
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$803cd8101b6c182b = [].concat($f18fbf7b212a7c8e$export$aec2ce47c367b8c3, [
        $f18fbf7b212a7c8e$export$dfb5619354ba860
    ]).reduce(function(acc, placement) {
        return acc.concat([
            placement,
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$421679a7c3d56e = 'beforeRead';
    var $f18fbf7b212a7c8e$export$aafa59e2e03f2942 = 'read';
    var $f18fbf7b212a7c8e$export$6964f6c886723980 = 'afterRead';
    var $f18fbf7b212a7c8e$export$c65e99957a05207c = 'beforeMain';
    var $f18fbf7b212a7c8e$export$f22da7240b7add18 = 'main';
    var $f18fbf7b212a7c8e$export$bab79516f2d662fe = 'afterMain';
    var $f18fbf7b212a7c8e$export$8d4d2d70e7d46032 = 'beforeWrite';
    var $f18fbf7b212a7c8e$export$68d8715fc104d294 = 'write';
    var $f18fbf7b212a7c8e$export$70a6e5159acce2e6 = 'afterWrite';
    var $f18fbf7b212a7c8e$export$d087d3878fdf71d5 = [
        $f18fbf7b212a7c8e$export$421679a7c3d56e,
        $f18fbf7b212a7c8e$export$aafa59e2e03f2942,
        $f18fbf7b212a7c8e$export$6964f6c886723980,
        $f18fbf7b212a7c8e$export$c65e99957a05207c,
        $f18fbf7b212a7c8e$export$f22da7240b7add18,
        $f18fbf7b212a7c8e$export$bab79516f2d662fe,
        $f18fbf7b212a7c8e$export$8d4d2d70e7d46032,
        $f18fbf7b212a7c8e$export$68d8715fc104d294,
        $f18fbf7b212a7c8e$export$70a6e5159acce2e6
    ];
});
parcelRegister("a8clb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7604395822cc5d61$export$2e2bcd8739ae039);
    function $7604395822cc5d61$export$2e2bcd8739ae039(fn) {
        var pending;
        return function() {
            if (!pending) pending = new Promise(function(resolve) {
                Promise.resolve().then(function() {
                    pending = undefined;
                    resolve(fn());
                });
            });
            return pending;
        };
    }
});
parcelRegister("i9xH7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3733441fcf2e882$export$2e2bcd8739ae039);
    function $d3733441fcf2e882$export$2e2bcd8739ae039(modifiers) {
        var merged = modifiers.reduce(function(merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing ? Object.assign({}, existing, current, {
                options: Object.assign({}, existing.options, current.options),
                data: Object.assign({}, existing.data, current.data)
            }) : current;
            return merged;
        }, {});
        return Object.keys(merged).map(function(key) {
            return merged[key];
        });
    }
});
parcelRegister("4TVC8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3918fd6b815bcf57$export$2e2bcd8739ae039);
    var $1Prpe;
    var $3918fd6b815bcf57$var$passive = {
        passive: true
    };
    function $3918fd6b815bcf57$var$effect(_ref) {
        var state = _ref.state, instance = _ref.instance, options = _ref.options;
        var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
        var window = (0, (0, parcelRequire("1Prpe")).default)(state.elements.popper);
        var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.addEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
        });
        if (resize) window.addEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        return function() {
            if (scroll) scrollParents.forEach(function(scrollParent) {
                scrollParent.removeEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
            });
            if (resize) window.removeEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        };
    }
    var $3918fd6b815bcf57$export$2e2bcd8739ae039 = {
        name: 'eventListeners',
        enabled: true,
        phase: 'write',
        fn: function fn() {},
        effect: $3918fd6b815bcf57$var$effect,
        data: {}
    };
});
parcelRegister("j8nKB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dee1300a39219bb5$export$2e2bcd8739ae039);
    var $dJ0Jl;
    function $dee1300a39219bb5$var$popperOffsets(_ref) {
        var state = _ref.state, name = _ref.name;
        state.modifiersData[name] = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: state.rects.reference,
            element: state.rects.popper,
            strategy: 'absolute',
            placement: state.placement
        });
    }
    var $dee1300a39219bb5$export$2e2bcd8739ae039 = {
        name: 'popperOffsets',
        enabled: true,
        phase: 'read',
        fn: $dee1300a39219bb5$var$popperOffsets,
        data: {}
    };
});
parcelRegister("dJ0Jl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fe00b5c334118ac$export$2e2bcd8739ae039);
    var $QXpw1;
    var $cGRJ4;
    var $9GF9F;
    var $kJPed;
    function $9fe00b5c334118ac$export$2e2bcd8739ae039(_ref) {
        var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
        var basePlacement = placement ? (0, (0, parcelRequire("QXpw1")).default)(placement) : null;
        var variation = placement ? (0, (0, parcelRequire("cGRJ4")).default)(placement) : null;
        var commonX = reference.x + reference.width / 2 - element.width / 2;
        var commonY = reference.y + reference.height / 2 - element.height / 2;
        var offsets;
        switch(basePlacement){
            case 0, (0, parcelRequire("kJPed")).top:
                offsets = {
                    x: commonX,
                    y: reference.y - element.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).bottom:
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).right:
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 0, (0, parcelRequire("kJPed")).left:
                offsets = {
                    x: reference.x - element.width,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        var mainAxis = basePlacement ? (0, (0, parcelRequire("9GF9F")).default)(basePlacement) : null;
        if (mainAxis != null) {
            var len = mainAxis === 'y' ? 'height' : 'width';
            switch(variation){
                case 0, (0, parcelRequire("kJPed")).start:
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                    break;
                case 0, (0, parcelRequire("kJPed")).end:
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                    break;
                default:
            }
        }
        return offsets;
    }
});
parcelRegister("QXpw1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09f2f123ac4a9fdf$export$2e2bcd8739ae039);
    function $09f2f123ac4a9fdf$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[0];
    }
});
parcelRegister("cGRJ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93d315208040ceed$export$2e2bcd8739ae039);
    function $93d315208040ceed$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[1];
    }
});
parcelRegister("9GF9F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70d7f5cda4210aa3$export$2e2bcd8739ae039);
    function $70d7f5cda4210aa3$export$2e2bcd8739ae039(placement) {
        return [
            'top',
            'bottom'
        ].indexOf(placement) >= 0 ? 'x' : 'y';
    }
});
parcelRegister("baic6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$820ebddbe0682e4f$export$2e2bcd8739ae039);
    var $kJPed;
    var $gbHJy;
    var $1Prpe;
    var $eVELE;
    var $1ix2F;
    var $QXpw1;
    var $cGRJ4;
    var $90xPK;
    var $820ebddbe0682e4f$var$unsetSides = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
    };
    function $820ebddbe0682e4f$var$roundOffsetsByDPR(_ref, win) {
        var x = _ref.x, y = _ref.y;
        var dpr = win.devicePixelRatio || 1;
        return {
            x: (0, (0, parcelRequire("90xPK")).round)(x * dpr) / dpr || 0,
            y: (0, (0, parcelRequire("90xPK")).round)(y * dpr) / dpr || 0
        };
    }
    function $820ebddbe0682e4f$export$378fa78a8fea596f(_ref2) {
        var _Object$assign2;
        var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
        var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
        var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
            x: x,
            y: y
        }) : {
            x: x,
            y: y
        };
        x = _ref3.x;
        y = _ref3.y;
        var hasX = offsets.hasOwnProperty('x');
        var hasY = offsets.hasOwnProperty('y');
        var sideX = (0, (0, parcelRequire("kJPed")).left);
        var sideY = (0, (0, parcelRequire("kJPed")).top);
        var win = window;
        if (adaptive) {
            var offsetParent = (0, (0, parcelRequire("gbHJy")).default)(popper);
            var heightProp = 'clientHeight';
            var widthProp = 'clientWidth';
            if (offsetParent === (0, (0, parcelRequire("1Prpe")).default)(popper)) {
                offsetParent = (0, (0, parcelRequire("eVELE")).default)(popper);
                if ((0, (0, parcelRequire("1ix2F")).default)(offsetParent).position !== 'static' && position === 'absolute') {
                    heightProp = 'scrollHeight';
                    widthProp = 'scrollWidth';
                }
            }
            offsetParent;
            if (placement === (0, (0, parcelRequire("kJPed")).top) || (placement === (0, (0, parcelRequire("kJPed")).left) || placement === (0, (0, parcelRequire("kJPed")).right)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideY = (0, (0, parcelRequire("kJPed")).bottom);
                var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
                y -= offsetY - popperRect.height;
                y *= gpuAcceleration ? 1 : -1;
            }
            if (placement === (0, (0, parcelRequire("kJPed")).left) || (placement === (0, (0, parcelRequire("kJPed")).top) || placement === (0, (0, parcelRequire("kJPed")).bottom)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideX = (0, (0, parcelRequire("kJPed")).right);
                var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
                x -= offsetX - popperRect.width;
                x *= gpuAcceleration ? 1 : -1;
            }
        }
        var commonStyles = Object.assign({
            position: position
        }, adaptive && $820ebddbe0682e4f$var$unsetSides);
        var _ref4 = roundOffsets === true ? $820ebddbe0682e4f$var$roundOffsetsByDPR({
            x: x,
            y: y
        }, (0, (0, parcelRequire("1Prpe")).default)(popper)) : {
            x: x,
            y: y
        };
        x = _ref4.x;
        y = _ref4.y;
        if (gpuAcceleration) {
            var _Object$assign;
            return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
        }
        return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function $820ebddbe0682e4f$var$computeStyles(_ref5) {
        var state = _ref5.state, options = _ref5.options;
        var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
        var commonStyles = {
            placement: (0, (0, parcelRequire("QXpw1")).default)(state.placement),
            variation: (0, (0, parcelRequire("cGRJ4")).default)(state.placement),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === 'fixed'
        };
        if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.popperOffsets,
            position: state.options.strategy,
            adaptive: adaptive,
            roundOffsets: roundOffsets
        })));
        if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.arrow,
            position: 'absolute',
            adaptive: false,
            roundOffsets: roundOffsets
        })));
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-placement': state.placement
        });
    }
    var $820ebddbe0682e4f$export$2e2bcd8739ae039 = {
        name: 'computeStyles',
        enabled: true,
        phase: 'beforeWrite',
        fn: $820ebddbe0682e4f$var$computeStyles,
        data: {}
    };
});
parcelRegister("1AoLg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$127c5c56b9511f5f$export$2e2bcd8739ae039);
    var $f5IBt;
    var $gmkfg;
    function $127c5c56b9511f5f$var$applyStyles(_ref) {
        var state = _ref.state;
        Object.keys(state.elements).forEach(function(name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name];
            if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(name) {
                var value = attributes[name];
                if (value === false) element.removeAttribute(name);
                else element.setAttribute(name, value === true ? '' : value);
            });
        });
    }
    function $127c5c56b9511f5f$var$effect(_ref2) {
        var state = _ref2.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
        return function() {
            Object.keys(state.elements).forEach(function(name) {
                var element = state.elements[name];
                var attributes = state.attributes[name] || {};
                var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
                var style = styleProperties.reduce(function(style, property) {
                    style[property] = '';
                    return style;
                }, {});
                if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
                Object.assign(element.style, style);
                Object.keys(attributes).forEach(function(attribute) {
                    element.removeAttribute(attribute);
                });
            });
        };
    }
    var $127c5c56b9511f5f$export$2e2bcd8739ae039 = {
        name: 'applyStyles',
        enabled: true,
        phase: 'write',
        fn: $127c5c56b9511f5f$var$applyStyles,
        effect: $127c5c56b9511f5f$var$effect,
        requires: [
            'computeStyles'
        ]
    };
});
parcelRegister("gy4Xr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0c3aad300d72ee1$export$2e2bcd8739ae039);
    var $QXpw1;
    var $kJPed;
    function $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, rects, offset) {
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
        var invertDistance = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).top)
        ].indexOf(basePlacement) >= 0 ? -1 : 1;
        var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
            placement: placement
        })) : offset, skidding = _ref[0], distance = _ref[1];
        skidding = skidding || 0;
        distance = (distance || 0) * invertDistance;
        return [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0 ? {
            x: distance,
            y: skidding
        } : {
            x: skidding,
            y: distance
        };
    }
    function $c0c3aad300d72ee1$var$offset(_ref2) {
        var state = _ref2.state, options = _ref2.options, name = _ref2.name;
        var _options$offset = options.offset, offset = _options$offset === void 0 ? [
            0,
            0
        ] : _options$offset;
        var data = (0, (0, parcelRequire("kJPed")).placements).reduce(function(acc, placement) {
            acc[placement] = $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, state.rects, offset);
            return acc;
        }, {});
        var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
        if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
        }
        state.modifiersData[name] = data;
    }
    var $c0c3aad300d72ee1$export$2e2bcd8739ae039 = {
        name: 'offset',
        enabled: true,
        phase: 'main',
        requires: [
            'popperOffsets'
        ],
        fn: $c0c3aad300d72ee1$var$offset
    };
});
parcelRegister("3dDWl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$258191447a7022df$export$2e2bcd8739ae039);
    var $jwSgb;
    var $QXpw1;
    var $4tIVJ;
    var $kgkit;
    var $cqF2x;
    var $kJPed;
    var $cGRJ4;
    function $258191447a7022df$var$getExpandedFallbackPlacements(placement) {
        if ((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto)) return [];
        var oppositePlacement = (0, (0, parcelRequire("jwSgb")).default)(placement);
        return [
            (0, (0, parcelRequire("4tIVJ")).default)(placement),
            oppositePlacement,
            (0, (0, parcelRequire("4tIVJ")).default)(oppositePlacement)
        ];
    }
    function $258191447a7022df$var$flip(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        if (state.modifiersData[name]._skip) return;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
        var preferredPlacement = state.options.placement;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(preferredPlacement);
        var isBasePlacement = basePlacement === preferredPlacement;
        var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            (0, (0, parcelRequire("jwSgb")).default)(preferredPlacement)
        ] : $258191447a7022df$var$getExpandedFallbackPlacements(preferredPlacement));
        var placements = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement) {
            return acc.concat((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto) ? (0, (0, parcelRequire("cqF2x")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements
            }) : placement);
        }, []);
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var checksMap = new Map();
        var makeFallbackChecks = true;
        var firstFittingPlacement = placements[0];
        for(var i = 0; i < placements.length; i++){
            var placement = placements[i];
            var _basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
            var isStartVariation = (0, (0, parcelRequire("cGRJ4")).default)(placement) === (0, (0, parcelRequire("kJPed")).start);
            var isVertical = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).bottom)
            ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? 'width' : 'height';
            var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding
            });
            var mainVariationSide = isVertical ? isStartVariation ? (0, (0, parcelRequire("kJPed")).right) : (0, (0, parcelRequire("kJPed")).left) : isStartVariation ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).top);
            if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var altVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var checks = [];
            if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
            if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
            if (checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement;
                makeFallbackChecks = false;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) {
            var numberOfChecks = flipVariations ? 3 : 1;
            var _loop = function _loop(_i) {
                var fittingPlacement = placements.find(function(placement) {
                    var checks = checksMap.get(placement);
                    if (checks) return checks.slice(0, _i).every(function(check) {
                        return check;
                    });
                });
                if (fittingPlacement) {
                    firstFittingPlacement = fittingPlacement;
                    return "break";
                }
            };
            for(var _i = numberOfChecks; _i > 0; _i--){
                var _ret = _loop(_i);
                if (_ret === "break") break;
            }
        }
        if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
        }
    }
    var $258191447a7022df$export$2e2bcd8739ae039 = {
        name: 'flip',
        enabled: true,
        phase: 'main',
        fn: $258191447a7022df$var$flip,
        requiresIfExists: [
            'offset'
        ],
        data: {
            _skip: false
        }
    };
});
parcelRegister("jwSgb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e37b1862c86f39c4$export$2e2bcd8739ae039);
    var $e37b1862c86f39c4$var$hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    function $e37b1862c86f39c4$export$2e2bcd8739ae039(placement) {
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return $e37b1862c86f39c4$var$hash[matched];
        });
    }
});
parcelRegister("4tIVJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$342cb90cb2622617$export$2e2bcd8739ae039);
    var $342cb90cb2622617$var$hash = {
        start: 'end',
        end: 'start'
    };
    function $342cb90cb2622617$export$2e2bcd8739ae039(placement) {
        return placement.replace(/start|end/g, function(matched) {
            return $342cb90cb2622617$var$hash[matched];
        });
    }
});
parcelRegister("kgkit", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec050bcf5e349283$export$2e2bcd8739ae039);
    var $dknpr;
    var $eVELE;
    var $g2O7Z;
    var $dJ0Jl;
    var $h8W1z;
    var $kJPed;
    var $gmkfg;
    var $gIXWB;
    var $50KfK;
    function $ec050bcf5e349283$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, (0, parcelRequire("kJPed")).clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, (0, parcelRequire("kJPed")).viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, (0, parcelRequire("kJPed")).popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
        var paddingObject = (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
        var altContext = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? (0, (0, parcelRequire("kJPed")).reference) : (0, (0, parcelRequire("kJPed")).popper);
        var popperRect = state.rects.popper;
        var element = state.elements[altBoundary ? altContext : elementContext];
        var clippingClientRect = (0, (0, parcelRequire("dknpr")).default)((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element : element.contextElement || (0, (0, parcelRequire("eVELE")).default)(state.elements.popper), boundary, rootBoundary, strategy);
        var referenceClientRect = (0, (0, parcelRequire("g2O7Z")).default)(state.elements.reference);
        var popperOffsets = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: referenceClientRect,
            element: popperRect,
            strategy: 'absolute',
            placement: placement
        });
        var popperClientRect = (0, (0, parcelRequire("h8W1z")).default)(Object.assign({}, popperRect, popperOffsets));
        var elementClientRect = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? popperClientRect : referenceClientRect;
        var overflowOffsets = {
            top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
            bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
            left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
            right: elementClientRect.right - clippingClientRect.right + paddingObject.right
        };
        var offsetData = state.modifiersData.offset;
        if (elementContext === (0, (0, parcelRequire("kJPed")).popper) && offsetData) {
            var offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function(key) {
                var multiply = [
                    (0, (0, parcelRequire("kJPed")).right),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 1 : -1;
                var axis = [
                    (0, (0, parcelRequire("kJPed")).top),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 'y' : 'x';
                overflowOffsets[key] += offset[axis] * multiply;
            });
        }
        return overflowOffsets;
    }
});
parcelRegister("dknpr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b3f4d3932acb3b2$export$2e2bcd8739ae039);
    var $kJPed;
    var $3V2hG;
    var $9NXD7;
    var $2r6BH;
    var $gbHJy;
    var $eVELE;
    var $1ix2F;
    var $gmkfg;
    var $g2O7Z;
    var $eTUzl;
    var $j6yPg;
    var $f5IBt;
    var $h8W1z;
    var $90xPK;
    function $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(element, strategy) {
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(element, false, strategy === 'fixed');
        rect.top = rect.top + element.clientTop;
        rect.left = rect.left + element.clientLeft;
        rect.bottom = rect.top + element.clientHeight;
        rect.right = rect.left + element.clientWidth;
        rect.width = element.clientWidth;
        rect.height = element.clientHeight;
        rect.x = rect.left;
        rect.y = rect.top;
        return rect;
    }
    function $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
        return clippingParent === (0, (0, parcelRequire("kJPed")).viewport) ? (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("3V2hG")).default)(element, strategy)) : (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) ? $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("9NXD7")).default)((0, (0, parcelRequire("eVELE")).default)(element)));
    }
    function $9b3f4d3932acb3b2$var$getClippingParents(element) {
        var clippingParents = (0, (0, parcelRequire("2r6BH")).default)((0, (0, parcelRequire("eTUzl")).default)(element));
        var canEscapeClipping = [
            'absolute',
            'fixed'
        ].indexOf((0, (0, parcelRequire("1ix2F")).default)(element).position) >= 0;
        var clipperElement = canEscapeClipping && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) ? (0, (0, parcelRequire("gbHJy")).default)(element) : element;
        if (!(0, (0, parcelRequire("gmkfg")).isElement)(clipperElement)) return [];
        return clippingParents.filter(function(clippingParent) {
            return (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) && (0, (0, parcelRequire("j6yPg")).default)(clippingParent, clipperElement) && (0, (0, parcelRequire("f5IBt")).default)(clippingParent) !== 'body';
        });
    }
    function $9b3f4d3932acb3b2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
        var mainClippingParents = boundary === 'clippingParents' ? $9b3f4d3932acb3b2$var$getClippingParents(element) : [].concat(boundary);
        var clippingParents = [].concat(mainClippingParents, [
            rootBoundary
        ]);
        var firstClippingParent = clippingParents[0];
        var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
            var rect = $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy);
            accRect.top = (0, (0, parcelRequire("90xPK")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("90xPK")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("90xPK")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("90xPK")).max)(rect.left, accRect.left);
            return accRect;
        }, $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
        clippingRect.width = clippingRect.right - clippingRect.left;
        clippingRect.height = clippingRect.bottom - clippingRect.top;
        clippingRect.x = clippingRect.left;
        clippingRect.y = clippingRect.top;
        return clippingRect;
    }
});
parcelRegister("3V2hG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2da877912142c34b$export$2e2bcd8739ae039);
    var $1Prpe;
    var $eVELE;
    var $imzt5;
    var $d8bsQ;
    function $2da877912142c34b$export$2e2bcd8739ae039(element, strategy) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(element);
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var visualViewport = win.visualViewport;
        var width = html.clientWidth;
        var height = html.clientHeight;
        var x = 0;
        var y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = (0, (0, parcelRequire("d8bsQ")).default)();
            if (layoutViewport || !layoutViewport && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x + (0, (0, parcelRequire("imzt5")).default)(element),
            y: y
        };
    }
});
parcelRegister("9NXD7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7236f1f1532b7fe8$export$2e2bcd8739ae039);
    var $eVELE;
    var $1ix2F;
    var $imzt5;
    var $8YTLN;
    var $90xPK;
    function $7236f1f1532b7fe8$export$2e2bcd8739ae039(element) {
        var _element$ownerDocumen;
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var winScroll = (0, (0, parcelRequire("8YTLN")).default)(element);
        var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
        var width = (0, (0, parcelRequire("90xPK")).max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
        var height = (0, (0, parcelRequire("90xPK")).max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
        var x = -winScroll.scrollLeft + (0, (0, parcelRequire("imzt5")).default)(element);
        var y = -winScroll.scrollTop;
        if ((0, (0, parcelRequire("1ix2F")).default)(body || html).direction === 'rtl') x += (0, (0, parcelRequire("90xPK")).max)(html.clientWidth, body ? body.clientWidth : 0) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
});
parcelRegister("j6yPg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de89978be23479c4$export$2e2bcd8739ae039);
    var $gmkfg;
    function $de89978be23479c4$export$2e2bcd8739ae039(parent, child) {
        var rootNode = child.getRootNode && child.getRootNode();
        if (parent.contains(child)) return true;
        else if (rootNode && (0, (0, parcelRequire("gmkfg")).isShadowRoot)(rootNode)) {
            var next = child;
            do {
                if (next && parent.isSameNode(next)) return true;
                next = next.parentNode || next.host;
            }while (next)
        }
        return false;
    }
});
parcelRegister("h8W1z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7b0316bb2f8fd97$export$2e2bcd8739ae039);
    function $c7b0316bb2f8fd97$export$2e2bcd8739ae039(rect) {
        return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height
        });
    }
});
parcelRegister("gIXWB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2cf410c4fe133f4$export$2e2bcd8739ae039);
    var $1ANH0;
    function $c2cf410c4fe133f4$export$2e2bcd8739ae039(paddingObject) {
        return Object.assign({}, (0, (0, parcelRequire("1ANH0")).default)(), paddingObject);
    }
});
parcelRegister("1ANH0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$128fb32b18b92ffa$export$2e2bcd8739ae039);
    function $128fb32b18b92ffa$export$2e2bcd8739ae039() {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
    }
});
parcelRegister("50KfK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a60d4b4ac4f93e5$export$2e2bcd8739ae039);
    function $3a60d4b4ac4f93e5$export$2e2bcd8739ae039(value, keys) {
        return keys.reduce(function(hashMap, key) {
            hashMap[key] = value;
            return hashMap;
        }, {});
    }
});
parcelRegister("cqF2x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90c7bf65fbdbec33$export$2e2bcd8739ae039);
    var $cGRJ4;
    var $kJPed;
    var $kgkit;
    var $QXpw1;
    function $90c7bf65fbdbec33$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, (0, parcelRequire("kJPed")).placements) : _options$allowedAutoP;
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(placement);
        var placements = variation ? flipVariations ? (0, (0, parcelRequire("kJPed")).variationPlacements) : (0, (0, parcelRequire("kJPed")).variationPlacements).filter(function(placement) {
            return (0, (0, parcelRequire("cGRJ4")).default)(placement) === variation;
        }) : (0, (0, parcelRequire("kJPed")).basePlacements);
        var allowedPlacements = placements.filter(function(placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
        });
        if (allowedPlacements.length === 0) allowedPlacements = placements;
        var overflows = allowedPlacements.reduce(function(acc, placement) {
            acc[placement] = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding
            })[(0, (0, parcelRequire("QXpw1")).default)(placement)];
            return acc;
        }, {});
        return Object.keys(overflows).sort(function(a, b) {
            return overflows[a] - overflows[b];
        });
    }
});
parcelRegister("1DdSC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13043339457d5bc5$export$2e2bcd8739ae039);
    var $kJPed;
    var $QXpw1;
    var $9GF9F;
    var $dNtrn;
    var $4WpIh;
    var $jkGDj;
    var $gbHJy;
    var $kgkit;
    var $cGRJ4;
    var $1ANH0;
    var $90xPK;
    function $13043339457d5bc5$var$preventOverflow(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
        var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            altBoundary: altBoundary
        });
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(state.placement);
        var isBasePlacement = !variation;
        var mainAxis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var altAxis = (0, (0, parcelRequire("dNtrn")).default)(mainAxis);
        var popperOffsets = state.modifiersData.popperOffsets;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
            placement: state.placement
        })) : tetherOffset;
        var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue
        } : Object.assign({
            mainAxis: 0,
            altAxis: 0
        }, tetherOffsetValue);
        var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
        var data = {
            x: 0,
            y: 0
        };
        if (!popperOffsets) return;
        if (checkMainAxis) {
            var _offsetModifierState$;
            var mainSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var altSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var len = mainAxis === 'y' ? 'height' : 'width';
            var offset = popperOffsets[mainAxis];
            var min = offset + overflow[mainSide];
            var max = offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen = variation === (0, (0, parcelRequire("kJPed")).start) ? referenceRect[len] : popperRect[len];
            var maxLen = variation === (0, (0, parcelRequire("kJPed")).start) ? -popperRect[len] : -referenceRect[len];
            var arrowElement = state.elements.arrow;
            var arrowRect = tether && arrowElement ? (0, (0, parcelRequire("jkGDj")).default)(arrowElement) : {
                width: 0,
                height: 0
            };
            var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, (0, parcelRequire("1ANH0")).default)();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide];
            var arrowLen = (0, (0, parcelRequire("4WpIh")).within)(0, referenceRect[len], arrowRect[len]);
            var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent = state.elements.arrow && (0, (0, parcelRequire("gbHJy")).default)(state.elements.arrow);
            var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
            var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
            var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = offset + maxOffset - offsetModifierValue;
            var preventedOffset = (0, (0, parcelRequire("4WpIh")).within)(tether ? (0, (0, parcelRequire("90xPK")).min)(min, tetherMin) : min, offset, tether ? (0, (0, parcelRequire("90xPK")).max)(max, tetherMax) : max);
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2;
            var _mainSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var _altSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var _offset = popperOffsets[altAxis];
            var _len = altAxis === 'y' ? 'height' : 'width';
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var isOriginSide = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).left)
            ].indexOf(basePlacement) !== -1;
            var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
            var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
            var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
            var _preventedOffset = tether && isOriginSide ? (0, (0, parcelRequire("4WpIh")).withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, (0, parcelRequire("4WpIh")).within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    }
    var $13043339457d5bc5$export$2e2bcd8739ae039 = {
        name: 'preventOverflow',
        enabled: true,
        phase: 'main',
        fn: $13043339457d5bc5$var$preventOverflow,
        requiresIfExists: [
            'offset'
        ]
    };
});
parcelRegister("dNtrn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0b6b03fadcbdfd7$export$2e2bcd8739ae039);
    function $a0b6b03fadcbdfd7$export$2e2bcd8739ae039(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
});
parcelRegister("4WpIh", function(module, exports) {
    $parcel$export(module.exports, "within", ()=>$3990864f59117d05$export$f28d906d67a997f3);
    $parcel$export(module.exports, "withinMaxClamp", ()=>$3990864f59117d05$export$86c8af6d3ef0b4a);
    var $90xPK;
    function $3990864f59117d05$export$f28d906d67a997f3(min, value, max) {
        return (0, (0, parcelRequire("90xPK")).max)(min, (0, (0, parcelRequire("90xPK")).min)(value, max));
    }
    function $3990864f59117d05$export$86c8af6d3ef0b4a(min, value, max) {
        var v = $3990864f59117d05$export$f28d906d67a997f3(min, value, max);
        return v > max ? max : v;
    }
});
parcelRegister("gzAfz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c10c08bd5e0ed9fb$export$2e2bcd8739ae039);
    var $QXpw1;
    var $jkGDj;
    var $j6yPg;
    var $gbHJy;
    var $9GF9F;
    var $4WpIh;
    var $gIXWB;
    var $50KfK;
    var $kJPed;
    var $c10c08bd5e0ed9fb$var$toPaddingObject = function toPaddingObject(padding, state) {
        padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
            placement: state.placement
        })) : padding;
        return (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
    };
    function $c10c08bd5e0ed9fb$var$arrow(_ref) {
        var _state$modifiersData$;
        var state = _ref.state, name = _ref.name, options = _ref.options;
        var arrowElement = state.elements.arrow;
        var popperOffsets = state.modifiersData.popperOffsets;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var axis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var isVertical = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0;
        var len = isVertical ? 'height' : 'width';
        if (!arrowElement || !popperOffsets) return;
        var paddingObject = $c10c08bd5e0ed9fb$var$toPaddingObject(options.padding, state);
        var arrowRect = (0, (0, parcelRequire("jkGDj")).default)(arrowElement);
        var minProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
        var maxProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
        var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
        var startDiff = popperOffsets[axis] - state.rects.reference[axis];
        var arrowOffsetParent = (0, (0, parcelRequire("gbHJy")).default)(arrowElement);
        var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
        var centerToReference = endDiff / 2 - startDiff / 2;
        var min = paddingObject[minProp];
        var max = clientSize - arrowRect[len] - paddingObject[maxProp];
        var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
        var offset = (0, (0, parcelRequire("4WpIh")).within)(min, center, max);
        var axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function $c10c08bd5e0ed9fb$var$effect(_ref2) {
        var state = _ref2.state, options = _ref2.options;
        var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
        if (arrowElement == null) return;
        if (typeof arrowElement === 'string') {
            arrowElement = state.elements.popper.querySelector(arrowElement);
            if (!arrowElement) return;
        }
        if (!(0, (0, parcelRequire("j6yPg")).default)(state.elements.popper, arrowElement)) return;
        state.elements.arrow = arrowElement;
    }
    var $c10c08bd5e0ed9fb$export$2e2bcd8739ae039 = {
        name: 'arrow',
        enabled: true,
        phase: 'main',
        fn: $c10c08bd5e0ed9fb$var$arrow,
        effect: $c10c08bd5e0ed9fb$var$effect,
        requires: [
            'popperOffsets'
        ],
        requiresIfExists: [
            'preventOverflow'
        ]
    };
});
parcelRegister("6iLAT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$496957b0c691a0ed$export$2e2bcd8739ae039);
    var $kJPed;
    var $kgkit;
    function $496957b0c691a0ed$var$getSideOffsets(overflow, rect, preventedOffsets) {
        if (preventedOffsets === void 0) preventedOffsets = {
            x: 0,
            y: 0
        };
        return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x
        };
    }
    function $496957b0c691a0ed$var$isAnySideFullyClipped(overflow) {
        return [
            (0, (0, parcelRequire("kJPed")).top),
            (0, (0, parcelRequire("kJPed")).right),
            (0, (0, parcelRequire("kJPed")).bottom),
            (0, (0, parcelRequire("kJPed")).left)
        ].some(function(side) {
            return overflow[side] >= 0;
        });
    }
    function $496957b0c691a0ed$var$hide(_ref) {
        var state = _ref.state, name = _ref.name;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var preventedOffsets = state.modifiersData.preventOverflow;
        var referenceOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            elementContext: 'reference'
        });
        var popperAltOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            altBoundary: true
        });
        var referenceClippingOffsets = $496957b0c691a0ed$var$getSideOffsets(referenceOverflow, referenceRect);
        var popperEscapeOffsets = $496957b0c691a0ed$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
        var isReferenceHidden = $496957b0c691a0ed$var$isAnySideFullyClipped(referenceClippingOffsets);
        var hasPopperEscaped = $496957b0c691a0ed$var$isAnySideFullyClipped(popperEscapeOffsets);
        state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped
        };
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-reference-hidden': isReferenceHidden,
            'data-popper-escaped': hasPopperEscaped
        });
    }
    var $496957b0c691a0ed$export$2e2bcd8739ae039 = {
        name: 'hide',
        enabled: true,
        phase: 'main',
        requiresIfExists: [
            'preventOverflow'
        ],
        fn: $496957b0c691a0ed$var$hide
    };
});
parcelRegister("iGDLS", function(module, exports) {
    $parcel$export(module.exports, "Reference", ()=>$d9aafffd117cbcc1$export$e0be378c32fb70a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hBYjV = parcelRequire("hBYjV");
    var $5n5w4;
    var $eclLw;
    function $d9aafffd117cbcc1$export$e0be378c32fb70a7(_ref) {
        var children = _ref.children, innerRef = _ref.innerRef;
        var setReferenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeSetterContext));
        var refHandler = $5uXOq.useCallback(function(node) {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, node);
            (0, (0, parcelRequire("eclLw")).safeInvoke)(setReferenceNode, node);
        }, [
            innerRef,
            setReferenceNode
        ]);
        $5uXOq.useEffect(function() {
            return function() {
                return (0, (0, parcelRequire("eclLw")).setRef)(innerRef, null);
            };
        }, []);
        $5uXOq.useEffect(function() {
            (0, ($parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
        }, [
            setReferenceNode
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)({
            ref: refHandler
        });
    }
});
parcelRegister("4wJSY", function(module, exports) {
    $parcel$export(module.exports, "shallowEqualObjects", ()=>$34bdbe885d924a05$export$3e67810a3f0e9f1c);
    function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
        if (arrA === arrB) return true;
        if (!arrA || !arrB) return false;
        const len = arrA.length;
        if (arrB.length !== len) return false;
        for(let i = 0; i < len; i++){
            if (arrA[i] !== arrB[i]) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
        if (objA === objB) return true;
        if (!objA || !objB) return false;
        const aKeys = Object.keys(objA);
        const bKeys = Object.keys(objB);
        const len = aKeys.length;
        if (bKeys.length !== len) return false;
        for(let i = 0; i < len; i++){
            const key = aKeys[i];
            if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
        const aIsArr = Array.isArray(a);
        const bIsArr = Array.isArray(b);
        if (aIsArr !== bIsArr) return false;
        if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
        return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
    }
});
parcelRegister("hT6ku", function(module, exports) {
    $parcel$export(module.exports, "MenuDialog", ()=>$3f79b132df1e01ff$export$c94219dad7c0e37d);
    $parcel$export(module.exports, "DummyControl", ()=>$3f79b132df1e01ff$export$87ce933b7fc29b8c);
    $parcel$export(module.exports, "defaultComponents", ()=>$3f79b132df1e01ff$export$71abc632aa29e6fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gMMNe;
    var $bChGW;
    var $k5uoT;
    var $jldZL;
    function $3f79b132df1e01ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3f79b132df1e01ff$var$menuDialogStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
        backgroundColor: "var(--ds-surface-overlay, white)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`
    });
    const $3f79b132df1e01ff$export$c94219dad7c0e37d = (0, $5uXOq.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            css: [
                $3f79b132df1e01ff$var$menuDialogStyles,
                {
                    maxWidth: maxWidth,
                    minWidth: minWidth
                }
            ],
            style: style,
            id: id,
            "data-testid": testId && `${testId}--menu`
        }, children));
    const $3f79b132df1e01ff$var$dropdownStyles = {
        name: "7693z9",
        styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
    };
    const $3f79b132df1e01ff$var$DropdownIndicator = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3f79b132df1e01ff$var$dropdownStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("gMMNe"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: "open"
        }));
    const $3f79b132df1e01ff$var$controlStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $3f79b132df1e01ff$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            css: $3f79b132df1e01ff$var$controlStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, {
            ...props,
            innerProps: innerProps
        }));
    const $3f79b132df1e01ff$export$87ce933b7fc29b8c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, props));
    const $3f79b132df1e01ff$var$Menu = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $3f79b132df1e01ff$var$IndicatorSeparator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).IndicatorSeparator, props);
    const $3f79b132df1e01ff$var$ClearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, props);
    const $3f79b132df1e01ff$var$MultiValueRemove = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props);
    const $3f79b132df1e01ff$export$71abc632aa29e6fe = {
        Control: $3f79b132df1e01ff$var$Control,
        DropdownIndicator: $3f79b132df1e01ff$var$DropdownIndicator,
        Menu: $3f79b132df1e01ff$var$Menu,
        IndicatorSeparator: $3f79b132df1e01ff$var$IndicatorSeparator,
        ClearIndicator: $3f79b132df1e01ff$var$ClearIndicator,
        MultiValueRemove: $3f79b132df1e01ff$var$MultiValueRemove
    };
});
parcelRegister("gMMNe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c386fa4cb21167b0$var$_react = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c386fa4cb21167b0$var$_search = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("hyOJh")));
    var $c386fa4cb21167b0$var$_search2 = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("77ZoC")));
    function $c386fa4cb21167b0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c386fa4cb21167b0$var$SearchIcon = (props)=>$c386fa4cb21167b0$var$_react.default.createElement($c386fa4cb21167b0$var$_search.default, Object.assign({
            LEGACY_fallbackIcon: $c386fa4cb21167b0$var$_search2.default
        }, props));
    $c386fa4cb21167b0$var$SearchIcon.Name = 'SearchIconMigration';
    var $c386fa4cb21167b0$var$_default = module.exports.default = $c386fa4cb21167b0$var$SearchIcon;
});
parcelRegister("77ZoC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
    function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>$5308cfd5e45a5605$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
        }, props, {
            newIcon: $5308cfd5e45a5605$var$_search.default
        }));
    $5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
    var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;
});
parcelRegister("78Gdn", function(module, exports) {
    $parcel$export(module.exports, "batchByKey", ()=>$2e9cc1cdc768945e$export$da86c38211c1c0a8);
    function $2e9cc1cdc768945e$export$da86c38211c1c0a8(callback) {
        const calls = {};
        return (key, ...args)=>{
            if (!calls[key]) {
                window.setTimeout(()=>{
                    callback(key, calls[key]);
                    delete calls[key];
                });
                calls[key] = [];
            }
            calls[key].push(args);
        };
    }
});
parcelRegister("8fG8p", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$7b21650c04984462$export$defe85febe8b728c);
    var $7VHMR;
    const $7b21650c04984462$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            id: 'fabric.elements.user-picker.placeholder',
            defaultMessage: 'Enter people or teams...',
            description: 'Placeholder description for empty user/team/email select field.'
        },
        addMore: {
            id: 'fabric.elements.user-picker.placeholder.add-more',
            defaultMessage: 'add more people...',
            description: 'Placeholder for multi user picker when the field is not empty.'
        },
        remove: {
            id: 'fabric.elements.user-picker.multi.remove-item',
            defaultMessage: 'Remove',
            description: 'Tooltip for the single item remove button in a multi user select field.'
        },
        clear: {
            id: 'fabric.elements.user-picker.single.clear',
            defaultMessage: 'Clear',
            description: 'Tooltip for clear button in the single user select field.'
        },
        errorMessage: {
            id: 'fabric.elements.user-picker.error.message',
            defaultMessage: 'Something went wrong',
            description: 'Error message to display when options fail to load.'
        },
        memberCountWithoutYou: {
            id: 'fabric.elements.user-picker.team.member.count',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
            description: 'Byline to show the number of members in the team when the current user is not a member of the team'
        },
        memberCountWithYou: {
            id: 'fabric.elements.user-picker.team.member.count.including.you',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
            description: 'Byline to show the number of members in the team when the current user is also a member of the team'
        },
        plus50MembersWithoutYou: {
            id: 'fabric.elements.user-picker.team.member.50plus',
            defaultMessage: "Team \u2022 50+ members",
            description: 'Byline to show the number of members in the team when the number exceeds 50'
        },
        plus50MembersWithYou: {
            id: 'fabric.elements.user-picker.team.member.50plus.including.you',
            defaultMessage: "Team \u2022 50+ members, including you",
            description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
        },
        addEmail: {
            id: 'fabric.elements.user-picker.email.add',
            defaultMessage: 'Add user',
            description: 'Byline for valid email option.'
        },
        selectToAddEmail: {
            id: 'fabric.elements.user-picker.email.select.to.add',
            defaultMessage: 'Select an email address',
            description: 'Byline for valid email option.'
        },
        continueToAddEmail: {
            id: 'fabric.elements.user-picker.email.add.potential',
            defaultMessage: 'Enter an email address',
            description: 'Byline for a potentially valid email option.'
        },
        groupByline: {
            id: 'fabric.elements.user-picker.group.byline',
            defaultMessage: 'Admin-managed group',
            description: 'Byline for admin-managed groups'
        },
        externalUserSourcesHeading: {
            id: 'fabric.elements.user-picker.external.sourced.from',
            defaultMessage: 'Found in:',
            description: 'From where the external user is coming'
        },
        externalUserSourcesError: {
            id: 'fabric.elements.user-picker.external.sourced.error',
            defaultMessage: "We can't connect you right now.",
            description: "Error message when we can't fetch a user's import sources"
        },
        slackProvider: {
            id: 'fabric.elements.user-picker.slack.provider',
            defaultMessage: 'Slack',
            description: 'This external user is sourced from Slack provider'
        },
        googleProvider: {
            id: 'fabric.elements.user-picker.google.provider',
            defaultMessage: 'Google',
            description: 'This external user is sourced from Google provider'
        },
        microsoftProvider: {
            id: 'fabric.elements.user-picker.microsoft.provider',
            defaultMessage: 'Microsoft',
            description: 'This external user is sourced from Microsoft provider'
        },
        gitHubProvider: {
            id: 'fabric.elements.user-picker.github.provider',
            defaultMessage: 'GitHub',
            description: 'This external user is sourced from GitHub provider'
        },
        jiraSource: {
            id: 'fabric.elements.user-picker.source.jira',
            defaultMessage: 'Jira',
            description: 'This external user is sourced from Jira'
        },
        confluenceSource: {
            id: 'fabric.elements.user-picker.source.confluence',
            defaultMessage: 'Confluence',
            description: 'This external user is sourced from Confluence'
        },
        otherAtlassianSource: {
            id: 'fabric.elements.user-picker.source.other-atlassian',
            defaultMessage: 'Other Atlassian products',
            description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
        },
        memberLozengeText: {
            id: 'fabric.elements.user-picker.member.lozenge.text',
            defaultMessage: 'MEMBER',
            description: 'Text within the Lozenge when the user is a workspace member'
        },
        guestLozengeText: {
            id: 'fabric.elements.user-picker.guest.lozenge.text',
            defaultMessage: 'GUEST',
            description: 'Text within the lozenge when the user is a guest of confluence'
        },
        guestUserLozengeTooltip: {
            id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
            defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
            description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
        },
        guestGroupLozengeTooltip: {
            id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
            defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
            description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
        }
    });
});
parcelRegister("pk97C", function(module, exports) {
    $parcel$export(module.exports, "userPickerRenderedUfoExperience", ()=>$06ebadcdd7d5e231$export$b49757166e1acfc2);
    $parcel$export(module.exports, "userPickerOptionsShownUfoExperience", ()=>$06ebadcdd7d5e231$export$135a264e0da507ae);
    $parcel$export(module.exports, "UfoErrorBoundary", ()=>$06ebadcdd7d5e231$export$5ef1c2550074a375);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBycP;
    var $7Zbvr;
    var $jZA09;
    const $06ebadcdd7d5e231$export$b49757166e1acfc2 = new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('user-picker-rendered', {
        platform: {
            component: 'user-picker'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $06ebadcdd7d5e231$export$135a264e0da507ae = new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('user-picker-options-shown', {
        platform: {
            component: 'user-picker'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).InlineResult
    });
    class $06ebadcdd7d5e231$export$5ef1c2550074a375 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch() {
            const instance = $06ebadcdd7d5e231$export$b49757166e1acfc2.getInstance(this.props.id);
            if (instance.state.id !== (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id) instance.failure();
        }
        render() {
            return this.props.children;
        }
    }
});
parcelRegister("cBycP", function(module, exports) {
    $parcel$export(module.exports, "ConcurrentExperience", ()=>$d4c0ab33dd6972cc$export$ac1cddfee07ba6ac);
    var $dCAsn;
    var $boHLC;
    class $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac {
        constructor(experienceId, config){
            this.instances = {};
            this.experienceId = experienceId;
            this.config = config;
        }
        getInstance(instanceId) {
            if (!this.instances[instanceId]) this.instances[instanceId] = new (0, (0, parcelRequire("boHLC")).UFOExperience)(this.experienceId, this.config, instanceId);
            return this.instances[instanceId];
        }
        release(instanceId) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('instanceId', instanceId);
            if (this.instances[instanceId]) this.instances[instanceId].abort();
            delete this.instances[instanceId];
        }
    }
});
parcelRegister("dCAsn", function(module, exports) {
    $parcel$export(module.exports, "ufolog", ()=>$c8856379f9e2d7e8$export$b4958caff08a0960);
    $parcel$export(module.exports, "ufowarn", ()=>$c8856379f9e2d7e8$export$d53d07b6034c4560);
    class $c8856379f9e2d7e8$var$UFOLogger {
        static{
            this.UFOprefix = "[ufo\uD83D\uDEF8]";
        }
        log(...args) {
            this.enabled && console.log($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
        }
        warn(...args) {
            this.enabled && console.warn($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
        }
        enable() {
            this.enabled = true;
        }
        disable() {
            this.enabled = false;
        }
        constructor(){
            this.enabled = false;
        }
    }
    const $c8856379f9e2d7e8$export$4ab84f6f04f6566d = new $c8856379f9e2d7e8$var$UFOLogger();
    const $c8856379f9e2d7e8$export$b4958caff08a0960 = (...args)=>{
        $c8856379f9e2d7e8$export$4ab84f6f04f6566d.log(...args);
    };
    const $c8856379f9e2d7e8$export$d53d07b6034c4560 = (...args)=>{
        $c8856379f9e2d7e8$export$4ab84f6f04f6566d.warn(...args);
    };
});
parcelRegister("boHLC", function(module, exports) {
    $parcel$export(module.exports, "UFOExperience", ()=>$69d53cdb5241e240$export$c00d22927c60484a);
    var $iLwDN;
    class $69d53cdb5241e240$export$c00d22927c60484a extends (0, (0, parcelRequire("iLwDN")).UFOAbstractExperience) {
    }
});
parcelRegister("iLwDN", function(module, exports) {
    $parcel$export(module.exports, "UFOAbstractExperience", ()=>$cc70575b2203e361$export$d31c89db257648c);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $1vlV8;
    var $dCAsn;
    var $dlucd;
    var $blQsS;
    var $9tjMO;
    var $1CRHx;
    var $jZA09;
    var $hM2B6;
    var $7Zbvr;
    const $cc70575b2203e361$var$getPageVisibleState = ()=>{
        return !(0, (0, parcelRequire("1CRHx")).isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, (0, parcelRequire("blQsS")).PageVisibleState).VISIBLE : (0, (0, parcelRequire("blQsS")).PageVisibleState).HIDDEN;
    };
    const $cc70575b2203e361$export$c753e8669d30c8ad = (timestamp)=>{
        if (timestamp !== undefined) return ~~timestamp;
        return (0, (0, parcelRequire("9tjMO")).roundPerfNow)();
    };
    class $cc70575b2203e361$export$d31c89db257648c {
        constructor(id, config, instanceId = null){
            this.state = (0, (0, parcelRequire("jZA09")).UFOExperienceState).NOT_STARTED;
            this.instanceId = null;
            this.parent = null;
            this.category = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.explicitTimings = {};
            this.isSSROutputAsFMP = false;
            this.uuid = null;
            this._until = null;
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this.performanceConfig = {};
            this.setPageVisibleStateToMixed = ()=>{
                this.pageVisibleState = (0, (0, parcelRequire("blQsS")).PageVisibleState).MIXED;
                (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            };
            this.id = id;
            this.category = config?.category || null;
            this.until = config?.until || null;
            this.instanceId = instanceId;
            this.handleDoneBind = this._handleDoneExperience.bind(this);
            this.type = config.type;
            this.performanceType = config.performanceType;
            this.performanceConfig = config.performanceConfig || {};
            this.config = config;
            this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
            this.featureFlags = config.featureFlags || [];
            this.timings = config.timings || [];
            if (config.performanceType === (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
        }
        async transition(newState, timestamp) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('async transition', this.id, this.state.id, newState.id);
            if ((0, (0, parcelRequire("hM2B6")).canTransition)(this.state, newState)) {
                (0, (0, parcelRequire("dCAsn")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
                if (newState === (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED) this._reset();
                if (this.state.final && !newState.final) {
                    this.metrics.startTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                    this.uuid = (0, $7Jxgt.v4)();
                }
                this.state = newState;
                if (newState.final) {
                    this.metrics.endTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                    if (!this._isManualStateEnabled()) (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).unsubscribeEvent)((0, (0, parcelRequire("blQsS")).SUBSCRIBE_ALL), this.handleDoneBind));
                    const data = await this.exportData();
                    (0, (0, parcelRequire("dCAsn")).ufolog)('this.parent', this.parent);
                    (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).experiencePayloadEvent)(data));
                }
                return true;
            }
            (0, (0, parcelRequire("dCAsn")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
            (0, (0, parcelRequire("dCAsn")).ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
            return false;
        }
        async start(startTime) {
            const transitionSuccessful = await this.transition((0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED, startTime);
            if (transitionSuccessful) {
                this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
                (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                if (!this._isManualStateEnabled()) {
                    (0, (0, parcelRequire("dCAsn")).ufolog)('subscribed', this.id);
                    (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).subscribeEvent)((0, (0, parcelRequire("blQsS")).SUBSCRIBE_ALL), this.handleDoneBind));
                }
            }
        }
        mark(name, timestamp) {
            if (name !== (0, (0, parcelRequire("blQsS")).FMP_MARK) && name !== (0, (0, parcelRequire("blQsS")).INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
            else (0, (0, parcelRequire("dCAsn")).ufowarn)('please use markFMP or markInlineResponse for specialised marks');
        }
        _mark(name, timestamp) {
            this.metrics.marks.push({
                name: name,
                time: $cc70575b2203e361$export$c753e8669d30c8ad(timestamp)
            });
            this.transition((0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS);
        }
        markFMP(timestamp) {
            this._mark((0, (0, parcelRequire("blQsS")).FMP_MARK), timestamp);
        }
        markInlineResponse(timestamp) {
            this._mark((0, (0, parcelRequire("blQsS")).INLINE_RESPONSE_MARK), timestamp);
        }
        _isManualStateEnabled() {
            return this.until === null;
        }
        _validateManualState() {
            if (!this._isManualStateEnabled()) {
                (0, (0, parcelRequire("dCAsn")).ufowarn)('manual change of state not allowed as "until" is defined');
                return false;
            }
            return true;
        }
        switchToEndState(state, config) {
            if (!config?.force && !this._validateManualState()) return null;
            if (config?.metadata) this.addMetadata(config.metadata);
            (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            return this.transition(state);
        }
        async success(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED, config);
        }
        async failure(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED, config);
        }
        async abort(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED, config);
        }
        addMetadata(data) {
            Object.assign(this.metadata, data);
        }
        _handleDoneExperience(data) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
            if (data.state.final) {
                if (this._until !== null) {
                    const { done: done, state: state } = this._until(data);
                    if (done && !this.state.final) this.transition(state);
                }
            }
        }
        async getId() {
            return this.id;
        }
        async exportData() {
            return {
                id: await this.getId(),
                uuid: this.uuid,
                type: this.type,
                schemaVersion: (0, $bbbd8b5766b053fb$export$2295b861f318254a) || 'unknown',
                performanceType: this.performanceType,
                category: this.category,
                state: this.state,
                metadata: {
                    ...this.metadata
                },
                metrics: {
                    ...this.metrics
                },
                children: [
                    ...this.childExperiences
                ],
                result: {
                    success: !!this.state.success,
                    startTime: this.metrics.startTime,
                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                },
                platform: this.config.platform || null,
                pageVisibleState: this.pageVisibleState,
                featureFlags: this.featureFlags,
                isSSROutputAsFMP: this.isSSROutputAsFMP,
                timings: this.timings,
                explicitTimings: this.explicitTimings,
                performanceConfig: this.performanceConfig
            };
        }
        _reset() {
            this.parent = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this._until = this.until ? this.until() : null;
        }
    }
});
const $bbbd8b5766b053fb$export$2295b861f318254a = '0.1.5';
parcelRegister("1vlV8", function(module, exports) {
    $parcel$export(module.exports, "getGlobalEventStream", ()=>$d117cb8be5e8747a$export$6123a44dc2384540);
    $parcel$export(module.exports, "subscribeEvent", ()=>$d117cb8be5e8747a$export$37863216db4b714d);
    $parcel$export(module.exports, "unsubscribeEvent", ()=>$d117cb8be5e8747a$export$ee1a7bd1fc9ea85e);
    $parcel$export(module.exports, "experiencePayloadEvent", ()=>$d117cb8be5e8747a$export$7c957416596ca127);
    var $dCAsn;
    var $blQsS;
    const $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH = 250;
    const $d117cb8be5e8747a$export$6123a44dc2384540 = ()=>{
        if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
            const earlyStream = (()=>{
                const stream = [];
                return {
                    __buffer_only__: true,
                    push: (event)=>{
                        if (stream.length < $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                    },
                    getStream: ()=>stream
                };
            })();
            globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
        }
        return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
    };
    const $d117cb8be5e8747a$export$c1522520b417b066 = (eventStream)=>{
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
            (0, (0, parcelRequire("dCAsn")).ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
            return;
        }
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
    };
    const $d117cb8be5e8747a$export$37863216db4b714d = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).SUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).UNSUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $d117cb8be5e8747a$export$7c957416596ca127 = (data)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
            payload: data
        };
    };
});
parcelRegister("blQsS", function(module, exports) {
    $parcel$export(module.exports, "UFOGlobalEventStreamEventType", ()=>$2d245cff606eb60d$export$96253c35c37cf96b);
    $parcel$export(module.exports, "PageVisibleState", ()=>$2d245cff606eb60d$export$a12c67b37a306b13);
    $parcel$export(module.exports, "SUBSCRIBE_ALL", ()=>$2d245cff606eb60d$export$79bf131685ad41d7);
    $parcel$export(module.exports, "FMP_MARK", ()=>$2d245cff606eb60d$export$9f2bf58999404c75);
    $parcel$export(module.exports, "INLINE_RESPONSE_MARK", ()=>$2d245cff606eb60d$export$837e0f79a8056912);
    var $2d245cff606eb60d$export$96253c35c37cf96b;
    (function(UFOGlobalEventStreamEventType) {
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    })($2d245cff606eb60d$export$96253c35c37cf96b || ($2d245cff606eb60d$export$96253c35c37cf96b = {}));
    var $2d245cff606eb60d$export$a12c67b37a306b13;
    (function(PageVisibleState) {
        PageVisibleState["VISIBLE"] = "visible";
        PageVisibleState["HIDDEN"] = "hidden";
        PageVisibleState["MIXED"] = "mixed";
    })($2d245cff606eb60d$export$a12c67b37a306b13 || ($2d245cff606eb60d$export$a12c67b37a306b13 = {}));
    var $2d245cff606eb60d$export$66b33c055cbb625e;
    (function(PageLoadMetrics) {
        PageLoadMetrics["fmp"] = "fmp";
        PageLoadMetrics["tti"] = "tti";
    })($2d245cff606eb60d$export$66b33c055cbb625e || ($2d245cff606eb60d$export$66b33c055cbb625e = {}));
    var $2d245cff606eb60d$export$3ce489cbe02dc21b;
    (function(PageSegmentLoadMetrics) {
        PageSegmentLoadMetrics["fmp"] = "fmp";
        PageSegmentLoadMetrics["tti"] = "tti";
    })($2d245cff606eb60d$export$3ce489cbe02dc21b || ($2d245cff606eb60d$export$3ce489cbe02dc21b = {}));
    var $2d245cff606eb60d$export$341b330828bd3906;
    (function(InteractionMetrics) {
        InteractionMetrics["response"] = "response";
        InteractionMetrics["result"] = "result";
    })($2d245cff606eb60d$export$341b330828bd3906 || ($2d245cff606eb60d$export$341b330828bd3906 = {}));
    var $2d245cff606eb60d$export$b9b20160f581e4f8;
    (function(CustomMetrics) {
        CustomMetrics["duration"] = "duration";
    })($2d245cff606eb60d$export$b9b20160f581e4f8 || ($2d245cff606eb60d$export$b9b20160f581e4f8 = {}));
    const $2d245cff606eb60d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
    const $2d245cff606eb60d$export$9f2bf58999404c75 = 'fmp';
    const $2d245cff606eb60d$export$837e0f79a8056912 = 'inline-response';
});
parcelRegister("dlucd", function(module, exports) {
    $parcel$export(module.exports, "visibilityChangeObserver", ()=>$46b8336a04974a29$export$13e680397ec8f3eb);
    var $1CRHx;
    class $46b8336a04974a29$var$VisibilityChangeObserver {
        start() {
            if (this.started) return;
            this.started = true;
            document.addEventListener('visibilitychange', this.broadcast);
            if ((0, (0, parcelRequire("1CRHx")).isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
        }
        subscribe(callback) {
            this.observers.push(callback);
        }
        unsubscribe(callback) {
            this.observers = this.observers.filter((fn)=>fn !== callback);
        }
        constructor(){
            this.started = false;
            this.observers = [];
            this.broadcast = ()=>{
                this.observers.forEach((fn)=>fn());
                this.observers = [];
            };
        }
    }
    const $46b8336a04974a29$export$13e680397ec8f3eb = new $46b8336a04974a29$var$VisibilityChangeObserver();
});
parcelRegister("1CRHx", function(module, exports) {
    $parcel$export(module.exports, "isWindowObjectAvailable", ()=>$5d24ea5e24f61a4f$export$15e172712955e18f);
    const $5d24ea5e24f61a4f$export$15e172712955e18f = ()=>{
        return typeof window !== 'undefined';
    };
});
parcelRegister("9tjMO", function(module, exports) {
    $parcel$export(module.exports, "roundPerfNow", ()=>$29608d3bcf65c265$export$5f490af6b2b115cf);
    const $29608d3bcf65c265$export$5f490af6b2b115cf = ()=>~~performance.now();
});
parcelRegister("hM2B6", function(module, exports) {
    $parcel$export(module.exports, "canTransition", ()=>$6edf4365ea9733d4$export$178881f329fdb81f);
    var $jZA09;
    const $6edf4365ea9733d4$var$UFOStateAvailableTransitions = {
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).NOT_STARTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).RECOVERED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).RECOVERED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ]
    };
    const $6edf4365ea9733d4$export$178881f329fdb81f = (state1, state2)=>{
        return $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id] && $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
    };
});
parcelRegister("7Zbvr", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTypes", ()=>$e40e68027603de60$export$994164cf3ae1cc9a);
    $parcel$export(module.exports, "ExperiencePerformanceTypes", ()=>$e40e68027603de60$export$cc26007c03242fff);
    var $e40e68027603de60$export$994164cf3ae1cc9a;
    (function(ExperienceTypes) {
        ExperienceTypes["Load"] = "load";
        ExperienceTypes["Experience"] = "experience";
        ExperienceTypes["Operation"] = "operation";
    })($e40e68027603de60$export$994164cf3ae1cc9a || ($e40e68027603de60$export$994164cf3ae1cc9a = {}));
    var $e40e68027603de60$export$cc26007c03242fff;
    (function(ExperiencePerformanceTypes) {
        ExperiencePerformanceTypes["PageLoad"] = "page-load";
        ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
        ExperiencePerformanceTypes["InlineResult"] = "inline-result";
        ExperiencePerformanceTypes["Custom"] = "custom";
    })($e40e68027603de60$export$cc26007c03242fff || ($e40e68027603de60$export$cc26007c03242fff = {}));
});
parcelRegister("2wgOn", function(module, exports) {
    $parcel$export(module.exports, "BORDER_PADDING", ()=>$01bdbab7be42e070$export$59c188914e58c94b);
    $parcel$export(module.exports, "getStyles", ()=>$01bdbab7be42e070$export$ffd58b7f6f099a57);
    $parcel$export(module.exports, "getPopupStyles", ()=>$01bdbab7be42e070$export$4e983f376ad8a3af);
    var $8QpSo;
    var $7VXAu;
    const $01bdbab7be42e070$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
    const $01bdbab7be42e070$export$53937c04f7dfc2ae = 6;
    const $01bdbab7be42e070$export$2c62ba763e976c54 = 39;
    const $01bdbab7be42e070$export$ffd58b7f6f099a57 = (0, (0, parcelRequire("8QpSo")).default)((width, isMulti, isCompact, overrideStyles, isInvalid)=>{
        let styles = {
            menu: (css, state)=>({
                    ...css,
                    width: width,
                    minWidth: state.selectProps.menuMinWidth,
                    zIndex: '400'
                }),
            menuList: (css)=>({
                    ...css,
                    zIndex: '400'
                }),
            control: (css, state)=>{
                const isMulti = state.selectProps.isMulti;
                return {
                    ...css,
                    width: width,
                    borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                    backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`,
                    '&:hover .fabric-user-picker__clear-indicator': {
                        opacity: 1
                    },
                    ':hover': {
                        ...css[':hover'],
                        borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                        backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $829f609a65d26a98$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`
                    },
                    padding: 0,
                    minHeight: isCompact ? 'none' : 44,
                    height: isCompact || isMulti ? '100%' : 44,
                    maxWidth: '100%'
                };
            },
            clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                    ...css,
                    opacity: 1,
                    '@media (hover: hover) and (pointer: fine)': {
                        opacity: 0
                    },
                    transition: css.transition + ', opacity 150ms',
                    paddingTop: 0,
                    padding: 0,
                    ':hover': {
                        color: `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`
                    }
                }),
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
                const isMulti = state.selectProps.isMulti;
                return {
                    ...css,
                    gridTemplateColumns: 'auto 1fr',
                    paddingTop: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                    paddingBottom: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                    paddingLeft: isMulti ? $01bdbab7be42e070$export$59c188914e58c94b : 0,
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    scrollbarWidth: 'none',
                    maxHeight: state.selectProps.maxPickerHeight || '100%',
                    '::-webkit-scrollbar': {
                        width: 0,
                        background: 'transparent'
                    }
                };
            },
            multiValue: (css)=>({
                    ...css,
                    borderRadius: 24,
                    cursor: 'default'
                }),
            multiValueLabel: (css)=>({
                    ...css,
                    fontSize: '100%',
                    display: 'flex'
                }),
            multiValueRemove: (css)=>({
                    ...css,
                    borderRadius: 24,
                    cursor: 'pointer'
                }),
            placeholder: (css, state)=>{
                if (css.position === 'absolute' && !css.left) css.left = `${$01bdbab7be42e070$export$59c188914e58c94b}px`;
                return {
                    ...css,
                    gridArea: '1/2/2/3',
                    paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                    margin: 0,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                };
            },
            option: (css)=>({
                    ...css,
                    overflow: 'hidden'
                }),
            input: (css, state)=>({
                    ...css,
                    gridArea: '1/2/2/3',
                    gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                    margin: `${"var(--ds-space-050, 4px)"} 0`,
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                    '& input::placeholder': {
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
                        opacity: 1
                    },
                    '& input:-ms-input-placeholder': {
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`
                    }
                }),
            singleValue: (css)=>({
                    ...css,
                    margin: 0,
                    gridArea: '1/2/2/3'
                })
        };
        return overrideStyles ? (0, (0, parcelRequire("7VXAu")).mergeStyles)(styles, overrideStyles) : styles;
    });
    const $01bdbab7be42e070$export$4e983f376ad8a3af = (0, (0, parcelRequire("8QpSo")).default)((width, isMulti, overrideStyles)=>({
            ...$01bdbab7be42e070$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles)
        }));
});
parcelRegister("dyegP", function(module, exports) {
    $parcel$export(module.exports, "getComponents", ()=>$27e51ea041192381$export$4e811121b221213b);
    $parcel$export(module.exports, "getPopupComponents", ()=>$27e51ea041192381$export$19205fd341a6bb08);
    var $8QpSo;
    var $dqbw8;
    var $8Y8Qe;
    var $fIpmY;
    var $3QONt;
    var $6Kkci;
    var $OxpB4;
    var $ee8bl;
    var $h3ej5;
    var $6Ks8i;
    var $lYehz;
    const $27e51ea041192381$export$4e811121b221213b = (0, (0, parcelRequire("8QpSo")).default)((multi, anchor)=>{
        if (anchor) return {
            Control: anchor,
            Option: (0, parcelRequire("3QONt")).Option
        };
        else return {
            MultiValue: (0, parcelRequire("8Y8Qe")).MultiValue,
            DropdownIndicator: null,
            SingleValue: (0, parcelRequire("6Kkci")).SingleValue,
            ClearIndicator: multi ? null : (0, (0, parcelRequire("dqbw8")).ClearIndicator),
            Option: (0, parcelRequire("3QONt")).Option,
            ValueContainer: multi ? (0, (0, parcelRequire("fIpmY")).MultiValueContainer) : (0, (0, parcelRequire("ee8bl")).SingleValueContainer),
            Input: (0, parcelRequire("OxpB4")).Input,
            Menu: (0, parcelRequire("lYehz")).Menu
        };
    });
    const $27e51ea041192381$export$19205fd341a6bb08 = (0, (0, parcelRequire("8QpSo")).default)((hasPopupTitle)=>{
        const baseProps = {
            DropdownIndicator: null,
            SingleValue: (0, parcelRequire("6Kkci")).SingleValue,
            ClearIndicator: (0, parcelRequire("dqbw8")).ClearIndicator,
            Option: (0, parcelRequire("3QONt")).Option,
            ValueContainer: (0, (0, parcelRequire("ee8bl")).SingleValueContainer),
            Input: (0, (0, parcelRequire("h3ej5")).PopupInput)
        };
        if (hasPopupTitle) return {
            ...baseProps,
            Control: (0, (0, parcelRequire("6Ks8i")).PopupControl)
        };
        return baseProps;
    });
});
parcelRegister("dqbw8", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$11bf495008933d24$export$ecf9cf59142dd54a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    const $11bf495008933d24$var$AsyncTooltip = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("inSCC")).then((module)=>{
            return {
                default: module.default
            };
        }));
    class $11bf495008933d24$export$ecf9cf59142dd54a extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { selectProps: { clearValueLabel: clearValueLabel } } = this.props;
            const Indicator = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
                ...this.props,
                innerProps: {
                    ...this.props.innerProps,
                    onMouseDown: this.handleMouseDown
                }
            });
            return clearValueLabel ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Suspense, {
                fallback: Indicator
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($11bf495008933d24$var$AsyncTooltip, {
                content: clearValueLabel
            }, Indicator)) : Indicator;
        }
        constructor(...args){
            super(...args), this.handleMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                const { clearValue: clearValue, selectProps: selectProps } = this.props;
                clearValue();
                if (selectProps && !selectProps.isFocused) event.stopPropagation();
            };
        }
    }
});
parcelRegister("inSCC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lOT8O").then(()=>parcelRequire('8hfZh'));
});
parcelRegister("8Y8Qe", function(module, exports) {
    $parcel$export(module.exports, "MultiValue", ()=>$65368b71d1856c3a$export$419cdf50db8b579);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $f8Sb3;
    var $dW8NE;
    var $5pJx4;
    var $3smIt;
    var $4hqZ5;
    var $fuhQD;
    var $VSDnB;
    function $65368b71d1856c3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $65368b71d1856c3a$export$118122ebc1e626fa = (valueContainer, control)=>{
        const { top: top, height: height } = valueContainer.getBoundingClientRect();
        const { height: controlHeight } = control.getBoundingClientRect();
        if (top - height < 0) valueContainer.scrollIntoView();
        if (top + height > controlHeight) valueContainer.scrollIntoView(false);
    };
    const $65368b71d1856c3a$var$groupTagContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.025',
        marginTop: 'space.025'
    });
    const $65368b71d1856c3a$var$nameWrapper = {
        name: "6urmvo",
        styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
    };
    class $65368b71d1856c3a$export$419cdf50db8b579 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props), this.getElemBefore = ()=>{
                const { data: { data: data } } = this.props;
                if ((0, (0, parcelRequire("3smIt")).isEmail)(data)) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dW8NE")).AddOptionAvatar), {
                    isLozenge: true
                });
                if ((0, (0, parcelRequire("3smIt")).isGroup)(data)) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $65368b71d1856c3a$var$groupTagContainer
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("4hqZ5"))))), {
                    LEGACY_margin: "-2px 0 0 0",
                    color: "currentColor",
                    label: "",
                    LEGACY_size: "small"
                }));
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5pJx4")).SizeableAvatar), {
                    appearance: "multi",
                    src: (0, (0, parcelRequire("3smIt")).getAvatarUrl)(data),
                    type: (0, (0, parcelRequire("3smIt")).isTeam)(data) && (0, (0, parcelRequire("VSDnB")).fg)('verified-team-in-user-picker') ? 'team' : 'person'
                });
            }, this.getElemAfter = ()=>{
                const { data: { data: data } } = this.props;
                if ((0, (0, parcelRequire("3smIt")).isTeam)(data) && data.verified && (0, (0, parcelRequire("VSDnB")).fg)('verified-team-in-user-picker')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fuhQD")).VerifiedTeamIcon), {
                    size: "small"
                });
                return null;
            };
            this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
        }
        componentDidUpdate() {
            const { isFocused: isFocused } = this.props;
            if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $65368b71d1856c3a$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
        }
        shouldComponentUpdate(nextProps) {
            const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
            const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
            return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
        }
        render() {
            const { children: children, innerProps: innerProps, ...rest } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValue, {
                ...rest,
                innerProps: {
                    ref: this.containerRef
                },
                cropWithEllipsis: false
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                alignBlock: "center"
            }, this.getElemBefore(), " ", (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $65368b71d1856c3a$var$nameWrapper
            }, children), this.getElemAfter()));
        }
    }
});
parcelRegister("dW8NE", function(module, exports) {
    $parcel$export(module.exports, "AddOptionAvatar", ()=>$f3236d5a67f7ff1f$export$df396db45e491922);
    var $aVnO1;
    var $f8Sb3;
    parcelRequire("5uXOq");
    const $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
        const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            padding: padding,
            backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            marginLeft: "var(--ds-space-025, 2px)"
        });
    };
    const $f3236d5a67f7ff1f$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle(isLozenge)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("aVnO1"))))), {
            testId: "add-option-avatar-email-icon",
            label: label || '',
            LEGACY_size: isLozenge ? 'small' : 'medium',
            LEGACY_margin: "0 0 0 -2px",
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        })));
    };
});
parcelRegister("aVnO1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7f41b19bed4136e0$var$_react = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7f41b19bed4136e0$var$_email = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("eRB05")));
    var $7f41b19bed4136e0$var$_email2 = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5bEkJ")));
    function $7f41b19bed4136e0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7f41b19bed4136e0$var$EmailIcon = (props)=>$7f41b19bed4136e0$var$_react.default.createElement($7f41b19bed4136e0$var$_email.default, Object.assign({
            LEGACY_fallbackIcon: $7f41b19bed4136e0$var$_email2.default
        }, props));
    $7f41b19bed4136e0$var$EmailIcon.Name = 'EmailIconMigration';
    var $7f41b19bed4136e0$var$_default = module.exports.default = $7f41b19bed4136e0$var$EmailIcon;
});
parcelRegister("eRB05", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ad22b76beceec928$var$_react = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ad22b76beceec928$var$_UNSAFE_baseNew = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ad22b76beceec928$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ad22b76beceec928$var$EmailIcon = (props)=>$ad22b76beceec928$var$_react.default.createElement($ad22b76beceec928$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 4.97V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v.97m14.5 0V12c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V4.97m14.5 0L8 8.986.75 4.971"/>`
        }, props));
    $ad22b76beceec928$var$EmailIcon.displayName = 'EmailIcon';
    var $ad22b76beceec928$var$_default = module.exports.default = $ad22b76beceec928$var$EmailIcon;
});
parcelRegister("5bEkJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3c6d443366bf8cbb$var$_react = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $3c6d443366bf8cbb$var$_email = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("eRB05")));
    function $3c6d443366bf8cbb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3c6d443366bf8cbb$var$EmailIcon = (props)=>$3c6d443366bf8cbb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
        }, props, {
            newIcon: $3c6d443366bf8cbb$var$_email.default
        }));
    $3c6d443366bf8cbb$var$EmailIcon.displayName = 'EmailIcon';
    var $3c6d443366bf8cbb$var$_default = module.exports.default = $3c6d443366bf8cbb$var$EmailIcon;
});
parcelRegister("5pJx4", function(module, exports) {
    $parcel$export(module.exports, "SizeableAvatar", ()=>$50cd04ab4dcbd6e5$export$44d81a88129649da);
    var $ujWmd;
    var $fwSAz;
    var $5uXOq = parcelRequire("5uXOq");
    var $3smIt;
    class $50cd04ab4dcbd6e5$export$44d81a88129649da extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
            const props = {
                size: (0, (0, parcelRequire("3smIt")).getAvatarSize)(appearance),
                src: src,
                borderColor: 'transparent',
                presence: presence
            };
            return type === 'team' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fwSAz")).default), props) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), props);
        }
    }
});
parcelRegister("fwSAz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cdf5ede1a400c9d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $2w1D3;
    const $6cdf5ede1a400c9d$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $6cdf5ede1a400c9d$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
    function $6cdf5ede1a400c9d$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: "circle",
            ...props,
            size: size,
            src: src,
            testId: `${testId}-team-avatar`
        }, (innerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2w1D3")).TeamAvatarImage), {
                src: src,
                size: size,
                testId: testId,
                ...innerProps
            }));
    }
});
parcelRegister("2w1D3", function(module, exports) {
    $parcel$export(module.exports, "TeamAvatarImage", ()=>$7d2527153712d181$export$ac3673635a5387be);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $vIiRg;
    var $h8cgU;
    function $7d2527153712d181$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7d2527153712d181$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $7d2527153712d181$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
    const $7d2527153712d181$var$ICON_PADDING = 4;
    const $7d2527153712d181$var$avatarDefaultIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        backgroundColor: $7d2527153712d181$var$ICON_COLOR,
        borderRadius: '50%',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $7d2527153712d181$var$nestedAvatarStyles = Object.entries((0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)).reduce((styles, [key, size])=>{
        return {
            ...styles,
            [key]: (0, (0, parcelRequire("f8Sb3")).css)({
                width: `${size}px`,
                height: `${size}px`,
                '& svg': {
                    width: `${size - $7d2527153712d181$var$ICON_PADDING}px`,
                    height: `${size - $7d2527153712d181$var$ICON_PADDING}px`
                }
            })
        };
    }, {});
    const $7d2527153712d181$var$avatarImageStyles = {
        name: "n68006",
        styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
    };
    const $7d2527153712d181$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, ...rest })=>{
        const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            setHasImageErrored(false);
        }, [
            src
        ]);
        if (!src || hasImageErrored) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $7d2527153712d181$var$avatarDefaultIconStyles,
                $7d2527153712d181$var$nestedAvatarStyles[size]
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("h8cgU"))))), {
            label: alt,
            primaryColor: $7d2527153712d181$var$ICON_BACKGROUND,
            secondaryColor: $7d2527153712d181$var$ICON_COLOR,
            testId: testId && `${testId}--team`
        }));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", rest, (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            src: src,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            css: $7d2527153712d181$var$avatarImageStyles,
            onError: ()=>setHasImageErrored(true)
        }));
    };
});
parcelRegister("h8cgU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c78cb3eb85357720$var$_react = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c78cb3eb85357720$var$_peopleGroup = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("fptva")));
    function $c78cb3eb85357720$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c78cb3eb85357720$var$PeopleIcon = (props)=>$c78cb3eb85357720$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
        }, props, {
            newIcon: $c78cb3eb85357720$var$_peopleGroup.default
        }));
    $c78cb3eb85357720$var$PeopleIcon.displayName = 'PeopleIcon';
    var $c78cb3eb85357720$var$_default = module.exports.default = $c78cb3eb85357720$var$PeopleIcon;
});
parcelRegister("4hqZ5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $31ddae7439c341a9$var$_react = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $31ddae7439c341a9$var$_peopleGroup = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("fptva")));
    var $31ddae7439c341a9$var$_people = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("h8cgU")));
    function $31ddae7439c341a9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $31ddae7439c341a9$var$PeopleGroupIcon = (props)=>$31ddae7439c341a9$var$_react.default.createElement($31ddae7439c341a9$var$_peopleGroup.default, Object.assign({
            LEGACY_fallbackIcon: $31ddae7439c341a9$var$_people.default
        }, props));
    $31ddae7439c341a9$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
    var $31ddae7439c341a9$var$_default = module.exports.default = $31ddae7439c341a9$var$PeopleGroupIcon;
});
parcelRegister("fuhQD", function(module, exports) {
    $parcel$export(module.exports, "VerifiedTeamIcon", ()=>$a137cc376204c926$export$d7949f68d31e5edd);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $fGmbh;
    var $3bDjY;
    var $27dJz;
    const $a137cc376204c926$export$d7949f68d31e5edd = ({ size: size, label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, (0, parcelRequire("27dJz")).messages).verifiedIconDefaultTooltip) : undefined;
        return tooltipContent ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            tabIndex: 0,
            role: "button",
            "aria-hidden": "true",
            "data-testid": "verified-team-icon"
        }, ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fGmbh")).default), {
            primaryColor: "var(--ds-icon-accent-blue, #1D7AFC)",
            size: size,
            label: tooltipContent
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fGmbh")).default), {
            primaryColor: "var(--ds-icon-accent-blue, #1D7AFC)",
            size: size,
            label: label
        });
    };
});
parcelRegister("fGmbh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9bd2ad2ea16bb95$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $d9bd2ad2ea16bb95$var$VerifiedIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "33",
            height: "32",
            viewBox: "0 0 33 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        }));
    const $d9bd2ad2ea16bb95$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $d9bd2ad2ea16bb95$var$VerifiedIconGlyph
        });
    var $d9bd2ad2ea16bb95$export$2e2bcd8739ae039 = $d9bd2ad2ea16bb95$var$VerifiedIcon;
});
parcelRegister("27dJz", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$952fb45ddff9712a$export$defe85febe8b728c);
    var $7VHMR;
    const $952fb45ddff9712a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        verifiedIconDefaultTooltip: {
            id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
            defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
            description: 'Tooltip text for the verified team icon'
        }
    });
});
parcelRegister("fIpmY", function(module, exports) {
    $parcel$export(module.exports, "MultiValueContainer", ()=>$0a44bca42d442dd9$export$cf9cf2a30a59265c);
    var $bChGW;
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $ousew;
    var $8fG8p;
    var $3smIt;
    var $jNYXM;
    class $0a44bca42d442dd9$export$cf9cf2a30a59265c extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static getDerivedStateFromProps(nextProps, prevState) {
            return {
                valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
                previousValueSize: prevState.valueSize
            };
        }
        constructor(props){
            super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
                this.timeoutId = window.setTimeout(()=>{
                    const { ref: { current: current } } = this.valueContainerInnerProps;
                    if (current !== null) {
                        const container = (0, ($parcel$interopDefault($7nsd3))).findDOMNode(current);
                        if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                    }
                    this.timeoutId = null;
                });
            }, this.showPlaceholder = ()=>{
                const { selectProps: { value: value } } = this.props;
                return value && value.length > 0;
            }, this.addPlaceholder = (placeholder)=>{
                const children = (0, ($parcel$interopDefault($5uXOq))).Children.map(this.props.children, (child)=>(0, (0, parcelRequire("3smIt")).isChildInput)(child) && this.showPlaceholder() ? (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                        placeholder: placeholder
                    }) : child);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, children);
            }, this.renderChildren = ()=>{
                const { selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
                if (isDisabled) return this.props.children;
                if (addMoreMessage === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("8fG8p")).messages).addMore, (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                });
                return this.addPlaceholder(addMoreMessage);
            }, this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
            this.state = {
                valueSize: 0,
                previousValueSize: 0
            };
            this.valueContainerInnerProps = {
                ref: (0, ($parcel$interopDefault($5uXOq))).createRef()
            };
        }
        componentDidUpdate() {
            const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
            const { isFocused: isFocused } = this.props.selectProps;
            if (valueSize > previousValueSize && isFocused) {
                if (this.timeoutId) {
                    window.clearTimeout(this.timeoutId);
                    this.timeoutId = null;
                }
                this.scrollToBottom();
            }
        }
        componentWillUnmount() {
            if (this.timeoutId) window.clearTimeout(this.timeoutId);
        }
        render() {
            const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
            const props = {
                ...valueContainerProps,
                innerProps: this.valueContainerInnerProps
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNYXM")).default), {
                isEnabled: this.onValueContainerClick,
                onMouseDown: this.onValueContainerClick
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).ValueContainer, props, this.renderChildren()));
        }
    }
});
parcelRegister("jNYXM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4661c12157fe2c0e$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $4661c12157fe2c0e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $4661c12157fe2c0e$var$_ref = {
        name: "1ff36h2",
        styles: "flex-grow:1"
    };
    const $4661c12157fe2c0e$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
        return isEnabled ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $4661c12157fe2c0e$var$_ref,
            onMouseDown: onMouseDown
        }, children) : children;
    };
    var $4661c12157fe2c0e$export$2e2bcd8739ae039 = $4661c12157fe2c0e$var$ValueContainerWrapper;
});
parcelRegister("3QONt", function(module, exports) {
    $parcel$export(module.exports, "Option", ()=>$99bbff5d4b124ec0$export$36d18380658d5d20);
    var $dC5iT;
    var $bChGW;
    var $3bDjY;
    var $5uXOq = parcelRequire("5uXOq");
    var $7SChb;
    var $IMPHa;
    var $8QliZ;
    var $jC9IK;
    var $3SqqV;
    var $f4ndh;
    var $3smIt;
    var $M0UM1;
    const $99bbff5d4b124ec0$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7SChb")).UserOption), {
            user: data,
            status: status,
            isSelected: isSelected
        });
    const $99bbff5d4b124ec0$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
        if ((0, (0, parcelRequire("3smIt")).isExternalUser)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("IMPHa")).default), {
            user: data,
            status: status,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("3smIt")).isUser)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7SChb")).UserOption), {
            user: data,
            status: status,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("3smIt")).isEmail)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3SqqV")).default), {
            email: data,
            emailValidity: (0, (0, parcelRequire("M0UM1")).isValidEmail)(data.id),
            isSelected: isSelected,
            label: selectProps.emailLabel
        });
        if ((0, (0, parcelRequire("3smIt")).isTeam)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8QliZ")).default), {
            team: data,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("3smIt")).isGroup)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jC9IK")).default), {
            group: data,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("3smIt")).isCustom)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4ndh")).default), {
            data: data,
            isSelected: isSelected
        });
        return null;
    };
    const $99bbff5d4b124ec0$var$dataOptionWithTooltip = (props)=>{
        if (props.data?.data?.tooltip) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: props.data?.data?.tooltip
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), tooltipProps, $99bbff5d4b124ec0$var$dataOption(props)));
        return $99bbff5d4b124ec0$var$dataOption(props);
    };
    const $99bbff5d4b124ec0$export$36d18380658d5d20 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Option, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Suspense, {
            fallback: $99bbff5d4b124ec0$var$defaultOption(props)
        }, $99bbff5d4b124ec0$var$dataOptionWithTooltip(props)));
});
parcelRegister("7SChb", function(module, exports) {
    $parcel$export(module.exports, "UserOption", ()=>$f97ab606ddc0972b$export$8e59f78010871662);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $bfXHv;
    var $1Y8bw;
    var $5pJx4;
    var $3smIt;
    class $f97ab606ddc0972b$export$8e59f78010871662 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bfXHv")).AvatarItemOption), {
                avatar: this.renderAvatar(),
                lozenge: this.getLozengeProps(),
                isDisabled: this.props.user.isDisabled,
                primaryText: this.getPrimaryText(),
                secondaryText: this.renderSecondaryText()
            });
        }
        constructor(...args){
            super(...args), this.getPrimaryText = ()=>{
                const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
                const result = [
                    (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                        key: "name",
                        css: (0, (0, parcelRequire("bfXHv")).textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`)
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1Y8bw")).HighlightText), {
                        highlights: highlight && highlight.name
                    }, name))
                ];
                if ((0, (0, parcelRequire("3smIt")).hasValue)(publicName) && name.trim() !== publicName.trim()) result.push((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                    key: "publicName"
                }, ' ', (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: (0, (0, parcelRequire("bfXHv")).textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
                }, "(", (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1Y8bw")).HighlightText), {
                    highlights: highlight && highlight.publicName
                }, publicName), ")")));
                return result;
            }, this.renderSecondaryText = ()=>this.props.user.byline ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: (0, (0, parcelRequire("bfXHv")).textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
                }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
                const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5pJx4")).SizeableAvatar), {
                    appearance: "big",
                    src: avatarUrl,
                    presence: status
                });
            }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                    text: this.props.user.lozenge
                } : this.props.user.lozenge;
        }
    }
});
parcelRegister("bfXHv", function(module, exports) {
    $parcel$export(module.exports, "textWrapper", ()=>$9d51fec62de0f8e9$export$aa6223da92b253dd);
    $parcel$export(module.exports, "AvatarItemOption", ()=>$9d51fec62de0f8e9$export$164a9d9b3b86dd0c);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $lj8SI;
    var $3smIt;
    function $9d51fec62de0f8e9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9d51fec62de0f8e9$var$AsyncTooltip = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("inSCC")).then((module)=>{
            return {
                default: module.default
            };
        }));
    const $9d51fec62de0f8e9$var$wrapper = (isDisabled)=>(0, (0, parcelRequire("f8Sb3")).css)({
            alignItems: 'center',
            boxSizing: 'border-box',
            display: 'flex',
            lineHeight: 1,
            outline: 'none',
            margin: 0,
            width: '100%',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
        });
    const $9d51fec62de0f8e9$var$optionWrapper = {
        name: "yyrqoa",
        styles: "max-width:100%;min-width:0;flex:1 1 100%;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
    };
    const $9d51fec62de0f8e9$var$getTextStyle = (isSecondary)=>{
        const secondaryCssArgs = isSecondary ? {
            fontSize: '0.85em'
        } : {};
        return (0, (0, parcelRequire("f8Sb3")).css)({
            margin: 0,
            overflowX: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...secondaryCssArgs
        });
    };
    const $9d51fec62de0f8e9$var$additionalInfo = {
        name: "tjo4qw",
        styles: "float:right"
    };
    const $9d51fec62de0f8e9$export$aa6223da92b253dd = (color)=>(0, (0, parcelRequire("f8Sb3")).css)({
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'inline',
            color: color
        });
    const $9d51fec62de0f8e9$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
        const renderLozenge = ()=>{
            if ((0, (0, parcelRequire("3smIt")).isLozengeText)(lozenge)) {
                if (lozenge?.tooltip) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Suspense, {
                    fallback: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), lozenge, lozenge.text)
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($9d51fec62de0f8e9$var$AsyncTooltip, {
                    content: lozenge.tooltip
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), lozenge, lozenge.text)));
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), lozenge, lozenge.text);
            }
            return lozenge;
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $9d51fec62de0f8e9$var$wrapper(isDisabled)
        }, avatar, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9d51fec62de0f8e9$var$optionWrapper
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9d51fec62de0f8e9$var$getTextStyle()
        }, primaryText), secondaryText && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9d51fec62de0f8e9$var$getTextStyle(true)
        }, secondaryText))), lozenge && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9d51fec62de0f8e9$var$additionalInfo
        }, renderLozenge())));
    };
});
parcelRegister("1Y8bw", function(module, exports) {
    $parcel$export(module.exports, "HighlightText", ()=>$dbc13bb98bfc2c59$export$bb02e7bc6e1a7119);
    var $5uXOq = parcelRequire("5uXOq");
    class $dbc13bb98bfc2c59$export$bb02e7bc6e1a7119 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { children: children, highlights: highlights } = this.props;
            const parts = [];
            let lastIndex = 0;
            if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
                const lastHighlight = highlights[highlights.length - 1];
                if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
                if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
                return highlights;
            }, []).forEach((highlight)=>{
                const { start: start, end: end } = highlight;
                if (start >= end) return;
                if (start > lastIndex) parts.push({
                    value: children.substring(lastIndex, start),
                    matches: false
                });
                parts.push({
                    value: children.substring(start, end + 1),
                    matches: true
                });
                lastIndex = end + 1;
            });
            if (lastIndex < children.length) parts.push({
                value: children.substring(lastIndex, children.length),
                matches: false
            });
            return parts.map((part, index)=>{
                if (part.matches) return (0, ($parcel$interopDefault($5uXOq))).createElement("b", {
                    key: index
                }, part.value);
                return part.value;
            });
        }
    }
});
parcelRegister("IMPHa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$244ad38dc6a6e0e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $244ad38dc6a6e0e3$var$AsyncExternalUserOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("8ED06")).then((module)=>{
            return {
                default: module.ExternalUserOption
            };
        }));
    var $244ad38dc6a6e0e3$export$2e2bcd8739ae039 = $244ad38dc6a6e0e3$var$AsyncExternalUserOption;
});
parcelRegister("8ED06", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7GjMk")
    ]).then(()=>parcelRequire('358Ik'));
});
parcelRegister("8QliZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e55a6473b89765e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $6e55a6473b89765e$var$AsyncTeamOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("aepOh")).then((module)=>{
            return {
                default: module.TeamOption
            };
        }));
    var $6e55a6473b89765e$export$2e2bcd8739ae039 = $6e55a6473b89765e$var$AsyncTeamOption;
});
parcelRegister("aepOh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bmRp3").then(()=>parcelRequire('8Pt0F'));
});
parcelRegister("jC9IK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d883d47691bcfd0f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $d883d47691bcfd0f$var$AsyncGroupOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("i1qww")).then((module)=>{
            return {
                default: module.GroupOption
            };
        }));
    var $d883d47691bcfd0f$export$2e2bcd8739ae039 = $d883d47691bcfd0f$var$AsyncGroupOption;
});
parcelRegister("i1qww", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("mdJEp").then(()=>parcelRequire('ctysX'));
});
parcelRegister("3SqqV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$120c09dc4c3dec5f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $120c09dc4c3dec5f$var$AsyncEmailOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("bng6R")).then((module)=>{
            return {
                default: module.EmailOption
            };
        }));
    var $120c09dc4c3dec5f$export$2e2bcd8739ae039 = $120c09dc4c3dec5f$var$AsyncEmailOption;
});
parcelRegister("bng6R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("AE9nS").then(()=>parcelRequire('4CChz'));
});
parcelRegister("f4ndh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57cc7ffb924c0e65$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $57cc7ffb924c0e65$var$AsyncCustomOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("3UNwy")).then((module)=>{
            return {
                default: module.CustomOption
            };
        }));
    var $57cc7ffb924c0e65$export$2e2bcd8739ae039 = $57cc7ffb924c0e65$var$AsyncCustomOption;
});
parcelRegister("3UNwy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lQtwe").then(()=>parcelRequire('iphiD'));
});
parcelRegister("M0UM1", function(module, exports) {
    $parcel$export(module.exports, "isValidEmail", ()=>$8e40db00ccd032ac$export$371e338370561054);
    const $8e40db00ccd032ac$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
    const $8e40db00ccd032ac$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
    const $8e40db00ccd032ac$export$371e338370561054 = (inputText)=>{
        if (inputText.match($8e40db00ccd032ac$var$validRegex)) return 'VALID';
        if (inputText.match($8e40db00ccd032ac$var$potentialRegex)) return 'POTENTIAL';
        return 'INVALID';
    };
});
parcelRegister("6Kkci", function(module, exports) {
    $parcel$export(module.exports, "SingleValue", ()=>$667e1159563155af$export$1949dac661ba6e3a);
    var $7sUFC;
    var $f8Sb3;
    var $bChGW;
    var $5pJx4;
    var $3smIt;
    var $fuhQD;
    var $VSDnB;
    var $f5TWP;
    const $667e1159563155af$var$avatarItemComponent = (0, (0, parcelRequire("f8Sb3")).css)({
        border: 'none !important',
        padding: `${"var(--ds-space-0, 0px)"} !important`,
        width: 'auto',
        overflow: 'hidden',
        minWidth: '100px',
        '& > span': {
            boxSizing: 'border-box'
        },
        '&:hover': {
            width: 'auto',
            padding: 0,
            border: 'none'
        }
    });
    const $667e1159563155af$var$ElementAfter = (props)=>{
        const { data: { data: data } } = props;
        if ((0, (0, parcelRequire("3smIt")).isTeam)(data) && data.verified) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fuhQD")).VerifiedTeamIcon), {
            size: "small"
        });
        return null;
    };
    const $667e1159563155af$export$1949dac661ba6e3a = (props)=>{
        const { data: { label: label, data: data }, selectProps: { appearance: appearance, isFocused: isFocused } } = props;
        return !isFocused ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).SingleValue, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7sUFC")).default), {
            backgroundColor: "transparent",
            avatar: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5pJx4")).SizeableAvatar), {
                src: (0, (0, parcelRequire("3smIt")).getAvatarUrl)(data),
                appearance: appearance,
                type: (0, (0, parcelRequire("3smIt")).isTeam)(data) && (0, (0, parcelRequire("VSDnB")).fg)('verified-team-in-user-picker') ? 'team' : 'person'
            }),
            primaryText: (0, (0, parcelRequire("VSDnB")).fg)('verified-team-in-user-picker') ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                alignBlock: "center"
            }, label, (0, (0, parcelRequire("f8Sb3")).jsx)($667e1159563155af$var$ElementAfter, props)) : label
        }, ({ ref: ref, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $667e1159563155af$var$avatarItemComponent,
                ...props
            }))) : null;
    };
});
parcelRegister("7sUFC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fee6a3655f9d2d5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $cgL5K;
    var $k5uoT;
    var $vIiRg;
    var $kyyq3;
    function $0fee6a3655f9d2d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0fee6a3655f9d2d5$var$avatarItemStyles = {
        name: "1dq1lfl",
        styles: "min-width:0;max-width:100%;flex:1 1 100%;line-height:1.4;padding-inline-start:var(--ds-space-100, 8px)"
    };
    const $0fee6a3655f9d2d5$var$secondaryTextOldStyles = {
        name: "1udad45",
        styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.85em"
    };
    const $0fee6a3655f9d2d5$var$baseTextStyles = {
        name: "1sodx6b",
        styles: "display:block;color:var(--ds-text, #172B4D)"
    };
    const $0fee6a3655f9d2d5$var$truncationStyles = {
        name: "n3ut7m",
        styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $0fee6a3655f9d2d5$var$getStyles = (css, { backgroundColor: backgroundColor, isInteractive: isInteractive, isDisabled: isDisabled })=>css`
		align-items: center;
		background-color: ${backgroundColor};
		border-radius: ${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px;
		border: ${0, (0, parcelRequire("vIiRg")).BORDER_WIDTH}px solid transparent;
		box-sizing: border-box;
		color: inherit;
		display: flex;
		font-size: inherit;
		font-style: normal;
		font-weight: normal;
		line-height: 1;
		outline: none;
		margin: ${"var(--ds-space-0, 0px)"};
		padding: ${"var(--ds-space-050, 4px)"};
		text-align: left;
		text-decoration: none;
		width: 100%;

		${isInteractive && `
        :hover {
          background-color: ${`var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`};
          cursor: pointer;
          text-decoration: none;
        }

        :focus {
          outline: none;
          border-color: ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`};
        }

        :active {
          background-color: ${`var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$226de0355ed012f8})`};
        }
      `}

		${isDisabled && `
        cursor: not-allowed;
        opacity: ${"var(--ds-opacity-disabled, 0.5)"};
        pointer-events: none;
      `}
	`;
    const $0fee6a3655f9d2d5$var$AvatarItem = (0, $5uXOq.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', children: children, isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
        const getTestId = (testId, children)=>!children ? {
                'data-testid': `${testId}--itemInner`
            } : {
                testId: `${testId}--itemInner`
            };
        const componentProps = ()=>{
            if (isDisabled) return {
                disabled: true
            };
            return {
                ...href && (0, (0, parcelRequire("kyyq3")).getLinkProps)(href, target),
                ...onClick && !href ? (0, (0, parcelRequire("kyyq3")).getButtonProps)(onClick) : {
                    onClick: onClick
                }
            };
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f8Sb3")).ClassNames), null, ({ css: css })=>{
            const props = {
                ref: ref,
                className: $0fee6a3655f9d2d5$var$getStyles(css, {
                    backgroundColor: backgroundColor,
                    isInteractive: Boolean(onClick || href),
                    isDisabled: isDisabled
                }),
                ...componentProps(),
                ...testId && getTestId(testId, children),
                ...(onClick || href) && {
                    'aria-label': label
                },
                children: (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, avatar, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: $0fee6a3655f9d2d5$var$avatarItemStyles
                }, (0, (0, parcelRequire("VSDnB")).fg)('platform.design-system-team.avatar-item-font-size_830x6') ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
                    maxLines: isTruncationDisabled ? undefined : 1
                }, primaryText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
                    color: "color.text.subtlest",
                    maxLines: isTruncationDisabled ? undefined : 1,
                    size: "UNSAFE_small"
                }, secondaryText)) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: [
                        $0fee6a3655f9d2d5$var$baseTextStyles,
                        !isTruncationDisabled && $0fee6a3655f9d2d5$var$truncationStyles
                    ]
                }, primaryText), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: [
                        $0fee6a3655f9d2d5$var$baseTextStyles,
                        $0fee6a3655f9d2d5$var$secondaryTextOldStyles,
                        !isTruncationDisabled && $0fee6a3655f9d2d5$var$truncationStyles
                    ]
                }, secondaryText))))
            };
            return children ? children(props) : (0, $5uXOq.createElement)((0, (0, parcelRequire("kyyq3")).getCustomElement)(isDisabled, href, onClick), props);
        });
    });
    $0fee6a3655f9d2d5$var$AvatarItem.displayName = 'AvatarItem';
    var $0fee6a3655f9d2d5$export$2e2bcd8739ae039 = $0fee6a3655f9d2d5$var$AvatarItem;
});
parcelRegister("OxpB4", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$98c53988263e2c5c$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    class $98c53988263e2c5c$export$f5b8910cec6cf069 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        get ariaLabelledBy() {
            return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
        }
        get ariaDescribedBy() {
            return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
                ...this.props,
                "aria-labelledby": this.ariaLabelledBy,
                "aria-describedby": this.ariaDescribedBy,
                innerRef: this.props.innerRef,
                onKeyPress: this.handleKeyPress
            });
        }
        constructor(...args){
            super(...args), this.handleKeyPress = (e)=>{
                if (e.key === 'Enter') e.preventDefault();
                if (this.props.selectProps?.disableInput) e.preventDefault();
            };
        }
    }
});
parcelRegister("ee8bl", function(module, exports) {
    $parcel$export(module.exports, "SingleValueContainer", ()=>$bd8914f05f01f9cc$export$afa5f855316c6a48);
    var $bChGW;
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $5pJx4;
    var $2wgOn;
    var $jNYXM;
    function $bd8914f05f01f9cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bd8914f05f01f9cc$var$placeholderIconContainer = (0, (0, parcelRequire("f8Sb3")).css)({
        paddingLeft: (0, (0, parcelRequire("2wgOn")).BORDER_PADDING),
        lineHeight: 0,
        gridArea: '1/1/2/2'
    });
    const $bd8914f05f01f9cc$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
    var $bd8914f05f01f9cc$var$_ref = {
        name: "1ff36h2",
        styles: "flex-grow:1"
    };
    class $bd8914f05f01f9cc$export$afa5f855316c6a48 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { children: children, ...valueContainerProps } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jNYXM")).default), {
                isEnabled: this.onValueContainerClick,
                onMouseDown: this.onValueContainerClick
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ValueContainer, valueContainerProps, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $bd8914f05f01f9cc$var$placeholderIconContainer
            }, this.renderAvatar()), children));
        }
        constructor(...args){
            super(...args), this.renderAvatar = ()=>{
                const { hasValue: hasValue, selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
                if (isFocused || !hasValue) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5pJx4")).SizeableAvatar), {
                    appearance: appearance,
                    type: placeholderAvatar,
                    src: $bd8914f05f01f9cc$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
                });
                return null;
            }, this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
                return this.onValueContainerClick ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: $bd8914f05f01f9cc$var$_ref,
                    onMouseDown: this.onValueContainerClick
                }, children) : children;
            };
        }
    }
});
parcelRegister("h3ej5", function(module, exports) {
    $parcel$export(module.exports, "PopupInput", ()=>$be92b88945d06137$export$d8edbfd510a7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $OxpB4;
    class $be92b88945d06137$export$d8edbfd510a7db82 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidMount() {
            if (this.ref) this.ref.select();
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("OxpB4")).Input), {
                ...this.props,
                innerRef: this.handleInnerRef
            });
        }
        constructor(...args){
            super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
                this.ref = ref;
                if (this.props.innerRef) this.props.innerRef(ref);
            };
        }
    }
});
parcelRegister("6Ks8i", function(module, exports) {
    $parcel$export(module.exports, "PopupControl", ()=>$77b9c0d4ebdf44c2$export$a0cb1b4352357fcc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    var $f8Sb3;
    const $77b9c0d4ebdf44c2$var$spacing = 8;
    const $77b9c0d4ebdf44c2$var$fontSize = 12;
    const $77b9c0d4ebdf44c2$var$innerHeight = $77b9c0d4ebdf44c2$var$spacing * 2;
    const $77b9c0d4ebdf44c2$var$lineHeight = $77b9c0d4ebdf44c2$var$innerHeight / $77b9c0d4ebdf44c2$var$fontSize;
    const $77b9c0d4ebdf44c2$var$controlWrapper = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        flexDirection: 'column',
        padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    });
    const $77b9c0d4ebdf44c2$var$getLabelStyle = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
            fontSize: `${$77b9c0d4ebdf44c2$var$fontSize}px`,
            fontWeight: 600,
            lineHeight: `${$77b9c0d4ebdf44c2$var$lineHeight}`,
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingLeft: "var(--ds-space-0, 0px)",
            paddingRight: "var(--ds-space-0, 0px)",
            paddingTop: "var(--ds-space-250, 20px)"
        });
    class $77b9c0d4ebdf44c2$export$a0cb1b4352357fcc extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { selectProps: { popupTitle: popupTitle } } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $77b9c0d4ebdf44c2$var$controlWrapper
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $77b9c0d4ebdf44c2$var$getLabelStyle()
            }, popupTitle), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, this.props));
        }
    }
});
parcelRegister("lYehz", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$9f291598157d275c$export$d9b273488cd8ce6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    var $f8Sb3;
    const $9f291598157d275c$var$getFooterStyle = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)({
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
        });
    };
    class $9f291598157d275c$export$d9b273488cd8ce6f extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $9f291598157d275c$var$getFooterStyle()
            }, this.props.selectProps.footer));
        }
    }
});
parcelRegister("fuG1P", function(module, exports) {
    $parcel$export(module.exports, "getCreatableProps", ()=>$3865687a924ab788$export$36f97d8afa97203d);
    var $8QpSo;
    var $M0UM1;
    var $3smIt;
    const $3865687a924ab788$var$validOption = [
        'VALID',
        'POTENTIAL'
    ];
    const $3865687a924ab788$var$isValidNewOption = (isValidEmail = (0, (0, parcelRequire("M0UM1")).isValidEmail))=>(inputValue)=>inputValue && $3865687a924ab788$var$validOption.includes(isValidEmail(inputValue));
    const $3865687a924ab788$var$getNewOptionData = (inputValue)=>({
            label: inputValue,
            value: inputValue,
            data: {
                id: inputValue,
                name: inputValue,
                type: (0, $f93312f7d4958f08$export$6662b3461398ef8c)
            }
        });
    const $3865687a924ab788$var$formatCreateLabel = (inputText)=>{
        if (inputText) return inputText.trim();
        return '';
    };
    const $3865687a924ab788$var$isOptionDisabled = (isValidEmail = (0, (0, parcelRequire("M0UM1")).isValidEmail))=>(option)=>{
            if ((0, (0, parcelRequire("3smIt")).isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
            return !!option.isDisabled;
        };
    function $3865687a924ab788$var$creatableProps(isValidEmail) {
        return {
            allowCreateWhileLoading: true,
            createOptionPosition: 'first',
            isValidNewOption: $3865687a924ab788$var$isValidNewOption(isValidEmail),
            getNewOptionData: $3865687a924ab788$var$getNewOptionData,
            formatCreateLabel: $3865687a924ab788$var$formatCreateLabel,
            isOptionDisabled: $3865687a924ab788$var$isOptionDisabled(isValidEmail)
        };
    }
    const $3865687a924ab788$export$36f97d8afa97203d = (0, (0, parcelRequire("8QpSo")).default)($3865687a924ab788$var$creatableProps);
});
parcelRegister("hcX3V", function(module, exports) {
    $parcel$export(module.exports, "getCreatableSuggestedEmailProps", ()=>$fd587de6edc26aae$export$34b9dd2dd6a225e5);
    var $8QpSo;
    var $M0UM1;
    var $3smIt;
    const $fd587de6edc26aae$var$validOption = [
        'VALID',
        'POTENTIAL'
    ];
    const $fd587de6edc26aae$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
    const $fd587de6edc26aae$var$getNewOptionData = (isValidEmail = (0, (0, parcelRequire("M0UM1")).isValidEmail), emailDomain)=>(inputValue)=>{
            if (!inputValue) return null;
            const isEmail = inputValue && $fd587de6edc26aae$var$validOption.includes(isValidEmail(inputValue));
            const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
            return {
                label: value,
                value: value,
                data: {
                    id: value,
                    name: value,
                    type: (0, $f93312f7d4958f08$export$6662b3461398ef8c),
                    suggestion: true
                }
            };
        };
    const $fd587de6edc26aae$var$formatCreateLabel = (inputText)=>{
        if (inputText) return inputText.trim();
        return '';
    };
    const $fd587de6edc26aae$var$isOptionDisabled = (isValidEmail = (0, (0, parcelRequire("M0UM1")).isValidEmail))=>(option)=>{
            if ((0, (0, parcelRequire("3smIt")).isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
            return !!option.isDisabled;
        };
    const $fd587de6edc26aae$export$34b9dd2dd6a225e5 = (0, (0, parcelRequire("8QpSo")).default)((emailDomain, isValidEmail)=>({
            allowCreateWhileLoading: true,
            createOptionPosition: 'last',
            isValidNewOption: $fd587de6edc26aae$var$isValidNewOption,
            getNewOptionData: $fd587de6edc26aae$var$getNewOptionData(isValidEmail, emailDomain),
            formatCreateLabel: $fd587de6edc26aae$var$formatCreateLabel,
            isOptionDisabled: $fd587de6edc26aae$var$isOptionDisabled(isValidEmail)
        }));
});
parcelRegister("hrO1B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ce4a8fbf6631c4e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    var $55C8M;
    const $9ce4a8fbf6631c4e$var$EMPTY = {};
    const $9ce4a8fbf6631c4e$var$useI18n = (locale)=>{
        const [messages, setMessages] = (0, ($parcel$interopDefault($5uXOq))).useState($9ce4a8fbf6631c4e$var$EMPTY);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            let aborted = false;
            setMessages($9ce4a8fbf6631c4e$var$EMPTY);
            (0, (0, parcelRequire("55C8M")).getMessagesForLocale)(locale).then((messages)=>{
                if (!aborted) setMessages(messages);
            }).catch((error)=>{
                console.error(error);
            });
            return ()=>{
                aborted = true;
            };
        }, [
            locale
        ]);
        return messages;
    };
    const $9ce4a8fbf6631c4e$var$MessagesIntlProvider = (props)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { children: children } = props;
        const messages = $9ce4a8fbf6631c4e$var$useI18n(intl.locale);
        const mergedMessages = (0, $5uXOq.useMemo)(()=>{
            return {
                ...intl.messages,
                ...messages
            };
        }, [
            intl.messages,
            messages
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: intl.locale,
            messages: mergedMessages
        }, children);
    };
    var $9ce4a8fbf6631c4e$export$2e2bcd8739ae039 = $9ce4a8fbf6631c4e$var$MessagesIntlProvider;
});
parcelRegister("55C8M", function(module, exports) {
    $parcel$export(module.exports, "getMessagesForLocale", ()=>$0d1c237fd5360db1$export$d0a3169680473b6c);
    const $0d1c237fd5360db1$export$d0a3169680473b6c = async (locale)=>{
        switch(locale){
            case 'cs':
                return (parcelRequire("asouP")).then((mod)=>mod.default);
            case 'da':
                return (parcelRequire("gCFP1")).then((mod)=>mod.default);
            case 'de':
                return (parcelRequire("ctXnR")).then((mod)=>mod.default);
            case 'en':
                return (parcelRequire("dVeZ7")).then((mod)=>mod.default);
            case 'en_GB':
                return (parcelRequire("5wasS")).then((mod)=>mod.default);
            case 'en_ZZ':
                return (parcelRequire("kXvsh")).then((mod)=>mod.default);
            case 'es':
                return (parcelRequire("8wFHw")).then((mod)=>mod.default);
            case 'et':
                return (parcelRequire("42RiL")).then((mod)=>mod.default);
            case 'fi':
                return (parcelRequire("01V88")).then((mod)=>mod.default);
            case 'fr':
                return (parcelRequire("7OhhH")).then((mod)=>mod.default);
            case 'hu':
                return (parcelRequire("ekPaa")).then((mod)=>mod.default);
            case 'is':
                return (parcelRequire("cgaOk")).then((mod)=>mod.default);
            case 'it':
                return (parcelRequire("4Ijhe")).then((mod)=>mod.default);
            case 'ja':
                return (parcelRequire("iO6Ar")).then((mod)=>mod.default);
            case 'ko':
                return (parcelRequire("DNotf")).then((mod)=>mod.default);
            case 'nb':
                return (parcelRequire("h1BPr")).then((mod)=>mod.default);
            case 'nl':
                return (parcelRequire("32FdM")).then((mod)=>mod.default);
            case 'pl':
                return (parcelRequire("6anuW")).then((mod)=>mod.default);
            case 'pt_BR':
            case 'pt-BR':
                return (parcelRequire("coeB4")).then((mod)=>mod.default);
            case 'pt_PT':
            case 'pt-PT':
                return (parcelRequire("4OfGz")).then((mod)=>mod.default);
            case 'ro':
                return (parcelRequire("7jMxK")).then((mod)=>mod.default);
            case 'ru':
                return (parcelRequire("8oKS4")).then((mod)=>mod.default);
            case 'sk':
                return (parcelRequire("lRSYN")).then((mod)=>mod.default);
            case 'sv':
                return (parcelRequire("lfcui")).then((mod)=>mod.default);
            case 'th':
                return (parcelRequire("kC3tY")).then((mod)=>mod.default);
            case 'tr':
                return (parcelRequire("jRqJp")).then((mod)=>mod.default);
            case 'uk':
                return (parcelRequire("hXOFb")).then((mod)=>mod.default);
            case 'vi':
                return (parcelRequire("5mdNh")).then((mod)=>mod.default);
            case 'zh_TW':
                return (parcelRequire("cj5fC")).then((mod)=>mod.default);
            case 'zh':
                return (parcelRequire("kZyWC")).then((mod)=>mod.default);
            default:
                {
                    const fragments = locale.split(/[_-]/);
                    if (fragments.length === 2) return $0d1c237fd5360db1$export$d0a3169680473b6c(fragments[0]);
                    else return (parcelRequire("dVeZ7")).then((mod)=>mod.default);
                }
        }
    };
});
parcelRegister("asouP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5lpPT").then(()=>parcelRequire('gXZJY'));
});
parcelRegister("gCFP1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kfO0l").then(()=>parcelRequire('4a4Fm'));
});
parcelRegister("ctXnR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("e7FWi").then(()=>parcelRequire('l8jlf'));
});
parcelRegister("dVeZ7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("auLKS").then(()=>parcelRequire('8JpVG'));
});
parcelRegister("5wasS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3W1ZK").then(()=>parcelRequire('e3biM'));
});
parcelRegister("kXvsh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Tlspk").then(()=>parcelRequire('dnuc7'));
});
parcelRegister("8wFHw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5X8ey").then(()=>parcelRequire('l3vqz'));
});
parcelRegister("42RiL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bmWXN").then(()=>parcelRequire('4oZES'));
});
parcelRegister("01V88", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bI4uf").then(()=>parcelRequire('2WBzr'));
});
parcelRegister("7OhhH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2H83s").then(()=>parcelRequire('bfZBm'));
});
parcelRegister("ekPaa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lUuxE").then(()=>parcelRequire('1tcJ6'));
});
parcelRegister("cgaOk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eN4os").then(()=>parcelRequire('4duqz'));
});
parcelRegister("4Ijhe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gvuTb").then(()=>parcelRequire('dizwu'));
});
parcelRegister("iO6Ar", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2Li3C").then(()=>parcelRequire('9N5CX'));
});
parcelRegister("DNotf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bh153").then(()=>parcelRequire('aZBlm'));
});
parcelRegister("h1BPr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gdZbx").then(()=>parcelRequire('fGwOM'));
});
parcelRegister("32FdM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aMnvr").then(()=>parcelRequire('NLRKB'));
});
parcelRegister("6anuW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("b7E7V").then(()=>parcelRequire('cHWkp'));
});
parcelRegister("coeB4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bCfU6").then(()=>parcelRequire('d6RJ6'));
});
parcelRegister("4OfGz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5b76P").then(()=>parcelRequire('bPIQC'));
});
parcelRegister("7jMxK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4Qca8").then(()=>parcelRequire('foWaf'));
});
parcelRegister("8oKS4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8ExDS").then(()=>parcelRequire('d41ym'));
});
parcelRegister("lRSYN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("57IRb").then(()=>parcelRequire('77rKe'));
});
parcelRegister("lfcui", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6iyhv").then(()=>parcelRequire('lwY85'));
});
parcelRegister("kC3tY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6FMDk").then(()=>parcelRequire('j3ZnO'));
});
parcelRegister("jRqJp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6583j").then(()=>parcelRequire('I9Pmk'));
});
parcelRegister("hXOFb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hdz1o").then(()=>parcelRequire('h4y14'));
});
parcelRegister("5mdNh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jefTP").then(()=>parcelRequire('6gWmN'));
});
parcelRegister("cj5fC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("j2uQo").then(()=>parcelRequire('haTkv'));
});
parcelRegister("kZyWC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("afbbf").then(()=>parcelRequire('lbgbB'));
});
parcelRegister("2vFqP", function(module, exports) {
    $parcel$export(module.exports, "ExusUserSourceProvider", ()=>$4629e0617f660bbc$export$bcd5c65b586ee3c3);
    $parcel$export(module.exports, "useUserSource", ()=>$4629e0617f660bbc$export$c6c0c1a2bac363f);
    var $5uXOq = parcelRequire("5uXOq");
    const $4629e0617f660bbc$var$ExusUserSourceContext = (0, $5uXOq.createContext)({});
    const $4629e0617f660bbc$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($4629e0617f660bbc$var$ExusUserSourceContext.Provider, {
            value: {
                fetchUserSource: fetchUserSource
            }
        }, children);
    const $4629e0617f660bbc$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
        const { fetchUserSource: fetchUserSource } = (0, $5uXOq.useContext)($4629e0617f660bbc$var$ExusUserSourceContext);
        const [externalSources, setExternalSources] = (0, $5uXOq.useState)([]);
        const [loading, setLoading] = (0, $5uXOq.useState)(true);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const abortController = (0, $5uXOq.useMemo)(()=>{
            if (typeof AbortController === 'undefined') return;
            return new AbortController();
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            let isMounted = true;
            const cleanup = ()=>{
                abortController?.abort();
                isMounted = false;
            };
            if (!fetchUserSource || !shouldFetchSources) {
                setLoading(false);
                return cleanup;
            }
            fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
                if (!isMounted) return;
                setLoading(false);
                const externalSourceTypes = externalSources.map((source)=>source.sourceType);
                setExternalSources(externalSourceTypes);
            }).catch((error)=>{
                if (!isMounted) return;
                setLoading(false);
                setError(error);
            });
            return cleanup;
        }, [
            fetchUserSource,
            accountId,
            abortController,
            shouldFetchSources
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                sources: Array.from(new Set([
                    ...existingSources ?? [],
                    ...externalSources
                ])),
                loading: loading,
                error: error
            }), [
            error,
            existingSources,
            externalSources,
            loading
        ]);
    };
});
parcelRegister("4bzfE", function(module, exports) {
    $parcel$export(module.exports, "useUpdateDriverExperienceStart", ()=>$2aae9539ba1b1e34$export$6e6b386771ff8a93);
    $parcel$export(module.exports, "useUpdateDriverExperienceFail", ()=>$2aae9539ba1b1e34$export$a86702725d24ceba);
    $parcel$export(module.exports, "useUpdateDriverExperienceSuccess", ()=>$2aae9539ba1b1e34$export$ce389ea9709547fd);
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    const $2aae9539ba1b1e34$var$EXPERIENCE_NAME = 'updateJiraVersionDriver';
    const $2aae9539ba1b1e34$var$SOURCE = 'versionDetails';
    const $2aae9539ba1b1e34$export$6e6b386771ff8a93 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: $2aae9539ba1b1e34$var$EXPERIENCE_NAME,
            experienceId: `${Date.now()}`,
            analyticsSource: $2aae9539ba1b1e34$var$SOURCE,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE),
            edition: appEditions.software
        });
    };
    const $2aae9539ba1b1e34$export$a86702725d24ceba = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $2aae9539ba1b1e34$var$EXPERIENCE_NAME
        });
    const $2aae9539ba1b1e34$export$ce389ea9709547fd = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: $2aae9539ba1b1e34$var$EXPERIENCE_NAME
        });
});
parcelRegister("arKXI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aed739763becd855$export$2e2bcd8739ae039);
    var $7VHMR;
    var $aed739763becd855$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unassigned: {
            "id": "software-releases-version-driver-field.unassigned",
            "defaultMessage": "Unassigned"
        },
        fieldLabel: {
            "id": "software-releases-version-driver-field.field-label",
            "defaultMessage": "Driver"
        },
        genericErrorFlagTitle: {
            "id": "software-releases-version-driver-field.generic-error-flag-title",
            "defaultMessage": "We couldn't update the version driver."
        },
        genericErrorFlagDescription: {
            "id": "software-releases-version-driver-field.generic-error-flag-description",
            "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
        }
    });
});
parcelRegister("g08V3", function(module, exports) {
    $parcel$export(module.exports, "VersionSummaryDescription", ()=>$ad3aee83ecbc9ec8$export$e4174f5e9c00a5fc);
    var $kGZk6;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $koVbs;
    var $fstKw;
    var $70dHp;
    const $ad3aee83ecbc9ec8$export$e4174f5e9c00a5fc = ({ jiraVersion: jiraVersion })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("kGZk6")).default), jiraVersion);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ad3aee83ecbc9ec8$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            weight: "bold",
            color: "color.text.subtle",
            as: "p"
        }, formatMessage((0, (0, parcelRequire("70dHp")).default).descriptionHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement($ad3aee83ecbc9ec8$var$DescriptionContainer, {
            "data-testid": "software-releases-version-summary-description.ui.description-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $ad3aee83ecbc9ec8$var$inlinedEditOffsetStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fstKw")).AsyncEditableVersionSummaryDescription), {
            jiraVersion: version,
            shouldTruncateText: true
        }))));
    };
    const $ad3aee83ecbc9ec8$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
    const $ad3aee83ecbc9ec8$var$DescriptionContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
    const $ad3aee83ecbc9ec8$var$inlinedEditOffsetStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.negative.100',
        marginLeft: 'space.negative.100'
    });
});
parcelRegister("kGZk6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b71e583f9b58616f$export$2e2bcd8739ae039);
    const $b71e583f9b58616f$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription"
            }
        ],
        "type": "JiraVersion"
    };
    $b71e583f9b58616f$var$node.hash = "ed1e590e92f538e88d28c5f6bba7c77c";
    var $b71e583f9b58616f$export$2e2bcd8739ae039 = $b71e583f9b58616f$var$node;
});
parcelRegister("fstKw", function(module, exports) {
    $parcel$export(module.exports, "AsyncEditableVersionSummaryDescription", ()=>$2938ef1a3508d069$export$6da629078e9c0cf3);
    var $1kNEw;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $koVbs;
    var $lfTZh;
    var $kxZPA;
    var $jyboW;
    var $bR45R;
    const $2938ef1a3508d069$var$LazyEditableSummaryDescription = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("f1iDp")).then((module)=>module.EditableVersionSummaryDescription), {
        moduleId: "./src/packages/releases/version-summary-description/src/ui/editable-version-summary-description/index.tsx"
    });
    const $2938ef1a3508d069$export$6da629078e9c0cf3 = ({ jiraVersion: jiraVersion, shouldTruncateText: shouldTruncateText })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("1kNEw")).default), jiraVersion);
        const descriptionText = version.description !== '' ? version.description : formatMessage((0, (0, parcelRequire("bR45R")).default).descriptionPlaceholder);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "editable-description",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($2938ef1a3508d069$var$InlineEditReadViewContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jyboW")).DescriptionContent), {
                descriptionText: descriptionText || '',
                isNonEmpty: !!version.description,
                shouldTruncateText: shouldTruncateText
            }))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2938ef1a3508d069$var$LazyEditableSummaryDescription, {
            jiraVersion: version,
            shouldTruncateText: shouldTruncateText
        }));
    };
    const $2938ef1a3508d069$var$InlineEditReadViewContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_189eyh40 _1dqonqa1 _1h6d3acm _vwz4kb7n",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1kNEw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d39e490f9b4c5620$export$2e2bcd8739ae039);
    const $d39e490f9b4c5620$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "description"
            },
            {
                "kind": "FragmentSpread",
                "name": "editableVersionSummaryDescription_softwareReleasesVersionSummaryDescription"
            }
        ],
        "type": "JiraVersion"
    };
    $d39e490f9b4c5620$var$node.hash = "2a90bb83f1ef52be3fdf77ad96c33404";
    var $d39e490f9b4c5620$export$2e2bcd8739ae039 = $d39e490f9b4c5620$var$node;
});
parcelRegister("jyboW", function(module, exports) {
    $parcel$export(module.exports, "DescriptionContent", ()=>$798943a7aef8fd46$export$afe6a96ed909bf0f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $h4EJ8 = parcelRequire("h4EJ8");
    const $798943a7aef8fd46$var$TRUNCATE_TEXT_LENGTH = 300;
    const $798943a7aef8fd46$export$afe6a96ed909bf0f = ({ isNonEmpty: isNonEmpty, shouldTruncateText: shouldTruncateText, descriptionText: descriptionText })=>(0, ($parcel$interopDefault($5uXOq))).createElement($798943a7aef8fd46$var$DescriptionContentContainer, {
            isNonEmpty: isNonEmpty
        }, shouldTruncateText ? (0, ($parcel$interopDefault($h4EJ8)))(descriptionText, {
            length: $798943a7aef8fd46$var$TRUNCATE_TEXT_LENGTH,
            separator: ' '
        }) : descriptionText);
    const $798943a7aef8fd46$var$DescriptionContentContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isNonEmpty: isNonEmpty, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt458a2 _slp31hna _o5726vc6 _vwz4cjiy",
                __cmplp.isNonEmpty ? "_syaz1kw7" : "_syaz1rc1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("h4EJ8", function(module, exports) {
    var $kHBB0 = parcelRequire("kHBB0");
    var $gvFfr = parcelRequire("gvFfr");
    var $axH2S = parcelRequire("axH2S");
    var $k0qYG = parcelRequire("k0qYG");
    var $cErmc = parcelRequire("cErmc");
    var $ifYxh = parcelRequire("ifYxh");
    var $jx6Tp = parcelRequire("jx6Tp");
    var $kPZpS = parcelRequire("kPZpS");
    var $jJVtR = parcelRequire("jJVtR");
    var $c6e266ef199f8e9f$var$DEFAULT_TRUNC_LENGTH = 30, $c6e266ef199f8e9f$var$DEFAULT_TRUNC_OMISSION = '...';
    var $c6e266ef199f8e9f$var$reFlags = /\w*$/;
    function $c6e266ef199f8e9f$var$truncate(string, options) {
        var length = $c6e266ef199f8e9f$var$DEFAULT_TRUNC_LENGTH, omission = $c6e266ef199f8e9f$var$DEFAULT_TRUNC_OMISSION;
        if ($k0qYG(options)) {
            var separator = 'separator' in options ? options.separator : separator;
            length = 'length' in options ? $kPZpS(options.length) : length;
            omission = 'omission' in options ? $kHBB0(options.omission) : omission;
        }
        string = $jJVtR(string);
        var strLength = string.length;
        if ($axH2S(string)) {
            var strSymbols = $jx6Tp(string);
            strLength = strSymbols.length;
        }
        if (length >= strLength) return string;
        var end = length - $ifYxh(omission);
        if (end < 1) return omission;
        var result = strSymbols ? $gvFfr(strSymbols, 0, end).join('') : string.slice(0, end);
        if (separator === undefined) return result + omission;
        if (strSymbols) end += result.length - end;
        if ($cErmc(separator)) {
            if (string.slice(end).search(separator)) {
                var match, substring = result;
                if (!separator.global) separator = RegExp(separator.source, $jJVtR($c6e266ef199f8e9f$var$reFlags.exec(separator)) + 'g');
                separator.lastIndex = 0;
                while(match = separator.exec(substring))var newEnd = match.index;
                result = result.slice(0, newEnd === undefined ? end : newEnd);
            }
        } else if (string.indexOf($kHBB0(separator), end) != end) {
            var index = result.lastIndexOf(separator);
            if (index > -1) result = result.slice(0, index);
        }
        return result + omission;
    }
    module.exports = $c6e266ef199f8e9f$var$truncate;
});
parcelRegister("cErmc", function(module, exports) {
    var $3euyi = parcelRequire("3euyi");
    var $cW28x = parcelRequire("cW28x");
    var $lMQGH = parcelRequire("lMQGH");
    var $935e70fe57caa939$var$nodeIsRegExp = $lMQGH && $lMQGH.isRegExp;
    var $935e70fe57caa939$var$isRegExp = $935e70fe57caa939$var$nodeIsRegExp ? $cW28x($935e70fe57caa939$var$nodeIsRegExp) : $3euyi;
    module.exports = $935e70fe57caa939$var$isRegExp;
});
parcelRegister("3euyi", function(module, exports) {
    var $beQoo = parcelRequire("beQoo");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $25aa60f3dfdc1028$var$regexpTag = '[object RegExp]';
    function $25aa60f3dfdc1028$var$baseIsRegExp(value) {
        return $fC1Kz(value) && $beQoo(value) == $25aa60f3dfdc1028$var$regexpTag;
    }
    module.exports = $25aa60f3dfdc1028$var$baseIsRegExp;
});
parcelRegister("ifYxh", function(module, exports) {
    var $dkmPN = parcelRequire("dkmPN");
    var $axH2S = parcelRequire("axH2S");
    var $61ekh = parcelRequire("61ekh");
    function $d4a895dd16218f22$var$stringSize(string) {
        return $axH2S(string) ? $61ekh(string) : $dkmPN(string);
    }
    module.exports = $d4a895dd16218f22$var$stringSize;
});
parcelRegister("dkmPN", function(module, exports) {
    var $8hdQS = parcelRequire("8hdQS");
    var $9b3edb0cff432526$var$asciiSize = $8hdQS('length');
    module.exports = $9b3edb0cff432526$var$asciiSize;
});
parcelRegister("61ekh", function(module, exports) {
    var $461df2ef275f3803$var$rsAstralRange = '\\ud800-\\udfff', $461df2ef275f3803$var$rsComboMarksRange = '\\u0300-\\u036f', $461df2ef275f3803$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $461df2ef275f3803$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $461df2ef275f3803$var$rsComboRange = $461df2ef275f3803$var$rsComboMarksRange + $461df2ef275f3803$var$reComboHalfMarksRange + $461df2ef275f3803$var$rsComboSymbolsRange, $461df2ef275f3803$var$rsVarRange = '\\ufe0e\\ufe0f';
    var $461df2ef275f3803$var$rsAstral = '[' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsCombo = '[' + $461df2ef275f3803$var$rsComboRange + ']', $461df2ef275f3803$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $461df2ef275f3803$var$rsModifier = '(?:' + $461df2ef275f3803$var$rsCombo + '|' + $461df2ef275f3803$var$rsFitz + ')', $461df2ef275f3803$var$rsNonAstral = '[^' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $461df2ef275f3803$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $461df2ef275f3803$var$rsZWJ = '\\u200d';
    var $461df2ef275f3803$var$reOptMod = $461df2ef275f3803$var$rsModifier + '?', $461df2ef275f3803$var$rsOptVar = '[' + $461df2ef275f3803$var$rsVarRange + ']?', $461df2ef275f3803$var$rsOptJoin = '(?:' + $461df2ef275f3803$var$rsZWJ + '(?:' + [
        $461df2ef275f3803$var$rsNonAstral,
        $461df2ef275f3803$var$rsRegional,
        $461df2ef275f3803$var$rsSurrPair
    ].join('|') + ')' + $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + ')*', $461df2ef275f3803$var$rsSeq = $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + $461df2ef275f3803$var$rsOptJoin, $461df2ef275f3803$var$rsSymbol = '(?:' + [
        $461df2ef275f3803$var$rsNonAstral + $461df2ef275f3803$var$rsCombo + '?',
        $461df2ef275f3803$var$rsCombo,
        $461df2ef275f3803$var$rsRegional,
        $461df2ef275f3803$var$rsSurrPair,
        $461df2ef275f3803$var$rsAstral
    ].join('|') + ')';
    var $461df2ef275f3803$var$reUnicode = RegExp($461df2ef275f3803$var$rsFitz + '(?=' + $461df2ef275f3803$var$rsFitz + ')|' + $461df2ef275f3803$var$rsSymbol + $461df2ef275f3803$var$rsSeq, 'g');
    function $461df2ef275f3803$var$unicodeSize(string) {
        var result = $461df2ef275f3803$var$reUnicode.lastIndex = 0;
        while($461df2ef275f3803$var$reUnicode.test(string))++result;
        return result;
    }
    module.exports = $461df2ef275f3803$var$unicodeSize;
});
parcelRegister("bR45R", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$052fa8361354cd40$export$2e2bcd8739ae039);
    var $7VHMR;
    var $052fa8361354cd40$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        descriptionPlaceholder: {
            "id": "software-releases-version-summary-description.editable-version-summary-description.description-placeholder",
            "defaultMessage": "No description added yet."
        },
        errorFlagTitle: {
            "id": "software-releases-version-summary-description.editable-version-summary-description.error-flag-title",
            "defaultMessage": "We couldn't update the description"
        },
        errorFlagDescription: {
            "id": "software-releases-version-summary-description.editable-version-summary-description.error-flag-description",
            "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
        },
        maxDescriptionSizeExceededErrorMessage: {
            "id": "software-releases-version-summary-description.editable-version-summary-description.max-description-size-exceeded-error-message",
            "defaultMessage": "Maximum description size exceeded"
        }
    });
});
parcelRegister("f1iDp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cwoIG").then(()=>parcelRequire('dwy4h'));
});
parcelRegister("70dHp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b29ed7df0af346b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5b29ed7df0af346b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        descriptionHeader: {
            "id": "software-releases-version-summary-description.description-header",
            "defaultMessage": "Description"
        }
    });
});
parcelRegister("gBkhv", function(module, exports) {
    $parcel$export(module.exports, "ARCHIVED", ()=>$8aa3067a3c7cf7a5$export$c936349447a77fe0);
    $parcel$export(module.exports, "RELEASED", ()=>$8aa3067a3c7cf7a5$export$b983f2cb1f658a55);
    $parcel$export(module.exports, "UNARCHIVED", ()=>$8aa3067a3c7cf7a5$export$5813036ca984d7f3);
    $parcel$export(module.exports, "UNRELEASED", ()=>$8aa3067a3c7cf7a5$export$cb459d726a8530a5);
    $parcel$export(module.exports, "FIRST_COLUMN_MIN_WIDTH", ()=>$8aa3067a3c7cf7a5$export$f6fe47beb5520aca);
    $parcel$export(module.exports, "SUPPORT_DOCS_LINK_URL", ()=>$8aa3067a3c7cf7a5$export$cfcb17c409b4e552);
    var $gwIPs;
    const $8aa3067a3c7cf7a5$export$c936349447a77fe0 = 'ARCHIVED';
    const $8aa3067a3c7cf7a5$export$b983f2cb1f658a55 = 'RELEASED';
    const $8aa3067a3c7cf7a5$export$5813036ca984d7f3 = 'UNARCHIVED';
    const $8aa3067a3c7cf7a5$export$cb459d726a8530a5 = 'UNRELEASED';
    const $8aa3067a3c7cf7a5$export$f6fe47beb5520aca = (0, (0, parcelRequire("gwIPs")).gridSize) * 23;
    const $8aa3067a3c7cf7a5$export$cfcb17c409b4e552 = 'https://support.atlassian.com/jira-software-cloud/docs/reference-issues-in-your-development-work/';
    var $8aa3067a3c7cf7a5$export$2e2bcd8739ae039 = [
        $8aa3067a3c7cf7a5$export$c936349447a77fe0,
        $8aa3067a3c7cf7a5$export$b983f2cb1f658a55,
        $8aa3067a3c7cf7a5$export$cb459d726a8530a5,
        $8aa3067a3c7cf7a5$export$5813036ca984d7f3
    ];
});
parcelRegister("6eRDX", function(module, exports) {
    $parcel$export(module.exports, "NonCriticalErrorBoundary", ()=>$e749b88b050e49c5$export$1625b7ea4c7a5a23);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    const $e749b88b050e49c5$export$1625b7ea4c7a5a23 = ({ fallback: fallback, eventLocation: eventLocation, children: children, onError: onError })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: fallback,
            packageName: "jiraSoftwareReleasesLaunchCard",
            teamName: "fusion-solaris",
            id: eventLocation,
            onError: onError
        }, children);
});
parcelRegister("gl90z", function(module, exports) {
    $parcel$export(module.exports, "LatestDeployment", ()=>$91f9e25791539622$export$4c54e4ee90dcb7e7);
    var $UvyUC;
    var $geUds;
    var $4R3aq;
    var $klqAj;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $luuSM;
    var $54a0z;
    var $8Uumt = parcelRequire("8Uumt");
    var $3bDjY;
    var $btzsC;
    var $koVbs;
    var $lfTZh;
    var $8zOmE;
    var $2NMNM;
    var $4R3aq;
    var $hDzhb;
    var $gBkhv;
    var $03FyW;
    var $dkZ1c;
    var $cD7pF;
    var $ghVnF;
    var $dGKnO;
    const $91f9e25791539622$export$9fbf3675ff70ff0 = ({ jiraVersion: jiraVersion, queryReference: queryReference })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const deploymentsRoute = (0, (0, parcelRequire("03FyW")).useDeploymentsRoute)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("klqAj")).default), jiraVersion);
        const isMoreThanAWeekApart = (a, b)=>{
            const oneWeekInMilliseconds = 604800000;
            return (0, (0, parcelRequire("luuSM")).default)(a, b) > oneWeekInMilliseconds;
        };
        const data = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("4R3aq")).default), queryReference);
        const deploymentNodes = data.devOps.ariGraph.relationships.edges.filter(Boolean).map((edge)=>edge.node);
        const renderLink = (content, hasNoRecentDeployments)=>hasNoRecentDeployments ? (0, ($parcel$interopDefault($5uXOq))).createElement($91f9e25791539622$var$StyledLink, {
                href: (0, (0, parcelRequire("gBkhv")).SUPPORT_DOCS_LINK_URL),
                onClick: ()=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'link'
                    }), 'latestDeploymentInVersion');
                },
                target: "_blank"
            }, content) : (0, ($parcel$interopDefault($5uXOq))).createElement($91f9e25791539622$var$StyledLink, {
                onClick: ()=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'link'
                    }), 'latestDeploymentInVersion');
                },
                prefetch: "hover",
                params: {
                    projectKey: version.project.key
                },
                query: {
                    startDate: '-3m',
                    endDate: 'now',
                    fixVersions: version.name
                },
                to: deploymentsRoute
            }, content);
        const latestDeployment = deploymentNodes[0]?.to.data;
        const hasNoDeploymentInLastWeek = latestDeployment?.lastUpdated ? isMoreThanAWeekApart(new Date(), new Date(latestDeployment.lastUpdated)) : true;
        let linkContent = null;
        if (latestDeployment == null) linkContent = formatMessage((0, (0, parcelRequire("ghVnF")).default).noDeployments);
        else if (latestDeployment.lastUpdated !== undefined) {
            if (hasNoDeploymentInLastWeek) linkContent = formatMessage((0, (0, parcelRequire("ghVnF")).default).noDeployments);
            else linkContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("ghVnF")).default).lastDeployment), (0, (0, parcelRequire("54a0z")).default)(new Date(latestDeployment.lastUpdated), new Date(), {
                addSuffix: true,
                roundingMethod: 'floor'
            }));
        }
        const [providersListQuery, loadProvidersListQuery] = (0, (0, parcelRequire("dGKnO")).useLoadProvidersListQuery)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            component: $91f9e25791539622$var$CustomTooltip,
            content: hasNoDeploymentInLastWeek && providersListQuery ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dGKnO")).ProvidersList), {
                queryReference: providersListQuery
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dkZ1c")).DeploymentTooltipContent), {
                jiraVersion: version,
                deployment: latestDeployment
            }),
            onShow: (analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, hasNoDeploymentInLastWeek && providersListQuery ? 'latestDeploymentInVersionProvidersTooltip' : 'latestDeploymentInVersionDetailsTooltip');
            }
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement($91f9e25791539622$var$Wrapper, {
                ...tooltipProps,
                onMouseOver: (event)=>{
                    tooltipProps.onMouseOver(event);
                    if (hasNoDeploymentInLastWeek) loadProvidersListQuery();
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cD7pF")).PulseIcon), null), linkContent && renderLink(linkContent, latestDeployment == null || hasNoDeploymentInLastWeek)));
    };
    const $91f9e25791539622$export$4c54e4ee90dcb7e7 = ({ jiraVersion: jiraVersion, preconditionQueryRef: preconditionQueryRef })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("geUds")).default), jiraVersion);
        const { jira: { deploymentsFeaturePreconditionByProjectKey: deploymentsFeaturePreconditionByProjectKey } } = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("UvyUC")).default), preconditionQueryRef);
        const [queryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("4R3aq")).default));
        (0, $5uXOq.useEffect)(()=>{
            if (deploymentsFeaturePreconditionByProjectKey === 'ALL_SATISFIED') loadQuery({
                from: version.id
            });
        }, [
            deploymentsFeaturePreconditionByProjectKey,
            version.id,
            loadQuery
        ]);
        return deploymentsFeaturePreconditionByProjectKey === 'ALL_SATISFIED' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "latest-deployment-content",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($91f9e25791539622$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cD7pF")).PulseIcon), null), formatMessage((0, (0, parcelRequire("ghVnF")).default).loading))
        }, queryRef && (0, ($parcel$interopDefault($5uXOq))).createElement($91f9e25791539622$export$9fbf3675ff70ff0, {
            jiraVersion: version,
            queryReference: queryRef
        })) : null;
    };
    const $91f9e25791539622$var$StyledLink = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1fxt _9h8h1fxt _f8pj1fxt _v0vw1fxt _30l31fxt",
                __cmplp.className
            ])
        });
    });
    const $91f9e25791539622$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4cvr1h6o _11q71yrq _1e0c1txw _zulpu2gc _1yt44ar7",
                __cmplp.className
            ])
        });
    });
    const $91f9e25791539622$var$CustomTooltip = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("btzsC")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1l7b _16qsjdvv _vchh18uv _bfhkvuon",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("geUds", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$033bc7b24a5f0035$export$2e2bcd8739ae039);
    const $033bc7b24a5f0035$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "latestDeployment_softwareReleasesLaunchCard_jiraVersion",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "FragmentSpread",
                "name": "latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion"
            }
        ],
        "type": "JiraVersion"
    };
    $033bc7b24a5f0035$var$node.hash = "9635192fd480eb66a7ef3d1c281498c0";
    var $033bc7b24a5f0035$export$2e2bcd8739ae039 = $033bc7b24a5f0035$var$node;
});
parcelRegister("4R3aq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80ab4a8ad9cdb291$export$2e2bcd8739ae039);
    const $80ab4a8ad9cdb291$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "from"
            }
        ], v1 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            },
            {
                "kind": "Variable",
                "name": "from",
                "variableName": "from"
            },
            {
                "kind": "Literal",
                "name": "sort",
                "value": {
                    "lastUpdatedSortDirection": "DESC"
                }
            },
            {
                "kind": "Literal",
                "name": "type",
                "value": "version-associated-deployment"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "lastUpdated"
        }, v3 = {
            "kind": "ScalarField",
            "name": "id"
        }, v4 = [
            v3
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "latestDeploymentForVersionQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "DevOps",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "AriGraph",
                                        "kind": "LinkedField",
                                        "name": "ariGraph",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "args": v1,
                                                    "concreteType": "AriGraphRelationshipConnection",
                                                    "kind": "LinkedField",
                                                    "name": "relationships",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "AriGraphRelationshipEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "AriGraphRelationship",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": {
                                                                                        "concreteType": "AriGraphRelationshipNode",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "to",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "data",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "RequiredField",
                                                                                                                    "field": v2,
                                                                                                                    "action": "THROW",
                                                                                                                    "path": "devOps.ariGraph.relationships.edges.node.to.data.lastUpdated"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "FragmentSpread",
                                                                                                                    "name": "deploymentTooltipContent_softwareReleasesLaunchCard_deployment"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "DeploymentSummary"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                "action": "THROW",
                                                                                                "path": "devOps.ariGraph.relationships.edges.node.to.data"
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    "action": "THROW",
                                                                                    "path": "devOps.ariGraph.relationships.edges.node.to"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "devOps.ariGraph.relationships.edges.node"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "devOps.ariGraph.relationships.edges"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "devOps.ariGraph.relationships"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "devOps.ariGraph"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "devOps"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "latestDeploymentForVersionQuery",
                "selections": [
                    {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "AriGraph",
                                "kind": "LinkedField",
                                "name": "ariGraph",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v1,
                                        "concreteType": "AriGraphRelationshipConnection",
                                        "kind": "LinkedField",
                                        "name": "relationships",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "AriGraphRelationshipEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "AriGraphRelationship",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AriGraphRelationshipNode",
                                                                "kind": "LinkedField",
                                                                "name": "to",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "data",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "__typename"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v2,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "state"
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "DevOpsEnvironment",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "environment",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "displayName"
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "category"
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "issueIds"
                                                                                    }
                                                                                ],
                                                                                "type": "DeploymentSummary"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "Node",
                                                                                "abstractKey": "__isNode"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "ConfluencePage"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "ConfluenceSpace"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "DevOpsFeatureFlag"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "DevOpsOperationsComponentDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "DevOpsOperationsIncidentDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "DevOpsPullRequestDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "DevOpsRepository"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "DevOpsSecurityVulnerabilityDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "JiraConfluenceRemoteIssueLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "JiraCustomRemoteIssueLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "JiraIssueRemoteIssueLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v4,
                                                                                "type": "JiraWebRemoteIssueLink"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v3
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "1f22a1f87c0835eeb644c45a7e790c9dcb473ce5783334aed5e082d45ceeac51",
                "metadata": {},
                "name": "latestDeploymentForVersionQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $80ab4a8ad9cdb291$var$node.hash = "804051e6b542c6dc7bf401419bdfe7f9";
    var $80ab4a8ad9cdb291$export$2e2bcd8739ae039 = $80ab4a8ad9cdb291$var$node;
});
parcelRegister("klqAj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$117270fca72ec8b5$export$2e2bcd8739ae039);
    const $117270fca72ec8b5$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "name"
                },
                "action": "THROW",
                "path": "name"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            "action": "THROW",
                            "path": "project.key"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            },
            {
                "kind": "FragmentSpread",
                "name": "deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion"
            }
        ],
        "type": "JiraVersion"
    };
    $117270fca72ec8b5$var$node.hash = "636e16e48d5710e3c9d238bef208f75d";
    var $117270fca72ec8b5$export$2e2bcd8739ae039 = $117270fca72ec8b5$var$node;
});
parcelRegister("03FyW", function(module, exports) {
    $parcel$export(module.exports, "useDeploymentsRoute", ()=>$4968c408415eacbe$export$7a17d870b2f984df);
    var $65Ltd;
    var $6jY6G;
    var $dAfqg;
    const $4968c408415eacbe$export$7a17d870b2f984df = ()=>{
        const { data: project } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const routeName = project?.simplified ? (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS) : (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC);
        return (0, (0, parcelRequire("6jY6G")).useRouteByName)(routeName) ?? routeName;
    };
});
parcelRegister("dkZ1c", function(module, exports) {
    $parcel$export(module.exports, "DeploymentTooltipContent", ()=>$a763509018e8b0e4$export$c36a118f96728a11);
    var $6XgBh;
    var $4zXYN;
    var $5uXOq = parcelRequire("5uXOq");
    var $54a0z;
    var $8Uumt = parcelRequire("8Uumt");
    var $lj8SI;
    var $dC5iT;
    var $f5TWP;
    var $cgL5K;
    var $8CUq3;
    var $ifS9h;
    var $koVbs;
    var $8zOmE;
    var $gYpv9;
    var $hDzhb;
    var $03FyW;
    var $g2uF3;
    var $e2lGD;
    const $a763509018e8b0e4$export$c36a118f96728a11 = ({ deployment: deployment, jiraVersion: jiraVersion })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("4zXYN")).default), jiraVersion);
        const { lastUpdated: lastUpdated, environment: environment, state: state, issueIds: issueIds } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("6XgBh")).default), deployment);
        const deploymentsRoute = (0, (0, parcelRequire("03FyW")).useDeploymentsRoute)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifS9h")).PopupContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifS9h")).PopupHeader), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifS9h")).PopupTitle), null, formatMessage((0, (0, parcelRequire("g2uF3")).default).deploymentPopupTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $a763509018e8b0e4$var$headerStatusIconAndLozengeStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $a763509018e8b0e4$var$headerStatusIconStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYpv9")).DeploymentIcons), {
            deploymentState: (0, (0, parcelRequire("e2lGD")).mapDeploymentState)(state, environment.category),
            size: "medium"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: (0, (0, parcelRequire("e2lGD")).mapStateToLozengeProp)(state)
        }, state))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifS9h")).LinkContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $a763509018e8b0e4$var$environmentStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p",
            weight: "bold"
        }, (0, (0, parcelRequire("e2lGD")).capitalizeOnlyFirstLetter)(environment.category), environment.displayName ? ` (${environment.displayName})` : ''))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $a763509018e8b0e4$var$environmentDetailStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p",
            size: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, (0, (0, parcelRequire("54a0z")).default)(new Date(lastUpdated), new Date(), {
            addSuffix: true,
            roundingMethod: 'floor'
        })), issueIds == null ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $a763509018e8b0e4$var$environmentDetailBetweenMarginStyles
        }, "\u2022"), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $a763509018e8b0e4$var$environmentDetailBetweenMarginStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "small"
        }, formatMessage((0, (0, parcelRequire("g2uF3")).default).issuesDeployed, {
            issueCount: issueIds.length
        })))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifS9h")).PopupOverflowSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifS9h")).PopupKeyline), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifS9h")).PopupOverflowButton), {
            component: (0, (0, parcelRequire("hDzhb")).default),
            appearance: "link",
            prefetch: "hover",
            params: {
                projectKey: version.project.key
            },
            query: {
                startDate: '-3m',
                endDate: 'now',
                fixVersions: version.name
            },
            to: deploymentsRoute,
            onClick: (_, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'latestDeploymentInVersionDetailsTooltipLink');
            }
        }, formatMessage((0, (0, parcelRequire("g2uF3")).default).viewAllDeployments))));
    };
    const $a763509018e8b0e4$var$headerStatusIconAndLozengeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: 1,
        justifyContent: 'end',
        alignItems: 'center'
    });
    const $a763509018e8b0e4$var$headerStatusIconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.100',
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $a763509018e8b0e4$var$environmentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.100'
    });
    const $a763509018e8b0e4$var$environmentDetailStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '16px',
        lineHeight: '16px',
        marginBottom: 'space.100',
        marginTop: 'space.0'
    });
    const $a763509018e8b0e4$var$environmentDetailBetweenMarginStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.050'
    });
});
parcelRegister("6XgBh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3fd499661a3b0105$export$2e2bcd8739ae039);
    const $3fd499661a3b0105$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "deploymentTooltipContent_softwareReleasesLaunchCard_deployment",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "state"
                },
                "action": "THROW",
                "path": "state"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "DevOpsEnvironment",
                    "kind": "LinkedField",
                    "name": "environment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "category"
                            },
                            "action": "THROW",
                            "path": "environment.category"
                        }
                    ]
                },
                "action": "THROW",
                "path": "environment"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "lastUpdated"
                },
                "action": "THROW",
                "path": "lastUpdated"
            },
            {
                "kind": "ScalarField",
                "name": "issueIds"
            }
        ],
        "type": "DeploymentSummary"
    };
    $3fd499661a3b0105$var$node.hash = "f474689f31fc91d3dfb760e1b811618d";
    var $3fd499661a3b0105$export$2e2bcd8739ae039 = $3fd499661a3b0105$var$node;
});
parcelRegister("4zXYN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba42f4c620d2cfe5$export$2e2bcd8739ae039);
    const $ba42f4c620d2cfe5$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "name"
                },
                "action": "THROW",
                "path": "name"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            "action": "THROW",
                            "path": "project.key"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            }
        ],
        "type": "JiraVersion"
    };
    $ba42f4c620d2cfe5$var$node.hash = "fc05ee90d6c0521ade9b87e6185e0b92";
    var $ba42f4c620d2cfe5$export$2e2bcd8739ae039 = $ba42f4c620d2cfe5$var$node;
});
parcelRegister("ifS9h", function(module, exports) {
    $parcel$export(module.exports, "PopupContainer", ()=>$88fc3594fd7e78a2$export$cca08eed9de89ba9);
    $parcel$export(module.exports, "LinkContainer", ()=>$88fc3594fd7e78a2$export$af2ec3aa21d10ab7);
    $parcel$export(module.exports, "PopupHeader", ()=>$88fc3594fd7e78a2$export$b11ea9d6e8111404);
    $parcel$export(module.exports, "StyledDate", ()=>$88fc3594fd7e78a2$export$30301703d55848e7);
    $parcel$export(module.exports, "RepositoryInfo", ()=>$88fc3594fd7e78a2$export$fde5e3d077213a6f);
    $parcel$export(module.exports, "PopupTitle", ()=>$88fc3594fd7e78a2$export$b834616c6081368f);
    $parcel$export(module.exports, "StyledLink", ()=>$88fc3594fd7e78a2$export$9048d548939551ee);
    $parcel$export(module.exports, "PopupOverflowSection", ()=>$88fc3594fd7e78a2$export$9e3158dc6a3a0f92);
    $parcel$export(module.exports, "PopupKeyline", ()=>$88fc3594fd7e78a2$export$a0765d4427758c62);
    $parcel$export(module.exports, "PopupOverflowButton", ()=>$88fc3594fd7e78a2$export$aeb11758c9d29e5c);
    $parcel$export(module.exports, "TimeDisplay", ()=>$88fc3594fd7e78a2$export$9b3df3d60caed5f9);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $l1N8i;
    var $41j30;
    const $88fc3594fd7e78a2$export$cca08eed9de89ba9 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4pxbi _1bsbnklw _1tkeys9h _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$af2ec3aa21d10ab7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _otyr1b66",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$b11ea9d6e8111404 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$30301703d55848e7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1wmz _otyridpf _1e0c1txw _o5724jg8",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$fde5e3d077213a6f = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1wmz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5724jg8",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$80b51772092eddc0 = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1wmz _1p1dangw _otyr1b66",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$b834616c6081368f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xxsmall",
            as: "div"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($88fc3594fd7e78a2$export$80b51772092eddc0, props));
    const $88fc3594fd7e78a2$export$9048d548939551ee = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("41j30")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81doa _k48p1igg _syaz1y58 _otyru2gc",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$9e3158dc6a3a0f92 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkpxbi",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$a0765d4427758c62 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3it94y _bfhk1wws _otyrutpp",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$aeb11758c9d29e5c = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yxxidpf _12r21nn1 _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf",
                __cmplp.className
            ])
        });
    });
    const $88fc3594fd7e78a2$export$9b3df3d60caed5f9 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66 _80omtlke",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("41j30", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c2f3c33a6194375$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8oe80;
    var $hDzhb;
    function $7c2f3c33a6194375$var$Link(props) {
        const { children: children, ...rest } = props;
        delete rest.createAnalyticsEvent;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), rest, children);
    }
    var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('link', {
        onClick: 'clicked'
    })($7c2f3c33a6194375$var$Link);
});
parcelRegister("gYpv9", function(module, exports) {
    $parcel$export(module.exports, "DeploymentIcons", ()=>$d467b0cdb29c9a92$export$5202eabf0ef214b4);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gtRBF;
    var $bnW55;
    var $8hIiD;
    var $bdG8F;
    var $huvAp;
    var $lgFQN;
    var $6TrDT;
    var $5gD09;
    var $aH4Tr;
    const $d467b0cdb29c9a92$export$16b26cd5e98d9100 = (state)=>{
        switch(state){
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).PENDING:
                return 0, (0, parcelRequire("bdG8F")).default;
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).IN_PROGRESS:
                return 0, (0, parcelRequire("8hIiD")).default;
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).SUCCESSFUL:
                return 0, (0, parcelRequire("6TrDT")).default;
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).SUCCESSFULNONPRODUCTION:
                return 0, (0, parcelRequire("lgFQN")).default;
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).CANCELLED:
                return 0, (0, parcelRequire("gtRBF")).default;
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).FAILED:
                return 0, (0, parcelRequire("bnW55")).default;
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).ROLLED_BACK:
                return 0, (0, parcelRequire("huvAp")).default;
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).UNKNOWN:
                return 0, (0, parcelRequire("aH4Tr")).default;
            default:
                throw Error(`Unhandled deployment state - ${state}`);
        }
    };
    const $d467b0cdb29c9a92$export$c7835fd8b8ca1d68 = {
        width: '20',
        height: '20',
        padding: '2'
    };
    const $d467b0cdb29c9a92$export$148e312beb132853 = {
        width: '16',
        height: '16',
        padding: '0'
    };
    const $d467b0cdb29c9a92$export$31b21d0167753bb4 = (state)=>{
        switch(state){
            case 'small':
                return $d467b0cdb29c9a92$export$148e312beb132853;
            case 'medium':
                return $d467b0cdb29c9a92$export$c7835fd8b8ca1d68;
            default:
                return $d467b0cdb29c9a92$export$148e312beb132853;
        }
    };
    const $d467b0cdb29c9a92$export$5202eabf0ef214b4 = ({ deploymentState: deploymentState, size: size })=>{
        const Icon = $d467b0cdb29c9a92$export$16b26cd5e98d9100(deploymentState);
        const iconSize = $d467b0cdb29c9a92$export$31b21d0167753bb4(size);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($d467b0cdb29c9a92$var$Wrapper, {
            "data-testid": `software-deployments-icons-common.ui.wrapper-${deploymentState}`,
            width: iconSize.width,
            height: iconSize.height,
            padding: iconSize.padding
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, null));
    };
    const $d467b0cdb29c9a92$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { padding: padding, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width, "px"),
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height, "px"),
                "--_fl6vf6": (0, (0, parcelRequire("lD23V")).default)(__cmplp.padding, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1rkg _4t3i1474 _19pk1wug _2hwxidpf _otyr1wug _18u0idpf _1yt4gesh",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("gtRBF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2518052977c9ef6c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $2518052977c9ef6c$var$cancelledIcon = `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y300})`;
    const $2518052977c9ef6c$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`;
    const $2518052977c9ef6c$var$CancelledIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            fill: "none",
            viewBox: "0 0 16 16"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            r: "7",
            cx: "8",
            cy: "8",
            fill: $2518052977c9ef6c$var$backgroundColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M4.184 9h8V7h-8v2zm11.367-4.102a8.039 8.039 0 0 0-1.703-2.546A8.122 8.122 0 0 0 11.293.641 7.769 7.769 0 0 0 8.184 0a7.789 7.789 0 0 0-3.102.633 8.043 8.043 0 0 0-2.547 1.703A8.11 8.11 0 0 0 .824 4.891 7.747 7.747 0 0 0 .184 8c0 1.083.211 2.117.632 3.102.422.984.99 1.833 1.704 2.546a8.084 8.084 0 0 0 2.554 1.711 7.766 7.766 0 0 0 3.11.641 7.788 7.788 0 0 0 3.101-.633 8.043 8.043 0 0 0 2.547-1.703 8.133 8.133 0 0 0 1.711-2.555A7.765 7.765 0 0 0 16.184 8a7.796 7.796 0 0 0-.633-3.102z",
            fill: $2518052977c9ef6c$var$cancelledIcon,
            fillRule: "evenodd"
        }));
    $2518052977c9ef6c$var$CancelledIcon.displayName = 'CancelledIcon';
    var $2518052977c9ef6c$export$2e2bcd8739ae039 = $2518052977c9ef6c$var$CancelledIcon;
});
parcelRegister("bnW55", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8632fcaa6429e476$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $8632fcaa6429e476$var$failedColor = `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R400})`;
    const $8632fcaa6429e476$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`;
    const $8632fcaa6429e476$var$FailedIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            fill: "none",
            viewBox: "0 0 16 16"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            r: "6",
            cx: "8",
            cy: "8",
            fill: $8632fcaa6429e476$var$backgroundColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: $8632fcaa6429e476$var$failedColor,
            fillRule: "evenodd",
            d: "M.768 9.768a2.5 2.5 0 010-3.536L6.232.768a2.5 2.5 0 013.536 0l5.464 5.464a2.5 2.5 0 010 3.536l-5.464 5.464a2.5 2.5 0 01-3.536 0L.768 9.768zM7 4a1 1 0 112 0v4a1 1 0 01-2 0V4zm1 8a1 1 0 100-2 1 1 0 000 2z",
            clipRule: "evenodd"
        }));
    $8632fcaa6429e476$var$FailedIcon.displayName = 'FailedIcon';
    var $8632fcaa6429e476$export$2e2bcd8739ae039 = $8632fcaa6429e476$var$FailedIcon;
});
parcelRegister("8hIiD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4327c88dccf550c9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $4327c88dccf550c9$var$inProgressColor = `var(--ds-icon-information, ${(0, $829f609a65d26a98$exports).B300})`;
    const $4327c88dccf550c9$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`;
    const $4327c88dccf550c9$var$InProgressIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($4327c88dccf550c9$var$SpinningSvg, {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            fill: "none",
            viewBox: "0 0 16 16"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            r: "7",
            cx: "8",
            cy: "8",
            fill: $4327c88dccf550c9$var$backgroundColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: $4327c88dccf550c9$var$inProgressColor,
            d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 12.444A4.445 4.445 0 013.556 8a.889.889 0 111.777 0A2.667 2.667 0 008 10.667a.888.888 0 110 1.777zm3.556-3.555a.889.889 0 01-.89-.889A2.667 2.667 0 008 5.333a.889.889 0 010-1.777A4.445 4.445 0 0112.444 8a.888.888 0 01-.888.889z"
        }));
    $4327c88dccf550c9$var$InProgressIcon.displayName = 'InProgressIcon';
    var $4327c88dccf550c9$export$2e2bcd8739ae039 = $4327c88dccf550c9$var$InProgressIcon;
    const $4327c88dccf550c9$var$spin = null;
    const $4327c88dccf550c9$var$spinAnimation = `${$4327c88dccf550c9$var$spin} 1.5s linear infinite`;
    const $4327c88dccf550c9$var$SpinningSvg = (0, $5uXOq.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1xz6pnn": (0, (0, parcelRequire("lD23V")).default)($4327c88dccf550c9$var$spinAnimation)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y44v1wf2",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bdG8F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dbbaafbb3b446ad9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $dbbaafbb3b446ad9$var$pendingColor = `var(--ds-icon-information, ${(0, $829f609a65d26a98$exports).B300})`;
    const $dbbaafbb3b446ad9$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`;
    const $dbbaafbb3b446ad9$var$PendingIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            fill: "none",
            viewBox: "0 0 16 16"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            r: "7",
            cx: "8",
            cy: "8",
            fill: $dbbaafbb3b446ad9$var$backgroundColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: $dbbaafbb3b446ad9$var$pendingColor,
            d: "M13.657 2.343A8 8 0 102.343 13.657 8 8 0 0013.657 2.343zm-2.308 9.006a1 1 0 01-1.389.024L7.294 8.707a.988.988 0 01-.217-.325l.002.007-.005-.013.003.006A.993.993 0 017 8V4a1 1 0 012 0v3.587l2.373 2.373a1 1 0 01-.024 1.389z"
        }));
    $dbbaafbb3b446ad9$var$PendingIcon.displayName = 'PendingIcon';
    var $dbbaafbb3b446ad9$export$2e2bcd8739ae039 = $dbbaafbb3b446ad9$var$PendingIcon;
});
parcelRegister("huvAp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73da12db542612ce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $73da12db542612ce$var$rolledBackColor = `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y400})`;
    const $73da12db542612ce$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`;
    const $73da12db542612ce$var$RolledBackIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            fill: "none",
            viewBox: "0 0 16 16"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            r: "7",
            cx: "8",
            cy: "8",
            fill: $73da12db542612ce$var$backgroundColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: $73da12db542612ce$var$rolledBackColor,
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM7.707 3.293a1 1 0 010 1.414L7.414 5H8.6C10.516 5 12 6.606 12 8.5S10.516 12 8.6 12H7a1 1 0 110-2h1.6c.735 0 1.4-.633 1.4-1.5S9.335 7 8.6 7H7.414l.293.293a1 1 0 01-1.414 1.414l-2-2a1 1 0 010-1.414l2-2a1 1 0 011.414 0z",
            clipRule: "evenodd"
        }));
    $73da12db542612ce$var$RolledBackIcon.displayName = 'RolledBackIcon';
    var $73da12db542612ce$export$2e2bcd8739ae039 = $73da12db542612ce$var$RolledBackIcon;
});
parcelRegister("lgFQN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a1792f365bbd0a4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $0a1792f365bbd0a4$var$successColor = `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`;
    const $0a1792f365bbd0a4$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`;
    const $0a1792f365bbd0a4$var$SuccessNonProductionIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            fill: "none",
            viewBox: "0 0 16 16"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            r: "7",
            cx: "8",
            cy: "8",
            fill: $0a1792f365bbd0a4$var$backgroundColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: $0a1792f365bbd0a4$var$successColor,
            fillRule: "evenodd",
            d: "M14 8A6 6 0 112 8a6 6 0 0112 0zm2 0A8 8 0 110 8a8 8 0 0116 0zm-4.293-1.293a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
            clipRule: "evenodd"
        }));
    $0a1792f365bbd0a4$var$SuccessNonProductionIcon.displayName = 'SuccessNonProductionIcon';
    var $0a1792f365bbd0a4$export$2e2bcd8739ae039 = $0a1792f365bbd0a4$var$SuccessNonProductionIcon;
});
parcelRegister("6TrDT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7eba88d22afe0554$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $7eba88d22afe0554$var$successColor = `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`;
    const $7eba88d22afe0554$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`;
    const $7eba88d22afe0554$var$SuccessProductionIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            fill: "none",
            viewBox: "0 0 16 16"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            r: "7",
            cx: "8",
            cy: "8",
            fill: $7eba88d22afe0554$var$backgroundColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: $7eba88d22afe0554$var$successColor,
            fillRule: "evenodd",
            d: "M8 16A8 8 0 108 0a8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
            clipRule: "evenodd"
        }));
    $7eba88d22afe0554$var$SuccessProductionIcon.displayName = 'SuccessProductionIcon';
    var $7eba88d22afe0554$export$2e2bcd8739ae039 = $7eba88d22afe0554$var$SuccessProductionIcon;
});
parcelRegister("5gD09", function(module, exports) {
    $parcel$export(module.exports, "DeploymentStateOptions", ()=>$fb6a7926b4820f28$export$a761da6c19e008f6);
    const $fb6a7926b4820f28$var$PENDING = 'PENDING';
    const $fb6a7926b4820f28$var$IN_PROGRESS = 'IN_PROGRESS';
    const $fb6a7926b4820f28$var$SUCCESSFUL = 'SUCCESSFUL';
    const $fb6a7926b4820f28$var$SUCCESSFULNONPRODUCTION = 'SUCCESSFULNONPRODUCTION';
    const $fb6a7926b4820f28$var$CANCELLED = 'CANCELLED';
    const $fb6a7926b4820f28$var$FAILED = 'FAILED';
    const $fb6a7926b4820f28$var$ROLLED_BACK = 'ROLLED_BACK';
    const $fb6a7926b4820f28$var$UNKNOWN = 'UNKNOWN';
    const $fb6a7926b4820f28$export$a761da6c19e008f6 = {
        PENDING: $fb6a7926b4820f28$var$PENDING,
        IN_PROGRESS: $fb6a7926b4820f28$var$IN_PROGRESS,
        SUCCESSFUL: $fb6a7926b4820f28$var$SUCCESSFUL,
        SUCCESSFULNONPRODUCTION: $fb6a7926b4820f28$var$SUCCESSFULNONPRODUCTION,
        CANCELLED: $fb6a7926b4820f28$var$CANCELLED,
        FAILED: $fb6a7926b4820f28$var$FAILED,
        ROLLED_BACK: $fb6a7926b4820f28$var$ROLLED_BACK,
        UNKNOWN: $fb6a7926b4820f28$var$UNKNOWN
    };
});
parcelRegister("aH4Tr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$88ff831a34167232$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    const $88ff831a34167232$var$unknownColor = `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`;
    const $88ff831a34167232$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`;
    const $88ff831a34167232$var$UnknownOld = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            fill: "none",
            viewBox: "0 0 16 16"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            r: "7",
            cx: "8",
            cy: "8",
            fill: $88ff831a34167232$var$backgroundColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("mask", {
            id: "path-1-inside-1",
            fill: $88ff831a34167232$var$backgroundColor
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            d: "M15.367 4.898a8.039 8.039 0 00-1.703-2.546A8.118 8.118 0 0011.11.641 7.777 7.777 0 008 0a7.784 7.784 0 00-3.101.633 8.032 8.032 0 00-2.547 1.703A8.11 8.11 0 00.641 4.891 7.748 7.748 0 000 8c0 1.083.211 2.117.633 3.102a8.022 8.022 0 001.703 2.546 8.1 8.1 0 002.555 1.711A7.762 7.762 0 008 16a7.796 7.796 0 003.102-.633 8.055 8.055 0 002.547-1.703 8.15 8.15 0 001.711-2.555C15.786 10.12 16 9.083 16 8a7.796 7.796 0 00-.633-3.102z",
            clipRule: "evenodd"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: $88ff831a34167232$var$unknownColor,
            d: "M11.11.641l.793-1.836H11.9L11.11.64zM4.899.633l.788 1.838L4.9.633zM.641 4.891l1.836.794v-.002L.641 4.891zm-.008 6.211l-1.838.788 1.838-.788zm1.703 2.546l1.415-1.413-.002-.002-1.413 1.415zm2.555 1.711l.793-1.836-.793 1.836zm6.211.008l.788 1.838-.788-1.838zm2.547-1.703l1.413 1.415.002-.002-1.415-1.413zm1.711-2.555l1.836.794V11.9l-1.836-.791zm1.845-7A10.037 10.037 0 0015.078.939L12.25 3.766a6.041 6.041 0 011.279 1.92l3.676-1.576zM15.078.939a10.116 10.116 0 00-3.175-2.133l-1.586 3.672a6.12 6.12 0 011.933 1.29l2.828-2.83zm-3.177-2.134A9.777 9.777 0 008-2v4c.811 0 1.578.159 2.319.478L11.9-1.196zM8-2a9.784 9.784 0 00-3.89.795L5.688 2.47A5.784 5.784 0 018 2v-4zm-3.889.795A10.031 10.031 0 00.938.922L3.766 3.75a6.034 6.034 0 011.92-1.279L4.112-1.205zM.938.922a10.11 10.11 0 00-2.133 3.177l3.672 1.584a6.113 6.113 0 011.29-1.933L.936.922zm-2.132 3.175A9.748 9.748 0 00-2 8h4c0-.813.158-1.58.476-2.315l-3.67-1.588zM-2 8c0 1.35.265 2.653.795 3.89l3.676-1.576A5.796 5.796 0 012 8h-4zm.795 3.89a10.021 10.021 0 002.128 3.173l2.826-2.83a6.024 6.024 0 01-1.278-1.92l-3.676 1.577zM.92 15.061a10.1 10.1 0 003.178 2.134l1.584-3.672a6.1 6.1 0 01-1.932-1.288L.921 15.06zm3.177 2.134A9.763 9.763 0 008 18v-4a5.76 5.76 0 01-2.316-.477l-1.586 3.672zM8 18c1.35 0 2.653-.265 3.89-.795l-1.576-3.676C9.581 13.843 8.815 14 8 14v4zm3.89-.795a10.054 10.054 0 003.172-2.126l-2.826-2.83a6.056 6.056 0 01-1.922 1.28l1.576 3.676zm3.174-2.128c.902-.903 1.61-1.969 2.132-3.174l-3.672-1.588a6.152 6.152 0 01-1.29 1.936l2.83 2.826zm2.133-3.177A9.78 9.78 0 0018 8h-4c0 .812-.159 1.58-.477 2.318l3.674 1.582zM18 8c0-1.35-.265-2.653-.795-3.89L13.53 5.686C13.843 6.419 14 7.185 14 8h4z",
            mask: "url(#path-1-inside-1)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: $88ff831a34167232$var$unknownColor,
            d: "M5.419 6.425h1.456c.032-.607.44-1 1.058-1 .612 0 1.02.371 1.02.882 0 .51-.21.773-.902 1.187-.741.435-1.037.918-.967 1.761l.01.312h1.424v-.285c0-.526.199-.79.913-1.203.758-.446 1.15-1.01 1.15-1.82 0-1.225-1.016-2.08-2.552-2.08-1.649 0-2.583.924-2.61 2.246zm2.444 5.73c.601 0 .972-.343.972-.896 0-.559-.37-.903-.972-.903s-.978.344-.978.903c0 .553.376.897.978.897z"
        }));
    const $88ff831a34167232$var$UnknownNew = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            fill: "none",
            viewBox: "0 0 16 16"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "8",
            cy: "8",
            r: "7",
            fill: $88ff831a34167232$var$backgroundColor
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("mask", {
            id: "a",
            fill: $88ff831a34167232$var$backgroundColor
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M15.4 4.9a8 8 0 0 0-1.7-2.5A8.1 8.1 0 0 0 11 .6 7.8 7.8 0 0 0 8 0a7.8 7.8 0 0 0-3.1.6 8 8 0 0 0-2.5 1.7A8.1 8.1 0 0 0 .6 5 7.7 7.7 0 0 0 0 8c0 1 .2 2.1.6 3.1a8 8 0 0 0 1.7 2.5A8.1 8.1 0 0 0 5 15.4 7.8 7.8 0 0 0 8 16a7.8 7.8 0 0 0 3.1-.6 8 8 0 0 0 2.5-1.7 8.2 8.2 0 0 0 1.8-2.6c.4-1 .6-2 .6-3.1a7.8 7.8 0 0 0-.6-3.1z",
            clipRule: "evenodd",
            fillRule: "evenodd"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: $88ff831a34167232$var$unknownColor,
            d: "m11.1.6.8-1.8-.8 1.8zM5 .6l.8 1.9L4.9.6zM.6 5l1.9.8-1.9-.8zm0 6.2-1.8.8L.6 11zm1.7 2.5 1.5-1.4-1.5 1.4zM5 15.4l.8-1.9-.8 1.9zm6.2 0 .8 1.8-.8-1.8zm2.5-1.7 1.5 1.4-1.5-1.4zm1.8-2.6 1.8.8-1.8-.8zm1.8-7A10 10 0 0 0 15.1 1l-2.8 2.9a6 6 0 0 1 1.2 1.9L17.2 4zM15.1 1a10.1 10.1 0 0 0-3.2-2l-1.6 3.6a6.1 6.1 0 0 1 2 1.3L15 .9zm-3.2-2A9.8 9.8 0 0 0 8-2v4c.8 0 1.6.2 2.3.5L12-1.2zM8-2a9.8 9.8 0 0 0-3.9.8l1.6 3.7A5.8 5.8 0 0 1 8 2v-4zm-3.9.8A10 10 0 0 0 1 .9l2.9 2.9a6 6 0 0 1 1.9-1.3L4-1.2zM1 .9a10.1 10.1 0 0 0-2.1 3.2l3.7 1.6a6.1 6.1 0 0 1 1.3-2L.9 1zm-2 3.2A9.7 9.7 0 0 0-2 8h4c0-.8.2-1.6.5-2.3L-1.2 4zM-2 8c0 1.4.3 2.7.8 3.9l3.7-1.6A5.8 5.8 0 0 1 2 8h-4zm.8 3.9A10 10 0 0 0 .9 15l2.8-2.9a6 6 0 0 1-1.2-1.9L-1.2 12zM.9 15a10.1 10.1 0 0 0 3.2 2.1l1.6-3.7a6.1 6.1 0 0 1-2-1.3L1 15.1zm3.2 2.1A9.8 9.8 0 0 0 8 18v-4a5.8 5.8 0 0 1-2.3-.5L4 17.2zM8 18c1.4 0 2.7-.3 3.9-.8l-1.6-3.7c-.7.3-1.5.5-2.3.5v4zm3.9-.8a10 10 0 0 0 3.2-2.1l-2.9-2.9a6 6 0 0 1-1.9 1.3l1.6 3.7zm3.2-2.1c.9-1 1.6-2 2.1-3.2l-3.7-1.6a6.2 6.2 0 0 1-1.3 2l2.9 2.8zm2.1-3.2A9.8 9.8 0 0 0 18 8h-4c0 .8-.2 1.6-.5 2.3l3.7 1.6zM18 8c0-1.4-.3-2.7-.8-3.9l-3.7 1.6c.3.7.5 1.5.5 2.3h4z",
            mask: "url(#a)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: $88ff831a34167232$var$unknownColor,
            d: "M5.4 6.4H7c0-.6.4-1 1-1s1 .4 1 1c0 .4-.2.7-.8 1-.8.5-1 1-1 1.9v.3h1.4v-.3c0-.5.2-.8 1-1.2.7-.5 1-1 1-1.8 0-1.3-1-2.1-2.5-2.1-1.6 0-2.6.9-2.6 2.2zM8 12.2c.6 0 1-.4 1-1 0-.5-.4-.8-1-.8s-1 .3-1 .9c0 .5.4.9 1 .9z"
        }));
    const $88ff831a34167232$var$Unknown = (0, (0, parcelRequire("cSD7y")).componentWithFG)('optimise_development_and_deployment_icons', $88ff831a34167232$var$UnknownNew, $88ff831a34167232$var$UnknownOld);
    $88ff831a34167232$var$Unknown.displayName = 'Unknown';
    var $88ff831a34167232$export$2e2bcd8739ae039 = $88ff831a34167232$var$Unknown;
});
parcelRegister("g2uF3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0476b58be30c776d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0476b58be30c776d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        deploymentPopupTitle: {
            "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.deployment-popup-title",
            "defaultMessage": "Deployment"
        },
        viewAllDeployments: {
            "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.view-all-deployments",
            "defaultMessage": "View all deployments"
        },
        issuesDeployed: {
            "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.issues-deployed",
            "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}} deployed"
        }
    });
});
parcelRegister("e2lGD", function(module, exports) {
    $parcel$export(module.exports, "capitalizeOnlyFirstLetter", ()=>$ec77f0c65895c94d$export$1f9f0c721cdd6cac);
    $parcel$export(module.exports, "mapDeploymentState", ()=>$ec77f0c65895c94d$export$e46eedc73b6bf584);
    $parcel$export(module.exports, "mapStateToLozengeProp", ()=>$ec77f0c65895c94d$export$bb72fc1de2630393);
    var $iHvFq = parcelRequire("iHvFq");
    var $9pctO = parcelRequire("9pctO");
    var $5gD09;
    const $ec77f0c65895c94d$export$1f9f0c721cdd6cac = (str)=>(0, ($parcel$interopDefault($9pctO)))((0, ($parcel$interopDefault($iHvFq)))(str));
    const $ec77f0c65895c94d$export$e46eedc73b6bf584 = (state, environmentCategory)=>{
        switch(state){
            case 'IN_PROGRESS':
            case 'PENDING':
            case 'ROLLED_BACK':
            case 'CANCELLED':
            case 'FAILED':
                return state;
            case 'SUCCESSFUL':
                if (environmentCategory !== 'PRODUCTION') return (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).SUCCESSFULNONPRODUCTION;
                return state;
            default:
                return (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).UNKNOWN;
        }
    };
    const $ec77f0c65895c94d$export$bb72fc1de2630393 = (state)=>{
        switch(state){
            case 'IN_PROGRESS':
            case 'PENDING':
                return 'inprogress';
            case 'ROLLED_BACK':
            case 'CANCELLED':
                return 'moved';
            case 'FAILED':
                return 'removed';
            case 'SUCCESSFUL':
            default:
                return 'success';
        }
    };
});
parcelRegister("iHvFq", function(module, exports) {
    var $gDRiW = parcelRequire("gDRiW");
    var $d9d4ce91007e2cba$var$lowerCase = $gDRiW(function(result, word, index) {
        return result + (index ? ' ' : '') + word.toLowerCase();
    });
    module.exports = $d9d4ce91007e2cba$var$lowerCase;
});
parcelRegister("cD7pF", function(module, exports) {
    $parcel$export(module.exports, "PulseIcon", ()=>$48dc2eb20a10ed22$export$821b06bbcfc0bc3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $5LWLA;
    var $gwIPs;
    const $48dc2eb20a10ed22$export$f27fc5fc552d177d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: (0, (0, parcelRequire("gwIPs")).gridSize) * 2,
            height: (0, (0, parcelRequire("gwIPs")).gridSize) * 2,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M2 8.70457H5.81067L7.7095 4L8.7403 12L10.5306 7.07724H14",
            stroke: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }));
    const $48dc2eb20a10ed22$export$821b06bbcfc0bc3c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($48dc2eb20a10ed22$export$be58b4326e23250f, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $48dc2eb20a10ed22$export$f27fc5fc552d177d,
            size: "medium",
            label: ""
        }));
    const $48dc2eb20a10ed22$export$be58b4326e23250f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ghVnF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12df77a1b19829dc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $12df77a1b19829dc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noDeployments: {
            "id": "software-releases-launch-card.latest-deployment.no-deployments",
            "defaultMessage": "No deployments for the last week"
        },
        lastDeployment: {
            "id": "software-releases-launch-card.latest-deployment.last-deployment",
            "defaultMessage": "Last deployment: "
        },
        loading: {
            "id": "software-releases-launch-card.latest-deployment.loading",
            "defaultMessage": "Loading..."
        }
    });
});
parcelRegister("dGKnO", function(module, exports) {
    $parcel$export(module.exports, "useLoadProvidersListQuery", ()=>$735230b5b4cedbec$export$8544c7d4cd7544c3);
    $parcel$export(module.exports, "ProvidersList", ()=>$735230b5b4cedbec$export$82486456ea9f13cc);
    var $4myeK;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $l1N8i;
    var $btivG;
    var $eZJjh;
    var $koVbs;
    var $lfTZh;
    var $dXq4S;
    var $4myeK;
    var $koeKL;
    var $gBkhv;
    var $1eX9X;
    var $dJzWW;
    const $735230b5b4cedbec$export$8544c7d4cd7544c3 = ()=>{
        const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("4myeK")).default));
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const loadProvidersListQuery = ()=>{
            if (queryReference == null) loadQuery({
                cloudId: (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: cloudId
                })
            });
        };
        return [
            queryReference,
            loadProvidersListQuery
        ];
    };
    const $735230b5b4cedbec$export$6bc5a3de56260df3 = ({ queryReference: queryReference })=>{
        const { devOps: devOps } = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("4myeK")).default), queryReference);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { deploymentProviders: deploymentProviders } = devOps.providers;
        const renderProvidersConnectedMessage = ()=>{
            switch(deploymentProviders.length){
                case 1:
                    return formatMessage((0, (0, parcelRequire("1eX9X")).default).oneProviderIsConnected, {
                        providerName: deploymentProviders[0]?.name
                    });
                case 2:
                    return formatMessage((0, (0, parcelRequire("1eX9X")).default).twoProvidersAreConnected);
                default:
                    return formatMessage((0, (0, parcelRequire("1eX9X")).default).threeOrMoreProvidersAreConnected);
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$ProviderList, null, deploymentProviders.filter(Boolean).slice(0, 3).map((provider)=>(0, ($parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$LogoContainer, {
                key: provider.id
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dJzWW")).ProviderLogo), {
                provider: provider
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$CheckIconContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("btivG"))))), {
            primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
            label: ""
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, renderProvidersConnectedMessage()), (0, ($parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$DetailText, null, formatMessage((0, (0, parcelRequire("1eX9X")).default).setUpDeploymentsDetail)), (0, ($parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$LinkText, {
            href: (0, (0, parcelRequire("gBkhv")).SUPPORT_DOCS_LINK_URL),
            target: "_blank"
        }, formatMessage((0, (0, parcelRequire("1eX9X")).default).supportLinkText)));
    };
    const $735230b5b4cedbec$export$82486456ea9f13cc = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "providers-list-inner",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$export$6bc5a3de56260df3, {
            queryReference: props.queryReference
        }));
    const $735230b5b4cedbec$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1lze _vchhusvi _1yt4xy5q _y3gn1h6o _syaz1wmz",
                __cmplp.className
            ])
        });
    });
    const $735230b5b4cedbec$var$ProviderList = (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _otyrutpp _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $735230b5b4cedbec$var$LogoContainer = (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1o8l _79apxmi2",
                __cmplp.className
            ])
        });
    });
    const $735230b5b4cedbec$var$DetailText = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4381o",
                __cmplp.className
            ])
        });
    });
    const $735230b5b4cedbec$var$CheckIconContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1bsb1tcg _4t3i1tcg _bfhkvuon _2rko1osq _154ir5cr _1xi2r5cr",
                __cmplp.className
            ])
        });
    });
    const $735230b5b4cedbec$var$LinkText = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1y58",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4myeK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff46286f6c80ad0a$export$2e2bcd8739ae039);
    const $ff46286f6c80ad0a$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "cloudId"
            },
            {
                "kind": "Literal",
                "name": "providerTypes",
                "value": [
                    "DEPLOYMENT"
                ]
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        }, v3 = {
            "kind": "ScalarField",
            "name": "name"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "providersListTooltipContentQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "DevOps",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v1,
                                        "concreteType": "DevOpsProviders",
                                        "kind": "LinkedField",
                                        "name": "providers",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "DevOpsDeploymentProvider",
                                                    "kind": "LinkedField",
                                                    "name": "deploymentProviders",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v2,
                                                            "action": "THROW",
                                                            "path": "devOps.providers.deploymentProviders.id"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v3,
                                                            "action": "THROW",
                                                            "path": "devOps.providers.deploymentProviders.name"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "providerLogo_softwareReleasesLaunchCard"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "devOps.providers.deploymentProviders"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "devOps.providers"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "devOps"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "providersListTooltipContentQuery",
                "selections": [
                    {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "DevOpsProviders",
                                "kind": "LinkedField",
                                "name": "providers",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "DevOpsDeploymentProvider",
                                        "kind": "LinkedField",
                                        "name": "deploymentProviders",
                                        "plural": true,
                                        "selections": [
                                            v2,
                                            v3,
                                            {
                                                "kind": "ScalarField",
                                                "name": "logoUrl"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "615b7ed663144eb1919951d271557951faf2fdb21681d222dc88fedad6aa9908",
                "metadata": {},
                "name": "providersListTooltipContentQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $ff46286f6c80ad0a$var$node.hash = "2fb2dcefa503b43df945cc594382beab";
    var $ff46286f6c80ad0a$export$2e2bcd8739ae039 = $ff46286f6c80ad0a$var$node;
});
parcelRegister("1eX9X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12442aeae637d827$export$2e2bcd8739ae039);
    var $7VHMR;
    var $12442aeae637d827$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        oneProviderIsConnected: {
            "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.one-provider-is-connected",
            "defaultMessage": "{providerName} is installed"
        },
        twoProvidersAreConnected: {
            "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.two-providers-are-connected",
            "defaultMessage": "2 deployment tools installed"
        },
        threeOrMoreProvidersAreConnected: {
            "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.three-or-more-providers-are-connected",
            "defaultMessage": "3+ deployment tools installed"
        },
        setUpDeploymentsDetail: {
            "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.set-up-deployments-detail",
            "defaultMessage": "To track deployments in Jira, start linking your work to issues in this project."
        },
        supportLinkText: {
            "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.support-link-text",
            "defaultMessage": "Learn how to link development work to issues"
        }
    });
});
parcelRegister("dJzWW", function(module, exports) {
    $parcel$export(module.exports, "ProviderLogo", ()=>$d5a890bebf2b9254$export$a48c0a0510fd5b7a);
    var $jmeDM;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $aGmU7 = parcelRequire("aGmU7");
    const $d5a890bebf2b9254$export$a48c0a0510fd5b7a = ({ provider: provider })=>{
        const { name: name, logoUrl: logoUrl } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("jmeDM")).default), provider);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($d5a890bebf2b9254$export$e464f89b9068f431, {
            src: logoUrl ?? '',
            alt: name ?? '',
            title: name ?? '',
            onError: (e)=>{
                if (e.target instanceof HTMLImageElement) e.target.src = (0, ($parcel$interopDefault($aGmU7)));
            }
        });
    };
    const $d5a890bebf2b9254$export$e464f89b9068f431 = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbzwfg _4t3izwfg _1yt4u2gc _2rko1osq _16qsvjj6 _bfhku67f",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jmeDM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$119bf602319f2f60$export$2e2bcd8739ae039);
    const $119bf602319f2f60$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "providerLogo_softwareReleasesLaunchCard",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "logoUrl"
            }
        ],
        "type": "DevOpsDeploymentProvider"
    };
    $119bf602319f2f60$var$node.hash = "a69ed29281953f2d0dd2061c60855b1f";
    var $119bf602319f2f60$export$2e2bcd8739ae039 = $119bf602319f2f60$var$node;
});
parcelRegister("aGmU7", function(module, exports) {
    module.exports = new URL("addon.840ab9ef.svg", import.meta.url).toString();
});
parcelRegister("aRLM0", function(module, exports) {
    $parcel$export(module.exports, "VersionContributorsSectionSkeleton", ()=>$9b7ba4f3787efd3d$export$9ffa065263e020b9);
    $parcel$export(module.exports, "AsyncVersionContributors", ()=>$9b7ba4f3787efd3d$export$c80cf9cb5de0170f);
    var $ifG8b;
    var $5ZT5S;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $cgL5K;
    var $koVbs;
    var $lfTZh;
    var $kxZPA;
    var $fTbjw;
    var $dw99M;
    const $9b7ba4f3787efd3d$var$LazyVersionContributors = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("fSNdm")).then((module)=>module.VersionContributors), {
        moduleId: "./src/packages/releases/launch-card/src/ui/version-contributors/index.tsx"
    });
    const $9b7ba4f3787efd3d$export$9ffa065263e020b9 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9b7ba4f3787efd3d$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            weight: "bold",
            color: "color.text.subtle",
            as: "p"
        }, formatMessage((0, (0, parcelRequire("dw99M")).default).contributorsLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fTbjw")).ContributorsSkeleton), {
            contributorCount: 4
        }));
    };
    const $9b7ba4f3787efd3d$export$c80cf9cb5de0170f = ({ queryRef: queryRef })=>{
        const { jira: jira } = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("5ZT5S")).default), queryRef);
        const versionFrag = jira.version;
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("ifG8b")).default), versionFrag);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "version-contributors",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($9b7ba4f3787efd3d$export$9ffa065263e020b9, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9b7ba4f3787efd3d$var$LazyVersionContributors, {
            jiraVersionContributors: version.contributors.edges.filter(Boolean)
        }));
    };
    const $9b7ba4f3787efd3d$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _zulpu2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ifG8b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b697d536620ab70$export$2e2bcd8739ae039);
    const $3b697d536620ab70$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "async_softwareReleasesLaunchCard_AsyncVersionContributors",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraVersionContributorConnection",
                    "kind": "LinkedField",
                    "name": "contributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraVersionContributorEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "versionContributors_softwareReleasesLaunchCard"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "contributors.edges"
                        }
                    ]
                },
                "action": "THROW",
                "path": "contributors"
            }
        ],
        "type": "JiraVersion"
    };
    $3b697d536620ab70$var$node.hash = "1c2f7736ef0703bba0e1b3081509e3ee";
    var $3b697d536620ab70$export$2e2bcd8739ae039 = $3b697d536620ab70$var$node;
});
parcelRegister("fTbjw", function(module, exports) {
    $parcel$export(module.exports, "ContributorsSkeleton", ()=>$774291702822ce62$export$bd943a9e5a9521c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $774291702822ce62$export$bd943a9e5a9521c = ({ contributorCount: contributorCount })=>(0, ($parcel$interopDefault($5uXOq))).createElement($774291702822ce62$var$Container, null, [
            ...Array(contributorCount)
        ].map((_, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement($774291702822ce62$var$SkeletonGroup, {
                key: i
            })));
    const $774291702822ce62$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1p5aglyw _kqswh2mm _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                __cmplp.className
            ])
        });
    });
    const $774291702822ce62$var$SkeletonGroup = (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1tcg _4t3i1tcg _bfhkqrzy _1e0c1o8l _2rko1ssb _189eyh40 _1dqonqa1 _1h6du67f _79apxmi2",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dw99M", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$acb7838bd58c3890$export$2e2bcd8739ae039);
    var $7VHMR;
    var $acb7838bd58c3890$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        contributorsLabel: {
            "id": "software-releases-launch-card.version-contributors.contributors-label",
            "defaultMessage": "Contributors"
        }
    });
});
parcelRegister("fSNdm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("i2AHI")
    ]).then(()=>parcelRequire('g2vqE'));
});
parcelRegister("gPH8i", function(module, exports) {
    $parcel$export(module.exports, "VersionDates", ()=>$57776e2f2bdc42ed$export$2f6a5887195e56f4);
    var $jPxD4;
    var $guZiv;
    var $8Gql5;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $1O7Kb;
    var $75GNn;
    var $16Op0;
    var $dyMGB;
    var $7RQHY;
    const $57776e2f2bdc42ed$var$BAD_START_RELEASE_DATE_ORDER_ERROR = 'BAD_START_RELEASE_DATE_ORDER';
    const $57776e2f2bdc42ed$var$useFormattedDates = (startDate, releaseDate)=>{
        const { formatMessage: formatMessage, formatDate: formatDate } = (0, (0, parcelRequire("koVbs")).default)();
        return {
            formattedStartDate: startDate === null ? formatMessage((0, (0, parcelRequire("7RQHY")).default).startDateNotSet) : formatDate(new Date(startDate), {
                timeZone: (0, (0, parcelRequire("1O7Kb")).VERSION_DATE_FORMAT_OPTION).timeZone,
                dateStyle: 'long'
            }),
            formattedReleaseDate: releaseDate === null ? formatMessage((0, (0, parcelRequire("7RQHY")).default).releaseDateNotSet) : formatDate(new Date(releaseDate), {
                timeZone: (0, (0, parcelRequire("1O7Kb")).VERSION_DATE_FORMAT_OPTION).timeZone,
                dateStyle: 'long'
            })
        };
    };
    const $57776e2f2bdc42ed$export$2f6a5887195e56f4 = ({ jiraVersion: jiraVersion })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("8Gql5")).default), jiraVersion);
        const [updateVersionStartDate] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("guZiv")).default));
        const [updateVersionReleaseDate] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("jPxD4")).default));
        const handleStartDateMutationError = (data)=>{
            const flagText = {
                title: (0, (0, parcelRequire("7RQHY")).default).startDateGenericErrorFlagTitle,
                description: (0, (0, parcelRequire("7RQHY")).default).genericErrorFlagDescription
            };
            if (data.jira?.updateVersionStartDate?.errors) {
                const { extensions: extensions } = data.jira.updateVersionStartDate.errors[0];
                if (extensions?.errorType === $57776e2f2bdc42ed$var$BAD_START_RELEASE_DATE_ORDER_ERROR) {
                    flagText.title = (0, (0, parcelRequire("7RQHY")).default).badReleaseStartDateOrderErrorFlagTitle;
                    flagText.description = (0, (0, parcelRequire("7RQHY")).default).badReleaseStartDateOrderErrorFlagDescription;
                }
            }
            showFlag({
                type: 'warning',
                ...flagText
            });
        };
        const handleStartDateChange = (startDate)=>{
            updateVersionStartDate({
                variables: {
                    input: {
                        id: version.id,
                        startDate: startDate
                    }
                },
                onCompleted: (data)=>{
                    if (!data.jira?.updateVersionStartDate?.success) handleStartDateMutationError(data);
                    else (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({
                        action: 'updated',
                        actionSubject: 'versionStartDate'
                    }), 'versionStartDate updated');
                },
                onError: ()=>{
                    (0, (0, parcelRequire("75GNn")).fireFieldUpdateErrorAnalytics)();
                    showFlag({
                        type: 'error',
                        title: (0, (0, parcelRequire("7RQHY")).default).startDateGenericErrorFlagTitle,
                        description: (0, (0, parcelRequire("7RQHY")).default).genericErrorFlagDescription
                    });
                },
                optimisticResponse: {
                    jira: {
                        updateVersionStartDate: {
                            success: true,
                            errors: [],
                            version: {
                                id: version.id,
                                startDate: startDate
                            }
                        }
                    }
                }
            });
        };
        const handleReleaseDateChange = (releaseDate)=>{
            updateVersionReleaseDate({
                variables: {
                    input: {
                        id: version.id,
                        releaseDate: releaseDate
                    }
                },
                onCompleted: (data)=>{
                    if (!data.jira?.updateVersionReleaseDate?.success) showFlag({
                        type: 'warning',
                        title: (0, (0, parcelRequire("7RQHY")).default).releaseDateErrorFlagTitle,
                        description: (0, (0, parcelRequire("7RQHY")).default).genericErrorFlagDescription
                    });
                    else (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({
                        action: 'updated',
                        actionSubject: 'versionReleaseDate'
                    }), 'versionReleaseDate updated');
                },
                onError: ()=>{
                    (0, (0, parcelRequire("75GNn")).fireFieldUpdateErrorAnalytics)();
                    showFlag({
                        type: 'error',
                        title: (0, (0, parcelRequire("7RQHY")).default).releaseDateErrorFlagTitle,
                        description: (0, (0, parcelRequire("7RQHY")).default).genericErrorFlagDescription
                    });
                },
                optimisticResponse: {
                    jira: {
                        updateVersionReleaseDate: {
                            success: true,
                            version: {
                                id: version.id,
                                releaseDate: releaseDate
                            }
                        }
                    }
                }
            });
        };
        const { formattedStartDate: formattedStartDate, formattedReleaseDate: formattedReleaseDate } = $57776e2f2bdc42ed$var$useFormattedDates(version.startDate, version.releaseDate);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($57776e2f2bdc42ed$var$DateContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16Op0")).AsyncEditableDatePicker), {
            analyticsEventName: "versionStartDate",
            canEdit: version.canEdit,
            currentDate: version.startDate,
            displayDate: formattedStartDate,
            label: formatMessage((0, (0, parcelRequire("7RQHY")).default).startDateFieldLabel),
            maxDate: (0, (0, parcelRequire("dyMGB")).convertDatetimeToDate)(version.releaseDate),
            onUpdateDate: handleStartDateChange,
            testId: "software-releases-launch-card.ui.version-dates.start-date-editable-date-picker"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16Op0")).AsyncEditableDatePicker), {
            analyticsEventName: "versionReleaseDate",
            canEdit: version.canEdit,
            currentDate: version.releaseDate,
            displayDate: formattedReleaseDate,
            label: formatMessage((0, (0, parcelRequire("7RQHY")).default).releaseDateFieldLabel),
            minDate: (0, (0, parcelRequire("dyMGB")).convertDatetimeToDate)(version.startDate),
            onUpdateDate: handleReleaseDateChange,
            testId: "software-releases-launch-card.ui.version-dates.release-date-editable-date-picker"
        }));
    };
    const $57776e2f2bdc42ed$var$DateContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _zulpu2gc _1bah1yb4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jPxD4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f30c73b914cd8ec$export$2e2bcd8739ae039);
    const $6f30c73b914cd8ec$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "kind": "ScalarField",
            "name": "releaseDate"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "versionDates_updateVersionReleaseDateMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionReleaseDate",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "versionDates_updateVersionReleaseDateMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionReleaseDate",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "77cad9e713773fc9731f7546654bb6829a888de63c65c65ad0484a7d7526abb5",
                "metadata": {},
                "name": "versionDates_updateVersionReleaseDateMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $6f30c73b914cd8ec$var$node.hash = "0404a02cdc80d06adbaaf61ada39552b";
    var $6f30c73b914cd8ec$export$2e2bcd8739ae039 = $6f30c73b914cd8ec$var$node;
});
parcelRegister("guZiv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56cb5aa6900e43ce$export$2e2bcd8739ae039);
    const $56cb5aa6900e43ce$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "kind": "ScalarField",
            "name": "statusCode"
        }, v4 = {
            "kind": "ScalarField",
            "name": "errorType"
        }, v5 = {
            "kind": "ScalarField",
            "name": "startDate"
        }, v6 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "versionDates_updateVersionStartDateMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionStartDate",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    v4
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v5
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "versionDates_updateVersionStartDateMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionStartDate",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "MutationError",
                                        "kind": "LinkedField",
                                        "name": "errors",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v3,
                                                    v4,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v6
                                                        ],
                                                        "type": "BulkMutationErrorExtension"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v5,
                                            v6
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "3c21a1f19ee00080fdbd0fc4853475b9e944bd3f18e9b98d9d5314b5ca267906",
                "metadata": {},
                "name": "versionDates_updateVersionStartDateMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $56cb5aa6900e43ce$var$node.hash = "9222866e01fe4d9b93a39fe2c827a3b0";
    var $56cb5aa6900e43ce$export$2e2bcd8739ae039 = $56cb5aa6900e43ce$var$node;
});
parcelRegister("8Gql5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c97a62a27014dc7b$export$2e2bcd8739ae039);
    const $c97a62a27014dc7b$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "versionDates_softwareReleasesLaunchCard",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "canEdit"
            },
            {
                "kind": "ScalarField",
                "name": "startDate"
            },
            {
                "kind": "ScalarField",
                "name": "releaseDate"
            }
        ],
        "type": "JiraVersion"
    };
    $c97a62a27014dc7b$var$node.hash = "4dcf74d53cdeafe5bdc663fa3f4c36e4";
    var $c97a62a27014dc7b$export$2e2bcd8739ae039 = $c97a62a27014dc7b$var$node;
});
parcelRegister("75GNn", function(module, exports) {
    $parcel$export(module.exports, "fireFieldUpdateErrorAnalytics", ()=>$2a20f35766e48831$export$f84dee30e0e69629);
    var $jcw0u;
    const $2a20f35766e48831$export$f84dee30e0e69629 = ()=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: 'jira.releases.launch.card.update.version.field.mutation.error.id',
                packageName: 'jiraSoftwareReleasesLaunchCard',
                teamName: 'fusion-solaris'
            },
            error: Error('Unable to update version'),
            sendToPrivacyUnsafeSplunk: true
        });
    };
});
parcelRegister("16Op0", function(module, exports) {
    $parcel$export(module.exports, "AsyncEditableDatePicker", ()=>$16268c5aa65eca45$export$e5d82c99aef790b1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2x3Cb;
    var $lfTZh;
    var $kxZPA;
    var $gPGcr;
    const $16268c5aa65eca45$var$LazyEditableDatePicker = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("sKcyI")).then((module)=>module.EditableDatePicker), {
        moduleId: "./src/packages/releases/launch-card/src/ui/version-dates/editable-date-picker/index.tsx"
    });
    const $16268c5aa65eca45$export$e5d82c99aef790b1 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "editable-date-picker",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($16268c5aa65eca45$export$66b8cea0c448285, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2x3Cb")).Label), {
                htmlFor: "version-details-editable-date-picker"
            }, props.label), (0, ($parcel$interopDefault($5uXOq))).createElement($16268c5aa65eca45$var$InlineEditReadViewContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gPGcr")).DatePickerReadView), {
                displayDate: props.displayDate
            })))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($16268c5aa65eca45$var$LazyEditableDatePicker, props));
    const $16268c5aa65eca45$export$66b8cea0c448285 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul91lit _otyru2gc",
                __cmplp.className
            ])
        });
    });
    const $16268c5aa65eca45$var$InlineEditReadViewContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19itj1ic _vwz4kb7n",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2x3Cb", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$987b76a5b7a0ea9b$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$987b76a5b7a0ea9b$export$ed247974535929c7);
    var $f8Sb3;
    function $987b76a5b7a0ea9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles
        }, children);
    };
    var $987b76a5b7a0ea9b$export$2e2bcd8739ae039 = $987b76a5b7a0ea9b$export$b04be29aa201d4f5;
});
parcelRegister("gPGcr", function(module, exports) {
    $parcel$export(module.exports, "DatePickerReadView", ()=>$7c9cf4f5dba27873$export$e9b589e36300c388);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $7c9cf4f5dba27873$export$e9b589e36300c388 = ({ displayDate: displayDate, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7c9cf4f5dba27873$var$ReadViewContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($7c9cf4f5dba27873$var$ReadViewItem, {
            "data-testid": testId
        }, displayDate));
    const $7c9cf4f5dba27873$var$ReadViewContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _1ul91qr7 _1yt45fii",
                __cmplp.className
            ])
        });
    });
    const $7c9cf4f5dba27873$var$ReadViewItem = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_u5f31b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("sKcyI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5T1ca").then(()=>parcelRequire('gkrBm'));
});
parcelRegister("dyMGB", function(module, exports) {
    $parcel$export(module.exports, "convertDatetimeToDate", ()=>$7dfd1c2586132c51$export$f2eb3c0da1d3f89e);
    var $k7m40;
    var $jovBr;
    const $7dfd1c2586132c51$export$f2eb3c0da1d3f89e = (startDate)=>startDate != null && (0, (0, parcelRequire("jovBr")).default)(new Date(startDate)) ? (0, (0, parcelRequire("k7m40")).default)(new Date(startDate), 'yyyy-MM-dd') : '';
});
parcelRegister("7RQHY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c45859eb177b61d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3c45859eb177b61d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        startDateNotSet: {
            "id": "software-releases-launch-card.version-dates.start-date-not-set",
            "defaultMessage": "Start date not set"
        },
        releaseDateNotSet: {
            "id": "software-releases-launch-card.version-dates.release-date-not-set",
            "defaultMessage": "Release date not set"
        },
        startDateFieldLabel: {
            "id": "software-releases-launch-card.version-dates.start-date-field-label",
            "defaultMessage": "Start date"
        },
        startDateGenericErrorFlagTitle: {
            "id": "software-releases-launch-card.version-dates.start-date-generic-error-flag-title",
            "defaultMessage": "We couldn't update the start date"
        },
        badReleaseStartDateOrderErrorFlagTitle: {
            "id": "software-releases-launch-card.version-dates.bad-release-start-date-order-error-flag-title",
            "defaultMessage": "The start date cannot be after the release date"
        },
        badReleaseStartDateOrderErrorFlagDescription: {
            "id": "software-releases-launch-card.version-dates.bad-release-start-date-order-error-flag-description",
            "defaultMessage": "Please select a different start date."
        },
        releaseDateFieldLabel: {
            "id": "software-releases-launch-card.version-dates.release-date-field-label",
            "defaultMessage": "Release date"
        },
        releaseDateErrorFlagTitle: {
            "id": "software-releases-launch-card.version-dates.release-date-error-flag-title",
            "defaultMessage": "We couldn't update the release date"
        },
        genericErrorFlagDescription: {
            "id": "software-releases-launch-card.version-dates.generic-error-flag-description",
            "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
        }
    });
});
parcelRegister("lFoXK", function(module, exports) {
    $parcel$export(module.exports, "AsyncVersionStatus", ()=>$7c7501660c6c65ae$export$f6bcf9d2a3221dfb);
    var $eCweN;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $lfTZh;
    var $kxZPA;
    var $bT8J9;
    const $7c7501660c6c65ae$var$LazyVersionStatus = (0, (0, parcelRequire("kxZPA")).lazy)(()=>Promise.resolve((parcelRequire("bT8J9"))).then((module)=>module.VersionStatus), {
        moduleId: "./src/packages/releases/launch-card/src/ui/version-status/index.tsx"
    });
    const $7c7501660c6c65ae$export$f6bcf9d2a3221dfb = ({ jiraVersion: jiraVersion })=>{
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("eCweN")).default), jiraVersion);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "version-status",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($7c7501660c6c65ae$var$SkeletonContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), null, (0, (0, parcelRequire("bT8J9")).GetCurrentStatusLabel)(version.status)))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c7501660c6c65ae$var$LazyVersionStatus, {
            jiraVersion: version
        }));
    };
    const $7c7501660c6c65ae$var$SkeletonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq _4t3i1ylp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("eCweN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94edbaa1df4c3e8c$export$2e2bcd8739ae039);
    const $94edbaa1df4c3e8c$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "async_softwareReleasesLaunchCard_AsyncVersionStatus",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "status"
                },
                "action": "THROW",
                "path": "status"
            },
            {
                "kind": "FragmentSpread",
                "name": "versionStatus_softwareReleasesLaunchCard"
            }
        ],
        "type": "JiraVersion"
    };
    $94edbaa1df4c3e8c$var$node.hash = "bbfb4743758d7a0f5d5885118b67b179";
    var $94edbaa1df4c3e8c$export$2e2bcd8739ae039 = $94edbaa1df4c3e8c$var$node;
});
parcelRegister("bT8J9", function(module, exports) {
    $parcel$export(module.exports, "GetCurrentStatusLabel", ()=>$7254dcd52a39f897$export$3e6be0c31593f3c4);
    $parcel$export(module.exports, "VersionStatus", ()=>$7254dcd52a39f897$export$8c6e0f93bfb5c6a4);
    var $7lDAS;
    var $1gEiV;
    var $35PYc;
    var $joKO7;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8Uumt = parcelRequire("8Uumt");
    var $2rqOp;
    var $ky7e4;
    var $6Ingq;
    var $i8Qvm;
    var $bChGW;
    var $b9dFI;
    var $jcw0u;
    var $pa9q9;
    var $koVbs;
    var $lfTZh;
    var $8zOmE;
    var $2NMNM;
    var $hlRDe;
    var $kfztd;
    var $4i1Dv;
    var $kKpgF;
    var $DVljb;
    var $lqWUw;
    var $gBkhv;
    var $6eRDX;
    var $63h61;
    const $7254dcd52a39f897$var$overrideComponents = {
        Option: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Option, {
                ...props,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1695idpf _1pnsidpf _vktqidpf _1byqidpf"
                ])
            })
    };
    const $7254dcd52a39f897$var$CustomOptionLabel = ({ label: label, value: value })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7254dcd52a39f897$var$VersionStatusOptionLabel, {
            isArchiveOption: value === (0, (0, parcelRequire("gBkhv")).ARCHIVED)
        }, label);
    const $7254dcd52a39f897$export$3e6be0c31593f3c4 = (currentStatusValue)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        switch(currentStatusValue){
            case 0, (0, parcelRequire("gBkhv")).ARCHIVED:
                return formatMessage((0, (0, parcelRequire("63h61")).default).archivedLabel);
            case 0, (0, parcelRequire("gBkhv")).RELEASED:
                return formatMessage((0, (0, parcelRequire("63h61")).default).releasedLabel);
            case 0, (0, parcelRequire("gBkhv")).UNRELEASED:
                return formatMessage((0, (0, parcelRequire("63h61")).default).unreleasedLabel);
            default:
                return formatMessage((0, (0, parcelRequire("63h61")).default).unreleasedLabel);
        }
    };
    const $7254dcd52a39f897$var$getHasReleaseNote = async (versionId, environment)=>{
        try {
            const data = await (0, $8Uumt.fetchQuery)(environment, (0, (0, parcelRequire("joKO7")).default), {
                versionId: versionId
            }).toPromise();
            return data?.jira?.version?.hasReleaseNote ?? false;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'jiraLaunchCardHasReleaseNoteQuery',
                    packageName: 'jiraVersionLaunchCard',
                    teamName: 'fusion-solaris'
                },
                error: new Error('Unable to get "hasReleaseNote" for "release version" modal')
            });
            return false;
        }
    };
    const $7254dcd52a39f897$var$useHasReleaseNote = (versionId, shouldLoadHasReleaseNote)=>{
        const [hasReleaseNote, setHasReleaseNote] = (0, $5uXOq.useState)(null);
        const environment = (0, $8Uumt.useRelayEnvironment)();
        (0, $5uXOq.useEffect)(()=>{
            if (shouldLoadHasReleaseNote) $7254dcd52a39f897$var$getHasReleaseNote(versionId, environment).then(setHasReleaseNote);
        }, [
            versionId,
            environment,
            shouldLoadHasReleaseNote
        ]);
        return hasReleaseNote;
    };
    const $7254dcd52a39f897$export$8c6e0f93bfb5c6a4 = ({ jiraVersion: jiraVersion })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isReleasedModalOpen, setIsReleaseModalOpen] = (0, $5uXOq.useState)(false);
        const { refetch: refetch, isLoading: isRefetchLoading } = (0, (0, parcelRequire("kKpgF")).useRefetchContext)();
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const [selectWidth, setSelectWidth] = (0, $5uXOq.useState)(undefined);
        const selectRef = (0, $5uXOq.useRef)();
        const [isReleaseNotesModalOpen, setIsReleaseNotesModalOpen] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (selectRef.current) setSelectWidth(selectRef.current.offsetWidth);
        }, []);
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("35PYc")).default), jiraVersion);
        const hasReleaseNote = $7254dcd52a39f897$var$useHasReleaseNote(version.id, !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)());
        const isVersionReleased = version.status === (0, (0, parcelRequire("gBkhv")).RELEASED);
        const [updateVersionReleased] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("1gEiV")).default));
        const [updateVersionArchived, isUpdateArchivedLoading] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("7lDAS")).default));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [releaseNotesQueryReference, loadReleaseNotesQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("hlRDe")).default));
        const loadReleaseNoteModalResource = ()=>{
            loadReleaseNotesQuery({
                versionAri: version.id
            }, {
                fetchPolicy: 'store-and-network'
            });
        };
        const isLoading = isUpdateArchivedLoading || isRefetchLoading;
        const releaseOptions = [
            {
                label: formatMessage((0, (0, parcelRequire("63h61")).default).releaseOptionLabel),
                value: (0, (0, parcelRequire("gBkhv")).RELEASED)
            },
            {
                label: formatMessage((0, (0, parcelRequire("63h61")).default).unreleaseOptionLabel),
                value: (0, (0, parcelRequire("gBkhv")).UNRELEASED)
            },
            {
                label: formatMessage((0, (0, parcelRequire("63h61")).default).archiveOptionLabel),
                value: (0, (0, parcelRequire("gBkhv")).ARCHIVED)
            }
        ];
        const archiveOptions = [
            {
                label: formatMessage((0, (0, parcelRequire("63h61")).default).unarchiveOptionLabel),
                value: (0, (0, parcelRequire("gBkhv")).UNARCHIVED)
            }
        ];
        const currentOptions = version.status === (0, (0, parcelRequire("gBkhv")).ARCHIVED) ? archiveOptions : releaseOptions;
        const getCurrentValue = (currentStatusValue)=>[
                ...releaseOptions,
                ...archiveOptions
            ].find((option)=>option.value === currentStatusValue);
        const handleChange = (option)=>{
            if (option === null) return;
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'selected',
                actionSubject: 'option'
            }), option.value);
            switch(option.value){
                case 0, (0, parcelRequire("gBkhv")).RELEASED:
                    setIsReleaseModalOpen(true);
                    if (!(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)()) loadReleaseNoteModalResource();
                    break;
                case 0, (0, parcelRequire("gBkhv")).UNRELEASED:
                    updateVersionReleased({
                        variables: {
                            input: {
                                id: version.id,
                                isReleased: false
                            }
                        },
                        onError: ()=>{
                            (0, (0, parcelRequire("jcw0u")).default)({
                                meta: {
                                    id: 'jira.releases.launch.card.update.released.mutation.error.id',
                                    packageName: 'jiraSoftwareReleasesLaunchCard',
                                    teamName: 'fusion-solaris'
                                },
                                error: new Error('Unable to update version released status'),
                                sendToPrivacyUnsafeSplunk: true
                            });
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("63h61")).default).genericUpdateFailedFlagTitle,
                                description: (0, (0, parcelRequire("63h61")).default).releaseFailedFlagDescription
                            });
                        },
                        optimisticResponse: {
                            jira: {
                                updateVersionReleasedStatus: {
                                    success: true,
                                    version: {
                                        id: version.id,
                                        status: option.value
                                    }
                                }
                            }
                        }
                    });
                    break;
                case 0, (0, parcelRequire("gBkhv")).ARCHIVED:
                case 0, (0, parcelRequire("gBkhv")).UNARCHIVED:
                    updateVersionArchived({
                        variables: {
                            input: {
                                id: version.id,
                                isArchived: option.value === (0, (0, parcelRequire("gBkhv")).ARCHIVED)
                            }
                        },
                        onError: ()=>{
                            (0, (0, parcelRequire("jcw0u")).default)({
                                meta: {
                                    id: 'jira.releases.launch.card.update.archived.mutation.error.id',
                                    packageName: 'jiraSoftwareReleasesLaunchCard',
                                    teamName: 'fusion-solaris'
                                },
                                error: new Error('Unable to update version archived status'),
                                sendToPrivacyUnsafeSplunk: true
                            });
                            showFlag({
                                type: 'error',
                                title: (0, (0, parcelRequire("63h61")).default).genericUpdateFailedFlagTitle,
                                description: (0, (0, parcelRequire("63h61")).default).archiveFailedFlagDescription
                            });
                        }
                    });
                    break;
                default:
                    break;
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7254dcd52a39f897$var$Container, {
            ref: selectRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b9dFI")).default), {
            hideSelectedOptions: true,
            components: $7254dcd52a39f897$var$overrideComponents,
            formatOptionLabel: $7254dcd52a39f897$var$CustomOptionLabel,
            minMenuWidth: `${selectWidth}px`,
            onChange: handleChange,
            options: currentOptions,
            target: ({ isOpen: isOpen, ref: ref, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7254dcd52a39f897$var$StyledLoadingButton, {
                    ...triggerProps,
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                        label: formatMessage((0, (0, parcelRequire("63h61")).default).buttonLabel)
                    }),
                    isDisabled: !version.canEdit,
                    isLoading: isLoading,
                    isSelected: isOpen,
                    ref: ref,
                    released: isVersionReleased && !isOpen ? 1 : 0,
                    shouldFitContainer: true,
                    onClick: (_, analyticsEvent)=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionStatusDropdown')
                }, isVersionReleased ? (0, ($parcel$interopDefault($5uXOq))).createElement($7254dcd52a39f897$var$ReleasedContentWrapper, null, $7254dcd52a39f897$export$3e6be0c31593f3c4(version.status), (0, ($parcel$interopDefault($5uXOq))).createElement($7254dcd52a39f897$var$ReleaseSucceededIcon, null)) : $7254dcd52a39f897$export$3e6be0c31593f3c4(version.status)),
            value: getCurrentValue(version.status)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6eRDX")).NonCriticalErrorBoundary), {
            eventLocation: "releaseNotesModal",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "release-notes-modal",
            fallback: null
        }, isReleaseNotesModalOpen && releaseNotesQueryReference && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4i1Dv")).ReleaseNotesModal), {
            queryReference: releaseNotesQueryReference,
            onClose: ()=>setIsReleaseNotesModalOpen(false)
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isReleasedModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lqWUw")).default), {
            baseUrl: "",
            locale: locale,
            projectKey: version.project.key,
            versionId: version.versionId,
            onOpened: (0, ($parcel$interopDefault($8Rkzz))),
            onCancel: ()=>{
                setIsReleaseModalOpen(false);
            },
            onSuccess: (_updatedVersion, params)=>{
                refetch();
                setIsReleaseModalOpen(false);
                if (params && params.shouldRedirectToCreateReleaseNotes) setIsReleaseNotesModalOpen(true);
            },
            onError: ()=>{
                showFlag({
                    type: 'error',
                    title: formatMessage((0, (0, parcelRequire("63h61")).default).genericUpdateFailedFlagTitle),
                    description: formatMessage((0, (0, parcelRequire("63h61")).default).releaseFailedFlagDescription)
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: new Error('Failed to release the version'),
                    meta: {
                        id: 'versionDetailsLaunchCardReleaseModal',
                        packageName: 'jiraSoftwareReleasesLaunchCard',
                        teamName: 'fusion-solaris'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            shouldShowCreateReleaseNotesOption: !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)(),
            hasReleaseNote: hasReleaseNote ?? false
        })));
    };
    const $7254dcd52a39f897$var$ReleaseSucceededIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ky7e4"))))), {
            label: "",
            color: $7254dcd52a39f897$export$a7643b841a7da7eb,
            LEGACY_size: "small"
        });
    const $7254dcd52a39f897$var$styles = null;
    const $7254dcd52a39f897$var$RELEASED_BACKGROUND_COLOR = `var(--ds-background-success, ${(0, $829f609a65d26a98$exports).G50})`;
    const $7254dcd52a39f897$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $7254dcd52a39f897$var$ReleasedContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4cvr1h6o _1e0c1txw _zulp1b66 _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $7254dcd52a39f897$export$a7643b841a7da7eb = `var(--ds-text, ${(0, $829f609a65d26a98$exports).G500})`;
    const $7254dcd52a39f897$var$StyledLoadingButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("2rqOp")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_mc545c": (0, (0, parcelRequire("lD23V")).default)($7254dcd52a39f897$var$RELEASED_BACKGROUND_COLOR),
                "--_pgbpk1": (0, (0, parcelRequire("lD23V")).default)($7254dcd52a39f897$export$a7643b841a7da7eb)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_15s31ylp _1ilx1txw _ubnr1h6o",
                __cmplp.released && "_bikluv1w",
                __cmplp.released && "_1gty12xq",
                __cmplp.className
            ])
        });
    });
    const $7254dcd52a39f897$var$VersionStatusOptionLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isArchiveOption: isArchiveOption, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4cvr1h6o _80omtlke _1e0c1txw _1yt41azu",
                __cmplp.isArchiveOption ? "_x3dope8f" : "_x3doglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7lDAS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$850130315c77c46d$export$2e2bcd8739ae039);
    const $850130315c77c46d$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "kind": "ScalarField",
            "name": "status"
        }, v4 = {
            "kind": "ScalarField",
            "name": "canAddAndRemoveIssues"
        }, v5 = {
            "kind": "ScalarField",
            "name": "canEditRelatedWork"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "versionStatus_updateVersionArchivedMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionArchivedStatus",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            v4,
                                            v5
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "versionStatus_updateVersionArchivedMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionArchivedStatus",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            v4,
                                            v5,
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "c6513ea034d4c8ea62a2e9887bcaa685c8b2fcb46147be3044a62ff69effec49",
                "metadata": {},
                "name": "versionStatus_updateVersionArchivedMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $850130315c77c46d$var$node.hash = "3e4bee8708d54a5a32d8530c63b327c7";
    var $850130315c77c46d$export$2e2bcd8739ae039 = $850130315c77c46d$var$node;
});
parcelRegister("1gEiV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$89bc4c47fdb74222$export$2e2bcd8739ae039);
    const $89bc4c47fdb74222$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "kind": "ScalarField",
            "name": "status"
        }, v4 = {
            "kind": "ScalarField",
            "name": "canAddAndRemoveIssues"
        }, v5 = {
            "kind": "ScalarField",
            "name": "canEditRelatedWork"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "versionStatus_updateVersionReleasedMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionReleasedStatus",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            v4,
                                            v5
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "versionStatus_updateVersionReleasedMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionReleasedStatus",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            v4,
                                            v5,
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "71ceeb655014e9c61184f72a862fcc1e2ce71afe4bf7f9accabc37395bc9d079",
                "metadata": {},
                "name": "versionStatus_updateVersionReleasedMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $89bc4c47fdb74222$var$node.hash = "0608e97fa861a9ec4da08bc961c0e4d0";
    var $89bc4c47fdb74222$export$2e2bcd8739ae039 = $89bc4c47fdb74222$var$node;
});
parcelRegister("35PYc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$15ae054e75fb118a$export$2e2bcd8739ae039);
    const $15ae054e75fb118a$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "versionStatus_softwareReleasesLaunchCard",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "versionId"
                },
                "action": "THROW",
                "path": "versionId"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "status"
                },
                "action": "THROW",
                "path": "status"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            "action": "THROW",
                            "path": "project.key"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "canEdit"
                },
                "action": "THROW",
                "path": "canEdit"
            }
        ],
        "type": "JiraVersion"
    };
    $15ae054e75fb118a$var$node.hash = "7085e7fbc51810607ae42a94bf5c14e4";
    var $15ae054e75fb118a$export$2e2bcd8739ae039 = $15ae054e75fb118a$var$node;
});
parcelRegister("joKO7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$503f3f81f4b6660c$export$2e2bcd8739ae039);
    const $503f3f81f4b6660c$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "versionId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "versionId"
            }
        ], v2 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasReleaseNote"
                }
            ],
            "type": "JiraVersion"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "versionStatus_versionHasReleaseNoteQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v2
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "versionStatus_versionHasReleaseNoteQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    v2,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "8d8191dfb21f183308ae9bfac528d60fcd67480a7ca1b48be8e339480044e138",
                "metadata": {},
                "name": "versionStatus_versionHasReleaseNoteQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $503f3f81f4b6660c$var$node.hash = "ac12222b76ff5150d612ed35c9605c2c";
    var $503f3f81f4b6660c$export$2e2bcd8739ae039 = $503f3f81f4b6660c$var$node;
});
parcelRegister("ky7e4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ef5c96854bbf6178$var$_react = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ef5c96854bbf6178$var$_checkMark = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("bjo8S")));
    var $ef5c96854bbf6178$var$_check = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("kbxJz")));
    function $ef5c96854bbf6178$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ef5c96854bbf6178$var$CheckMarkIcon = (props)=>$ef5c96854bbf6178$var$_react.default.createElement($ef5c96854bbf6178$var$_checkMark.default, Object.assign({
            LEGACY_fallbackIcon: $ef5c96854bbf6178$var$_check.default
        }, props));
    $ef5c96854bbf6178$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
    var $ef5c96854bbf6178$var$_default = module.exports.default = $ef5c96854bbf6178$var$CheckMarkIcon;
});
parcelRegister("bjo8S", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83c43234bc70a485$var$_UNSAFE_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83c43234bc70a485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83c43234bc70a485$var$CheckMarkIcon = (props)=>$83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
        }, props));
    $83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;
});
parcelRegister("kbxJz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
    function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb1f0098e5a023eb$var$CheckIcon = (props)=>$eb1f0098e5a023eb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
        }, props, {
            newIcon: $eb1f0098e5a023eb$var$_checkMark.default
        }));
    $eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
    var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;
});
parcelRegister("hlRDe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9a3cf061de648cd$export$2e2bcd8739ae039);
    const $c9a3cf061de648cd$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "releaseNoteConfiguration"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionAri"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "versionAri"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = {
            "kind": "ScalarField",
            "name": "id"
        }, v5 = {
            "kind": "ScalarField",
            "name": "canEditRelatedWork"
        }, v6 = {
            "kind": "ScalarField",
            "name": "releasesNotesPreferenceType"
        }, v7 = {
            "kind": "ScalarField",
            "name": "issueKeyConfig"
        }, v8 = {
            "kind": "ScalarField",
            "name": "issueFieldIds"
        }, v9 = {
            "kind": "ScalarField",
            "name": "issueTypeIds"
        }, v10 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 100
            }
        ], v11 = [
            {
                "kind": "Variable",
                "name": "releaseNoteConfiguration",
                "variableName": "releaseNoteConfiguration"
            }
        ], v12 = {
            "kind": "ScalarField",
            "name": "isSystem"
        }, v13 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v14 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ],
            "type": "QueryError"
        }, v15 = {
            "kind": "ScalarField",
            "name": "name"
        }, v16 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v17 = {
            "kind": "ScalarField",
            "name": "endCursor"
        }, v18 = {
            "kind": "ScalarField",
            "name": "hasNextPage"
        }, v19 = [
            {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    v18,
                    v17
                ]
            },
            {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v3,
                            v4,
                            v15
                        ]
                    },
                    v16
                ]
            }
        ], v20 = [
            "searchString"
        ], v21 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 10
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "uiReleaseNotesModalQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v4,
                                                        "action": "THROW",
                                                        "path": "jira.version.id"
                                                    },
                                                    v5,
                                                    v6,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraReleaseNotesConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "releaseNotesConfiguration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v7,
                                                                    "action": "THROW",
                                                                    "path": "jira.version.releaseNotesConfiguration.issueKeyConfig"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v8,
                                                                    "action": "THROW",
                                                                    "path": "jira.version.releaseNotesConfiguration.issueFieldIds"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v9,
                                                                    "action": "THROW",
                                                                    "path": "jira.version.releaseNotesConfiguration.issueTypeIds"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.version.releaseNotesConfiguration"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "args": v10,
                                                            "concreteType": "JiraIssueTypeConnection",
                                                            "kind": "LinkedField",
                                                            "name": "releaseNotesOptionsIssueTypes",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueTypeEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "FragmentSpread",
                                                                                "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModal_jiraIssueTypeEdges"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.version.releaseNotesOptionsIssueTypes.edges"
                                                                }
                                                            ],
                                                            "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.version.releaseNotesOptionsIssueTypes"
                                                    },
                                                    {
                                                        "args": v11,
                                                        "kind": "FragmentSpread",
                                                        "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalContent_version"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "formattingOptions_softwareReleasesAddReleaseNotesModal"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "embeddedPageReleaseNotes_softwareReleasesAddReleaseNotesModal_EmbeddedPageReleaseNotesModal"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "analyticsContext_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalAnalyticsContext"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versionSelector_softwareReleasesAddReleaseNotesModal"
                                                    },
                                                    {
                                                        "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                                                        "kind": "LinkedField",
                                                        "name": "availableSites",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v12,
                                                                                        "action": "LOG",
                                                                                        "path": "jira.version.availableSites.edges.node.isSystem"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "LOG",
                                                                            "path": "jira.version.availableSites.edges.node"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "LOG",
                                                                "path": "jira.version.availableSites.edges"
                                                            }
                                                        ]
                                                    },
                                                    v13
                                                ],
                                                "type": "JiraVersion"
                                            },
                                            v14
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.version"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "uiReleaseNotesModalQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v4,
                                            v5,
                                            v6,
                                            {
                                                "concreteType": "JiraReleaseNotesConfiguration",
                                                "kind": "LinkedField",
                                                "name": "releaseNotesConfiguration",
                                                "plural": false,
                                                "selections": [
                                                    v7,
                                                    v8,
                                                    v9
                                                ]
                                            },
                                            {
                                                "args": v10,
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "releaseNotesOptionsIssueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueTypeEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v4,
                                                                    v15,
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "xsmall"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v3
                                                                ]
                                                            },
                                                            v16
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "PageInfo",
                                                        "kind": "LinkedField",
                                                        "name": "pageInfo",
                                                        "plural": false,
                                                        "selections": [
                                                            v17,
                                                            v18
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                                            },
                                            {
                                                "args": v10,
                                                "handle": "connection",
                                                "key": "issueTypeSelector_releaseNotesOptionsIssueTypes",
                                                "kind": "LinkedHandle",
                                                "name": "releaseNotesOptionsIssueTypes"
                                            },
                                            {
                                                "args": v11,
                                                "concreteType": "JiraADF",
                                                "kind": "LinkedField",
                                                "name": "releaseNotes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "json"
                                                    }
                                                ]
                                            },
                                            {
                                                "args": v10,
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "releaseNotesOptionsIssueFields",
                                                "plural": false,
                                                "selections": v19,
                                                "storageKey": "releaseNotesOptionsIssueFields(first:100)"
                                            },
                                            {
                                                "args": v10,
                                                "filters": v20,
                                                "handle": "connection",
                                                "key": "issueFieldSelectors_releaseNotesOptionsIssueFields",
                                                "kind": "LinkedHandle",
                                                "name": "releaseNotesOptionsIssueFields"
                                            },
                                            {
                                                "args": v21,
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "nativeReleaseNotesOptionsIssueFields",
                                                "plural": false,
                                                "selections": v19,
                                                "storageKey": "nativeReleaseNotesOptionsIssueFields(first:10)"
                                            },
                                            {
                                                "args": v21,
                                                "filters": v20,
                                                "handle": "connection",
                                                "key": "issueFieldSelectors_nativeReleaseNotesOptionsIssueFields",
                                                "kind": "LinkedHandle",
                                                "name": "nativeReleaseNotesOptionsIssueFields"
                                            },
                                            {
                                                "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                                                "kind": "LinkedField",
                                                "name": "availableSites",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v12
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            v13
                                        ],
                                        "type": "JiraVersion"
                                    },
                                    v14,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v4
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "37f717b64e4486e6291f013eacaff04d5801050c0cedd59372868f44083b4686",
                "metadata": {},
                "name": "uiReleaseNotesModalQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $c9a3cf061de648cd$var$node.hash = "f68c70e5840c60381e97022c22e35462";
    var $c9a3cf061de648cd$export$2e2bcd8739ae039 = $c9a3cf061de648cd$var$node;
});
parcelRegister("4i1Dv", function(module, exports) {
    $parcel$export(module.exports, "ReleaseNotesModal", ()=>$4e0db3a273624333$export$d334132901e7fcb2);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1R1Ge;
    var $7QSqG;
    var $eZJjh;
    var $9fuVs;
    var $4R6GH;
    var $lfTZh;
    var $kxZPA;
    const $4e0db3a273624333$var$LazyReleaseNotesModalContent = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("4qdC1")).then((module)=>module.ReleaseNotesModalContent), {
        moduleId: "./src/packages/releases/release-notes-modal/src/ui/index.tsx"
    });
    const $4e0db3a273624333$var$LazyEmbeddedPageReleaseNotesEditorModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("f9ftL")).then((module)=>module.EmbeddedPageReleaseNotesEditorModal), {
        moduleId: "./src/packages/releases/release-notes-modal/src/ui/embedded-page-release-notes-editor-modal/index.tsx"
    });
    const $4e0db3a273624333$var$LoadingModalBody = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($4e0db3a273624333$export$43a792a870d28db2, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large"
        })));
    const $4e0db3a273624333$export$d334132901e7fcb2 = (props)=>{
        const [confluenceReleaseNotesDraftUrl, setConfluenceReleaseNotesDraftUrl] = (0, $5uXOq.useState)(null);
        const { onClose: onClose } = props;
        const onCreateConfluenceReleaseNotes = (0, $5uXOq.useCallback)((draftUrl)=>{
            setConfluenceReleaseNotesDraftUrl(draftUrl);
        }, []);
        const onCloseConfluenceReleaseNotes = (0, $5uXOq.useCallback)(()=>{
            setConfluenceReleaseNotesDraftUrl(null);
            onClose();
        }, [
            onClose
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, (0, parcelRequire("4R6GH")).fg)('embedded_automated_release_notes') && confluenceReleaseNotesDraftUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement($4e0db3a273624333$var$LazyEmbeddedPageReleaseNotesEditorModal, {
            draftUrl: confluenceReleaseNotesDraftUrl,
            onClose: onCloseConfluenceReleaseNotes
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "x-large",
            autoFocus: false,
            onClose: props.onClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "release-notes-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($4e0db3a273624333$var$LoadingModalBody, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4e0db3a273624333$var$LazyReleaseNotesModalContent, {
            ...props,
            onCreateConfluenceReleaseNotes: onCreateConfluenceReleaseNotes
        }))));
    };
    const $4e0db3a273624333$export$43a792a870d28db2 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kdj",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("4qdC1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cXbgi")
    ]).then(()=>parcelRequire('lk3mD'));
});
parcelRegister("f9ftL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("6C8yY")
    ]).then(()=>parcelRequire('8qZpw'));
});
parcelRegister("lqWUw", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$b15b9ab9c95e18c3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aB8eX = parcelRequire("aB8eX");
    var $jD5no;
    var $9pe79;
    var $bxJen;
    var $3yLu1;
    var $dGae8;
    var $6FZ5A;
    class $b15b9ab9c95e18c3$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.store = (0, (0, parcelRequire("dGae8")).default)((0, (0, parcelRequire("bxJen")).default));
            this.setAppProps(this.props);
            this.store.dispatch((0, (0, parcelRequire("3yLu1")).initialRequest)(this.props.versionId));
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if ((0, (0, parcelRequire("9pe79")).default)(nextProps, this.props)) return;
            this.setAppProps(this.props);
        }
        setAppProps(props) {
            const { baseUrl: baseUrl, projectKey: projectKey, onOpened: onOpened, onError: onError, onSuccess: onSuccess, onCancel: onCancel, shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption = false, hasReleaseNote: hasReleaseNote = false } = props;
            this.store.dispatch((0, $aB8eX.batchActions)([
                (0, (0, parcelRequire("3yLu1")).setContext)({
                    baseUrl: baseUrl,
                    projectKey: projectKey
                }),
                (0, (0, parcelRequire("3yLu1")).setHandlers)({
                    onOpened: onOpened,
                    onError: onError,
                    onSuccess: onSuccess,
                    onCancel: onCancel
                }),
                (0, (0, parcelRequire("3yLu1")).setCreateReleaseNotesOptionConfig)({
                    shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption,
                    hasReleaseNote: hasReleaseNote
                })
            ]));
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
                store: this.store,
                id: "versionReleaseModal"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6FZ5A")).default), null));
        }
    }
});
parcelRegister("bxJen", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4baa4be00b04d5f9$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $5Lfyk;
    var $cHY1X;
    var $4baa4be00b04d5f9$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("5Lfyk")).initialRequestEpic), (0, (0, parcelRequire("5Lfyk")).fetchUnresolvedIssues), (0, (0, parcelRequire("cHY1X")).initialRequestSuccessEpic), (0, (0, parcelRequire("5Lfyk")).releaseVersionRequestEpic), (0, (0, parcelRequire("cHY1X")).releaseVersionRequestFailureEpic), (0, (0, parcelRequire("cHY1X")).releaseVersionRequestSuccessEpic));
});
parcelRegister("5Lfyk", function(module, exports) {
    $parcel$export(module.exports, "initialRequestEpic", ()=>$45a7f90f7cc0949b$export$73dafa621a3e5eba);
    $parcel$export(module.exports, "fetchUnresolvedIssues", ()=>$45a7f90f7cc0949b$export$5f5c175d78772606);
    $parcel$export(module.exports, "releaseVersionRequestEpic", ()=>$45a7f90f7cc0949b$export$b327638b0f58ac49);
    parcelRequire("fp4O3");
    parcelRequire("9o0uh");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $gccSB = parcelRequire("gccSB");
    var $fr1K2 = parcelRequire("fr1K2");
    var $3NMrl = parcelRequire("3NMrl");
    var $kVLXA = parcelRequire("kVLXA");
    var $fsh9d;
    var $c42uT;
    var $3yLu1;
    var $ai3Yq;
    const $45a7f90f7cc0949b$export$73dafa621a3e5eba = (action$, store)=>action$.ofType((0, (0, parcelRequire("3yLu1")).INITIAL_REQUEST)).mergeMap(({ payload: versionId })=>{
            const state = store.getState();
            const baseUrl = (0, (0, parcelRequire("ai3Yq")).getBaseUrl)(state);
            return (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("c42uT")).getVersion)(baseUrl, versionId)).mergeMap((version)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("3yLu1")).initialRequestSuccess)(version))).catch((error)=>{
                (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, 'project-directories.versions.release.ops.get.version', (0, $71a059cf91522abc$export$6c87c1302bf5163c));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("3yLu1")).releaseVersionFailure)({
                    id: versionId
                }));
            });
        });
    const $45a7f90f7cc0949b$export$5f5c175d78772606 = (action$, store)=>action$.ofType((0, (0, parcelRequire("3yLu1")).INITIAL_REQUEST)).mergeMap(({ payload: versionId })=>{
            const state = store.getState();
            const baseUrl = (0, (0, parcelRequire("ai3Yq")).getBaseUrl)(state);
            return (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("c42uT")).getUnresolvedIssues)(baseUrl, versionId)).mergeMap((unresolvedIssuesCount)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("3yLu1")).setUnreleasedIssuesCount)(unresolvedIssuesCount))).catch((error)=>{
                (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, 'project-directories.versions.release.ops.get.getUnresolvedIssues', (0, $71a059cf91522abc$export$6c87c1302bf5163c));
                return (0, $kVLXA.Observable).empty();
            });
        });
    const $45a7f90f7cc0949b$export$b327638b0f58ac49 = (action$, store)=>action$.ofType((0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_REQUEST)).mergeMap(()=>{
            const state = store.getState();
            const baseUrl = (0, (0, parcelRequire("ai3Yq")).getBaseUrl)(state);
            const keepIssues = (0, (0, parcelRequire("ai3Yq")).isKeepingIssues)(state);
            const version = (0, (0, parcelRequire("ai3Yq")).getVersion)(state);
            const versionToRelease = keepIssues ? (0, ($parcel$interopDefault($fr1K2)))(version, 'moveUnfixedIssuesTo') : version;
            return (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("c42uT")).releaseVersion)(baseUrl, versionToRelease)).mergeMap((releasedVersion)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("3yLu1")).releaseVersionSuccess)(releasedVersion))).catch((error)=>{
                try {
                    const errors = (0, ($parcel$interopDefault($3NMrl)))(JSON.parse(error.message).errors, [
                        'releaseDate',
                        'moveUnfixedIssuesTo'
                    ]);
                    if (!(0, ($parcel$interopDefault($gccSB)))(errors)) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("3yLu1")).releaseVersionValidationFailure)(errors));
                } catch (e) {}
                (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, 'project-directories.versions.release.ops.release.version', (0, $71a059cf91522abc$export$6c87c1302bf5163c));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("3yLu1")).releaseVersionFailure)());
            });
        });
});
parcelRegister("fsh9d", function(module, exports) {
    $parcel$export(module.exports, "logSafeErrorWithoutCustomerData", ()=>$064efdbf2b7e743c$export$c77be5886e7f1d9e);
    var $dJl1T;
    const $064efdbf2b7e743c$export$b94ad046ae639a1c = (error, location, suffix, message)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, message || error.message, error);
    const $064efdbf2b7e743c$export$c77be5886e7f1d9e = (error, location, suffix, message)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, message || error.message, error);
});
const $71a059cf91522abc$export$595d93fed3fb6b04 = 'jiraReleasesVersions';
const $71a059cf91522abc$export$6c87c1302bf5163c = 'directories.versions.error';
parcelRegister("c42uT", function(module, exports) {
    $parcel$export(module.exports, "getVersion", ()=>$c81fe9e74b3610a0$export$c506eb22e615ba4a);
    $parcel$export(module.exports, "getUnresolvedIssues", ()=>$c81fe9e74b3610a0$export$d98ed0fcfb679bfe);
    $parcel$export(module.exports, "releaseVersion", ()=>$c81fe9e74b3610a0$export$b8e3d145af76ef26);
    $parcel$export(module.exports, "useReleaseAutomationBanner", ()=>$c81fe9e74b3610a0$export$d9a4a1588da51f7c);
    var $5uXOq = parcelRequire("5uXOq");
    var $90yGq;
    var $hhRBl;
    var $5Y6UB;
    var $gCDZi;
    var $kMTMr;
    var $agk64;
    const $c81fe9e74b3610a0$export$c506eb22e615ba4a = (baseUrl, versionId)=>(0, (0, parcelRequire("hhRBl")).getVersion)(baseUrl, versionId).then((0, (0, parcelRequire("5Y6UB")).transformVersion)).then((0, (0, parcelRequire("kMTMr")).addDefaultReleaseDate));
    const $c81fe9e74b3610a0$export$d98ed0fcfb679bfe = (baseUrl, versionId)=>(0, (0, parcelRequire("hhRBl")).getUnresolvedIssuesCount)(baseUrl, versionId).then((0, (0, parcelRequire("5Y6UB")).transformUnresolvedIssuesCount));
    const $c81fe9e74b3610a0$export$b8e3d145af76ef26 = (baseUrl, version)=>(0, (0, parcelRequire("gCDZi")).releaseVersion)(baseUrl, (0, (0, parcelRequire("kMTMr")).transformReleasableToRestVersion)(version)).then((0, (0, parcelRequire("5Y6UB")).transformVersion));
    const $c81fe9e74b3610a0$export$d9a4a1588da51f7c = ()=>{
        const [showBanner, setShowBanner] = (0, $5uXOq.useState)(false);
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        (0, $5uXOq.useEffect)(()=>{
            if (accountId != null) (0, (0, parcelRequire("agk64")).getHasDismissedReleaseAutomationBanner)(accountId).then((hasDismissed)=>setShowBanner(!hasDismissed)).catch((0, (0, parcelRequire("agk64")).fireReleaseAutomationBannerError));
        }, [
            accountId
        ]);
        const dismissBanner = async ()=>{
            setShowBanner(false);
            if (accountId != null) await (0, (0, parcelRequire("agk64")).dismissReleaseAutomationBanner)(accountId).catch((0, (0, parcelRequire("agk64")).fireReleaseAutomationBannerError));
        };
        return {
            showBanner: showBanner,
            dismissBanner: dismissBanner
        };
    };
});
parcelRegister("hhRBl", function(module, exports) {
    $parcel$export(module.exports, "getVersionEndpointUrl", ()=>$8d02574a1b02ba22$export$9513b66f34c81f7d);
    $parcel$export(module.exports, "getVersion", ()=>$8d02574a1b02ba22$export$c506eb22e615ba4a);
    $parcel$export(module.exports, "getUnresolvedIssuesCount", ()=>$8d02574a1b02ba22$export$b7679bf23524baba);
    var $7f4tk;
    const $8d02574a1b02ba22$export$9513b66f34c81f7d = (baseUrl, versionId)=>`${baseUrl}/rest/api/2/version/${versionId}`;
    const $8d02574a1b02ba22$export$18ba274da71f4912 = (baseUrl, versionId)=>`${$8d02574a1b02ba22$export$9513b66f34c81f7d(baseUrl, versionId)}?expand=issuesstatus`;
    const $8d02574a1b02ba22$export$fdc7e642e6597237 = (baseUrl, versionId)=>`${$8d02574a1b02ba22$export$9513b66f34c81f7d(baseUrl, versionId)}/unresolvedIssueCount`;
    const $8d02574a1b02ba22$export$c506eb22e615ba4a = (baseUrl, versionId)=>(0, (0, parcelRequire("7f4tk")).default)($8d02574a1b02ba22$export$18ba274da71f4912(baseUrl, versionId));
    const $8d02574a1b02ba22$export$b7679bf23524baba = (baseUrl, versionId)=>(0, (0, parcelRequire("7f4tk")).default)($8d02574a1b02ba22$export$fdc7e642e6597237(baseUrl, versionId));
});
parcelRegister("5Y6UB", function(module, exports) {
    $parcel$export(module.exports, "transformVersion", ()=>$62220a7fcc1eb582$export$390ab7123357e756);
    $parcel$export(module.exports, "transformUnresolvedIssuesCount", ()=>$62220a7fcc1eb582$export$9c917bd1ad6cfd7f);
    var $brjCS;
    const $62220a7fcc1eb582$var$transformStatus = (archived, released)=>{
        if (archived) return 0, (0, parcelRequire("brjCS")).ARCHIVED;
        if (released) return 0, (0, parcelRequire("brjCS")).RELEASED;
        return 0, (0, parcelRequire("brjCS")).UNRELEASED;
    };
    const $62220a7fcc1eb582$var$transformIssuesStatus = ({ toDo: toDo, inProgress: inProgress, done: done })=>({
            toDo: toDo,
            inProgress: inProgress,
            done: done
        });
    const $62220a7fcc1eb582$export$390ab7123357e756 = (restVersion)=>{
        const version = {
            id: restVersion.id,
            name: restVersion.name,
            description: restVersion.description ? restVersion.description : '',
            status: $62220a7fcc1eb582$var$transformStatus(restVersion.archived, restVersion.released),
            startDate: restVersion.startDate,
            releaseDate: restVersion.releaseDate,
            overdue: !!restVersion.overdue,
            projectId: restVersion.projectId
        };
        if (restVersion.issuesStatusForFixVersion) version.issuesStatus = $62220a7fcc1eb582$var$transformIssuesStatus(restVersion.issuesStatusForFixVersion);
        return version;
    };
    const $62220a7fcc1eb582$export$9c917bd1ad6cfd7f = (rest)=>rest.issuesUnresolvedCount;
});
parcelRegister("gCDZi", function(module, exports) {
    $parcel$export(module.exports, "releaseVersion", ()=>$24fa99d1c29a27de$export$b8e3d145af76ef26);
    var $9RyXH;
    var $hhRBl;
    const $24fa99d1c29a27de$export$b8e3d145af76ef26 = (baseUrl, version)=>{
        const url = (0, (0, parcelRequire("hhRBl")).getVersionEndpointUrl)(baseUrl, version.id);
        return (0, (0, parcelRequire("9RyXH")).default)(url, {
            method: 'put',
            body: JSON.stringify({
                ...version
            })
        });
    };
});
parcelRegister("9RyXH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01c4a849d3703fe6$export$2e2bcd8739ae039);
    var $aDvGo;
    var $jJZqs;
    var $01c4a849d3703fe6$export$2e2bcd8739ae039 = (url, options = {})=>{
        const option = {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        };
        return fetch(url, option).then((response)=>{
            if (!response.ok) {
                const { status: status } = response;
                return response.text().then((str)=>{
                    throw new (0, (0, parcelRequire("jJZqs")).default)(status, str);
                });
            }
            return response.json();
        });
    };
});
parcelRegister("kMTMr", function(module, exports) {
    $parcel$export(module.exports, "transformReleasableToRestVersion", ()=>$9820223a518af481$export$6c7ef87ae81a803f);
    $parcel$export(module.exports, "addDefaultReleaseDate", ()=>$9820223a518af481$export$a3871b8272282d64);
    var $fr1K2 = parcelRequire("fr1K2");
    var $kMUwX;
    const $9820223a518af481$export$6c7ef87ae81a803f = (version)=>{
        const restVersion = (0, ($parcel$interopDefault($fr1K2)))(version, [
            'issuesStatus'
        ]);
        return {
            ...restVersion,
            released: true,
            releaseDate: (0, (0, parcelRequire("kMUwX")).atlasKitToServerDateFormat)(version.releaseDate)
        };
    };
    const $9820223a518af481$export$a3871b8272282d64 = (version)=>{
        const { id: id, name: name, releaseDate: releaseDate, issuesStatus: issuesStatus } = version;
        return {
            id: id,
            name: name,
            issuesStatus: issuesStatus,
            moveUnfixedIssuesTo: '',
            releaseDate: releaseDate ? (0, (0, parcelRequire("kMUwX")).ISOToAtlasKitDateFormat)(releaseDate) : (0, (0, parcelRequire("kMUwX")).todayToAtlasKitDateFormat)()
        };
    };
});
parcelRegister("kMUwX", function(module, exports) {
    $parcel$export(module.exports, "ISOToAtlasKitDateFormat", ()=>$013f23539a74f0d2$export$4df2a4adbb0e5391);
    $parcel$export(module.exports, "todayToAtlasKitDateFormat", ()=>$013f23539a74f0d2$export$d9939b5b983bc908);
    $parcel$export(module.exports, "atlasKitToServerDateFormat", ()=>$013f23539a74f0d2$export$bcd9d8ad44970e94);
    var $k7m40;
    var $b77vc;
    var $jovBr;
    var $eZDAP;
    var $htiPW;
    const $013f23539a74f0d2$export$c9b0b9ddba618847 = (dateStr)=>{
        if (dateStr) {
            const date = (0, (0, parcelRequire("eZDAP")).default)(dateStr.replace(/\//g, '-'));
            if ((0, (0, parcelRequire("jovBr")).default)(date)) return (0, (0, parcelRequire("k7m40")).default)(new Date(date), 'yyyy-MM-dd');
        }
        return '';
    };
    const $013f23539a74f0d2$export$4df2a4adbb0e5391 = (dateStr)=>{
        if (dateStr) {
            const date = (0, (0, parcelRequire("eZDAP")).default)(dateStr);
            if ((0, (0, parcelRequire("jovBr")).default)(date)) return (0, (0, parcelRequire("k7m40")).default)(new Date(date), 'yyyy/MM/dd');
        }
        return '';
    };
    const $013f23539a74f0d2$export$d9939b5b983bc908 = ()=>(0, (0, parcelRequire("k7m40")).default)((0, (0, parcelRequire("htiPW")).default)(), 'yyyy/MM/dd');
    const $013f23539a74f0d2$export$6350eb346dee22fe = (dateStr)=>{
        if (dateStr) return (0, (0, parcelRequire("jovBr")).default)((0, (0, parcelRequire("eZDAP")).default)(dateStr.replace(/\//g, '-')));
        return false;
    };
    const $013f23539a74f0d2$export$bcd9d8ad44970e94 = (dateStr)=>{
        let dateISO;
        if (dateStr && $013f23539a74f0d2$export$6350eb346dee22fe(dateStr)) dateISO = $013f23539a74f0d2$export$c9b0b9ddba618847(dateStr);
        return dateISO || null;
    };
    const $013f23539a74f0d2$export$e36c611b04695a2e = (dateStr)=>{
        const date = (0, (0, parcelRequire("eZDAP")).default)(dateStr);
        if ((0, (0, parcelRequire("jovBr")).default)(date)) return (0, (0, parcelRequire("b77vc")).default)(date);
        return undefined;
    };
    const $013f23539a74f0d2$export$8d60448f563c47a6 = {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
    };
});
parcelRegister("agk64", function(module, exports) {
    $parcel$export(module.exports, "getHasDismissedReleaseAutomationBanner", ()=>$42933e7c8516f8fa$export$b8702a08258e1098);
    $parcel$export(module.exports, "dismissReleaseAutomationBanner", ()=>$42933e7c8516f8fa$export$7f678873378110b8);
    $parcel$export(module.exports, "fireReleaseAutomationBannerError", ()=>$42933e7c8516f8fa$export$76cf25de6ffb8030);
    var $aDvGo;
    var $jcw0u;
    const $42933e7c8516f8fa$export$b8702a08258e1098 = async (accountId)=>{
        const fetchResponse = await fetch(`/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`, (0, (0, parcelRequire("aDvGo")).default));
        if (fetchResponse.ok) {
            const responseObj = await fetchResponse.json();
            return responseObj.value;
        }
        const { status: status } = fetchResponse;
        if (status === 401) return true;
        if (status === 404) return false;
        throw new Error(`Fetching hasDismisssedReleaseAutomationBanner user property failed. Status code: ${fetchResponse.status}`);
    };
    const $42933e7c8516f8fa$export$7f678873378110b8 = async (accountId)=>{
        const fetchResponse = await fetch(`/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            method: 'PUT',
            body: JSON.stringify(true)
        });
        if (!fetchResponse.ok) throw Error('Failed to dismiss release automation banner via user properties.');
    };
    const $42933e7c8516f8fa$export$76cf25de6ffb8030 = (error)=>(0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: 'versions.release.version.modal.release.automation.user.property',
                packageName: 'jiraVersionModals',
                teamName: 'fusion-solaris'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
});
parcelRegister("3yLu1", function(module, exports) {
    $parcel$export(module.exports, "SET_CONTEXT", ()=>$efa9dcf433ebc4c7$export$4bc4e62e7d72b94b);
    $parcel$export(module.exports, "setContext", ()=>$efa9dcf433ebc4c7$export$2f04de43fe27971a);
    $parcel$export(module.exports, "SET_HANDLERS", ()=>$efa9dcf433ebc4c7$export$bc2eae499d5e6cec);
    $parcel$export(module.exports, "setHandlers", ()=>$efa9dcf433ebc4c7$export$241365d6eef6c169);
    $parcel$export(module.exports, "INITIAL_REQUEST", ()=>$efa9dcf433ebc4c7$export$e1efaa8f406867bb);
    $parcel$export(module.exports, "initialRequest", ()=>$efa9dcf433ebc4c7$export$3bccc812fdbc3954);
    $parcel$export(module.exports, "INITIAL_REQUEST_SUCCESS", ()=>$efa9dcf433ebc4c7$export$37a4e72ae1c0a1b5);
    $parcel$export(module.exports, "initialRequestSuccess", ()=>$efa9dcf433ebc4c7$export$fbef4e4c40c06dae);
    $parcel$export(module.exports, "SET_VERSION_UNRESOLVED_ISSUES_COUNT", ()=>$efa9dcf433ebc4c7$export$a558394b02430fa);
    $parcel$export(module.exports, "setUnreleasedIssuesCount", ()=>$efa9dcf433ebc4c7$export$521ad3c091ef9f4b);
    $parcel$export(module.exports, "SWAP_ISSUES", ()=>$efa9dcf433ebc4c7$export$1e105c795f4df801);
    $parcel$export(module.exports, "swapIssues", ()=>$efa9dcf433ebc4c7$export$f9d0b46042c1093d);
    $parcel$export(module.exports, "RELEASE_VERSION_UPDATE", ()=>$efa9dcf433ebc4c7$export$a7943bb075347bd4);
    $parcel$export(module.exports, "releaseVersionUpdate", ()=>$efa9dcf433ebc4c7$export$6e5a7b93aba64e1c);
    $parcel$export(module.exports, "RELEASE_VERSION_REQUEST", ()=>$efa9dcf433ebc4c7$export$b482a6a2418379a4);
    $parcel$export(module.exports, "releaseVersionRequest", ()=>$efa9dcf433ebc4c7$export$f25b64441359ac5d);
    $parcel$export(module.exports, "RELEASE_VERSION_SUCCESS", ()=>$efa9dcf433ebc4c7$export$9f45f3d28614fd39);
    $parcel$export(module.exports, "releaseVersionSuccess", ()=>$efa9dcf433ebc4c7$export$ef2ca233886223dd);
    $parcel$export(module.exports, "RELEASE_VERSION_FAILURE", ()=>$efa9dcf433ebc4c7$export$f79008eab89d4f56);
    $parcel$export(module.exports, "releaseVersionFailure", ()=>$efa9dcf433ebc4c7$export$f40837cd887e0e7d);
    $parcel$export(module.exports, "RELEASE_VERSION_VALIDATION_FAILURE", ()=>$efa9dcf433ebc4c7$export$15feef518e3a0f72);
    $parcel$export(module.exports, "releaseVersionValidationFailure", ()=>$efa9dcf433ebc4c7$export$d206bb816a78117c);
    $parcel$export(module.exports, "CREATE_RELEASE_NOTES_OPTIONS", ()=>$efa9dcf433ebc4c7$export$95df9c1149c6615a);
    $parcel$export(module.exports, "setCreateReleaseNotesOptionConfig", ()=>$efa9dcf433ebc4c7$export$778db09b7ef0e606);
    $parcel$export(module.exports, "RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS", ()=>$efa9dcf433ebc4c7$export$95c8c0da90c589f);
    $parcel$export(module.exports, "releaseRedirectToCreateReleaseNotesStatus", ()=>$efa9dcf433ebc4c7$export$bec051bc82fda7b3);
    const $efa9dcf433ebc4c7$export$4bc4e62e7d72b94b = 'release-version-modal.state.SET_CONTEXT';
    const $efa9dcf433ebc4c7$export$2f04de43fe27971a = (payload)=>({
            type: $efa9dcf433ebc4c7$export$4bc4e62e7d72b94b,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$bc2eae499d5e6cec = 'release-version-modal.state.SET_HANDLERS';
    const $efa9dcf433ebc4c7$export$241365d6eef6c169 = (payload)=>({
            type: $efa9dcf433ebc4c7$export$bc2eae499d5e6cec,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$e1efaa8f406867bb = 'release-version-modal.state.INITIAL_REQUEST';
    const $efa9dcf433ebc4c7$export$3bccc812fdbc3954 = (versionId)=>({
            type: $efa9dcf433ebc4c7$export$e1efaa8f406867bb,
            payload: versionId
        });
    const $efa9dcf433ebc4c7$export$37a4e72ae1c0a1b5 = 'release-version-modal.state.INITIAL_REQUEST_SUCCESS';
    const $efa9dcf433ebc4c7$export$fbef4e4c40c06dae = (version)=>({
            type: $efa9dcf433ebc4c7$export$37a4e72ae1c0a1b5,
            payload: version
        });
    const $efa9dcf433ebc4c7$export$a558394b02430fa = 'release-version-modal.state.SET_VERSION_UNRESOLVED_ISSUES_COUNT';
    const $efa9dcf433ebc4c7$export$521ad3c091ef9f4b = (payload)=>({
            type: $efa9dcf433ebc4c7$export$a558394b02430fa,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$33d1af9ce619539e = 'release-version-modal.state.SET_VERSION';
    const $efa9dcf433ebc4c7$export$f99c3c9c04cda7ae = (payload)=>({
            type: $efa9dcf433ebc4c7$export$33d1af9ce619539e,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$1e105c795f4df801 = 'release-version-modal.state.SWAP_ISSUES';
    const $efa9dcf433ebc4c7$export$f9d0b46042c1093d = (payload)=>({
            type: $efa9dcf433ebc4c7$export$1e105c795f4df801,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$a7943bb075347bd4 = 'release-version-modal.state.RELEASE_VERSION_UPDATE';
    const $efa9dcf433ebc4c7$export$6e5a7b93aba64e1c = (payload)=>({
            type: $efa9dcf433ebc4c7$export$a7943bb075347bd4,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$b482a6a2418379a4 = 'release-version-modal.state.RELEASE_VERSION_REQUEST';
    const $efa9dcf433ebc4c7$export$f25b64441359ac5d = ()=>({
            type: $efa9dcf433ebc4c7$export$b482a6a2418379a4
        });
    const $efa9dcf433ebc4c7$export$9f45f3d28614fd39 = 'release-version-modal.state.RELEASE_VERSION_SUCCESS';
    const $efa9dcf433ebc4c7$export$ef2ca233886223dd = (payload)=>({
            type: $efa9dcf433ebc4c7$export$9f45f3d28614fd39,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$f79008eab89d4f56 = 'release-version-modal.state.RELEASE_VERSION_FAILURE';
    const $efa9dcf433ebc4c7$export$f40837cd887e0e7d = (payload)=>({
            type: $efa9dcf433ebc4c7$export$f79008eab89d4f56,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$15feef518e3a0f72 = 'release-version-modal.state.RELEASE_VERSION_VALIDATION_FAILURE';
    const $efa9dcf433ebc4c7$export$d206bb816a78117c = (payload)=>({
            type: $efa9dcf433ebc4c7$export$15feef518e3a0f72,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$95df9c1149c6615a = 'release-version-modal.state.CREATE_RELEASE_NOTES_OPTIONS';
    const $efa9dcf433ebc4c7$export$778db09b7ef0e606 = (payload)=>({
            type: $efa9dcf433ebc4c7$export$95df9c1149c6615a,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$95c8c0da90c589f = 'release-version-modal.state.RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS';
    const $efa9dcf433ebc4c7$export$bec051bc82fda7b3 = (payload)=>({
            type: $efa9dcf433ebc4c7$export$95c8c0da90c589f,
            payload: payload
        });
});
parcelRegister("ai3Yq", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$9799cf0a53e1d000$export$f654b28f82155665);
    $parcel$export(module.exports, "getProjectKey", ()=>$9799cf0a53e1d000$export$667f2a0f99c75faa);
    $parcel$export(module.exports, "getVersion", ()=>$9799cf0a53e1d000$export$c506eb22e615ba4a);
    $parcel$export(module.exports, "getVersionId", ()=>$9799cf0a53e1d000$export$d0a84488c5034e2b);
    $parcel$export(module.exports, "getTodoInProgressIssuesCount", ()=>$9799cf0a53e1d000$export$7c32856ef2a2cb6);
    $parcel$export(module.exports, "getUnresolvedIssuesCount", ()=>$9799cf0a53e1d000$export$b7679bf23524baba);
    $parcel$export(module.exports, "getResolvedIssuesCount", ()=>$9799cf0a53e1d000$export$96488947387acc21);
    $parcel$export(module.exports, "getDoneIssuesCount", ()=>$9799cf0a53e1d000$export$51a75c074eb3f4d4);
    $parcel$export(module.exports, "getName", ()=>$9799cf0a53e1d000$export$7d9f7e9c1c02b41e);
    $parcel$export(module.exports, "getReleaseDate", ()=>$9799cf0a53e1d000$export$9664966f747b3c18);
    $parcel$export(module.exports, "getErrors", ()=>$9799cf0a53e1d000$export$501239432719417d);
    $parcel$export(module.exports, "isSwapSelected", ()=>$9799cf0a53e1d000$export$8fff49f07292ff94);
    $parcel$export(module.exports, "isSaving", ()=>$9799cf0a53e1d000$export$3b51d1dcee070cea);
    $parcel$export(module.exports, "isInitiating", ()=>$9799cf0a53e1d000$export$8b35c3a55e549a0d);
    $parcel$export(module.exports, "getOnOpenedHandler", ()=>$9799cf0a53e1d000$export$9cb228195867c4ba);
    $parcel$export(module.exports, "getOnErrorHandler", ()=>$9799cf0a53e1d000$export$1a207b7e599ecdc7);
    $parcel$export(module.exports, "getOnSuccessHandler", ()=>$9799cf0a53e1d000$export$8fb55c0bc571e8e7);
    $parcel$export(module.exports, "getOnCancelHandler", ()=>$9799cf0a53e1d000$export$e776433ed4e15cc4);
    $parcel$export(module.exports, "getPropsForVersionPicker", ()=>$9799cf0a53e1d000$export$95a1217518b748b8);
    $parcel$export(module.exports, "isReleaseDisabled", ()=>$9799cf0a53e1d000$export$2a2f3b8b22c4af1f);
    $parcel$export(module.exports, "isKeepingIssues", ()=>$9799cf0a53e1d000$export$e783a0e680cad4ec);
    $parcel$export(module.exports, "shouldShowCreateReleaseNotesOption", ()=>$9799cf0a53e1d000$export$37c3a3cc47342e65);
    $parcel$export(module.exports, "shouldRedirectToCreateReleaseNotes", ()=>$9799cf0a53e1d000$export$24122e8f86a884b6);
    var $dGvGJ = parcelRequire("dGvGJ");
    const $9799cf0a53e1d000$export$f654b28f82155665 = (state)=>state.context.baseUrl;
    const $9799cf0a53e1d000$export$667f2a0f99c75faa = (state)=>state.context.projectKey;
    const $9799cf0a53e1d000$export$c506eb22e615ba4a = (state)=>state.version;
    const $9799cf0a53e1d000$export$57294fc3393f82ae = (state)=>state.version.moveUnfixedIssuesTo;
    const $9799cf0a53e1d000$export$d0a84488c5034e2b = (state)=>state.version.id;
    const $9799cf0a53e1d000$export$7c32856ef2a2cb6 = (state)=>{
        if (state.version.issuesStatus) return state.version.issuesStatus.toDo + state.version.issuesStatus.inProgress;
        return 0;
    };
    const $9799cf0a53e1d000$export$b7679bf23524baba = (state)=>state.unresolvedIssuesCount;
    const $9799cf0a53e1d000$export$36e4434605c3220 = (state)=>{
        if (state.version.issuesStatus) return state.version.issuesStatus.done + state.version.issuesStatus.toDo + state.version.issuesStatus.inProgress;
        return 0;
    };
    const $9799cf0a53e1d000$export$96488947387acc21 = (state)=>$9799cf0a53e1d000$export$36e4434605c3220(state) - $9799cf0a53e1d000$export$b7679bf23524baba(state);
    const $9799cf0a53e1d000$export$51a75c074eb3f4d4 = (state)=>{
        if (state.version.issuesStatus) return state.version.issuesStatus.done;
        return 0;
    };
    const $9799cf0a53e1d000$export$7d9f7e9c1c02b41e = (state)=>$9799cf0a53e1d000$export$c506eb22e615ba4a(state).name || '';
    const $9799cf0a53e1d000$export$9664966f747b3c18 = (state)=>$9799cf0a53e1d000$export$c506eb22e615ba4a(state).releaseDate || '';
    const $9799cf0a53e1d000$export$501239432719417d = (0, $dGvGJ.createSelector)((state)=>state.errors, (errors)=>{
        const { releaseDate: releaseDate = '', moveUnfixedIssuesTo: moveUnfixedIssuesTo = '' } = errors || {};
        return {
            releaseDate: releaseDate,
            moveUnfixedIssuesTo: moveUnfixedIssuesTo
        };
    });
    const $9799cf0a53e1d000$export$8fff49f07292ff94 = (state)=>state.shouldSwapIssues;
    const $9799cf0a53e1d000$export$3b51d1dcee070cea = (state)=>!!state.isSaving;
    const $9799cf0a53e1d000$export$8b35c3a55e549a0d = (state)=>!!state.isInitiating;
    const $9799cf0a53e1d000$export$9cb228195867c4ba = (state)=>state.handlers.onOpened;
    const $9799cf0a53e1d000$export$1a207b7e599ecdc7 = (state)=>state.handlers.onError;
    const $9799cf0a53e1d000$export$8fb55c0bc571e8e7 = (state)=>state.handlers.onSuccess;
    const $9799cf0a53e1d000$export$e776433ed4e15cc4 = (state)=>state.handlers.onCancel;
    const $9799cf0a53e1d000$export$95a1217518b748b8 = (state)=>({
            baseUrl: state.context.baseUrl,
            projectKey: state.context.projectKey,
            shouldSwapIssues: state.shouldSwapIssues,
            isSaving: state.isSaving,
            versionId: state.version.id
        });
    const $9799cf0a53e1d000$var$hasTodoInProgressIssues = (state)=>$9799cf0a53e1d000$export$7c32856ef2a2cb6(state) > 0;
    const $9799cf0a53e1d000$export$2a2f3b8b22c4af1f = (state)=>state.isSaving || $9799cf0a53e1d000$export$b7679bf23524baba(state) > 0 && state.shouldSwapIssues && !$9799cf0a53e1d000$export$57294fc3393f82ae(state);
    const $9799cf0a53e1d000$export$e783a0e680cad4ec = (state)=>{
        if ($9799cf0a53e1d000$var$hasTodoInProgressIssues(state)) return state.shouldSwapIssues ? !$9799cf0a53e1d000$export$57294fc3393f82ae(state) : true;
        return true;
    };
    const $9799cf0a53e1d000$export$37c3a3cc47342e65 = (state)=>state.shouldShowCreateReleaseNotesOption;
    const $9799cf0a53e1d000$export$24122e8f86a884b6 = (state)=>state.shouldRedirectToCreateReleaseNotes;
});
parcelRegister("cHY1X", function(module, exports) {
    $parcel$export(module.exports, "initialRequestSuccessEpic", ()=>$d761eb56ba97a1cf$export$9d210f02e9fc914d);
    $parcel$export(module.exports, "releaseVersionRequestSuccessEpic", ()=>$d761eb56ba97a1cf$export$77863bf7469abd8f);
    $parcel$export(module.exports, "releaseVersionRequestFailureEpic", ()=>$d761eb56ba97a1cf$export$79de050f634d0345);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    var $3yLu1;
    var $ai3Yq;
    const $d761eb56ba97a1cf$export$9d210f02e9fc914d = (action$, store)=>action$.ofType((0, (0, parcelRequire("3yLu1")).INITIAL_REQUEST_SUCCESS)).mergeMap(()=>{
            const state = store.getState();
            const versionId = (0, (0, parcelRequire("ai3Yq")).getVersionId)(state);
            (0, (0, parcelRequire("ai3Yq")).getOnOpenedHandler)(state)({
                id: versionId
            });
            return (0, $kVLXA.Observable).empty();
        });
    const $d761eb56ba97a1cf$export$77863bf7469abd8f = (action$, store)=>action$.ofType((0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_SUCCESS)).mergeMap(({ payload: version })=>{
            const state = store.getState();
            (0, (0, parcelRequire("ai3Yq")).getOnSuccessHandler)(state)(version, {
                shouldRedirectToCreateReleaseNotes: (0, (0, parcelRequire("ai3Yq")).shouldRedirectToCreateReleaseNotes)(state)
            });
            return (0, $kVLXA.Observable).empty();
        });
    const $d761eb56ba97a1cf$export$79de050f634d0345 = (action$, store)=>action$.ofType((0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_FAILURE)).mergeMap(({ payload: id })=>{
            const state = store.getState();
            (0, (0, parcelRequire("ai3Yq")).getOnErrorHandler)(state)(id);
            return (0, $kVLXA.Observable).empty();
        });
});
parcelRegister("dGae8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73fa150bafb032f5$export$2e2bcd8739ae039);
    var $F2Mxm;
    var $5lQMY;
    var $73fa150bafb032f5$export$2e2bcd8739ae039 = (rootEpic)=>(0, (0, parcelRequire("F2Mxm")).default)({
            appName: 'release-version',
            rootReducer: (0, parcelRequire("5lQMY")).default,
            rootEpic: rootEpic
        });
});
parcelRegister("5lQMY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d40ac852e63d3642$export$2e2bcd8739ae039);
    var $6Csk1 = parcelRequire("6Csk1");
    var $1UikQ = parcelRequire("1UikQ");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fr1K2 = parcelRequire("fr1K2");
    var $3yLu1;
    const $d40ac852e63d3642$export$d4c72bab9d6cc13a = {
        context: {
            baseUrl: '',
            projectKey: ''
        },
        handlers: {
            onOpened: (0, ($parcel$interopDefault($8Rkzz))),
            onError: (0, ($parcel$interopDefault($8Rkzz))),
            onSuccess: (0, ($parcel$interopDefault($8Rkzz))),
            onCancel: (0, ($parcel$interopDefault($8Rkzz)))
        },
        version: {
            id: '0',
            name: ''
        },
        unresolvedIssuesCount: 0,
        shouldSwapIssues: true,
        isInitiating: true,
        isSaving: false,
        shouldShowCreateReleaseNotesOption: false,
        hasReleaseNote: false,
        shouldRedirectToCreateReleaseNotes: true
    };
    var $d40ac852e63d3642$export$2e2bcd8739ae039 = (state = $d40ac852e63d3642$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("3yLu1")).SET_CONTEXT:
                {
                    const context = action.payload;
                    return {
                        ...state,
                        context: context
                    };
                }
            case 0, (0, parcelRequire("3yLu1")).SET_VERSION_UNRESOLVED_ISSUES_COUNT:
                {
                    const unresolvedIssuesCount = action.payload;
                    return {
                        ...state,
                        unresolvedIssuesCount: unresolvedIssuesCount || 0
                    };
                }
            case 0, (0, parcelRequire("3yLu1")).SWAP_ISSUES:
                return {
                    ...state,
                    shouldSwapIssues: action.payload
                };
            case 0, (0, parcelRequire("3yLu1")).SET_HANDLERS:
                {
                    const handlers = action.payload;
                    return {
                        ...state,
                        handlers: (0, ($parcel$interopDefault($1UikQ)))({}, state.handlers, handlers)
                    };
                }
            case 0, (0, parcelRequire("3yLu1")).INITIAL_REQUEST_SUCCESS:
                {
                    const version = action.payload;
                    return (0, ($parcel$interopDefault($fr1K2)))({
                        ...state,
                        version: version
                    }, 'isInitiating');
                }
            case 0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_UPDATE:
                {
                    const prevVersion = state.version;
                    const prevErrors = state.errors;
                    const nextVersion = action.payload;
                    const errors = {};
                    if (action.payload && action.payload.moveUnfixedIssuesTo) errors.moveUnfixedIssuesTo = '';
                    if (action.payload && action.payload.releaseDate) errors.releaseDate = '';
                    return {
                        ...state,
                        errors: (0, ($parcel$interopDefault($6Csk1)))({}, prevErrors, errors),
                        version: (0, ($parcel$interopDefault($6Csk1)))({}, prevVersion, nextVersion)
                    };
                }
            case 0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_VALIDATION_FAILURE:
                {
                    const errors = action.payload;
                    return (0, ($parcel$interopDefault($fr1K2)))({
                        ...state,
                        errors: errors
                    }, 'isSaving');
                }
            case 0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_REQUEST:
                return {
                    ...state,
                    isSaving: true
                };
            case 0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_SUCCESS:
            case 0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_FAILURE:
                return (0, ($parcel$interopDefault($fr1K2)))(state, 'isSaving');
            case 0, (0, parcelRequire("3yLu1")).INITIAL_REQUEST:
                return state;
            case 0, (0, parcelRequire("3yLu1")).CREATE_RELEASE_NOTES_OPTIONS:
                return {
                    ...state,
                    ...action.payload,
                    shouldRedirectToCreateReleaseNotes: !(action.payload?.hasReleaseNote ?? false)
                };
            case 0, (0, parcelRequire("3yLu1")).RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS:
                {
                    const shouldRedirectToCreateReleaseNotes = action.payload !== undefined ? action.payload : false;
                    return {
                        ...state,
                        shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes
                    };
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("6FZ5A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dba542cd4fb317a1$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3yLu1;
    var $ai3Yq;
    var $gdGCZ;
    var $61jfR;
    const $dba542cd4fb317a1$var$mapStateToProps = (state)=>({
            unresolvedIssuesCount: (0, (0, parcelRequire("ai3Yq")).getUnresolvedIssuesCount)(state),
            isReleaseDisabled: (0, (0, parcelRequire("ai3Yq")).isReleaseDisabled)(state),
            name: (0, (0, parcelRequire("ai3Yq")).getName)(state),
            isSaving: (0, (0, parcelRequire("ai3Yq")).isSaving)(state),
            isInitiating: (0, (0, parcelRequire("ai3Yq")).isInitiating)(state),
            onCancel: (0, (0, parcelRequire("ai3Yq")).getOnCancelHandler)(state),
            Content: (0, parcelRequire("gdGCZ")).default,
            shouldRedirectToCreateReleaseNotes: (0, (0, parcelRequire("ai3Yq")).shouldRedirectToCreateReleaseNotes)(state),
            shouldShowCreateReleaseNotesOption: (0, (0, parcelRequire("ai3Yq")).shouldShowCreateReleaseNotesOption)(state)
        });
    const $dba542cd4fb317a1$var$dispatcher = (dispatch)=>({
            onRelease: ()=>dispatch((0, (0, parcelRequire("3yLu1")).releaseVersionRequest)()),
            setRedirectToCreateReleaseNotesStatus: (value)=>dispatch((0, (0, parcelRequire("3yLu1")).releaseRedirectToCreateReleaseNotesStatus)(value))
        });
    const $dba542cd4fb317a1$var$mapDispatchToProps = (dispatch)=>$dba542cd4fb317a1$var$dispatcher(dispatch);
    var $dba542cd4fb317a1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($dba542cd4fb317a1$var$mapStateToProps, $dba542cd4fb317a1$var$mapDispatchToProps)((0, (0, parcelRequire("61jfR")).default));
});
parcelRegister("gdGCZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc6b5ee15f8b82ed$export$2e2bcd8739ae039);
    var $bC2fB;
    var $jC89g;
    var $ai3Yq;
    var $ixV8C;
    var $50qub;
    var $3nRuh;
    var $uKe1m;
    const $bc6b5ee15f8b82ed$var$mapStateToProps = (state)=>({
            SwapIssues: (0, parcelRequire("3nRuh")).default,
            ReleaseDate: (0, parcelRequire("50qub")).default,
            ReleaseAutomationBanner: (0, parcelRequire("ixV8C")).ReleaseAutomationBanner,
            doneIssues: (0, (0, parcelRequire("ai3Yq")).getDoneIssuesCount)(state),
            unresolvedIssuesCount: (0, (0, parcelRequire("ai3Yq")).getUnresolvedIssuesCount)(state),
            resolvedIssuesCount: (0, (0, parcelRequire("ai3Yq")).getResolvedIssuesCount)(state),
            unresolvedIssuesUrl: (0, (0, parcelRequire("jC89g")).getUnresolvedIssuesInVersionJql)((0, (0, parcelRequire("ai3Yq")).getProjectKey)(state), (0, (0, parcelRequire("ai3Yq")).getName)(state)),
            resolvedIssueUrl: (0, (0, parcelRequire("jC89g")).getResolvedIssuesInVersionJql)((0, (0, parcelRequire("ai3Yq")).getProjectKey)(state), (0, (0, parcelRequire("ai3Yq")).getName)(state))
        });
    var $bc6b5ee15f8b82ed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($bc6b5ee15f8b82ed$var$mapStateToProps, {})((0, (0, parcelRequire("uKe1m")).default));
});
parcelRegister("jC89g", function(module, exports) {
    $parcel$export(module.exports, "getUnresolvedIssuesInVersionJql", ()=>$a27f6842930b4a90$export$6ec377b2fc8168c7);
    $parcel$export(module.exports, "getResolvedIssuesInVersionJql", ()=>$a27f6842930b4a90$export$c14e075033246e76);
    var $cIy4l;
    const $a27f6842930b4a90$export$6ec377b2fc8168c7 = (projectKey, versionName)=>{
        const jql = `project = ${(0, (0, parcelRequire("cIy4l")).toQuotedString)(projectKey)} AND fixVersion = ${(0, (0, parcelRequire("cIy4l")).toQuotedString)(versionName)} AND resolution is EMPTY`;
        return (0, (0, parcelRequire("cIy4l")).createIssuesUrl)(jql);
    };
    const $a27f6842930b4a90$export$c14e075033246e76 = (projectKey, versionName)=>(0, (0, parcelRequire("cIy4l")).createIssuesUrl)(`project = ${(0, (0, parcelRequire("cIy4l")).toQuotedString)(projectKey)} AND fixVersion = ${(0, (0, parcelRequire("cIy4l")).toQuotedString)(versionName)} AND resolution is NOT EMPTY`);
});
parcelRegister("cIy4l", function(module, exports) {
    $parcel$export(module.exports, "toQuotedString", ()=>$ae91325110cc96a6$export$dbeab020a4aa404);
    $parcel$export(module.exports, "createIssuesUrl", ()=>$ae91325110cc96a6$export$c623a4b2d8c439ab);
    const $ae91325110cc96a6$var$ENCODE_MAP = {
        '\t': '\\t',
        '\n': '\\n',
        '\r': '\\r',
        '"': '\\"',
        "'": "\\'",
        '\\': '\\\\'
    };
    const $ae91325110cc96a6$export$946fe289c25510be = (character, ignoredCharacter)=>{
        if (character === ignoredCharacter) return character;
        return $ae91325110cc96a6$var$ENCODE_MAP[character] || character;
    };
    const $ae91325110cc96a6$export$dbeab020a4aa404 = (parameter)=>{
        let escaped = '';
        for(let position = 0; position < parameter.length; position += 1)escaped += $ae91325110cc96a6$export$946fe289c25510be(parameter[position], "'");
        return `"${escaped}"`;
    };
    const $ae91325110cc96a6$export$c623a4b2d8c439ab = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;
});
parcelRegister("ixV8C", function(module, exports) {
    $parcel$export(module.exports, "ReleaseAutomationBanner", ()=>$52f7cd2e766f7238$export$45e1a2bd60e730ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $itzrU;
    var $fVnbM;
    var $lLLkM;
    var $gOS29;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $2NMNM;
    var $dAfqg;
    var $c42uT;
    var $5d48Z = parcelRequire("5d48Z");
    var $4eavD;
    const $52f7cd2e766f7238$export$d6be0a6034032add = (projectProps)=>`${(0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)(projectProps)}#rule/new?componentFilterCriteria=RELEASE_MANAGEMENT_TRIGGERS`;
    const $52f7cd2e766f7238$export$45e1a2bd60e730ec = ({ isTransitionEnabled: isTransitionEnabled = true })=>{
        const { showBanner: showBanner, dismissBanner: dismissBanner } = (0, (0, parcelRequire("c42uT")).useReleaseAutomationBanner)();
        const { data: projectContext, loading: loading, error: error } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        if (loading) return null;
        if (error) throw error;
        if (projectContext == null) throw Error('Missing project context when rendering ReleaseAutomationBanner');
        const { simplified: isSimplified, projectKey: projectKey, projectType: projectType } = projectContext;
        const renderBannerContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($52f7cd2e766f7238$var$Spacer, null), (0, ($parcel$interopDefault($5uXOq))).createElement($52f7cd2e766f7238$var$Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            width: 14,
            height: 16,
            src: (0, ($parcel$interopDefault($5d48Z))),
            alt: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($52f7cd2e766f7238$var$CallToAction, {
            href: $52f7cd2e766f7238$export$d6be0a6034032add({
                isSimplified: isSimplified,
                projectKey: projectKey,
                projectType: projectType
            }),
            target: "_blank",
            rel: "noopener noreferrer",
            title: formatMessage((0, (0, parcelRequire("4eavD")).default).setupReleaseAutomation),
            onClick: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                }), 'newRuleAutomationLink');
                dismissBanner();
            }
        }, formatMessage((0, (0, parcelRequire("4eavD")).default).setupReleaseAutomation)), (0, ($parcel$interopDefault($5uXOq))).createElement($52f7cd2e766f7238$var$Dismiss, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            shouldFitContainer: true,
            appearance: "subtle",
            onClick: (_, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'dismissButton');
                dismissBanner();
            },
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
                label: formatMessage((0, (0, parcelRequire("4eavD")).default).dismiss),
                size: "small"
            })
        }))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$238d30785c4bca84),
            sourceName: "releaseAutomationCallToAction"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), isTransitionEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement($52f7cd2e766f7238$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("itzrU")).default), {
            in: showBanner,
            timeout: $52f7cd2e766f7238$var$TRANSITION_DURATION,
            classNames: "release-automation-banner",
            unmountOnExit: true
        }, renderBannerContent)) : renderBannerContent);
    };
    const $52f7cd2e766f7238$var$BANNER_HEIGHT = 80;
    const $52f7cd2e766f7238$var$TRANSITION_DURATION = 400;
    const $52f7cd2e766f7238$var$Section = (0, $5uXOq.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _2rko1y44 _1yt4pxbi _zulppxbi _189eyh40 _1dqonqa1 _1h6d193x",
                __cmplp.className
            ])
        });
    });
    const $52f7cd2e766f7238$var$CallToAction = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
    const $52f7cd2e766f7238$var$Dismiss = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbzwfg",
                __cmplp.className
            ])
        });
    });
    const $52f7cd2e766f7238$var$Spacer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg",
                __cmplp.className
            ])
        });
    });
    const $52f7cd2e766f7238$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1k7uidpf _lnbg15vq _11ok15vq _pmb0idpf _lghnkb7n _1sz115vq _iayz15vq _3g9qys9h _19q1o91y _28jmkb7n _1b0e15vq _19ci15vq _13e1ys9h _zsv0idpf _1g5d15vq _153n15vq _qigkidpf _khvao91y",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5d48Z", function(module, exports) {
    module.exports = new URL("lightning.44c03a60.svg", import.meta.url).toString();
});
parcelRegister("4eavD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$428af210918cdaf9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $428af210918cdaf9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        setupReleaseAutomation: {
            "id": "project-directories.versions.release-version-modal.content.release-automation-banner.setup-release-automation",
            "defaultMessage": "Set up release automation"
        },
        dismiss: {
            "id": "project-directories.versions.release-version-modal.content.release-automation-banner.dismiss",
            "defaultMessage": "Dismiss"
        }
    });
});
parcelRegister("50qub", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b98138cc474c021$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3yLu1;
    var $ai3Yq;
    var $2Nd4Z;
    const $9b98138cc474c021$var$mapStateToProps = (state)=>({
            releaseDate: (0, (0, parcelRequire("ai3Yq")).getReleaseDate)(state),
            errors: (0, (0, parcelRequire("ai3Yq")).getErrors)(state),
            isSaving: (0, (0, parcelRequire("ai3Yq")).isSaving)(state)
        });
    const $9b98138cc474c021$var$dispatcher = (dispatch)=>({
            onInputChange: (version)=>dispatch((0, (0, parcelRequire("3yLu1")).releaseVersionUpdate)(version))
        });
    const $9b98138cc474c021$var$mapDispatchToProps = (dispatch)=>$9b98138cc474c021$var$dispatcher(dispatch);
    var $9b98138cc474c021$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($9b98138cc474c021$var$mapStateToProps, $9b98138cc474c021$var$mapDispatchToProps)((0, (0, parcelRequire("2Nd4Z")).default));
});
parcelRegister("2Nd4Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf173cf292ca0eac$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jj52j;
    var $cHapz;
    var $7O4UO;
    var $8tAHc;
    var $az4zD;
    var $3LzsZ;
    var $lhpg4;
    class $bf173cf292ca0eac$export$55e7fadddcffb796 extends (0, $5uXOq.Component) {
        inputChange(update) {
            const { onInputChange: onInputChange } = this.props;
            onInputChange({
                releaseDate: update.releaseDate
            });
        }
        render() {
            const { intl: { formatMessage: formatMessage, locale: locale }, releaseDate: releaseDate, errors: errors, isSaving: isSaving } = this.props;
            const { releaseDate: releaseDateError } = errors;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                name: "releaseDate",
                label: formatMessage((0, (0, parcelRequire("lhpg4")).default).releaseDate)
            }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($bf173cf292ca0eac$var$DatePickerContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3LzsZ")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cHapz")).default), {
                    isDisabled: isSaving,
                    defaultValue: releaseDate !== '' ? (0, (0, parcelRequire("jj52j")).default)(new Date(releaseDate)) : releaseDate,
                    onChange: this.onReleaseDateChange,
                    placeholder: formatMessage((0, (0, parcelRequire("8tAHc")).default).placeholderDate),
                    locale: locale
                })))), releaseDateError && (0, ($parcel$interopDefault($5uXOq))).createElement($bf173cf292ca0eac$var$ValidationError, null, releaseDateError));
        }
        constructor(...args){
            super(...args), this.onReleaseDateChange = (releaseDate)=>{
                if (releaseDate) this.inputChange({
                    releaseDate: releaseDate
                });
                else this.inputChange({
                    releaseDate: ''
                });
            };
        }
    }
    var $bf173cf292ca0eac$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($bf173cf292ca0eac$export$55e7fadddcffb796);
    const $bf173cf292ca0eac$var$DatePickerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1ssb",
                __cmplp.className
            ])
        });
    });
    const $bf173cf292ca0eac$var$ValidationError = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pku2gc _syaz17af",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cHapz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a844b50b385d50f7$export$2e2bcd8739ae039);
    var $VSDnB;
    var $cKsfY;
    var $2TI0z;
    var $jcbUF;
    const $a844b50b385d50f7$var$DatePicker = (0, (0, parcelRequire("cKsfY")).componentWithCondition)(()=>(0, (0, parcelRequire("VSDnB")).fg)('dst-date-picker-use-functional-component'), (0, (0, parcelRequire("jcbUF")).default), (0, (0, parcelRequire("2TI0z")).default));
    var $a844b50b385d50f7$export$2e2bcd8739ae039 = $a844b50b385d50f7$var$DatePicker;
});
parcelRegister("cKsfY", function(module, exports) {
    $parcel$export(module.exports, "componentWithCondition", ()=>$8f027f90da2b6bac$export$6e8ea24b15199873);
    var $5uXOq = parcelRequire("5uXOq");
    function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
        const ComponentWithCondition = (0, $5uXOq.forwardRef)((props, ref)=>condition() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            }));
        if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
        return ComponentWithCondition;
    }
});
parcelRegister("2TI0z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19201d0a1f7d7d54$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $9KnKW;
    var $acknU;
    var $cTemL;
    var $7qZ1x;
    var $VSDnB;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $7K5PP;
    var $7VXAu;
    var $jldZL;
    var $jHBnA;
    var $5RLF6;
    var $iaQLg;
    var $gtijU;
    var $6AqCE;
    var $dBs4v;
    function $19201d0a1f7d7d54$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
    const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
    const $19201d0a1f7d7d54$var$dropdownIndicatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $19201d0a1f7d7d54$var$CalendarIcon = (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("acknU"))))) : (0, ($parcel$interopDefault((0, parcelRequire("cTemL")))));
    const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
        defaultIsOpen: false,
        defaultValue: '',
        disabled: [],
        disabledDateFilter: (_)=>false,
        locale: 'en-US',
        onBlur: (_event)=>{},
        onChange: (_value)=>{},
        onFocus: (_event)=>{}
    };
    const $19201d0a1f7d7d54$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $19201d0a1f7d7d54$var$iconContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        insetBlockStart: 0,
        insetInlineEnd: 0,
        transition: `color 150ms`,
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        }
    });
    const $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles = {
        name: "jd0mtf",
        styles: "margin-inline-end:var(--ds-space-400, 2rem)"
    };
    const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew = {
        name: "129q61y",
        styles: "margin-inline-end:var(--ds-space-050, 0.25rem)"
    };
    const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles = {
        name: "sz3drw",
        styles: "margin-inline-end:var(--ds-space-025, 0.125rem)"
    };
    const $19201d0a1f7d7d54$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $19201d0a1f7d7d54$var$calendarButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
        }
        constructor(props){
            super(props), this.containerRef = null, this.calendarRef = (0, $5uXOq.createRef)(), this.calendarButtonRef = (0, $5uXOq.createRef)(), this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
                this.setState({
                    calendarValue: (0, (0, parcelRequire("5RLF6")).getParsedISO)({
                        iso: iso
                    })
                });
            }, this.onCalendarSelect = ({ iso: iso })=>{
                this.setState({
                    selectInputValue: '',
                    isOpen: false,
                    calendarValue: iso,
                    value: iso,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onChange(iso);
                if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                this.setState({
                    isOpen: false
                });
            }, this.onInputClick = ()=>{
                if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            }, this.onContainerBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (!this.containerRef?.contains(newlyFocusedElement)) {
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    this.props.onBlur(event);
                }
            }, this.onContainerFocus = ()=>{
                this.setState({
                    shouldSetFocusOnCurrentDay: false
                });
            }, this.onSelectBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (this.state.clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else if (!this.containerRef?.contains(newlyFocusedElement)) this.setState({
                    isOpen: false,
                    isFocused: false,
                    wasOpenedFromCalendarButton: false
                });
            }, this.onSelectFocus = (event)=>{
                const { clearingFromIcon: clearingFromIcon } = this.state;
                const value = this.getValue();
                if (clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else this.setState({
                    isOpen: !this.props.shouldShowCalendarButton,
                    calendarValue: value,
                    isFocused: true,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onFocus(event);
            }, this.onTextInput = (event)=>{
                const inputValue = event.target.value;
                if (inputValue) {
                    const parsed = (0, (0, parcelRequire("5RLF6")).parseDate)(inputValue, {
                        parseInputValue: this.props.parseInputValue,
                        dateFormat: this.props.dateFormat,
                        l10n: this.state.l10n
                    });
                    if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) this.setState({
                        calendarValue: (0, (0, parcelRequire("6AqCE")).getShortISOString)(parsed)
                    });
                }
                this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            }, this.onInputKeyDown = (event)=>{
                const { calendarValue: calendarValue } = this.state;
                const value = this.getValue();
                const keyPressed = event.key.toLowerCase();
                if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
                switch(keyPressed){
                    case 'escape':
                        if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                        else {
                            const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                            innerCombobox?.focus();
                        }
                        this.setState({
                            isOpen: false,
                            shouldSetFocusOnCurrentDay: false,
                            wasOpenedFromCalendarButton: false
                        });
                        break;
                    case 'backspace':
                    case 'delete':
                        {
                            const inputCount = 0;
                            if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) this.setState({
                                clearingFromIcon: false,
                                value: ''
                            });
                            break;
                        }
                    case 'enter':
                        if (!this.state.isOpen) return;
                        event.preventDefault();
                        if (!(0, (0, parcelRequire("5RLF6")).isDateDisabled)(calendarValue, {
                            disabled: this.props.disabled
                        })) {
                            const safeCalendarValue = (0, (0, parcelRequire("6AqCE")).getSafeCalendarValue)(calendarValue);
                            const valueChanged = safeCalendarValue !== value;
                            this.setState({
                                selectInputValue: '',
                                isOpen: false,
                                value: safeCalendarValue,
                                calendarValue: safeCalendarValue,
                                wasOpenedFromCalendarButton: false
                            });
                            if (valueChanged) this.props.onChange(safeCalendarValue);
                        }
                        break;
                    case 'arrowdown':
                    case 'arrowup':
                        if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                            isOpen: true,
                            shouldSetFocusOnCurrentDay: true
                        });
                        break;
                    default:
                        break;
                }
            }, this.onCalendarButtonKeyDown = (e)=>{
                if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
                if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                    e.stopPropagation();
                    this.setState({
                        isKeyDown: true,
                        wasOpenedFromCalendarButton: true
                    });
                }
            }, this.onCalendarButtonClick = (e)=>{
                this.setState({
                    isOpen: !this.state.isOpen,
                    wasOpenedFromCalendarButton: true
                }, ()=>{
                    if (!this.state.isKeyDown) return;
                    this.setState({
                        isKeyDown: false
                    });
                    this.calendarRef?.current?.querySelector('button')?.focus();
                });
                e.stopPropagation();
            }, this.onClear = ()=>{
                let changedState = {
                    value: '',
                    calendarValue: this.props.defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date())
                };
                if (!this.props.hideIcon) changedState = {
                    ...changedState,
                    clearingFromIcon: true
                };
                this.setState(changedState);
                this.props.onChange('');
            }, this.onSelectChange = (_value, action)=>{
                if (action.action === 'clear') this.onClear();
            }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
                const onInputChange = this.props.selectProps?.onInputChange;
                if (onInputChange) onInputChange(selectInputValue, actionMeta);
                this.setState({
                    selectInputValue: selectInputValue
                });
            }, this.getContainerRef = (ref)=>{
                const oldRef = this.containerRef;
                this.containerRef = ref;
                if (oldRef == null && ref != null) this.forceUpdate();
            };
            this.state = {
                isKeyDown: false,
                isOpen: this.props.defaultIsOpen,
                isFocused: false,
                clearingFromIcon: false,
                selectInputValue: this.props.selectProps?.inputValue || '',
                value: this.props.value || this.props.defaultValue,
                calendarValue: this.props.value || this.props.defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()),
                l10n: (0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(this.props.locale),
                locale: this.props.locale,
                shouldSetFocusOnCurrentDay: false,
                wasOpenedFromCalendarButton: false
            };
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.locale !== prevState.locale) return {
                l10n: (0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(nextProps.locale),
                locale: nextProps.locale
            };
            else return null;
        }
        render() {
            const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = $19201d0a1f7d7d54$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
            const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
            const value = this.getValue();
            let actualSelectInputValue;
            actualSelectInputValue = selectInputValue;
            const menuIsOpen = this.getIsOpen() && !isDisabled;
            const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
            let clearIndicator = Icon;
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $19201d0a1f7d7d54$var$dropdownIndicatorStyles
                }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
            const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
            const SingleValue = (0, (0, parcelRequire("dBs4v")).makeSingleValue)({
                lang: this.props.locale
            });
            const selectComponents = {
                DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("jHBnA")).EmptyComponent) : dropDownIcon,
                ...shouldShowCalendarButton ? {
                    IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iaQLg")).IndicatorsContainer), {
                            ...props,
                            showClearIndicator: showClearIndicator
                        })
                } : {},
                Menu: (0, parcelRequire("gtijU")).Menu,
                SingleValue: SingleValue,
                ...!showClearIndicator && {
                    ClearIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent)
                }
            };
            const { styles: selectStyles = {} } = selectProps;
            const disabledStyle = isDisabled ? {
                pointerEvents: 'none',
                color: "var(--ds-icon-disabled, inherit)"
            } : {};
            const calendarProps = {
                calendarContainerRef: this.containerRef,
                calendarDisabled: disabled,
                calendarDisabledDateFilter: disabledDateFilter,
                calendarMaxDate: maxDate,
                calendarMinDate: minDate,
                calendarRef: this.calendarRef,
                calendarValue: value && (0, (0, parcelRequire("6AqCE")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(value)),
                calendarView: calendarValue,
                onCalendarChange: this.onCalendarChange,
                onCalendarSelect: this.onCalendarSelect,
                calendarLocale: locale,
                calendarWeekStartDay: weekStartDay,
                shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
            };
            const mergedStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)(selectStyles, {
                control: (base)=>({
                        ...base,
                        ...disabledStyle
                    }),
                indicatorsContainer: (base)=>({
                        ...base,
                        paddingLeft: "var(--ds-space-025, 2px)",
                        paddingRight: "var(--ds-space-075, 6px)"
                    })
            });
            const initialValue = value ? {
                label: (0, (0, parcelRequire("5RLF6")).formatDate)(value, {
                    formatDisplayLabel: this.props.formatDisplayLabel,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }),
                value: value
            } : null;
            const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ...innerProps,
                css: $19201d0a1f7d7d54$var$pickerContainerStyles,
                role: "presentation",
                onBlur: this.onContainerBlur,
                onFocus: this.onContainerFocus,
                onClick: this.onInputClick,
                onInput: this.onTextInput,
                onKeyDown: this.onInputKeyDown,
                ref: this.getContainerRef,
                "data-testid": testId && `${testId}--container`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`
            }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7K5PP")).default), {
                appearance: this.props.appearance,
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                components: selectComponents,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: this.onSelectBlur,
                onChange: this.onSelectChange,
                onFocus: this.onSelectFocus,
                onInputChange: this.handleSelectInputChange,
                placeholder: (0, (0, parcelRequire("5RLF6")).getPlaceholder)({
                    placeholder: this.props.placeholder,
                    l10n: this.state.l10n
                }),
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
            }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9KnKW")).IdProvider), {
                prefix: "open-calendar-label--"
            }, ({ id: openCalendarLabelId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: [
                        $19201d0a1f7d7d54$var$iconContainerStyles,
                        value && !hideIcon ? $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew : $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles
                    ]
                }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
                    id: openCalendarLabelId
                }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
                    ...inputLabelId ? {
                        'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
                    } : {
                        'aria-label': fullopenCalendarLabel
                    },
                    onClick: this.onCalendarButtonClick,
                    onKeyDown: this.onCalendarButtonKeyDown,
                    ref: this.calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`,
                    type: "button",
                    backgroundColor: "color.background.neutral.subtle",
                    padding: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
                    xcss: [
                        $19201d0a1f7d7d54$var$calendarButtonStyles,
                        (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') && $19201d0a1f7d7d54$var$calendarButtonFixedSizeStyles
                    ]
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($19201d0a1f7d7d54$var$CalendarIcon, {
                    label: "",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                        color: "var(--ds-icon, #44546F)"
                    } : {
                        primaryColor: "var(--ds-icon, #44546F)"
                    }
                })))) : null));
        }
    }
    const $19201d0a1f7d7d54$var$DatePicker = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'datePicker',
        packageName: $19201d0a1f7d7d54$var$packageName,
        packageVersion: $19201d0a1f7d7d54$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: (0, (0, parcelRequire("gB4mS")).default)('atlaskit')({
            action: 'selectedDate',
            actionSubject: 'datePicker',
            attributes: {
                componentName: 'datePicker',
                packageName: $19201d0a1f7d7d54$var$packageName,
                packageVersion: $19201d0a1f7d7d54$var$packageVersion
            }
        })
    })($19201d0a1f7d7d54$export$df43d21f5faca9f7));
    var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;
});
parcelRegister("acknU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));
    var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
    function $76cad653a4883392$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $76cad653a4883392$var$CalendarIcon = (props)=>$76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
            LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
        }, props));
    $76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
    var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;
});
parcelRegister("3fesp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $25cdfcb8bb836404$var$_UNSAFE_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25cdfcb8bb836404$var$CalendarIcon = (props)=>$25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
        }, props));
    $25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
    var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;
});
parcelRegister("cTemL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
    function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9625c3edd02eaf26$var$CalendarIcon = (props)=>$9625c3edd02eaf26$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
        }, props, {
            newIcon: $9625c3edd02eaf26$var$_calendar.default
        }));
    $9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
    var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;
});
parcelRegister("7qZ1x", function(module, exports) {
    $parcel$export(module.exports, "createLocalizationProvider", ()=>$71bdd27445bf5301$export$ea56ca58f08ffa52);
    var $lCAti;
    var $is0Fy;
    var $1cWOp;
    const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
        const normalizedLocale = (0, (0, parcelRequire("lCAti")).normalizeLocale)(locale);
        const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
        const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
                hour: 'numeric',
                minute: 'numeric'
            }).format(date);
        const getDays = (weekStartDay = 0, length)=>{
            const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
                weekday: length
            });
            const weekdays = [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ];
            const rotatedWeekdays = weekStartDay > 0 ? [
                ...weekdays.slice(weekStartDay),
                ...weekdays.slice(0, weekStartDay)
            ] : weekdays;
            return rotatedWeekdays.map((day)=>{
                const result = dayFormatter.format(new Date(2000, 9, day + 1, 12)).replace(/[\s\u200E]/g, '');
                if (length === 'short') return result.substring(0, 3);
                else return result;
            });
        };
        const getDaysShort = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'short');
        };
        const getDaysLong = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'long');
        };
        const getMonthsLong = ()=>{
            const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
                month: 'long'
            });
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ].map((month)=>monthFormatter.format(new Date(2020, month, 1)));
        };
        const parseDate = (date)=>(0, (0, parcelRequire("is0Fy")).createDateParser)(normalizedLocale)(date);
        const formatToParts = (date = new Date())=>{
            const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
            const fixedDate = new Date(date);
            fixedDate.setFullYear(2020);
            const fixedParts = (0, (0, parcelRequire("1cWOp")).toFormattedParts)(formatter.formatToParts(fixedDate));
            const originalParts = (0, (0, parcelRequire("1cWOp")).toFormattedParts)(formatter.formatToParts(date));
            if (fixedParts.year) fixedParts.year = originalParts.year;
            if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
            return fixedParts;
        };
        return {
            getDaysShort: getDaysShort,
            getDaysLong: getDaysLong,
            getMonthsLong: getMonthsLong,
            formatDate: formatDate,
            formatTime: formatTime,
            parseDate: parseDate,
            formatToParts: formatToParts
        };
    };
});
parcelRegister("lCAti", function(module, exports) {
    $parcel$export(module.exports, "normalizeLocale", ()=>$13af55a9724edafd$export$dca0327c9b9c6498);
    const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
});
parcelRegister("is0Fy", function(module, exports) {
    $parcel$export(module.exports, "createDateParser", ()=>$d8bb223589902df4$export$cfa2ef2687faeda2);
    var $3wYKB;
    var $lCAti;
    const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
    const $d8bb223589902df4$var$INVARIANT = {
        year: 1993,
        month: 2,
        day: 18
    };
    const $d8bb223589902df4$var$INVARIANT_DATE = (0, (0, parcelRequire("3wYKB")).toDate)($d8bb223589902df4$var$INVARIANT);
    const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
    const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
    const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
    const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
        return matchResult.splice(1, 4).map((datePart)=>parseInt(datePart, 10));
    };
    const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("lCAti")).normalizeLocale)(locale);
        const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
        const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
        const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
        const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
        if (!formatMatch) throw new Error('Unable to create DateParser');
        const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
        const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
        const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
        const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
        return (date)=>{
            const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
            if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
            const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
            const extractedDate = {
                year: dateParts[yearPosition],
                month: dateParts[monthPosition],
                day: dateParts[dayPosition]
            };
            const normalizedDate = (0, (0, parcelRequire("3wYKB")).normalizeDate)(extractedDate);
            if (!(0, (0, parcelRequire("3wYKB")).isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
            return (0, (0, parcelRequire("3wYKB")).toDate)(normalizedDate);
        };
    };
});
parcelRegister("3wYKB", function(module, exports) {
    $parcel$export(module.exports, "toDate", ()=>$121d324fc62f760d$export$e67a095c620b86fe);
    $parcel$export(module.exports, "isValid", ()=>$121d324fc62f760d$export$1ea939691cdc45b8);
    $parcel$export(module.exports, "normalizeDate", ()=>$121d324fc62f760d$export$fcc71269590ba0a8);
    const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        });
    const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>new Date(date.year, date.month - 1, date.day);
    const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    };
    const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
        if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
        return [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ][month - 1];
    };
    const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
        const { year: year, month: month, day: day } = date;
        const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
        return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
    };
    const $121d324fc62f760d$export$fcc71269590ba0a8 = (date)=>{
        const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
        const { year: year, month: month, day: day } = date;
        const fullYear = year < 100 ? 2000 + year : year;
        const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
        const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
        const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
        return {
            year: normalizedYear,
            month: normalizedMonth,
            day: normalizedDay
        };
    };
});
parcelRegister("1cWOp", function(module, exports) {
    $parcel$export(module.exports, "toFormattedParts", ()=>$56bd04270448c035$export$9b7ca29af37c192);
    const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
                ...result,
                [datePart.type]: datePart.value
            }), {});
});
parcelRegister("jHBnA", function(module, exports) {
    $parcel$export(module.exports, "EmptyComponent", ()=>$91948b176ea23188$export$5e30e9a24d6c1203);
    $parcel$export(module.exports, "placeholderDatetime", ()=>$91948b176ea23188$export$fff8babee5abe3e2);
    $parcel$export(module.exports, "defaultTimes", ()=>$91948b176ea23188$export$b42ffb9f09b1861b);
    $parcel$export(module.exports, "defaultTimeFormat", ()=>$91948b176ea23188$export$9e6d8fcf62256b85);
    $parcel$export(module.exports, "defaultDateFormat", ()=>$91948b176ea23188$export$75032c84f56650eb);
    $parcel$export(module.exports, "padToTwo", ()=>$91948b176ea23188$export$a7de57e5b672ccdb);
    $parcel$export(module.exports, "formatDateTimeZoneIntoIso", ()=>$91948b176ea23188$export$2eeb05a2ecc2ce0a);
    const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
    const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
    const $91948b176ea23188$export$b42ffb9f09b1861b = [
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00'
    ];
    const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
    const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
    function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
        return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
    }
    function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
        const needsLeadingZero = /^\d:/;
        const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
        return `${date}T${sanitizedTime}${zone}`;
    }
});
parcelRegister("5RLF6", function(module, exports) {
    $parcel$export(module.exports, "isDateDisabled", ()=>$e0db4b6edb7dbfac$export$d38e7e283938128c);
    $parcel$export(module.exports, "getParsedISO", ()=>$e0db4b6edb7dbfac$export$38db26406d1a1ee2);
    $parcel$export(module.exports, "parseDate", ()=>$e0db4b6edb7dbfac$export$6b862160d295c8e);
    $parcel$export(module.exports, "formatDate", ()=>$e0db4b6edb7dbfac$export$3ae94a2503e890a1);
    $parcel$export(module.exports, "getPlaceholder", ()=>$e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
    var $k7m40;
    var $5I2ju;
    var $eZDAP;
    var $2ucUe;
    var $jHBnA;
    const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
        const { disabled: disabled } = di;
        return disabled.indexOf(date) > -1;
    };
    const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
        const { iso: iso } = di;
        const [year, month, date] = iso.split('-');
        let newIso = iso;
        const parsedDate = parseInt(date, 10);
        const parsedMonth = parseInt(month, 10);
        const parsedYear = parseInt(year, 10);
        const lastDayInMonth = (0, (0, parcelRequire("5I2ju")).default)(new Date(parsedYear, parsedMonth - 1)).getDate();
        if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(lastDayInMonth)}`;
        else newIso = `${parsedYear}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedDate)}`;
        return newIso;
    };
    const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
        const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
        if (parseInputValue) return parseInputValue(date, dateFormat || (0, (0, parcelRequire("jHBnA")).defaultDateFormat));
        return l10n.parseDate(date);
    };
    const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
        const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
        if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, (0, parcelRequire("jHBnA")).defaultDateFormat));
        const date = (0, (0, parcelRequire("eZDAP")).default)(value);
        return dateFormat ? (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("2ucUe")).convertTokens)(dateFormat)) : l10n.formatDate(date);
    };
    const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
        const { placeholder: placeholder, l10n: l10n } = di;
        return placeholder || l10n.formatDate((0, (0, parcelRequire("jHBnA")).placeholderDatetime));
    };
});
parcelRegister("2ucUe", function(module, exports) {
    $parcel$export(module.exports, "convertTokens", ()=>$ca6f20a476eda5dc$export$4d5430175be73d45);
    const $ca6f20a476eda5dc$var$tokensMap = {
        M: 'L',
        Mo: 'Mo',
        MM: 'LL',
        MMM: 'LLL',
        MMMM: 'LLLL',
        Q: 'q',
        Qo: 'qo',
        D: 'd',
        Do: 'do',
        DD: 'dd',
        DDD: 'D',
        DDDo: 'Do',
        DDDD: 'DDD',
        d: 'i',
        do: 'io',
        dd: 'iiiiii',
        ddd: 'iii',
        dddd: 'iiii',
        A: 'a',
        a: 'a',
        aa: 'aaaa',
        E: 'i',
        W: 'I',
        Wo: 'Io',
        WW: 'II',
        YY: 'yy',
        YYYY: 'yyyy',
        GG: 'RR',
        GGGG: 'RRRR',
        H: 'H',
        HH: 'HH',
        h: 'h',
        hh: 'hh',
        m: 'm',
        mm: 'mm',
        s: 's',
        ss: 'ss',
        S: 'S',
        SS: 'SS',
        SSS: 'SSS',
        Z: 'xxx',
        ZZ: 'xx',
        X: 't',
        x: 'T'
    };
    const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
    const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp("(\\[[^\\[]*\\])|(\\\\)?('.+'|" + $ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
    function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
        const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
        if (!tokensCaptures) return format;
        return tokensCaptures.reduce((parsed, tokenString, index)=>{
            const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
            if (!v2token) {
                const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
                if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
                else parsed.escapedTextBuffer.push(tokenString);
            }
            const endOfString = index === tokensCaptures.length - 1;
            if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
                const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
                parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
                parsed.escapedTextBuffer = [];
            }
            if (v2token) parsed.formatBuffer.push(v2token);
            return parsed;
        }, {
            formatBuffer: [],
            escapedTextBuffer: []
        }).formatBuffer.join('');
    }
});
parcelRegister("iaQLg", function(module, exports) {
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$d73476b891de3e0c$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $bChGW;
    function $d73476b891de3e0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d73476b891de3e0c$var$calendarButtonInclusionStyles = {
        name: "i3e4rp",
        styles: "margin-inline-start:var(--ds-space-400, 32px)"
    };
    const $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles = {
        name: "19a3ait",
        styles: "margin-inline-start:var(--ds-space-300, 24px)"
    };
    const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: showClearIndicator ? $d73476b891de3e0c$var$calendarButtonInclusionStyles : $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).IndicatorsContainer, rest));
});
parcelRegister("gtijU", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$e800a879ee1613fc$export$d9b273488cd8ce6f);
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $1f0Hs;
    var $9MHPe;
    var $k5uoT;
    var $avHVh;
    function $e800a879ee1613fc$var$getValidDate(isos) {
        return isos.reduce((acc, iso)=>{
            const date = (0, (0, parcelRequire("eZDAP")).default)(iso);
            return (0, (0, parcelRequire("jovBr")).default)(date) ? {
                day: date.getDate(),
                month: date.getMonth() + 1,
                year: date.getFullYear()
            } : acc;
        }, {});
    }
    const $e800a879ee1613fc$var$menuStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).dialog(),
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        overflow: 'hidden'
    });
    const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
        const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
        const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
            calendarValue,
            calendarView
        ]);
        const onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9MHPe")).Layering), {
            isDisabled: false
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("avHVh")).default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $e800a879ee1613fc$var$menuStyles,
                ...innerProps,
                onMouseDown: onMenuMouseDown
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1f0Hs")).default), {
                day: day,
                month: month,
                year: year,
                disabled: selectProps.calendarDisabled,
                disabledDateFilter: selectProps.calendarDisabledDateFilter,
                minDate: selectProps.calendarMinDate,
                maxDate: selectProps.calendarMaxDate,
                nextMonthLabel: selectProps.nextMonthLabel,
                onChange: selectProps.onCalendarChange,
                onSelect: selectProps.onCalendarSelect,
                previousMonthLabel: selectProps.previousMonthLabel,
                ref: selectProps.calendarRef,
                selected: [
                    selectProps.calendarValue
                ],
                shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                locale: selectProps.calendarLocale,
                testId: selectProps.testId && `${selectProps.testId}--calendar`,
                weekStartDay: selectProps.calendarWeekStartDay
            })),
            testId: selectProps.testId
        }));
    };
});
parcelRegister("1f0Hs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16abbcd9b9109722$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $9KnKW;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $ePz3p;
    var $lJWdi;
    var $avO9B;
    var $iioJV;
    var $jihAA;
    var $bbnGB;
    var $hbcve;
    var $2TGJ3;
    var $f9D1v;
    var $9efze;
    const $16abbcd9b9109722$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-block',
        userSelect: 'none'
    });
    const $16abbcd9b9109722$var$analyticsAttributes = {
        componentName: 'calendar',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $16abbcd9b9109722$var$InnerCalendar = (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, (0, parcelRequire("iioJV")).blankStringArray), defaultSelected: defaultSelected = (0, (0, parcelRequire("iioJV")).blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, (0, parcelRequire("eGmKJ")).default), onChange: onChange = (0, (0, parcelRequire("eGmKJ")).default), onFocus: onFocus = (0, (0, parcelRequire("eGmKJ")).default), onSelect: onSelect = (0, (0, parcelRequire("eGmKJ")).default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
        const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, (0, parcelRequire("jihAA")).default)({
            day: day,
            defaultDay: defaultDay,
            month: month,
            defaultMonth: defaultMonth,
            year: year,
            defaultYear: defaultYear,
            today: today,
            selected: selected,
            defaultSelected: defaultSelected,
            previouslySelected: previouslySelected,
            defaultPreviouslySelected: defaultPreviouslySelected
        });
        const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
        const onChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            ...$16abbcd9b9109722$var$analyticsAttributes
        });
        const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, (0, parcelRequire("2TGJ3")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            shouldSetFocus: [
                shouldSetFocus,
                setShouldSetFocus
            ],
            onChange: onChangeWithAnalytics
        });
        const onSelectWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onSelect,
            action: 'selected',
            analyticsData: analyticsContext,
            ...$16abbcd9b9109722$var$analyticsAttributes
        });
        const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, (0, parcelRequire("f9D1v")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                ,
                setPreviouslySelectedValue
            ],
            onSelect: onSelectWithAnalytics,
            navigate: navigate
        });
        const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, (0, parcelRequire("bbnGB")).default)({
            onFocus: onFocus,
            onBlur: onBlur
        });
        const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, (0, parcelRequire("9efze")).default)({
            locale: locale,
            weekStartDay: weekStartDay
        });
        const weeks = (0, (0, parcelRequire("hbcve")).default)({
            day: dayValue,
            month: monthValue,
            year: yearValue,
            today: todayValue,
            selected: selectedValue,
            previouslySelected: previouslySelectedValue,
            disabled: disabled,
            disabledDateFilter: disabledDateFilter,
            minDate: minDate,
            maxDate: maxDate,
            daysLong: daysLong,
            weekStartDay: weekStartDay
        });
        const getNextHeading = ()=>{
            const nextMonth = monthValue % 12;
            const showNextYear = monthValue === 12;
            return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
        };
        const getPreviousHeading = ()=>{
            const previousMonth = (monthValue + 12 - 2) % 12;
            const showPreviousYear = monthValue === 1;
            return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
        };
        const headerId = (0, (0, parcelRequire("9KnKW")).useId)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: className,
            style: style,
            onBlur: handleContainerBlur,
            onFocus: handleContainerFocus,
            "data-testid": testId && `${testId}--container`,
            ref: ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $16abbcd9b9109722$var$boxStyles,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("luBm6")).default), {
            space: "space.150"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ePz3p")).default), {
            monthLongTitle: monthsLong[monthValue - 1],
            year: yearValue,
            nextMonthLabel: nextMonthLabel,
            previousMonthLabel: previousMonthLabel,
            nextHeading: getNextHeading(),
            previousHeading: getPreviousHeading(),
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev,
            headerId: headerId,
            tabIndex: tabIndex,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            role: "grid",
            onKeyDown: handleContainerKeyDown,
            "aria-labelledby": headerId,
            testId: testId && `${testId}--calendar-dates`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("avO9B")).default), {
            daysShort: daysShort,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lJWdi")).default), {
            weeks: weeks,
            handleClickDay: handleClickDay,
            monthsLong: monthsLong,
            shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
            tabIndex: tabIndex,
            testId: testId
        })))));
    });
    const $16abbcd9b9109722$var$Calendar = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Calendar(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($16abbcd9b9109722$var$InnerCalendar, {
            ...props,
            ref: ref
        });
    }));
    $16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
    var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;
});
parcelRegister("ePz3p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$995afee12cb828f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $42CjB;
    var $9KnKW;
    var $l1N8i;
    var $fmJTX;
    var $6s76W;
    var $dC5iT;
    var $f5TWP;
    const $995afee12cb828f6$var$Header = (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
        const announceId = (0, (0, parcelRequire("9KnKW")).useId)();
        const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $5uXOq.useState)(false);
        const handlePrevMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickPrev(e);
        };
        const handleNextMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickNext(e);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            paddingInline: "space.100"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handlePrevMonthInteraction,
            testId: testId && `${testId}--previous-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("fmJTX"))))),
            label: `${previousMonthLabel}, ${previousHeading}`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
            id: announceId,
            testId: testId && `${testId}--current-month-year--container`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall",
            as: "h2",
            id: headerId,
            testId: testId && `${testId}--current-month-year`
        }, `${monthLongTitle} ${year}`)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handleNextMonthInteraction,
            testId: testId && `${testId}--next-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("6s76W"))))),
            label: `${nextMonthLabel}, ${nextHeading}`
        })));
    });
    $995afee12cb828f6$var$Header.displayName = 'Header';
    var $995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;
});
parcelRegister("fmJTX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));
    var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
    function $b2fc843461eabf96$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>$b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
        }, props));
    $b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("6s76W", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));
    var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
    function $4b2adfad98efb792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>$4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
        }, props));
    $4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
parcelRegister("lJWdi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43f22a52ec309eeb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $1q4y8;
    var $h581D;
    const $43f22a52ec309eeb$var$WeekDays = (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            role: "rowgroup",
            testId: testId && `${testId}--month`
        }, weeks.map((week, i)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("h581D")).default), {
                key: i,
                testId: testId && `${testId}--week`
            }, week.values.map((weekDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1q4y8")).default), {
                    key: `${week.id}-${weekDay.id}`,
                    isDisabled: weekDay.isDisabled,
                    isFocused: weekDay.isFocused,
                    isToday: weekDay.isToday,
                    dayLong: weekDay.weekDayName,
                    month: weekDay.month,
                    monthLong: monthsLong[weekDay.month - 1],
                    onClick: handleClickDay,
                    isPreviouslySelected: weekDay.isPreviouslySelected,
                    isSelected: weekDay.isSelected,
                    isSibling: weekDay.isSiblingMonth,
                    year: weekDay.year,
                    shouldSetFocus: shouldSetFocus,
                    tabIndex: tabIndex,
                    testId: testId
                }, weekDay.day)))));
    });
    $43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
    var $43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;
});
parcelRegister("1q4y8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d70b02566a310b79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $eGmKJ;
    var $bgrar;
    var $h0WbJ;
    const $d70b02566a310b79$var$Date = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, (0, parcelRequire("eGmKJ")).default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
        const dateRef = (0, $5uXOq.useRef)({
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: day,
                month: month,
                year: year,
                isDisabled: isDisabled
            };
        }, [
            day,
            month,
            year,
            isDisabled
        ]);
        const focusRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
        }, [
            isFocused,
            shouldSetFocus
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
            if (!isDisabledValue) onClick({
                day: dayValue,
                month: monthValue,
                year: yearValue
            });
        }, [
            onClick
        ]);
        const dateCellStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("h0WbJ")).dateCellStyles)());
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bgrar")).default), {
            role: "gridcell",
            alignItems: "center"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            css: dateCellStyles,
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
        }, day));
    }));
    $d70b02566a310b79$var$Date.displayName = 'Date';
    var $d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;
});
parcelRegister("h0WbJ", function(module, exports) {
    $parcel$export(module.exports, "dateCellStyles", ()=>$a52fc59169f9ec00$export$f62807af68630d86);
    const $a52fc59169f9ec00$export$f62807af68630d86 = ()=>({
            all: 'unset',
            display: 'block',
            padding: `${"var(--ds-space-050, 4px)"} 9px`,
            position: 'relative',
            backgroundColor: 'transparent',
            border: '2px solid transparent',
            borderRadius: 3,
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'pointer',
            flexGrow: 1,
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            textAlign: 'center',
            '&[data-sibling]': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            },
            '&[data-today]': {
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`,
                fontWeight: "var(--ds-font-weight-bold, bold)",
                '&::after': {
                    display: 'block',
                    height: 2,
                    position: 'absolute',
                    right: "var(--ds-space-025, 2px)",
                    bottom: "var(--ds-space-025, 2px)",
                    left: "var(--ds-space-025, 2px)",
                    backgroundColor: 'currentColor',
                    content: '""'
                }
            },
            '&[data-prev-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`,
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$29a4f05edc054374})`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`,
                cursor: 'not-allowed'
            },
            '&:focus-visible': {
                border: `2px solid ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '&:hover': {
                backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`,
                color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
            },
            '&:active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
            },
            '&[data-selected]:hover': {
                backgroundColor: `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-prev-selected]:hover': {
                color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-sibling]:hover': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            },
            '&[data-disabled]:hover': {
                backgroundColor: 'transparent',
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`
            }
        });
});
parcelRegister("h581D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c8aba25f4ae00ff$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $bgrar;
    const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
        const row = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bgrar")).default), {
            testId: testId,
            templateColumns: "repeat(7, minmax(max-content, 1fr))",
            role: "row"
        }, children);
        return isHidden ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-hidden": "true"
        }, row) : row;
    };
    var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;
});
parcelRegister("avO9B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f29b1b1295ce3a84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $h581D;
    const $f29b1b1295ce3a84$var$columnHeaderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: 'size.400',
        whiteSpace: 'nowrap',
        display: 'flex',
        justifyContent: 'center'
    });
    const $f29b1b1295ce3a84$var$WeekHeader = (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("h581D")).default), {
            isHidden: true,
            testId: testId && `${testId}--column-headers`
        }, daysShort.map((shortDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                padding: "space.100",
                xcss: $f29b1b1295ce3a84$var$columnHeaderStyles,
                key: shortDay,
                role: "columnheader",
                testId: testId && `${testId}--column-header`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
                weight: "bold",
                size: "UNSAFE_small",
                align: "center",
                color: "color.text.subtle"
            }, shortDay))));
    });
    $f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
    var $f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;
});
parcelRegister("iioJV", function(module, exports) {
    $parcel$export(module.exports, "arrowKeys", ()=>$85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
    $parcel$export(module.exports, "daysPerWeek", ()=>$85c2ac8e9452c4bf$export$3ae905d9742bef55);
    $parcel$export(module.exports, "monthsPerYear", ()=>$85c2ac8e9452c4bf$export$c9b7c010035d60c6);
    $parcel$export(module.exports, "blankStringArray", ()=>$85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
    const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
        ArrowDown: 'down',
        ArrowLeft: 'left',
        ArrowRight: 'right',
        ArrowUp: 'up'
    };
    const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
    const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
    const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];
});
parcelRegister("jihAA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$654a69afe715a212$export$2e2bcd8739ae039);
    var $33etG;
    var $f8qry;
    var $3EtUb;
    function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
        const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, (0, parcelRequire("f8qry")).default)(()=>{
            const now = new Date();
            const thisDay = now.getDate();
            const thisMonth = now.getMonth() + 1;
            const thisYear = now.getFullYear();
            return {
                thisDay: thisDay,
                thisMonth: thisMonth,
                thisYear: thisYear
            };
        });
        const [dayValue, setDayValue] = (0, (0, parcelRequire("33etG")).default)(day, ()=>defaultDay || thisDay);
        const [monthValue, setMonthValue] = (0, (0, parcelRequire("33etG")).default)(month, ()=>defaultMonth || thisMonth);
        const [yearValue, setYearValue] = (0, (0, parcelRequire("33etG")).default)(year, ()=>defaultYear || thisYear);
        const [todayValue] = (0, (0, parcelRequire("33etG")).default)(today, ()=>today || `${thisYear}-${(0, (0, parcelRequire("3EtUb")).default)(thisMonth)}-${(0, (0, parcelRequire("3EtUb")).default)(thisDay)}`);
        const [selectedValue, setSelectedValue] = (0, (0, parcelRequire("33etG")).default)(selected, ()=>defaultSelected);
        const [previouslySelectedValue, setPreviouslySelectedValue] = (0, (0, parcelRequire("33etG")).default)(previouslySelected, ()=>defaultPreviouslySelected);
        return {
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            today: [
                todayValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                previouslySelectedValue,
                setPreviouslySelectedValue
            ]
        };
    }
});
parcelRegister("3EtUb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd804e1790f6d755$export$2e2bcd8739ae039);
    function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
        return num < 10 ? `0${num}` : `${num}`;
    }
});
parcelRegister("bbnGB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ccb38b64bb63461$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
        const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur(event);
        }, [
            onBlur
        ]);
        const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
            onFocus(event);
        }, [
            onFocus
        ]);
        return {
            handleContainerBlur: handleContainerBlur,
            handleContainerFocus: handleContainerFocus
        };
    }
});
parcelRegister("hbcve", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fe53b5f3382c02e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZDAP;
    var $iioJV;
    var $6ASl9;
    var $5wbTt;
    function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
        const shouldDisplaySixthWeek = calendar.length % 6;
        const calendarLastValue = calendar[calendar.length - 1];
        return (0, $5uXOq.useMemo)(()=>{
            if (shouldDisplaySixthWeek) {
                const lastDayIsSibling = calendarLastValue.siblingMonth;
                const sliceStart = lastDayIsSibling ? (0, (0, parcelRequire("iioJV")).daysPerWeek) : 0;
                return (0, (0, parcelRequire("5wbTt")).default)(year, month, {
                    weekStartDay: weekStartDay
                }).slice(sliceStart, sliceStart + (0, (0, parcelRequire("iioJV")).daysPerWeek)).map((date)=>({
                        ...date,
                        siblingMonth: true
                    }));
            }
        }, [
            calendarLastValue,
            month,
            shouldDisplaySixthWeek,
            weekStartDay,
            year
        ]);
    }
    function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
        const calendar = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("5wbTt")).default)(year, month - 1, {
                weekStartDay: weekStartDay
            }), [
            month,
            weekStartDay,
            year
        ]);
        const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
            month: month,
            year: year,
            weekStartDay: weekStartDay
        });
        if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
        const minDate = minDateString ? (0, (0, parcelRequire("eZDAP")).default)(minDateString) : undefined;
        const maxDate = maxDateString ? (0, (0, parcelRequire("eZDAP")).default)(maxDateString) : undefined;
        const needJsDate = minDateString || maxDateString;
        return (0, $5uXOq.useMemo)(()=>{
            const weeks = [];
            calendar.forEach((date)=>{
                const dateAsString = (0, (0, parcelRequire("6ASl9")).default)(date, {
                    fixMonth: true
                });
                const JSDate = needJsDate ? (0, (0, parcelRequire("eZDAP")).default)(dateAsString) : undefined;
                let week;
                if (date.weekDay === weekStartDay) {
                    week = {
                        id: dateAsString,
                        values: []
                    };
                    weeks.push(week);
                } else week = weeks[weeks.length - 1];
                const weekDayOffset = (date.weekDay - weekStartDay) % 7;
                const weekDayName = daysLong[weekDayOffset];
                const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
                const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
                const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
                const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
                const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
                const isFocused = day === date.day && !date.siblingMonth;
                const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
                const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
                const isSiblingMonth = !!date.siblingMonth;
                const isToday = today === dateAsString;
                week.values.push({
                    id: dateAsString,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isToday: isToday,
                    month: date.month + 1,
                    isPreviouslySelected: isPreviouslySelected,
                    isSelected: isSelected,
                    isSiblingMonth: isSiblingMonth,
                    year: date.year,
                    day: date.day,
                    weekDayName: weekDayName
                });
            });
            return weeks;
        }, [
            calendar,
            day,
            disabled,
            disabledDateFilter,
            minDate,
            maxDate,
            needJsDate,
            previouslySelected,
            selected,
            today,
            weekStartDay,
            daysLong
        ]);
    }
});
parcelRegister("6ASl9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6ae62fd51c4538f$export$2e2bcd8739ae039);
    var $3EtUb;
    function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
        return `${date.year}-${(0, (0, parcelRequire("3EtUb")).default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, (0, parcelRequire("3EtUb")).default)(date.day)}`;
    }
});
parcelRegister("5wbTt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3dff1ed1384abe91$export$2e2bcd8739ae039);
    var $iioJV;
    var $9Zmg7;
    function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
        weekStartDay: 0
    }) {
        const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
        const utcYear = date.getUTCFullYear();
        const utcMonth = date.getUTCMonth();
        const calendar = [];
        const firstDay = date.getUTCDay();
        const firstDate = -(((0, (0, parcelRequire("iioJV")).daysPerWeek) - weekStartDay + firstDay) % (0, (0, parcelRequire("iioJV")).daysPerWeek));
        const lastDate = (0, (0, parcelRequire("9Zmg7")).default)(utcYear, utcMonth);
        const lastDay = (lastDate - firstDate) % (0, (0, parcelRequire("iioJV")).daysPerWeek);
        const lastDateOfPreviousMonth = (0, (0, parcelRequire("9Zmg7")).default)(utcYear, utcMonth - 1);
        let dateCounter = firstDate;
        let currentDay;
        let currentDate;
        let currentDateObject = null;
        let calculatedMonth;
        let calculatedYear;
        const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, (0, parcelRequire("iioJV")).daysPerWeek) - lastDay : 0) + firstDate;
        while(dateCounter < maxDateCount){
            currentDate = dateCounter + 1;
            currentDay = ((dateCounter < 1 ? (0, (0, parcelRequire("iioJV")).daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, (0, parcelRequire("iioJV")).daysPerWeek);
            if (currentDate < 1 || currentDate > lastDate) {
                if (currentDate < 1) {
                    calculatedMonth = utcMonth - 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth < 0) {
                        calculatedMonth = (0, (0, parcelRequire("iioJV")).monthsPerYear) - 1;
                        calculatedYear--;
                    }
                    currentDate = lastDateOfPreviousMonth + currentDate;
                } else if (currentDate > lastDate) {
                    calculatedMonth = utcMonth + 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth > (0, (0, parcelRequire("iioJV")).monthsPerYear) - 1) {
                        calculatedMonth = 0;
                        calculatedYear++;
                    }
                    currentDate = dateCounter - lastDate + 1;
                }
                if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                    day: currentDate,
                    weekDay: currentDay,
                    month: calculatedMonth,
                    year: calculatedYear,
                    siblingMonth: true
                };
            } else currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: utcMonth,
                year: utcYear
            };
            calendar.push(currentDateObject);
            dateCounter++;
        }
        return calendar;
    }
});
parcelRegister("9Zmg7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$878800070b837d93$export$2e2bcd8739ae039);
    function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
        return new Date(year, month + 1, 0).getDate();
    }
});
parcelRegister("2TGJ3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$caae4eff24f6e8d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iioJV;
    var $6ASl9;
    var $9Zmg7;
    const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === (0, (0, parcelRequire("iioJV")).monthsPerYear)) {
            month = 1;
            year += 1;
        } else month += 1;
        return {
            month: month,
            year: year
        };
    };
    const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === 1) {
            month = (0, (0, parcelRequire("iioJV")).monthsPerYear);
            year -= 1;
        } else month -= 1;
        return {
            month: month,
            year: year
        };
    };
    function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
            const iso = (0, (0, parcelRequire("6ASl9")).default)({
                year: year,
                month: month,
                day: day
            });
            const isFocusableType = [
                'up',
                'down',
                'left',
                'right'
            ].includes(type);
            onChange({
                day: day,
                month: month,
                year: year,
                iso: iso,
                type: type
            });
            setDayValue(day);
            setMonthValue(month);
            setYearValue(year);
            setShouldSetFocus(isFocusableType);
        }, [
            onChange,
            setDayValue,
            setMonthValue,
            setYearValue,
            setShouldSetFocus
        ]);
        const navigate = (0, $5uXOq.useCallback)((type)=>{
            const { day: day, month: month, year: year } = dateRef.current;
            if (type === 'down') {
                const next = day + (0, (0, parcelRequire("iioJV")).daysPerWeek);
                const daysInMonth = (0, (0, parcelRequire("9Zmg7")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: next - daysInMonth,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'left') {
                const prev = day - 1;
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("9Zmg7")).default)(prevYear, prevMonth - 1);
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            } else if (type === 'right') {
                const next = day + 1;
                const daysInMonth = (0, (0, parcelRequire("9Zmg7")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: 1,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'up') {
                const prev = day - (0, (0, parcelRequire("iioJV")).daysPerWeek);
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("9Zmg7")).default)(prevYear, prevMonth - 1) + prev;
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            }
        }, [
            triggerOnChange
        ]);
        const handleClickNext = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'next'
            });
        }, [
            triggerOnChange
        ]);
        const handleClickPrev = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'prev'
            });
        }, [
            triggerOnChange
        ]);
        return {
            navigate: navigate,
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev
        };
    }
});
parcelRegister("f9D1v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42ec54640e7b9de4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iioJV;
    var $6ASl9;
    function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            const iso = (0, (0, parcelRequire("6ASl9")).default)({
                year: year,
                month: month,
                day: day
            });
            onSelect({
                day: day,
                month: month,
                year: year,
                iso: iso
            });
            setPreviouslySelectedValue(selectedValue);
            setSelectedValue([
                iso
            ]);
        }, [
            onSelect,
            selectedValue,
            setPreviouslySelectedValue,
            setSelectedValue
        ]);
        const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            triggerOnSelect({
                year: year,
                month: month,
                day: day
            });
        }, [
            triggerOnSelect
        ]);
        const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
            const { key: key } = e;
            const arrowKey = (0, (0, parcelRequire("iioJV")).arrowKeys)[key];
            if (key === 'Enter' || key === ' ') {
                e.preventDefault();
                triggerOnSelect(dateRef.current);
            } else if (arrowKey) {
                e.preventDefault();
                navigate(arrowKey);
            }
        }, [
            triggerOnSelect,
            navigate
        ]);
        return {
            handleClickDay: handleClickDay,
            handleContainerKeyDown: handleContainerKeyDown
        };
    }
});
parcelRegister("9efze", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbd6f430b06675a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7qZ1x;
    function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
        const l10n = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(locale), [
            locale
        ]);
        const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
            l10n
        ]);
        const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        return {
            monthsLong: monthsLong,
            daysShort: daysShort,
            daysLong: daysLong
        };
    }
});
parcelRegister("avHVh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac07968b7cb494a9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $5owSH;
    var $gkD4s;
    var $4oNEb;
    var $1V7PR;
    var $k5uoT;
    class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidUpdate(prevProps) {
            if (prevProps.inputValue !== this.props.inputValue) this.update();
        }
        render() {
            const { containerRef: containerRef, content: content, testId: testId } = this.props;
            if (!containerRef) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null);
            const divStyles = {
                background: 'transparent',
                position: 'absolute',
                top: 0,
                height: containerRef.getBoundingClientRect().height,
                width: containerRef.getBoundingClientRect().width - parseInt((0, (0, parcelRequire("5owSH")).sizes).small.slice(0, -2)) - (0, (0, parcelRequire("k5uoT")).gridSize)()
            };
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gkD4s")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1V7PR")).Reference), null, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    "data-layer-child": true,
                    style: divStyles
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oNEb")).Popper), null, ({ ref: ref, style: style, update: update })=>{
                this.update = update;
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    style: {
                        ...style,
                        zIndex: (0, (0, parcelRequire("k5uoT")).layers).dialog()
                    },
                    "data-testid": testId && `${testId}--popper--container`
                }, content);
            })));
        }
        constructor(...args){
            super(...args), this.update = (0, (0, parcelRequire("eGmKJ")).default);
        }
    }
});
parcelRegister("6AqCE", function(module, exports) {
    $parcel$export(module.exports, "getShortISOString", ()=>$caee16c105163c22$export$77d5bc49fed7ef14);
    $parcel$export(module.exports, "getSafeCalendarValue", ()=>$caee16c105163c22$export$ff525416014fb67d);
    var $k7m40;
    var $2ucUe;
    function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
        return (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("2ucUe")).convertTokens)('YYYY-MM-DD'));
    }
    function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
        const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
        if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
        return calendarValue;
    }
});
parcelRegister("dBs4v", function(module, exports) {
    $parcel$export(module.exports, "makeSingleValue", ()=>$9661917c82165ad2$export$6e30bf8cb1347b56);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...rest })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).SingleValue, {
                ...rest,
                className: className,
                clearValue: clearValue,
                cx: cx,
                data: data,
                getStyles: getStyles,
                getValue: getValue,
                hasValue: hasValue,
                innerProps: {
                    lang: lang
                },
                isDisabled: isDisabled,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: selectProps,
                setValue: setValue,
                theme: theme
            }, children);
        };
});
parcelRegister("jcbUF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48f5b21daaca02ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $6QvkM;
    var $9KnKW;
    var $acknU;
    var $cTemL;
    var $7qZ1x;
    var $VSDnB;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $7K5PP;
    var $7VXAu;
    var $jldZL;
    var $jHBnA;
    var $5RLF6;
    var $iaQLg;
    var $gtijU;
    var $6AqCE;
    var $dBs4v;
    function $48f5b21daaca02ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $48f5b21daaca02ab$var$packageName = "platform-pkg";
    const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
    const $48f5b21daaca02ab$var$analyticsAttributes = {
        componentName: 'datePicker',
        packageName: $48f5b21daaca02ab$var$packageName,
        packageVersion: $48f5b21daaca02ab$var$packageVersion
    };
    const $48f5b21daaca02ab$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $48f5b21daaca02ab$var$dropdownIndicatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $48f5b21daaca02ab$var$CalendarIcon = (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("acknU"))))) : (0, ($parcel$interopDefault((0, parcelRequire("cTemL")))));
    const $48f5b21daaca02ab$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: 'color.text.subtlest',
        insetBlockStart: 'space.0',
        insetInlineEnd: 'space.0',
        transition: `color 150ms`,
        ':hover': {
            color: 'color.text.subtle'
        }
    });
    const $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.400'
    });
    const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.050'
    });
    const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.025'
    });
    const $48f5b21daaca02ab$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $48f5b21daaca02ab$var$calendarButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    const $48f5b21daaca02ab$var$DatePicker = (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
        const containerRef = (0, $5uXOq.useRef)(null);
        const calendarRef = (0, $5uXOq.useRef)(null);
        const calendarButtonRef = (0, $5uXOq.useRef)(null);
        const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = $48f5b21daaca02ab$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
        const [_, setIsFocused] = (0, $5uXOq.useState)(false);
        const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
        const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
        const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
        const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()));
        const [l10n, setL10n] = (0, $5uXOq.useState)((0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(propLocale));
        const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
        const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
        const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
        const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false);
        const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
        const onChangePropWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChangeProp,
            action: 'selectedDate',
            actionSubject: 'datePicker',
            ...$48f5b21daaca02ab$var$analyticsAttributes
        });
        if (propLocale !== locale) {
            setL10n((0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(propLocale));
            setLocale(propLocale);
        }
        (0, $5uXOq.useEffect)(()=>{
            if (!isKeyDown) return;
            if (isOpen && wasOpenedFromCalendarButton) {
                setIsKeyDown(false);
                calendarRef?.current?.querySelector('button')?.focus();
            }
        }, [
            isKeyDown,
            calendarRef,
            isOpen,
            wasOpenedFromCalendarButton
        ]);
        const getValue = ()=>propValue ?? value;
        const getIsOpen = ()=>isOpenProp ?? isOpen;
        const onCalendarChange = ({ iso: iso })=>{
            setCalendarValue((0, (0, parcelRequire("5RLF6")).getParsedISO)({
                iso: iso
            }));
        };
        const onCalendarSelect = ({ iso: iso })=>{
            setSelectInputValue('');
            setIsOpen(false);
            setCalendarValue(iso);
            setValue(iso);
            setWasOpenedFromCalendarButton(false);
            onChangePropWithAnalytics(iso);
            if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
            else {
                const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            setIsOpen(false);
        };
        const onInputClick = ()=>{
            if (!isDisabled && !getIsOpen()) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                onBlur(event);
            }
        };
        const onContainerFocus = ()=>{
            setShouldSetFocusOnCurrentDay(false);
        };
        const onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (clearingFromIcon) setClearingFromIcon(false);
            else if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setIsFocused(false);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onSelectFocus = (event)=>{
            const value = getValue();
            if (clearingFromIcon) setClearingFromIcon(false);
            else {
                setIsOpen(!shouldShowCalendarButton);
                setCalendarValue(value);
                setIsFocused(true);
                setWasOpenedFromCalendarButton(false);
            }
            onFocus(event);
        };
        const onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, (0, parcelRequire("5RLF6")).parseDate)(inputValue, {
                    parseInputValue: rest?.parseInputValue,
                    dateFormat: rest?.dateFormat,
                    l10n: l10n
                });
                if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) setCalendarValue((0, (0, parcelRequire("6AqCE")).getShortISOString)(parsed));
            }
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        };
        const onInputKeyDown = (event)=>{
            const value = getValue();
            const keyPressed = event.key.toLowerCase();
            if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
            switch(keyPressed){
                case 'escape':
                    if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    setIsOpen(false);
                    setShouldSetFocusOnCurrentDay(false);
                    setWasOpenedFromCalendarButton(false);
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                            setClearingFromIcon(false);
                            setValue('');
                        }
                        break;
                    }
                case 'enter':
                    if (!isOpen) return;
                    event.preventDefault();
                    if (!(0, (0, parcelRequire("5RLF6")).isDateDisabled)(calendarValue, {
                        disabled: disabled
                    })) {
                        const safeCalendarValue = (0, (0, parcelRequire("6AqCE")).getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        setSelectInputValue('');
                        setIsOpen(false);
                        setValue(safeCalendarValue);
                        setCalendarValue(safeCalendarValue);
                        setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                        if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!shouldSetFocusOnCurrentDay) {
                        setIsOpen(true);
                        setShouldSetFocusOnCurrentDay(true);
                    }
                    break;
                default:
                    break;
            }
        };
        const onCalendarButtonKeyDown = (e)=>{
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                setIsKeyDown(true);
                setWasOpenedFromCalendarButton(true);
            }
        };
        const onCalendarButtonClick = (e)=>{
            setIsOpen(!isOpen);
            setWasOpenedFromCalendarButton(true);
            e.stopPropagation();
        };
        const onClear = ()=>{
            setValue('');
            setCalendarValue(defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()));
            if (!hideIcon) setClearingFromIcon(true);
            onChangePropWithAnalytics('');
        };
        const onSelectChange = (_value, action)=>{
            if (action.action === 'clear') onClear();
        };
        const handleSelectInputChange = (selectInputValue, actionMeta)=>{
            if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
            setSelectInputValue(selectInputValue);
        };
        const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
            const oldRef = containerRef.current;
            containerRef.current = ref;
            if (oldRef == null && ref != null) forceUpdate();
        }, [
            containerRef
        ]);
        const getterValue = getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $48f5b21daaca02ab$var$dropdownIndicatorStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, (0, parcelRequire("dBs4v")).makeSingleValue)({
            lang: propLocale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("jHBnA")).EmptyComponent) : dropDownIcon,
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iaQLg")).IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: (0, parcelRequire("gtijU")).Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: containerRef.current,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: calendarRef,
            calendarValue: getterValue && (0, (0, parcelRequire("6AqCE")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(getterValue)),
            calendarView: calendarValue,
            onCalendarChange: onCalendarChange,
            onCalendarSelect: onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay
        };
        const mergedStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-075, 6px)"
                })
        });
        const initialValue = getterValue ? {
            label: (0, (0, parcelRequire("5RLF6")).formatDate)(getterValue, {
                formatDisplayLabel: formatDisplayLabel,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }),
            value: getterValue
        } : null;
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
        const openCalendarLabelId = `open-calendar-label--${(0, (0, parcelRequire("9KnKW")).useId)()}`;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...innerProps,
            css: $48f5b21daaca02ab$var$pickerContainerStyles,
            "data-testid": testId && `${testId}--container`,
            onBlur: onContainerBlur,
            onFocus: onContainerFocus,
            onClick: onInputClick,
            onInput: onTextInput,
            onKeyDown: onInputKeyDown,
            ref: getContainerRef,
            role: "presentation"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            name: name,
            type: "hidden",
            value: getterValue,
            "data-testid": testId && `${testId}--input`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7K5PP")).default), {
            appearance: appearance,
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            autoFocus: autoFocus,
            clearControlLabel: clearControlLabel,
            closeMenuOnSelect: true,
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: menuIsOpen,
            onBlur: onSelectBlur,
            onChange: onSelectChange,
            onFocus: onSelectFocus,
            onInputChange: handleSelectInputChange,
            placeholder: (0, (0, parcelRequire("5RLF6")).getPlaceholder)({
                placeholder: placeholder,
                l10n: l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarRef: calendarProps.calendarRef,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $48f5b21daaca02ab$var$iconContainerStyles,
                value && !hideIcon ? $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew : $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles
            ]
        }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
            id: openCalendarLabelId
        }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            ...inputLabelId ? {
                'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
            } : {
                'aria-label': fullopenCalendarLabel
            },
            onClick: onCalendarButtonClick,
            onKeyDown: onCalendarButtonKeyDown,
            ref: calendarButtonRef,
            testId: testId && `${testId}--open-calendar-button`,
            type: "button",
            backgroundColor: "color.background.neutral.subtle",
            padding: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
            xcss: [
                $48f5b21daaca02ab$var$calendarButtonStyles,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') && $48f5b21daaca02ab$var$calendarButtonFixedSizeStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($48f5b21daaca02ab$var$CalendarIcon, {
            label: "",
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                color: "var(--ds-icon, #44546F)"
            } : {
                primaryColor: "var(--ds-icon, #44546F)"
            }
        }))) : null));
    });
    var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;
});
parcelRegister("7O4UO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e20204ce79b642c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $9KnKW;
    var $dRN65;
    var $efXp3;
    var $2x3Cb;
    var $kxqHl;
    var $6cAn5 = parcelRequire("6cAn5");
    function $7e20204ce79b642c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7e20204ce79b642c$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $7e20204ce79b642c$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $7e20204ce79b642c$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $7e20204ce79b642c$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
        const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7e20204ce79b642c$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kxqHl")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("dRN65", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$706cd4dbd4574fd7$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $706cd4dbd4574fd7$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("efXp3", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$987e2ff089e89967$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$987e2ff089e89967$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$987e2ff089e89967$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $987e2ff089e89967$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $987e2ff089e89967$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("kxqHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55ac25356e81a33$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d55ac25356e81a33$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d55ac25356e81a33$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d55ac25356e81a33$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("8tAHc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ceca1d2f82d990c4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ceca1d2f82d990c4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholderDate: {
            "id": "common-date.utils.date-messages.placeholder-date",
            "defaultMessage": "e.g. 2018/12/31"
        }
    });
});
parcelRegister("3LzsZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2176f4fa091e9ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $d2176f4fa091e9ab$var$SuppressEscKey extends (0, $5uXOq.Component) {
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                role: "presentation",
                onKeyDown: this.onKeyEvent,
                onKeyUp: this.onKeyEvent
            }, this.props.children);
        }
        constructor(...args){
            super(...args), this.onKeyEvent = (e)=>{
                const { key: key } = e;
                if (key === 'Escape') {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                }
            };
        }
    }
    var $d2176f4fa091e9ab$export$2e2bcd8739ae039 = $d2176f4fa091e9ab$var$SuppressEscKey;
});
parcelRegister("lhpg4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42dd5dd53080d3ce$export$2e2bcd8739ae039);
    var $7VHMR;
    var $42dd5dd53080d3ce$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        releaseDate: {
            "id": "project-directories.versions.release-version-modal.content.release-date.release-date",
            "defaultMessage": "Release date"
        }
    });
});
parcelRegister("3nRuh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c42196f8d6f40709$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $bC2fB;
    var $7ZIA5;
    var $3yLu1;
    var $ai3Yq;
    var $kqZtV;
    const $c42196f8d6f40709$var$mapStateToProps = ()=>{
        const renderVersionPickerFactory = (0, (0, parcelRequire("8QpSo")).default)((shouldSwapIssues, isSaving, baseUrl, projectKey, versionId)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ZIA5")).default), {
                    isDisabled: !shouldSwapIssues || isSaving,
                    baseUrl: baseUrl,
                    projectKey: projectKey,
                    ignore: [
                        versionId
                    ],
                    versionStatuses: [
                        'UNRELEASED'
                    ],
                    ...props
                }));
        return (state)=>{
            const { baseUrl: baseUrl, projectKey: projectKey, shouldSwapIssues: shouldSwapIssues, isSaving: isSaving, versionId: versionId } = (0, (0, parcelRequire("ai3Yq")).getPropsForVersionPicker)(state);
            return {
                toDoInProgressIssuesCount: (0, (0, parcelRequire("ai3Yq")).getTodoInProgressIssuesCount)(state),
                isSaving: (0, (0, parcelRequire("ai3Yq")).isSaving)(state),
                shouldSwapIssues: (0, (0, parcelRequire("ai3Yq")).isSwapSelected)(state),
                errors: (0, (0, parcelRequire("ai3Yq")).getErrors)(state),
                renderVersionPicker: renderVersionPickerFactory(shouldSwapIssues, isSaving, baseUrl, projectKey, versionId)
            };
        };
    };
    const $c42196f8d6f40709$var$dispatcher = (dispatch)=>({
            onInputChange: (version)=>dispatch((0, (0, parcelRequire("3yLu1")).releaseVersionUpdate)(version)),
            onSwapIssuesSelected: (swap)=>dispatch((0, (0, parcelRequire("3yLu1")).swapIssues)(swap))
        });
    const $c42196f8d6f40709$var$mapDispatchToProps = (dispatch)=>$c42196f8d6f40709$var$dispatcher(dispatch);
    var $c42196f8d6f40709$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($c42196f8d6f40709$var$mapStateToProps, $c42196f8d6f40709$var$mapDispatchToProps)((0, (0, parcelRequire("kqZtV")).default));
});
parcelRegister("7ZIA5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6639293982f702ce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $iQv12;
    var $4U4qk;
    var $az4zD;
    var $bcrAM;
    var $5wI4U;
    var $kVzJJ;
    class $6639293982f702ce$export$c7c815960e157d78 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isRequired: false,
                isDisabled: false,
                isClearableWithCrossIcon: false,
                baseUrl: '',
                noPortal: false,
                value: undefined,
                label: '',
                placeholder: undefined,
                ignore: [],
                versionStatuses: [],
                onSelected: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        getVersionIdsToIgnore() {
            const { value: value, ignore: ignore } = this.props;
            if (value) return [
                value.id,
                ...ignore
            ];
            return ignore;
        }
        getPlaceholder() {
            const { intl: { formatMessage: formatMessage } } = this.props;
            return this.props.placeholder === undefined ? formatMessage((0, (0, parcelRequire("kVzJJ")).default).placeholder) : this.props.placeholder;
        }
        getValue() {
            const { value: value } = this.props;
            if (value === null || value === undefined) return value;
            return (0, (0, parcelRequire("5wI4U")).transformVersion)(value);
        }
        render() {
            const { label: label, isRequired: isRequired, isDisabled: isDisabled, intl: intl, noPortal: noPortal, isClearableWithCrossIcon: isClearableWithCrossIcon } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4U4qk")).Picker), {
                value: this.getValue(),
                label: label,
                placeholder: this.getPlaceholder(),
                isRequired: isRequired,
                isDisabled: isDisabled,
                isClearableWithCrossIcon: isClearableWithCrossIcon,
                errorMessage: intl.formatMessage((0, (0, parcelRequire("kVzJJ")).default).error),
                onSelected: this.onSelected,
                options: this.onFetchOptions,
                noPortal: noPortal,
                intl: intl
            });
        }
        constructor(...args){
            super(...args), this.onSelected = (selectedOption, analyticsEvent)=>selectedOption ? this.props.onSelected({
                    id: selectedOption.value,
                    name: selectedOption.label
                }, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent), this.onFetchOptions = (filter)=>(0, (0, parcelRequire("bcrAM")).requestVersions)(this.props.baseUrl, this.props.projectKey, filter, this.props.versionStatuses, this.getVersionIdsToIgnore());
        }
    }
    var $6639293982f702ce$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)((0, (0, parcelRequire("iQv12")).default)({
        onSelected: 'versionPicker'
    })($6639293982f702ce$export$c7c815960e157d78));
});
parcelRegister("iQv12", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$945500a9598c3ac2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gvRPW;
    const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
        const providedKeys = Object.keys(ConnectedProps).sort();
        const cachedMappedProps = {};
        const cachedConnectedProps = {};
        const getStateFromMappedProps = (mapped)=>{
            providedKeys.forEach((key, index)=>{
                const prop = mapped[index];
                if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
                cachedMappedProps[key] = prop;
                cachedConnectedProps[key] = (...attrs)=>{
                    const analyticsEvent = attrs[attrs.length - 1].clone();
                    const connectedProp = ConnectedProps[key];
                    if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                        name: connectedProp,
                        analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                    }).fire();
                    else if (typeof connectedProp === 'function') {
                        const update = connectedProp(...attrs);
                        analyticsEvent.update({
                            ...update,
                            analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                        }).fire();
                    }
                    if (typeof prop === 'function') prop(...attrs);
                };
            });
            return cachedConnectedProps;
        };
        return (WrappedComponent)=>class WithAnalytics extends (0, $5uXOq.Component) {
                static{
                    this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
                }
                render() {
                    const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                        ...this.props,
                        ...newMappedProps
                    });
                }
            };
    };
    var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;
});
parcelRegister("4U4qk", function(module, exports) {
    $parcel$export(module.exports, "getOptionBaseStyles", ()=>$0d1a93ba35d548ba$export$cef6e25059b681a);
    $parcel$export(module.exports, "Picker", ()=>$0d1a93ba35d548ba$export$ba25329847403e11);
    $parcel$export(module.exports, "default", ()=>$0d1a93ba35d548ba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lFKmC = parcelRequire("lFKmC");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $ctg8C;
    var $dC5iT;
    var $8CUq3;
    var $1ZftP;
    var $94bNw;
    var $bChGW;
    var $iOwNT;
    var $7K5PP;
    var $3bDjY;
    var $VgvL1;
    var $fVAPR;
    var $gwIPs;
    var $az4zD;
    var $e239o;
    const $0d1a93ba35d548ba$export$3a3072dd741f354b = 500;
    const $0d1a93ba35d548ba$export$cef6e25059b681a = (optionState)=>({
            ...optionState.isDisabled ? {
                cursor: 'not-allowed',
                color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N90})`,
                '&, :active': {
                    backgroundColor: 'transparent'
                }
            } : {
                cursor: 'pointer'
            },
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        });
    class $0d1a93ba35d548ba$export$ba25329847403e11 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isRequired: false,
                isDisabled: false,
                isClearable: false,
                isCompact: false,
                isCreatable: false,
                isMulti: false,
                noPortal: false,
                isCheckbox: false,
                label: '',
                defaultValue: undefined,
                width: 'auto',
                onSelected: (0, ($parcel$interopDefault($8Rkzz))),
                onMultiSelected: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        static getDerivedStateFromProps(props) {
            if (props.menuIsOpen !== undefined) return {
                menuIsOpen: props.menuIsOpen
            };
            return null;
        }
        constructor(props){
            super(props), this.state = {
                validationState: 'default',
                showErrorMessage: false,
                menuWasOpen: false,
                menuIsOpen: false,
                initialFocusHandled: false
            }, this.onSelected = (selection, action, analyticsEvent)=>{
                this.setState(()=>({
                        menuIsOpen: false
                    }));
                const { isMulti: isMulti } = this.props;
                if (Array.isArray(selection)) {
                    if (isMulti) this.props.onMultiSelected(selection, analyticsEvent);
                    else this.props.onSelected(undefined, analyticsEvent);
                } else selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
            }, this.onMenuOpen = ()=>{
                this.setState(()=>({
                        menuIsOpen: true,
                        menuWasOpen: true
                    }));
            }, this.onMenuClose = ()=>{
                this.setState(()=>({
                        menuIsOpen: false
                    }));
            }, this.onBlur = (event)=>{
                this.hideErrorMessage();
                const { onBlur: onBlur } = this.props;
                if (onBlur && typeof onBlur === 'function') onBlur(event);
            }, this.onFocus = (event)=>{
                this.showErrorMessage();
                const { onFocus: onFocus } = this.props;
                if (onFocus && typeof onFocus === 'function') onFocus(event);
            }, this.setErrorState = ()=>{
                this.setState({
                    showErrorMessage: true,
                    validationState: 'error'
                });
            }, this.showErrorMessage = ()=>this.setState({
                    showErrorMessage: true
                }), this.hideErrorMessage = ()=>this.setState({
                    showErrorMessage: false
                }), this.loadOptions = (filter, callback)=>{
                this.setState({
                    validationState: 'default'
                });
                this.debouncedLoadOptions(filter, callback);
            }, this.renderOption = (props)=>{
                const propsData = props.data;
                const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    position: "right",
                    content: disableReason
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Option, props));
            }, this.renderMenuList = (menuListProps)=>{
                const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).MenuList, menuListProps, isClearable && menuListProps.hasValue && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $0d1a93ba35d548ba$var$clearButtonWrapperStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "link",
                    shouldFitContainer: true,
                    onClick: menuListProps.clearValue
                }, formatMessage((0, (0, parcelRequire("e239o")).default).clearSelected))), menuListProps.children));
            }, this.renderValueContainer = (props)=>{
                const { onValueContainerClick: onValueContainerClick } = props.selectProps;
                return (0, ($parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$StyledValueContainer, {
                    "data-testid": "common-components-picker.base.react-dnd-and-select-focus-bug-fix",
                    onClick: onValueContainerClick
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).ValueContainer, props));
            };
            this.debouncedLoadOptions = (0, ($parcel$interopDefault($lFKmC)))((filter, callback)=>{
                this.props.options(filter).then(callback, ()=>{
                    callback([]);
                    this.setErrorState();
                });
            }, $0d1a93ba35d548ba$export$3a3072dd741f354b);
            this.selectRef = (0, $5uXOq.createRef)();
        }
        getSelectComponent(isAsync) {
            if (this.props.isCreatable) return isAsync ? (0, (0, parcelRequire("1ZftP")).default) : (0, (0, parcelRequire("iOwNT")).default);
            if (isAsync) return 0, (0, parcelRequire("VgvL1")).AsyncSelectWithAnalytics;
            return this.props.isCheckbox ? (0, (0, parcelRequire("94bNw")).default) : (0, (0, parcelRequire("7K5PP")).default);
        }
        getComponentOverrides() {
            const { menuWasOpen: menuWasOpen } = this.state;
            const Option = {
                Option: this.renderOption
            };
            const MenuList = {
                MenuList: this.renderMenuList
            };
            const LoadingIndicator = menuWasOpen ? {} : {
                LoadingIndicator: null
            };
            return {
                ...Option,
                ...MenuList,
                ...LoadingIndicator
            };
        }
        render() {
            const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
            const { intl: { formatMessage: formatMessage } } = this.props;
            const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, (0, parcelRequire("e239o")).default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
            const isAsync = typeof options === 'function';
            const SelectComponent = this.getSelectComponent(isAsync);
            const isErrorMessageOpened = showErrorMessage && validationState === 'error';
            let selectParams = {
                placeholder: placeholder,
                isDisabled: isDisabled,
                isClearable: isClearableWithCrossIcon || false,
                defaultValue: defaultValue,
                defaultOptions: true,
                autoFocus: !!this.props.autoFocus,
                loadOptions: isAsync && this.loadOptions,
                options: !isAsync && options,
                onChange: this.onSelected,
                noOptionsMessage: ()=>formatMessage((0, (0, parcelRequire("e239o")).default).noOptions),
                loadingMessage: ()=>formatMessage((0, (0, parcelRequire("e239o")).default).loading),
                validationState: this.state.validationState,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                menuPortalTarget: noPortal ? null : document.body,
                spacing: isCompact ? 'compact' : 'default',
                styles: {
                    menuPortal: (base)=>({
                            ...base,
                            zIndex: (0, (0, parcelRequire("gwIPs")).layers).modal
                        }),
                    container: (base)=>({
                            ...base,
                            width: width,
                            minWidth: minWidth
                        }),
                    option: (base, optionState)=>({
                            ...base,
                            ...$0d1a93ba35d548ba$export$cef6e25059b681a(optionState),
                            ...listItemCustomStyles
                        })
                }
            };
            if (!isCheckbox) selectParams = {
                ...selectParams,
                menuIsOpen: menuIsOpen,
                onMenuOpen: this.onMenuOpen,
                onMenuClose: this.onMenuClose,
                components: this.getComponentOverrides()
            };
            if (hasDraggableParentComponent) {
                const { initialFocusHandled: initialFocusHandled } = this.state;
                const handleClick = ()=>{
                    if (initialFocusHandled) this.setState((state)=>({
                            menuIsOpen: !state.menuIsOpen
                        }));
                    else if (!menuIsOpen) {
                        this.selectRef.current.focus();
                        this.setState(()=>({
                                initialFocusHandled: true
                            }));
                    }
                };
                selectParams = {
                    ...selectParams,
                    ref: this.selectRef,
                    components: {
                        ...this.getComponentOverrides,
                        ValueContainer: this.renderValueContainer
                    },
                    onValueContainerClick: handleClick,
                    openMenuOnFocus: true
                };
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, label && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVAPR")).FieldLabel), {
                htmlFor: this.props.inputId,
                label: label,
                isRequired: isRequired
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctg8C")).default), {
                content: errorMessage,
                isOpen: isErrorMessageOpened,
                placement: "right"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
                inputId: this.props.inputId,
                ...this.props,
                ...selectParams,
                options: isAsync ? undefined : this.props.options
            })));
        }
    }
    const $0d1a93ba35d548ba$var$PickerWithIntl = (0, (0, parcelRequire("az4zD")).injectIntlV2)($0d1a93ba35d548ba$export$ba25329847403e11);
    const $0d1a93ba35d548ba$var$DefaultPicker = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$PickerWithIntl, props);
    };
    $0d1a93ba35d548ba$var$DefaultPicker.defaultProps = $0d1a93ba35d548ba$export$ba25329847403e11.defaultProps;
    var $0d1a93ba35d548ba$export$2e2bcd8739ae039 = $0d1a93ba35d548ba$var$DefaultPicker;
    const $0d1a93ba35d548ba$var$StyledValueContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $0d1a93ba35d548ba$var$clearButtonWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`}`
    });
});
parcelRegister("1ZftP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffe39b95a8bd43db$export$2e2bcd8739ae039);
    var $isgat;
    var $3c98u;
    const $ffe39b95a8bd43db$var$AsyncCreatableSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("isgat")).default));
    var $ffe39b95a8bd43db$export$2e2bcd8739ae039 = $ffe39b95a8bd43db$var$AsyncCreatableSelect;
});
parcelRegister("isgat", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d6ce0d05b9e97e68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $2HH7Y;
    var $9uJ4X;
    const $d6ce0d05b9e97e68$var$AsyncCreatableSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const stateManagerProps = (0, (0, parcelRequire("iaInK")).default)(props);
        const creatableProps = (0, (0, parcelRequire("9uJ4X")).default)(stateManagerProps);
        const selectProps = (0, (0, parcelRequire("2HH7Y")).default)(creatableProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $d6ce0d05b9e97e68$export$2e2bcd8739ae039 = $d6ce0d05b9e97e68$var$AsyncCreatableSelect;
});
parcelRegister("94bNw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebf832c571222d72$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7K5PP;
    var $itpgN;
    const $ebf832c571222d72$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
        const mergedComponents = (0, $5uXOq.useMemo)(()=>({
                ...components,
                Option: (0, (0, parcelRequire("itpgN")).CheckboxOption)
            }), [
            components
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            closeMenuOnSelect: false,
            hideSelectedOptions: false,
            isMulti: true,
            ...props,
            components: mergedComponents
        });
    };
    const $ebf832c571222d72$var$CheckboxSelect = (0, ($parcel$interopDefault($5uXOq))).memo($ebf832c571222d72$var$CheckboxSelectInternal);
    var $ebf832c571222d72$export$2e2bcd8739ae039 = $ebf832c571222d72$var$CheckboxSelect;
});
parcelRegister("itpgN", function(module, exports) {
    $parcel$export(module.exports, "CheckboxOption", ()=>$f5875245cd0ad0c1$export$d40cc97ecda916f9);
    $parcel$export(module.exports, "RadioOption", ()=>$f5875245cd0ad0c1$export$82ab7168879267a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6aY6N;
    var $iQHJo;
    var $dV6Te;
    var $VSDnB;
    function $f5875245cd0ad0c1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f5875245cd0ad0c1$var$getPrimitiveStyles = (props)=>{
        const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
        const baseStyles = {
            alignItems: 'center',
            backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : 'transparent',
            color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
            display: 'flex ',
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingLeft: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-050, 4px)",
            boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}` : 'none',
            ':active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
            },
            '@media screen and (-ms-high-contrast: active)': {
                borderLeft: isFocused ? '2px solid transparent' : ''
            }
        };
        const augmentedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
            ...getStyles('option', props),
            ...baseStyles
        });
        const bemClasses = {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        };
        return [
            augmentedStyles,
            cx(bemClasses, className)
        ];
    };
    const $f5875245cd0ad0c1$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isActive) return `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
        else if (isFocused) return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
        else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (!isSelected) return 'transparent';
        return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isActive) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused) return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
    };
    const $f5875245cd0ad0c1$var$baseIconStyles = {
        name: "35x0q3",
        styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
    };
    const $f5875245cd0ad0c1$var$baseOptionStyles = {
        name: "16e0ede",
        styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    class $f5875245cd0ad0c1$var$ControlOption extends (0, $5uXOq.Component) {
        render() {
            const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
            const props = {
                ...innerProps,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            const [styles, classes] = $f5875245cd0ad0c1$var$getPrimitiveStyles({
                getStyles: getStyles,
                ...rest
            });
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: styles,
                className: classes,
                ref: innerRef,
                ...props
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $f5875245cd0ad0c1$var$baseIconStyles,
                    {
                        '& svg rect, & svg circle:first-of-type': {
                            stroke: $f5875245cd0ad0c1$var$getBorderColor({
                                ...this.props,
                                ...this.state
                            })
                        }
                    }
                ]
            }, !!Icon ? (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
                label: "",
                primaryColor: $f5875245cd0ad0c1$var$getPrimaryColor({
                    ...this.props,
                    ...this.state
                }),
                secondaryColor: $f5875245cd0ad0c1$var$getSecondaryColor({
                    ...this.props,
                    ...this.state
                }),
                isFacadeDisabled: true
            }) : null), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $f5875245cd0ad0c1$var$baseOptionStyles
            }, children)));
        }
        constructor(...args){
            super(...args), this.state = {
                isActive: false
            }, this.onMouseDown = ()=>this.setState({
                    isActive: true
                }), this.onMouseUp = ()=>this.setState({
                    isActive: false
                }), this.onMouseLeave = ()=>this.setState({
                    isActive: false
                });
        }
    }
    const $f5875245cd0ad0c1$var$NewCheckboxIcon = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), props, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            fill: "currentColor"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        })));
    const $f5875245cd0ad0c1$var$NewRadioIcon = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), props, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "6.75",
            fill: "currentColor",
            strokeWidth: "1.5"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "3",
            fill: "inherit"
        })));
    const $f5875245cd0ad0c1$export$d40cc97ecda916f9 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? $f5875245cd0ad0c1$var$NewCheckboxIcon : (0, ($parcel$interopDefault((0, parcelRequire("6aY6N"))))),
            ...props
        });
    const $f5875245cd0ad0c1$export$82ab7168879267a7 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? $f5875245cd0ad0c1$var$NewRadioIcon : (0, ($parcel$interopDefault((0, parcelRequire("iQHJo"))))),
            ...props
        });
});
parcelRegister("6aY6N", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $47f24d9003b82760$var$_react = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $47f24d9003b82760$var$_checkboxChecked = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("aoKYM")));
    function $47f24d9003b82760$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $47f24d9003b82760$var$CheckboxIcon = (props)=>$47f24d9003b82760$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $47f24d9003b82760$var$_checkboxChecked.default
        }));
    $47f24d9003b82760$var$CheckboxIcon.displayName = 'CheckboxIcon';
    var $47f24d9003b82760$var$_default = module.exports.default = $47f24d9003b82760$var$CheckboxIcon;
});
parcelRegister("aoKYM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $79209663d32c0c44$var$_UNSAFE_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $79209663d32c0c44$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>$79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
    var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;
});
parcelRegister("iQHJo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $db8f016a0af5fda9$var$_react = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $db8f016a0af5fda9$var$_radioChecked = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("kqGQn")));
    function $db8f016a0af5fda9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $db8f016a0af5fda9$var$RadioIcon = (props)=>$db8f016a0af5fda9$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
        }, props, {
            newIcon: $db8f016a0af5fda9$var$_radioChecked.default
        }));
    $db8f016a0af5fda9$var$RadioIcon.displayName = 'RadioIcon';
    var $db8f016a0af5fda9$var$_default = module.exports.default = $db8f016a0af5fda9$var$RadioIcon;
});
parcelRegister("kqGQn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $edf7783e719984ba$var$_react = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $edf7783e719984ba$var$_UNSAFE_baseNew = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $edf7783e719984ba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $edf7783e719984ba$var$RadioCheckedIcon = (props)=>$edf7783e719984ba$var$_react.default.createElement($edf7783e719984ba$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
        }, props));
    $edf7783e719984ba$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
    var $edf7783e719984ba$var$_default = module.exports.default = $edf7783e719984ba$var$RadioCheckedIcon;
});
parcelRegister("VgvL1", function(module, exports) {
    $parcel$export(module.exports, "AsyncSelectWithAnalytics", ()=>$462c399840da3e1c$export$ee664e5add893f9);
    var $d7FF4;
    var $8oe80;
    const $462c399840da3e1c$export$ee664e5add893f9 = (0, (0, parcelRequire("8oe80")).default)('select', {
        onChange: 'changed'
    })((0, (0, parcelRequire("d7FF4")).default));
});
parcelRegister("d7FF4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac4d84cf4438daea$export$2e2bcd8739ae039);
    var $eAthk;
    var $3c98u;
    const $ac4d84cf4438daea$var$AsyncSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    var $ac4d84cf4438daea$export$2e2bcd8739ae039 = $ac4d84cf4438daea$var$AsyncSelect;
});
parcelRegister("fVAPR", function(module, exports) {
    $parcel$export(module.exports, "FieldLabel", ()=>$97462970d1593b07$export$1acdcf5a973a8414);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $3RZIb;
    var $gwIPs;
    const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
            htmlFor: htmlFor
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$LabelText, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? (0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$RequiredIndicator, {
            role: "presentation"
        }, "*") : null));
    const $97462970d1593b07$var$Label = (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule",
                __cmplp.className
            ])
        });
    });
    const $97462970d1593b07$var$LabelText = (0, $47bDC.default).div.withConfig({
        componentId: "sc-9kgl5s-0"
    })`${(0, (0, parcelRequire("3RZIb")).h200)()} display:block;font-family:${(0, (0, parcelRequire("gwIPs")).fontFamily)};margin:0;${(0, $47bDC.css)({
        padding: `${"var(--ds-space-250, 20px)"} 0px ${"var(--ds-space-050, 4px)"} 0px`
    })}`;
    const $97462970d1593b07$var$RequiredIndicator = (0, $47bDC.default).span.withConfig({
        componentId: "sc-9kgl5s-1"
    })({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$exports).R400})`,
        fontFamily: (0, parcelRequire("gwIPs")).fontFamily,
        paddingLeft: "var(--ds-space-025, 2px)"
    });
    $97462970d1593b07$var$RequiredIndicator.displayName = 'RequiredIndicator';
});
parcelRegister("e239o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c6849afedcc0fa8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1c6849afedcc0fa8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOptions: {
            "id": "common.components.picker.base.no-options",
            "defaultMessage": "No results"
        },
        loading: {
            "id": "common.components.picker.base.loading",
            "defaultMessage": "Searching..."
        },
        defaultPlaceholder: {
            "id": "common.components.picker.base.default-placeholder",
            "defaultMessage": "Select..."
        },
        clearSelected: {
            "id": "common.components.picker.base.clear-selected",
            "defaultMessage": "Clear selected"
        }
    });
});
parcelRegister("bcrAM", function(module, exports) {
    $parcel$export(module.exports, "requestVersions", ()=>$5693781e34d2d219$export$aadfb092a4919504);
    var $fosv1;
    var $5wI4U;
    const $5693781e34d2d219$export$aadfb092a4919504 = async (baseUrl, projectKey, filter, versionStatuses, ignore, excludeArchivedVersions = false)=>{
        const pageVersions = await (0, (0, parcelRequire("fosv1")).requestVersions)(baseUrl, projectKey, filter, versionStatuses, ignore);
        return (0, (0, parcelRequire("5wI4U")).transformVersions)(pageVersions.values, ignore, excludeArchivedVersions);
    };
});
parcelRegister("fosv1", function(module, exports) {
    $parcel$export(module.exports, "MAX_RESULTS", ()=>$8ee5477fd3092e8b$export$f6b2881bc1090cea);
    $parcel$export(module.exports, "requestVersions", ()=>$8ee5477fd3092e8b$export$aadfb092a4919504);
    var $ebyGx = parcelRequire("ebyGx");
    var $7f4tk;
    const $8ee5477fd3092e8b$export$f6b2881bc1090cea = 5;
    const $8ee5477fd3092e8b$export$b702ac644ba114c = (baseUrl, projectKey)=>`${baseUrl}/rest/api/2/project/${projectKey}/version`;
    const $8ee5477fd3092e8b$export$10181c3ba572bfce = (filter, versionStatuses, ignore)=>(0, $ebyGx.stringify)({
            startAt: 0,
            query: filter,
            maxResults: $8ee5477fd3092e8b$export$f6b2881bc1090cea + ignore.length,
            orderBy: '+NAME',
            status: versionStatuses.join(',')
        });
    const $8ee5477fd3092e8b$export$8395ad088d65e586 = (baseUrl, projectKey, filter, versionStatuses, ignore)=>`${$8ee5477fd3092e8b$export$b702ac644ba114c(baseUrl, projectKey)}?${$8ee5477fd3092e8b$export$10181c3ba572bfce(filter, versionStatuses, ignore)}`;
    const $8ee5477fd3092e8b$export$aadfb092a4919504 = async (baseUrl, projectKey, filter, versionStatuses, ignore)=>(0, (0, parcelRequire("7f4tk")).default)($8ee5477fd3092e8b$export$8395ad088d65e586(baseUrl, projectKey, filter, versionStatuses, ignore));
});
parcelRegister("5wI4U", function(module, exports) {
    $parcel$export(module.exports, "transformVersion", ()=>$9ac4e1645e42431e$export$390ab7123357e756);
    $parcel$export(module.exports, "transformVersions", ()=>$9ac4e1645e42431e$export$8bc7a3929156b65e);
    var $fosv1;
    const $9ac4e1645e42431e$export$390ab7123357e756 = (component)=>({
            value: component.id,
            label: component.name
        });
    const $9ac4e1645e42431e$export$8bc7a3929156b65e = (data, ignore, excludeArchivedVersions)=>data.filter((value)=>!ignore.includes(value.id) && (!excludeArchivedVersions || !value.archived)).map($9ac4e1645e42431e$export$390ab7123357e756).slice(0, (0, (0, parcelRequire("fosv1")).MAX_RESULTS));
});
parcelRegister("kVzJJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc1b839fbdef43a1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cc1b839fbdef43a1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        error: {
            "id": "version-picker.error",
            "defaultMessage": "We couldn't retrieve versions"
        },
        placeholder: {
            "id": "version-picker.placeholder",
            "defaultMessage": "Select version"
        }
    });
});
parcelRegister("kqZtV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4dbde7804cdf94bb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7O4UO;
    var $jouoW;
    var $az4zD;
    var $rnB41;
    class $4dbde7804cdf94bb$var$SwapIssues extends (0, $5uXOq.Component) {
        inputChange(update) {
            const { onInputChange: onInputChange } = this.props;
            onInputChange({
                moveUnfixedIssuesTo: update.moveUnfixedIssuesTo
            });
        }
        render() {
            const { intl: { formatMessage: formatMessage }, toDoInProgressIssuesCount: toDoInProgressIssuesCount, shouldSwapIssues: shouldSwapIssues, errors: errors, isSaving: isSaving, renderVersionPicker: renderVersionPicker } = this.props;
            const { moveUnfixedIssuesTo: moveUnfixedIssuesToError } = errors;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                name: "UnresolvedIssue",
                isRequired: true,
                label: formatMessage((0, (0, parcelRequire("rnB41")).default).unresolvedIssuesHeader, {
                    issues: toDoInProgressIssuesCount
                })
            }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
                    isDisabled: isSaving,
                    isChecked: shouldSwapIssues,
                    onChange: this.onMoveIssuesSelected,
                    label: formatMessage((0, (0, parcelRequire("rnB41")).default).unresolvedIssuesMove, {
                        issues: toDoInProgressIssuesCount
                    }),
                    testId: "version-modals.release-version-modal.content.swap-issues.move-radio"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement($4dbde7804cdf94bb$var$VersionPickerContainer, null, renderVersionPicker({
                    onSelected: this.onSwapIssues
                })), moveUnfixedIssuesToError && (0, ($parcel$interopDefault($5uXOq))).createElement($4dbde7804cdf94bb$var$ValidationError, null, formatMessage((0, (0, parcelRequire("rnB41")).default).invalidVersionChosen, {
                    issues: toDoInProgressIssuesCount
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
                    isDisabled: isSaving,
                    isChecked: !shouldSwapIssues,
                    onChange: this.onRemoveVersionFromIssuesSelected,
                    label: formatMessage((0, (0, parcelRequire("rnB41")).default).unresolvedIssuesIgnore),
                    testId: "version-modals.release-version-modal.content.swap-issues.ignore-radio"
                })));
        }
        constructor(...args){
            super(...args), this.onSwapIssues = (version)=>{
                if (version) this.inputChange({
                    moveUnfixedIssuesTo: version.id
                });
                else this.inputChange({
                    moveUnfixedIssuesTo: ''
                });
            }, this.onMoveIssuesSelected = ()=>{
                const { onSwapIssuesSelected: onSwapIssuesSelected } = this.props;
                onSwapIssuesSelected(true);
            }, this.onRemoveVersionFromIssuesSelected = ()=>{
                const { onSwapIssuesSelected: onSwapIssuesSelected } = this.props;
                onSwapIssuesSelected(false);
            };
        }
    }
    var $4dbde7804cdf94bb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($4dbde7804cdf94bb$var$SwapIssues);
    const $4dbde7804cdf94bb$var$VersionPickerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s88z4d",
                __cmplp.className
            ])
        });
    });
    const $4dbde7804cdf94bb$var$ValidationError = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pku2gc _syaz17af",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jouoW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d22fafff331be84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $VSDnB;
    function $5d22fafff331be84$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5d22fafff331be84$var$packageName = "platform-pkg";
    const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
    const $5d22fafff331be84$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $5d22fafff331be84$var$labelPaddingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $5d22fafff331be84$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        boxSizing: 'border-box',
        position: 'relative',
        alignItems: 'flex-start',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
            cursor: 'not-allowed'
        }
    });
    const $5d22fafff331be84$var$radioStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: '24px',
        height: '24px',
        margin: "var(--ds-space-0, 0px)",
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        backgroundColor: 'var(--radio-background-color)',
        border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        MozAppearance: 'none',
        outline: 'none',
        '--radio-background-color': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--radio-dot-opacity': 0,
        transform: 'scale(calc(7 / 12))',
        transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
        verticalAlign: 'top',
        WebkitAppearance: 'none',
        '&::after': {
            width: 'calc(4px * 12 / 7)',
            height: 'calc(4px * 12 / 7)',
            position: 'absolute',
            background: 'var(--radio-dot-color)',
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: "''",
            opacity: 'var(--radio-dot-opacity)',
            transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
        },
        '&:hover': {
            '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
            '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
        },
        '&:active': {
            '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        },
        '&:focus': {
            outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-border-width-indicator, 3px)"
        },
        '&:checked': {
            '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            '--radio-dot-opacity': 1
        },
        '&:checked:hover': {
            '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
            '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`
        },
        '&:checked:active': {
            '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
            '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        },
        '&:checked:focus': {
            outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-border-width-indicator, 3px)"
        },
        '&[data-invalid], &:checked[data-invalid]': {
            '--radio-border-color': `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
        },
        '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
            cursor: 'not-allowed',
            '--radio-background-color': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            '--radio-border-color': `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`
        }
    });
    const $5d22fafff331be84$var$newRadioStyles = {
        name: "5rrwak",
        styles: "transform:scale(calc(7.5 / 12));&::after{width:calc(5.6px * 12 / 7);height:calc(5.6px * 12 / 7);}"
    };
    const $5d22fafff331be84$var$InnerRadio = (0, $5uXOq.forwardRef)(function Radio(props, ref) {
        const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, ...rest } = props;
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'radio',
            packageName: $5d22fafff331be84$var$packageName,
            packageVersion: $5d22fafff331be84$var$packageVersion
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            "data-testid": testId && `${testId}--radio-label`,
            "data-disabled": isDisabled ? 'true' : undefined,
            css: $5d22fafff331be84$var$labelStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...rest,
            tabIndex: 0,
            "aria-label": ariaLabel,
            checked: isChecked,
            disabled: isDisabled,
            name: name,
            onChange: onChangeAnalytics,
            required: isRequired,
            type: "radio",
            value: value,
            "data-testid": testId && `${testId}--radio-input`,
            "data-invalid": isInvalid ? 'true' : undefined,
            css: [
                $5d22fafff331be84$var$radioStyles,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') && $5d22fafff331be84$var$newRadioStyles
            ],
            ref: ref
        }), label ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $5d22fafff331be84$var$labelPaddingStyles
        }, label) : null);
    });
    const $5d22fafff331be84$var$Radio = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Radio(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($5d22fafff331be84$var$InnerRadio, {
            ...props,
            ref: ref
        });
    }));
    var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;
});
parcelRegister("rnB41", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a40bbc0e4b3cafaf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a40bbc0e4b3cafaf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unresolvedIssuesHeader: {
            "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-header",
            "defaultMessage": "Unresolved {issues, plural, one {issue} other {issues}}"
        },
        unresolvedIssuesMove: {
            "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-move",
            "defaultMessage": "Move unresolved {issues, plural, one {issue} other {issues}} to"
        },
        unresolvedIssuesIgnore: {
            "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-ignore",
            "defaultMessage": "Ignore unresolved issues"
        },
        invalidVersionChosen: {
            "id": "project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen",
            "defaultMessage": "Can't use this version. Change this version to another in your project or remove it from {issues, plural, one {this issue} other {these issues}}."
        }
    });
});
parcelRegister("uKe1m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a77752f277ff7388$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $ousew;
    var $az4zD;
    var $gED7w;
    class $a77752f277ff7388$export$7c6e2c02157bb7d2 extends (0, $5uXOq.Component) {
        renderDescriptionWithIssues() {
            const { intl: { formatMessage: formatMessage }, unresolvedIssuesCount: unresolvedIssuesCount, unresolvedIssuesUrl: unresolvedIssuesUrl } = this.props;
            const unresolvedIssueJqlViewLink = (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                href: unresolvedIssuesUrl
            }, formatMessage((0, (0, parcelRequire("gED7w")).default).descriptionWithIssuesCount, {
                issues: unresolvedIssuesCount
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("gED7w")).default).descriptionWithIssues,
                values: {
                    issueCountLink: unresolvedIssueJqlViewLink
                }
            }));
        }
        renderDescriptionWithoutIssues() {
            const { intl: { formatMessage: formatMessage }, resolvedIssueUrl: resolvedIssueUrl, resolvedIssuesCount: resolvedIssuesCount } = this.props;
            const resolvedIssueJqlViewLink = (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                href: resolvedIssueUrl
            }, formatMessage((0, (0, parcelRequire("gED7w")).default).descriptionWithoutIssues, {
                doneIssues: resolvedIssuesCount
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("gED7w")).default).descriptionWithoutIssuesRestMessage,
                values: {
                    issueCountLink: resolvedIssueJqlViewLink
                }
            }));
        }
        render() {
            const { unresolvedIssuesCount: unresolvedIssuesCount, SwapIssues: SwapIssues, ReleaseDate: ReleaseDate, ReleaseAutomationBanner: ReleaseAutomationBanner } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, unresolvedIssuesCount > 0 ? this.renderDescriptionWithIssues() : this.renderDescriptionWithoutIssues(), unresolvedIssuesCount > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement(SwapIssues, null) : null, (0, ($parcel$interopDefault($5uXOq))).createElement(ReleaseDate, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
                fallback: "unmount",
                packageName: "jiraSoftwareReleasesVersionDetail",
                teamName: "fusion-solaris",
                id: "releaseAutomationBanner"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ReleaseAutomationBanner, null)));
        }
    }
    var $a77752f277ff7388$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($a77752f277ff7388$export$7c6e2c02157bb7d2);
});
parcelRegister("gED7w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e5a4514f0f67d4d6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e5a4514f0f67d4d6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        descriptionWithIssues: {
            "id": "project-directories.versions.release-version-modal.content.description-with-issues",
            "defaultMessage": "This release contains {issueCountLink}."
        },
        descriptionWithIssuesCount: {
            "id": "project-directories.versions.release-version-modal.content.description-with-issues-count",
            "defaultMessage": "{issues, plural, one {{issues} unresolved issue} other {{issues} unresolved issues}}"
        },
        descriptionWithoutIssues: {
            "id": "project-directories.versions.release-version-modal.content.description-without-issues",
            "defaultMessage": "{doneIssues} {doneIssues, plural, one {issue} other {issues}}"
        },
        descriptionWithoutIssuesRestMessage: {
            "id": "project-directories.versions.release-version-modal.content.description-without-issues-rest-message",
            "defaultMessage": "{issueCountLink} will be released."
        }
    });
});
parcelRegister("61jfR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91e0f4109e87b34b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $dC5iT;
    var $8CUq3;
    var $eZJjh;
    var $jzjy1;
    var $iQv12;
    var $9fuVs;
    var $az4zD;
    var $8xH1O;
    var $dq84i;
    class $91e0f4109e87b34b$export$b77f092f9cf63f1e extends (0, $5uXOq.Component) {
        render() {
            const { Content: Content, unresolvedIssuesCount: unresolvedIssuesCount, isInitiating: isInitiating, onCancel: onCancel, intl: { formatMessage: formatMessage }, name: name } = this.props;
            if (isInitiating) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                isOpen: true,
                width: "small",
                onClose: onCancel,
                testId: "version-modals.release-version-modal.release-version-modal"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, unresolvedIssuesCount ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
                appearance: "warning"
            }, formatMessage((0, (0, parcelRequire("dq84i")).default).header, {
                name: name
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, (0, parcelRequire("dq84i")).default).header, {
                name: name
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(Content, null)), this.renderFooter(this.props)));
        }
        constructor(...args){
            super(...args), this.onButtonMounted = (node)=>{
                this.button = node;
            }, this.onRelease = (...args)=>{
                if (this.button) this.button.focus();
                this.props.onRelease(this.props.shouldRedirectToCreateReleaseNotes, args[args.length - 1]);
            }, this.renderFooter = (props)=>{
                const { intl: { formatMessage: formatMessage }, unresolvedIssuesCount: unresolvedIssuesCount, isSaving: isSaving, onCancel: onCancel, isReleaseDisabled: isReleaseDisabled, shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes, setRedirectToCreateReleaseNotesStatus: setRedirectToCreateReleaseNotesStatus, shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), props, (0, ($parcel$interopDefault($5uXOq))).createElement($91e0f4109e87b34b$var$FooterContainer, {
                    showReleaseNotesPrompt: shouldShowCreateReleaseNotesOption
                }, shouldShowCreateReleaseNotesOption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8xH1O")).CreateReleaseNotesPrompt), {
                    onChange: setRedirectToCreateReleaseNotesStatus,
                    value: shouldRedirectToCreateReleaseNotes
                }), (0, ($parcel$interopDefault($5uXOq))).createElement($91e0f4109e87b34b$var$ButtonsContainer, null, isSaving && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $91e0f4109e87b34b$var$spinnerContainerStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                    size: "small"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    onClick: this.onRelease,
                    appearance: unresolvedIssuesCount ? 'warning' : 'primary',
                    type: "submit",
                    isDisabled: isReleaseDisabled,
                    ref: this.onButtonMounted
                }, formatMessage((0, (0, parcelRequire("dq84i")).default).release)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "subtle-link",
                    isDisabled: false,
                    onClick: onCancel
                }, formatMessage((0, (0, parcelRequire("dq84i")).default).cancel)))));
            };
        }
    }
    var $91e0f4109e87b34b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('releaseVersions', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))((0, (0, parcelRequire("iQv12")).default)({
        onRelease: (isCreateReleaseNotesOptedIn)=>({
                name: 'release',
                isCreateReleaseNotesOptedIn: isCreateReleaseNotesOptedIn
            }),
        onCancel: 'cancel'
    })((0, (0, parcelRequire("az4zD")).injectIntlV2)($91e0f4109e87b34b$export$b77f092f9cf63f1e)));
    const $91e0f4109e87b34b$var$spinnerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.200'
    });
    const $91e0f4109e87b34b$var$ButtonsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $91e0f4109e87b34b$var$FooterContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { showReleaseNotesPrompt: showReleaseNotesPrompt, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq",
                __cmplp.showReleaseNotesPrompt ? "_1bah1yb4" : "_1bahesu3",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8xH1O", function(module, exports) {
    $parcel$export(module.exports, "CreateReleaseNotesPrompt", ()=>$cfcc6773eafb9afa$export$d8a8f048cf64e9ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kkJfY;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $gjQ4F;
    const $cfcc6773eafb9afa$export$d8a8f048cf64e9ff = ({ onChange: onChange, value: value })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onValueChange = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'toggled',
                actionSubject: 'checkbox'
            }), 'releaseModalCreateReleaseNotesCheckbox');
            onChange(event.target.checked);
        }, [
            createAnalyticsEvent,
            onChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($cfcc6773eafb9afa$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            name: "createReleaseNotes",
            label: formatMessage((0, (0, parcelRequire("gjQ4F")).default).createReleaseNotesTitle),
            isChecked: value,
            onChange: onValueChange
        }));
    };
    const $cfcc6773eafb9afa$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kkJfY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3106eb14f9b0a593$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $5JjdN;
    var $kag1C;
    var $7xteU;
    var $hsLv2;
    var $e62YQ;
    const $3106eb14f9b0a593$var$checkboxStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        margin: "var(--ds-space-0, 0px)",
        appearance: 'none',
        border: 'none',
        gridArea: '1 / 1 / 2 / 2',
        opacity: 0,
        outline: 'none',
        '& + svg': {
            '--checkbox-background-color': 'var(--local-background)',
            '--checkbox-border-color': 'var(--local-border)',
            '--checkbox-tick-color': 'var(--local-tick-rest)',
            color: 'var(--checkbox-background-color)',
            fill: 'var(--checkbox-tick-color)',
            gridArea: '1 / 1 / 2 / 2',
            pointerEvents: 'none',
            transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
            'rect:first-of-type': {
                stroke: 'var(--checkbox-border-color)',
                strokeWidth: "var(--ds-border-width, 1px)",
                transition: 'stroke 0.2s ease-in-out'
            }
        },
        '&&:focus + svg, &&:checked:focus + svg': {
            borderRadius: "var(--ds-border-radius, 0.25rem)",
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        },
        '&:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-hover)',
            '--checkbox-border-color': 'var(--local-border-hover)'
        },
        '&:checked:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-checked-hover)',
            '--checkbox-border-color': 'var(--local-border-checked-hover)'
        },
        '&:checked + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-invalid)'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-checked-invalid)'
        },
        '&:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)'
        },
        '&:checked:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)',
            '--checkbox-tick-color': 'var(--local-tick-active)'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            cursor: 'not-allowed',
            pointerEvents: 'none'
        },
        '&:disabled:checked + svg': {
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '&:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&:disabled:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '@media screen and (forced-colors: active)': {
            '& + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:checked + svg, &:checked:hover + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:focus + svg rect:first-of-type': {
                stroke: 'Highlight'
            },
            '&[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:checked[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'GrayText',
                '--checkbox-tick-color': 'GrayText'
            }
        }
    });
    const $3106eb14f9b0a593$var$Checkbox = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
        const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
        const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
        const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        }, [
            onChangeProps
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'checkbox',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const internalRef = (0, $5uXOq.useRef)(null);
        const mergedRefs = (0, (0, parcelRequire("5JjdN")).default)([
            internalRef,
            ref
        ]);
        const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
        (0, $5uXOq.useEffect)(()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        }, [
            isIndeterminate
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7xteU")).default), {
            isDisabled: isDisabled,
            label: label,
            id: rest.id ? `${rest.id}-label` : undefined,
            testId: testId && `${testId}--checkbox-label`,
            xcss: xcss
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            css: $3106eb14f9b0a593$var$checkboxStyles,
            onChange: onChangeAnalytics,
            "aria-invalid": isInvalid ? 'true' : undefined,
            "data-testid": testId && `${testId}--hidden-checkbox`,
            "data-invalid": isInvalid ? 'true' : undefined
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kag1C")).default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        }), label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hsLv2")).default), null, label, isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e62YQ")).default), null)));
    }));
    $3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
    var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;
});
parcelRegister("kag1C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0746a27410bc168$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dV6Te;
    var $VSDnB;
    function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
        if (isIndeterminate) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration')) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
                fill: "inherit"
            });
            else return (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
                fill: "inherit",
                x: "8",
                y: "11",
                width: "8",
                height: "2",
                rx: "1"
            });
        }
        if (isChecked) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration')) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                fill: "inherit"
            });
            else return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
                fill: "inherit"
            });
        }
        return null;
    }
    const $a0746a27410bc168$var$CheckboxIcon = (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
        const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
            isIndeterminate,
            isChecked
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), {
            label: "",
            primaryColor: "var(--checkbox-background-color)",
            secondaryColor: "var(--checkbox-tick-color)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5"
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2"
        }), icon));
    });
    var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;
});
parcelRegister("7xteU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b368d644c230660$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $7b368d644c230660$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        gridAutoColumns: '1fr',
        gridAutoRows: 'min-content',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        cursor: 'default',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $7b368d644c230660$var$textLabelLayoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        gridTemplateColumns: 'min-content auto'
    });
    const $7b368d644c230660$var$disabledStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    });
    const $7b368d644c230660$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        '--local-tick-rest': 'transparent'
    });
    function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            className: xcss,
            css: [
                $7b368d644c230660$var$baseStyles,
                label && $7b368d644c230660$var$textLabelLayoutStyles,
                isDisabled && $7b368d644c230660$var$disabledStyles,
                $7b368d644c230660$var$labelStyles
            ],
            "data-testid": testId,
            "data-disabled": isDisabled || undefined,
            id: id
        }, children);
    }
});
parcelRegister("hsLv2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce636d67b4ff1120$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ce636d67b4ff1120$var$labelTextStyles = {
        name: "12hofyr",
        styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
    };
    function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $ce636d67b4ff1120$var$labelTextStyles
        }, children);
    }
});
parcelRegister("e62YQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2156c28a3894cac$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d2156c28a3894cac$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d2156c28a3894cac$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d2156c28a3894cac$var$requiredIndicatorStyles,
            "aria-hidden": true
        }, "*");
    }
});
parcelRegister("gjQ4F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82038eb6c516431a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $82038eb6c516431a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createReleaseNotesTitle: {
            "id": "project-directories.versions.release-version-modal.create-release-notes-prompt.create-release-notes-title",
            "defaultMessage": "Create release notes"
        }
    });
});
parcelRegister("dq84i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bbc5f7f1540b8320$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bbc5f7f1540b8320$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        header: {
            "id": "project-directories.versions.release-version-modal.header",
            "defaultMessage": "Release {name}"
        },
        release: {
            "id": "project-directories.versions.release-version-modal.release",
            "defaultMessage": "Release"
        },
        cancel: {
            "id": "project-directories.versions.release-version-modal.cancel",
            "defaultMessage": "Cancel"
        }
    });
});
parcelRegister("63h61", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e726e5333611677b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e726e5333611677b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        buttonLabel: {
            "id": "software-releases-launch-card.version-status.button-label",
            "defaultMessage": "Version release state dropdown"
        },
        archiveOptionLabel: {
            "id": "software-releases-launch-card.version-status.archive-option-label",
            "defaultMessage": "Archive"
        },
        archivedLabel: {
            "id": "software-releases-launch-card.version-status.archived-label",
            "defaultMessage": "Archived"
        },
        releasedLabel: {
            "id": "software-releases-launch-card.version-status.released-label",
            "defaultMessage": "Released"
        },
        releaseOptionLabel: {
            "id": "software-releases-launch-card.version-status.release-option-label",
            "defaultMessage": "Release"
        },
        unarchiveOptionLabel: {
            "id": "software-releases-launch-card.version-status.unarchive-option-label",
            "defaultMessage": "Unarchive"
        },
        unreleaseOptionLabel: {
            "id": "software-releases-launch-card.version-status.unrelease-option-label",
            "defaultMessage": "Unrelease"
        },
        unreleasedLabel: {
            "id": "software-releases-launch-card.version-status.unreleased-label",
            "defaultMessage": "Unreleased"
        },
        archiveFailedFlagDescription: {
            "id": "software-releases-launch-card.version-status.archive-failed-flag-description",
            "defaultMessage": "We were not able to update the version archived status. Please refresh the page and try again."
        },
        genericUpdateFailedFlagTitle: {
            "id": "software-releases-launch-card.version-status.generic-update-failed-flag-title",
            "defaultMessage": "Something went wrong"
        },
        releaseFailedFlagDescription: {
            "id": "software-releases-launch-card.version-status.release-failed-flag-description",
            "defaultMessage": "We were not able to update the version released status. Please refresh the page and try again."
        }
    });
});
parcelRegister("oH05V", function(module, exports) {
    $parcel$export(module.exports, "LoadingWrapper", ()=>$513cf4f6a15c0943$export$43a792a870d28db2);
    $parcel$export(module.exports, "StatusLoading", ()=>$513cf4f6a15c0943$export$51c5b32c3d6a82a3);
    $parcel$export(module.exports, "LatestDeploymentLoading", ()=>$513cf4f6a15c0943$export$312fd886f74b4447);
    $parcel$export(module.exports, "TwoColumnFieldWrapper", ()=>$513cf4f6a15c0943$export$6dbdef323b681eb1);
    $parcel$export(module.exports, "FieldLoadingWrapper", ()=>$513cf4f6a15c0943$export$6f356a6f7f11d124);
    $parcel$export(module.exports, "FieldLabelLoading", ()=>$513cf4f6a15c0943$export$1411e5aa93aa9d74);
    $parcel$export(module.exports, "FieldContentLoading", ()=>$513cf4f6a15c0943$export$9f4ff45992eb7f88);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $513cf4f6a15c0943$var$skeletonKeyFrames = null;
    const $513cf4f6a15c0943$var$AnimationBaseDiv = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ju25ru3m _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _bfhkqrzy _j7hq1nls",
                __cmplp.className
            ])
        });
    });
    const $513cf4f6a15c0943$export$43a792a870d28db2 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1l7b _189et94y _1dqonqa1 _1h6dhloo",
                __cmplp.className
            ])
        });
    });
    const $513cf4f6a15c0943$export$51c5b32c3d6a82a3 = (0, $5uXOq.forwardRef)(({ as: C = $513cf4f6a15c0943$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1ylp",
                __cmplp.className
            ])
        });
    });
    const $513cf4f6a15c0943$export$312fd886f74b4447 = (0, $5uXOq.forwardRef)(({ as: C = $513cf4f6a15c0943$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i8vuz",
                __cmplp.className
            ])
        });
    });
    const $513cf4f6a15c0943$export$6dbdef323b681eb1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1neqek2": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.height}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4t3i2nrh",
                __cmplp.className
            ])
        });
    });
    const $513cf4f6a15c0943$export$6f356a6f7f11d124 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $513cf4f6a15c0943$export$1411e5aa93aa9d74 = (0, $5uXOq.forwardRef)(({ as: C = $513cf4f6a15c0943$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1ssb _4t3i7vkz _19pkftgi _2hwxidpf _otyrftgi _18u0idpf",
                __cmplp.className
            ])
        });
    });
    const $513cf4f6a15c0943$export$9f4ff45992eb7f88 = (0, $5uXOq.forwardRef)(({ as: C = $513cf4f6a15c0943$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1n8h _4t3i1crf _19pkftgi _2hwxidpf _otyrftgi _18u0idpf",
                __cmplp.className
            ])
        });
    });
    const $513cf4f6a15c0943$export$22183793b514d3aa = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq _4t3i8vuz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dLRv1", function(module, exports) {
    $parcel$export(module.exports, "IssueListWithHeaderWithErrorBoundary", ()=>$6c9ffa8d73f171f7$export$d97e9356033839cd);
    var $aVXy2;
    var $aJqtc;
    var $bkWqL;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $l1N8i;
    var $dC5iT;
    var $8CUq3;
    var $gwIPs;
    var $7Q2kM;
    var $39xOx;
    var $koVbs;
    var $lfTZh;
    var $jDrwg;
    var $iXVV6;
    var $jX1s1;
    var $fi7WV;
    var $1YU2V;
    var $20fNh;
    var $bRpse;
    var $a40gh;
    var $1KPiA;
    var $liM6F;
    var $kDV3t;
    var $1Ql36;
    var $4UGZW;
    var $hWY96;
    var $h1W9c;
    var $bLVnv;
    var $9VaPq;
    var $fx0Tw;
    var $c8MHq;
    const $6c9ffa8d73f171f7$var$DEV_DETAILS_DIALOG_SCOPE_ID = 'VersionDetailsIssueList';
    const $6c9ffa8d73f171f7$var$LOAD_MORE_PAGE_SIZE = 50;
    const $6c9ffa8d73f171f7$var$IssuesRefetchable = ({ jiraVersion: jiraVersion })=>{
        const { isAnyFilterApplied: isAnyFilterApplied } = (0, (0, parcelRequire("1YU2V")).useFilterSortingQueryParams)();
        const { filters: filters, sortBy: sortBy } = (0, (0, parcelRequire("20fNh")).useVersionIssuesGraphQLVariables)();
        const onExperienceSuccess = (0, (0, parcelRequire("1KPiA")).useViewVersionDetailsPageExperienceSuccess)();
        const versionFragmentRef = (0, $8Uumt.usePaginationFragment)((0, (0, parcelRequire("bkWqL")).default), jiraVersion);
        const { data: jiraVersionData, refetch: refetch, hasNext: hasNext, loadNext: loadNext, isLoadingNext: isLoadingNext } = versionFragmentRef;
        const loadNextPage = (0, $5uXOq.useCallback)(()=>{
            if (hasNext) loadNext($6c9ffa8d73f171f7$var$LOAD_MORE_PAGE_SIZE);
        }, [
            loadNext,
            hasNext
        ]);
        const issueEdges = jiraVersionData.issuesForList.edges.filter(Boolean);
        const totalIssuesCount = jiraVersionData.issuesForList.totalCount ?? issueEdges.length;
        const nextPageSize = Math.min(totalIssuesCount - issueEdges.length, $6c9ffa8d73f171f7$var$LOAD_MORE_PAGE_SIZE);
        const setLoadMoreElement = (0, (0, parcelRequire("c8MHq")).useIntersectionObserver)({
            margin: 40,
            onIntersection: loadNextPage
        });
        const variables = (0, (0, parcelRequire("bRpse")).useDeepMemo)({
            sortBy: sortBy,
            filters: filters
        });
        const [debouncedRefetch] = (0, (0, parcelRequire("jDrwg")).default)((refetchVariables)=>{
            refetch({
                id: jiraVersionData.id,
                ...refetchVariables
            });
        }, 500);
        const isFirstRenderRef = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>{
            if (isFirstRenderRef.current) isFirstRenderRef.current = false;
            else debouncedRefetch(variables);
        }, [
            debouncedRefetch,
            variables
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, issueEdges.length === 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "jira.software.releases.version.detail.issue.list.empty-view",
            packageName: "jira-software-releases-version-detail-issue-list",
            teamName: "fusion-solaris",
            onError: ()=>{
                onExperienceSuccess();
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("liM6F")).EmptyView), {
            jiraVersion: jiraVersionData,
            isAnyFilterApplied: isAnyFilterApplied,
            textFilter: filters.searchStr ?? null
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h1W9c")).Issues), {
            jiraIssueEdgesReference: issueEdges,
            jiraVersion: jiraVersionData,
            jiraVersionRefetch: jiraVersionData
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$LoadingMoreContainer, {
            ref: setLoadMoreElement
        }, isLoadingNext ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4UGZW")).IssueListSkeleton), {
            rowCount: nextPageSize
        }) : null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a40gh")).ErrorBoundary), {
            id: "jira.software.releases.version.detail.issue.list.screen-analytics"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fx0Tw")).IssueListScreenAnalytics), {
            jiraVersionReference: jiraVersionData,
            jiraIssueEdgesReference: issueEdges
        })));
    };
    const $6c9ffa8d73f171f7$var$IssueListWithHeader = ({ jiraVersion: jiraVersion })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("aJqtc")).default), jiraVersion);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "versionDetailsTable",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a40gh")).ErrorBoundary), {
            id: "issuesListDevDetailsDialog"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Q2kM")).DevDetailsDialogLoaderAsync), {
            scopeId: $6c9ffa8d73f171f7$var$DEV_DETAILS_DIALOG_SCOPE_ID
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fi7WV")).CollapsibleSection), {
            jiraVersion: data,
            uiType: "ISSUES",
            renderHeader: (isCollapsed, onToggleClicked)=>(0, ($parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$HeaderCollapsibleWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$HeaderLeftWrapper, {
                    onClick: onToggleClicked
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
                    size: "small",
                    as: "h2"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $6c9ffa8d73f171f7$var$sectionTitleStyles
                }, formatMessage((0, (0, parcelRequire("9VaPq")).default).issues))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
                    id: "jira.software.releases.version.detail.issue-total-count",
                    packageName: "jira-software-releases-version-detail-issue-list",
                    teamName: "fusion-solaris"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Ql36")).IssueTotalCount), {
                    jiraVersion: data
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fi7WV")).CollapsibleToggleButton), {
                    isCollapsed: isCollapsed
                })), (0, ($parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$HeaderRightWrapper, null, data.canAddAndRemoveIssues === true && (0, ($parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$AddIssueWrapper, {
                    key: "addIssuesButton"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX1s1")).AddIssuesToVersion), {
                    appearance: "subtle",
                    isIssueListFooterButton: true,
                    jiraVersion: data,
                    showIcon: true,
                    showLabel: false
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWY96")).IssuesMoreButton), {
                    key: "issuesMoreButton",
                    jiraVersion: data,
                    jiraIssueEdges: data.issuesForList.edges.filter(Boolean)
                }))),
            renderBody: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bLVnv")).ListOptions), {
                    jiraVersion: data
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                    name: "issues-refetchable",
                    fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4UGZW")).IssueListSkeleton), {
                        rowCount: 10,
                        marginTop: (0, (0, parcelRequire("gwIPs")).gridSize) * 2
                    })
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$IssuesRefetchable, {
                    jiraVersion: data
                })))
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1KPiA")).ViewVersionDetailsPageExperienceSuccessTracker), null));
    };
    const $6c9ffa8d73f171f7$export$d97e9356033839cd = ({ jiraVersion: jiraVersion })=>{
        const jiraVersionData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("aVXy2")).default), jiraVersion);
        const onExperienceFail = (0, (0, parcelRequire("1KPiA")).useViewVersionDetailsPageExperienceFail)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kDV3t")).ErrorView), null),
            id: "jira.software.releases.version.detail.issue.list",
            packageName: "jira-software-releases-version-detail-issue-list",
            teamName: "fusion-solaris",
            onError: (location, error)=>{
                onExperienceFail(location, error);
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$IssueListWithHeader, {
            jiraVersion: jiraVersionData
        }));
    };
    const $6c9ffa8d73f171f7$var$LoadingMoreContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _1tke7vkz",
                __cmplp.className
            ])
        });
    });
    const $6c9ffa8d73f171f7$var$AddIssueWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3izwfg _1bsbzwfg",
                __cmplp.className
            ])
        });
    });
    const $6c9ffa8d73f171f7$var$HeaderCollapsibleWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o _19pk1jfw",
                __cmplp.className
            ])
        });
    });
    const $6c9ffa8d73f171f7$var$HeaderLeftWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _80omtlke",
                __cmplp.className
            ])
        });
    });
    const $6c9ffa8d73f171f7$var$HeaderRightWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $6c9ffa8d73f171f7$var$sectionTitleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.100'
    });
});
parcelRegister("aVXy2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$520f02734ed0daec$export$2e2bcd8739ae039);
    const $520f02734ed0daec$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion"
            }
        ],
        "type": "JiraVersion"
    };
    $520f02734ed0daec$var$node.hash = "dcffc936c288beebfd459b5bcb75d18a";
    var $520f02734ed0daec$export$2e2bcd8739ae039 = $520f02734ed0daec$var$node;
});
parcelRegister("aJqtc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5703710cb99335d5$export$2e2bcd8739ae039);
    const $5703710cb99335d5$var$node = {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "filters"
            },
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "sortBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "issuesForList"
                    ]
                }
            ]
        },
        "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "listOptions_softwareReleasesVersionDetailIssueList"
            },
            {
                "kind": "FragmentSpread",
                "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "canAddAndRemoveIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "issuesForList",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": "ALL"
                        },
                        {
                            "kind": "Variable",
                            "name": "filters",
                            "variableName": "filters"
                        },
                        {
                            "kind": "Variable",
                            "name": "sortBy",
                            "variableName": "sortBy"
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "__ListVersion_issuesForList_connection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraIssueEdges"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "cursor"
                                    },
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "issuesForList.edges"
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "issuesForList"
            }
        ],
        "type": "JiraVersion"
    };
    $5703710cb99335d5$var$node.hash = "1b95186d8ae0c639ac2a3313467b4212";
    var $5703710cb99335d5$export$2e2bcd8739ae039 = $5703710cb99335d5$var$node;
});
parcelRegister("bkWqL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98a4a861304e679a$export$2e2bcd8739ae039);
    var $d1Clq;
    const $98a4a861304e679a$var$node = function() {
        var v0 = [
            "issuesForList"
        ];
        return {
            "argumentDefinitions": [
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "after"
                },
                {
                    "kind": "RootArgument",
                    "name": "filters"
                },
                {
                    "defaultValue": 20,
                    "kind": "LocalArgument",
                    "name": "first"
                },
                {
                    "kind": "RootArgument",
                    "name": "isDevopsFeatureDisabledInFedRamp"
                },
                {
                    "kind": "RootArgument",
                    "name": "isIssueSummarisedDeploymentsMigratedToAgs"
                },
                {
                    "kind": "RootArgument",
                    "name": "shouldIncludeDevOpsFieldsViaAgs"
                },
                {
                    "kind": "RootArgument",
                    "name": "sortBy"
                }
            ],
            "kind": "Fragment",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": v0
                    }
                ],
                "refetch": {
                    "connection": {
                        "forward": {
                            "count": "first",
                            "cursor": "after"
                        },
                        "backward": null,
                        "path": v0
                    },
                    "fragmentPathInResult": [
                        "node"
                    ],
                    "operation": (0, (0, parcelRequire("d1Clq")).default),
                    "identifierInfo": {
                        "identifierField": "id",
                        "identifierQueryVariableName": "id"
                    }
                }
            },
            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersion"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "emptyView_softwareReleasesVersionDetailIssueList"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "issuesForList",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "ALL"
                            },
                            {
                                "kind": "Variable",
                                "name": "filters",
                                "variableName": "filters"
                            },
                            {
                                "kind": "Variable",
                                "name": "sortBy",
                                "variableName": "sortBy"
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "__ListVersion_issuesForList_connection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "totalCount"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "jql"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraIssueEdges"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        },
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "issuesForList.edges"
                            },
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "endCursor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "issuesForList"
                }
            ],
            "type": "JiraVersion"
        };
    }();
    $98a4a861304e679a$var$node.hash = "1a52a23b324242e6dd47774f54758481";
    var $98a4a861304e679a$export$2e2bcd8739ae039 = $98a4a861304e679a$var$node;
});
parcelRegister("d1Clq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$897a8fc037864ba8$export$2e2bcd8739ae039);
    const $897a8fc037864ba8$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filters"
        }, v2 = {
            "defaultValue": 20,
            "kind": "LocalArgument",
            "name": "first"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isIssueSummarisedDeploymentsMigratedToAgs"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldIncludeDevOpsFieldsViaAgs"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sortBy"
        }, v8 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
            }
        ], v9 = {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        }, v10 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }, v11 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v12 = {
            "kind": "ScalarField",
            "name": "id"
        }, v13 = {
            "kind": "ScalarField",
            "name": "key"
        }, v14 = {
            "kind": "ScalarField",
            "name": "name"
        }, v15 = [
            v9,
            {
                "kind": "Literal",
                "name": "filter",
                "value": "ALL"
            },
            {
                "kind": "Variable",
                "name": "filters",
                "variableName": "filters"
            },
            v10,
            {
                "kind": "Variable",
                "name": "sortBy",
                "variableName": "sortBy"
            }
        ], v16 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v17 = {
            "kind": "ScalarField",
            "name": "count"
        }, v18 = {
            "kind": "ScalarField",
            "name": "state"
        }, v19 = {
            "concreteType": "DevOpsSummarisedBuildState",
            "kind": "LinkedField",
            "name": "buildStates",
            "plural": true,
            "selections": [
                v18,
                v17
            ]
        }, v20 = [
            v17
        ], v21 = {
            "concreteType": "DevOpsSummarisedFeatureFlags",
            "kind": "LinkedField",
            "name": "summarisedFeatureFlags",
            "plural": false,
            "selections": [
                v16,
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantDisplayName"
                },
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantEnabled"
                },
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantRolloutPercentage"
                }
            ]
        }, v22 = [
            v17,
            v12
        ], v23 = {
            "concreteType": "DevOpsSummarisedDeployments",
            "kind": "LinkedField",
            "name": "summarisedDeployments",
            "plural": false,
            "selections": v22
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7
                ],
                "kind": "Fragment",
                "name": "verionDetailsIssueListQuery",
                "selections": [
                    {
                        "args": v8,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    v9,
                                    v10
                                ],
                                "kind": "FragmentSpread",
                                "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v4,
                    v5,
                    v6,
                    v7,
                    v3
                ],
                "kind": "Operation",
                "name": "verionDetailsIssueListQuery",
                "selections": [
                    {
                        "args": v8,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v11,
                            v12,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "JiraVersionWarningConfig",
                                        "kind": "LinkedField",
                                        "name": "warningConfig",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "openPullRequest"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "openReview"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "unreviewedCode"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "failingBuild"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "canViewDevTools"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionIssueTableHiddenColumns"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "canAddAndRemoveIssues"
                                    },
                                    {
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": [
                                            v12,
                                            {
                                                "kind": "ScalarField",
                                                "name": "projectId"
                                            },
                                            v13
                                        ]
                                    },
                                    v14,
                                    {
                                        "alias": "issuesForList",
                                        "args": v15,
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issues",
                                        "plural": false,
                                        "selections": [
                                            v16,
                                            {
                                                "kind": "ScalarField",
                                                "name": "jql"
                                            },
                                            {
                                                "concreteType": "JiraIssueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v13,
                                                            v12,
                                                            {
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "ids",
                                                                        "value": [
                                                                            "priority",
                                                                            "summary",
                                                                            "assignee",
                                                                            "status",
                                                                            "issuetype"
                                                                        ]
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueFieldConnection",
                                                                "kind": "LinkedField",
                                                                "name": "fieldsById",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v11,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "fieldId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraStatus",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "status",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraStatusCategory",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "statusCategory",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "statusCategoryId"
                                                                                                            },
                                                                                                            v12
                                                                                                        ]
                                                                                                    },
                                                                                                    v12,
                                                                                                    v14,
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "description"
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraStatusField"
                                                                                    },
                                                                                    v12,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "user",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v11,
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "picture"
                                                                                                    },
                                                                                                    v14,
                                                                                                    v12
                                                                                                ]
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraSingleSelectUserPickerField"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "text"
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraSingleLineTextField"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueType",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "issueType",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v14,
                                                                                                    {
                                                                                                        "concreteType": "JiraAvatar",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "avatar",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "xsmall"
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    v12
                                                                                                ]
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraIssueTypeField"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraPriority",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "priority",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v14,
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "iconUrl"
                                                                                                    },
                                                                                                    v12
                                                                                                ]
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraPriorityField"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "issueId"
                                                            },
                                                            v11,
                                                            {
                                                                "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                "kind": "Condition",
                                                                "passingValue": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSummarisedEntities",
                                                                        "kind": "LinkedField",
                                                                        "name": "devOpsSummarisedEntities",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "DevOpsSummarisedBuilds",
                                                                                "kind": "LinkedField",
                                                                                "name": "summarisedBuilds",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v17,
                                                                                    v19,
                                                                                    v12
                                                                                ]
                                                                            },
                                                                            {
                                                                                "concreteType": "DevOpsSummarisedDeployments",
                                                                                "kind": "LinkedField",
                                                                                "name": "summarisedDeployments",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "DevOpsEnvironment",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "deploymentEnvironment",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "category"
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "deploymentState"
                                                                                    },
                                                                                    v12
                                                                                ]
                                                                            },
                                                                            {
                                                                                "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                                "kind": "Condition",
                                                                                "passingValue": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "DevOpsSummarisedDeployments",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "summarisedDeployments",
                                                                                        "plural": false,
                                                                                        "selections": v20
                                                                                    },
                                                                                    v21
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraIssueDevSummaryResult",
                                                                        "kind": "LinkedField",
                                                                        "name": "devSummaryCache",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueDevSummary",
                                                                                "kind": "LinkedField",
                                                                                "name": "devSummary",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "pullrequest",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "overall",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v17,
                                                                                                    v18
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "branch",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueBranchDevSummary",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "overall",
                                                                                                "plural": false,
                                                                                                "selections": v20
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "review",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueReviewDevSummary",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "overall",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v17,
                                                                                                    v18,
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "lastUpdated"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "stateCount"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "summaryByProvider",
                                                                                                "plural": true,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "providerId"
                                                                                                    },
                                                                                                    v14,
                                                                                                    v17
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "commit",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueCommitDevSummary",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "overall",
                                                                                                "plural": false,
                                                                                                "selections": v20
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "build",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueBuildDevSummary",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "overall",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v17,
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "failedBuildCount"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "successfulBuildCount"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "unknownBuildCount"
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "deploymentEnvironments",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "overall",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "topEnvironments",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "status"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "title"
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            v23,
                                                                            {
                                                                                "concreteType": "DevOpsSummarisedBuilds",
                                                                                "kind": "LinkedField",
                                                                                "name": "summarisedBuilds",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v19,
                                                                                    v17,
                                                                                    v12
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            v21
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    v23,
                                                                    {
                                                                        "concreteType": "DevOpsSummarisedBuilds",
                                                                        "kind": "LinkedField",
                                                                        "name": "summarisedBuilds",
                                                                        "plural": false,
                                                                        "selections": v22
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                        "kind": "LinkedField",
                                                                        "name": "summarisedFeatureFlags",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v16
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "cursor"
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "endCursor"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "alias": "issuesForList",
                                        "args": v15,
                                        "filters": [
                                            "filter",
                                            "sortBy",
                                            "filters"
                                        ],
                                        "handle": "connection",
                                        "key": "ListVersion_issuesForList",
                                        "kind": "LinkedHandle",
                                        "name": "issues"
                                    },
                                    {
                                        "condition": "isDevopsFeatureDisabledInFedRamp",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "concreteType": "DevOpsSummarisedEntities",
                                                "kind": "LinkedField",
                                                "name": "devOpsSummarisedEntities",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "DevOpsProviders",
                                                        "kind": "LinkedField",
                                                        "name": "providers",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "DevOpsFeatureFlagProvider",
                                                                "kind": "LinkedField",
                                                                "name": "featureFlagProviders",
                                                                "plural": true,
                                                                "selections": [
                                                                    v11,
                                                                    v12,
                                                                    v14,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "createFeatureFlagTemplateUrl"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "connectFeatureFlagTemplateUrl"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "logoUrl"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "type": "JiraVersion"
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "26e25861f3c09cd6ac38042267a2bb3604873c383bc5c314249c167618f0c705",
                "metadata": {},
                "name": "verionDetailsIssueListQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $897a8fc037864ba8$var$node.hash = "1a52a23b324242e6dd47774f54758481";
    var $897a8fc037864ba8$export$2e2bcd8739ae039 = $897a8fc037864ba8$var$node;
});
parcelRegister("7Q2kM", function(module, exports) {
    $parcel$export(module.exports, "DevDetailsDialogLoaderAsync", ()=>$1e951f8230b07137$export$f5ffc0f323543e16);
    $parcel$export(module.exports, "default", ()=>$1e951f8230b07137$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $lfTZh;
    var $kxZPA;
    const $1e951f8230b07137$var$DevDetailDialogLoaderWithContainer = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("jmhGO")), {
        ssr: false,
        moduleId: "./src/packages/development/details-loader/src/ui/main.tsx"
    });
    const $1e951f8230b07137$export$f5ffc0f323543e16 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "dev-detail-dialog-loader-with-container",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1e951f8230b07137$var$DevDetailDialogLoaderWithContainer, props));
    $1e951f8230b07137$export$f5ffc0f323543e16.defaultProps = {
        onCloseDevDetailDialog: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $1e951f8230b07137$export$2e2bcd8739ae039 = $1e951f8230b07137$export$f5ffc0f323543e16;
});
parcelRegister("jmhGO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4DoQ8")
    ]).then(()=>parcelRequire('bmGNV'));
});
parcelRegister("fi7WV", function(module, exports) {
    $parcel$export(module.exports, "CollapsibleToggleButton", ()=>$b5a0aa544c0a186e$export$9438d677ba26a40a);
    $parcel$export(module.exports, "CollapsibleSection", ()=>$b5a0aa544c0a186e$export$55b973e094275b13);
    var $eaM0Q;
    var $eXHXY;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $6Ingq;
    var $ebd3R;
    var $jcw0u;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $doJJi;
    var $3obFm;
    const $b5a0aa544c0a186e$var$getNewCollapsedUis = (currentState, type, isCurrentlyCollapsed)=>isCurrentlyCollapsed ? currentState.filter((value)=>value !== type) : [
            ...currentState,
            type
        ];
    const $b5a0aa544c0a186e$export$9438d677ba26a40a = ({ isCollapsed: isCollapsed, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const icon = isCollapsed ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ebd3R"))))), {
            label: formatMessage((0, (0, parcelRequire("doJJi")).default).collapsedIconLabel)
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
            label: formatMessage((0, (0, parcelRequire("doJJi")).default).expandedIconLabel)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            iconBefore: icon,
            onClick: onClick
        });
    };
    const $b5a0aa544c0a186e$export$55b973e094275b13 = ({ jiraVersion: jiraVersion, uiType: uiType, renderHeader: renderHeader, renderBody: renderBody })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("eXHXY")).default), jiraVersion);
        const collapsedUis = (version.collapsedUis ?? []).filter(Boolean);
        const [updateCollapsedUis] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("eaM0Q")).default));
        const onError = ()=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'jira.releases.version.detail.collapsed-uis.user-preference.mutation.error.id',
                    packageName: 'jiraSoftwareReleasesCollapsibleUiToggle',
                    teamName: 'fusion-solaris'
                },
                error: Error('Unable to update collapsed ui state'),
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const saveUserPreference = (newCollapsedUis)=>{
            updateCollapsedUis({
                variables: {
                    input: {
                        collapsedUis: newCollapsedUis,
                        versionId: version.id
                    }
                },
                onCompleted: (data)=>{
                    if (!data.jira?.saveVersionDetailsCollapsedUis?.success) onError();
                },
                onError: onError,
                optimisticResponse: {
                    jira: {
                        saveVersionDetailsCollapsedUis: {
                            success: true,
                            version: {
                                collapsedUis: newCollapsedUis,
                                id: version.id
                            }
                        }
                    }
                }
            });
        };
        const isCollapsed = collapsedUis.includes(uiType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderHeader(isCollapsed, ()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'toggled',
                actionSubject: 'collapsedUiToggleButon'
            }), 'versionDetailsCollapsedUis', {
                uiType: uiType,
                action: isCollapsed ? 'expand' : 'collapse'
            });
            saveUserPreference($b5a0aa544c0a186e$var$getNewCollapsedUis(collapsedUis, uiType, isCollapsed));
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b5a0aa544c0a186e$var$CollapsibleContent, {
            isCollapsed: (0, (0, parcelRequire("3obFm")).checkIsCollapsed)(version.collapsedUis, uiType)
        }, renderBody()));
    };
    const $b5a0aa544c0a186e$var$CollapsibleContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.isCollapsed ? "_1e0cglyw" : "_1e0c1ule",
                __cmplp.isCollapsed ? "_otyr1jfw" : "_otyrze3t",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("eaM0Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c64b6eb7486b219d$export$2e2bcd8739ae039);
    const $c64b6eb7486b219d$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "kind": "ScalarField",
            "name": "collapsedUis"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                                "kind": "LinkedField",
                                "name": "saveVersionDetailsCollapsedUis",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                                "kind": "LinkedField",
                                "name": "saveVersionDetailsCollapsedUis",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "59da25bc507c60457c7c0a7f80672b6888c11c77e2bed2a33db2c0d2dcd80db9",
                "metadata": {},
                "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $c64b6eb7486b219d$var$node.hash = "784b6375f621589ebabb1f85323c82aa";
    var $c64b6eb7486b219d$export$2e2bcd8739ae039 = $c64b6eb7486b219d$var$node;
});
parcelRegister("eXHXY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8bf2bd9e5955f9e$export$2e2bcd8739ae039);
    const $e8bf2bd9e5955f9e$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "collapsedUis"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            }
        ],
        "type": "JiraVersion"
    };
    $e8bf2bd9e5955f9e$var$node.hash = "4c7960151ff25f69412e79192a278d0e";
    var $e8bf2bd9e5955f9e$export$2e2bcd8739ae039 = $e8bf2bd9e5955f9e$var$node;
});
parcelRegister("doJJi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8228388d4b0e23ba$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8228388d4b0e23ba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        collapsedIconLabel: {
            "id": "software-releases-collapsible-ui-toggle.collapsed-icon-label",
            "defaultMessage": "Click/enter to expand the section"
        },
        expandedIconLabel: {
            "id": "software-releases-collapsible-ui-toggle.expanded-icon-label",
            "defaultMessage": "Click/enter to collapse the section"
        }
    });
});
parcelRegister("3obFm", function(module, exports) {
    $parcel$export(module.exports, "checkIsCollapsed", ()=>$48ec67b9d596c03c$export$b5bb70308851c0e1);
    const $48ec67b9d596c03c$export$b5bb70308851c0e1 = (collapsedUis, type)=>(collapsedUis ?? []).includes(type);
});
parcelRegister("1YU2V", function(module, exports) {
    $parcel$export(module.exports, "useFilterSortingQueryParams", ()=>$b2385da6883008a2$export$c59d013998b3679d);
    var $gULOk;
    var $3hGWp;
    var $3dG8c;
    const $b2385da6883008a2$var$joinValuesIfNotEmpty = (values)=>values.length ? values.join(',') : undefined;
    const $b2385da6883008a2$export$c59d013998b3679d = ()=>{
        const [queryParams, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)((0, $5d187be87424268f$export$e39925d10cebc0b), (0, $5d187be87424268f$export$b98a7875ddbefaac), (0, $5d187be87424268f$export$c307007520232013), (0, $5d187be87424268f$export$2552faed9df6a2cd), (0, $5d187be87424268f$export$f78d8c81fcad32a2), (0, $5d187be87424268f$export$13d5b2891ca65cd6), (0, $5d187be87424268f$export$810a1f7ed2facfcb));
        const parsedQueryParams = (0, (0, parcelRequire("3dG8c")).parseQueryParams)(queryParams);
        return {
            parsedQueryParams: parsedQueryParams,
            isAnyFilterApplied: (0, (0, parcelRequire("3dG8c")).isAnyFilterApplied)(parsedQueryParams),
            setTextFilterParam: (searchStr)=>setQueryParams({
                    [(0, $5d187be87424268f$export$e39925d10cebc0b)]: searchStr === '' || searchStr == null ? undefined : searchStr
                }),
            setEpicFilterParam: (issueIds)=>setQueryParams({
                    [(0, $5d187be87424268f$export$b98a7875ddbefaac)]: $b2385da6883008a2$var$joinValuesIfNotEmpty(issueIds)
                }),
            setStatusCategoryFilterParam: (statusCategories)=>setQueryParams({
                    [(0, $5d187be87424268f$export$c307007520232013)]: $b2385da6883008a2$var$joinValuesIfNotEmpty(statusCategories.map((0, (0, parcelRequire("gULOk")).statusCategoryForId)))
                }),
            setWarningsFilterParam: (warnings)=>setQueryParams({
                    [(0, $5d187be87424268f$export$2552faed9df6a2cd)]: $b2385da6883008a2$var$joinValuesIfNotEmpty(warnings)
                }),
            setAssigneeFilterParam: (assignees)=>setQueryParams({
                    [(0, $5d187be87424268f$export$f78d8c81fcad32a2)]: $b2385da6883008a2$var$joinValuesIfNotEmpty(assignees)
                }),
            setSortByParam: (sortBy)=>setQueryParams({
                    [(0, $5d187be87424268f$export$13d5b2891ca65cd6)]: sortBy
                }),
            setSortOrderParam: (sortOrder)=>setQueryParams({
                    [(0, $5d187be87424268f$export$810a1f7ed2facfcb)]: sortOrder
                }),
            clearAll: ()=>{
                setQueryParams({
                    [(0, $5d187be87424268f$export$e39925d10cebc0b)]: undefined,
                    [(0, $5d187be87424268f$export$b98a7875ddbefaac)]: undefined,
                    [(0, $5d187be87424268f$export$c307007520232013)]: undefined,
                    [(0, $5d187be87424268f$export$2552faed9df6a2cd)]: undefined,
                    [(0, $5d187be87424268f$export$f78d8c81fcad32a2)]: undefined,
                    [(0, $5d187be87424268f$export$13d5b2891ca65cd6)]: undefined,
                    [(0, $5d187be87424268f$export$810a1f7ed2facfcb)]: undefined
                });
            },
            showIssuesWithWarnings: (warnings)=>{
                setQueryParams({
                    [(0, $5d187be87424268f$export$e39925d10cebc0b)]: undefined,
                    [(0, $5d187be87424268f$export$b98a7875ddbefaac)]: undefined,
                    [(0, $5d187be87424268f$export$c307007520232013)]: undefined,
                    [(0, $5d187be87424268f$export$2552faed9df6a2cd)]: $b2385da6883008a2$var$joinValuesIfNotEmpty(warnings),
                    [(0, $5d187be87424268f$export$f78d8c81fcad32a2)]: undefined,
                    [(0, $5d187be87424268f$export$13d5b2891ca65cd6)]: undefined,
                    [(0, $5d187be87424268f$export$810a1f7ed2facfcb)]: undefined
                });
            },
            showStatusCategoryIssues: (statusCategories)=>{
                setQueryParams({
                    [(0, $5d187be87424268f$export$e39925d10cebc0b)]: undefined,
                    [(0, $5d187be87424268f$export$b98a7875ddbefaac)]: undefined,
                    [(0, $5d187be87424268f$export$c307007520232013)]: $b2385da6883008a2$var$joinValuesIfNotEmpty(statusCategories.map((0, (0, parcelRequire("gULOk")).statusCategoryForId))),
                    [(0, $5d187be87424268f$export$2552faed9df6a2cd)]: undefined,
                    [(0, $5d187be87424268f$export$f78d8c81fcad32a2)]: undefined,
                    [(0, $5d187be87424268f$export$13d5b2891ca65cd6)]: undefined,
                    [(0, $5d187be87424268f$export$810a1f7ed2facfcb)]: undefined
                });
            }
        };
    };
    const $b2385da6883008a2$export$22b92ff6db8f144a = ()=>{
        const { parsedQueryParams: parsedQueryParams } = $b2385da6883008a2$export$c59d013998b3679d();
        return {
            sortByField: parsedQueryParams[0, $5d187be87424268f$export$13d5b2891ca65cd6] ?? 'CREATED',
            sortOrder: parsedQueryParams[0, $5d187be87424268f$export$810a1f7ed2facfcb] ?? 'ASC'
        };
    };
});
const $5d187be87424268f$export$e39925d10cebc0b = 'text';
const $5d187be87424268f$export$b98a7875ddbefaac = 'epics';
const $5d187be87424268f$export$c307007520232013 = 'statusCategory';
const $5d187be87424268f$export$2552faed9df6a2cd = 'warnings';
const $5d187be87424268f$export$f78d8c81fcad32a2 = 'assignee';
const $5d187be87424268f$export$13d5b2891ca65cd6 = 'sortBy';
const $5d187be87424268f$export$810a1f7ed2facfcb = 'sortOrder';
parcelRegister("bRpse", function(module, exports) {
    $parcel$export(module.exports, "useDeepMemo", ()=>$e5f49c67ed7d4ae1$export$722debc0e56fea39);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    const $e5f49c67ed7d4ae1$export$722debc0e56fea39 = (value)=>{
        const ref = (0, $5uXOq.useRef)(value);
        if (!(0, ($parcel$interopDefault($ajpes)))(value, ref.current)) ref.current = value;
        return ref.current;
    };
});
parcelRegister("a40gh", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$36364ba0c826f8ba$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    const $36364ba0c826f8ba$export$e926676385687eaf = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "flag",
            ...props,
            packageName: "jiraSoftwareReleasesVersionDetailIssueList",
            teamName: "fusion-solaris"
        });
});
parcelRegister("1KPiA", function(module, exports) {
    $parcel$export(module.exports, "useViewVersionDetailsPageExperienceFail", ()=>$b9e7b187c8d007ae$export$f9fb921f60393679);
    $parcel$export(module.exports, "useViewVersionDetailsPageExperienceSuccess", ()=>$b9e7b187c8d007ae$export$1a84e8ad118354e4);
    $parcel$export(module.exports, "ViewVersionDetailsPageExperienceSuccessTracker", ()=>$b9e7b187c8d007ae$export$ab0e4c71ad46eacd);
    var $5uXOq = parcelRequire("5uXOq");
    var $93jKl;
    var $3bQtK;
    var $cfyOy;
    const $b9e7b187c8d007ae$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME = 'viewVersionDetailsPage';
    const $b9e7b187c8d007ae$export$f9fb921f60393679 = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $b9e7b187c8d007ae$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
        });
    const $b9e7b187c8d007ae$export$1a84e8ad118354e4 = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: $b9e7b187c8d007ae$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
        });
    const $b9e7b187c8d007ae$export$ab0e4c71ad46eacd = ()=>{
        const projectInfo = (0, (0, parcelRequire("cfyOy")).useProjectAnalyticsAttributes)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: $b9e7b187c8d007ae$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
            attributes: {
                ...projectInfo
            }
        });
    };
});
parcelRegister("cfyOy", function(module, exports) {
    $parcel$export(module.exports, "useProjectAnalyticsAttributes", ()=>$f14bce8f0d26bc71$export$b6a91b2d78273787);
    var $kUACW;
    var $dxCvy;
    var $g5X3G;
    var $2YP9W;
    const $f14bce8f0d26bc71$export$a3138047c831fa4e = (0, (0, parcelRequire("kUACW")).withSuspense)(()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource)));
    const $f14bce8f0d26bc71$export$8f31c2503e1efa93 = ()=>{
        const { data: data, error: error } = $f14bce8f0d26bc71$export$a3138047c831fa4e();
        if (data == null) throw new Error(`data of useProjectContext via withSuspense shouldn't be null. If projectContext is null, this means an invalid project key was provided and the page should return a 404 and useProjectContext should never be called. error: ${error !== null ? error.message : 'null'}`);
        return {
            ...data,
            projectKey: (0, (0, parcelRequire("g5X3G")).toProjectKey)(data.projectKey),
            projectId: (0, (0, parcelRequire("g5X3G")).toProjectId)(data.projectId.toString())
        };
    };
    const $f14bce8f0d26bc71$export$b6a91b2d78273787 = ()=>{
        const { projectId: projectId, isProjectAdmin: isProjectAdmin, simplified: simplified } = $f14bce8f0d26bc71$export$8f31c2503e1efa93();
        return {
            isSimplified: simplified,
            isProjectAdmin: isProjectAdmin,
            projectId: projectId
        };
    };
});
parcelRegister("liM6F", function(module, exports) {
    $parcel$export(module.exports, "EmptyView", ()=>$2f71f8e52115bae9$export$f716ac8971c5316e);
    var $agoe7;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $hTEpF;
    var $gwIPs;
    var $koVbs;
    var $8zOmE;
    var $jX1s1;
    var $1YU2V;
    var $iiidL = parcelRequire("iiidL");
    var $kwvDS = parcelRequire("kwvDS");
    var $gkaEo;
    const $2f71f8e52115bae9$export$f716ac8971c5316e = ({ jiraVersion: jiraVersion, isAnyFilterApplied: isAnyFilterApplied, textFilter: textFilter })=>{
        const { clearAll: clearAll } = (0, (0, parcelRequire("1YU2V")).useFilterSortingQueryParams)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("agoe7")).default), jiraVersion);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2f71f8e52115bae9$var$Container, {
            "data-testid": "software-releases-version-detail-issue-list.ui.empty-view"
        }, isAnyFilterApplied ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            header: textFilter !== null ? formatMessage((0, (0, parcelRequire("gkaEo")).default).noIssuesMatchTextFilterHeader, {
                textFilter: textFilter
            }) : formatMessage((0, (0, parcelRequire("gkaEo")).default).noIssuesMatchFilterHeader),
            description: textFilter !== null ? formatMessage((0, (0, parcelRequire("gkaEo")).default).noIssuesMatchTextFilterDescription) : formatMessage((0, (0, parcelRequire("gkaEo")).default).noIssuesMatchFilterDescription),
            imageUrl: (0, ($parcel$interopDefault($kwvDS))),
            imageWidth: (0, (0, parcelRequire("gwIPs")).gridSize) * 8,
            imageHeight: (0, (0, parcelRequire("gwIPs")).gridSize) * 11.5,
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "primary",
                onClick: (_, analyticsEvent)=>{
                    clearAll();
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'clearFilter');
                }
            }, formatMessage((0, (0, parcelRequire("gkaEo")).default).clearFilters))
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            header: formatMessage((0, (0, parcelRequire("gkaEo")).default).noIssuesInVersionHeader),
            description: formatMessage((0, (0, parcelRequire("gkaEo")).default).noIssuesInVersionDescription),
            imageUrl: (0, ($parcel$interopDefault($iiidL))),
            imageWidth: (0, (0, parcelRequire("gwIPs")).gridSize) * 16,
            imageHeight: (0, (0, parcelRequire("gwIPs")).gridSize) * 13,
            primaryAction: version?.canAddAndRemoveIssues === true ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jX1s1")).AddIssuesToVersion), {
                appearance: "primary",
                jiraVersion: version
            }) : undefined
        }));
    };
    const $2f71f8e52115bae9$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qv47k",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("agoe7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$daadb41da5a489f3$export$2e2bcd8739ae039);
    const $daadb41da5a489f3$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "emptyView_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "canAddAndRemoveIssues"
                },
                "action": "LOG",
                "path": "canAddAndRemoveIssues"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
            }
        ],
        "type": "JiraVersion"
    };
    $daadb41da5a489f3$var$node.hash = "e747dc1997c64c6a07fe54d01ff7878c";
    var $daadb41da5a489f3$export$2e2bcd8739ae039 = $daadb41da5a489f3$var$node;
});
parcelRegister("iiidL", function(module, exports) {
    module.exports = new URL("noIssuesInVersion.348ccc3b.svg", import.meta.url).toString();
});
parcelRegister("kwvDS", function(module, exports) {
    module.exports = new URL("noSearchResults.d74f9061.svg", import.meta.url).toString();
});
parcelRegister("gkaEo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9efc6fa540355ad$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f9efc6fa540355ad$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noIssuesInVersionHeader: {
            "id": "software-releases-version-detail-issue-list.empty-view.no-issues-in-version-header",
            "defaultMessage": "Nothing to see here"
        },
        noIssuesInVersionDescription: {
            "id": "software-releases-version-detail-issue-list.empty-view.no-issues-in-version-description",
            "defaultMessage": "No issues have been added yet."
        },
        noIssuesMatchFilterHeader: {
            "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-header",
            "defaultMessage": "No issues here"
        },
        noIssuesMatchFilterDescription: {
            "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-description",
            "defaultMessage": "We didn't find any issues that match the filters you've chosen"
        },
        noIssuesMatchTextFilterHeader: {
            "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-text-filter-header",
            "defaultMessage": "We didn't find any results for \"{textFilter}\""
        },
        noIssuesMatchTextFilterDescription: {
            "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-text-filter-description",
            "defaultMessage": "Try changing your search or check any filters."
        },
        clearFilters: {
            "id": "software-releases-version-detail-issue-list.empty-view.clear-filters",
            "defaultMessage": "Clear filters"
        }
    });
});
parcelRegister("kDV3t", function(module, exports) {
    $parcel$export(module.exports, "ErrorView", ()=>$e4fe36307f0c1a62$export$8c68b6013ae44ca6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $l1N8i;
    var $koVbs;
    var $3QrXk = parcelRequire("3QrXk");
    var $6lHw4;
    const $e4fe36307f0c1a62$export$8c68b6013ae44ca6 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e4fe36307f0c1a62$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($e4fe36307f0c1a62$var$Img, {
            src: (0, ($parcel$interopDefault($3QrXk))),
            alt: formatMessage((0, (0, parcelRequire("6lHw4")).default).errorImageAlt)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "small"
        }, formatMessage((0, (0, parcelRequire("6lHw4")).default).failToLoadTitleNonFianl)), (0, ($parcel$interopDefault($5uXOq))).createElement($e4fe36307f0c1a62$var$ButtonContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            onClick: ()=>{
                window.location.reload();
            }
        }, formatMessage((0, (0, parcelRequire("6lHw4")).default).refreshButtonLabel))));
    };
    const $e4fe36307f0c1a62$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0q1epz _1e0c1txw _2lx21bp4 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $e4fe36307f0c1a62$var$Img = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyrxy5q",
                __cmplp.className
            ])
        });
    });
    const $e4fe36307f0c1a62$var$ButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pku2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3QrXk", function(module, exports) {
    module.exports = new URL("error.e4b20277.svg", import.meta.url).toString();
});
parcelRegister("6lHw4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5fa89bd67e70d15b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5fa89bd67e70d15b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        failToLoadTitleNonFianl: {
            "id": "software-releases-version-detail-issue-list.error-view.fail-to-load-title-non-fianl",
            "defaultMessage": "Can't load issues"
        },
        refreshButtonLabel: {
            "id": "software-releases-version-detail-issue-list.error-view.refresh-button-label",
            "defaultMessage": "Refresh page"
        },
        errorImageAlt: {
            "id": "software-releases-version-detail-issue-list.error-view.error-image-alt",
            "defaultMessage": "Image that shows loading issues failed."
        }
    });
});
parcelRegister("1Ql36", function(module, exports) {
    $parcel$export(module.exports, "IssueTotalCount", ()=>$5ab5480930b5091b$export$7866c3f349a6505);
    var $an58X;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    const $5ab5480930b5091b$export$7866c3f349a6505 = ({ jiraVersion: jiraVersion })=>{
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("an58X")).default), jiraVersion);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5ab5480930b5091b$var$TotalCountLozenge, null, data.allIssuesRedesignTemp.totalCount);
    };
    const $5ab5480930b5091b$var$TotalCountLozenge = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk4zhb _1wyb1skh _1e0c1txw _1bah1h6o _4cvr1h6o _4t3i7vkz _2rkoftgi _19pkv77o _u5f31b66 _19bv1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("an58X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7981ef9470073128$export$2e2bcd8739ae039);
    const $7981ef9470073128$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issueTotalCount_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "allIssuesRedesignTemp",
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "totalCount"
                            },
                            "action": "THROW",
                            "path": "allIssuesRedesignTemp.totalCount"
                        }
                    ]
                },
                "action": "THROW",
                "path": "allIssuesRedesignTemp"
            }
        ],
        "type": "JiraVersion"
    };
    $7981ef9470073128$var$node.hash = "aaf1e03a6deba9e0e365569571ef5db3";
    var $7981ef9470073128$export$2e2bcd8739ae039 = $7981ef9470073128$var$node;
});
parcelRegister("4UGZW", function(module, exports) {
    $parcel$export(module.exports, "IssueListSkeleton", ()=>$dcbe829579ca1886$export$ebd1a9517b9c28aa);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $dcbe829579ca1886$var$IssueRowSkeleton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($dcbe829579ca1886$var$IssueRowSkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($dcbe829579ca1886$var$IssueTypeSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($dcbe829579ca1886$var$IssueFieldSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($dcbe829579ca1886$var$IssueSummarySkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($dcbe829579ca1886$var$IssueFieldSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($dcbe829579ca1886$var$IssueAssigneeSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($dcbe829579ca1886$var$IssueDevDataSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($dcbe829579ca1886$var$IssueDevDataSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($dcbe829579ca1886$var$IssueDevDataSkeleton, null));
    const $dcbe829579ca1886$export$ebd1a9517b9c28aa = ({ rowCount: rowCount, marginTop: marginTop })=>(0, ($parcel$interopDefault($5uXOq))).createElement($dcbe829579ca1886$var$Wrapper, {
            marginTop: marginTop
        }, [
            ...Array(rowCount < 0 ? 10 : rowCount).keys()
        ].map((index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($dcbe829579ca1886$var$IssueRowSkeleton, {
                key: index
            })));
    const $dcbe829579ca1886$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { marginTop: marginTop, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1fj4wta": (0, (0, parcelRequire("lD23V")).default)(__cmplp.marginTop, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.marginTop ? "_19pkmye1" : "_19pkidpf",
                __cmplp.className
            ])
        });
    });
    const $dcbe829579ca1886$var$skeletonKeyFrames = null;
    const $dcbe829579ca1886$var$AnimationBaseDiv = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ju25ru3m _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _bfhkqrzy _j7hq1nls",
                __cmplp.className
            ])
        });
    });
    const $dcbe829579ca1886$var$IssueRowSkeletonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ickbl _19bvpxbi _u5f3oahv _1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $dcbe829579ca1886$var$IssueTypeSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $dcbe829579ca1886$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1l7b _4t3i7vkz _1bsb7vkz _2hwxftgi",
                __cmplp.className
            ])
        });
    });
    const $dcbe829579ca1886$var$IssueFieldSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $dcbe829579ca1886$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1l7b _4t3i7vkz _1bsbvbgk _2hwx7vkz",
                __cmplp.className
            ])
        });
    });
    const $dcbe829579ca1886$var$IssueDevDataSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $dcbe829579ca1886$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1l7b _4t3i7vkz _1bsbvbgk _2hwxzwfg",
                __cmplp.className
            ])
        });
    });
    const $dcbe829579ca1886$var$IssueSummarySkeleton = (0, $5uXOq.forwardRef)(({ as: C = $dcbe829579ca1886$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1l7b _4t3i7vkz _2hwx16xz _16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $dcbe829579ca1886$var$IssueAssigneeSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $dcbe829579ca1886$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1tcg _4t3i1tcg _1bsb1tcg _2hwxvbgk",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hWY96", function(module, exports) {
    $parcel$export(module.exports, "IssuesMoreButton", ()=>$7153158fdfc91bf5$export$ef8795476184c09b);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $3oUqw;
    var $39xOx;
    var $koVbs;
    var $lfTZh;
    var $kxZPA;
    var $lJsME;
    const $7153158fdfc91bf5$var$MoreButtonLazy = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("96EnG")).then((mod)=>mod.IssuesMoreButton), {
        moduleId: "./src/packages/releases/issue-list/src/ui/issues-more-button/index.tsx"
    });
    const $7153158fdfc91bf5$export$ef8795476184c09b = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "flag",
            id: "jira.software.releases.version.detail.issue.list.more.button",
            packageName: "jira-software-releases-version-detail-issue-list",
            teamName: "fusion-solaris"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jira-software-releases-version-detail-issue-list",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "subtle",
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))), {
                    label: formatMessage((0, (0, parcelRequire("lJsME")).default).moreButtonLabel)
                })
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7153158fdfc91bf5$var$MoreButtonLazy, props)));
    };
});
parcelRegister("lJsME", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0e8ce19644952ff$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b0e8ce19644952ff$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueNavigatorLink: {
            "id": "software-releases-version-detail-issue-list.issues-more-button.issue-navigator-link",
            "defaultMessage": "View in Issue Navigator"
        },
        moreButtonLabel: {
            "id": "software-releases-version-detail-issue-list.issues-more-button.more-button-label",
            "defaultMessage": "More"
        },
        displayInformation: {
            "id": "software-releases-version-detail-issue-list.issues-more-button.display-information",
            "defaultMessage": "Display information"
        },
        assigneeColumnLabel: {
            "id": "software-releases-version-detail-issue-list.issues-more-button.assignee-column-label",
            "defaultMessage": "Assignee"
        },
        priorityColumnLabel: {
            "id": "software-releases-version-detail-issue-list.issues-more-button.priority-column-label",
            "defaultMessage": "Priority"
        },
        issueStatusColumnLabel: {
            "id": "software-releases-version-detail-issue-list.issues-more-button.issue-status-column-label",
            "defaultMessage": "Issue status"
        },
        developmentStatusColumnLabel: {
            "id": "software-releases-version-detail-issue-list.issues-more-button.development-status-column-label",
            "defaultMessage": "Development status"
        },
        buildStatusColumnLabel: {
            "id": "software-releases-version-detail-issue-list.issues-more-button.build-status-column-label",
            "defaultMessage": "Build status"
        },
        deliveryStatusColumnLabel: {
            "id": "software-releases-version-detail-issue-list.issues-more-button.delivery-status-column-label",
            "defaultMessage": "Delivery status"
        },
        featureFlagStatusColumnLabel: {
            "id": "software-releases-version-detail-issue-list.issues-more-button.feature-flag-status-column-label",
            "defaultMessage": "Feature flag status"
        },
        errorFlagDescription: {
            "id": "software-releases-version-detail-issue-list.issues-more-button.error-flag-description",
            "defaultMessage": "We couldn't save your preference. Please try again."
        },
        moreActionColumnLabel: {
            "id": "software-releases-version-detail-issue-list.issues-more-button.more-action-column-label",
            "defaultMessage": "More actions"
        },
        manageWarningsButtonLabel: {
            "id": "software-releases-version-detail-issue-list.issues-more-button.manage-warnings-button-label",
            "defaultMessage": "Manage warnings"
        }
    });
});
parcelRegister("96EnG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fGVHZ").then(()=>parcelRequire('6acQ9'));
});
parcelRegister("h1W9c", function(module, exports) {
    $parcel$export(module.exports, "Issues", ()=>$08637b5c18f56f00$export$1cb51167b20548a0);
    var $diDzB;
    var $6JNlC;
    var $fg0QX;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $4R6GH;
    var $1othz;
    var $5bw2O;
    var $kfztd;
    var $dSE3R;
    var $dnJ5M;
    const $08637b5c18f56f00$export$1cb51167b20548a0 = ({ jiraIssueEdgesReference: jiraIssueEdgesReference, jiraVersion: jiraVersion, jiraVersionRefetch: jiraVersionRefetch })=>{
        const [isFeatureFlagEmptyStateModalOpen, setIsFeatureFlagEmptyStateModalOpen] = (0, $5uXOq.useState)(false);
        const jiraIssueEdgeReferenceData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("fg0QX")).default), jiraIssueEdgesReference);
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("6JNlC")).default), jiraVersion);
        const [versionRefetch, refetch] = (0, $8Uumt.useRefetchableFragment)((0, (0, parcelRequire("diDzB")).default), jiraVersionRefetch);
        const [refetchDevOpsProviders] = (0, (0, parcelRequire("1othz")).useSuspenselessRefetch)((0, (0, parcelRequire("5bw2O")).default), refetch, {
            fetchPolicy: 'network-only'
        });
        const featureFlagProviders = (versionRefetch.devOpsSummarisedEntities?.providers.featureFlagProviders ?? []).filter(Boolean);
        const nodes = jiraIssueEdgeReferenceData?.map((edge)=>edge.node).filter(Boolean);
        const hasBambooDeployment = nodes.some((node)=>(node.devSummaryCache?.devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0);
        const hasDeployments = nodes.some((node)=>(0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re') ? node.summarisedDeployments?.count != null && node.summarisedDeployments?.count > 0 : node.devOpsSummarisedEntities?.summarisedDeployments?.count != null && node.devOpsSummarisedEntities?.summarisedDeployments?.count > 0);
        const hasCommits = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.commit?.overall?.count) > 0);
        const hasPullRequests = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.pullrequest?.overall?.count) > 0);
        const hasBranches = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.branch?.overall?.count) > 0);
        const hasBuilds = nodes.some((node)=>(0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re') ? Number(node.summarisedBuilds?.count) > 0 : Number(node.devOpsSummarisedEntities?.summarisedBuilds?.count) > 0) || nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.build?.overall?.count) > 0);
        const hasReviews = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.review?.overall?.count) > 0);
        const hasDevelopments = hasCommits || hasPullRequests || hasBranches || hasReviews;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($08637b5c18f56f00$var$IssuesContainer, null, nodes.map((node, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dnJ5M")).IssueCard), {
                rowNum: i + 1,
                key: node.key,
                jiraIssue: node,
                jiraVersion: version,
                onFeatureFlagEmptyStateModalOpen: setIsFeatureFlagEmptyStateModalOpen,
                hasBambooDeployment: hasBambooDeployment,
                hasDeployments: hasDeployments,
                hasDevelopments: hasDevelopments,
                hasBuilds: hasBuilds
            })), !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dSE3R")).FeatureFlagEmptyStateExperienceModal), {
            devOpsFeatureFlagProviders: featureFlagProviders,
            isOpen: isFeatureFlagEmptyStateModalOpen,
            onClose: ()=>setIsFeatureFlagEmptyStateModalOpen(false),
            onInstallSuccess: ()=>refetchDevOpsProviders({
                    id: versionRefetch.id,
                    isDevopsFeatureDisabledInFedRamp: (0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)()
                })
        }));
    };
    const $08637b5c18f56f00$var$IssuesContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pbykb7n _kqswh2mm _bfhkvuon",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("diDzB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$387657015570be4c$export$2e2bcd8739ae039);
    var $5bw2O;
    const $387657015570be4c$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, (0, parcelRequire("5bw2O")).default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "DevOpsSummarisedEntities",
                        "kind": "LinkedField",
                        "name": "devOpsSummarisedEntities",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "DevOpsFeatureFlagProvider",
                                                "kind": "LinkedField",
                                                "name": "featureFlagProviders",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal"
                                                    }
                                                ]
                                            },
                                            "action": "NONE",
                                            "path": "devOpsSummarisedEntities.providers.featureFlagProviders"
                                        }
                                    ]
                                },
                                "action": "NONE",
                                "path": "devOpsSummarisedEntities.providers"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraVersion"
    };
    $387657015570be4c$var$node.hash = "67e86aee284b1de0db813afbd23b7bbc";
    var $387657015570be4c$export$2e2bcd8739ae039 = $387657015570be4c$var$node;
});
parcelRegister("5bw2O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3dced7270b458cdc$export$2e2bcd8739ae039);
    const $3dced7270b458cdc$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "versionDetailIssueListJiraVersionRefetchQuery",
                "selections": [
                    {
                        "args": v2,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "versionDetailIssueListJiraVersionRefetchQuery",
                "selections": [
                    {
                        "args": v2,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v3,
                            v4,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "condition": "isDevopsFeatureDisabledInFedRamp",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "concreteType": "DevOpsSummarisedEntities",
                                                "kind": "LinkedField",
                                                "name": "devOpsSummarisedEntities",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "DevOpsProviders",
                                                        "kind": "LinkedField",
                                                        "name": "providers",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "DevOpsFeatureFlagProvider",
                                                                "kind": "LinkedField",
                                                                "name": "featureFlagProviders",
                                                                "plural": true,
                                                                "selections": [
                                                                    v3,
                                                                    v4,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "name"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "logoUrl"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "type": "JiraVersion"
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "3cbb87d716e7da1ddfbdbde8292c44abd6d8a20728f8b637597b48bcde37becc",
                "metadata": {},
                "name": "versionDetailIssueListJiraVersionRefetchQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $3dced7270b458cdc$var$node.hash = "67e86aee284b1de0db813afbd23b7bbc";
    var $3dced7270b458cdc$export$2e2bcd8739ae039 = $3dced7270b458cdc$var$node;
});
parcelRegister("6JNlC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06a1297c8ff8ae0d$export$2e2bcd8739ae039);
    const $06a1297c8ff8ae0d$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersion",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraVersion"
            }
        ],
        "type": "JiraVersion"
    };
    $06a1297c8ff8ae0d$var$node.hash = "224ec701c99ed1fc3c24b3cb47926906";
    var $06a1297c8ff8ae0d$export$2e2bcd8739ae039 = $06a1297c8ff8ae0d$var$node;
});
parcelRegister("fg0QX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95ef3cbc86f7cd1c$export$2e2bcd8739ae039);
    const $95ef3cbc86f7cd1c$var$node = function() {
        var v0 = [
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ], v1 = [
            {
                "concreteType": "DevOpsSummarisedDeployments",
                "kind": "LinkedField",
                "name": "summarisedDeployments",
                "plural": false,
                "selections": v0
            },
            {
                "concreteType": "DevOpsSummarisedBuilds",
                "kind": "LinkedField",
                "name": "summarisedBuilds",
                "plural": false,
                "selections": v0
            }
        ];
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "isDevopsFeatureDisabledInFedRamp"
                },
                {
                    "kind": "RootArgument",
                    "name": "isIssueSummarisedDeploymentsMigratedToAgs"
                },
                {
                    "kind": "RootArgument",
                    "name": "shouldIncludeDevOpsFieldsViaAgs"
                }
            ],
            "kind": "Fragment",
            "metadata": {
                "plural": true
            },
            "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                "action": "THROW",
                                "path": "node.key"
                            },
                            {
                                "condition": "isDevopsFeatureDisabledInFedRamp",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "concreteType": "DevOpsSummarisedEntities",
                                        "kind": "LinkedField",
                                        "name": "devOpsSummarisedEntities",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": v1
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraIssueDevSummaryResult",
                                        "kind": "LinkedField",
                                        "name": "devSummaryCache",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueDevSummary",
                                                "kind": "LinkedField",
                                                "name": "devSummary",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                        "kind": "LinkedField",
                                                        "name": "pullrequest",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssuePullRequestDevSummary",
                                                                "kind": "LinkedField",
                                                                "name": "overall",
                                                                "plural": false,
                                                                "selections": v0
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                        "kind": "LinkedField",
                                                        "name": "branch",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueBranchDevSummary",
                                                                "kind": "LinkedField",
                                                                "name": "overall",
                                                                "plural": false,
                                                                "selections": v0
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                        "kind": "LinkedField",
                                                        "name": "review",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueReviewDevSummary",
                                                                "kind": "LinkedField",
                                                                "name": "overall",
                                                                "plural": false,
                                                                "selections": v0
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                        "kind": "LinkedField",
                                                        "name": "commit",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueCommitDevSummary",
                                                                "kind": "LinkedField",
                                                                "name": "overall",
                                                                "plural": false,
                                                                "selections": v0
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                        "kind": "LinkedField",
                                                        "name": "build",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueBuildDevSummary",
                                                                "kind": "LinkedField",
                                                                "name": "overall",
                                                                "plural": false,
                                                                "selections": v0
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                        "kind": "LinkedField",
                                                        "name": "deploymentEnvironments",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                "kind": "LinkedField",
                                                                "name": "overall",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueDeploymentEnvironment",
                                                                        "kind": "LinkedField",
                                                                        "name": "topEnvironments",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "status"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v1
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraIssue"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "node"
                }
            ],
            "type": "JiraIssueEdge"
        };
    }();
    $95ef3cbc86f7cd1c$var$node.hash = "7e745b10637620df992daefcbbc74bdc";
    var $95ef3cbc86f7cd1c$export$2e2bcd8739ae039 = $95ef3cbc86f7cd1c$var$node;
});
parcelRegister("dSE3R", function(module, exports) {
    $parcel$export(module.exports, "FeatureFlagEmptyStateExperienceModal", ()=>$a046ad663b4e60bc$export$4e1e35d50ebac320);
    var $et5SG;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $1R1Ge;
    var $i8Qvm;
    var $9fuVs;
    var $4YVWJ;
    const $a046ad663b4e60bc$export$4e1e35d50ebac320 = ({ isOpen: isOpen, onClose: onClose, devOpsFeatureFlagProviders: devOpsFeatureFlagProviders, onInstallSuccess: onInstallSuccess })=>{
        const featureFlagProviders = (0, $8Uumt.useFragment)((0, (0, parcelRequire("et5SG")).default), devOpsFeatureFlagProviders);
        const entryPoint = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4YVWJ")).FeatureFlagEmptyStateExperienceEntryPoint), {
            onInstallSuccess: onInstallSuccess,
            devOpsFeatureFlagProviders: featureFlagProviders,
            isOpen: isOpen,
            onClose: onClose
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: onClose,
            width: 592,
            autoFocus: false
        }, entryPoint)) : null);
    };
});
parcelRegister("et5SG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fc81a4070f06f96$export$2e2bcd8739ae039);
    const $9fc81a4070f06f96$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint"
            }
        ],
        "type": "DevOpsFeatureFlagProvider"
    };
    $9fc81a4070f06f96$var$node.hash = "0fbad5b696ab8a25991a0d1c79838173";
    var $9fc81a4070f06f96$export$2e2bcd8739ae039 = $9fc81a4070f06f96$var$node;
});
parcelRegister("4YVWJ", function(module, exports) {
    $parcel$export(module.exports, "FeatureFlagEmptyStateExperienceEntryPoint", ()=>$aafc4590fb5d3b83$export$d0d10a136f7d769f);
    var $5z4FT;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $eZJjh;
    var $39xOx;
    var $lfTZh;
    var $dXq4S;
    var $dAfqg;
    var $bSmlz;
    var $koeKL;
    var $kxZPA;
    var $93kRE;
    const $aafc4590fb5d3b83$var$FeatureFlagEmptyStateExperienceQueryLoader = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("iM97Z")).then((mod)=>mod.FeatureFlagsEmptyStateExperienceQueryLoader), {
        moduleId: "./src/packages/software/empty-state-experience/feature-flags/src/ui/index.tsx"
    });
    const $aafc4590fb5d3b83$var$Loading = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c11p5 _4cvr1h6o _6a6z1h6o _1yt4koci",
                __cmplp.className
            ])
        });
    });
    const $aafc4590fb5d3b83$export$d0d10a136f7d769f = ({ isOpen: isOpen, onClose: onClose, devOpsFeatureFlagProviders: devOpsFeatureFlagProviders, onInstallSuccess: onInstallSuccess })=>{
        const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("bSmlz")).default));
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const onExperienceFail = (0, (0, parcelRequire("93kRE")).useViewFeatureFlagsEmptyStateExperienceExperienceFail)();
        const featureFlagProviders = (0, $8Uumt.useFragment)((0, (0, parcelRequire("5z4FT")).default), devOpsFeatureFlagProviders);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (projectContext?.projectId != null && isOpen) loadQuery({
                projectAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceId: projectContext.projectId.toString(),
                    resourceOwner: 'jira',
                    resourceType: 'project',
                    cloudId: cloudId
                })
            }, {
                fetchPolicy: 'store-and-network'
            });
        }, [
            isOpen,
            loadQuery,
            cloudId,
            projectContext
        ]);
        return projectContext != null && isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "flag",
            id: "featureFlagEmptyStateExperienceEntryPoint",
            packageName: "jiraSoftwareEmptyStateExperienceFeatureFlags",
            teamName: "fusion-solaris",
            onError: (location, error)=>{
                onExperienceFail(location, error);
                onClose();
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "software-empty-state-experience-feature-flags",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($aafc4590fb5d3b83$var$Loading, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: "large"
            }))
        }, queryReference != null ? (0, ($parcel$interopDefault($5uXOq))).createElement($aafc4590fb5d3b83$var$FeatureFlagEmptyStateExperienceQueryLoader, {
            onInstallSuccess: onInstallSuccess,
            devOpsFeatureFlagProviders: featureFlagProviders,
            queryReference: queryReference
        }) : null))) : null;
    };
});
parcelRegister("5z4FT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ede98c0713128b6$export$2e2bcd8739ae039);
    const $5ede98c0713128b6$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareEmptyStateExperienceFeatureFlags_FeatureFlagsEmptyStateExperienceQueryLoader_devOpsFeatureFlagProviders"
            }
        ],
        "type": "DevOpsFeatureFlagProvider"
    };
    $5ede98c0713128b6$var$node.hash = "17afe0c67200280c81407f20b1ac9cf2";
    var $5ede98c0713128b6$export$2e2bcd8739ae039 = $5ede98c0713128b6$var$node;
});
parcelRegister("bSmlz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b361172cf1e900ca$export$2e2bcd8739ae039);
    const $b361172cf1e900ca$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectAri"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "uiFeatureFlagsEmptyStateExperienceQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "ui_softwareEmptyStateExperienceFeatureFlags_FeatureFlagsEmptyStateExperience_query"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "uiFeatureFlagsEmptyStateExperienceQuery",
                "selections": [
                    {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "AriGraph",
                                "kind": "LinkedField",
                                "name": "ariGraph",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "fields": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "from",
                                                        "variableName": "projectAri"
                                                    },
                                                    {
                                                        "kind": "Literal",
                                                        "name": "type",
                                                        "value": "project-associated-feature-flag"
                                                    }
                                                ],
                                                "kind": "ObjectValue",
                                                "name": "filter"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 1
                                            }
                                        ],
                                        "concreteType": "AriGraphRelationshipConnection",
                                        "kind": "LinkedField",
                                        "name": "relationships",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "AriGraphRelationship",
                                                "kind": "LinkedField",
                                                "name": "nodes",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "26f590dcda44b5fc757b038bb24223ad14175c339c87b80b056b42ed91aa2a99",
                "metadata": {},
                "name": "uiFeatureFlagsEmptyStateExperienceQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $b361172cf1e900ca$var$node.hash = "c8856730dcfda88439b157a25ff3f97f";
    var $b361172cf1e900ca$export$2e2bcd8739ae039 = $b361172cf1e900ca$var$node;
});
parcelRegister("iM97Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("br1Gd")
    ]).then(()=>parcelRequire('6vcJA'));
});
parcelRegister("dnJ5M", function(module, exports) {
    $parcel$export(module.exports, "IssueCard", ()=>$3d03a02f601ed834$export$11b5a73dc1ef6ab9);
    var $dao5r;
    var $ajPr6;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $8Uumt = parcelRequire("8Uumt");
    var $4HJKb;
    var $8zOmE;
    var $2NMNM;
    var $g5X3G;
    var $kfztd;
    var $2vbty;
    var $npYQQ;
    var $9lAUN;
    var $a40gh;
    var $1KeDw;
    var $c7zJ6;
    var $cmBKm;
    var $iKL1U;
    var $clzRD;
    var $iEXri;
    var $4uVJc;
    var $cMkJv;
    const $3d03a02f601ed834$var$DEV_DETAILS_DIALOG_SCOPE_ID = 'VersionDetailsIssueList';
    const $3d03a02f601ed834$export$11b5a73dc1ef6ab9 = ({ jiraIssue: jiraIssue, jiraVersion: jiraVersion, hasBambooDeployment: hasBambooDeployment, hasDeployments: hasDeployments, hasDevelopments: hasDevelopments, hasBuilds: hasBuilds, onFeatureFlagEmptyStateModalOpen: onFeatureFlagEmptyStateModalOpen, rowNum: rowNum })=>{
        const issue = (0, $8Uumt.useFragment)((0, (0, parcelRequire("ajPr6")).default), jiraIssue);
        const { showDevDetailDialog: showDevDetailDialog } = (0, (0, parcelRequire("4HJKb")).useDevOpsDetailsDialogLoaderActions)($3d03a02f601ed834$var$DEV_DETAILS_DIALOG_SCOPE_ID);
        const [, sidebarActions] = (0, (0, parcelRequire("2vbty")).useSidebarStore)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleClick = (dataType, reviewData)=>{
            showDevDetailDialog(dataType, dataType === (0, $61a2cd6236d50c20$export$3f1e2b276d607490) ? reviewData : undefined, (0, (0, parcelRequire("g5X3G")).toIssueKey)(issue.key), (0, (0, parcelRequire("g5X3G")).toIssueId)(issue.issueId));
        };
        const jiraVersionData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("dao5r")).default), jiraVersion);
        const { canViewDevTools: canViewDevTools, devOpsSummarisedEntities: devOpsSummarisedEntities, versionIssueTableHiddenColumns: versionIssueTableHiddenColumns } = jiraVersionData;
        const fields = issue.fieldsById.edges.map((edge)=>edge?.node).filter(Boolean);
        const jiraIssueSummaryField = fields.find((fieldNode)=>fieldNode?.fieldId === 'summary');
        const jiraIssueTypeField = fields.find((fieldNode)=>fieldNode?.fieldId === 'issuetype');
        const jiraPriorityField = fields.find((fieldNode)=>fieldNode?.fieldId === 'priority');
        const jiraStatusField = fields.find((fieldNode)=>fieldNode?.fieldId === 'status');
        const jiraAssigneeField = fields.find((fieldNode)=>fieldNode?.fieldId === 'assignee');
        const issueUrl = `/browse/${issue.key}`;
        const onIssueClick = (e)=>{
            if (e.target instanceof Element && e.target.closest((0, (0, parcelRequire("npYQQ")).getIssueCardClickIgnorePreventDefaultTargetSelector)()) != null) {
                if (e.target.closest((0, (0, parcelRequire("npYQQ")).getIssueCardClickIgnoreTargetNoPreventDefaultSelector)())) return;
                e.preventDefault();
                return;
            }
            const modifiersPressed = Boolean(e.shiftKey || e.metaKey || e.ctrlKey);
            const shouldOpenIssueSidebar = e.button === 0 && !modifiersPressed;
            if (shouldOpenIssueSidebar) {
                e.preventDefault();
                sidebarActions.showIssue(issue.key);
            }
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, 'versionDetailsIssue', {
                clickType: e.button,
                modifiersPressed: modifiersPressed
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9lAUN")).IssueWarningProvider), {
            jiraVersion: jiraVersionData,
            jiraIssue: issue
        }, ({ hasWarnings: hasWarnings, hasOpenPullRequestWarning: hasOpenPullRequestWarning, hasFailingBuildsWarning: hasFailingBuildsWarning, hasUnreviewedCodeWarning: hasUnreviewedCodeWarning, hasOpenReviewWarning: hasOpenReviewWarning })=>(0, ($parcel$interopDefault($5uXOq))).createElement($3d03a02f601ed834$var$IssueCardContainer, {
                href: issueUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: onIssueClick,
                "data-component-selector": (0, $752b719410cf933d$export$b343d4705e10ba61),
                "data-testid": "software-releases-version-detail-issue-list.ui.issues.issue-card",
                hasWarnings: hasWarnings
            }, jiraIssueSummaryField && jiraIssueTypeField && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cMkJv")).Summary), {
                jiraIssue: issue,
                jiraIssueSummaryField: jiraIssueSummaryField,
                jiraIssueTypeField: jiraIssueTypeField
            }), jiraPriorityField && !versionIssueTableHiddenColumns.includes('ISSUE_PRIORITY') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iEXri")).Priority), {
                jiraPriorityField: jiraPriorityField
            }), jiraStatusField && !versionIssueTableHiddenColumns.includes('ISSUE_STATUS') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uVJc")).Status), {
                jiraStatusField: jiraStatusField
            }), jiraAssigneeField && !versionIssueTableHiddenColumns.includes('ISSUE_ASSIGNEE') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1KeDw")).Assignee), {
                jiraAssigneeField: jiraAssigneeField
            }), !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && canViewDevTools && hasDevelopments && !versionIssueTableHiddenColumns.includes('DEVELOPMENT_STATUS') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a40gh")).ErrorBoundary), {
                id: "issueListIssueCardDevelopment",
                fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cmBKm")).DevelopmentContainer), null)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cmBKm")).Development), {
                jiraIssue: issue,
                onClick: handleClick
            })), !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (hasBambooDeployment || hasDeployments || hasBuilds) && canViewDevTools && !versionIssueTableHiddenColumns.includes('DEPLOYMENT_STATUS') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a40gh")).ErrorBoundary), {
                id: "issueListIssueCardDelivery",
                fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c7zJ6")).DeliveryContainer), null)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c7zJ6")).Delivery), {
                jiraIssue: issue,
                onClick: handleClick
            })), !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && canViewDevTools && devOpsSummarisedEntities && !versionIssueTableHiddenColumns.includes('FEATURE_FLAG_STATUS') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a40gh")).ErrorBoundary), {
                id: "issueListIssueCardFeatureFlags",
                fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iKL1U")).FeatureFlagsContainer), null)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-version-details-issue-click-ignore-target": (0, (0, parcelRequire("npYQQ")).ISSUE_CARD_CLICK_IGNORE_TARGET)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iKL1U")).FeatureFlags), {
                devOpsSummarisedEntities: devOpsSummarisedEntities,
                jiraIssue: issue,
                onClick: handleClick,
                setFeatureFlagEmptyStateModalOpen: onFeatureFlagEmptyStateModalOpen,
                rowNum: rowNum
            }))), !versionIssueTableHiddenColumns.includes('MORE_ACTION') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a40gh")).ErrorBoundary), {
                id: "issueListIssueCardMoreButton",
                fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("clzRD")).OnHoverVisibility), null, null)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-version-details-issue-click-ignore-target": (0, (0, parcelRequire("npYQQ")).ISSUE_CARD_CLICK_IGNORE_TARGET)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("clzRD")).MoreButton), {
                jiraVersion: jiraVersionData,
                jiraIssue: issue,
                hasWarnings: hasWarnings,
                hasOpenPullRequestWarning: hasOpenPullRequestWarning,
                hasFailingBuildsWarning: hasFailingBuildsWarning,
                hasUnreviewedCodeWarning: hasUnreviewedCodeWarning,
                hasOpenReviewWarning: hasOpenReviewWarning
            })))));
    };
    const $3d03a02f601ed834$var$WARNING_COLOR = `var(--ds-background-warning, ${(0, $829f609a65d26a98$exports).Y50})`;
    const $3d03a02f601ed834$var$WARNING_HOVER_COLOR = `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$exports).Y75})`;
    const $3d03a02f601ed834$var$HOVER_COLOR = `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$exports).N20})`;
    const $3d03a02f601ed834$var$IssueCardContainer = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { hasWarnings: hasWarnings, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1d5pv2t": (0, (0, parcelRequire("lD23V")).default)(__cmplp.hasWarnings && $3d03a02f601ed834$var$WARNING_COLOR),
                "--_dxlr0u": (0, (0, parcelRequire("lD23V")).default)($3d03a02f601ed834$var$WARNING_HOVER_COLOR),
                "--_158qcri": (0, (0, parcelRequire("lD23V")).default)($3d03a02f601ed834$var$HOVER_COLOR)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _bfhk62r0 _4t3izwfg _1yt4plml _9oik18uv _1bnxglyw _jf4cnqa1 _189exib9 _1dqonqa1 _1h6db5v6 _gy1pu2gc _7cca15wb _64ezt94y _1ov81l7b _k8kw1l7b _1rcd1l7b _1wp91l7b _7ehiglyw _1a3b18uv _4fprglyw _5goinqa1",
                __cmplp.hasWarnings ? "_10j71vyq _irr31vyq" : "_10j71h9u _irr31h9u",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dao5r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f8cb52b4f34e290$export$2e2bcd8739ae039);
    const $1f8cb52b4f34e290$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraVersion",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion"
            },
            {
                "kind": "ScalarField",
                "name": "canViewDevTools"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "versionIssueTableHiddenColumns"
                },
                "action": "THROW",
                "path": "versionIssueTableHiddenColumns"
            },
            {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "DevOpsSummarisedEntities",
                        "kind": "LinkedField",
                        "name": "devOpsSummarisedEntities",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraVersion"
            }
        ],
        "type": "JiraVersion"
    };
    $1f8cb52b4f34e290$var$node.hash = "522ae3c2b555fac40be79e26c643efd9";
    var $1f8cb52b4f34e290$export$2e2bcd8739ae039 = $1f8cb52b4f34e290$var$node;
});
parcelRegister("ajPr6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51c92cf70e6668b5$export$2e2bcd8739ae039);
    const $51c92cf70e6668b5$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraIssue",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "issueId"
                },
                "action": "THROW",
                "path": "issueId"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "key"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "ids",
                            "value": [
                                "priority",
                                "summary",
                                "assignee",
                                "status",
                                "issuetype"
                            ]
                        }
                    ],
                    "concreteType": "JiraIssueFieldConnection",
                    "kind": "LinkedField",
                    "name": "fieldsById",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "fieldId"
                                                },
                                                "action": "THROW",
                                                "path": "fieldsById.edges.node.fieldId"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "status_softwareReleasesVersionDetailIssueList"
                                                    }
                                                ],
                                                "type": "JiraStatusField"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "assignee_softwareReleasesVersionDetailIssueList"
                                                    }
                                                ],
                                                "type": "JiraSingleSelectUserPickerField"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField"
                                                    }
                                                ],
                                                "type": "JiraSingleLineTextField"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField"
                                                    }
                                                ],
                                                "type": "JiraIssueTypeField"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "priority_softwareReleasesVersionDetailIssueList"
                                                    }
                                                ],
                                                "type": "JiraPriorityField"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "fieldsById.edges"
                        }
                    ],
                    "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                },
                "action": "THROW",
                "path": "fieldsById"
            },
            {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "delivery_softwareReleasesVersionDetailIssueList"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "development_softwareReleasesVersionDetailIssueList"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssue"
            }
        ],
        "type": "JiraIssue"
    };
    $51c92cf70e6668b5$var$node.hash = "81587616f95bbce4695593a62ffa6d45";
    var $51c92cf70e6668b5$export$2e2bcd8739ae039 = $51c92cf70e6668b5$var$node;
});
parcelRegister("4HJKb", function(module, exports) {
    $parcel$export(module.exports, "loadDialogBridge", ()=>$ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a);
    $parcel$export(module.exports, "DevOpsDetailsDialogLoaderContainer", ()=>$ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55);
    $parcel$export(module.exports, "DevOpsDetailsDialogLoaderSubscriber", ()=>$ccf4b85a4aaf3a68$export$693f51ab225dff94);
    $parcel$export(module.exports, "useDevOpsDetailsDialogLoaderActions", ()=>$ccf4b85a4aaf3a68$export$506ad06ecf691cd3);
    var $6BZYo;
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $bKpgX;
    var $62M1I;
    const $ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a = async ()=>(0, (0, parcelRequire("6BZYo")).loadBridge)({
            name: (0, (0, parcelRequire("62M1I")).DEV_DETAILS_WRM_RESOURCE),
            wrmKeys: [
                'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-wrm',
                'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources'
            ]
        });
    const $ccf4b85a4aaf3a68$export$e324594224ef24da = {
        resetState: (stateOverrides)=>({ setState: setState })=>{
                setState({
                    ...(0, (0, parcelRequire("62M1I")).INITIAL_STATE),
                    ...stateOverrides
                });
            },
        updateState: (stateUpdates)=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    ...stateUpdates
                });
            },
        showDevDetailDialog: (itemType, legacyData, targetIssueKey, targetIssueId)=>({ setState: setState, getState: getState })=>{
                if (itemType === (0, $61a2cd6236d50c20$export$3f1e2b276d607490)) setState({
                    ...getState(),
                    legacyDevPanelDetailsDialogShownCounter: getState().legacyDevPanelDetailsDialogShownCounter + 1,
                    isDevPanelDetailsDialogShown: false,
                    dataTypeSelected: itemType,
                    legacyData: legacyData,
                    issueKey: targetIssueKey,
                    issueId: targetIssueId
                });
                else setState({
                    ...getState(),
                    isDevPanelDetailsDialogShown: true,
                    dataTypeSelected: itemType,
                    issueKey: targetIssueKey,
                    issueId: targetIssueId
                });
            },
        closeDetailDialog: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    ...getState(),
                    dataTypeSelected: '',
                    isDevPanelDetailsDialogShown: false,
                    issueKey: undefined,
                    issueId: undefined
                });
            }
    };
    const $ccf4b85a4aaf3a68$export$390f32400eaf98c9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'DetailsDialogLoaderRemoteState',
        initialState: (0, (0, parcelRequire("62M1I")).INITIAL_STATE),
        actions: $ccf4b85a4aaf3a68$export$e324594224ef24da
    });
    const $ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55 = (0, (0, parcelRequire("gg7kZ")).createContainer)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
    const $ccf4b85a4aaf3a68$export$693f51ab225dff94 = (0, (0, parcelRequire("51nlc")).createSubscriber)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
    const $ccf4b85a4aaf3a68$export$550d4b3c29100112 = (0, (0, parcelRequire("3sQ5x")).createHook)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
    function $ccf4b85a4aaf3a68$export$506ad06ecf691cd3(scopeId) {
        return (0, (0, parcelRequire("bKpgX")).defaultRegistry).getStore($ccf4b85a4aaf3a68$export$390f32400eaf98c9, scopeId)?.actions;
    }
});
const $61a2cd6236d50c20$export$e18d81f044132a0e = 'branch';
const $61a2cd6236d50c20$export$74a388a09f2a004e = 'build';
const $61a2cd6236d50c20$export$2e42513c7764d5f3 = 'repository';
const $61a2cd6236d50c20$export$3f1e2b276d607490 = 'review';
const $61a2cd6236d50c20$export$90cac6260ae9ced5 = 'deployment-environment';
const $61a2cd6236d50c20$export$6f74b53d652f13f3 = 'pullrequest';
const $61a2cd6236d50c20$export$c69477f358d30f7e = 'feature-flags';
const $61a2cd6236d50c20$export$56470bdd9cd798d0 = 'remote-links';
const $61a2cd6236d50c20$export$3da53566eda5eeef = 'jira.fe.issue.dev-details.time-to.load';
const $61a2cd6236d50c20$export$b4bb784d069c9ab = 'development.details.details-header';
const $61a2cd6236d50c20$export$74189cec821240a6 = 'development.details.remote-links';
parcelRegister("62M1I", function(module, exports) {
    $parcel$export(module.exports, "INITIAL_STATE", ()=>$bf37254db56efc10$export$36d128238e6b60f5);
    $parcel$export(module.exports, "DEV_DETAILS_WRM_RESOURCE", ()=>$bf37254db56efc10$export$43a8ab4f373ff0ee);
    const $bf37254db56efc10$export$36d128238e6b60f5 = {
        issueId: '',
        issueKey: undefined,
        locale: 'en_US',
        dataTypeSelected: '',
        legacyData: undefined,
        isDevPanelDetailsDialogShown: false,
        legacyDevPanelDetailsDialogShownCounter: 0
    };
    const $bf37254db56efc10$export$b5ed55f3ed234f95 = 'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources';
    const $bf37254db56efc10$export$43a8ab4f373ff0ee = 'jira-development-status/releasereport/dev-status-dialog-bridge';
    const $bf37254db56efc10$export$432f9ff6c01431e3 = 'jira-development-status/util/WRM';
});
parcelRegister("npYQQ", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_CARD_CLICK_IGNORE_TARGET", ()=>$864ae6bce0b99b4e$export$4fbe2e62d82203a7);
    $parcel$export(module.exports, "VERSION_SELECT_MENU_PORTAL_CLASS_PREFIX", ()=>$864ae6bce0b99b4e$export$57f23f1fe030a106);
    $parcel$export(module.exports, "FEATURE_FLAG_ACTION_DROPDOWN_ANCHORS", ()=>$864ae6bce0b99b4e$export$36d427b8bcbcfc80);
    $parcel$export(module.exports, "getIssueCardClickIgnorePreventDefaultTargetSelector", ()=>$864ae6bce0b99b4e$export$31dcba8332a40055);
    $parcel$export(module.exports, "getIssueCardClickIgnoreTargetNoPreventDefaultSelector", ()=>$864ae6bce0b99b4e$export$6c4862367e99e37a);
    const $864ae6bce0b99b4e$export$4fbe2e62d82203a7 = 'issueClickOpenIssueIgnoreTarget';
    const $864ae6bce0b99b4e$export$57f23f1fe030a106 = 'move-issue-modal-select-dropdown';
    const $864ae6bce0b99b4e$export$36d427b8bcbcfc80 = 'featureFlagAnchorActionDropdown';
    const $864ae6bce0b99b4e$export$31dcba8332a40055 = ()=>`[data-version-details-issue-click-ignore-target="${$864ae6bce0b99b4e$export$4fbe2e62d82203a7}"],
    [data-version-details-issue-click-ignore-target="${$864ae6bce0b99b4e$export$36d427b8bcbcfc80}"],
    [data-testid="software-releases-move-issues-between-versions.ui.move-issue-version-select-modal--blanket"],
    [class^='${$864ae6bce0b99b4e$export$57f23f1fe030a106}'], [class*=' ${$864ae6bce0b99b4e$export$57f23f1fe030a106}']`;
    const $864ae6bce0b99b4e$export$6c4862367e99e37a = ()=>`[data-version-details-issue-click-ignore-target="${$864ae6bce0b99b4e$export$36d427b8bcbcfc80}"]`;
});
parcelRegister("9lAUN", function(module, exports) {
    $parcel$export(module.exports, "IssueWarningProvider", ()=>$bd3e4874a4d639a0$export$3786225113492c89);
    $parcel$export(module.exports, "IssuesWarningCountProvider", ()=>$bd3e4874a4d639a0$export$d7ec5473e7d825ae);
    var $dUrsT;
    var $el3Dm;
    var $kWCTI;
    var $iwqD8;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $gULOk;
    const $bd3e4874a4d639a0$var$getDevSummaryDataWarnings = (issue, jiraVersionData)=>{
        const fields = issue.fieldsById.edges.map((edge)=>edge?.node).filter(Boolean);
        const jiraStatusField = fields.find((fieldNode)=>fieldNode?.fieldId === 'status');
        const issueStatus = (0, (0, parcelRequire("gULOk")).statusCategoryForId)(jiraStatusField?.status?.statusCategory?.statusCategoryId);
        const build = issue.devSummaryCache?.devSummary.build;
        const commit = issue.devSummaryCache?.devSummary.commit;
        const pullrequest = issue.devSummaryCache?.devSummary.pullrequest;
        const pullrequestCount = issue.devSummaryCache?.devSummary.pullrequest?.overall.count ?? 0;
        const reviewState = issue.devSummaryCache?.devSummary?.review?.overall?.state;
        const reviewCount = issue.devSummaryCache?.devSummary?.review?.overall?.count ?? 0;
        const openPullRequest = jiraVersionData.warningConfig?.openPullRequest;
        const failingBuild = jiraVersionData.warningConfig?.failingBuild;
        const unreviewedCode = jiraVersionData.warningConfig?.unreviewedCode;
        const openReview = jiraVersionData.warningConfig?.openReview;
        const failingBuildCount = (build?.overall.failedBuildCount ?? 0) + ((issue.devOpsSummarisedEntities?.summarisedBuilds?.buildStates ?? []).find((buildState)=>buildState?.state === 'FAILED')?.count ?? 0);
        const hasOpenPullRequestWarning = issueStatus === 'DONE' && openPullRequest === 'ENABLED' && pullrequest?.overall?.state === 'OPEN' && pullrequest.overall.count > 0;
        const hasFailingBuildsWarning = issueStatus === 'DONE' && failingBuild === 'ENABLED' && build != null && failingBuildCount > 0;
        const hasUnreviewedCodeWarning = issueStatus === 'DONE' && unreviewedCode === 'ENABLED' && pullrequestCount === 0 && reviewCount === 0 && commit != null && commit.overall.count > 0;
        const hasOpenReviewWarning = issueStatus === 'DONE' && openReview === 'ENABLED' && reviewState != null && ![
            'CLOSED',
            'REJECTED'
        ].includes(reviewState);
        const hasWarnings = issueStatus === 'DONE' && (hasOpenPullRequestWarning || hasFailingBuildsWarning || hasUnreviewedCodeWarning || hasOpenReviewWarning);
        return {
            hasWarnings: hasWarnings,
            hasOpenPullRequestWarning: hasOpenPullRequestWarning,
            hasFailingBuildsWarning: hasFailingBuildsWarning,
            hasUnreviewedCodeWarning: hasUnreviewedCodeWarning,
            hasOpenReviewWarning: hasOpenReviewWarning
        };
    };
    const $bd3e4874a4d639a0$var$getIssueNodeWarningsCount = (edges, jiraVersionData)=>edges.map((edge)=>edge.node).filter(Boolean).reduce((acc, issue)=>{
            const warningResult = $bd3e4874a4d639a0$var$getDevSummaryDataWarnings(issue, jiraVersionData);
            if (warningResult.hasWarnings) return acc + 1;
            return acc;
        }, 0);
    const $bd3e4874a4d639a0$var$getIssueWarnings = (issue, jiraVersionData)=>$bd3e4874a4d639a0$var$getDevSummaryDataWarnings(issue, jiraVersionData);
    const $bd3e4874a4d639a0$export$3786225113492c89 = ({ jiraVersion: jiraVersion, jiraIssue: jiraIssue, children: children })=>{
        const issue = (0, $8Uumt.useFragment)((0, (0, parcelRequire("iwqD8")).default), jiraIssue);
        const jiraVersionData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("kWCTI")).default), jiraVersion);
        const warningFlags = $bd3e4874a4d639a0$var$getIssueWarnings(issue, jiraVersionData);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children(warningFlags));
    };
    const $bd3e4874a4d639a0$export$d7ec5473e7d825ae = ({ jiraVersion: jiraVersion, issueEdges: issueEdges, children: children })=>{
        const jiraIssueEdgeReferenceData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("el3Dm")).default), issueEdges);
        const warningConfig = (0, $8Uumt.useFragment)((0, (0, parcelRequire("dUrsT")).default), jiraVersion);
        const warningCount = $bd3e4874a4d639a0$var$getIssueNodeWarningsCount(jiraIssueEdgeReferenceData, warningConfig);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children(warningCount));
    };
});
parcelRegister("dUrsT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45788d524cf8c40d$export$2e2bcd8739ae039);
    const $45788d524cf8c40d$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion",
        "selections": [
            {
                "concreteType": "JiraVersionWarningConfig",
                "kind": "LinkedField",
                "name": "warningConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "openPullRequest"
                        },
                        "action": "NONE",
                        "path": "warningConfig.openPullRequest"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "openReview"
                        },
                        "action": "NONE",
                        "path": "warningConfig.openReview"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "unreviewedCode"
                        },
                        "action": "NONE",
                        "path": "warningConfig.unreviewedCode"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "failingBuild"
                        },
                        "action": "NONE",
                        "path": "warningConfig.failingBuild"
                    }
                ]
            }
        ],
        "type": "JiraVersion"
    };
    $45788d524cf8c40d$var$node.hash = "a12dea52160bb6c6b5d0ff127f4a7b36";
    var $45788d524cf8c40d$export$2e2bcd8739ae039 = $45788d524cf8c40d$var$node;
});
parcelRegister("el3Dm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72c997acb36af248$export$2e2bcd8739ae039);
    const $72c997acb36af248$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "count"
        }, v1 = {
            "kind": "ScalarField",
            "name": "state"
        };
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "isDevopsFeatureDisabledInFedRamp"
                }
            ],
            "kind": "Fragment",
            "metadata": {
                "plural": true
            },
            "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "priority",
                                            "summary",
                                            "assignee",
                                            "status",
                                            "issuetype"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssueFieldEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "kind": "ScalarField",
                                                                "name": "fieldId"
                                                            },
                                                            "action": "THROW",
                                                            "path": "node.fieldsById.edges.node.fieldId"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraStatusField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "node.fieldsById.edges"
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                            },
                            "action": "THROW",
                            "path": "node.fieldsById"
                        },
                        {
                            "condition": "isDevopsFeatureDisabledInFedRamp",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsSummarisedEntities",
                                    "kind": "LinkedField",
                                    "name": "devOpsSummarisedEntities",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsSummarisedBuilds",
                                            "kind": "LinkedField",
                                            "name": "summarisedBuilds",
                                            "plural": false,
                                            "selections": [
                                                v0,
                                                {
                                                    "concreteType": "DevOpsSummarisedBuildState",
                                                    "kind": "LinkedField",
                                                    "name": "buildStates",
                                                    "plural": true,
                                                    "selections": [
                                                        v1,
                                                        v0
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraIssueDevSummaryResult",
                                        "kind": "LinkedField",
                                        "name": "devSummaryCache",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraIssueDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "devSummary",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                "kind": "LinkedField",
                                                                "name": "pullrequest",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "overall",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v1,
                                                                                    "action": "NONE",
                                                                                    "path": "node.devSummaryCache.devSummary.pullrequest.overall.state"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v0,
                                                                                    "action": "NONE",
                                                                                    "path": "node.devSummaryCache.devSummary.pullrequest.overall.count"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "NONE",
                                                                        "path": "node.devSummaryCache.devSummary.pullrequest.overall"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "NONE",
                                                            "path": "node.devSummaryCache.devSummary.pullrequest"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                "kind": "LinkedField",
                                                                "name": "review",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "overall",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v0,
                                                                                    "action": "NONE",
                                                                                    "path": "node.devSummaryCache.devSummary.review.overall.count"
                                                                                },
                                                                                v1
                                                                            ]
                                                                        },
                                                                        "action": "NONE",
                                                                        "path": "node.devSummaryCache.devSummary.review.overall"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "NONE",
                                                            "path": "node.devSummaryCache.devSummary.review"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                "kind": "LinkedField",
                                                                "name": "commit",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "overall",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v0,
                                                                                    "action": "NONE",
                                                                                    "path": "node.devSummaryCache.devSummary.commit.overall.count"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "NONE",
                                                                        "path": "node.devSummaryCache.devSummary.commit.overall"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "NONE",
                                                            "path": "node.devSummaryCache.devSummary.commit"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                "kind": "LinkedField",
                                                                "name": "build",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "overall",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v0,
                                                                                    "action": "NONE",
                                                                                    "path": "node.devSummaryCache.devSummary.build.overall.count"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "failedBuildCount"
                                                                                    },
                                                                                    "action": "NONE",
                                                                                    "path": "node.devSummaryCache.devSummary.build.overall.failedBuildCount"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "NONE",
                                                                        "path": "node.devSummaryCache.devSummary.build.overall"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "NONE",
                                                            "path": "node.devSummaryCache.devSummary.build"
                                                        }
                                                    ]
                                                },
                                                "action": "NONE",
                                                "path": "node.devSummaryCache.devSummary"
                                            }
                                        ]
                                    },
                                    "action": "NONE",
                                    "path": "node.devSummaryCache"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraIssueEdge"
        };
    }();
    $72c997acb36af248$var$node.hash = "2af391280f3df5e713e3630effb3b264";
    var $72c997acb36af248$export$2e2bcd8739ae039 = $72c997acb36af248$var$node;
});
parcelRegister("kWCTI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d42738ed9f0149a7$export$2e2bcd8739ae039);
    const $d42738ed9f0149a7$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion",
        "selections": [
            {
                "concreteType": "JiraVersionWarningConfig",
                "kind": "LinkedField",
                "name": "warningConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "openPullRequest"
                        },
                        "action": "NONE",
                        "path": "warningConfig.openPullRequest"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "openReview"
                        },
                        "action": "NONE",
                        "path": "warningConfig.openReview"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "unreviewedCode"
                        },
                        "action": "NONE",
                        "path": "warningConfig.unreviewedCode"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "failingBuild"
                        },
                        "action": "NONE",
                        "path": "warningConfig.failingBuild"
                    }
                ]
            }
        ],
        "type": "JiraVersion"
    };
    $d42738ed9f0149a7$var$node.hash = "e4b994880d16817a096017c816579b1b";
    var $d42738ed9f0149a7$export$2e2bcd8739ae039 = $d42738ed9f0149a7$var$node;
});
parcelRegister("iwqD8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b841e02ff989ff3$export$2e2bcd8739ae039);
    const $3b841e02ff989ff3$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "count"
        }, v1 = {
            "kind": "ScalarField",
            "name": "state"
        }, v2 = [
            v1,
            v0
        ];
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "isDevopsFeatureDisabledInFedRamp"
                }
            ],
            "kind": "Fragment",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "ids",
                                "value": [
                                    "priority",
                                    "summary",
                                    "assignee",
                                    "status",
                                    "issuetype"
                                ]
                            }
                        ],
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fieldsById",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    "action": "THROW",
                                                    "path": "fieldsById.edges.node.fieldId"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatusCategory",
                                                                    "kind": "LinkedField",
                                                                    "name": "statusCategory",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "statusCategoryId"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "fieldsById.edges"
                            }
                        ],
                        "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                    },
                    "action": "THROW",
                    "path": "fieldsById"
                },
                {
                    "condition": "isDevopsFeatureDisabledInFedRamp",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "DevOpsSummarisedEntities",
                            "kind": "LinkedField",
                            "name": "devOpsSummarisedEntities",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsSummarisedBuilds",
                                    "kind": "LinkedField",
                                    "name": "summarisedBuilds",
                                    "plural": false,
                                    "selections": [
                                        v0,
                                        {
                                            "concreteType": "DevOpsSummarisedBuildState",
                                            "kind": "LinkedField",
                                            "name": "buildStates",
                                            "plural": true,
                                            "selections": v2
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraIssueDevSummaryResult",
                            "kind": "LinkedField",
                            "name": "devSummaryCache",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraIssueDevSummary",
                                        "kind": "LinkedField",
                                        "name": "devSummary",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "pullrequest",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraIssuePullRequestDevSummary",
                                                                "kind": "LinkedField",
                                                                "name": "overall",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v1,
                                                                        "action": "NONE",
                                                                        "path": "devSummaryCache.devSummary.pullrequest.overall.state"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v0,
                                                                        "action": "NONE",
                                                                        "path": "devSummaryCache.devSummary.pullrequest.overall.count"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "NONE",
                                                            "path": "devSummaryCache.devSummary.pullrequest.overall"
                                                        }
                                                    ]
                                                },
                                                "action": "NONE",
                                                "path": "devSummaryCache.devSummary.pullrequest"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "commit",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraIssueCommitDevSummary",
                                                                "kind": "LinkedField",
                                                                "name": "overall",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v0,
                                                                        "action": "NONE",
                                                                        "path": "devSummaryCache.devSummary.commit.overall.count"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "NONE",
                                                            "path": "devSummaryCache.devSummary.commit.overall"
                                                        }
                                                    ]
                                                },
                                                "action": "NONE",
                                                "path": "devSummaryCache.devSummary.commit"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "build",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraIssueBuildDevSummary",
                                                                "kind": "LinkedField",
                                                                "name": "overall",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "kind": "ScalarField",
                                                                            "name": "failedBuildCount"
                                                                        },
                                                                        "action": "NONE",
                                                                        "path": "devSummaryCache.devSummary.build.overall.failedBuildCount"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "NONE",
                                                            "path": "devSummaryCache.devSummary.build.overall"
                                                        }
                                                    ]
                                                },
                                                "action": "NONE",
                                                "path": "devSummaryCache.devSummary.build"
                                            },
                                            {
                                                "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "review",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueReviewDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v2
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "NONE",
                                    "path": "devSummaryCache.devSummary"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraIssue"
        };
    }();
    $3b841e02ff989ff3$var$node.hash = "ffa772f7a474b433d08a55e95366246c";
    var $3b841e02ff989ff3$export$2e2bcd8739ae039 = $3b841e02ff989ff3$var$node;
});
const $752b719410cf933d$export$b343d4705e10ba61 = 'VersionDetailIssueListIssueCardContainer';
const $752b719410cf933d$export$6bc465585d114926 = 'VersionDetailsIssueList';
const $752b719410cf933d$export$eb4c541f23d39ba2 = 1740;
const $752b719410cf933d$export$ac70ca19af3aa92c = 1380;
parcelRegister("1KeDw", function(module, exports) {
    $parcel$export(module.exports, "Assignee", ()=>$3c0e123bdcc383cb$export$361f73eba39649ac);
    var $2HbPb;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $ujWmd;
    var $3bDjY;
    var $koVbs;
    var $eAypR;
    const $3c0e123bdcc383cb$export$361f73eba39649ac = ({ jiraAssigneeField: jiraAssigneeField })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("2HbPb")).default), jiraAssigneeField);
        const avatarUrl = data?.user == null ? '' : data.user.picture;
        const displayName = data?.user == null ? formatMessage((0, (0, parcelRequire("eAypR")).default).unassigned) : data.user.name;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3c0e123bdcc383cb$var$AssigneeContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: displayName,
            position: "bottom-start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3c0e123bdcc383cb$var$VerticalCenter, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: "circle",
            src: avatarUrl,
            size: "small"
        }))));
    };
    const $3c0e123bdcc383cb$var$AssigneeContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _4t3izwfg _1bsbzwfg _1ul9zwfg _8mocu2gc",
                __cmplp.className
            ])
        });
    });
    const $3c0e123bdcc383cb$var$VerticalCenter = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2HbPb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f03087c3dbf693a$export$2e2bcd8739ae039);
    const $7f03087c3dbf693a$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "assignee_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectUserPickerField"
    };
    $7f03087c3dbf693a$var$node.hash = "a79331910374d5f581f31a15777ff330";
    var $7f03087c3dbf693a$export$2e2bcd8739ae039 = $7f03087c3dbf693a$var$node;
});
parcelRegister("eAypR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d25d0f86e97cdffa$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d25d0f86e97cdffa$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unassigned: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.assignee.unassigned",
            "defaultMessage": "Unassigned"
        }
    });
});
parcelRegister("c7zJ6", function(module, exports) {
    $parcel$export(module.exports, "DeliveryInfo", ()=>$fb3330b088a6db2d$export$61f40ad692662ca7);
    $parcel$export(module.exports, "Delivery", ()=>$fb3330b088a6db2d$export$12cbedef95fe0035);
    $parcel$export(module.exports, "DeliveryContainer", ()=>$fb3330b088a6db2d$export$8901d2e97ed55253);
    var $l4DDb;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8Uumt = parcelRequire("8Uumt");
    var $8YTUU;
    var $Iny5X;
    var $4R6GH;
    var $npYQQ;
    var $a40gh;
    var $4ttab;
    var $aEu2z;
    var $916hF;
    const $fb3330b088a6db2d$var$getDeploymentDetails = (devOpsSummarisedEntities)=>{
        const summaries = devOpsSummarisedEntities?.summarisedDeployments;
        if (!summaries) return undefined;
        const { deploymentState: deploymentState, deploymentEnvironment: deploymentEnvironment } = summaries;
        return {
            deploymentState: deploymentState ?? undefined,
            deploymentEnvironment: deploymentEnvironment?.category ?? undefined
        };
    };
    const $fb3330b088a6db2d$export$61f40ad692662ca7 = ({ issueId: issueId, scopeId: scopeId, customTrigger: customTrigger, devSummaryCache: devSummaryCache, devOpsSummarisedEntities: devOpsSummarisedEntities, zIndexForPopup: zIndexForPopup, location: location, onClick: onClick = (0, ($parcel$interopDefault($8Rkzz))) })=>{
        const devSummary = devSummaryCache?.devSummary;
        const hasBambooDeployments = (devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0;
        const hasBuilds = Number(devSummary?.build?.overall?.count) > 0 || Number(devOpsSummarisedEntities?.summarisedBuilds?.count) > 0;
        const deploymentCount = devOpsSummarisedEntities?.summarisedDeployments?.count ?? 0;
        const hasDeployments = deploymentCount > 0;
        if (devOpsSummarisedEntities != null && hasDeployments) {
            const deploymentDetails = $fb3330b088a6db2d$var$getDeploymentDetails(devOpsSummarisedEntities);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Iny5X")).default), {
                devInfoType: (0, (0, parcelRequire("8YTUU")).DevInfoTypes).DEPLOYMENT,
                issueId: Number(issueId),
                customTrigger: customTrigger,
                scopeId: scopeId,
                deploymentDetails: deploymentDetails,
                zIndex: zIndexForPopup,
                location: location
            });
        }
        if (devSummary != null && hasBambooDeployments) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ttab")).BambooDeploymentData), {
            jiraIssueDevSummary: devSummary,
            onDeploymentClicked: ()=>onClick((0, $61a2cd6236d50c20$export$90cac6260ae9ced5))
        });
        if (devSummary != null && hasBuilds) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aEu2z")).BuildData), {
            devOpsSummarisedBuilds: devOpsSummarisedEntities?.summarisedBuilds ?? undefined,
            jiraIssueDevSummary: devSummary,
            onBuildClicked: ()=>onClick((0, $61a2cd6236d50c20$export$74a388a09f2a004e))
        });
        return null;
    };
    const $fb3330b088a6db2d$export$12cbedef95fe0035 = ({ jiraIssue: jiraIssue, onClick: onClick })=>{
        const { issueId: issueId, devSummaryCache: devSummaryCache, devOpsSummarisedEntities: devOpsSummarisedEntities, summarisedDeployments: summarisedDeployments, summarisedBuilds: summarisedBuilds } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("l4DDb")).default), jiraIssue);
        const devSummary = devSummaryCache?.devSummary;
        const hasBambooDeployments = (devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0;
        const hasBuilds = Number(devSummary?.build?.overall?.count) > 0 || ((0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re') ? Number(summarisedBuilds?.count) > 0 : Number(devOpsSummarisedEntities?.summarisedBuilds?.count) > 0);
        const deploymentCount = (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re') ? summarisedDeployments?.count ?? 0 : devOpsSummarisedEntities?.summarisedDeployments?.count ?? 0;
        const hasDeployments = deploymentCount > 0;
        if (devOpsSummarisedEntities != null && hasDeployments) return (0, ($parcel$interopDefault($5uXOq))).createElement($fb3330b088a6db2d$export$8901d2e97ed55253, {
            "data-version-details-issue-click-ignore-target": (0, (0, parcelRequire("npYQQ")).ISSUE_CARD_CLICK_IGNORE_TARGET)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a40gh")).ErrorBoundary), {
            id: "issuesListDeploymentData"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Iny5X")).default), {
            devInfoType: (0, (0, parcelRequire("8YTUU")).DevInfoTypes).DEPLOYMENT,
            issueId: Number(issueId),
            customTrigger: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("916hF")).DeploymentData), {
                jiraIssueDevOpsSummarisedEntities: devOpsSummarisedEntities,
                onDeploymentClicked: ()=>onClick((0, $61a2cd6236d50c20$export$90cac6260ae9ced5))
            }),
            scopeId: (0, $752b719410cf933d$export$6bc465585d114926),
            isStopPropagationOnClick: false,
            location: (0, $4ebd35f903e92a1a$export$ede40e627a0cbf14)
        })));
        if (devSummary != null && hasBambooDeployments) return (0, ($parcel$interopDefault($5uXOq))).createElement($fb3330b088a6db2d$export$8901d2e97ed55253, {
            "data-version-details-issue-click-ignore-target": (0, (0, parcelRequire("npYQQ")).ISSUE_CARD_CLICK_IGNORE_TARGET)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a40gh")).ErrorBoundary), {
            id: "issuesListBambooDeploymentData"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ttab")).BambooDeploymentData), {
            jiraIssueDevSummary: devSummary,
            onDeploymentClicked: ()=>onClick((0, $61a2cd6236d50c20$export$90cac6260ae9ced5))
        })));
        if (devSummary != null && hasBuilds) return (0, ($parcel$interopDefault($5uXOq))).createElement($fb3330b088a6db2d$export$8901d2e97ed55253, {
            "data-version-details-issue-click-ignore-target": (0, (0, parcelRequire("npYQQ")).ISSUE_CARD_CLICK_IGNORE_TARGET)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a40gh")).ErrorBoundary), {
            fallback: "flag",
            id: "issuesListBuildData"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aEu2z")).BuildData), {
            devOpsSummarisedBuilds: ((0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re') ? summarisedBuilds : devOpsSummarisedEntities?.summarisedBuilds) ?? undefined,
            jiraIssueDevSummary: devSummary,
            onBuildClicked: ()=>onClick((0, $61a2cd6236d50c20$export$74a388a09f2a004e))
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fb3330b088a6db2d$export$8901d2e97ed55253, null);
    };
    const $fb3330b088a6db2d$export$8901d2e97ed55253 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_17av1lit _fmdx1lit _jyrf1tcg _3ufp1tcg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("l4DDb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92767328c82a2148$export$2e2bcd8739ae039);
    const $92767328c82a2148$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "count"
        }, v1 = [
            v0
        ], v2 = {
            "concreteType": "DevOpsSummarisedDeployments",
            "kind": "LinkedField",
            "name": "summarisedDeployments",
            "plural": false,
            "selections": v1
        }, v3 = {
            "kind": "FragmentSpread",
            "name": "buildData_softwareReleasesVersionDetailIssueList_devOpsSummarisedBuilds"
        };
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "isIssueSummarisedDeploymentsMigratedToAgs"
                },
                {
                    "kind": "RootArgument",
                    "name": "shouldIncludeDevOpsFieldsViaAgs"
                }
            ],
            "kind": "Fragment",
            "name": "delivery_softwareReleasesVersionDetailIssueList",
            "selections": [
                {
                    "concreteType": "DevOpsSummarisedEntities",
                    "kind": "LinkedField",
                    "name": "devOpsSummarisedEntities",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                v2,
                                {
                                    "concreteType": "DevOpsSummarisedBuilds",
                                    "kind": "LinkedField",
                                    "name": "summarisedBuilds",
                                    "plural": false,
                                    "selections": [
                                        v0,
                                        v3
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "deploymentData_softwareReleasesVersionDetailIssueList"
                        }
                    ]
                },
                {
                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v2,
                        {
                            "concreteType": "DevOpsSummarisedBuilds",
                            "kind": "LinkedField",
                            "name": "summarisedBuilds",
                            "plural": false,
                            "selections": [
                                v3,
                                v0
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraIssueDevSummaryResult",
                    "kind": "LinkedField",
                    "name": "devSummaryCache",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueDevSummary",
                            "kind": "LinkedField",
                            "name": "devSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                    "kind": "LinkedField",
                                    "name": "build",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueBuildDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": v1
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                    "kind": "LinkedField",
                                    "name": "deploymentEnvironments",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                    "kind": "LinkedField",
                                                    "name": "topEnvironments",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "bambooDeploymentData_softwareReleasesVersionDetailIssueList"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "buildData_softwareReleasesVersionDetailIssueList_jiraIssueDevSummary"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                }
            ],
            "type": "JiraIssue"
        };
    }();
    $92767328c82a2148$var$node.hash = "4ee91cee5bc4c8f8709d2bffdcc6225b";
    var $92767328c82a2148$export$2e2bcd8739ae039 = $92767328c82a2148$var$node;
});
const $4ebd35f903e92a1a$export$9b8283d5878d2491 = 'board';
const $4ebd35f903e92a1a$export$76a449e52fa0e1e8 = 'issue';
const $4ebd35f903e92a1a$export$ede40e627a0cbf14 = 'version_details';
const $4ebd35f903e92a1a$export$464c50016d069471 = 'issue_view_child_issues_list';
const $4ebd35f903e92a1a$export$3a46c5b594c0f84c = 'issue_view_linked_issues_list';
parcelRegister("8YTUU", function(module, exports) {
    $parcel$export(module.exports, "DevInfoTypes", ()=>$ba5542dc32884ee4$export$a100703e17b2650a);
    $parcel$export(module.exports, "DevInfoTypeMap", ()=>$ba5542dc32884ee4$export$39c00ace65e13f2d);
    $parcel$export(module.exports, "ButtonStatus", ()=>$ba5542dc32884ee4$export$477d4d2d93581a40);
    const $ba5542dc32884ee4$export$a100703e17b2650a = Object.freeze({
        BRANCH: 'branch',
        COMMIT: 'commit',
        PULLREQUEST: 'pullrequest',
        DECLINED: 'declined',
        MERGED: 'merged',
        DEPLOYMENT: 'deployment',
        DESIGN: 'design'
    });
    const $ba5542dc32884ee4$export$39c00ace65e13f2d = {
        [$ba5542dc32884ee4$export$a100703e17b2650a.BRANCH]: 'branch',
        [$ba5542dc32884ee4$export$a100703e17b2650a.COMMIT]: 'commit',
        [$ba5542dc32884ee4$export$a100703e17b2650a.PULLREQUEST]: 'pull request',
        [$ba5542dc32884ee4$export$a100703e17b2650a.MERGED]: 'pull request',
        [$ba5542dc32884ee4$export$a100703e17b2650a.DECLINED]: 'pull request',
        [$ba5542dc32884ee4$export$a100703e17b2650a.DEPLOYMENT]: 'deployment',
        [$ba5542dc32884ee4$export$a100703e17b2650a.DESIGN]: 'design'
    };
    const $ba5542dc32884ee4$export$477d4d2d93581a40 = Object.freeze({
        ACTIVE: 'active',
        HOVER: 'hover',
        DEFAULT: 'default'
    });
});
parcelRegister("Iny5X", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "DevInfoIconView", ()=>$a9451438a3e9bf76$export$b98af1fb6b8b345e);
    $parcel$export(module.exports, "default", ()=>$a9451438a3e9bf76$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8QpSo;
    var $9yOBd;
    var $4iPF3;
    var $ePJ5X;
    var $bFklq;
    var $ksIER;
    var $91Cn3;
    var $hXgVM;
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $gwIPs;
    var $4gmb8;
    var $dJl1T;
    var $8YTUU;
    var $lxrPB;
    var $kcaDR;
    var $7MIrF;
    var $47gW9;
    var $7XluA;
    var $ivDCs;
    var $4mO32;
    var $39xOx;
    var $kaHBi;
    var $3bQtK;
    var $lXSZ8;
    var $koVbs;
    var $7IEKg;
    var $dXq4S;
    var $iXVV6;
    var $fiv1r;
    var $a3HWu;
    var $kfztd;
    var $9OXo1;
    var $gicL9;
    var $4Dyci;
    const $a9451438a3e9bf76$var$DEV_INFO_BUTTON_ID = 'development-board-dev-info-icon.button-text';
    const $a9451438a3e9bf76$var$DevInfoIconsMapping = (0, (0, parcelRequire("8QpSo")).default)((formatMessage)=>({
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).BRANCH]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4iPF3"))))), {
                label: formatMessage((0, (0, parcelRequire("4Dyci")).default).branchIconLabel),
                color: "var(--ds-icon, #44546F)"
            }),
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bFklq"))))), {
                label: formatMessage((0, (0, parcelRequire("4Dyci")).default).commitIconLabel),
                color: "var(--ds-icon, #44546F)"
            }),
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hXgVM"))))), {
                label: formatMessage((0, (0, parcelRequire("4Dyci")).default).openPullRequestIconLabel),
                color: "var(--ds-icon, #44546F)"
            }),
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DECLINED]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ksIER"))))), {
                label: formatMessage((0, (0, parcelRequire("4Dyci")).default).declinedPullRequestIconLabel),
                color: "var(--ds-icon, #44546F)"
            }),
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).MERGED]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("91Cn3"))))), {
                label: formatMessage((0, (0, parcelRequire("4Dyci")).default).mergedPullRequestIconLabel),
                color: "var(--ds-icon-accent-green, #22A06B)"
            }),
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DEPLOYMENT]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ePJ5X"))))), {
                label: formatMessage((0, (0, parcelRequire("4Dyci")).default).deploymentIconLabel),
                color: "var(--ds-icon, #44546F)"
            }),
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DESIGN]: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $a9451438a3e9bf76$var$DesignIconStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lXSZ8")).default), {
                label: formatMessage((0, (0, parcelRequire("4Dyci")).default).designIconLabel)
            }))
        }));
    const $a9451438a3e9bf76$var$getDevInfoIcon = (devInfoType, formatMessage, deploymentDetails)=>{
        if (deploymentDetails?.deploymentState && deploymentDetails?.deploymentEnvironment) {
            if (deploymentDetails.deploymentEnvironment === (0, (0, parcelRequire("gicL9")).DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, (0, parcelRequire("gicL9")).DeploymentState).SUCCESSFUL) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7MIrF")).DeploymentProdSuccess), {
                size: "small",
                label: formatMessage((0, (0, parcelRequire("4Dyci")).default).deploymentProductionSuccessIconLabel)
            });
            if (deploymentDetails.deploymentEnvironment === (0, (0, parcelRequire("gicL9")).DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, (0, parcelRequire("gicL9")).DeploymentState).FAILED) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7MIrF")).DeploymentProdFailed), {
                size: "small",
                label: formatMessage((0, (0, parcelRequire("4Dyci")).default).deploymentProductionFailedIconLabel)
            });
            if (deploymentDetails.deploymentEnvironment !== (0, (0, parcelRequire("gicL9")).DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, (0, parcelRequire("gicL9")).DeploymentState).SUCCESSFUL) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7MIrF")).DeploymentNonProdSuccess), {
                size: "small",
                label: formatMessage((0, (0, parcelRequire("4Dyci")).default).deploymentNonProductionSuccessIconLabel)
            });
            if (deploymentDetails.deploymentEnvironment !== (0, (0, parcelRequire("gicL9")).DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, (0, parcelRequire("gicL9")).DeploymentState).FAILED) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7MIrF")).DeploymentNonProdFailed), {
                size: "small",
                label: formatMessage((0, (0, parcelRequire("4Dyci")).default).deploymentNonProductionFailedIconLabel)
            });
        }
        return $a9451438a3e9bf76$var$DevInfoIconsMapping(formatMessage)[devInfoType];
    };
    const $a9451438a3e9bf76$export$b98af1fb6b8b345e = ({ issueId: issueId, devInfoType: devInfoType, allowNativeContextMenu: allowNativeContextMenu, customTrigger: customTrigger, scopeId: scopeId, deploymentDetails: deploymentDetails, isStopPropagationOnClick: isStopPropagationOnClick = true, placement: placement = 'bottom-start', offset: offset, zIndex: zIndex = (0, (0, parcelRequire("gwIPs")).layers).layer - 1 })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const [isHoverMode, setIsHoverMode] = (0, $5uXOq.useState)(true);
        const [shouldAutoFocus, setShouldAutoFocus] = (0, $5uXOq.useState)(true);
        const timeoutRef = (0, $5uXOq.useRef)(undefined);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const issueAri = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("kcaDR")).createIssueAri)(cloudId, issueId.toString()), [
            cloudId,
            issueId
        ]);
        const siteAri = (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            resourceType: 'site',
            resourceId: cloudId
        });
        const initialTrigger = (0, $5uXOq.useRef)(null);
        const devInfoIcon = $a9451438a3e9bf76$var$getDevInfoIcon(devInfoType, formatMessage, deploymentDetails);
        const popupType = devInfoType === (0, (0, parcelRequire("8YTUU")).DevInfoTypes).MERGED || devInfoType === (0, (0, parcelRequire("8YTUU")).DevInfoTypes).DECLINED ? (0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST : devInfoType;
        const { id: experienceId, name: experienceName } = (0, (0, parcelRequire("gicL9")).experienceDetails)[popupType];
        const onExperienceSuccess = (0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: experienceName
        });
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                issueId: issueAri
            }), [
            issueAri
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("gicL9")).popupEntryPoints)[popupType], entryPointParams, (0, (0, parcelRequire("gicL9")).metrics)[popupType]);
        const designEntrypoint = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("7IEKg")).designModalEntryPoint), {
            siteAri: siteAri,
            issueAri: issueAri,
            cloudId: cloudId
        });
        const designModalTriggerRef = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(designEntrypoint.entryPointActions);
        const entryPointErrorBoundaryProps = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("gicL9")).packageDetails)[popupType],
                errorFallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lxrPB")).default), {
                        devInfoType: devInfoType,
                        issueAri: issueAri,
                        scopeId: scopeId
                    })
            }), [
            devInfoType,
            issueAri,
            popupType,
            scopeId
        ]);
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                issueAri: issueAri,
                devInfoType: devInfoType,
                trigger: initialTrigger.current ?? undefined,
                onReady: ()=>{
                    stopMetric();
                    onExperienceSuccess();
                },
                scopeId: scopeId,
                modalTriggerRef: devInfoType === (0, (0, parcelRequire("8YTUU")).DevInfoTypes).DESIGN ? designModalTriggerRef : undefined
            }), [
            issueAri,
            devInfoType,
            scopeId,
            designModalTriggerRef,
            stopMetric,
            onExperienceSuccess
        ]);
        const handleDevIconClick = (0, $5uXOq.useCallback)(()=>{
            clearTimeout(timeoutRef.current);
            if (initialTrigger.current === null) initialTrigger.current = 'click';
            if (isOpen && isHoverMode) setIsHoverMode(false);
            else if (isOpen && !isHoverMode) {
                initialTrigger.current = null;
                setIsOpen(false);
                setIsHoverMode(true);
            } else {
                entryPointActions.load();
                setShouldAutoFocus(true);
                setIsOpen(true);
                setIsHoverMode(false);
            }
        }, [
            entryPointActions,
            isHoverMode,
            isOpen
        ]);
        const handleMouseEnter = ()=>{
            if (!isHoverMode) return;
            clearTimeout(timeoutRef.current);
            setShouldAutoFocus(false);
            if (!isOpen) {
                entryPointActions.preload();
                timeoutRef.current = undefined;
                timeoutRef.current = setTimeout(()=>{
                    if (initialTrigger.current === null) initialTrigger.current = 'hover';
                    entryPointActions.load();
                    setIsOpen(true);
                }, (0, (0, parcelRequire("gicL9")).HOVER_TIMEOUT_MS));
            }
        };
        const handleMouseLeave = ()=>{
            if (!isHoverMode) return;
            clearTimeout(timeoutRef.current);
            entryPointActions.cancelPreload();
            timeoutRef.current = undefined;
            if (isOpen) timeoutRef.current = setTimeout(()=>{
                initialTrigger.current = null;
                setShouldAutoFocus(true);
                setIsHoverMode(true);
                setIsOpen(false);
            }, (0, (0, parcelRequire("gicL9")).HOVER_TIMEOUT_MS));
        };
        if ((0, (0, parcelRequire("gicL9")).iconColor)[devInfoType] === undefined) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('packages.development.board.dev-info-icon', 'unexpected devInfoType', {
            devInfoType: devInfoType
        });
        const customTheme = (0, (0, parcelRequire("4gmb8")).getTheme)({
            buttonStyles: {
                subtle: {
                    color: {
                        default: (0, (0, parcelRequire("gicL9")).iconColor)[devInfoType][(0, (0, parcelRequire("8YTUU")).ButtonStatus).DEFAULT],
                        hover: (0, (0, parcelRequire("gicL9")).iconColor)[devInfoType][(0, (0, parcelRequire("8YTUU")).ButtonStatus).HOVER],
                        active: (0, (0, parcelRequire("gicL9")).iconColor)[devInfoType][(0, (0, parcelRequire("8YTUU")).ButtonStatus).ACTIVE]
                    }
                }
            }
        });
        const devInfoTextId = `${$a9451438a3e9bf76$var$DEV_INFO_BUTTON_ID}-${issueId}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            role: "presentation",
            "data-testid": "development-board-dev-info-icon.container",
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onClick: (e)=>{
                if (isStopPropagationOnClick) e.stopPropagation();
            },
            onKeyDown: (e)=>{
                e.stopPropagation();
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            placement: placement,
            shouldFlip: true,
            autoFocus: shouldAutoFocus,
            shouldUseCaptureOnOutsideClick: true,
            testId: "development-board-dev-info-icon.popup",
            trigger: (triggerProps)=>customTrigger != null ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", triggerProps, customTrigger) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
                    ...triggerProps,
                    onClick: handleDevIconClick,
                    isSelected: isOpen && !isHoverMode,
                    theme: customTheme,
                    appearance: "subtle",
                    spacing: "compact",
                    iconBefore: devInfoIcon,
                    "aria-describedby": devInfoTextId
                }), (0, ($parcel$interopDefault($5uXOq))).createElement($a9451438a3e9bf76$var$DevInfoButtonText, {
                    id: devInfoTextId
                }, (0, (0, parcelRequire("gicL9")).DevInfoButtonLabelMapping)(formatMessage)[devInfoType])),
            isOpen: isOpen,
            onClose: ()=>{
                initialTrigger.current = null;
                setIsOpen(false);
                setIsHoverMode(true);
            },
            offset: offset,
            zIndex: zIndex,
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    onContextMenu: (event)=>{
                        if (!allowNativeContextMenu) event.preventDefault();
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaHBi")).ExperienceStart), {
                    analyticsSource: experienceName,
                    experience: experienceName,
                    experienceId: experienceId
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
                    entryPointReferenceSubject: entryPointReferenceSubject,
                    ...entryPointErrorBoundaryProps,
                    fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a3HWu")).DevInfoDetailsPopupSkeleton), {
                        devinfoType: popupType
                    }),
                    runtimeProps: runtimeProps
                }))
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivDCs")).ModalEntryPointContainer), {
            entryPointReferenceSubject: designEntrypoint.entryPointReferenceSubject,
            id: "jiraDesignModal",
            packageName: "design-modal",
            entryPointActions: designEntrypoint.entryPointActions,
            runtimeProps: {
                initialSelectedDesign: 0
            }
        }));
    };
    const $a9451438a3e9bf76$var$ERROR_ID = 'renderDevInfoIcon';
    const $a9451438a3e9bf76$var$PACKAGE_NAME = 'jiraDevelopmentBoardDevInfoIcon';
    const $a9451438a3e9bf76$var$DevInfoIcon = ({ issueId: issueId, devInfoType: devInfoType, allowNativeContextMenu: allowNativeContextMenu, customTrigger: customTrigger, scopeId: scopeId, deploymentDetails: deploymentDetails, isStopPropagationOnClick: isStopPropagationOnClick = true, placement: placement, offset: offset, zIndex: zIndex, location: location = (0, $4ebd35f903e92a1a$export$9b8283d5878d2491) })=>{
        const attributes = {
            devInfoType: devInfoType ?? 'unexpected',
            location: location
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: $a9451438a3e9bf76$var$ERROR_ID,
            packageName: $a9451438a3e9bf76$var$PACKAGE_NAME,
            teamName: "fusion-isotopes",
            fallback: "unmount",
            attributes: attributes,
            extraEventData: attributes,
            sendToPrivacyUnsafeSplunk: true
        }, !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fiv1r")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
            sourceName: "DevInfoIcon",
            attributes: attributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a9451438a3e9bf76$export$b98af1fb6b8b345e, {
            issueId: issueId,
            devInfoType: devInfoType,
            allowNativeContextMenu: allowNativeContextMenu,
            customTrigger: customTrigger,
            scopeId: scopeId,
            deploymentDetails: deploymentDetails,
            isStopPropagationOnClick: isStopPropagationOnClick,
            placement: placement,
            offset: offset,
            zIndex: zIndex
        }))));
    };
    var $a9451438a3e9bf76$export$2e2bcd8739ae039 = $a9451438a3e9bf76$var$DevInfoIcon;
    const $a9451438a3e9bf76$var$DevInfoButtonText = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cglyw",
                __cmplp.className
            ])
        });
    });
    const $a9451438a3e9bf76$var$DesignIconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '16px',
        width: '16px',
        display: 'flex',
        justifyContent: 'center'
    });
});
parcelRegister("4iPF3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3220eab15e59539d$var$_react = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3220eab15e59539d$var$_UNSAFE_baseNew = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3220eab15e59539d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3220eab15e59539d$var$BranchIcon = (props)=>$3220eab15e59539d$var$_react.default.createElement($3220eab15e59539d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M4.25 4.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0V9m1.5 3.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 0h3.5a2.5 2.5 0 0 0 2.5-2.5v-5.5m0 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>`
        }, props));
    $3220eab15e59539d$var$BranchIcon.displayName = 'BranchIcon';
    var $3220eab15e59539d$var$_default = module.exports.default = $3220eab15e59539d$var$BranchIcon;
});
parcelRegister("ePJ5X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $acc8cf07db1d2dba$var$_react = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $acc8cf07db1d2dba$var$_UNSAFE_baseNew = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $acc8cf07db1d2dba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $acc8cf07db1d2dba$var$CloudArrowUpIcon = (props)=>$acc8cf07db1d2dba$var$_react.default.createElement($acc8cf07db1d2dba$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m4.429 3.18.217.718.358-.108.129-.35zm6.25.81-.723.2.151.55h.572zM8 8.75l.53-.53a.75.75 0 0 0-1.06 0zm2.405-5.754.723-.2zM2.5 6.5v-.482H1V6.5zm1.408-2.378.738-.224-.434-1.435-.738.223zm1.225-.683.157-.427-1.408-.517-.157.427zm4.549-.244.274.995 1.446-.398-.274-.995zm.997 1.546h1.191v-1.5h-1.19zM13.5 6.37v.13H15v-.13zm-7.97 5.91 3-3-1.06-1.06-3 3zm1.94-3 3 3 1.06-1.061-3-3zm-.22-.031V16h1.5V9.25zM13.5 6.5A1.5 1.5 0 0 1 12 8v1.5a3 3 0 0 0 3-3zm-6.044-5a2.31 2.31 0 0 1 2.226 1.695l1.446-.398A3.81 3.81 0 0 0 7.456 0zM5.29 3.012A2.31 2.31 0 0 1 7.456 1.5V0a3.81 3.81 0 0 0-3.574 2.495zm6.58 1.729c.9 0 1.63.73 1.63 1.63H15a3.13 3.13 0 0 0-3.13-3.13zM2.5 6.018a1.98 1.98 0 0 1 1.408-1.896l-.434-1.436A3.48 3.48 0 0 0 1 6.018zM4 8a1.5 1.5 0 0 1-1.5-1.5H1a3 3 0 0 0 3 3z"/>`
        }, props));
    $acc8cf07db1d2dba$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
    var $acc8cf07db1d2dba$var$_default = module.exports.default = $acc8cf07db1d2dba$var$CloudArrowUpIcon;
});
parcelRegister("bFklq", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $87e34e0db8f20450$var$_react = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $87e34e0db8f20450$var$_UNSAFE_baseNew = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $87e34e0db8f20450$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $87e34e0db8f20450$var$CommitIcon = (props)=>$87e34e0db8f20450$var$_react.default.createElement($87e34e0db8f20450$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 10a2 2 0 1 0 0-4m0 4a2 2 0 1 1 0-4m0 4v6M8 6V0"/>`
        }, props));
    $87e34e0db8f20450$var$CommitIcon.displayName = 'CommitIcon';
    var $87e34e0db8f20450$var$_default = module.exports.default = $87e34e0db8f20450$var$CommitIcon;
});
parcelRegister("ksIER", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ee5910529ff74451$var$_react = $ee5910529ff74451$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ee5910529ff74451$var$_UNSAFE_baseNew = $ee5910529ff74451$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ee5910529ff74451$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ee5910529ff74451$var$MergeFailureIcon = (props)=>$ee5910529ff74451$var$_react.default.createElement($ee5910529ff74451$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8.5 3.25h1.25a2 2 0 0 1 2 2v6M4.25 7.5v3.75m0 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM2 1l2.25 2.25m0 0L6.5 5.5M4.25 3.25 6.5 1M4.25 3.25 2 5.5"/>`
        }, props));
    $ee5910529ff74451$var$MergeFailureIcon.displayName = 'MergeFailureIcon';
    var $ee5910529ff74451$var$_default = module.exports.default = $ee5910529ff74451$var$MergeFailureIcon;
});
parcelRegister("91Cn3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6921f8b1fecd6128$var$_react = $6921f8b1fecd6128$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $6921f8b1fecd6128$var$_UNSAFE_baseNew = $6921f8b1fecd6128$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $6921f8b1fecd6128$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6921f8b1fecd6128$var$MergeSuccessIcon = (props)=>$6921f8b1fecd6128$var$_react.default.createElement($6921f8b1fecd6128$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8.5 3.25h1.25a2 2 0 0 1 2 2v6M4.25 7.5v3.75m0 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-10-8 1.667 2 3.333-4"/>`
        }, props));
    $6921f8b1fecd6128$var$MergeSuccessIcon.displayName = 'MergeSuccessIcon';
    var $6921f8b1fecd6128$var$_default = module.exports.default = $6921f8b1fecd6128$var$MergeSuccessIcon;
});
parcelRegister("hXgVM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d1251477351c10fe$var$_react = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d1251477351c10fe$var$_UNSAFE_baseNew = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $d1251477351c10fe$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d1251477351c10fe$var$PullRequestIcon = (props)=>$d1251477351c10fe$var$_react.default.createElement($d1251477351c10fe$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 3.25h1.75a2 2 0 0 1 2 2v6m-7.5-6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0v6.5m0 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>`
        }, props));
    $d1251477351c10fe$var$PullRequestIcon.displayName = 'PullRequestIcon';
    var $d1251477351c10fe$var$_default = module.exports.default = $d1251477351c10fe$var$PullRequestIcon;
});
parcelRegister("4gmb8", function(module, exports) {
    $parcel$export(module.exports, "getTheme", ()=>$26e3b01c3b885768$export$89cbf1a0881c8b9c);
    const $26e3b01c3b885768$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
        const theme = {
            ...rest,
            buttonStyles: {
                ...buttonStyles,
                backgroundColor: (0, $829f609a65d26a98$exports).P400,
                '> span': {
                    color: (0, $829f609a65d26a98$exports).N0
                }
            }
        };
        return theme;
    };
    const $26e3b01c3b885768$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
        const { appearance: appearance, mode: mode, state: state } = themeProps;
        if (!appearance || !newTheme[appearance]) return undefined;
        const root = newTheme[appearance];
        return Object.keys(root).reduce((acc, val)=>{
            let node = root;
            [
                val,
                state,
                mode
            ].forEach((item)=>{
                if (!item) return;
                if (!node[item] && node[item] !== 0) return;
                if (typeof node[item] !== 'object') {
                    acc[val] = node[item];
                    return;
                }
                node = node[item];
            });
            return acc;
        }, {});
    };
    const $26e3b01c3b885768$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
            const theme = currentTheme(themeProps);
            const styles = Object.entries(theme).reduce((acc, [key, value])=>{
                if (!overrides?.[key]) {
                    acc[key] = value;
                    return acc;
                }
                const overriddenStyles = $26e3b01c3b885768$export$f9380c9a627682d3(overrides[key], themeProps);
                acc[key] = {
                    ...value,
                    ...overriddenStyles
                };
                return acc;
            }, {});
            return styles;
        };
});
parcelRegister("lxrPB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfd87e1125ba31c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $l1N8i;
    var $7nnPp;
    var $koVbs;
    var $ifS9h;
    var $8YTUU;
    var $dt6Va;
    var $el2W3;
    const $cfd87e1125ba31c4$var$ErrorFallback = ({ devInfoType: devInfoType, issueAri: issueAri, scopeId: scopeId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showDevDetailDialogForPopup: showDevDetailDialogForPopup } = (0, (0, parcelRequire("dt6Va")).useShowDevDetailDialogForPopup)(scopeId);
        const handleLinkClick = ()=>{
            showDevDetailDialogForPopup(devInfoType, issueAri);
        };
        const devInfoTypeName = (0, (0, parcelRequire("8YTUU")).DevInfoTypeMap)[devInfoType];
        const errorMessage = devInfoType === (0, (0, parcelRequire("8YTUU")).DevInfoTypes).DESIGN ? formatMessage((0, (0, parcelRequire("el2W3")).default).designErrorDescription, {
            devInfoType: devInfoTypeName
        }) : formatMessage((0, (0, parcelRequire("el2W3")).default).errorDescription, {
            devInfoType: devInfoTypeName
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifS9h")).PopupContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ifS9h")).PopupTitle), null, formatMessage((0, (0, parcelRequire("el2W3")).default).errorPopupTitle, {
            devInfoType: (0, (0, parcelRequire("8YTUU")).DevInfoTypeMap)[devInfoType]
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Header, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
            label: "",
            primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Title, null, formatMessage((0, (0, parcelRequire("el2W3")).default).errorTitle)))), (0, ($parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Description, null, errorMessage, devInfoType !== (0, (0, parcelRequire("8YTUU")).DevInfoTypes).DESIGN && (0, ($parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$StyledButton, {
            appearance: "link",
            onClick: handleLinkClick
        }, formatMessage((0, (0, parcelRequire("el2W3")).default).developmentErrorDescriptionCta))));
    };
    var $cfd87e1125ba31c4$export$2e2bcd8739ae039 = $cfd87e1125ba31c4$var$ErrorFallback;
    const $cfd87e1125ba31c4$var$Title = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66",
                __cmplp.className
            ])
        });
    });
    const $cfd87e1125ba31c4$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1wmz _18u0u2gc",
                __cmplp.className
            ])
        });
    });
    const $cfd87e1125ba31c4$var$StyledButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yxxidpf _12r21nn1 _if291ule _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf",
                __cmplp.className
            ])
        });
    });
    const $cfd87e1125ba31c4$var$Header = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _syaz1wmz _19pku2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dt6Va", function(module, exports) {
    $parcel$export(module.exports, "useShowDevDetailDialogForPopup", ()=>$71478bde10e2ba46$export$cdc75a6c65207319);
    var $4HJKb;
    var $dXq4S;
    var $8YTUU;
    const $71478bde10e2ba46$export$166d6c8e7de25541 = (issueAri)=>(0, (0, parcelRequire("dXq4S")).parseAri)(issueAri)?.resourceId;
    const $71478bde10e2ba46$var$devInfoTypeToPanelDataType = (devInfoType)=>{
        if (devInfoType === (0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT) return 0, $61a2cd6236d50c20$export$2e42513c7764d5f3;
        if (devInfoType === (0, (0, parcelRequire("8YTUU")).DevInfoTypes).DEPLOYMENT) return 0, $61a2cd6236d50c20$export$90cac6260ae9ced5;
        return devInfoType;
    };
    function $71478bde10e2ba46$export$cdc75a6c65207319(scopeId) {
        const { showDevDetailDialog: showDevDetailDialog } = (0, (0, parcelRequire("4HJKb")).useDevOpsDetailsDialogLoaderActions)(scopeId || 'software-board.board');
        const showDevDetailDialogForPopup = (devInfoType, issueAri)=>{
            const type = $71478bde10e2ba46$var$devInfoTypeToPanelDataType(devInfoType);
            const issueId = $71478bde10e2ba46$export$166d6c8e7de25541(issueAri);
            showDevDetailDialog(type, undefined, '', issueId);
        };
        return {
            showDevDetailDialogForPopup: showDevDetailDialogForPopup
        };
    }
});
parcelRegister("el2W3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06bd70345536382a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $06bd70345536382a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorPopupTitle: {
            "id": "development-board-common.error-fallback.error-popup-title",
            "defaultMessage": "{devInfoType}"
        },
        errorTitle: {
            "id": "development-board-common.error-fallback.error-title",
            "defaultMessage": "Something went wrong"
        },
        errorDescription: {
            "id": "development-board-common.error-fallback.error-description",
            "defaultMessage": "For some reason we couldn't load this {devInfoType}."
        },
        developmentErrorDescriptionCta: {
            "id": "development-board-common.error-fallback.development-error-description-cta",
            "defaultMessage": "View all development information."
        },
        designErrorDescription: {
            "id": "development-board-common.error-fallback.design-error-description",
            "defaultMessage": "For some reason we couldn't load this design. Refresh your page to try again."
        }
    });
});
parcelRegister("kcaDR", function(module, exports) {
    $parcel$export(module.exports, "createIssueAri", ()=>$f1bea1631292edff$export$6b0ec881a3540845);
    var $dXq4S;
    const $f1bea1631292edff$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'issue',
            resourceId: issueId
        });
});
parcelRegister("7MIrF", function(module, exports) {
    $parcel$export(module.exports, "DeploymentProdSuccess", ()=>$7a25946f9b14c935$export$8409a6d16fd5ac8e);
    $parcel$export(module.exports, "DeploymentNonProdSuccess", ()=>$7a25946f9b14c935$export$814ebe75b826c47b);
    $parcel$export(module.exports, "DeploymentProdFailed", ()=>$7a25946f9b14c935$export$22f2b1620b38359);
    $parcel$export(module.exports, "DeploymentNonProdFailed", ()=>$7a25946f9b14c935$export$5b461fe0712c5c45);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $4R6GH;
    const $7a25946f9b14c935$export$3800ce670a7fa29b = ({ size: size, label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            size: size,
            label: label,
            glyph: ()=>(0, (0, parcelRequire("4R6GH")).fg)('optimise_development_and_deployment_icons') ? (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    width: "24",
                    height: "24",
                    fill: "none"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    d: "M0 0h24v24H0z",
                    fillOpacity: ".01"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
                    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                    clipRule: "evenodd",
                    fillRule: "evenodd"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "M7 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM4 6a3 3 0 1 1 4 2.83V20a1 1 0 1 1-2 0V8.83A3.001 3.001 0 0 1 4 6z"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "M7 7a1 1 0 0 1 1 1v2a7.001 7.001 0 0 0 6.188 6.953 3.001 3.001 0 1 1-.03 2.008A9.001 9.001 0 0 1 6 10V8a1 1 0 0 1 1-1zm10 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM20.707 4.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L16 7.586l3.293-3.293a1 1 0 0 1 1.414 0z"
                }))) : (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    fill: "none",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "m0 0h24v24h-24z",
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    fillOpacity: ".01"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
                    clipRule: "evenodd",
                    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                    fillRule: "evenodd"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "m7 5c-.55228 0-1 .44772-1 1s.44772 1 1 1 1-.44772 1-1-.44772-1-1-1zm-3 1c0-1.65685 1.34315-3 3-3s3 1.34315 3 3c0 1.30622-.83481 2.41746-2 2.82929v11.17071c0 .5523-.44772 1-1 1s-1-.4477-1-1v-11.17071c-1.16519-.41183-2-1.52307-2-2.82929z"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "m7 7c.55228 0 1 .44772 1 1v2c0 3.5912 2.7043 6.5508 6.1876 6.9534.4247-1.1408 1.5237-1.9534 2.8124-1.9534 1.6569 0 3 1.3431 3 3s-1.3431 3-3 3c-1.3207 0-2.4421-.8534-2.8428-2.0389-4.57535-.4249-8.1572-4.2747-8.1572-8.9611v-2c0-.55228.44772-1 1-1zm10 10c-.5523 0-1 .4477-1 1s.4477 1 1 1 1-.4477 1-1-.4477-1-1-1z"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "m20.7071 4.29289c.3905.39053.3905 1.02369 0 1.41422l-4 4c-.3905.39049-1.0237.39049-1.4142 0l-2-2c-.3905-.39053-.3905-1.02369 0-1.41422.3905-.39052 1.0237-.39052 1.4142 0l1.2929 1.2929 3.2929-3.2929c.3905-.39052 1.0237-.39052 1.4142 0z"
                })))
        });
    const $7a25946f9b14c935$export$9a767285e35d722a = ({ size: size, label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            size: size,
            label: label,
            glyph: ()=>(0, (0, parcelRequire("4R6GH")).fg)('optimise_development_and_deployment_icons') ? (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    width: "24",
                    height: "24",
                    fill: "none"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    d: "M0 0h24v24H0z",
                    fillOpacity: "0"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                    clipRule: "evenodd",
                    fillRule: "evenodd"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "M7 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM4 6a3 3 0 1 1 4 2.8V20a1 1 0 1 1-2 0V8.8A3 3 0 0 1 4 6zM17 11c.6 0 1 .4 1 1v3.2a3 3 0 1 1-2 0V12c0-.6.4-1 1-1zm0 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM13.8 2.8a1 1 0 0 1 1.4 0L17 4.6l1.8-1.8a1 1 0 1 1 1.4 1.4L18.4 6l1.8 1.8a1 1 0 0 1-1.4 1.4L17 7.4l-1.8 1.8a1 1 0 1 1-1.4-1.4L15.6 6l-1.8-1.8a1 1 0 0 1 0-1.4z"
                }))) : (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    fill: "none",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "m0 0h24v24h-24z",
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    fillOpacity: ".01"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
                    clipRule: "evenodd",
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                    fillRule: "evenodd"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "m7 5c-.55228 0-1 .44772-1 1s.44772 1 1 1 1-.44772 1-1-.44772-1-1-1zm-3 1c0-1.65685 1.34315-3 3-3s3 1.34315 3 3c0 1.30622-.83481 2.41746-2 2.82929v11.17071c0 .5523-.44772 1-1 1s-1-.4477-1-1v-11.17071c-1.16519-.41183-2-1.52307-2-2.82929z"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "m17 11c.5523 0 1 .4477 1 1v3.1707c1.1652.4118 2 1.5231 2 2.8293 0 1.6569-1.3431 3-3 3s-3-1.3431-3-3c0-1.3062.8348-2.4175 2-2.8293v-3.1707c0-.5523.4477-1 1-1zm0 6c-.5523 0-1 .4477-1 1s.4477 1 1 1 1-.4477 1-1-.4477-1-1-1z"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "m13.7929 2.79289c.3905-.39052 1.0237-.39052 1.4142 0l1.7929 1.7929 1.7929-1.7929c.3905-.39052 1.0237-.39052 1.4142 0 .3905.39053.3905 1.02369 0 1.41422l-1.7929 1.79289 1.7929 1.79289c.3905.39053.3905 1.02369 0 1.41422-.3905.39052-1.0237.39052-1.4142 0l-1.7929-1.7929-1.7929 1.7929c-.3905.39052-1.0237.39052-1.4142 0-.3905-.39053-.3905-1.02369 0-1.41422l1.7929-1.79289-1.7929-1.79289c-.3905-.39053-.3905-1.02369 0-1.41422z"
                })))
        });
    const $7a25946f9b14c935$export$8409a6d16fd5ac8e = ({ size: size, label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            size: size,
            label: label,
            glyph: ()=>(0, (0, parcelRequire("4R6GH")).fg)('optimise_development_and_deployment_icons') ? (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 16 16",
                    width: "16",
                    height: "16",
                    fill: "none"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    d: "M0 0h16v16H0z",
                    fillOpacity: ".01"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                    d: "M1 9.75a3.15 3.15 0 0 0 2.8 3.13v.02h8.4v-.02a3.15 3.15 0 0 0 .533-6.155 4.902 4.902 0 0 0-9.466 0A3.151 3.151 0 0 0 1 9.75Zm5.85-1.8a.669.669 0 1 0-.946.946l1.15 1.15a.67.67 0 0 0 .946 0l2.096-2.096a.67.67 0 1 0-.946-.946L7.527 8.627 6.85 7.95Z",
                    clipRule: "evenodd",
                    fillRule: "evenodd"
                })) : (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "16",
                    height: "16",
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    fillOpacity: "0.01"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M1 9.74998C1 11.3714 2.22503 12.7067 3.80003 12.8808V12.9H12.2V12.8807C13.775 12.7066 15 11.3713 15 9.74998C15 8.31668 14.0427 7.10697 12.7326 6.72531C12.1716 4.63715 10.2653 3.09998 8.00006 3.09998C5.73479 3.09998 3.82855 4.63713 3.2675 6.72527C1.95735 7.10688 1 8.31663 1 9.74998ZM6.84995 7.94994C6.78825 7.88606 6.71445 7.83511 6.63285 7.80005C6.55124 7.765 6.46348 7.74655 6.37467 7.74578C6.28586 7.745 6.19778 7.76193 6.11558 7.79556C6.03338 7.82919 5.9587 7.87885 5.8959 7.94165C5.8331 8.00445 5.78344 8.07913 5.74981 8.16133C5.71618 8.24353 5.69925 8.33161 5.70003 8.42042C5.7008 8.50923 5.71925 8.59699 5.7543 8.6786C5.78936 8.7602 5.84031 8.834 5.90419 8.8957L7.0542 10.0457C7.17963 10.171 7.34973 10.2415 7.52708 10.2415C7.70444 10.2415 7.87453 10.171 7.99996 10.0457L10.0958 7.94996C10.1597 7.88826 10.2106 7.81446 10.2457 7.73286C10.2808 7.65125 10.2992 7.56349 10.3 7.47467C10.3007 7.38586 10.2838 7.29779 10.2502 7.21559C10.2166 7.13339 10.1669 7.05871 10.1041 6.99591C10.0413 6.93311 9.96662 6.88345 9.88442 6.84982C9.80222 6.81619 9.71414 6.79926 9.62533 6.80003C9.53652 6.80081 9.44876 6.81926 9.36715 6.85431C9.28555 6.88936 9.21175 6.94032 9.15005 7.0042L7.52708 8.62702L6.84995 7.94994Z",
                    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
                }))
        });
    const $7a25946f9b14c935$export$814ebe75b826c47b = ({ size: size, label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            size: size,
            label: label,
            glyph: ()=>(0, (0, parcelRequire("4R6GH")).fg)('optimise_development_and_deployment_icons') ? (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 16 16",
                    width: "16",
                    height: "16",
                    fill: "none"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    d: "M0 0h16v16H0z",
                    fillOpacity: "0"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("mask", {
                    id: "a",
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                    d: "M3.8 12.9a3.2 3.2 0 0 1-.5-6.2 4.9 4.9 0 0 1 9.4 0 3.2 3.2 0 0 1-.5 6.2H3.8Z",
                    clipRule: "evenodd",
                    fillRule: "evenodd"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                    d: "M3.8 12.9h1.5v-1.4L4 11.4l-.2 1.5Zm-.5-6.2.4 1.5.8-.3.2-.8-1.4-.4Zm9.4 0-1.4.4.2.8.8.3.4-1.5Zm-.5 6.2-.2-1.5-1.3.1V13h1.5Zm0 0v1.5h1.5v-1.5h-1.5Zm-8.4 0H2.3v1.5h1.5v-1.5Zm.2-1.5c-.9-.1-1.5-.8-1.5-1.7h-3c0 2.4 1.8 4.4 4.1 4.7l.4-3ZM2.5 9.7c0-.7.5-1.3 1.2-1.5l-.9-3C1 5.9-.5 7.7-.5 9.8h3Zm2.2-2.6A3.4 3.4 0 0 1 8 4.6v-3c-3 0-5.4 2-6.2 4.7l3 .8ZM8 4.6c1.6 0 2.9 1 3.3 2.5l2.9-.8A6.4 6.4 0 0 0 8 1.6v3Zm4.3 3.6c.7.2 1.2.8 1.2 1.5h3c0-2-1.4-3.9-3.3-4.4l-.9 2.9Zm1.2 1.5c0 .9-.6 1.6-1.5 1.7l.4 3a4.7 4.7 0 0 0 4.1-4.7h-3ZM10.7 13h3-3Zm1.5-1.5H3.8v3h8.4v-3Zm-6.9 1.5h-3 3Z",
                    mask: "url(#a)"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                    d: "M6.8 7.9 7 8l.6.6L9 7.2a.6.6 0 1 1 .8.8L8 9.8a.6.6 0 0 1-.8 0l-1-1a.6.6 0 0 1 .6-1Z"
                })) : (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "16",
                    height: "16",
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    fillOpacity: "0.01"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("mask", {
                    id: "path-1-inside-1_81_24007",
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.80003 12.8808C2.22503 12.7067 1 11.3714 1 9.74998C1 8.31663 1.95735 7.10688 3.2675 6.72527C3.82855 4.63713 5.73479 3.09998 8.00006 3.09998C10.2653 3.09998 12.1716 4.63715 12.7326 6.72531C14.0427 7.10697 15 8.31668 15 9.74998C15 11.3713 13.775 12.7066 12.2 12.8807V12.9H3.80003V12.8808Z"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "M3.80003 12.8808H5.30003V11.5374L3.96483 11.3898L3.80003 12.8808ZM3.2675 6.72527L3.68698 8.16542L4.49716 7.92944L4.71613 7.11449L3.2675 6.72527ZM12.7326 6.72531L11.284 7.11452L11.5029 7.92943L12.3131 8.16544L12.7326 6.72531ZM12.2 12.8807L12.0352 11.3898L10.7 11.5374V12.8807H12.2ZM12.2 12.9V14.4H13.7V12.9H12.2ZM3.80003 12.9H2.30003V14.4H3.80003V12.9ZM3.96483 11.3898C3.14142 11.2988 2.5 10.5983 2.5 9.74998H-0.5C-0.5 12.1445 1.30864 14.1145 3.63523 14.3717L3.96483 11.3898ZM2.5 9.74998C2.5 9.00137 2.99976 8.36559 3.68698 8.16542L2.84803 5.28511C0.914937 5.84817 -0.5 7.63188 -0.5 9.74998H2.5ZM4.71613 7.11449C5.10556 5.66505 6.43035 4.59998 8.00006 4.59998V1.59998C5.03923 1.59998 2.55153 3.60922 1.81888 6.33605L4.71613 7.11449ZM8.00006 4.59998C9.56978 4.59998 10.8946 5.66506 11.284 7.11452L14.1812 6.33611C13.4486 3.60925 10.9609 1.59998 8.00006 1.59998V4.59998ZM12.3131 8.16544C13.0003 8.36564 13.5 9.0014 13.5 9.74998H16.5C16.5 7.63196 15.0851 5.8483 13.1522 5.28518L12.3131 8.16544ZM13.5 9.74998C13.5 10.5983 12.8586 11.2988 12.0352 11.3898L12.3649 14.3717C14.6914 14.1144 16.5 12.1444 16.5 9.74998H13.5ZM10.7 12.8807V12.9H13.7V12.8807H10.7ZM12.2 11.4H3.80003V14.4H12.2V11.4ZM5.30003 12.9V12.8808H2.30003V12.9H5.30003Z",
                    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
                    mask: "url(#path-1-inside-1_81_24007)"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "M6.81117 7.86961C6.88213 7.90009 6.94631 7.9444 6.99996 7.99995L7.58877 8.58871L9.00004 7.17757C9.05369 7.12202 9.11787 7.07771 9.18883 7.04723C9.25979 7.01674 9.33611 7.0007 9.41333 7.00003C9.49056 6.99936 9.56715 7.01407 9.63862 7.04332C9.7101 7.07256 9.77504 7.11575 9.82965 7.17036C9.88426 7.22497 9.92745 7.28991 9.95669 7.36138C9.98593 7.43286 10.0006 7.50945 9.99998 7.58667C9.99931 7.6639 9.98326 7.74022 9.95278 7.81118C9.9223 7.88214 9.87799 7.94632 9.82244 7.99997L7.99997 9.82231C7.8909 9.93135 7.74299 9.9926 7.58877 9.9926C7.43454 9.9926 7.28663 9.93135 7.17757 9.82231L6.17756 8.82235C6.12201 8.7687 6.0777 8.70452 6.04722 8.63356C6.01674 8.5626 6.00069 8.48628 6.00002 8.40906C5.99935 8.33183 6.01407 8.25525 6.04331 8.18377C6.07255 8.11229 6.11574 8.04735 6.17035 7.99274C6.22496 7.93813 6.2899 7.89495 6.36138 7.8657C6.43285 7.83646 6.50944 7.82174 6.58667 7.82241C6.66389 7.82308 6.74021 7.83913 6.81117 7.86961Z",
                    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
                }))
        });
    const $7a25946f9b14c935$export$22f2b1620b38359 = ({ size: size, label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            size: size,
            label: label,
            glyph: ()=>(0, (0, parcelRequire("4R6GH")).fg)('optimise_development_and_deployment_icons') ? (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 16 16",
                    width: "16",
                    height: "16",
                    fill: "none"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    d: "M0 0h16v16H0z",
                    fillOpacity: ".01"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                    d: "M3.8 12.88a3.15 3.15 0 0 1-.53-6.15 4.9 4.9 0 0 1 9.46 0 3.15 3.15 0 0 1-.53 6.15v.02H3.8v-.02Zm3.55-6.63a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-1.5 0v-2ZM8.1 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z",
                    clipRule: "evenodd",
                    fillRule: "evenodd"
                })) : (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "16",
                    height: "16",
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    fillOpacity: "0.01"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.80003 12.8808C2.22503 12.7067 1 11.3714 1 9.74998C1 8.31663 1.95735 7.10688 3.2675 6.72527C3.82855 4.63713 5.73479 3.09998 8.00006 3.09998C10.2653 3.09998 12.1716 4.63715 12.7326 6.72531C14.0427 7.10697 15 8.31668 15 9.74998C15 11.3713 13.775 12.7066 12.2 12.8807V12.9H3.80003V12.8808ZM7.35 6.25C7.35 5.83579 7.68579 5.5 8.1 5.5C8.51421 5.5 8.85 5.83579 8.85 6.25V8.25C8.85 8.66421 8.51421 9 8.1 9C7.68579 9 7.35 8.66421 7.35 8.25V6.25ZM8.1 9.5C7.68579 9.5 7.35 9.83579 7.35 10.25C7.35 10.6642 7.68579 11 8.1 11C8.51421 11 8.85 10.6642 8.85 10.25C8.85 9.83579 8.51421 9.5 8.1 9.5Z",
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
                }))
        });
    const $7a25946f9b14c935$export$5b461fe0712c5c45 = ({ size: size, label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            size: size,
            label: label,
            glyph: ()=>(0, (0, parcelRequire("4R6GH")).fg)('optimise_development_and_deployment_icons') ? (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 16 16",
                    width: "16",
                    height: "16",
                    fill: "none"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    d: "M0 0h16v16H0z",
                    fillOpacity: "0"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("mask", {
                    id: "a",
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                    d: "M3.8 12.9a3.2 3.2 0 0 1-.5-6.2 4.9 4.9 0 0 1 9.4 0 3.2 3.2 0 0 1-.5 6.2H3.8Z",
                    clipRule: "evenodd",
                    fillRule: "evenodd"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                    d: "M3.8 12.9h1.5v-1.4L4 11.4l-.2 1.5Zm-.5-6.2.4 1.5.8-.3.2-.8-1.4-.4Zm9.4 0-1.4.4.2.8.8.3.4-1.5Zm-.5 6.2-.2-1.5-1.3.1V13h1.5Zm0 0v1.5h1.5v-1.5h-1.5Zm-8.4 0H2.3v1.5h1.5v-1.5Zm.2-1.5c-.9-.1-1.5-.8-1.5-1.7h-3c0 2.4 1.8 4.4 4.1 4.7l.4-3ZM2.5 9.7c0-.7.5-1.3 1.2-1.5l-.9-3C1 5.9-.5 7.7-.5 9.8h3Zm2.2-2.6A3.4 3.4 0 0 1 8 4.6v-3c-3 0-5.4 2-6.2 4.7l3 .8ZM8 4.6c1.6 0 2.9 1 3.3 2.5l2.9-.8A6.4 6.4 0 0 0 8 1.6v3Zm4.3 3.6c.7.2 1.2.8 1.2 1.5h3c0-2-1.4-3.9-3.3-4.4l-.9 2.9Zm1.2 1.5c0 .9-.6 1.6-1.5 1.7l.4 3a4.7 4.7 0 0 0 4.1-4.7h-3ZM10.7 13h3-3Zm1.5-1.5H3.8v3h8.4v-3Zm-6.9 1.5h-3 3Z",
                    mask: "url(#a)"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "1.5",
                    height: "3.5",
                    x: "7.4",
                    y: "5.5",
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                    rx: ".8"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "1.5",
                    height: "1.5",
                    x: "7.4",
                    y: "9.5",
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                    rx: ".8"
                })) : (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "16",
                    height: "16",
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    fillOpacity: "0.01"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("mask", {
                    id: "path-1-inside-1_91_14760",
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                    d: "M3.80003 12.8808C2.22503 12.7067 1 11.3714 1 9.74998C1 8.31663 1.95735 7.10688 3.2675 6.72527C3.82855 4.63713 5.73479 3.09998 8.00006 3.09998C10.2653 3.09998 12.1716 4.63715 12.7326 6.72531C14.0427 7.10697 15 8.31668 15 9.74998C15 11.3713 13.775 12.7066 12.2 12.8807V12.9H3.80003V12.8808Z"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    d: "M3.80003 12.8808H5.30003V11.5374L3.96483 11.3898L3.80003 12.8808ZM3.2675 6.72527L3.68698 8.16542L4.49716 7.92944L4.71613 7.11449L3.2675 6.72527ZM12.7326 6.72531L11.284 7.11452L11.5029 7.92943L12.3131 8.16544L12.7326 6.72531ZM12.2 12.8807L12.0352 11.3898L10.7 11.5374V12.8807H12.2ZM12.2 12.9V14.4H13.7V12.9H12.2ZM3.80003 12.9H2.30003V14.4H3.80003V12.9ZM3.96483 11.3898C3.14142 11.2988 2.5 10.5983 2.5 9.74998H-0.5C-0.5 12.1445 1.30864 14.1145 3.63523 14.3717L3.96483 11.3898ZM2.5 9.74998C2.5 9.00137 2.99976 8.36559 3.68698 8.16542L2.84803 5.28511C0.914937 5.84817 -0.5 7.63188 -0.5 9.74998H2.5ZM4.71613 7.11449C5.10556 5.66505 6.43035 4.59998 8.00006 4.59998V1.59998C5.03923 1.59998 2.55153 3.60922 1.81888 6.33605L4.71613 7.11449ZM8.00006 4.59998C9.56978 4.59998 10.8946 5.66506 11.284 7.11452L14.1812 6.33611C13.4486 3.60925 10.9609 1.59998 8.00006 1.59998V4.59998ZM12.3131 8.16544C13.0003 8.36564 13.5 9.0014 13.5 9.74998H16.5C16.5 7.63196 15.0851 5.8483 13.1522 5.28518L12.3131 8.16544ZM13.5 9.74998C13.5 10.5983 12.8586 11.2988 12.0352 11.3898L12.3649 14.3717C14.6914 14.1144 16.5 12.1444 16.5 9.74998H13.5ZM10.7 12.8807V12.9H13.7V12.8807H10.7ZM12.2 11.4H3.80003V14.4H12.2V11.4ZM5.30003 12.9V12.8808H2.30003V12.9H5.30003Z",
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
                    mask: "url(#path-1-inside-1_91_14760)"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: "7.3501",
                    y: "5.5",
                    width: "1.5",
                    height: "3.5",
                    rx: "0.75",
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    x: "7.3501",
                    y: "9.5",
                    width: "1.5",
                    height: "1.5",
                    rx: "0.75",
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
                }))
        });
});
parcelRegister("47gW9", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointButtonTrigger", ()=>$1be876415a945060$export$25d2524a63315ed);
    $parcel$export(module.exports, "getDefaultEntrypointActionEventMap", ()=>$1be876415a945060$export$5f13515bd3a35325);
    var $5uXOq = parcelRequire("5uXOq");
    var $iRKpN;
    const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap = $1be876415a945060$export$5f13515bd3a35325(actions))=>{
        const removePreviousListeners = (0, $5uXOq.useRef)(null);
        const isMounted = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>()=>{
                removePreviousListeners.current?.();
                removePreviousListeners.current = null;
                isMounted.current = false;
            }, []);
        return (0, $5uXOq.useCallback)((element)=>{
            if (!isMounted.current) return;
            removePreviousListeners.current?.();
            if (element && isActive) {
                (0, (0, parcelRequire("iRKpN")).modifyListeners)({
                    element: element,
                    operationName: 'add',
                    eventMap: eventMap
                });
                removePreviousListeners.current = ()=>{
                    (0, (0, parcelRequire("iRKpN")).modifyListeners)({
                        element: element,
                        operationName: 'remove',
                        eventMap: eventMap
                    });
                };
            } else removePreviousListeners.current = null;
        }, [
            eventMap,
            isActive
        ]);
    };
    const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
            click: actions.load,
            mouseenter: actions.preload,
            mouseleave: actions.cancelPreload,
            focusin: actions.preload,
            focusout: actions.cancelPreload
        });
});
parcelRegister("iRKpN", function(module, exports) {
    $parcel$export(module.exports, "modifyListeners", ()=>$62bae43418420b8a$export$15257a36a7e3f9d6);
    function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
        const { element: element, operationName: operationName, eventMap: eventMap } = params;
        const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
        if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
    }
});
parcelRegister("lXSZ8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bacacc98904ab4af$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $bacacc98904ab4af$var$DesignIconSVG = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "currentcolor",
            d: "M9.864 10.736c.77-.746 1.893-.536 2.72.265.826.8 1.043 1.888.273 2.634-1.816 1.76-5.482 2.002-4.765 1.207 1.587-1.76.578-2.949 1.772-4.106M19.968 4.03c.402.378-3.1 4.732-4.427 5.98-.659.62-1.012.826-1.276 1.016-.115.082-.15-.027-.177-.076a3.7 3.7 0 0 0-.63-.801c-.236-.222-.607-.445-.867-.572-.053-.025-.169-.058-.08-.166.201-.249.421-.58 1.08-1.2 1.327-1.247 5.974-4.56 6.377-4.181M18.38 19.946a1 1 0 0 1-.332.054.95.95 0 0 1-.913-.628c-.343-.957-1.14-1.642-2.257-1.933-2.182-.568-3.22-.264-5.053.995l-.16.11a9 9 0 0 1-1.049.644c-1.477.755-2.632.825-3.482.419-.586-.28-.989-.794-1.1-1.407-.254-1.403.93-2.647 2.602-3.156a.906.906 0 0 1 1.155.601.92.92 0 0 1-.62 1.186c-.33.1-.717.311-.978.533-.195.165-.33.355-.306.434.042.138.088.185.16.214.155.063.445.029.818-.096q.247-.083.524-.21c.196-.088.348-.165.58-.287.076-.04.177-.11.445-.303 1.09-.784 1.802-1.198 2.845-1.52 1.562-.482 3.18-.39 4.802.272 1.399.57 2.399 1.589 2.883 2.94.174.483-.07.97-.564 1.138"
        }));
    const $bacacc98904ab4af$var$DesignIcon = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            ...props,
            glyph: $bacacc98904ab4af$var$DesignIconSVG
        });
    var $bacacc98904ab4af$export$2e2bcd8739ae039 = $bacacc98904ab4af$var$DesignIcon;
});
parcelRegister("7IEKg", function(module, exports) {
    $parcel$export(module.exports, "designModalEntryPoint", ()=>$1a95bcb1a4c0b956$export$b98395a806b85a49);
    var $69fJl;
    var $eufEc;
    var $fEDBv;
    const $1a95bcb1a4c0b956$export$b98395a806b85a49 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("j0MGN")), {
            moduleId: "576d28f0"
        }),
        getPreloadProps: ({ siteAri: siteAri, issueAri: issueAri, cloudId: cloudId, designAri: designAri })=>({
                queries: {
                    designModal: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: (0, (0, parcelRequire("69fJl")).default),
                        variables: {
                            siteAri: siteAri,
                            issueAri: issueAri,
                            cloudId: cloudId,
                            designAri: designAri
                        }
                    }
                }
            })
    });
});
parcelRegister("69fJl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c20e9923143cad3f$export$2e2bcd8739ae039);
    const $c20e9923143cad3f$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "5455aa42cc5ba971a154b4555e76f70cb6faf70a0f41a193d62856efb789841b",
            "metadata": {},
            "name": "ui_DesignModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $c20e9923143cad3f$export$2e2bcd8739ae039 = $c20e9923143cad3f$var$node;
});
parcelRegister("j0MGN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ddPfp")
    ]).then(()=>parcelRequire('ebk7x'));
});
parcelRegister("a3HWu", function(module, exports) {
    $parcel$export(module.exports, "DevInfoDetailsPopupSkeleton", ()=>$93f34a824a74f869$export$9044eba4855892a5);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $kfBZt = parcelRequire("kfBZt");
    var $if4PE = parcelRequire("if4PE");
    var $gVTPk = parcelRequire("gVTPk");
    var $i2tpm = parcelRequire("i2tpm");
    var $5swzJ = parcelRequire("5swzJ");
    const $93f34a824a74f869$var$customCssStyles = null;
    const $93f34a824a74f869$var$skeletonStyles = null;
    const $93f34a824a74f869$export$ae7439e01588d047 = {
        BRANCH: 'branch',
        COMMIT: 'commit',
        PULLREQUEST: 'pullrequest',
        DEPLOYMENT: 'deployment',
        DESIGN: 'design'
    };
    const $93f34a824a74f869$var$skeletonAsset = {
        [$93f34a824a74f869$export$ae7439e01588d047.BRANCH]: (0, ($parcel$interopDefault($kfBZt))),
        [$93f34a824a74f869$export$ae7439e01588d047.COMMIT]: (0, ($parcel$interopDefault($if4PE))),
        [$93f34a824a74f869$export$ae7439e01588d047.PULLREQUEST]: (0, ($parcel$interopDefault($5swzJ))),
        [$93f34a824a74f869$export$ae7439e01588d047.DEPLOYMENT]: (0, ($parcel$interopDefault($gVTPk))),
        [$93f34a824a74f869$export$ae7439e01588d047.DESIGN]: (0, ($parcel$interopDefault($i2tpm)))
    };
    const $93f34a824a74f869$export$9044eba4855892a5 = ({ devinfoType: devinfoType })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                devinfoType === $93f34a824a74f869$export$ae7439e01588d047.BRANCH && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi",
                devinfoType === $93f34a824a74f869$export$ae7439e01588d047.COMMIT && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi",
                devinfoType === $93f34a824a74f869$export$ae7439e01588d047.PULLREQUEST && "_1bsbnklw _1yt41lhn _vchhusvi _4t3imgvx",
                devinfoType === $93f34a824a74f869$export$ae7439e01588d047.DEPLOYMENT && "_1bsbnklw _4t3i1lit",
                devinfoType === $93f34a824a74f869$export$ae7439e01588d047.DESIGN && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: $93f34a824a74f869$var$skeletonAsset[devinfoType],
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw _rcujmgjw"
            ])
        }));
});
parcelRegister("kfBZt", function(module, exports) {
    module.exports = new URL("branch-details-popup.tpl.90980aef.svg", import.meta.url).toString();
});
parcelRegister("if4PE", function(module, exports) {
    module.exports = new URL("commit-details-popup.tpl.ef7b25c8.svg", import.meta.url).toString();
});
parcelRegister("gVTPk", function(module, exports) {
    module.exports = new URL("deployment-details-popup.tpl.d0e045e6.svg", import.meta.url).toString();
});
parcelRegister("i2tpm", function(module, exports) {
    module.exports = new URL("design-details-popup.tpl.da785a24.svg", import.meta.url).toString();
});
parcelRegister("5swzJ", function(module, exports) {
    module.exports = new URL("pr-details-popup.tpl.2fd71422.svg", import.meta.url).toString();
});
parcelRegister("gicL9", function(module, exports) {
    $parcel$export(module.exports, "HOVER_TIMEOUT_MS", ()=>$045105c41d1dfec6$export$bbec45119b804b4d);
    $parcel$export(module.exports, "DevInfoButtonLabelMapping", ()=>$045105c41d1dfec6$export$41f3316f17440396);
    $parcel$export(module.exports, "iconColor", ()=>$045105c41d1dfec6$export$3797a580396e3639);
    $parcel$export(module.exports, "experienceDetails", ()=>$045105c41d1dfec6$export$ba2604b0fdde2542);
    $parcel$export(module.exports, "metrics", ()=>$045105c41d1dfec6$export$b0c5c2fac8144e54);
    $parcel$export(module.exports, "packageDetails", ()=>$045105c41d1dfec6$export$48b44d9f3c6e15de);
    $parcel$export(module.exports, "popupEntryPoints", ()=>$045105c41d1dfec6$export$1452632269dce6);
    $parcel$export(module.exports, "DeploymentState", ()=>$045105c41d1dfec6$export$a12a01ce2571070a);
    $parcel$export(module.exports, "DeploymentEnvironment", ()=>$045105c41d1dfec6$export$618f130aff825d2b);
    var $8QpSo;
    var $4Dm5W;
    var $6KTxo;
    var $8YTUU;
    var $6dYOr;
    var $jH32b;
    var $890PS;
    var $4Dyci;
    var $8GnxT;
    const $045105c41d1dfec6$export$bbec45119b804b4d = 300;
    const $045105c41d1dfec6$export$41f3316f17440396 = (0, (0, parcelRequire("8QpSo")).default)((formatMessage)=>({
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).BRANCH]: formatMessage((0, (0, parcelRequire("4Dyci")).default).branchIconButtonLabel),
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT]: formatMessage((0, (0, parcelRequire("4Dyci")).default).commitIconButtonLabel),
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST]: formatMessage((0, (0, parcelRequire("4Dyci")).default).pullRequestIconButtonLabel),
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).MERGED]: formatMessage((0, (0, parcelRequire("4Dyci")).default).pullRequestIconButtonLabel),
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DECLINED]: formatMessage((0, (0, parcelRequire("4Dyci")).default).pullRequestIconButtonLabel),
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DEPLOYMENT]: formatMessage((0, (0, parcelRequire("4Dyci")).default).deploymentIconButtonLabel),
            [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DESIGN]: formatMessage((0, (0, parcelRequire("4Dyci")).default).designIconButtonLabel)
        }));
    const $045105c41d1dfec6$export$3797a580396e3639 = {
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).BRANCH]: {
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N100})`
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT]: {
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N100})`
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST]: {
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N100})`
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).MERGED]: {
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).ACTIVE]: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G200})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).HOVER]: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).DEFAULT]: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DECLINED]: {
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).ACTIVE]: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R100})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).HOVER]: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).DEFAULT]: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DEPLOYMENT]: {
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N100})`
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DESIGN]: {
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).ACTIVE]: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).HOVER]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N500})`,
            [(0, (0, parcelRequire("8YTUU")).ButtonStatus).DEFAULT]: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N100})`
        }
    };
    const $045105c41d1dfec6$export$ba2604b0fdde2542 = {
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).BRANCH]: {
            id: 'branchDetailsPopup',
            name: 'jiraSoftwareBoardBranchDetailsPopup'
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT]: {
            id: 'commitDetailsPopup',
            name: 'jiraSoftwareBoardCommitDetailsPopup'
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DEPLOYMENT]: {
            id: 'deploymentDetailsPopup',
            name: 'jiraSoftwareBoardDeploymentDetailsPopup'
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST]: {
            id: 'prDetailsPopup',
            name: 'jiraSoftwareBoardPrDetailsPopup'
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DESIGN]: {
            id: 'designDetailsPopup',
            name: 'jiraSoftwareBoardDesignDetailsPopup'
        }
    };
    const $045105c41d1dfec6$export$b0c5c2fac8144e54 = {
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).BRANCH]: (0, (0, parcelRequire("8GnxT")).branchDetailsPopupLoad),
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT]: (0, (0, parcelRequire("8GnxT")).commitDetailsPopupLoad),
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DEPLOYMENT]: (0, (0, parcelRequire("8GnxT")).deploymentDetailsPopupLoad),
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST]: (0, (0, parcelRequire("8GnxT")).prDetailsPopupLoad),
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DESIGN]: (0, (0, parcelRequire("8GnxT")).designDetailsPopupLoad)
    };
    const $045105c41d1dfec6$export$48b44d9f3c6e15de = {
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).BRANCH]: {
            id: 'renderBranchDetailsPopup',
            packageName: 'jiraDevelopmentBoardBranchDetailsPopup',
            teamName: 'fusion-isotopes'
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT]: {
            id: 'renderCommitDetailsPopup',
            packageName: 'jiraDevelopmentBoardCommitDetailsPopup',
            teamName: 'fusion-isotopes'
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DEPLOYMENT]: {
            id: 'renderDeploymentDetailsPopup',
            packageName: 'jiraDevelopmentBoardDeploymentDetailsPopup',
            teamName: 'fusion-solaris'
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST]: {
            id: 'renderPRDetailsPopup',
            packageName: 'jiraDevelopmentBoardPrDetailsPopup',
            teamName: 'fusion-isotopes'
        },
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DESIGN]: {
            id: 'renderDesignDetailsPopup',
            packageName: 'jiraDevelopmentBoardDesignDetailsPopup',
            teamName: 'helios-headcoach'
        }
    };
    const $045105c41d1dfec6$export$1452632269dce6 = {
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).BRANCH]: (0, (0, parcelRequire("4Dm5W")).branchDetailsEntryPoint),
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT]: (0, (0, parcelRequire("6KTxo")).commitDetailsEntryPoint),
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DEPLOYMENT]: (0, (0, parcelRequire("6dYOr")).deploymentDetailsEntryPoint),
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST]: (0, (0, parcelRequire("890PS")).pullRequestDetailsEntryPoint),
        [(0, (0, parcelRequire("8YTUU")).DevInfoTypes).DESIGN]: (0, (0, parcelRequire("jH32b")).designDetailsEntryPoint)
    };
    const $045105c41d1dfec6$export$a12a01ce2571070a = Object.freeze({
        SUCCESSFUL: 'SUCCESSFUL',
        FAILED: 'FAILED'
    });
    const $045105c41d1dfec6$export$618f130aff825d2b = Object.freeze({
        PRODUCTION: 'PRODUCTION',
        STAGING: 'STAGING',
        TESTING: 'TESTING'
    });
});
parcelRegister("4Dm5W", function(module, exports) {
    $parcel$export(module.exports, "branchDetailsEntryPoint", ()=>$36e1f5ea1b2544c9$export$4e1fb223e6b994ad);
    var $8lY7K;
    var $eufEc;
    var $fEDBv;
    const $36e1f5ea1b2544c9$export$4e1fb223e6b994ad = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("eynrL")), {
            moduleId: "24c6676c"
        }),
        getPreloadProps: ({ issueId: issueId })=>({
                queries: {
                    branchDetailsForIssue: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: (0, parcelRequire("8lY7K")).default,
                        variables: {
                            issueId: issueId
                        }
                    }
                }
            })
    });
});
parcelRegister("8lY7K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1485287fd69790ca$export$2e2bcd8739ae039);
    const $1485287fd69790ca$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "50d8c5a327ce393f92430f04532d211b7f0cc460a938b554e063e4a413b3c9b6",
            "metadata": {},
            "name": "mainJiraBoardFetchBranchDetailsForIssueQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $1485287fd69790ca$export$2e2bcd8739ae039 = $1485287fd69790ca$var$node;
});
parcelRegister("eynrL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8tdzL").then(()=>parcelRequire('93XNc'));
});
parcelRegister("6KTxo", function(module, exports) {
    $parcel$export(module.exports, "commitDetailsEntryPoint", ()=>$9842290edc643ca7$export$543707906869c79b);
    var $kmK4e;
    var $eufEc;
    var $fEDBv;
    const $9842290edc643ca7$export$543707906869c79b = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("bppAv")), {
            moduleId: "c43c4a0f"
        }),
        getPreloadProps: ({ issueId: issueId })=>({
                queries: {
                    commitDetailsForIssue: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: (0, parcelRequire("kmK4e")).default,
                        variables: {
                            issueId: issueId
                        }
                    }
                }
            })
    });
});
parcelRegister("kmK4e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1a92de7c94d3b0d$export$2e2bcd8739ae039);
    const $e1a92de7c94d3b0d$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b",
            "metadata": {},
            "name": "mainJiraBoardFetchCommitDetailsForIssueQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $e1a92de7c94d3b0d$export$2e2bcd8739ae039 = $e1a92de7c94d3b0d$var$node;
});
parcelRegister("bppAv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fxdbP").then(()=>parcelRequire('1ml2E'));
});
parcelRegister("6dYOr", function(module, exports) {
    $parcel$export(module.exports, "deploymentDetailsEntryPoint", ()=>$f735f9faccd14399$export$bb44df517ead129f);
    var $4R6GH;
    var $k022a;
    var $eufEc;
    var $fEDBv;
    const $f735f9faccd14399$export$bb44df517ead129f = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("jWRvY")), {
            moduleId: "12f43749"
        }),
        getPreloadProps: ({ issueId: issueId })=>({
                queries: {
                    deployments: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: (0, parcelRequire("k022a")).default,
                        variables: {
                            issueAris: [
                                issueId
                            ],
                            isDevOpsDataAgsMigrationOn: (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re')
                        }
                    }
                }
            })
    });
});
parcelRegister("k022a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efb931bb8db9b600$export$2e2bcd8739ae039);
    const $efb931bb8db9b600$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "45a6c6bb5a98d9a9c3dbcd9f289262fb7d192b97d36ffaa9a2819f875e9e95f4",
            "metadata": {},
            "name": "uiDevOpsBoardQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $efb931bb8db9b600$export$2e2bcd8739ae039 = $efb931bb8db9b600$var$node;
});
parcelRegister("jWRvY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jOGOe").then(()=>parcelRequire('asD4H'));
});
parcelRegister("jH32b", function(module, exports) {
    $parcel$export(module.exports, "designDetailsEntryPoint", ()=>$4f00e6184ecff192$export$9b838851ea165d28);
    var $cN09Q;
    var $eufEc;
    var $fEDBv;
    const $4f00e6184ecff192$export$9b838851ea165d28 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("fqjFw")), {
            moduleId: "b9d22806"
        }),
        getPreloadProps: ({ issueId: issueId })=>({
                queries: {
                    designDetailsPopup: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: (0, parcelRequire("cN09Q")).default,
                        variables: {
                            issueAri: issueId
                        }
                    }
                }
            })
    });
});
parcelRegister("cN09Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37545b8a0156af47$export$2e2bcd8739ae039);
    const $37545b8a0156af47$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "f1f10befcdb537dd4ab4ac9c44e5edcb51d6b3f4306fd285cc82de529ebae8db",
            "metadata": {},
            "name": "uiDesignDetailsPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $37545b8a0156af47$export$2e2bcd8739ae039 = $37545b8a0156af47$var$node;
});
parcelRegister("fqjFw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5vjTk").then(()=>parcelRequire('9bEVC'));
});
parcelRegister("890PS", function(module, exports) {
    $parcel$export(module.exports, "pullRequestDetailsEntryPoint", ()=>$0896cca9b8d893af$export$37ab544e7066c095);
    var $5E8Mw;
    var $eufEc;
    var $fEDBv;
    const $0896cca9b8d893af$export$37ab544e7066c095 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("fRRC0")), {
            moduleId: "1b74db53"
        }),
        getPreloadProps: ({ issueId: issueId })=>({
                queries: {
                    pullRequestDetailsForIssue: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: (0, parcelRequire("5E8Mw")).default,
                        variables: {
                            issueId: issueId
                        }
                    }
                }
            })
    });
});
parcelRegister("5E8Mw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a4d40ac042e33e2$export$2e2bcd8739ae039);
    const $6a4d40ac042e33e2$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0",
            "metadata": {},
            "name": "mainJiraBoardFetchPullRequestDetailsForIssueQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $6a4d40ac042e33e2$export$2e2bcd8739ae039 = $6a4d40ac042e33e2$var$node;
});
parcelRegister("fRRC0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("98n7j")
    ]).then(()=>parcelRequire('cnLAn'));
});
parcelRegister("4Dyci", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$436dc0db7ef24cd0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $436dc0db7ef24cd0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        branchIconLabel: {
            "id": "development-board-dev-info-icon.branch-icon-label",
            "defaultMessage": "branch"
        },
        commitIconLabel: {
            "id": "development-board-dev-info-icon.commit-icon-label",
            "defaultMessage": "commit"
        },
        designIconLabel: {
            "id": "development-board-dev-info-icon.design-icon-label",
            "defaultMessage": "Linked design data"
        },
        deploymentIconLabel: {
            "id": "development-board-dev-info-icon.deployment-icon-label",
            "defaultMessage": "Linked deployment data."
        },
        deploymentProductionSuccessIconLabel: {
            "id": "development-board-dev-info-icon.deployment-production-success-icon-label",
            "defaultMessage": "Successful deployment to production."
        },
        deploymentProductionFailedIconLabel: {
            "id": "development-board-dev-info-icon.deployment-production-failed-icon-label",
            "defaultMessage": "Failed deployment to production."
        },
        deploymentNonProductionSuccessIconLabel: {
            "id": "development-board-dev-info-icon.deployment-non-production-success-icon-label",
            "defaultMessage": "Successful deployment to non-production environment."
        },
        deploymentNonProductionFailedIconLabel: {
            "id": "development-board-dev-info-icon.deployment-non-production-failed-icon-label",
            "defaultMessage": "Failed deployment to non-production environment."
        },
        openPullRequestIconLabel: {
            "id": "development-board-dev-info-icon.open-pull-request-icon-label",
            "defaultMessage": "pull request"
        },
        mergedPullRequestIconLabel: {
            "id": "development-board-dev-info-icon.merged-pull-request-icon-label",
            "defaultMessage": "merged pull request"
        },
        declinedPullRequestIconLabel: {
            "id": "development-board-dev-info-icon.declined-pull-request-icon-label",
            "defaultMessage": "declined pull request"
        },
        branchIconButtonLabel: {
            "id": "development-board-dev-info-icon.branch-icon-button-label",
            "defaultMessage": "Select to open branch details."
        },
        commitIconButtonLabel: {
            "id": "development-board-dev-info-icon.commit-icon-button-label",
            "defaultMessage": "Select to open commit details."
        },
        pullRequestIconButtonLabel: {
            "id": "development-board-dev-info-icon.pull-request-icon-button-label",
            "defaultMessage": "Select to open pull request details."
        },
        deploymentIconButtonLabel: {
            "id": "development-board-dev-info-icon.deployment-icon-button-label",
            "defaultMessage": "Select to open deployment details."
        },
        designIconButtonLabel: {
            "id": "development-board-dev-info-icon.design-icon-button-label",
            "defaultMessage": "Select to open design details."
        }
    });
});
parcelRegister("8GnxT", function(module, exports) {
    $parcel$export(module.exports, "branchDetailsPopupLoad", ()=>$a8d6a72aae83d56f$export$1e45f095e94fd8a);
    $parcel$export(module.exports, "commitDetailsPopupLoad", ()=>$a8d6a72aae83d56f$export$e3af05dcf8f03d06);
    $parcel$export(module.exports, "deploymentDetailsPopupLoad", ()=>$a8d6a72aae83d56f$export$205c7cad3de97a2);
    $parcel$export(module.exports, "prDetailsPopupLoad", ()=>$a8d6a72aae83d56f$export$3ca761127f6f2822);
    $parcel$export(module.exports, "designDetailsPopupLoad", ()=>$a8d6a72aae83d56f$export$935f70f8029ab734);
    var $dGrdR;
    const $a8d6a72aae83d56f$export$1e45f095e94fd8a = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'board.branch-details-popup-load'
    });
    const $a8d6a72aae83d56f$export$e3af05dcf8f03d06 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'board.commit-details-popup-load'
    });
    const $a8d6a72aae83d56f$export$205c7cad3de97a2 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'board.deployment-details-popup-load'
    });
    const $a8d6a72aae83d56f$export$3ca761127f6f2822 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'board.pr-details-popup-load'
    });
    const $a8d6a72aae83d56f$export$935f70f8029ab734 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'board.design-details-popup-load'
    });
});
parcelRegister("4ttab", function(module, exports) {
    $parcel$export(module.exports, "BambooDeploymentData", ()=>$7ad950bf4034d187$export$d73f8a5da425a8c5);
    var $6IhIi;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $btivG;
    var $3bDjY;
    var $koVbs;
    var $8zOmE;
    var $bIVgi;
    const $7ad950bf4034d187$var$MAX_DISPLAYED_ENVIRONMENTS = 3;
    const $7ad950bf4034d187$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $7ad950bf4034d187$export$d73f8a5da425a8c5 = ({ jiraIssueDevSummary: jiraIssueDevSummary, onDeploymentClicked: onDeploymentClicked })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("6IhIi")).default), jiraIssueDevSummary);
        const deployedBuilds = (data.deploymentEnvironments.overall.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED');
        const environments = deployedBuilds.filter((environment)=>environment).map((environment)=>environment.title);
        const displayedEnvironments = environments.slice(0, $7ad950bf4034d187$var$MAX_DISPLAYED_ENVIRONMENTS).join(', ');
        const remainingEnvironments = environments.length > $7ad950bf4034d187$var$MAX_DISPLAYED_ENVIRONMENTS ? deployedBuilds.length - $7ad950bf4034d187$var$MAX_DISPLAYED_ENVIRONMENTS : null;
        return deployedBuilds.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement($7ad950bf4034d187$var$IconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            spacing: "compact",
            appearance: "subtle-link",
            onClick: (_, analyticsEvent)=>{
                onDeploymentClicked();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'bambooSummaryCell');
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("bIVgi")).default).deployedEnvironments, {
                hasHiddenEnvironments: !!remainingEnvironments,
                displayedEnvironments: displayedEnvironments,
                othersCount: remainingEnvironments ?? 0
            }),
            onShow: (analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'bambooSummaryTooltip');
            },
            position: "bottom"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("btivG"))))), {
            size: "medium",
            label: formatMessage((0, (0, parcelRequire("bIVgi")).default).bambooDeploymentIcon),
            primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
        })))) : null;
    };
});
parcelRegister("6IhIi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f620d35ae0594d0$export$2e2bcd8739ae039);
    const $0f620d35ae0594d0$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "bambooDeploymentData_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                    "kind": "LinkedField",
                    "name": "deploymentEnvironments",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssueDeploymentEnvironment",
                                            "kind": "LinkedField",
                                            "name": "topEnvironments",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "ScalarField",
                                                        "name": "status"
                                                    },
                                                    "action": "THROW",
                                                    "path": "deploymentEnvironments.overall.topEnvironments.status"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "deploymentEnvironments.overall.topEnvironments"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "deploymentEnvironments.overall"
                        }
                    ]
                },
                "action": "THROW",
                "path": "deploymentEnvironments"
            }
        ],
        "type": "JiraIssueDevSummary"
    };
    $0f620d35ae0594d0$var$node.hash = "f1dd87aba73205d2eb34f56156e152c9";
    var $0f620d35ae0594d0$export$2e2bcd8739ae039 = $0f620d35ae0594d0$var$node;
});
parcelRegister("bIVgi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea545e3a7ecdbfcf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ea545e3a7ecdbfcf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        bambooDeploymentIcon: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.bamboo-deployment-data.bamboo-deployment-icon",
            "defaultMessage": "Bamboo deployment icon"
        },
        deployedEnvironments: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.bamboo-deployment-data.deployed-environments",
            "defaultMessage": "{hasHiddenEnvironments, select, false {Deployed to {displayedEnvironments}} other {Deployed to {displayedEnvironments} and {othersCount, number} {othersCount, plural, one {other} other {others}}}}"
        }
    });
});
parcelRegister("aEu2z", function(module, exports) {
    $parcel$export(module.exports, "BuildData", ()=>$cf9c8b4d8385b371$export$c35480212824a8c6);
    var $kvOAm;
    var $ekgtZ;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $btivG;
    var $d5Zn3;
    var $eJS47;
    var $3bDjY;
    var $koVbs;
    var $8zOmE;
    var $ifjZR;
    const $cf9c8b4d8385b371$export$be58b4326e23250f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $cf9c8b4d8385b371$export$c35480212824a8c6 = ({ jiraIssueDevSummary: jiraIssueDevSummary, devOpsSummarisedBuilds: devOpsSummarisedBuilds, onBuildClicked: onBuildClicked })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const appLinkBuildData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("ekgtZ")).default), jiraIssueDevSummary);
        const nonAppLinkBuildData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("kvOAm")).default), devOpsSummarisedBuilds ?? null);
        const { failedBuildCount: failedBuildCountAppLink, successfulBuildCount: successfulBuildCountAppLink, unknownBuildCount: unknownBuildCountAppLink } = appLinkBuildData.build.overall;
        const buildStates = nonAppLinkBuildData?.buildStates ?? [];
        const failedBuildCountNonAppLink = buildStates.find((buildState)=>buildState?.state === 'FAILED')?.count ?? 0;
        const successfulBuildCountNonAppLink = buildStates.find((buildState)=>buildState?.state === 'SUCCESSFUL')?.count ?? 0;
        const unknownBuildCountNonAppLink = buildStates.find((buildState)=>buildState?.state === 'UNKNOWN')?.count ?? 0;
        const failedBuildCount = failedBuildCountAppLink + failedBuildCountNonAppLink;
        const successfulBuildCount = successfulBuildCountAppLink + successfulBuildCountNonAppLink;
        const unknownBuildCount = unknownBuildCountAppLink + unknownBuildCountNonAppLink;
        const hasBuilds = failedBuildCount + successfulBuildCount + unknownBuildCount > 0;
        const renderIcon = ()=>{
            if (failedBuildCount > 0) {
                const failedBuildMessage = formatMessage((0, (0, parcelRequire("ifjZR")).default).failedBuild, {
                    buildCount: failedBuildCount
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: failedBuildMessage
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("d5Zn3"))))), {
                    size: "medium",
                    label: failedBuildMessage,
                    primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
                }));
            }
            if (successfulBuildCount > 0) {
                const successfulBuildMessage = formatMessage((0, (0, parcelRequire("ifjZR")).default).successfulBuild, {
                    buildCount: successfulBuildCount
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: successfulBuildMessage
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("btivG"))))), {
                    size: "medium",
                    label: successfulBuildMessage,
                    primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
                }));
            }
            if (unknownBuildCount > 0) {
                const unknownBuildMessage = formatMessage((0, (0, parcelRequire("ifjZR")).default).unknownBuild, {
                    buildCount: unknownBuildCount
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    content: unknownBuildMessage
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))), {
                    size: "medium",
                    label: unknownBuildMessage,
                    primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y300})`
                }));
            }
            return null;
        };
        return hasBuilds ? (0, ($parcel$interopDefault($5uXOq))).createElement($cf9c8b4d8385b371$export$be58b4326e23250f, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            spacing: "none",
            appearance: "subtle-link",
            onClick: (_, analyticsEvent)=>{
                onBuildClicked();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionsBuildsLozenge');
            }
        }, renderIcon())) : null;
    };
});
parcelRegister("kvOAm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d83768d9b8777867$export$2e2bcd8739ae039);
    const $d83768d9b8777867$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "buildData_softwareReleasesVersionDetailIssueList_devOpsSummarisedBuilds",
        "selections": [
            {
                "concreteType": "DevOpsSummarisedBuildState",
                "kind": "LinkedField",
                "name": "buildStates",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "state"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    }
                ]
            }
        ],
        "type": "DevOpsSummarisedBuilds"
    };
    $d83768d9b8777867$var$node.hash = "dd56ce5fd7d57ba00bf945a310710b23";
    var $d83768d9b8777867$export$2e2bcd8739ae039 = $d83768d9b8777867$var$node;
});
parcelRegister("ekgtZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fac064913ac614a7$export$2e2bcd8739ae039);
    const $fac064913ac614a7$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "buildData_softwareReleasesVersionDetailIssueList_jiraIssueDevSummary",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                    "kind": "LinkedField",
                    "name": "build",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueBuildDevSummary",
                                "kind": "LinkedField",
                                "name": "overall",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "ScalarField",
                                            "name": "failedBuildCount"
                                        },
                                        "action": "THROW",
                                        "path": "build.overall.failedBuildCount"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "ScalarField",
                                            "name": "successfulBuildCount"
                                        },
                                        "action": "THROW",
                                        "path": "build.overall.successfulBuildCount"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "ScalarField",
                                            "name": "unknownBuildCount"
                                        },
                                        "action": "THROW",
                                        "path": "build.overall.unknownBuildCount"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "build.overall"
                        }
                    ]
                },
                "action": "THROW",
                "path": "build"
            }
        ],
        "type": "JiraIssueDevSummary"
    };
    $fac064913ac614a7$var$node.hash = "51c2585ef90bb27a6d71bf4d7670a32b";
    var $fac064913ac614a7$export$2e2bcd8739ae039 = $fac064913ac614a7$var$node;
});
parcelRegister("d5Zn3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $988b58f36f60a149$var$_react = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $988b58f36f60a149$var$_crossCircle = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $988b58f36f60a149$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $988b58f36f60a149$var$CrossCircleIcon = (props)=>$988b58f36f60a149$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
        }, props, {
            newIcon: $988b58f36f60a149$var$_crossCircle.default
        }));
    $988b58f36f60a149$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $988b58f36f60a149$var$_default = module.exports.default = $988b58f36f60a149$var$CrossCircleIcon;
});
parcelRegister("ifjZR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0b346816c77ac1fc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0b346816c77ac1fc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        successfulBuild: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.build-data.successful-build",
            "defaultMessage": "{buildCount} successful {buildCount, plural, one {build} other {builds}}"
        },
        failedBuild: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.build-data.failed-build",
            "defaultMessage": "{buildCount} failed {buildCount, plural, one {build} other {builds}}"
        },
        unknownBuild: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.build-data.unknown-build",
            "defaultMessage": "{buildCount} unknown state {buildCount, plural, one {build} other {builds}}"
        }
    });
});
parcelRegister("916hF", function(module, exports) {
    $parcel$export(module.exports, "DeploymentData", ()=>$da9b384ac1708a2f$export$b2b8032dce325acb);
    var $jL3EI;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $koVbs;
    var $8zOmE;
    var $lSCyP;
    var $lfyVj;
    const $da9b384ac1708a2f$var$mapEnvironmentCategory = (category, formatMessage)=>{
        switch(category){
            case 'PRODUCTION':
                return formatMessage((0, (0, parcelRequire("lSCyP")).default).production);
            case 'STAGING':
                return formatMessage((0, (0, parcelRequire("lSCyP")).default).staging);
            case 'TESTING':
                return formatMessage((0, (0, parcelRequire("lSCyP")).default).testing);
            case 'DEVELOPMENT':
                return formatMessage((0, (0, parcelRequire("lSCyP")).default).development);
            case 'UNMAPPED':
                return formatMessage((0, (0, parcelRequire("lSCyP")).default).unmapped);
            default:
                return formatMessage((0, (0, parcelRequire("lSCyP")).default).unmapped);
        }
    };
    const $da9b384ac1708a2f$export$b2b8032dce325acb = ({ onDeploymentClicked: onDeploymentClicked, jiraIssueDevOpsSummarisedEntities: jiraIssueSummarisedEntities })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { summarisedDeployments: summarisedDeployments } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("jL3EI")).default), jiraIssueSummarisedEntities);
        if (summarisedDeployments == null) return null;
        const category = summarisedDeployments.deploymentEnvironment?.category ? summarisedDeployments.deploymentEnvironment.category : 'UNMAPPED';
        return (0, ($parcel$interopDefault($5uXOq))).createElement($da9b384ac1708a2f$var$BaseContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            spacing: "none",
            appearance: "subtle-link",
            onClick: (_, analyticsEvent)=>{
                onDeploymentClicked();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'deploymentSummaryCell');
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($da9b384ac1708a2f$var$ContentsContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($da9b384ac1708a2f$var$StatusContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfyVj")).StatusIcon), {
            jiraSummarisedDeployments: summarisedDeployments
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($da9b384ac1708a2f$var$DescriptionInternalContainer, null, $da9b384ac1708a2f$var$mapEnvironmentCategory(category, formatMessage)))));
    };
    const $da9b384ac1708a2f$var$BaseContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $da9b384ac1708a2f$var$ContentsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $da9b384ac1708a2f$var$DescriptionInternalContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _1bto1l2s _1reo15vq _18m915vq _1vhi1ule _ifb4glyw",
                __cmplp.className
            ])
        });
    });
    const $da9b384ac1708a2f$var$StatusContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _syaz15i6",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jL3EI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82177fb84ac8c2dc$export$2e2bcd8739ae039);
    const $82177fb84ac8c2dc$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "deploymentData_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "concreteType": "DevOpsSummarisedDeployments",
                "kind": "LinkedField",
                "name": "summarisedDeployments",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "DevOpsEnvironment",
                        "kind": "LinkedField",
                        "name": "deploymentEnvironment",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "category"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "statusIcon_softwareReleasesVersionDetailIssueList"
                    }
                ]
            }
        ],
        "type": "DevOpsSummarisedEntities"
    };
    $82177fb84ac8c2dc$var$node.hash = "0a7623df234c698148c854c1e3a6ce8d";
    var $82177fb84ac8c2dc$export$2e2bcd8739ae039 = $82177fb84ac8c2dc$var$node;
});
parcelRegister("lSCyP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81bc2b0055ab231f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $81bc2b0055ab231f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        deploymentsTooltip: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.deployments-tooltip",
            "defaultMessage": "{deploymentCount} {deploymentCount, plural, one {deployment} other {deployments}}"
        },
        production: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.production",
            "defaultMessage": "Production"
        },
        staging: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.staging",
            "defaultMessage": "Staging"
        },
        testing: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.testing",
            "defaultMessage": "Testing"
        },
        development: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.development",
            "defaultMessage": "Development"
        },
        unmapped: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.unmapped",
            "defaultMessage": "Undefined environment"
        }
    });
});
parcelRegister("lfyVj", function(module, exports) {
    $parcel$export(module.exports, "StatusIcon", ()=>$ec1f18b42e680184$export$b131c49b26d3f427);
    var $gAldo;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $3bDjY;
    var $koVbs;
    var $gYpv9;
    var $5gD09;
    var $7ry0V;
    const $ec1f18b42e680184$var$mapState = (state, environmentType, formatMessage)=>{
        switch(state){
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).PENDING:
                return {
                    message: formatMessage((0, (0, parcelRequire("7ry0V")).default).pending),
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYpv9")).DeploymentIcons), {
                        deploymentState: (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).PENDING,
                        size: "medium"
                    })
                };
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).IN_PROGRESS:
                return {
                    message: formatMessage((0, (0, parcelRequire("7ry0V")).default).inProgress),
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYpv9")).DeploymentIcons), {
                        deploymentState: (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).IN_PROGRESS,
                        size: "medium"
                    })
                };
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).SUCCESSFUL:
                if (environmentType === 'PRODUCTION') return {
                    message: formatMessage((0, (0, parcelRequire("7ry0V")).default).successful),
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYpv9")).DeploymentIcons), {
                        deploymentState: (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).SUCCESSFUL,
                        size: "medium"
                    })
                };
                return {
                    message: formatMessage((0, (0, parcelRequire("7ry0V")).default).successful),
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYpv9")).DeploymentIcons), {
                        deploymentState: (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).SUCCESSFULNONPRODUCTION,
                        size: "medium"
                    })
                };
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).FAILED:
                return {
                    message: formatMessage((0, (0, parcelRequire("7ry0V")).default).failed),
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYpv9")).DeploymentIcons), {
                        deploymentState: (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).FAILED,
                        size: "medium"
                    })
                };
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).ROLLED_BACK:
                return {
                    message: formatMessage((0, (0, parcelRequire("7ry0V")).default).rolledBack),
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYpv9")).DeploymentIcons), {
                        deploymentState: (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).ROLLED_BACK,
                        size: "medium"
                    })
                };
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).CANCELLED:
                return {
                    message: formatMessage((0, (0, parcelRequire("7ry0V")).default).cancelled),
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYpv9")).DeploymentIcons), {
                        deploymentState: (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).CANCELLED,
                        size: "medium"
                    })
                };
            case (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).UNKNOWN:
                return {
                    message: formatMessage((0, (0, parcelRequire("7ry0V")).default).unknown),
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYpv9")).DeploymentIcons), {
                        deploymentState: (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).UNKNOWN,
                        size: "medium"
                    })
                };
            default:
                return {
                    message: formatMessage((0, (0, parcelRequire("7ry0V")).default).unknown),
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYpv9")).DeploymentIcons), {
                        deploymentState: (0, (0, parcelRequire("5gD09")).DeploymentStateOptions).UNKNOWN,
                        size: "medium"
                    })
                };
        }
    };
    const $ec1f18b42e680184$export$b131c49b26d3f427 = ({ jiraSummarisedDeployments: jiraSummarisedDeployments })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const deploymentSummary = (0, $8Uumt.useFragment)((0, (0, parcelRequire("gAldo")).default), jiraSummarisedDeployments);
        const state = deploymentSummary.deploymentState ? deploymentSummary.deploymentState : 'UNKNOWN';
        const environment = deploymentSummary.deploymentEnvironment?.category ? deploymentSummary.deploymentEnvironment.category : 'UNMAPPED';
        const { icon: icon, message: message } = $ec1f18b42e680184$var$mapState(state, environment, formatMessage);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: message
        }, icon);
    };
});
parcelRegister("gAldo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55c65f6062c38236$export$2e2bcd8739ae039);
    const $55c65f6062c38236$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "statusIcon_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "deploymentState"
            },
            {
                "concreteType": "DevOpsEnvironment",
                "kind": "LinkedField",
                "name": "deploymentEnvironment",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    }
                ]
            }
        ],
        "type": "DevOpsSummarisedDeployments"
    };
    $55c65f6062c38236$var$node.hash = "f151e3f42403e9b74c8517a51ce0be46";
    var $55c65f6062c38236$export$2e2bcd8739ae039 = $55c65f6062c38236$var$node;
});
parcelRegister("7ry0V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d50d6de20092c4d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3d50d6de20092c4d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        pending: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.pending",
            "defaultMessage": "Pending"
        },
        inProgress: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.in-progress",
            "defaultMessage": "In-progress"
        },
        successful: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.successful",
            "defaultMessage": "Successful"
        },
        failed: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.failed",
            "defaultMessage": "Failed"
        },
        rolledBack: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.rolled-back",
            "defaultMessage": "Rolled back"
        },
        cancelled: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.cancelled",
            "defaultMessage": "Canceled"
        },
        unknown: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.unknown",
            "defaultMessage": "Unknown"
        }
    });
});
parcelRegister("cmBKm", function(module, exports) {
    $parcel$export(module.exports, "Development", ()=>$5ecfa643deeabce9$export$fb8a2d432bc2d196);
    $parcel$export(module.exports, "DevelopmentContainer", ()=>$5ecfa643deeabce9$export$3c8f918e865f8ead);
    var $2pTnM;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $fb5SF;
    var $9XvX5;
    var $1TUd3;
    var $3bDjY;
    var $8YTUU;
    var $Iny5X;
    var $koVbs;
    var $8zOmE;
    var $npYQQ;
    var $nXMUs;
    var $3oO19;
    var $3RJ9y;
    const $5ecfa643deeabce9$export$fb8a2d432bc2d196 = ({ jiraIssue: jiraIssue, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { issueId: issueId, devSummaryCache: devSummaryCache } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("2pTnM")).default), jiraIssue);
        const { branch: branch, commit: commit, pullrequest: pullrequest, review: review } = devSummaryCache.devSummary;
        const pullRequestCount = pullrequest.overall.count;
        const pullRequestState = pullrequest.overall.state;
        if (pullRequestCount > 0 && pullRequestState) return (0, ($parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$export$3c8f918e865f8ead, {
            "data-version-details-issue-click-ignore-target": (0, (0, parcelRequire("npYQQ")).ISSUE_CARD_CLICK_IGNORE_TARGET)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            onClick: (_, analyticsEvent)=>{
                onClick((0, $61a2cd6236d50c20$export$6f74b53d652f13f3));
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionsPullRequestLozenge');
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$var$VerticalCenter, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Iny5X")).default), {
            devInfoType: (0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST,
            issueId: Number(issueId),
            customTrigger: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3oO19")).CustomPullRequestIcon), {
                pullRequestState: (0, (0, parcelRequire("3RJ9y")).toDevInfoType)(pullrequest.overall.state),
                label: formatMessage((0, (0, parcelRequire("nXMUs")).default).pullRequestIconLabel),
                primaryColor: (0, (0, parcelRequire("3RJ9y")).mapPullRequestStateToIconColour)(pullrequest.overall.state)
            }),
            isStopPropagationOnClick: false,
            scopeId: (0, $752b719410cf933d$export$6bc465585d114926),
            location: (0, $4ebd35f903e92a1a$export$ede40e627a0cbf14)
        }))));
        const reviewCount = review.overall.count;
        const reviewState = review.overall.state;
        if (reviewCount > 0 && reviewState) return (0, ($parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$export$3c8f918e865f8ead, {
            "data-version-details-issue-click-ignore-target": (0, (0, parcelRequire("npYQQ")).ISSUE_CARD_CLICK_IGNORE_TARGET)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("nXMUs")).default).reviewCount, {
                reviewCount: reviewCount
            }),
            position: "bottom-start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            onClick: (_, analyticsEvent)=>{
                const reviewDataByProvider = {};
                review.summaryByProvider.forEach(({ providerId: providerId, name: name, count: count })=>{
                    if (providerId != null) reviewDataByProvider[providerId] = {
                        name: name,
                        count: count
                    };
                });
                onClick((0, $61a2cd6236d50c20$export$3f1e2b276d607490), {
                    overall: {
                        count: review.overall.count,
                        lastUpdated: review.overall.lastUpdated ?? '',
                        state: (0, (0, parcelRequire("3RJ9y")).toReviewState)(reviewState),
                        stateCount: review.overall.stateCount
                    },
                    byInstanceType: reviewDataByProvider
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionsReviewLozenge');
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$var$VerticalCenter, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fb5SF"))))), {
            label: formatMessage((0, (0, parcelRequire("nXMUs")).default).reviewIconLabel),
            color: (0, (0, parcelRequire("3RJ9y")).mapReviewStateToIconColour)(reviewState)
        })))));
        const branchCount = branch.overall.count;
        if (branchCount > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$export$3c8f918e865f8ead, {
            "data-version-details-issue-click-ignore-target": (0, (0, parcelRequire("npYQQ")).ISSUE_CARD_CLICK_IGNORE_TARGET)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            onClick: (_, analyticsEvent)=>{
                onClick((0, $61a2cd6236d50c20$export$e18d81f044132a0e));
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionsBranchLozenge');
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$var$VerticalCenter, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Iny5X")).default), {
            devInfoType: (0, (0, parcelRequire("8YTUU")).DevInfoTypes).BRANCH,
            issueId: Number(issueId),
            customTrigger: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9XvX5"))))), {
                label: formatMessage((0, (0, parcelRequire("nXMUs")).default).branchIconLabel),
                primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`
            }),
            scopeId: (0, $752b719410cf933d$export$6bc465585d114926),
            location: (0, $4ebd35f903e92a1a$export$ede40e627a0cbf14)
        }))));
        const commitCount = commit.overall.count;
        if (commitCount > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$export$3c8f918e865f8ead, {
            "data-version-details-issue-click-ignore-target": (0, (0, parcelRequire("npYQQ")).ISSUE_CARD_CLICK_IGNORE_TARGET)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$var$VerticalCenter, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Iny5X")).default), {
            devInfoType: (0, (0, parcelRequire("8YTUU")).DevInfoTypes).COMMIT,
            issueId: Number(issueId),
            customTrigger: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "subtle-link",
                onClick: (_, analyticsEvent)=>{
                    onClick((0, $61a2cd6236d50c20$export$2e42513c7764d5f3));
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionsCommitLozenge');
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1TUd3"))))), {
                label: formatMessage((0, (0, parcelRequire("nXMUs")).default).commitIconLabel),
                primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`
            })),
            scopeId: (0, $752b719410cf933d$export$6bc465585d114926),
            location: (0, $4ebd35f903e92a1a$export$ede40e627a0cbf14)
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$export$3c8f918e865f8ead, null);
    };
    const $5ecfa643deeabce9$export$3c8f918e865f8ead = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbckbl _1ul9ckbl",
                __cmplp.className
            ])
        });
    });
    const $5ecfa643deeabce9$var$VerticalCenter = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2pTnM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b974285bf8073ca$export$2e2bcd8739ae039);
    const $1b974285bf8073ca$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "count"
        }, v1 = {
            "kind": "ScalarField",
            "name": "state"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "development_softwareReleasesVersionDetailIssueList",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "issueId"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraIssueDevSummaryResult",
                        "kind": "LinkedField",
                        "name": "devSummaryCache",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraIssueDevSummary",
                                    "kind": "LinkedField",
                                    "name": "devSummary",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "branch",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v0,
                                                                    "action": "THROW",
                                                                    "path": "devSummaryCache.devSummary.branch.overall.count"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "devSummaryCache.devSummary.branch.overall"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devSummaryCache.devSummary.branch"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "commit",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v0,
                                                                    "action": "THROW",
                                                                    "path": "devSummaryCache.devSummary.commit.overall.count"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "devSummaryCache.devSummary.commit.overall"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devSummaryCache.devSummary.commit"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "pullrequest",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v0,
                                                                    "action": "THROW",
                                                                    "path": "devSummaryCache.devSummary.pullrequest.overall.count"
                                                                },
                                                                v1
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "devSummaryCache.devSummary.pullrequest.overall"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devSummaryCache.devSummary.pullrequest"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "review",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v0,
                                                                    "action": "THROW",
                                                                    "path": "devSummaryCache.devSummary.review.overall.count"
                                                                },
                                                                v1,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "lastUpdated"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "kind": "ScalarField",
                                                                        "name": "stateCount"
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "devSummaryCache.devSummary.review.overall.stateCount"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "devSummaryCache.devSummary.review.overall"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                                            "kind": "LinkedField",
                                                            "name": "summaryByProvider",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "providerId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                v0
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "devSummaryCache.devSummary.review.summaryByProvider"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devSummaryCache.devSummary.review"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devSummaryCache.devSummary"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devSummaryCache"
                }
            ],
            "type": "JiraIssue"
        };
    }();
    $1b974285bf8073ca$var$node.hash = "a6fa00d421e78b1cfca02a289c940e70";
    var $1b974285bf8073ca$export$2e2bcd8739ae039 = $1b974285bf8073ca$var$node;
});
parcelRegister("fb5SF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b0cc71de29a7bd8c$var$_react = $b0cc71de29a7bd8c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b0cc71de29a7bd8c$var$_pullRequest = $b0cc71de29a7bd8c$var$_interopRequireDefault((parcelRequire("hXgVM")));
    var $b0cc71de29a7bd8c$var$_pullrequests = $b0cc71de29a7bd8c$var$_interopRequireDefault((parcelRequire("dMzAR")));
    function $b0cc71de29a7bd8c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b0cc71de29a7bd8c$var$PullRequestIcon = (props)=>$b0cc71de29a7bd8c$var$_react.default.createElement($b0cc71de29a7bd8c$var$_pullRequest.default, Object.assign({
            LEGACY_fallbackIcon: $b0cc71de29a7bd8c$var$_pullrequests.default
        }, props));
    $b0cc71de29a7bd8c$var$PullRequestIcon.Name = 'PullRequestIconMigration';
    var $b0cc71de29a7bd8c$var$_default = module.exports.default = $b0cc71de29a7bd8c$var$PullRequestIcon;
});
parcelRegister("dMzAR", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a08b5e30d2d36873$var$_react = $a08b5e30d2d36873$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $a08b5e30d2d36873$var$_pullRequest = $a08b5e30d2d36873$var$_interopRequireDefault((parcelRequire("hXgVM")));
    function $a08b5e30d2d36873$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a08b5e30d2d36873$var$BitbucketPullrequestsIcon = (props)=>$a08b5e30d2d36873$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2q.3 0 .6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8M17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1M7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3m0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1"/></svg>`
        }, props, {
            newIcon: $a08b5e30d2d36873$var$_pullRequest.default
        }));
    $a08b5e30d2d36873$var$BitbucketPullrequestsIcon.displayName = 'BitbucketPullrequestsIcon';
    var $a08b5e30d2d36873$var$_default = module.exports.default = $a08b5e30d2d36873$var$BitbucketPullrequestsIcon;
});
parcelRegister("9XvX5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $740268c474e86b43$var$_react = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $740268c474e86b43$var$_branch = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("4iPF3")));
    function $740268c474e86b43$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $740268c474e86b43$var$BitbucketBranchesIcon = (props)=>$740268c474e86b43$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
        }, props, {
            newIcon: $740268c474e86b43$var$_branch.default
        }));
    $740268c474e86b43$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
    var $740268c474e86b43$var$_default = module.exports.default = $740268c474e86b43$var$BitbucketBranchesIcon;
});
parcelRegister("1TUd3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $162687911a858d49$var$_react = $162687911a858d49$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $162687911a858d49$var$_commit = $162687911a858d49$var$_interopRequireDefault((parcelRequire("bFklq")));
    function $162687911a858d49$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $162687911a858d49$var$BitbucketCommitsIcon = (props)=>$162687911a858d49$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9m-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"/></svg>`
        }, props, {
            newIcon: $162687911a858d49$var$_commit.default
        }));
    $162687911a858d49$var$BitbucketCommitsIcon.displayName = 'BitbucketCommitsIcon';
    var $162687911a858d49$var$_default = module.exports.default = $162687911a858d49$var$BitbucketCommitsIcon;
});
parcelRegister("nXMUs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8ea841775256067$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b8ea841775256067$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        commitIconLabel: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.development.commit-icon-label",
            "defaultMessage": "Commits"
        },
        branchIconLabel: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.development.branch-icon-label",
            "defaultMessage": "Branches"
        },
        pullRequestIconLabel: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.development.pull-request-icon-label",
            "defaultMessage": "Pull requests"
        },
        reviewCount: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.development.review-count",
            "defaultMessage": "{reviewCount} {reviewCount, plural, one {review} other {reviews}}"
        },
        reviewIconLabel: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.development.review-icon-label",
            "defaultMessage": "Reviews"
        }
    });
});
parcelRegister("3oO19", function(module, exports) {
    $parcel$export(module.exports, "CustomPullRequestIcon", ()=>$1f4c6a4120332c17$export$59a5de4025575d75);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $dMzAR;
    var $8YTUU;
    const $1f4c6a4120332c17$var$PullrequestDeclinedIcon = ({ label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            glyph: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "24",
                    height: "24",
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    fillOpacity: "0.01"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.75 5.25C6.19772 5.25 5.75 5.69772 5.75 6.25C5.75 6.80228 6.19772 7.25 6.75 7.25C7.30228 7.25 7.75 6.80228 7.75 6.25C7.75 5.69772 7.30228 5.25 6.75 5.25ZM3.75 6.25C3.75 4.59315 5.09315 3.25 6.75 3.25C8.40685 3.25 9.75 4.59315 9.75 6.25C9.75 7.55622 8.91519 8.66746 7.75 9.07929V20.25C7.75 20.8023 7.30228 21.25 6.75 21.25C6.19772 21.25 5.75 20.8023 5.75 20.25V9.07929C4.58481 8.66746 3.75 7.55622 3.75 6.25Z",
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.75 11.25C17.3023 11.25 17.75 11.6977 17.75 12.25V15.4207C18.9152 15.8325 19.75 16.9438 19.75 18.25C19.75 19.9069 18.4069 21.25 16.75 21.25C15.0931 21.25 13.75 19.9069 13.75 18.25C13.75 16.9438 14.5848 15.8325 15.75 15.4207V12.25C15.75 11.6977 16.1977 11.25 16.75 11.25ZM16.75 17.25C16.1977 17.25 15.75 17.6977 15.75 18.25C15.75 18.8023 16.1977 19.25 16.75 19.25C17.3023 19.25 17.75 18.8023 17.75 18.25C17.75 17.6977 17.3023 17.25 16.75 17.25Z",
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.5429 3.04289C13.9334 2.65237 14.5666 2.65237 14.9571 3.04289L16.75 4.83579L18.5429 3.04289C18.9334 2.65237 19.5666 2.65237 19.9571 3.04289C20.3476 3.43342 20.3476 4.06658 19.9571 4.45711L18.1642 6.25L19.9571 8.04289C20.3476 8.43342 20.3476 9.06658 19.9571 9.45711C19.5666 9.84763 18.9334 9.84763 18.5429 9.45711L16.75 7.66421L14.9571 9.45711C14.5666 9.84763 13.9334 9.84763 13.5429 9.45711C13.1524 9.06658 13.1524 8.43342 13.5429 8.04289L15.3358 6.25L13.5429 4.45711C13.1524 4.06658 13.1524 3.43342 13.5429 3.04289Z",
                    fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R300})`
                }))
        });
    const $1f4c6a4120332c17$var$PullrequestMergedIcon = ({ label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            glyph: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
                    width: "24",
                    height: "24",
                    fill: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                    fillOpacity: "0.01"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.5 5C5.94772 5 5.5 5.44772 5.5 6C5.5 6.55228 5.94772 7 6.5 7C7.05228 7 7.5 6.55228 7.5 6C7.5 5.44772 7.05228 5 6.5 5ZM3.5 6C3.5 4.34315 4.84315 3 6.5 3C8.15685 3 9.5 4.34315 9.5 6C9.5 7.30622 8.66519 8.41746 7.5 8.82929V20C7.5 20.5523 7.05228 21 6.5 21C5.94772 21 5.5 20.5523 5.5 20V8.82929C4.33481 8.41746 3.5 7.30622 3.5 6Z",
                    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.5 7C7.05228 7 7.5 7.44772 7.5 8V10C7.5 13.5912 10.2043 16.5508 13.6876 16.9534C14.1123 15.8126 15.2113 15 16.5 15C18.1569 15 19.5 16.3431 19.5 18C19.5 19.6569 18.1569 21 16.5 21C15.1793 21 14.0579 20.1466 13.6572 18.9611C9.08185 18.5362 5.5 14.6864 5.5 10V8C5.5 7.44772 5.94772 7 6.5 7ZM16.5 17C15.9477 17 15.5 17.4477 15.5 18C15.5 18.5523 15.9477 19 16.5 19C17.0523 19 17.5 18.5523 17.5 18C17.5 17.4477 17.0523 17 16.5 17Z",
                    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
                }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20.2071 4.29289C20.5976 4.68342 20.5976 5.31658 20.2071 5.70711L16.2071 9.70711C15.8166 10.0976 15.1834 10.0976 14.7929 9.70711L12.7929 7.70711C12.4024 7.31658 12.4024 6.68342 12.7929 6.29289C13.1834 5.90237 13.8166 5.90237 14.2071 6.29289L15.5 7.58579L18.7929 4.29289C19.1834 3.90237 19.8166 3.90237 20.2071 4.29289Z",
                    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`
                }))
        });
    const $1f4c6a4120332c17$export$59a5de4025575d75 = ({ pullRequestState: pullRequestState, label: label, primaryColor: primaryColor })=>{
        if (pullRequestState === (0, (0, parcelRequire("8YTUU")).DevInfoTypes).DECLINED) return (0, ($parcel$interopDefault($5uXOq))).createElement($1f4c6a4120332c17$var$PullrequestDeclinedIcon, {
            label: label
        });
        if (pullRequestState === (0, (0, parcelRequire("8YTUU")).DevInfoTypes).MERGED) return (0, ($parcel$interopDefault($5uXOq))).createElement($1f4c6a4120332c17$var$PullrequestMergedIcon, {
            label: label
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dMzAR"))))), {
            label: label,
            primaryColor: primaryColor
        });
    };
});
parcelRegister("3RJ9y", function(module, exports) {
    $parcel$export(module.exports, "mapPullRequestStateToIconColour", ()=>$305273cb65147a1f$export$b659f6ad1597c81c);
    $parcel$export(module.exports, "mapReviewStateToIconColour", ()=>$305273cb65147a1f$export$3503f5c2d5e8553a);
    $parcel$export(module.exports, "toReviewState", ()=>$305273cb65147a1f$export$e4227c1382daeae5);
    $parcel$export(module.exports, "toDevInfoType", ()=>$305273cb65147a1f$export$f3b34c5748a7d335);
    var $8YTUU;
    const $305273cb65147a1f$export$b659f6ad1597c81c = (state)=>{
        switch(state){
            case 'MERGED':
                return `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`;
            case 'DECLINED':
                return `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R400})`;
            default:
                return `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`;
        }
    };
    const $305273cb65147a1f$export$3503f5c2d5e8553a = (state)=>{
        switch(state){
            case 'REVIEW':
                return `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`;
            case 'APPROVAL':
                return `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`;
            case 'SUMMARIZE':
                return `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`;
            case 'REJECTED':
                return `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R400})`;
            case 'CLOSED':
                return `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`;
            case 'DRAFT':
                return `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`;
            case 'DEAD':
                return `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R400})`;
            case 'UNKNOWN':
                return `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R400})`;
            default:
                return `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`;
        }
    };
    const $305273cb65147a1f$export$e4227c1382daeae5 = (state)=>{
        switch(state){
            case 'REVIEW':
            case 'APPROVAL':
            case 'SUMMARIZE':
            case 'REJECTED':
            case 'CLOSED':
            case 'DRAFT':
            case 'DEAD':
                return state;
            default:
                return 'UNKNOWN';
        }
    };
    const $305273cb65147a1f$export$f3b34c5748a7d335 = (state)=>{
        switch(state){
            case 'DECLINED':
                return (0, (0, parcelRequire("8YTUU")).DevInfoTypes).DECLINED;
            case 'MERGED':
                return (0, (0, parcelRequire("8YTUU")).DevInfoTypes).MERGED;
            default:
                return (0, (0, parcelRequire("8YTUU")).DevInfoTypes).PULLREQUEST;
        }
    };
});
parcelRegister("iKL1U", function(module, exports) {
    $parcel$export(module.exports, "FeatureFlags", ()=>$8f29d9dcd9c0b374$export$ab28ab2e245553c7);
    $parcel$export(module.exports, "FeatureFlagsContainer", ()=>$8f29d9dcd9c0b374$export$c518a6c3736e9db7);
    var $lEj39;
    var $8g3g9;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $4R6GH;
    var $8zOmE;
    var $inYVm;
    var $5eQEK;
    var $hUdMc;
    const $8f29d9dcd9c0b374$export$ab28ab2e245553c7 = ({ devOpsSummarisedEntities: devOpsSummarisedEntities, jiraIssue: jiraIssue, onClick: onClick, setFeatureFlagEmptyStateModalOpen: setFeatureFlagEmptyStateModalOpen, rowNum: rowNum })=>{
        const issue = (0, $8Uumt.useFragment)((0, (0, parcelRequire("8g3g9")).default), jiraIssue);
        const { providers: providers } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("lEj39")).default), devOpsSummarisedEntities);
        const summarisedFlags = (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re') ? issue.summarisedFeatureFlags : issue.devOpsSummarisedEntities?.summarisedFeatureFlags;
        const featureFlagCount = summarisedFlags?.totalCount ?? 0;
        const hasFeatureFlags = summarisedFlags != null && featureFlagCount != null && featureFlagCount > 0;
        const featureFlagProviders = (providers.featureFlagProviders ?? []).filter(Boolean);
        const hasFeatureFlagProviders = featureFlagProviders.length > 0;
        const renderContent = ()=>{
            const fields = issue.fieldsById.edges.map((edge)=>edge?.node).filter(Boolean);
            const jiraIssueSummary = fields.find((fieldNode)=>fieldNode?.fieldId === 'summary');
            if (hasFeatureFlags) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "subtle-link",
                spacing: "none",
                onClick: (_, analyticsEvent)=>{
                    onClick((0, $61a2cd6236d50c20$export$c69477f358d30f7e));
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'featureFlagSummaryCell');
                }
            }, featureFlagCount === 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hUdMc")).SingleFlag), {
                summarisedFlags: summarisedFlags
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5eQEK")).MultipleFlags), {
                jiraIssue: issue,
                summarisedFlags: summarisedFlags
            }));
            if (hasFeatureFlagProviders) return jiraIssueSummary != null ? (0, ($parcel$interopDefault($5uXOq))).createElement($8f29d9dcd9c0b374$export$e7937791cac9c51b, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("inYVm")).AddFeatureFlagDropdown), {
                devOpsFeatureFlagProviders: featureFlagProviders,
                jiraIssue: issue,
                jiraIssueSummary: jiraIssueSummary,
                onOpenFeatureFlagEmptyStateModal: ()=>setFeatureFlagEmptyStateModalOpen(true)
            })) : null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($8f29d9dcd9c0b374$export$e7937791cac9c51b, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("inYVm")).AddFeatureFlagButton), {
                onOpenFeatureFlagEmptyStateModal: ()=>setFeatureFlagEmptyStateModalOpen(true),
                rowNum: rowNum
            }));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($8f29d9dcd9c0b374$export$c518a6c3736e9db7, null, renderContent(), " ");
    };
    const $8f29d9dcd9c0b374$export$e7937791cac9c51b = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wtl15vq _j9irewfl"
            ])
        }, children);
    const $8f29d9dcd9c0b374$export$c518a6c3736e9db7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1b081l8a _15yj1l8a _13n41tcg _fhcx1tcg",
                __cmplp.className
            ])
        });
    });
    const $8f29d9dcd9c0b374$var$styles = null;
});
parcelRegister("lEj39", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d874885535259cf$export$2e2bcd8739ae039);
    const $9d874885535259cf$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "DevOpsProviders",
                    "kind": "LinkedField",
                    "name": "providers",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "DevOpsFeatureFlagProvider",
                                "kind": "LinkedField",
                                "name": "featureFlagProviders",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "providers.featureFlagProviders"
                        }
                    ]
                },
                "action": "THROW",
                "path": "providers"
            }
        ],
        "type": "DevOpsSummarisedEntities"
    };
    $9d874885535259cf$var$node.hash = "6396e923543528812899038e05950d31";
    var $9d874885535259cf$export$2e2bcd8739ae039 = $9d874885535259cf$var$node;
});
parcelRegister("8g3g9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a128492eddc5e9ab$export$2e2bcd8739ae039);
    const $a128492eddc5e9ab$var$node = function() {
        var v0 = [
            {
                "concreteType": "DevOpsSummarisedFeatureFlags",
                "kind": "LinkedField",
                "name": "summarisedFeatureFlags",
                "plural": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "singleFlag_softwareReleasesVersionDetailIssueList"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    }
                ]
            }
        ];
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "isIssueSummarisedDeploymentsMigratedToAgs"
                }
            ],
            "kind": "Fragment",
            "name": "featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue",
            "selections": [
                {
                    "concreteType": "DevOpsSummarisedEntities",
                    "kind": "LinkedField",
                    "name": "devOpsSummarisedEntities",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": v0
                        }
                    ]
                },
                {
                    "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": v0
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "ids",
                                "value": [
                                    "priority",
                                    "summary",
                                    "assignee",
                                    "status",
                                    "issuetype"
                                ]
                            }
                        ],
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fieldsById",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                    },
                                                    "action": "THROW",
                                                    "path": "fieldsById.edges.node.fieldId"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary"
                                                        }
                                                    ],
                                                    "type": "JiraSingleLineTextField"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "fieldsById.edges"
                            }
                        ],
                        "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                    },
                    "action": "THROW",
                    "path": "fieldsById"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue"
                }
            ],
            "type": "JiraIssue"
        };
    }();
    $a128492eddc5e9ab$var$node.hash = "e07d07935307d3c1473575baacb25327";
    var $a128492eddc5e9ab$export$2e2bcd8739ae039 = $a128492eddc5e9ab$var$node;
});
parcelRegister("inYVm", function(module, exports) {
    $parcel$export(module.exports, "AddFeatureFlagDropdown", ()=>$a3f3c9d852ccccf6$export$e0238a9f85d3899d);
    $parcel$export(module.exports, "AddFeatureFlagButton", ()=>$a3f3c9d852ccccf6$export$18659c2363dd7739);
    var $iIcWc;
    var $5XGjJ;
    var $9s19T;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $koVbs;
    var $lfTZh;
    var $iXVV6;
    var $8zOmE;
    var $5oFIy;
    var $kxZPA;
    var $an1Yn;
    var $lDiAW;
    var $iWraz;
    const $a3f3c9d852ccccf6$var$ActionMenu = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("1cVs1")).then((module)=>module.ActionMenu), {
        moduleId: "./src/packages/releases/issue-list/src/ui/issues/issue-card/feature-flags/add-feature-flag/action-menu/index.tsx"
    });
    const $a3f3c9d852ccccf6$var$TriggerContent = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$ButtonContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lDiAW")).AddFeatureFlagIcon), null), (0, ($parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$ButtonText, null, children));
    const $a3f3c9d852ccccf6$export$e0238a9f85d3899d = ({ jiraIssue: jiraIssue, jiraIssueSummary: jiraIssueSummary, devOpsFeatureFlagProviders: devOpsFeatureFlagProviders, onOpenFeatureFlagEmptyStateModal: onOpenFeatureFlagEmptyStateModal })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
        const issue = (0, $8Uumt.useFragment)((0, (0, parcelRequire("9s19T")).default), jiraIssue);
        const issueSummary = (0, $8Uumt.useFragment)((0, (0, parcelRequire("5XGjJ")).default), jiraIssueSummary);
        const featureFlagProviders = (0, $8Uumt.useFragment)((0, (0, parcelRequire("iIcWc")).default), devOpsFeatureFlagProviders);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$OnHoverContainer, {
            isVisible: isDropdownOpen
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "action-menu",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "subtle-link",
                spacing: "none",
                isDisabled: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$TriggerContent, null, formatMessage((0, (0, parcelRequire("iWraz")).default).addFeatureFlag)))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$ActionMenu, {
            jiraIssue: issue,
            jiraIssueSummary: issueSummary,
            onOpenChange: ({ isOpen: isOpen })=>setIsDropdownOpen(isOpen),
            devOpsFeatureFlagProviders: featureFlagProviders,
            onOpenFeatureFlagEmptyStateExperience: onOpenFeatureFlagEmptyStateModal,
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "subtle-link",
                    spacing: "none",
                    ref: triggerRef,
                    ...props
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$TriggerContent, null, formatMessage((0, (0, parcelRequire("iWraz")).default).addFeatureFlag)))
        })));
    };
    const $a3f3c9d852ccccf6$export$18659c2363dd7739 = ({ onOpenFeatureFlagEmptyStateModal: onOpenFeatureFlagEmptyStateModal, rowNum: rowNum })=>{
        const spotlightButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "action-button-no-provider",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "subtle-link",
                spacing: "none",
                isDisabled: true
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lDiAW")).AddFeatureFlagIcon), null))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("an1Yn")).ActionButtonNoProviderAsync), {
            onClick: (_, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionDetailAddFeatureFlagButton');
                onOpenFeatureFlagEmptyStateModal();
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lDiAW")).AddFeatureFlagIcon), null)));
        const regularButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            spacing: "none",
            onClick: (_, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionDetailAddFeatureFlagButton');
                onOpenFeatureFlagEmptyStateModal();
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lDiAW")).AddFeatureFlagIcon), null));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$AddFeatureFlagButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "versionDetailsTableAddFeatureFlagActionButton",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, rowNum === 1 ? spotlightButton : regularButton, rowNum === 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null) : null));
    };
    const $a3f3c9d852ccccf6$var$ButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $a3f3c9d852ccccf6$var$ButtonText = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_u5f3u2gc _1flu1nu9 _1a4cglyw",
                __cmplp.className
            ])
        });
    });
    const $a3f3c9d852ccccf6$var$AddFeatureFlagButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $a3f3c9d852ccccf6$var$OnHoverContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isVisible: isVisible, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.isVisible ? "_3um015ya" : "_3um015vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iIcWc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38ecba1a4ee8de56$export$2e2bcd8739ae039);
    const $38ecba1a4ee8de56$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "actionMenu_softwareReleasesVersionDetailIssueList_devOpsFeatureFlagProviders"
            }
        ],
        "type": "DevOpsFeatureFlagProvider"
    };
    $38ecba1a4ee8de56$var$node.hash = "9b78d95e09cfbfd2c5af5b680d6fc543";
    var $38ecba1a4ee8de56$export$2e2bcd8739ae039 = $38ecba1a4ee8de56$var$node;
});
parcelRegister("5XGjJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9e693cdb105dea5$export$2e2bcd8739ae039);
    const $e9e693cdb105dea5$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "actionMenu_softwareReleasesVersionDetailIssueList_jiraIssueSummary"
            }
        ],
        "type": "JiraSingleLineTextField"
    };
    $e9e693cdb105dea5$var$node.hash = "f26b20a2f8e5f0c916921d8c8691c202";
    var $e9e693cdb105dea5$export$2e2bcd8739ae039 = $e9e693cdb105dea5$var$node;
});
parcelRegister("9s19T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$454a021224027b41$export$2e2bcd8739ae039);
    const $454a021224027b41$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "actionMenu_softwareReleasesVersionDetailIssueList_jiraIssue"
            }
        ],
        "type": "JiraIssue"
    };
    $454a021224027b41$var$node.hash = "3ccc732c38654f19cf9d23f0c776cb28";
    var $454a021224027b41$export$2e2bcd8739ae039 = $454a021224027b41$var$node;
});
parcelRegister("an1Yn", function(module, exports) {
    $parcel$export(module.exports, "ActionButtonNoProviderAsync", ()=>$0d1d6af6a4ed6d33$export$86b05afa2718604);
    var $5uXOq = parcelRequire("5uXOq");
    var $kxZPA;
    const $0d1d6af6a4ed6d33$var$ActionButtonNoProviderLazy = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("fMFcT")).then((module)=>module.ActionButtonNoProvider), {
        moduleId: "./src/packages/releases/issue-list/src/ui/issues/issue-card/feature-flags/add-feature-flag/action-button-no-provider/index.tsx"
    });
    const $0d1d6af6a4ed6d33$export$86b05afa2718604 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($0d1d6af6a4ed6d33$var$ActionButtonNoProviderLazy, props);
});
parcelRegister("fMFcT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5xEm7").then(()=>parcelRequire('2x0yw'));
});
parcelRegister("lDiAW", function(module, exports) {
    $parcel$export(module.exports, "AddFeatureFlagIcon", ()=>$ab861c161b1aacef$export$c3b91b420ace5d12);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $5LWLA;
    var $gwIPs;
    var $koVbs;
    var $2TNn2;
    const $ab861c161b1aacef$var$AddFeatureFlagGlyph = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: (0, (0, parcelRequire("gwIPs")).gridSize) * 3,
            height: (0, (0, parcelRequire("gwIPs")).gridSize) * 3,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17 2C17.5523 2 18 2.44772 18 3V5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H18V9C18 9.55228 17.5523 10 17 10C16.4477 10 16 9.55228 16 9V7H14C13.4477 7 13 6.55228 13 6C13 5.44772 13.4477 5 14 5H16V3C16 2.44772 16.4477 2 17 2ZM12.2444 4.49608C12.3613 4.52442 12.477 4.55249 12.5917 4.57991C12.2263 4.9423 12 5.44472 12 6C12 6.17625 12.0228 6.34718 12.0656 6.50999C11.966 6.48607 11.867 6.46205 11.7688 6.43821L11.768 6.43801L11.7623 6.43662L11.7623 6.43662C10.3856 6.10219 9.16838 5.80649 8 6.14801V10.852C8.36666 10.7863 8.7385 10.7539 9.111 10.755C10.205 10.755 11.259 11.011 12.24 11.25C13.621 11.585 14.84 11.88 16.008 11.539V10.737C16.3004 10.9044 16.639 11 17 11C17.3676 11 17.712 10.9008 18.008 10.7278V12.221C18.0081 12.4088 17.9554 12.5927 17.8558 12.7519C17.7562 12.9111 17.6139 13.039 17.445 13.121C16.6509 13.5034 15.7793 13.6974 14.898 13.688C13.8103 13.688 12.7622 13.434 11.785 13.1971L11.785 13.1971L11.768 13.193C10.389 12.858 9.17 12.562 8 12.903V18.681C8 19.218 7.55 19.658 7 19.658C6.45 19.658 6 19.218 6 18.681V12.235V5.46601C6 5.27855 6.05268 5.09486 6.15205 4.93591C6.25143 4.77695 6.39348 4.64912 6.562 4.56701C8.553 3.60001 10.511 4.07501 12.24 4.49501L12.2444 4.49608Z",
            fill: "currentcolor"
        }));
    const $ab861c161b1aacef$export$c3b91b420ace5d12 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ab861c161b1aacef$export$be58b4326e23250f, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.add-feature-flag.icon.icon",
            glyph: $ab861c161b1aacef$var$AddFeatureFlagGlyph,
            size: "medium",
            label: formatMessage((0, (0, parcelRequire("2TNn2")).default).addFeatureFlagIconLabel)
        }));
    };
    const $ab861c161b1aacef$export$be58b4326e23250f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2TNn2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$227a89c3121401e3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $227a89c3121401e3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addFeatureFlagIconLabel: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.icon.add-feature-flag-icon-label",
            "defaultMessage": "Add feature flag icon"
        }
    });
});
parcelRegister("iWraz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1a2df9b0df79890$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a1a2df9b0df79890$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addFeatureFlag: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.add-feature-flag",
            "defaultMessage": "Add flag"
        },
        createFeatureFlagMenuItem: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.create-feature-flag-menu-item",
            "defaultMessage": "Create feature flag"
        },
        connectFeatureFlagMenuItem: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.connect-feature-flag-menu-item",
            "defaultMessage": "Connect feature flag"
        },
        installAnotherToolMenuItem: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.install-another-tool-menu-item",
            "defaultMessage": "Install another tool"
        }
    });
});
parcelRegister("1cVs1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iOyrw").then(()=>parcelRequire('9sAyx'));
});
parcelRegister("5eQEK", function(module, exports) {
    $parcel$export(module.exports, "MultipleFlags", ()=>$13def82d73e54807$export$6d8ca791f6cb1232);
    var $es0sT;
    var $3xP8m;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $3bDjY;
    var $koVbs;
    var $lfTZh;
    var $8zOmE;
    var $dqjrh;
    var $l4isl;
    var $9UCV3;
    const $13def82d73e54807$export$6d8ca791f6cb1232 = ({ jiraIssue: jiraIssue, summarisedFlags: summarisedFlags })=>{
        const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, (0, parcelRequire("koVbs")).default)();
        const issue = (0, $8Uumt.useFragment)((0, (0, parcelRequire("3xP8m")).default), jiraIssue);
        const { totalCount: totalCount } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("es0sT")).default), summarisedFlags);
        const [tooltipQueryReference, loadTooltipQuery] = (0, (0, parcelRequire("9UCV3")).useTooltipContentQuery)(issue.id);
        const tooltipContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "tooltip-content",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("l4isl")).default).tooltipLoading))
        }, tooltipQueryReference == null ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCV3")).TooltipContent), {
            queryReference: tooltipQueryReference
        }));
        const cellContent = (0, ($parcel$interopDefault($5uXOq))).createElement($13def82d73e54807$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dqjrh")).MultipleFlagsIcon), null), (0, ($parcel$interopDefault($5uXOq))).createElement($13def82d73e54807$var$TextContainer, null, formatMessage((0, (0, parcelRequire("l4isl")).default).flags, {
            count: formatNumber(totalCount)
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            onFocus: loadTooltipQuery,
            onMouseOver: loadTooltipQuery
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.multiple-flags.tooltip",
            content: tooltipContent,
            onShow: (analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'featureFlagSummaryTooltip');
            },
            position: "bottom-start"
        }, cellContent));
    };
    const $13def82d73e54807$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _zulp1b66",
                __cmplp.className
            ])
        });
    });
    const $13def82d73e54807$var$TextContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1flu1nu9 _1a4cglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("es0sT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$15e4250d4704aca6$export$2e2bcd8739ae039);
    const $15e4250d4704aca6$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                "action": "THROW",
                "path": "totalCount"
            }
        ],
        "type": "DevOpsSummarisedFeatureFlags"
    };
    $15e4250d4704aca6$var$node.hash = "f8750caf47e7cdb0f524b2138f711e5d";
    var $15e4250d4704aca6$export$2e2bcd8739ae039 = $15e4250d4704aca6$var$node;
});
parcelRegister("3xP8m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19e2cb315ea3e8dc$export$2e2bcd8739ae039);
    const $19e2cb315ea3e8dc$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            }
        ],
        "type": "JiraIssue"
    };
    $19e2cb315ea3e8dc$var$node.hash = "895bdec15c863c74e317666c4dea1c42";
    var $19e2cb315ea3e8dc$export$2e2bcd8739ae039 = $19e2cb315ea3e8dc$var$node;
});
parcelRegister("dqjrh", function(module, exports) {
    $parcel$export(module.exports, "MultipleFlagsIcon", ()=>$0f5e6f41698d692f$export$b02a1ce334df672e);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $koVbs;
    var $3ISnT = parcelRequire("3ISnT");
    var $exdGI;
    const $0f5e6f41698d692f$var$MultipleFlagsGlyph = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($3ISnT))),
            alt: ""
        });
    const $0f5e6f41698d692f$export$b02a1ce334df672e = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.multiple-flags.icon.multiple",
            size: "medium",
            glyph: $0f5e6f41698d692f$var$MultipleFlagsGlyph,
            label: formatMessage((0, (0, parcelRequire("exdGI")).default).multipleFlagsIconLabel)
        });
    };
});
parcelRegister("3ISnT", function(module, exports) {
    module.exports = new URL("multiple-flags.fdb5d926.svg", import.meta.url).toString();
});
parcelRegister("exdGI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2acd0735af8f7c7d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2acd0735af8f7c7d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        multipleFlagsIconLabel: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.icon.multiple-flags-icon-label",
            "defaultMessage": "Multiple feature flags"
        }
    });
});
parcelRegister("l4isl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5762788d5ba9fe91$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5762788d5ba9fe91$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        flags: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.flags",
            "defaultMessage": "{count} {count, plural, one {flag} other {flags}}"
        },
        tooltipLoading: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-loading",
            "defaultMessage": "Loading..."
        }
    });
});
parcelRegister("9UCV3", function(module, exports) {
    $parcel$export(module.exports, "useTooltipContentQuery", ()=>$a81f9cffb9ef88ca$export$8f5a61dd01353b26);
    $parcel$export(module.exports, "TooltipContent", ()=>$a81f9cffb9ef88ca$export$e9003e2be37ec060);
    var $2yXS8;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $h4EJ8 = parcelRequire("h4EJ8");
    var $8Uumt = parcelRequire("8Uumt");
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $2yXS8;
    var $86j5r;
    const $a81f9cffb9ef88ca$var$MAX_DISPLAY_NAME_LENGTH = 32;
    const $a81f9cffb9ef88ca$var$MAX_FLAGS_TO_SHOW = 3;
    const $a81f9cffb9ef88ca$export$8f5a61dd01353b26 = (issueId)=>{
        const [queryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("2yXS8")).default));
        return [
            queryRef,
            ()=>loadQuery({
                    issueId: issueId
                })
        ];
    };
    const $a81f9cffb9ef88ca$export$e9003e2be37ec060 = ({ queryReference: queryReference })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const result = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("2yXS8")).default), queryReference);
        const { totalCount: totalCount, edges: edges } = result.devOps.entitiesByAssociations.featureFlagEntities;
        const featureFlags = edges?.flatMap((edge)=>edge?.node == null ? [] : [
                edge.node
            ]).map((node)=>({
                id: node.id,
                displayName: node.displayName.length > $a81f9cffb9ef88ca$var$MAX_DISPLAY_NAME_LENGTH ? (0, ($parcel$interopDefault($h4EJ8)))(node.displayName, {
                    length: $a81f9cffb9ef88ca$var$MAX_DISPLAY_NAME_LENGTH,
                    separator: ' '
                }) : node.displayName,
                enabled: node.summary.enabled
            }));
        const hiddenFlagsCount = Math.max(0, totalCount - $a81f9cffb9ef88ca$var$MAX_FLAGS_TO_SHOW);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $a81f9cffb9ef88ca$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a81f9cffb9ef88ca$var$FeatureFlagList, null, featureFlags.map(({ id: id, displayName: displayName, enabled: enabled })=>(0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: id
            }, enabled ? formatMessage((0, (0, parcelRequire("86j5r")).default).flagEnabled, {
                displayName: displayName
            }) : formatMessage((0, (0, parcelRequire("86j5r")).default).flagDisabled, {
                displayName: displayName
            })))), (0, ($parcel$interopDefault($5uXOq))).createElement($a81f9cffb9ef88ca$var$MoreFlagsText, null, hiddenFlagsCount > 0 ? formatMessage((0, (0, parcelRequire("86j5r")).default).flagsHidden, {
            hiddenFlagsCount: hiddenFlagsCount
        }) : null));
    };
    const $a81f9cffb9ef88ca$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.050'
    });
    const $a81f9cffb9ef88ca$var$FeatureFlagList = (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_qtt8glyw _19bvidpf",
                __cmplp.className
            ])
        });
    });
    const $a81f9cffb9ef88ca$var$MoreFlagsText = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2yXS8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$76366f3dadf05eaf$export$2e2bcd8739ae039);
    const $76366f3dadf05eaf$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "issueId"
            }
        ], v1 = [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "ids.0",
                        "variableName": "issueId"
                    }
                ],
                "kind": "ListValue",
                "name": "ids"
            }
        ], v2 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 3
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v4 = {
            "kind": "ScalarField",
            "name": "id"
        }, v5 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v6 = {
            "kind": "ScalarField",
            "name": "enabled"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "DevOps",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v1,
                                        "concreteType": "DevOpsEntities",
                                        "kind": "LinkedField",
                                        "name": "entitiesByAssociations",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "args": v2,
                                                    "concreteType": "DevOpsFeatureFlagConnection",
                                                    "kind": "LinkedField",
                                                    "name": "featureFlagEntities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v3,
                                                            "action": "THROW",
                                                            "path": "devOps.entitiesByAssociations.featureFlagEntities.totalCount"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "DevOpsFeatureFlagEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsFeatureFlag",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v4,
                                                                                "action": "NONE",
                                                                                "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v5,
                                                                                "action": "NONE",
                                                                                "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.displayName"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "DevOpsFeatureFlagSummary",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summary",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v6,
                                                                                            "action": "NONE",
                                                                                            "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.summary.enabled"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "NONE",
                                                                                "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.summary"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "devOps.entitiesByAssociations.featureFlagEntities.edges"
                                                        }
                                                    ],
                                                    "storageKey": "featureFlagEntities(first:3)"
                                                },
                                                "action": "THROW",
                                                "path": "devOps.entitiesByAssociations.featureFlagEntities"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "devOps.entitiesByAssociations"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "devOps"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
                "selections": [
                    {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "DevOpsEntities",
                                "kind": "LinkedField",
                                "name": "entitiesByAssociations",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2,
                                        "concreteType": "DevOpsFeatureFlagConnection",
                                        "kind": "LinkedField",
                                        "name": "featureFlagEntities",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "concreteType": "DevOpsFeatureFlagEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "DevOpsFeatureFlag",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v4,
                                                            v5,
                                                            {
                                                                "concreteType": "DevOpsFeatureFlagSummary",
                                                                "kind": "LinkedField",
                                                                "name": "summary",
                                                                "plural": false,
                                                                "selections": [
                                                                    v6
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "featureFlagEntities(first:3)"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "dff5c0a2fd12a20d8c39553c2a3cdae2a128b7c8518310de561d020720953cdc",
                "metadata": {},
                "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $76366f3dadf05eaf$var$node.hash = "c17feb1731a74b476c57976ce322ce68";
    var $76366f3dadf05eaf$export$2e2bcd8739ae039 = $76366f3dadf05eaf$var$node;
});
parcelRegister("86j5r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1d7a455c347b64d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a1d7a455c347b64d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        flagEnabled: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flag-enabled",
            "defaultMessage": "\u2018{displayName}\u2019 is on"
        },
        flagDisabled: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flag-disabled",
            "defaultMessage": "\u2018{displayName}\u2019 is off"
        },
        flagsHidden: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flags-hidden",
            "defaultMessage": "+ {hiddenFlagsCount} more"
        }
    });
});
parcelRegister("hUdMc", function(module, exports) {
    $parcel$export(module.exports, "SingleFlag", ()=>$53cb27a6594a4a93$export$c039c42a03fd637);
    var $e86xE;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $h4EJ8 = parcelRequire("h4EJ8");
    var $8Uumt = parcelRequire("8Uumt");
    var $3bDjY;
    var $koVbs;
    var $8zOmE;
    var $7jHLD;
    var $6PLG2;
    const $53cb27a6594a4a93$var$MAX_DISPLAY_NAME_LENGTH = 255;
    const $53cb27a6594a4a93$export$c039c42a03fd637 = ({ summarisedFlags: summarisedFlags })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { mostRelevantDisplayName: mostRelevantDisplayName, mostRelevantEnabled: mostRelevantEnabled, mostRelevantRolloutPercentage: mostRelevantRolloutPercentage } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("e86xE")).default), summarisedFlags);
        const truncatedDisplayName = mostRelevantDisplayName.length > $53cb27a6594a4a93$var$MAX_DISPLAY_NAME_LENGTH ? (0, ($parcel$interopDefault($h4EJ8)))(mostRelevantDisplayName, {
            length: $53cb27a6594a4a93$var$MAX_DISPLAY_NAME_LENGTH,
            separator: ' '
        }) : mostRelevantDisplayName;
        const renderTooltip = ()=>{
            if (!mostRelevantEnabled) return formatMessage((0, (0, parcelRequire("6PLG2")).default).flagDisabled, {
                displayName: truncatedDisplayName
            });
            if (mostRelevantRolloutPercentage == null) return formatMessage((0, (0, parcelRequire("6PLG2")).default).flagWithoutPercentage, {
                displayName: truncatedDisplayName
            });
            return formatMessage((0, (0, parcelRequire("6PLG2")).default).flagWithPercentage, {
                displayName: truncatedDisplayName,
                percentage: mostRelevantRolloutPercentage / 100
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.tooltip",
            content: renderTooltip(),
            onShow: (analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'featureFlagSummaryTooltip');
            },
            position: "bottom-start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($53cb27a6594a4a93$var$Container, null, mostRelevantEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7jHLD")).FlagEnabledIcon), null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7jHLD")).FlagDisabledIcon), null), (0, ($parcel$interopDefault($5uXOq))).createElement($53cb27a6594a4a93$var$TextContainer, null, mostRelevantRolloutPercentage != null ? `${formatMessage((0, (0, parcelRequire("6PLG2")).default).flagPercentageRollout, {
            featureFlagPercentageRollout: mostRelevantRolloutPercentage / 100
        })}` : null)));
    };
    const $53cb27a6594a4a93$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _zulp1b66",
                __cmplp.className
            ])
        });
    });
    const $53cb27a6594a4a93$var$TextContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1flu1nu9 _1a4cglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("e86xE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79727ae8f9f00582$export$2e2bcd8739ae039);
    const $79727ae8f9f00582$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "singleFlag_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "mostRelevantDisplayName"
                },
                "action": "THROW",
                "path": "mostRelevantDisplayName"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "mostRelevantEnabled"
                },
                "action": "THROW",
                "path": "mostRelevantEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "mostRelevantRolloutPercentage"
            }
        ],
        "type": "DevOpsSummarisedFeatureFlags"
    };
    $79727ae8f9f00582$var$node.hash = "5843724954a8e05bf3074b304ff85341";
    var $79727ae8f9f00582$export$2e2bcd8739ae039 = $79727ae8f9f00582$var$node;
});
parcelRegister("7jHLD", function(module, exports) {
    $parcel$export(module.exports, "FlagDisabledIcon", ()=>$2be53577a09d600e$export$a94a5376ccc0e3fb);
    $parcel$export(module.exports, "FlagEnabledIcon", ()=>$2be53577a09d600e$export$b99b90244f32ccbf);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $koVbs;
    var $4sTkx = parcelRequire("4sTkx");
    var $bBqSU = parcelRequire("bBqSU");
    var $aSWM1;
    const $2be53577a09d600e$var$size = 'medium';
    const $2be53577a09d600e$var$FlagDisabledGlyph = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($4sTkx))),
            alt: ""
        });
    const $2be53577a09d600e$export$a94a5376ccc0e3fb = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.disabled",
            size: $2be53577a09d600e$var$size,
            glyph: $2be53577a09d600e$var$FlagDisabledGlyph,
            label: formatMessage((0, (0, parcelRequire("aSWM1")).default).flagDisabledIconLabel)
        });
    };
    const $2be53577a09d600e$var$FlagEnabledGlyph = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($bBqSU))),
            alt: ""
        });
    const $2be53577a09d600e$export$b99b90244f32ccbf = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.enabled",
            size: $2be53577a09d600e$var$size,
            glyph: $2be53577a09d600e$var$FlagEnabledGlyph,
            label: formatMessage((0, (0, parcelRequire("aSWM1")).default).flagEnabledIconLabel)
        });
    };
});
parcelRegister("4sTkx", function(module, exports) {
    module.exports = new URL("flag-disabled.813c2320.svg", import.meta.url).toString();
});
parcelRegister("bBqSU", function(module, exports) {
    module.exports = new URL("flag-enabled.1378f3de.svg", import.meta.url).toString();
});
parcelRegister("aSWM1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff8a8d8277a40fae$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ff8a8d8277a40fae$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        flagEnabledIconLabel: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.icons.flag-enabled-icon-label",
            "defaultMessage": "Feature flag enabled"
        },
        flagDisabledIconLabel: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.icons.flag-disabled-icon-label",
            "defaultMessage": "Feature flag disabled"
        }
    });
});
parcelRegister("6PLG2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49a7c2489c2b1676$export$2e2bcd8739ae039);
    var $7VHMR;
    var $49a7c2489c2b1676$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        flagDisabled: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-disabled",
            "defaultMessage": "\u2018{displayName}\u2019 is off"
        },
        flagWithoutPercentage: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-without-percentage",
            "defaultMessage": "\u2018{displayName}\u2019 is on"
        },
        flagWithPercentage: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-with-percentage",
            "defaultMessage": "\u2018{displayName}\u2019 is on at {percentage, number, percent}"
        },
        flagPercentageRollout: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-percentage-rollout",
            "defaultMessage": "{featureFlagPercentageRollout, number, percent}"
        }
    });
});
parcelRegister("clzRD", function(module, exports) {
    $parcel$export(module.exports, "MoreButton", ()=>$7d33bc58ccaeacb1$export$7f94856880993f27);
    $parcel$export(module.exports, "OnHoverVisibility", ()=>$7d33bc58ccaeacb1$export$e7937791cac9c51b);
    var $04lFO;
    var $4Bkdr;
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $3oUqw;
    var $gtreQ;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $hnzOX;
    var $8vfmT;
    var $dLN1S;
    const $7d33bc58ccaeacb1$export$7f94856880993f27 = ({ jiraIssue: jiraIssue, jiraVersion: jiraVersion, hasWarnings: hasWarnings, hasOpenPullRequestWarning: hasOpenPullRequestWarning, hasFailingBuildsWarning: hasFailingBuildsWarning, hasUnreviewedCodeWarning: hasUnreviewedCodeWarning, hasOpenReviewWarning: hasOpenReviewWarning })=>{
        const issue = (0, $8Uumt.useFragment)((0, (0, parcelRequire("4Bkdr")).default), jiraIssue);
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("04lFO")).default), jiraVersion);
        const [isPopupOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [moveIssuesBetweenVersionsQueryReference, loadMoveIssuesBetweenVersionsQuery] = (0, (0, parcelRequire("8vfmT")).useMoveIssuesBetweenVersionsQuery)(version.project.id, 4, version.id);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const togglePopup = ()=>{
            if (hasWarnings) {
                const warnings = [];
                if (hasOpenPullRequestWarning) warnings.push('OPEN_PULL_REQUEST');
                if (hasFailingBuildsWarning) warnings.push('FAILING_BUILD');
                if (hasUnreviewedCodeWarning) warnings.push('UNREVIEWED_CODE');
                if (hasOpenReviewWarning) warnings.push('OPEN_REVIEW');
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'IssueWarningMoreButton'
                }), {
                    warnings: warnings.toString()
                });
            }
            if (moveIssuesBetweenVersionsQueryReference == null) loadMoveIssuesBetweenVersionsQuery();
            setIsOpen(!isPopupOpen);
        };
        const handlePopupClose = ()=>{
            setIsOpen(false);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7d33bc58ccaeacb1$export$e7937791cac9c51b, null, (!!version.canAddAndRemoveIssues || hasWarnings) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hnzOX")).default), {
            renderTrigger: ({ triggerProps: triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...triggerProps,
                    iconBefore: hasWarnings ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.more-button.issue-card-warning-more-button",
                        primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y500})`,
                        label: formatMessage((0, (0, parcelRequire("dLN1S")).default).moreVersions),
                        size: "medium"
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))), {
                        label: formatMessage((0, (0, parcelRequire("dLN1S")).default).moreVersions)
                    }),
                    onClick: togglePopup,
                    onMouseOver: loadMoveIssuesBetweenVersionsQuery,
                    appearance: "subtle",
                    isSelected: isPopupOpen
                }),
            queryReference: moveIssuesBetweenVersionsQueryReference,
            jiraIssue: issue,
            onClose: handlePopupClose,
            isOpen: isPopupOpen
        }));
    };
    const $7d33bc58ccaeacb1$export$e7937791cac9c51b = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1ylp _1wtl15vq _j9irewfl"
            ])
        }, children);
    const $7d33bc58ccaeacb1$var$styles = null;
});
parcelRegister("04lFO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7486d8f786777ea9$export$2e2bcd8739ae039);
    const $7486d8f786777ea9$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraVersion",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v0,
                    "action": "THROW",
                    "path": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "canAddAndRemoveIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "project.id"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "project"
                }
            ],
            "type": "JiraVersion"
        };
    }();
    $7486d8f786777ea9$var$node.hash = "e838cd21a0e90d2500f678bc796ae098";
    var $7486d8f786777ea9$export$2e2bcd8739ae039 = $7486d8f786777ea9$var$node;
});
parcelRegister("4Bkdr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$68adbcce61fa137c$export$2e2bcd8739ae039);
    const $68adbcce61fa137c$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue"
            }
        ],
        "type": "JiraIssue"
    };
    $68adbcce61fa137c$var$node.hash = "fae4c5ea4895f8ef68f1e0800962eb5d";
    var $68adbcce61fa137c$export$2e2bcd8739ae039 = $68adbcce61fa137c$var$node;
});
parcelRegister("hnzOX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34a1c6585b01a6bb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $34a1c6585b01a6bb$var$MoveVersions = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("3ZnwB")).then((mod)=>mod.default), {
        moduleId: "./src/packages/releases/move-issues-between-versions/src/index.tsx"
    });
    var $34a1c6585b01a6bb$export$2e2bcd8739ae039 = ({ renderTrigger: renderTrigger, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async.jira.move.issues.between.versions",
            packageName: "jira-software-releases-move-issues-between-versions",
            teamName: "fusion-solaris"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "move-issues-between-versions",
            fallback: renderTrigger({
                triggerProps: {},
                isLoading: true,
                isSelected: false
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($34a1c6585b01a6bb$var$MoveVersions, {
            renderTrigger: renderTrigger,
            ...props
        })));
});
parcelRegister("3ZnwB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7EfGG").then(()=>parcelRequire('kxqkS'));
});
parcelRegister("8vfmT", function(module, exports) {
    $parcel$export(module.exports, "useMoveIssuesBetweenVersionsQuery", ()=>$7a42401a5a2ee9e1$export$4d5ca68749a2d51a);
    $parcel$export(module.exports, "MoveIssuesBetweenVersions", ()=>$7a42401a5a2ee9e1$export$1113ac51f1804da9);
    var $dyZnA;
    var $lIQhE;
    var $fZROX;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $1R1Ge;
    var $i8Qvm;
    var $1I7E8;
    var $9fuVs;
    var $39xOx;
    var $lfTZh;
    var $fZROX;
    var $npYQQ;
    var $gtvcr;
    var $hugbT;
    const $7a42401a5a2ee9e1$export$4d5ca68749a2d51a = (projectAri, first, versionAri)=>{
        const [queryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("fZROX")).default));
        return [
            queryRef,
            ()=>loadQuery({
                    projectAri: projectAri,
                    first: first,
                    versionAri: versionAri
                }, {
                    fetchPolicy: 'store-or-network'
                })
        ];
    };
    const $7a42401a5a2ee9e1$export$56eba4b61234c117 = ({ queryReference: queryReference, jiraIssue: jiraIssue, onClose: onClose, isVersionPickerModalOpen: isVersionPickerModalOpen, setIsVersionPickerModalOpen: setIsVersionPickerModalOpen })=>{
        const { jira: jira } = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("fZROX")).default), queryReference);
        const issue = (0, $8Uumt.useFragment)((0, (0, parcelRequire("lIQhE")).default), jiraIssue);
        const { version: version, versionsForProject: versionsForProject } = jira;
        const handleClose = ()=>{
            setIsVersionPickerModalOpen(false);
            onClose();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hugbT")).VersionList), {
            jiraVersionEdges: versionsForProject.edges.filter(Boolean),
            jiraIssue: issue,
            jiraVersion: version,
            onVersionPickerModalOpen: ()=>{
                setIsVersionPickerModalOpen(true);
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isVersionPickerModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "jira.move.issues.between.versions.version.picker",
            packageName: "jira-software-releases-move-issues-between-versions",
            teamName: "fusion-solaris",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            testId: "software-releases-move-issues-between-versions.ui.move-issue-version-select-modal",
            autoFocus: false,
            width: "small",
            onClose: handleClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gtvcr")).VersionPicker), {
            jiraVersion: version,
            jiraIssue: issue,
            onClose: handleClose
        }))))));
    };
    const $7a42401a5a2ee9e1$export$1113ac51f1804da9 = ({ renderTrigger: renderTrigger, jiraIssue: jiraIssue, queryReference: queryReference, isOpen: isOpen, onClose: onClose })=>{
        const [isVersionPickerModalOpen, setIsVersionPickerModalOpen] = (0, $5uXOq.useState)(false);
        const handleClose = ()=>{
            if (!isVersionPickerModalOpen) onClose();
        };
        const issue = (0, $8Uumt.useFragment)((0, (0, parcelRequire("dyZnA")).default), jiraIssue);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7a42401a5a2ee9e1$var$HoverVisibilityControlWrapper, {
            isVisible: isOpen
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            autoFocus: false,
            onClose: handleClose,
            placement: "left-start",
            fallbackPlacements: [
                'left-end'
            ],
            content: ()=>queryReference != null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                    name: "move-issues-between-versions-popup-content",
                    fallback: null
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    "data-version-details-issue-click-ignore-target": (0, (0, parcelRequire("npYQQ")).ISSUE_CARD_CLICK_IGNORE_TARGET)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($7a42401a5a2ee9e1$export$56eba4b61234c117, {
                    isVersionPickerModalOpen: isVersionPickerModalOpen,
                    jiraIssue: issue,
                    onClose: onClose,
                    queryReference: queryReference,
                    setIsVersionPickerModalOpen: setIsVersionPickerModalOpen
                }))) : null,
            trigger: (triggerProps)=>renderTrigger({
                    triggerProps: triggerProps,
                    isSelected: isOpen,
                    isLoading: false
                })
        }));
    };
    const $7a42401a5a2ee9e1$var$HoverVisibilityControlWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isVisible: isVisible, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.isVisible ? "_3um0ewfl" : "_3um015vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dyZnA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc3bfeeb04099ed$export$2e2bcd8739ae039);
    const $7cc3bfeeb04099ed$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue"
            }
        ],
        "type": "JiraIssue"
    };
    $7cc3bfeeb04099ed$var$node.hash = "a82d3697e92fea96f21c1bc4281c03e5";
    var $7cc3bfeeb04099ed$export$2e2bcd8739ae039 = $7cc3bfeeb04099ed$var$node;
});
parcelRegister("lIQhE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22f5da28b42399c7$export$2e2bcd8739ae039);
    const $22f5da28b42399c7$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionPicker_VersionPicker_jiraIssue"
            }
        ],
        "type": "JiraIssue"
    };
    $22f5da28b42399c7$var$node.hash = "a7d48e98e04811f2286b41cb01a9419a";
    var $22f5da28b42399c7$export$2e2bcd8739ae039 = $22f5da28b42399c7$var$node;
});
parcelRegister("fZROX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83962715aa1bd50d$export$2e2bcd8739ae039);
    const $83962715aa1bd50d$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionAri"
        }, v3 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "versionAri"
            }
        ], v4 = {
            "kind": "Literal",
            "name": "filter",
            "value": [
                "UNRELEASED"
            ]
        }, v5 = {
            "kind": "Variable",
            "name": "jiraProjectId",
            "variableName": "projectAri"
        }, v6 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v7 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v8 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v9 = {
            "kind": "ScalarField",
            "name": "id"
        }, v10 = {
            "kind": "ScalarField",
            "name": "versionId"
        }, v11 = [
            v4,
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
            },
            v5
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2
                ],
                "kind": "Fragment",
                "name": "uiMoveIssuesBetweenVersionsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v3,
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ui_softwareReleasesVersionPicker_VersionPicker_jiraVersion"
                                                    }
                                                ],
                                                "type": "JiraVersion"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.version"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": "versionsForProject",
                                        "args": [
                                            v4,
                                            v5
                                        ],
                                        "concreteType": "JiraVersionConnection",
                                        "kind": "LinkedField",
                                        "name": "__moveIssuesBetweenVersions_versionsForProject_connection",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraVersionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges"
                                                        },
                                                        v6,
                                                        {
                                                            "concreteType": "JiraVersion",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v7
                                                            ]
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.versionsForProject.edges"
                                            },
                                            v8
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.versionsForProject"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0,
                    v2
                ],
                "kind": "Operation",
                "name": "uiMoveIssuesBetweenVersionsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v7,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v9,
                                            v10,
                                            {
                                                "kind": "ScalarField",
                                                "name": "canAddAndRemoveIssues"
                                            },
                                            {
                                                "concreteType": "JiraVersionWarningConfig",
                                                "kind": "LinkedField",
                                                "name": "warningConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "openPullRequest"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "openReview"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "unreviewedCode"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "failingBuild"
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectId"
                                                    },
                                                    v9
                                                ]
                                            }
                                        ],
                                        "type": "JiraVersion"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v9
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            },
                            {
                                "args": v11,
                                "concreteType": "JiraVersionConnection",
                                "kind": "LinkedField",
                                "name": "versionsForProject",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersionEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraVersion",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v10,
                                                    v9,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    },
                                                    v7
                                                ]
                                            },
                                            v6
                                        ]
                                    },
                                    v8
                                ]
                            },
                            {
                                "args": v11,
                                "filters": [
                                    "jiraProjectId",
                                    "filter"
                                ],
                                "handle": "connection",
                                "key": "moveIssuesBetweenVersions_versionsForProject",
                                "kind": "LinkedHandle",
                                "name": "versionsForProject"
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "0c62d9f35893c4558aa832a3da78fb1119e9bb8ef77a3c044ed4fd5a3679820f",
                "metadata": {
                    "connection": [
                        {
                            "count": "first",
                            "cursor": null,
                            "direction": "forward",
                            "path": [
                                "jira",
                                "versionsForProject"
                            ]
                        }
                    ]
                },
                "name": "uiMoveIssuesBetweenVersionsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $83962715aa1bd50d$var$node.hash = "58c061e61158c45d3f183de8ea9ac7ab";
    var $83962715aa1bd50d$export$2e2bcd8739ae039 = $83962715aa1bd50d$var$node;
});
parcelRegister("gtvcr", function(module, exports) {
    $parcel$export(module.exports, "VersionPicker", ()=>$f0f3778e1550dd46$export$c7c815960e157d78);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7QSqG;
    var $eZJjh;
    var $lfTZh;
    var $kxZPA;
    const $f0f3778e1550dd46$var$LazyVersionsPicker = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("gKwTW")).then((module)=>module.VersionPicker), {
        moduleId: "./src/packages/releases/version-picker/src/ui/index.tsx"
    });
    const $f0f3778e1550dd46$var$LoadingModal = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($f0f3778e1550dd46$export$43a792a870d28db2, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large"
        })));
    const $f0f3778e1550dd46$export$c7c815960e157d78 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "version-picker",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($f0f3778e1550dd46$var$LoadingModal, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f0f3778e1550dd46$var$LazyVersionsPicker, props));
    const $f0f3778e1550dd46$export$43a792a870d28db2 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1lit",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("gKwTW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jt5C4").then(()=>parcelRequire('clYwT'));
});
parcelRegister("hugbT", function(module, exports) {
    $parcel$export(module.exports, "VersionList", ()=>$b916df3f72fe85dc$export$e1d14e02661b0653);
    var $3RlKc;
    var $hpfFy;
    var $ju0Iw;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $kJpBP;
    var $4mNf3;
    var $eZUJu;
    var $9UCCQ;
    var $koVbs;
    var $cDRap;
    var $12diM;
    var $ghxT9;
    var $d7ygY;
    const $b916df3f72fe85dc$export$e1d14e02661b0653 = ({ jiraVersionEdges: jiraVersionEdges, jiraIssue: jiraIssue, jiraVersion: jiraVersion, onVersionPickerModalOpen: onVersionPickerModalOpen })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const versions = (0, $8Uumt.useFragment)((0, (0, parcelRequire("ju0Iw")).default), jiraVersionEdges);
        const issue = (0, $8Uumt.useFragment)((0, (0, parcelRequire("hpfFy")).default), jiraIssue);
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("3RlKc")).default), jiraVersion);
        const originalJiraVersion = version.id;
        const allVersions = versions.filter(Boolean).filter((object)=>object.node.versionId !== version.versionId);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), {
            maxWidth: 221
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cDRap")).IssueWarning), {
            jiraIssue: issue,
            jiraVersion: version
        }), !!version.canAddAndRemoveIssues && allVersions.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4mNf3")).default), null, formatMessage((0, (0, parcelRequire("12diM")).default).versionsListHeader)), allVersions.map((edge)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghxT9")).MoveIssueToOtherVersion), {
                originalJiraVersion: originalJiraVersion,
                jiraVersion: edge.node,
                key: edge.node.versionId,
                jiraIssue: issue
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: onVersionPickerModalOpen
        }, formatMessage((0, (0, parcelRequire("12diM")).default).otherVersionsButton))) : null, !!version.canAddAndRemoveIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7ygY")).RemoveIssueFromVersion), {
            originalJiraVersion: originalJiraVersion,
            jiraIssue: issue
        }));
    };
});
parcelRegister("3RlKc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1d7d9e7aafd254a5$export$2e2bcd8739ae039);
    const $1d7d9e7aafd254a5$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "versionId"
                },
                "action": "THROW",
                "path": "versionId"
            },
            {
                "kind": "ScalarField",
                "name": "canAddAndRemoveIssues"
            },
            {
                "kind": "FragmentSpread",
                "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
            }
        ],
        "type": "JiraVersion"
    };
    $1d7d9e7aafd254a5$var$node.hash = "3401c25196bed99e751ba57506a3021b";
    var $1d7d9e7aafd254a5$export$2e2bcd8739ae039 = $1d7d9e7aafd254a5$var$node;
});
parcelRegister("hpfFy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64c032cce39f1530$export$2e2bcd8739ae039);
    const $64c032cce39f1530$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "FragmentSpread",
                "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
            },
            {
                "kind": "FragmentSpread",
                "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions"
            },
            {
                "kind": "FragmentSpread",
                "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
            }
        ],
        "type": "JiraIssue"
    };
    $64c032cce39f1530$var$node.hash = "9dbec216043d11ab3ebbdd111e565798";
    var $64c032cce39f1530$export$2e2bcd8739ae039 = $64c032cce39f1530$var$node;
});
parcelRegister("ju0Iw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed43ad65a8d3006b$export$2e2bcd8739ae039);
    const $ed43ad65a8d3006b$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "versionId"
                            },
                            "action": "NONE",
                            "path": "node.versionId"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
                        }
                    ]
                },
                "action": "NONE",
                "path": "node"
            }
        ],
        "type": "JiraVersionEdge"
    };
    $ed43ad65a8d3006b$var$node.hash = "62c56f9fefcd51f7cc6feffc9b24ce64";
    var $ed43ad65a8d3006b$export$2e2bcd8739ae039 = $ed43ad65a8d3006b$var$node;
});
parcelRegister("cDRap", function(module, exports) {
    $parcel$export(module.exports, "IssueWarning", ()=>$6c35bf5e55596cfb$export$40ff2db377648cee);
    var $jaCvM;
    var $iEQdG;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $4mNf3;
    var $9UCCQ;
    var $koVbs;
    var $9lAUN;
    var $ijekY;
    const $6c35bf5e55596cfb$export$40ff2db377648cee = ({ jiraIssue: jiraIssue, jiraVersion: jiraVersion })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const issue = (0, $8Uumt.useFragment)((0, (0, parcelRequire("iEQdG")).default), jiraIssue);
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("jaCvM")).default), jiraVersion);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9lAUN")).IssueWarningProvider), {
            jiraVersion: version,
            jiraIssue: issue
        }, ({ hasOpenPullRequestWarning: hasOpenPullRequestWarning, hasFailingBuildsWarning: hasFailingBuildsWarning, hasUnreviewedCodeWarning: hasUnreviewedCodeWarning, hasOpenReviewWarning: hasOpenReviewWarning })=>{
            const warningsMessages = [];
            if (hasOpenPullRequestWarning) warningsMessages.push((0, (0, parcelRequire("ijekY")).default).openPullRequest);
            if (hasFailingBuildsWarning) warningsMessages.push((0, (0, parcelRequire("ijekY")).default).failingBuilds);
            if (hasUnreviewedCodeWarning) warningsMessages.push((0, (0, parcelRequire("ijekY")).default).unreviewedCode);
            if (hasOpenReviewWarning) warningsMessages.push((0, (0, parcelRequire("ijekY")).default).openReviews);
            if (warningsMessages.length === 1) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4mNf3")).default), null, formatMessage((0, (0, parcelRequire("ijekY")).default).issueWarningHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement($6c35bf5e55596cfb$var$WarningDescription, null, formatMessage((0, (0, parcelRequire("ijekY")).default).issueWarning, {
                warning: formatMessage(warningsMessages[0])
            })));
            if (warningsMessages.length > 1) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4mNf3")).default), null, formatMessage((0, (0, parcelRequire("ijekY")).default).issueWarningHeader)), (0, ($parcel$interopDefault($5uXOq))).createElement($6c35bf5e55596cfb$var$WarningDescription, null, formatMessage((0, (0, parcelRequire("ijekY")).default).issueMultipleWarnings)), (0, ($parcel$interopDefault($5uXOq))).createElement($6c35bf5e55596cfb$var$List, null, warningsMessages.map((warning)=>(0, ($parcel$interopDefault($5uXOq))).createElement($6c35bf5e55596cfb$var$ListItem, {
                    key: warning.id
                }, formatMessage(warning)))));
            return null;
        });
    };
    const $6c35bf5e55596cfb$var$ListItem = (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syazhoca",
                __cmplp.className
            ])
        });
    });
    const $6c35bf5e55596cfb$var$List = (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyrgktf _18u0idpf",
                __cmplp.className
            ])
        });
    });
    const $6c35bf5e55596cfb$var$WarningDescription = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt494j5 _syazhoca",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jaCvM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d31575f3bb7188a$export$2e2bcd8739ae039);
    const $9d31575f3bb7188a$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion"
            }
        ],
        "type": "JiraVersion"
    };
    $9d31575f3bb7188a$var$node.hash = "4337c06001af5c62a61021cb3fd03fad";
    var $9d31575f3bb7188a$export$2e2bcd8739ae039 = $9d31575f3bb7188a$var$node;
});
parcelRegister("iEQdG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4818d7c9fa4b9c8a$export$2e2bcd8739ae039);
    const $4818d7c9fa4b9c8a$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue"
            }
        ],
        "type": "JiraIssue"
    };
    $4818d7c9fa4b9c8a$var$node.hash = "c07bf95905363410cf22a75dbe9a1754";
    var $4818d7c9fa4b9c8a$export$2e2bcd8739ae039 = $4818d7c9fa4b9c8a$var$node;
});
parcelRegister("ijekY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c20a1f7edd5d622a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c20a1f7edd5d622a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueWarningHeader: {
            "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-warning-header",
            "defaultMessage": "Warning"
        },
        issueWarning: {
            "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-warning",
            "defaultMessage": "This issue has {warning}"
        },
        issueMultipleWarnings: {
            "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-multiple-warnings",
            "defaultMessage": "This issue is done but has:"
        },
        openPullRequest: {
            "id": "software-releases-move-issues-between-versions.version-list.issue-warning.open-pull-request",
            "defaultMessage": "open pull requests"
        },
        failingBuilds: {
            "id": "software-releases-move-issues-between-versions.version-list.issue-warning.failing-builds",
            "defaultMessage": "failing builds"
        },
        unreviewedCode: {
            "id": "software-releases-move-issues-between-versions.version-list.issue-warning.unreviewed-code",
            "defaultMessage": "unreviewed code"
        },
        openReviews: {
            "id": "software-releases-move-issues-between-versions.version-list.issue-warning.open-reviews",
            "defaultMessage": "open reviews"
        }
    });
});
parcelRegister("12diM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b93b84580cc1a62$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5b93b84580cc1a62$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        versionsListHeader: {
            "id": "software-releases-move-issues-between-versions.version-list.versions-list-header",
            "defaultMessage": "Move to"
        },
        otherVersionsButton: {
            "id": "software-releases-move-issues-between-versions.version-list.other-versions-button",
            "defaultMessage": "View all versions"
        }
    });
});
parcelRegister("ghxT9", function(module, exports) {
    $parcel$export(module.exports, "MoveIssueToOtherVersion", ()=>$9b7a96e7adf02006$export$7bc266f2ce749644);
    var $d4bqt;
    var $lUTEp;
    var $4lOqP;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $kJpBP;
    var $jcw0u;
    var $4R6GH;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $kfztd;
    var $20fNh;
    var $5GInV;
    var $S0LGk;
    var $lk6rS;
    const $9b7a96e7adf02006$export$7bc266f2ce749644 = ({ jiraVersion: jiraVersion, jiraIssue: jiraIssue, originalJiraVersion: originalJiraVersion })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const issue = (0, $8Uumt.useFragment)((0, (0, parcelRequire("4lOqP")).default), jiraIssue);
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("lUTEp")).default), jiraVersion);
        const [moveIssuesToFixVersion] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("d4bqt")).default));
        const { filters: filters, sortBy: sortBy } = (0, (0, parcelRequire("20fNh")).useVersionIssuesGraphQLVariables)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const experienceStart = (0, (0, parcelRequire("5GInV")).useMoveIssuesBetweenVersionsExperienceStart)();
        const experienceFail = (0, (0, parcelRequire("5GInV")).useMoveIssuesBetweenVersionsExperienceFail)();
        const experienceSuccess = (0, (0, parcelRequire("5GInV")).useMoveIssuesBetweenVersionsExperienceSuccess)();
        const onError = (err)=>{
            showFlag({
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("S0LGk")).default).errorFlagDescription, {
                    issueKey: issue.key,
                    versionName: version.name
                })
            });
            experienceFail('graphql error', err);
            (0, (0, parcelRequire("jcw0u")).default)({
                error: err,
                meta: {
                    id: 'jira.releases.remove-issue-from-version.mutation',
                    packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                    teamName: 'fusion-solaris'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const onErrorWithPermissionValidationEnabled = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission)=>{
            const error = (0, (0, parcelRequire("lk6rS")).getErrorMessage)(issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage);
            showFlag({
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("S0LGk")).default).errorFlagTitle),
                description: error
            });
            experienceFail('graphql error', new Error(error));
            (0, (0, parcelRequire("jcw0u")).default)({
                error: new Error(error),
                meta: {
                    id: 'jira.releases.remove-issue-from-version.mutation',
                    packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                    teamName: 'fusion-solaris'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const onUpdateVersion = ()=>{
            moveIssuesToFixVersion({
                variables: {
                    input: {
                        issueIds: [
                            issue.id
                        ],
                        originalVersionId: originalJiraVersion,
                        targetVersionId: version.id
                    },
                    isDevopsFeatureDisabledInFedRamp: (0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)(),
                    isIssueSummarisedDeploymentsMigratedToAgs: (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re'),
                    shouldIncludeDevOpsFieldsViaAgs: !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re'),
                    filters: filters,
                    sortBy: sortBy
                },
                onCompleted: (data)=>{
                    if (data?.jira?.moveIssuesToFixVersion?.success !== true) onErrorWithPermissionValidationEnabled(issue.key, data?.jira?.moveIssuesToFixVersion?.issuesWithMissingResolvePermission, data?.jira?.moveIssuesToFixVersion?.issuesWithMissingEditPermission);
                    else {
                        const flagText = formatMessage((0, (0, parcelRequire("S0LGk")).default).successFlagDescription, {
                            issueKey: issue.key,
                            versionName: version.name
                        });
                        showFlag({
                            type: 'success',
                            title: flagText
                        });
                        experienceSuccess();
                    }
                },
                onError: onError
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'moveIssueToVersion');
                experienceStart();
                onUpdateVersion();
            }
        }, version.name);
    };
});
parcelRegister("d4bqt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$347899009fdc432b$export$2e2bcd8739ae039);
    const $347899009fdc432b$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filters"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isIssueSummarisedDeploymentsMigratedToAgs"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldIncludeDevOpsFieldsViaAgs"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sortBy"
        }, v6 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v7 = {
            "kind": "ScalarField",
            "name": "success"
        }, v8 = [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ], v9 = {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": v8
        }, v10 = {
            "kind": "ScalarField",
            "name": "issuesWithMissingResolvePermission"
        }, v11 = {
            "kind": "ScalarField",
            "name": "issuesWithMissingEditPermission"
        }, v12 = {
            "kind": "ScalarField",
            "name": "id"
        }, v13 = {
            "kind": "Literal",
            "name": "filter",
            "value": "ALL"
        }, v14 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v15 = [
            v14
        ], v16 = {
            "kind": "ScalarField",
            "name": "key"
        }, v17 = {
            "kind": "ScalarField",
            "name": "collapsedUis"
        }, v18 = {
            "kind": "ScalarField",
            "name": "canEdit"
        }, v19 = {
            "kind": "ScalarField",
            "name": "status"
        }, v20 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v21 = {
            "kind": "ScalarField",
            "name": "accountId"
        }, v22 = {
            "kind": "ScalarField",
            "name": "name"
        }, v23 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v24 = {
            "kind": "ScalarField",
            "name": "description"
        }, v25 = [
            v13,
            {
                "kind": "Variable",
                "name": "filters",
                "variableName": "filters"
            },
            {
                "kind": "Literal",
                "name": "first",
                "value": 20
            },
            {
                "kind": "Variable",
                "name": "sortBy",
                "variableName": "sortBy"
            }
        ], v26 = {
            "kind": "ScalarField",
            "name": "count"
        }, v27 = {
            "kind": "ScalarField",
            "name": "state"
        }, v28 = {
            "concreteType": "DevOpsSummarisedBuildState",
            "kind": "LinkedField",
            "name": "buildStates",
            "plural": true,
            "selections": [
                v27,
                v26
            ]
        }, v29 = [
            v26
        ], v30 = {
            "concreteType": "DevOpsSummarisedFeatureFlags",
            "kind": "LinkedField",
            "name": "summarisedFeatureFlags",
            "plural": false,
            "selections": [
                v14,
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantDisplayName"
                },
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantEnabled"
                },
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantRolloutPercentage"
                }
            ]
        }, v31 = {
            "kind": "ScalarField",
            "name": "title"
        }, v32 = [
            v26,
            v12
        ], v33 = {
            "concreteType": "DevOpsSummarisedDeployments",
            "kind": "LinkedField",
            "name": "summarisedDeployments",
            "plural": false,
            "selections": v32
        }, v34 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v35 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v36 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 100
            }
        ], v37 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5
                ],
                "kind": "Fragment",
                "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v6,
                                "concreteType": "JiraMoveIssuesToFixVersionPayload",
                                "kind": "LinkedField",
                                "name": "moveIssuesToFixVersion",
                                "plural": false,
                                "selections": [
                                    v7,
                                    v9,
                                    v10,
                                    v11,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "originalVersion",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v5,
                    v0,
                    v2,
                    v3,
                    v4
                ],
                "kind": "Operation",
                "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v6,
                                "concreteType": "JiraMoveIssuesToFixVersionPayload",
                                "kind": "LinkedField",
                                "name": "moveIssuesToFixVersion",
                                "plural": false,
                                "selections": [
                                    v7,
                                    v9,
                                    v10,
                                    v11,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "originalVersion",
                                        "plural": false,
                                        "selections": [
                                            v12,
                                            {
                                                "kind": "ScalarField",
                                                "name": "canEditRelatedWork"
                                            },
                                            {
                                                "alias": "allIssues",
                                                "args": [
                                                    v13
                                                ],
                                                "concreteType": "JiraIssueConnection",
                                                "kind": "LinkedField",
                                                "name": "issues",
                                                "plural": false,
                                                "selections": v15,
                                                "storageKey": "issues(filter:\"ALL\")"
                                            },
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": [
                                                    v12,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectId"
                                                    },
                                                    v16,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "cloudId"
                                                    }
                                                ]
                                            },
                                            {
                                                "alias": "allIssuesRedesignTemp",
                                                "concreteType": "JiraIssueConnection",
                                                "kind": "LinkedField",
                                                "name": "issues",
                                                "plural": false,
                                                "selections": v15
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "canAddAndRemoveIssues"
                                            },
                                            v17,
                                            v18,
                                            {
                                                "kind": "ScalarField",
                                                "name": "startDate"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "releaseDate"
                                            },
                                            v19,
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionId"
                                            },
                                            {
                                                "concreteType": "JiraVersionDriverResult",
                                                "kind": "LinkedField",
                                                "name": "driverData",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "driver",
                                                        "plural": false,
                                                        "selections": [
                                                            v20,
                                                            v21,
                                                            v22,
                                                            v23,
                                                            v12
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "queryError",
                                                        "plural": false,
                                                        "selections": v8
                                                    }
                                                ]
                                            },
                                            v24,
                                            v22,
                                            {
                                                "concreteType": "JiraVersionWarningConfig",
                                                "kind": "LinkedField",
                                                "name": "warningConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "openPullRequest"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "openReview"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "unreviewedCode"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "failingBuild"
                                                    },
                                                    v18
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraVersionConnectAddonIframeData",
                                                "kind": "LinkedField",
                                                "name": "connectAddonIframeData",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "appKey"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "moduleKey"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "appName"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "location"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "options"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "canViewDevTools"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionIssueTableHiddenColumns"
                                            },
                                            {
                                                "alias": "issuesForList",
                                                "args": v25,
                                                "concreteType": "JiraIssueConnection",
                                                "kind": "LinkedField",
                                                "name": "issues",
                                                "plural": false,
                                                "selections": [
                                                    v14,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "jql"
                                                    },
                                                    {
                                                        "concreteType": "JiraIssueEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssue",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v16,
                                                                    v12,
                                                                    {
                                                                        "args": [
                                                                            {
                                                                                "kind": "Literal",
                                                                                "name": "ids",
                                                                                "value": [
                                                                                    "priority",
                                                                                    "summary",
                                                                                    "assignee",
                                                                                    "status",
                                                                                    "issuetype"
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "concreteType": "JiraIssueFieldConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "fieldsById",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v20,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "fieldId"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraStatus",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "status",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraStatusCategory",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "statusCategory",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "statusCategoryId"
                                                                                                                    },
                                                                                                                    v12
                                                                                                                ]
                                                                                                            },
                                                                                                            v12,
                                                                                                            v22,
                                                                                                            v24
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraStatusField"
                                                                                            },
                                                                                            v12,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "user",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v20,
                                                                                                            v23,
                                                                                                            v22,
                                                                                                            v12
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraSingleSelectUserPickerField"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "text"
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraSingleLineTextField"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueType",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "issueType",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v22,
                                                                                                            {
                                                                                                                "concreteType": "JiraAvatar",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "avatar",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "xsmall"
                                                                                                                    }
                                                                                                                ]
                                                                                                            },
                                                                                                            v12
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraIssueTypeField"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraPriority",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "priority",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v22,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "iconUrl"
                                                                                                            },
                                                                                                            v12
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraPriorityField"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueId"
                                                                    },
                                                                    v20,
                                                                    {
                                                                        "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                        "kind": "Condition",
                                                                        "passingValue": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "DevOpsSummarisedEntities",
                                                                                "kind": "LinkedField",
                                                                                "name": "devOpsSummarisedEntities",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "DevOpsSummarisedBuilds",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "summarisedBuilds",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v26,
                                                                                            v28,
                                                                                            v12
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "DevOpsSummarisedDeployments",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "summarisedDeployments",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "DevOpsEnvironment",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "deploymentEnvironment",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "category"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "deploymentState"
                                                                                            },
                                                                                            v12
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                                        "kind": "Condition",
                                                                                        "passingValue": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "DevOpsSummarisedDeployments",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "summarisedDeployments",
                                                                                                "plural": false,
                                                                                                "selections": v29
                                                                                            },
                                                                                            v30
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "concreteType": "JiraIssueDevSummaryResult",
                                                                                "kind": "LinkedField",
                                                                                "name": "devSummaryCache",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueDevSummary",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "devSummary",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "pullrequest",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "overall",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v26,
                                                                                                            v27
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "branch",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueBranchDevSummary",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "overall",
                                                                                                        "plural": false,
                                                                                                        "selections": v29
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "review",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueReviewDevSummary",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "overall",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v26,
                                                                                                            v27,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "lastUpdated"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "stateCount"
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "summaryByProvider",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "providerId"
                                                                                                            },
                                                                                                            v22,
                                                                                                            v26
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "commit",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueCommitDevSummary",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "overall",
                                                                                                        "plural": false,
                                                                                                        "selections": v29
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "build",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueBuildDevSummary",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "overall",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v26,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "failedBuildCount"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "successfulBuildCount"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "unknownBuildCount"
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "deploymentEnvironments",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "overall",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "topEnvironments",
                                                                                                                "plural": true,
                                                                                                                "selections": [
                                                                                                                    v19,
                                                                                                                    v31
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": [
                                                                                    v33,
                                                                                    {
                                                                                        "concreteType": "DevOpsSummarisedBuilds",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "summarisedBuilds",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v28,
                                                                                            v26,
                                                                                            v12
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": [
                                                                                    v30
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            v33,
                                                                            {
                                                                                "concreteType": "DevOpsSummarisedBuilds",
                                                                                "kind": "LinkedField",
                                                                                "name": "summarisedBuilds",
                                                                                "plural": false,
                                                                                "selections": v32
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                                "kind": "LinkedField",
                                                                                "name": "summarisedFeatureFlags",
                                                                                "plural": false,
                                                                                "selections": v15
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            v34
                                                        ]
                                                    },
                                                    v35
                                                ]
                                            },
                                            {
                                                "alias": "issuesForList",
                                                "args": v25,
                                                "filters": [
                                                    "filter",
                                                    "sortBy",
                                                    "filters"
                                                ],
                                                "handle": "connection",
                                                "key": "ListVersion_issuesForList",
                                                "kind": "LinkedHandle",
                                                "name": "issues"
                                            },
                                            v17,
                                            {
                                                "args": v36,
                                                "concreteType": "JiraVersionApproverConnection",
                                                "kind": "LinkedField",
                                                "name": "approvers",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionApproverEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraVersionApprover",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v12,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v20,
                                                                            v22,
                                                                            v23,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "extendedProfile",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "jobTitle"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "AtlassianAccountUser"
                                                                            },
                                                                            v12,
                                                                            v21
                                                                        ]
                                                                    },
                                                                    v19,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "declineReason"
                                                                    },
                                                                    v24,
                                                                    v37,
                                                                    v20
                                                                ]
                                                            },
                                                            v34
                                                        ]
                                                    },
                                                    v35
                                                ],
                                                "storageKey": "approvers(first:100)"
                                            },
                                            {
                                                "args": v36,
                                                "handle": "connection",
                                                "key": "version_approvers",
                                                "kind": "LinkedHandle",
                                                "name": "approvers"
                                            },
                                            {
                                                "concreteType": "JiraVersionRichTextSection",
                                                "kind": "LinkedField",
                                                "name": "richTextSection",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraADF",
                                                        "kind": "LinkedField",
                                                        "name": "content",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "json"
                                                            }
                                                        ]
                                                    },
                                                    v31
                                                ]
                                            },
                                            v37,
                                            {
                                                "condition": "isDevopsFeatureDisabledInFedRamp",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "DevOpsSummarisedEntities",
                                                        "kind": "LinkedField",
                                                        "name": "devOpsSummarisedEntities",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "DevOpsProviders",
                                                                "kind": "LinkedField",
                                                                "name": "providers",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsFeatureFlagProvider",
                                                                        "kind": "LinkedField",
                                                                        "name": "featureFlagProviders",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v20,
                                                                            v12,
                                                                            v22,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "createFeatureFlagTemplateUrl"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "connectFeatureFlagTemplateUrl"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "logoUrl"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "c2bc5c49bf7578201a82e5358091c5b8df368923d99b8a5e537de54110449e83",
                "metadata": {},
                "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $347899009fdc432b$var$node.hash = "678bdd4ff02d7ba9790ffbbad0483994";
    var $347899009fdc432b$export$2e2bcd8739ae039 = $347899009fdc432b$var$node;
});
parcelRegister("lUTEp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa929e2e516e29fb$export$2e2bcd8739ae039);
    const $aa929e2e516e29fb$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "name"
                },
                "action": "THROW",
                "path": "name"
            }
        ],
        "type": "JiraVersion"
    };
    $aa929e2e516e29fb$var$node.hash = "84a88afd5bdd1daa65b86ea3c2e3ac4e";
    var $aa929e2e516e29fb$export$2e2bcd8739ae039 = $aa929e2e516e29fb$var$node;
});
parcelRegister("4lOqP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$903c8d96330806be$export$2e2bcd8739ae039);
    const $903c8d96330806be$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "key"
            }
        ],
        "type": "JiraIssue"
    };
    $903c8d96330806be$var$node.hash = "970de75536631065f879841e95abf41b";
    var $903c8d96330806be$export$2e2bcd8739ae039 = $903c8d96330806be$var$node;
});
parcelRegister("5GInV", function(module, exports) {
    $parcel$export(module.exports, "useMoveIssuesBetweenVersionsExperienceStart", ()=>$aec61e2addafe240$export$b93744d3b3f8b975);
    $parcel$export(module.exports, "useMoveIssuesBetweenVersionsExperienceFail", ()=>$aec61e2addafe240$export$476b47bb3c16d45a);
    $parcel$export(module.exports, "useMoveIssuesBetweenVersionsExperienceSuccess", ()=>$aec61e2addafe240$export$a7bd95f0cc752718);
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    const $aec61e2addafe240$export$52919046b94109dc = 'moveIssueBetweenVersions';
    const $aec61e2addafe240$var$ANALYTICS_SOURCE = 'versionDetails';
    const $aec61e2addafe240$export$b93744d3b3f8b975 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: $aec61e2addafe240$export$52919046b94109dc,
            experienceId: `${Date.now()}`,
            analyticsSource: $aec61e2addafe240$var$ANALYTICS_SOURCE,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE),
            edition: appEditions.software
        });
    };
    const $aec61e2addafe240$export$476b47bb3c16d45a = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $aec61e2addafe240$export$52919046b94109dc
        });
    const $aec61e2addafe240$export$a7bd95f0cc752718 = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: $aec61e2addafe240$export$52919046b94109dc
        });
});
parcelRegister("S0LGk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7671e2cbd0abe366$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7671e2cbd0abe366$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.error-flag-title",
            "defaultMessage": "Can't move this issue to another version"
        },
        errorFlagDescription: {
            "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.error-flag-description",
            "defaultMessage": "We couldn't move {issueKey} to {versionName}. Please try again."
        },
        successFlagDescription: {
            "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.success-flag-description",
            "defaultMessage": "{issueKey} has been moved to {versionName}."
        },
        missingResolvePermissionErrorgFlagDescription: {
            "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-resolve-permission-errorg-flag-description",
            "defaultMessage": "You don't have permission to resolve {issueKey}, so you can't move it to another version."
        },
        missingEditPermissionErrorFlagDescription: {
            "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-edit-permission-error-flag-description",
            "defaultMessage": "You don't have permission to edit {issueKey}, so you can't move it to another version."
        },
        missingPermissionsErrorFlagDescription: {
            "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-permissions-error-flag-description",
            "defaultMessage": "You don't have permission to edit or resolve {issueKey}, so you can't move it to another version."
        }
    });
});
parcelRegister("lk6rS", function(module, exports) {
    $parcel$export(module.exports, "getErrorMessage", ()=>$af4587f909f032d4$export$82f46aa4e6535a45);
    var $S0LGk;
    const $af4587f909f032d4$export$82f46aa4e6535a45 = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage)=>{
        const issueIsMissingResolvePermission = issuesWithMissingResolvePermission !== null && issuesWithMissingResolvePermission !== undefined && issuesWithMissingResolvePermission.length > 0;
        const issueIsMissingEditPermission = issuesWithMissingEditPermission !== null && issuesWithMissingEditPermission !== undefined && issuesWithMissingEditPermission.length > 0;
        if (issueIsMissingResolvePermission && issueIsMissingEditPermission) return formatMessage((0, (0, parcelRequire("S0LGk")).default).missingPermissionsErrorFlagDescription, {
            issueKey: issueKey
        });
        if (issueIsMissingResolvePermission) return formatMessage((0, (0, parcelRequire("S0LGk")).default).missingResolvePermissionErrorgFlagDescription, {
            issueKey: issueKey
        });
        if (issueIsMissingEditPermission) return formatMessage((0, (0, parcelRequire("S0LGk")).default).missingEditPermissionErrorFlagDescription, {
            issueKey: issueKey
        });
        return formatMessage((0, (0, parcelRequire("S0LGk")).default).errorFlagDescription);
    };
});
parcelRegister("d7ygY", function(module, exports) {
    $parcel$export(module.exports, "RemoveIssueFromVersion", ()=>$fd3c14d5a3eb9058$export$d34fb821a58a3d5c);
    var $fq1A6;
    var $2uHyI;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $kJpBP;
    var $9UCCQ;
    var $jcw0u;
    var $4R6GH;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $kfztd;
    var $20fNh;
    var $68iZl;
    var $cMnUo;
    var $gMbdf;
    const $fd3c14d5a3eb9058$export$d34fb821a58a3d5c = ({ jiraIssue: jiraIssue, originalJiraVersion: originalJiraVersion })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const issue = (0, $8Uumt.useFragment)((0, (0, parcelRequire("2uHyI")).default), jiraIssue);
        const [removeIssuesFromFixVersion] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("fq1A6")).default));
        const { filters: filters, sortBy: sortBy } = (0, (0, parcelRequire("20fNh")).useVersionIssuesGraphQLVariables)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const experienceStart = (0, (0, parcelRequire("68iZl")).useRemoveIssueFromVersionExperienceStart)();
        const experienceFail = (0, (0, parcelRequire("68iZl")).useRemoveIssueFromVersionExperienceFail)();
        const experienceSuccess = (0, (0, parcelRequire("68iZl")).useRemoveIssueFromVersionExperienceSuccess)();
        const onError = (err)=>{
            showFlag({
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("cMnUo")).default).errorFlagDescription, {
                    issueKey: issue.key
                })
            });
            experienceFail('graphql error', err);
            (0, (0, parcelRequire("jcw0u")).default)({
                error: err,
                meta: {
                    id: 'jira.releases.remove-issue-from-version.mutation',
                    packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                    teamName: 'fusion-solaris'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const onErrorWithPermissionValidationEnabled = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission)=>{
            const error = (0, (0, parcelRequire("gMbdf")).getErrorMessage)(issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage);
            showFlag({
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("cMnUo")).default).errorFlagTitle),
                description: error
            });
            experienceFail('graphql error', new Error(error));
            (0, (0, parcelRequire("jcw0u")).default)({
                error: new Error(error),
                meta: {
                    id: 'jira.releases.remove-issue-from-version.mutation',
                    packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                    teamName: 'fusion-solaris'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const onUpdateVersion = ()=>{
            removeIssuesFromFixVersion({
                variables: {
                    input: {
                        issueIds: [
                            issue.id
                        ],
                        versionId: originalJiraVersion
                    },
                    isDevopsFeatureDisabledInFedRamp: (0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)(),
                    isIssueSummarisedDeploymentsMigratedToAgs: (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re'),
                    shouldIncludeDevOpsFieldsViaAgs: !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re'),
                    filters: filters,
                    sortBy: sortBy
                },
                onCompleted: (data)=>{
                    if (data?.jira?.removeIssuesFromFixVersion?.success !== true) {
                        const issuesWithMissingResolvePermission = data?.jira?.removeIssuesFromFixVersion?.issuesWithMissingResolvePermission || [];
                        const issuesWithMissingEditPermission = data?.jira?.removeIssuesFromFixVersion?.issuesWithMissingEditPermission || [];
                        onErrorWithPermissionValidationEnabled(issue.key, issuesWithMissingResolvePermission, issuesWithMissingEditPermission);
                    } else {
                        const flagText = formatMessage((0, (0, parcelRequire("cMnUo")).default).successFlagDescription, {
                            issueKey: issue.key
                        });
                        experienceSuccess();
                        showFlag({
                            type: 'success',
                            title: flagText
                        });
                    }
                },
                onError: onError
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            onClick: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'removeIssueFromVersion');
                experienceStart();
                onUpdateVersion();
            }
        }, formatMessage((0, (0, parcelRequire("cMnUo")).default).removeButtonTitle)));
    };
});
parcelRegister("fq1A6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c5aca855535074d$export$2e2bcd8739ae039);
    const $4c5aca855535074d$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filters"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isIssueSummarisedDeploymentsMigratedToAgs"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldIncludeDevOpsFieldsViaAgs"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sortBy"
        }, v6 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v7 = {
            "kind": "ScalarField",
            "name": "success"
        }, v8 = [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ], v9 = {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": v8
        }, v10 = {
            "kind": "ScalarField",
            "name": "issuesWithMissingResolvePermission"
        }, v11 = {
            "kind": "ScalarField",
            "name": "issuesWithMissingEditPermission"
        }, v12 = {
            "kind": "ScalarField",
            "name": "id"
        }, v13 = {
            "kind": "Literal",
            "name": "filter",
            "value": "ALL"
        }, v14 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v15 = [
            v14
        ], v16 = {
            "kind": "ScalarField",
            "name": "key"
        }, v17 = {
            "kind": "ScalarField",
            "name": "collapsedUis"
        }, v18 = {
            "kind": "ScalarField",
            "name": "canEdit"
        }, v19 = {
            "kind": "ScalarField",
            "name": "status"
        }, v20 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v21 = {
            "kind": "ScalarField",
            "name": "accountId"
        }, v22 = {
            "kind": "ScalarField",
            "name": "name"
        }, v23 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v24 = {
            "kind": "ScalarField",
            "name": "description"
        }, v25 = [
            v13,
            {
                "kind": "Variable",
                "name": "filters",
                "variableName": "filters"
            },
            {
                "kind": "Literal",
                "name": "first",
                "value": 20
            },
            {
                "kind": "Variable",
                "name": "sortBy",
                "variableName": "sortBy"
            }
        ], v26 = {
            "kind": "ScalarField",
            "name": "count"
        }, v27 = {
            "kind": "ScalarField",
            "name": "state"
        }, v28 = {
            "concreteType": "DevOpsSummarisedBuildState",
            "kind": "LinkedField",
            "name": "buildStates",
            "plural": true,
            "selections": [
                v27,
                v26
            ]
        }, v29 = [
            v26
        ], v30 = {
            "concreteType": "DevOpsSummarisedFeatureFlags",
            "kind": "LinkedField",
            "name": "summarisedFeatureFlags",
            "plural": false,
            "selections": [
                v14,
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantDisplayName"
                },
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantEnabled"
                },
                {
                    "kind": "ScalarField",
                    "name": "mostRelevantRolloutPercentage"
                }
            ]
        }, v31 = {
            "kind": "ScalarField",
            "name": "title"
        }, v32 = [
            v26,
            v12
        ], v33 = {
            "concreteType": "DevOpsSummarisedDeployments",
            "kind": "LinkedField",
            "name": "summarisedDeployments",
            "plural": false,
            "selections": v32
        }, v34 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v35 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v36 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 100
            }
        ], v37 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5
                ],
                "kind": "Fragment",
                "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v6,
                                "concreteType": "JiraRemoveIssuesFromFixVersionPayload",
                                "kind": "LinkedField",
                                "name": "removeIssuesFromFixVersion",
                                "plural": false,
                                "selections": [
                                    v7,
                                    v9,
                                    v10,
                                    v11,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v5,
                    v0,
                    v2,
                    v3,
                    v4
                ],
                "kind": "Operation",
                "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v6,
                                "concreteType": "JiraRemoveIssuesFromFixVersionPayload",
                                "kind": "LinkedField",
                                "name": "removeIssuesFromFixVersion",
                                "plural": false,
                                "selections": [
                                    v7,
                                    v9,
                                    v10,
                                    v11,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v12,
                                            {
                                                "kind": "ScalarField",
                                                "name": "canEditRelatedWork"
                                            },
                                            {
                                                "alias": "allIssues",
                                                "args": [
                                                    v13
                                                ],
                                                "concreteType": "JiraIssueConnection",
                                                "kind": "LinkedField",
                                                "name": "issues",
                                                "plural": false,
                                                "selections": v15,
                                                "storageKey": "issues(filter:\"ALL\")"
                                            },
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": [
                                                    v12,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectId"
                                                    },
                                                    v16,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "cloudId"
                                                    }
                                                ]
                                            },
                                            {
                                                "alias": "allIssuesRedesignTemp",
                                                "concreteType": "JiraIssueConnection",
                                                "kind": "LinkedField",
                                                "name": "issues",
                                                "plural": false,
                                                "selections": v15
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "canAddAndRemoveIssues"
                                            },
                                            v17,
                                            v18,
                                            {
                                                "kind": "ScalarField",
                                                "name": "startDate"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "releaseDate"
                                            },
                                            v19,
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionId"
                                            },
                                            {
                                                "concreteType": "JiraVersionDriverResult",
                                                "kind": "LinkedField",
                                                "name": "driverData",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "driver",
                                                        "plural": false,
                                                        "selections": [
                                                            v20,
                                                            v21,
                                                            v22,
                                                            v23,
                                                            v12
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "queryError",
                                                        "plural": false,
                                                        "selections": v8
                                                    }
                                                ]
                                            },
                                            v24,
                                            v22,
                                            {
                                                "concreteType": "JiraVersionWarningConfig",
                                                "kind": "LinkedField",
                                                "name": "warningConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "openPullRequest"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "openReview"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "unreviewedCode"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "failingBuild"
                                                    },
                                                    v18
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraVersionConnectAddonIframeData",
                                                "kind": "LinkedField",
                                                "name": "connectAddonIframeData",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "appKey"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "moduleKey"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "appName"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "location"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "options"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "canViewDevTools"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionIssueTableHiddenColumns"
                                            },
                                            {
                                                "alias": "issuesForList",
                                                "args": v25,
                                                "concreteType": "JiraIssueConnection",
                                                "kind": "LinkedField",
                                                "name": "issues",
                                                "plural": false,
                                                "selections": [
                                                    v14,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "jql"
                                                    },
                                                    {
                                                        "concreteType": "JiraIssueEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssue",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v16,
                                                                    v12,
                                                                    {
                                                                        "args": [
                                                                            {
                                                                                "kind": "Literal",
                                                                                "name": "ids",
                                                                                "value": [
                                                                                    "priority",
                                                                                    "summary",
                                                                                    "assignee",
                                                                                    "status",
                                                                                    "issuetype"
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "concreteType": "JiraIssueFieldConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "fieldsById",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v20,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "fieldId"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraStatus",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "status",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraStatusCategory",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "statusCategory",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "statusCategoryId"
                                                                                                                    },
                                                                                                                    v12
                                                                                                                ]
                                                                                                            },
                                                                                                            v12,
                                                                                                            v22,
                                                                                                            v24
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraStatusField"
                                                                                            },
                                                                                            v12,
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "user",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v20,
                                                                                                            v23,
                                                                                                            v22,
                                                                                                            v12
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraSingleSelectUserPickerField"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "text"
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraSingleLineTextField"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueType",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "issueType",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v22,
                                                                                                            {
                                                                                                                "concreteType": "JiraAvatar",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "avatar",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "xsmall"
                                                                                                                    }
                                                                                                                ]
                                                                                                            },
                                                                                                            v12
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraIssueTypeField"
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraPriority",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "priority",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v22,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "iconUrl"
                                                                                                            },
                                                                                                            v12
                                                                                                        ]
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraPriorityField"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueId"
                                                                    },
                                                                    v20,
                                                                    {
                                                                        "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                        "kind": "Condition",
                                                                        "passingValue": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "DevOpsSummarisedEntities",
                                                                                "kind": "LinkedField",
                                                                                "name": "devOpsSummarisedEntities",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "DevOpsSummarisedBuilds",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "summarisedBuilds",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v26,
                                                                                            v28,
                                                                                            v12
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "DevOpsSummarisedDeployments",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "summarisedDeployments",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "DevOpsEnvironment",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "deploymentEnvironment",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "category"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "deploymentState"
                                                                                            },
                                                                                            v12
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                                        "kind": "Condition",
                                                                                        "passingValue": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "DevOpsSummarisedDeployments",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "summarisedDeployments",
                                                                                                "plural": false,
                                                                                                "selections": v29
                                                                                            },
                                                                                            v30
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "concreteType": "JiraIssueDevSummaryResult",
                                                                                "kind": "LinkedField",
                                                                                "name": "devSummaryCache",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueDevSummary",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "devSummary",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "pullrequest",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "overall",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v26,
                                                                                                            v27
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "branch",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueBranchDevSummary",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "overall",
                                                                                                        "plural": false,
                                                                                                        "selections": v29
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "review",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueReviewDevSummary",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "overall",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v26,
                                                                                                            v27,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "lastUpdated"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "stateCount"
                                                                                                            }
                                                                                                        ]
                                                                                                    },
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "summaryByProvider",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "providerId"
                                                                                                            },
                                                                                                            v22,
                                                                                                            v26
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "commit",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueCommitDevSummary",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "overall",
                                                                                                        "plural": false,
                                                                                                        "selections": v29
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "build",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueBuildDevSummary",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "overall",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            v26,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "failedBuildCount"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "successfulBuildCount"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "unknownBuildCount"
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "deploymentEnvironments",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "overall",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "topEnvironments",
                                                                                                                "plural": true,
                                                                                                                "selections": [
                                                                                                                    v19,
                                                                                                                    v31
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": [
                                                                                    v33,
                                                                                    {
                                                                                        "concreteType": "DevOpsSummarisedBuilds",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "summarisedBuilds",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v28,
                                                                                            v26,
                                                                                            v12
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": [
                                                                                    v30
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            v33,
                                                                            {
                                                                                "concreteType": "DevOpsSummarisedBuilds",
                                                                                "kind": "LinkedField",
                                                                                "name": "summarisedBuilds",
                                                                                "plural": false,
                                                                                "selections": v32
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                                "kind": "LinkedField",
                                                                                "name": "summarisedFeatureFlags",
                                                                                "plural": false,
                                                                                "selections": v15
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            v34
                                                        ]
                                                    },
                                                    v35
                                                ]
                                            },
                                            {
                                                "alias": "issuesForList",
                                                "args": v25,
                                                "filters": [
                                                    "filter",
                                                    "sortBy",
                                                    "filters"
                                                ],
                                                "handle": "connection",
                                                "key": "ListVersion_issuesForList",
                                                "kind": "LinkedHandle",
                                                "name": "issues"
                                            },
                                            v17,
                                            {
                                                "args": v36,
                                                "concreteType": "JiraVersionApproverConnection",
                                                "kind": "LinkedField",
                                                "name": "approvers",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionApproverEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraVersionApprover",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v12,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v20,
                                                                            v22,
                                                                            v23,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "extendedProfile",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "jobTitle"
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "AtlassianAccountUser"
                                                                            },
                                                                            v12,
                                                                            v21
                                                                        ]
                                                                    },
                                                                    v19,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "declineReason"
                                                                    },
                                                                    v24,
                                                                    v37,
                                                                    v20
                                                                ]
                                                            },
                                                            v34
                                                        ]
                                                    },
                                                    v35
                                                ],
                                                "storageKey": "approvers(first:100)"
                                            },
                                            {
                                                "args": v36,
                                                "handle": "connection",
                                                "key": "version_approvers",
                                                "kind": "LinkedHandle",
                                                "name": "approvers"
                                            },
                                            {
                                                "concreteType": "JiraVersionRichTextSection",
                                                "kind": "LinkedField",
                                                "name": "richTextSection",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraADF",
                                                        "kind": "LinkedField",
                                                        "name": "content",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "json"
                                                            }
                                                        ]
                                                    },
                                                    v31
                                                ]
                                            },
                                            v37,
                                            {
                                                "condition": "isDevopsFeatureDisabledInFedRamp",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "DevOpsSummarisedEntities",
                                                        "kind": "LinkedField",
                                                        "name": "devOpsSummarisedEntities",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "DevOpsProviders",
                                                                "kind": "LinkedField",
                                                                "name": "providers",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsFeatureFlagProvider",
                                                                        "kind": "LinkedField",
                                                                        "name": "featureFlagProviders",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v20,
                                                                            v12,
                                                                            v22,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "createFeatureFlagTemplateUrl"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "connectFeatureFlagTemplateUrl"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "logoUrl"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "bc8510fea7bd505a5de5ad5bfc6bb3363ba982992dd0cf86b9176a8bb0593335",
                "metadata": {},
                "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $4c5aca855535074d$var$node.hash = "7a6b944f00d21566398340aaa81314c4";
    var $4c5aca855535074d$export$2e2bcd8739ae039 = $4c5aca855535074d$var$node;
});
parcelRegister("2uHyI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e5625c51cfa9499$export$2e2bcd8739ae039);
    const $1e5625c51cfa9499$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "key"
            }
        ],
        "type": "JiraIssue"
    };
    $1e5625c51cfa9499$var$node.hash = "bf7da4aac2b6cd1fbe625288d4086691";
    var $1e5625c51cfa9499$export$2e2bcd8739ae039 = $1e5625c51cfa9499$var$node;
});
parcelRegister("68iZl", function(module, exports) {
    $parcel$export(module.exports, "useRemoveIssueFromVersionExperienceStart", ()=>$3da27e8d218b719e$export$7d327eeb0dc00eee);
    $parcel$export(module.exports, "useRemoveIssueFromVersionExperienceFail", ()=>$3da27e8d218b719e$export$5da0a49410009ec1);
    $parcel$export(module.exports, "useRemoveIssueFromVersionExperienceSuccess", ()=>$3da27e8d218b719e$export$234c5c3c1b869f23);
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    const $3da27e8d218b719e$export$52919046b94109dc = 'removeIssueFromVersion';
    const $3da27e8d218b719e$var$ANALYTICS_SOURCE = 'versionDetails';
    const $3da27e8d218b719e$export$7d327eeb0dc00eee = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: $3da27e8d218b719e$export$52919046b94109dc,
            experienceId: `${Date.now()}`,
            analyticsSource: $3da27e8d218b719e$var$ANALYTICS_SOURCE,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE),
            edition: appEditions.software
        });
    };
    const $3da27e8d218b719e$export$5da0a49410009ec1 = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $3da27e8d218b719e$export$52919046b94109dc
        });
    const $3da27e8d218b719e$export$234c5c3c1b869f23 = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: $3da27e8d218b719e$export$52919046b94109dc
        });
});
parcelRegister("cMnUo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$979762e5739b8c14$export$2e2bcd8739ae039);
    var $7VHMR;
    var $979762e5739b8c14$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.error-flag-title",
            "defaultMessage": "Can't remove this issue from version"
        },
        errorFlagDescription: {
            "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.error-flag-description",
            "defaultMessage": "We couldn't remove {issueKey} from this version. Please try again"
        },
        successFlagDescription: {
            "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.success-flag-description",
            "defaultMessage": "{issueKey} has been removed from this version."
        },
        removeButtonTitle: {
            "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.remove-button-title",
            "defaultMessage": "Remove from version"
        },
        missingResolvePermissionErrorgFlagDescription: {
            "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-resolve-permission-errorg-flag-description",
            "defaultMessage": "You don't have permission to resolve {issueKey}, so you can't remove it from the version."
        },
        missingEditPermissionErrorFlagDescription: {
            "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-edit-permission-error-flag-description",
            "defaultMessage": "You don't have permission to edit {issueKey}, so you can't remove it from the version."
        },
        missingPermissionsErrorFlagDescription: {
            "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-permissions-error-flag-description",
            "defaultMessage": "You don't have permission to edit or resolve {issueKey}, so you can't remove it from the version."
        }
    });
});
parcelRegister("gMbdf", function(module, exports) {
    $parcel$export(module.exports, "getErrorMessage", ()=>$5267518c5af1c12d$export$82f46aa4e6535a45);
    var $cMnUo;
    const $5267518c5af1c12d$export$82f46aa4e6535a45 = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage)=>{
        const issueIsMissingResolvePermission = issuesWithMissingResolvePermission !== null && issuesWithMissingResolvePermission !== undefined && issuesWithMissingResolvePermission.length > 0;
        const issueIsMissingEditPermission = issuesWithMissingEditPermission !== null && issuesWithMissingEditPermission !== undefined && issuesWithMissingEditPermission.length > 0;
        if (issueIsMissingResolvePermission && issueIsMissingEditPermission) return formatMessage((0, (0, parcelRequire("cMnUo")).default).missingPermissionsErrorFlagDescription, {
            issueKey: issueKey
        });
        if (issueIsMissingResolvePermission) return formatMessage((0, (0, parcelRequire("cMnUo")).default).missingResolvePermissionErrorgFlagDescription, {
            issueKey: issueKey
        });
        if (issueIsMissingEditPermission) return formatMessage((0, (0, parcelRequire("cMnUo")).default).missingEditPermissionErrorFlagDescription, {
            issueKey: issueKey
        });
        return formatMessage((0, (0, parcelRequire("cMnUo")).default).errorFlagDescription);
    };
});
parcelRegister("dLN1S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$228dcc8f51f524a1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $228dcc8f51f524a1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moreVersions: {
            "id": "software-releases-version-detail-issue-list.issues.issue-card.more-button.more-versions",
            "defaultMessage": "More"
        }
    });
});
parcelRegister("iEXri", function(module, exports) {
    $parcel$export(module.exports, "Priority", ()=>$1d8525f9d31159be$export$300334f671c43555);
    var $kovkY;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $7lUTo;
    const $1d8525f9d31159be$export$300334f671c43555 = ({ jiraPriorityField: jiraPriorityField })=>{
        const [isPriorityIconBroken, setIsPriorityIconBroken] = (0, $5uXOq.useState)(false);
        const { priority: priority } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("kovkY")).default), jiraPriorityField);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1d8525f9d31159be$var$PriorityContainer, null, priority && (isPriorityIconBroken ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7lUTo"))))), {
            size: "small",
            label: priority.name || ''
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($1d8525f9d31159be$var$Icon, {
            src: priority.iconUrl,
            alt: priority.name ?? undefined,
            title: priority.name ?? undefined,
            onError: ()=>{
                setIsPriorityIconBroken(true);
            }
        })));
    };
    const $1d8525f9d31159be$var$Icon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i7vkz _1bsb7vkz _18s8m31d _16jlidpf _1o9zidpf _i0dl1wug",
                __cmplp.className
            ])
        });
    });
    const $1d8525f9d31159be$var$PriorityContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb7vkz _1ul97vkz _1e0c1txw _1bah1h6o _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kovkY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96fa7df9e8c4ccf5$export$2e2bcd8739ae039);
    const $96fa7df9e8c4ccf5$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "priority_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "iconUrl"
                        },
                        "action": "NONE",
                        "path": "priority.iconUrl"
                    }
                ]
            }
        ],
        "type": "JiraPriorityField"
    };
    $96fa7df9e8c4ccf5$var$node.hash = "ab255857fbd72fa53e70fe6a619699a6";
    var $96fa7df9e8c4ccf5$export$2e2bcd8739ae039 = $96fa7df9e8c4ccf5$var$node;
});
parcelRegister("7lUTo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $55a6a03819d31d72$var$_react = $55a6a03819d31d72$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $55a6a03819d31d72$var$_questionCircle = $55a6a03819d31d72$var$_interopRequireDefault((parcelRequire("8nk07")));
    function $55a6a03819d31d72$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $55a6a03819d31d72$var$EditorHelpIcon = (props)=>$55a6a03819d31d72$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10h2.5c0-2 1.5-2 1.5-2 1.5 0 2.5 1.5.5 3-1.5 1-1.5 1.5-1.5 3 0 .144-.016.824 0 1h2c0-1.568 0-2 1.5-3 1.446-.964 1.5-1.896 1.5-3 0-2-1.5-3-4-3-2 0-4 1-4 4m5 8v-2h-2v2z"/></svg>`
        }, props, {
            newIcon: $55a6a03819d31d72$var$_questionCircle.default
        }));
    $55a6a03819d31d72$var$EditorHelpIcon.displayName = 'EditorHelpIcon';
    var $55a6a03819d31d72$var$_default = module.exports.default = $55a6a03819d31d72$var$EditorHelpIcon;
});
parcelRegister("4uVJc", function(module, exports) {
    $parcel$export(module.exports, "Status", ()=>$09812bb54450a431$export$96e9906d6d93a972);
    var $9H7fH;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $3bDjY;
    var $2EwJD;
    var $gULOk;
    const $09812bb54450a431$export$96e9906d6d93a972 = ({ jiraStatusField: jiraStatusField })=>{
        const { status: status } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("9H7fH")).default), jiraStatusField);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($09812bb54450a431$var$StatusName, null, status.name), status.description != null && status.description.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement($09812bb54450a431$var$StatusDescription, null, status.description))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2EwJD")).default), {
            name: status.name,
            category: (0, (0, parcelRequire("gULOk")).statusCategoryForId)(status.statusCategory.statusCategoryId)
        }));
    };
    const $09812bb54450a431$var$StatusName = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p8n31",
                __cmplp.className
            ])
        });
    });
    const $09812bb54450a431$var$StatusDescription = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9H7fH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81f3aae902cb3bb3$export$2e2bcd8739ae039);
    const $81f3aae902cb3bb3$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "status_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            "action": "THROW",
                            "path": "status.name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "description"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraStatusCategory",
                                "kind": "LinkedField",
                                "name": "statusCategory",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "ScalarField",
                                            "name": "statusCategoryId"
                                        },
                                        "action": "THROW",
                                        "path": "status.statusCategory.statusCategoryId"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "status.statusCategory"
                        }
                    ]
                },
                "action": "THROW",
                "path": "status"
            }
        ],
        "type": "JiraStatusField"
    };
    $81f3aae902cb3bb3$var$node.hash = "5e65ebd3a202999e9094506fd6a31982";
    var $81f3aae902cb3bb3$export$2e2bcd8739ae039 = $81f3aae902cb3bb3$var$node;
});
parcelRegister("2EwJD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd41c6095391bfc6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $gULOk;
    const $cd41c6095391bfc6$var$statusCategoryToAppearenceMap = {
        [(0, (0, parcelRequire("gULOk")).UNDEFINED)]: 'default',
        [(0, (0, parcelRequire("gULOk")).TODO)]: 'default',
        [(0, (0, parcelRequire("gULOk")).DONE)]: 'success',
        [(0, (0, parcelRequire("gULOk")).IN_PROGRESS)]: 'inprogress'
    };
    class $cd41c6095391bfc6$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isActive: false
            };
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                testId: "common-components-status-lozenge.status-lozenge",
                isBold: this.props.isActive,
                appearance: $cd41c6095391bfc6$var$statusCategoryToAppearenceMap[this.props.category],
                maxWidth: this.props.isFullWidth ? '100%' : undefined
            }, this.props.name);
        }
    }
});
parcelRegister("cMkJv", function(module, exports) {
    $parcel$export(module.exports, "Summary", ()=>$982482a2b0150a9f$export$46453a0401d6cd1a);
    var $97Tt1;
    var $4Bd7r;
    var $1o3Lw;
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $3bDjY;
    var $fpaAk = parcelRequire("fpaAk");
    const $982482a2b0150a9f$var$TooltipTag = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($982482a2b0150a9f$var$IssueSummary, {
            ...props,
            ref: ref
        }));
    const $982482a2b0150a9f$export$46453a0401d6cd1a = ({ jiraIssue: jiraIssue, jiraIssueSummaryField: jiraIssueSummaryField, jiraIssueTypeField: jiraIssueTypeField })=>{
        const { key: key } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("1o3Lw")).default), jiraIssue);
        const { text: summary } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("4Bd7r")).default), jiraIssueSummaryField);
        const { issueType: issueType } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("97Tt1")).default), jiraIssueTypeField);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($982482a2b0150a9f$var$SummaryContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($982482a2b0150a9f$var$Icon, {
            src: issueType.avatar?.xsmall ?? (0, ($parcel$interopDefault($fpaAk))),
            alt: issueType.name,
            title: issueType.name
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($982482a2b0150a9f$var$IssueKey, null, key), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: summary,
            tag: $982482a2b0150a9f$var$TooltipTag
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($982482a2b0150a9f$var$IssueSummary, null, summary)));
    };
    const $982482a2b0150a9f$var$SummaryContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1osq _1ul9uuw1 _4cvr1h6o _8mocu2gc",
                __cmplp.className
            ])
        });
    });
    const $982482a2b0150a9f$var$Icon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i7vkz _1bsb7vkz _18s8m31d _16jlidpf _1o9zidpf _i0dl1wug",
                __cmplp.className
            ])
        });
    });
    const $982482a2b0150a9f$var$IssueSummary = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _syaz1fxt _9oik18uv _1bnx8stv _jf4cnqa1",
                __cmplp.className
            ])
        });
    });
    const $982482a2b0150a9f$var$IssueKey = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1o9zidpf _syaz1wmz _u5f3pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("97Tt1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e2eb63a63eaef37$export$2e2bcd8739ae039);
    const $5e2eb63a63eaef37$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            "action": "THROW",
                            "path": "issueType.name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "xsmall"
                                    },
                                    "action": "LOG",
                                    "path": "issueType.avatar.xsmall"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "issueType"
            }
        ],
        "type": "JiraIssueTypeField"
    };
    $5e2eb63a63eaef37$var$node.hash = "9c2af22d7b07779fb498e0197b0b8a31";
    var $5e2eb63a63eaef37$export$2e2bcd8739ae039 = $5e2eb63a63eaef37$var$node;
});
parcelRegister("4Bd7r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e12b298083406c4b$export$2e2bcd8739ae039);
    const $e12b298083406c4b$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "text"
                },
                "action": "THROW",
                "path": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    };
    $e12b298083406c4b$var$node.hash = "ecdba23eb4bd24552ee157f9d7e6c2dc";
    var $e12b298083406c4b$export$2e2bcd8739ae039 = $e12b298083406c4b$var$node;
});
parcelRegister("1o3Lw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1698ce32761cff8$export$2e2bcd8739ae039);
    const $d1698ce32761cff8$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssue",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "key"
            }
        ],
        "type": "JiraIssue"
    };
    $d1698ce32761cff8$var$node.hash = "be0a5b93419942c75fd2d852a9d5c8fc";
    var $d1698ce32761cff8$export$2e2bcd8739ae039 = $d1698ce32761cff8$var$node;
});
parcelRegister("fpaAk", function(module, exports) {
    module.exports = new URL("issue-type-avatar-fallback.a9f6df1b.svg", import.meta.url).toString();
});
parcelRegister("bLVnv", function(module, exports) {
    $parcel$export(module.exports, "ListOptions", ()=>$e5c564d307b91bbd$export$c50fde0141a9ce82);
    var $j0sCG;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $83Lzw;
    var $bV6Ph;
    const $e5c564d307b91bbd$export$c50fde0141a9ce82 = ({ jiraVersion: jiraVersion })=>{
        const jiraVersionData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("j0sCG")).default), jiraVersion);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e5c564d307b91bbd$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("83Lzw")).FiltersAsync), {
            jiraVersion: jiraVersionData
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($e5c564d307b91bbd$var$SortingWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bV6Ph")).AsyncSortIssues), null)));
    };
    const $e5c564d307b91bbd$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _4t3i1ylp _1ul9idpf _kqsw1if8 _154iidpf _1pbycs5v _11q7vuon _ca0qv47k _n3tdpxbi",
                __cmplp.className
            ])
        });
    });
    const $e5c564d307b91bbd$var$SortingWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("j0sCG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a525887e43a9604$export$2e2bcd8739ae039);
    const $8a525887e43a9604$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "listOptions_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesVersionDetailIssueList_FiltersAsync"
            }
        ],
        "type": "JiraVersion"
    };
    $8a525887e43a9604$var$node.hash = "72816e24a790f41b4c2b45bd06ad26f9";
    var $8a525887e43a9604$export$2e2bcd8739ae039 = $8a525887e43a9604$var$node;
});
parcelRegister("83Lzw", function(module, exports) {
    $parcel$export(module.exports, "FiltersAsync", ()=>$0aabf33f1f510e23$export$c2ea1db993d10580);
    var $aiA4o;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $0aabf33f1f510e23$var$FiltersLazy = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("7bdRT")).then((mod)=>mod.Filters), {
        moduleId: "./src/packages/releases/issue-list/src/ui/list-options/filters/index.tsx"
    });
    const $0aabf33f1f510e23$export$669f6ea7d267feaf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$var$FilterBarLoadingWraper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$var$TextFilterSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$var$AssigneeFilterSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$var$DropdownFilterSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$var$DropdownFilterSkeleton, null));
    const $0aabf33f1f510e23$export$c2ea1db993d10580 = ({ jiraVersion: jiraVersion })=>{
        const jiraVersionData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("aiA4o")).default), jiraVersion);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "flag",
            id: "jira.software.releases.version.detail.issue.list.filters",
            packageName: "jira-software-releases-version-detail-issue-list",
            teamName: "fusion-solaris"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jira-software-releases-version-detail-issue-list-filters",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$export$669f6ea7d267feaf, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$var$FiltersLazy, {
            jiraVersion: jiraVersionData
        })));
    };
    const $0aabf33f1f510e23$var$skeletonKeyFrames = null;
    const $0aabf33f1f510e23$var$AnimationBaseDiv = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ju25ru3m _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _bfhkqrzy _j7hq1nls",
                __cmplp.className
            ])
        });
    });
    const $0aabf33f1f510e23$var$FilterBarLoadingWraper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ylp _1bsb1osq _1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $0aabf33f1f510e23$var$TextFilterSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $0aabf33f1f510e23$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1y44 _1bsb68cl _4t3i1ylp _2hwx7vkz",
                __cmplp.className
            ])
        });
    });
    const $0aabf33f1f510e23$var$AssigneeFilterSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $0aabf33f1f510e23$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko7vkz _4t3izwfg _1bsbzwfg _2hwx7vkz",
                __cmplp.className
            ])
        });
    });
    const $0aabf33f1f510e23$var$DropdownFilterSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $0aabf33f1f510e23$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko7vkz _4t3igktf _1bsbvbgk _2hwx7vkz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aiA4o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$75b1d7804985602b$export$2e2bcd8739ae039);
    const $75b1d7804985602b$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "async_softwareReleasesVersionDetailIssueList_FiltersAsync",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "filters_softwareReleasesVersionDetailIssueList"
            }
        ],
        "type": "JiraVersion"
    };
    $75b1d7804985602b$var$node.hash = "80684c6429225cfc5da72844f8d61f76";
    var $75b1d7804985602b$export$2e2bcd8739ae039 = $75b1d7804985602b$var$node;
});
parcelRegister("7bdRT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("krsxF")
    ]).then(()=>parcelRequire('f6qTx'));
});
parcelRegister("bV6Ph", function(module, exports) {
    $parcel$export(module.exports, "AsyncSortIssues", ()=>$ddc14527767de26a$export$e985a1e694548d49);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $lfTZh;
    var $kxZPA;
    var $kkxNP;
    var $1KVd1;
    var $kEJPu;
    const $ddc14527767de26a$var$LazySortIssues = (0, (0, parcelRequire("kxZPA")).lazy)(()=>Promise.resolve((parcelRequire("kkxNP"))).then((module)=>module.SortIssuesDropdown), {
        moduleId: "./src/packages/releases/issue-list/src/ui/list-options/sorting/sorting-dropdown/index.tsx"
    });
    const $ddc14527767de26a$export$e985a1e694548d49 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { currentSortByOption: currentSortByOption, currentSortOrderOption: currentSortOrderOption } = (0, (0, parcelRequire("kEJPu")).useCurrentSortOptions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "version-detail-sort-issues",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkxNP")).StyledButton), {
                iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkxNP")).SortOrderIcon), {
                    order: currentSortOrderOption.id
                })
            }, `${formatMessage((0, (0, parcelRequire("1KVd1")).default).sortBy)}: ${formatMessage(currentSortByOption.label)}`)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ddc14527767de26a$var$LazySortIssues, null));
    };
});
parcelRegister("kkxNP", function(module, exports) {
    $parcel$export(module.exports, "SortIssuesDropdown", ()=>$b4bf5664f8038187$export$2c14c390745c589);
    $parcel$export(module.exports, "StyledButton", ()=>$b4bf5664f8038187$export$2d5d2ba3c7c8c40b);
    $parcel$export(module.exports, "SortOrderIcon", ()=>$b4bf5664f8038187$export$80ba57d0e34e16ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2rqOp;
    var $BLPHT;
    var $a5n5E;
    var $b2TJP;
    var $ls8Y7;
    var $kAObg;
    var $9UCCQ;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $1YU2V;
    var $1KVd1;
    var $kEJPu;
    const $b4bf5664f8038187$export$2c14c390745c589 = ({ defaultOpen: defaultOpen })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { currentSortByOption: currentSortByOption, currentSortOrderOption: currentSortOrderOption } = (0, (0, parcelRequire("kEJPu")).useCurrentSortOptions)();
        const { setSortByParam: setSortByParam, setSortOrderParam: setSortOrderParam } = (0, (0, parcelRequire("1YU2V")).useFilterSortingQueryParams)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            defaultOpen: defaultOpen,
            spacing: "compact",
            placement: "bottom-end",
            trigger: ({ triggerRef: triggerRef, isSelected: isSelected, ...providedProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement($b4bf5664f8038187$export$2d5d2ba3c7c8c40b, {
                    ...providedProps,
                    ref: triggerRef,
                    isSelected: isSelected,
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement($b4bf5664f8038187$export$80ba57d0e34e16ec, {
                        order: currentSortOrderOption.id
                    }),
                    appearance: "subtle"
                }, `${formatMessage((0, (0, parcelRequire("1KVd1")).default).sortBy)}: ${formatMessage(currentSortByOption.label)}`)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b2TJP")).default), {
            id: "sortByFields"
        }, (0, (0, parcelRequire("kEJPu")).sortByFieldOptions).map((field)=>(0, ($parcel$interopDefault($5uXOq))).createElement($b4bf5664f8038187$export$29d4895f75c15b40, {
                isSelected: field.id === currentSortByOption.id,
                id: field.id,
                key: field.id,
                onClick: ()=>{
                    setSortByParam(field.id);
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'toggled',
                        actionSubject: 'radio'
                    });
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'sorting', {
                        sortBy: field.id,
                        sortOrder: currentSortOrderOption.id
                    });
                }
            }, formatMessage(field.label)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b2TJP")).default), {
            id: "sortOrderOptions"
        }, (0, (0, parcelRequire("kEJPu")).sortOrderOptions).map((order)=>(0, ($parcel$interopDefault($5uXOq))).createElement($b4bf5664f8038187$export$29d4895f75c15b40, {
                isSelected: order.id === currentSortOrderOption.id,
                id: order.id,
                key: order.id,
                onClick: ()=>{
                    setSortOrderParam(order.id);
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'toggled',
                        actionSubject: 'radio'
                    });
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'sorting', {
                        sortBy: currentSortByOption.id,
                        sortOrder: order.id
                    });
                }
            }, formatMessage(order.label))))));
    };
    const $b4bf5664f8038187$export$80ba57d0e34e16ec = ({ order: order })=>{
        switch(order){
            case 'ASC':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kAObg"))))), {
                    label: "software-releases-version-detail.common.sort-issues.ui.sort-order-icon.ascending",
                    size: "small"
                });
            case 'DESC':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ls8Y7"))))), {
                    label: "software-releases-version-detail.common.sort-issues.ui.sort-order-icon.descending",
                    size: "small"
                });
            default:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ls8Y7"))))), {
                    label: "software-releases-version-detail.common.sort-issues.ui.sort-order-icon.descending",
                    size: "small"
                });
        }
    };
    const $b4bf5664f8038187$export$29d4895f75c15b40 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("a5n5E")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p1nn1 _1kha1b66",
                __cmplp.className
            ])
        });
    });
    const $b4bf5664f8038187$export$2d5d2ba3c7c8c40b = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("2rqOp")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_if291txw _1kba1h6o _1i92dlk8 _12r2bfng",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ls8Y7", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f9e32b81d01f795b$var$_react = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f9e32b81d01f795b$var$_arrowDown = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("cC5ib")));
    function $f9e32b81d01f795b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f9e32b81d01f795b$var$ArrowDownIcon = (props)=>$f9e32b81d01f795b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
        }, props, {
            newIcon: $f9e32b81d01f795b$var$_arrowDown.default
        }));
    $f9e32b81d01f795b$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
    var $f9e32b81d01f795b$var$_default = module.exports.default = $f9e32b81d01f795b$var$ArrowDownIcon;
});
parcelRegister("cC5ib", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $92ed238f23140736$var$_UNSAFE_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $92ed238f23140736$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $92ed238f23140736$var$ArrowDownIcon = (props)=>$92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1v12.75m-5-4.5 5 5 5-5"/>`
        }, props));
    $92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
    var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;
});
parcelRegister("kAObg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $efde1844fc0ef421$var$_react = $efde1844fc0ef421$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $efde1844fc0ef421$var$_arrowUp = $efde1844fc0ef421$var$_interopRequireDefault((parcelRequire("kcHZS")));
    function $efde1844fc0ef421$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $efde1844fc0ef421$var$ArrowUpIcon = (props)=>$efde1844fc0ef421$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
        }, props, {
            newIcon: $efde1844fc0ef421$var$_arrowUp.default
        }));
    $efde1844fc0ef421$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
    var $efde1844fc0ef421$var$_default = module.exports.default = $efde1844fc0ef421$var$ArrowUpIcon;
});
parcelRegister("kcHZS", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eb570e807ab2e210$var$_UNSAFE_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eb570e807ab2e210$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>$eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
        }, props));
    $eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
    var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;
});
parcelRegister("1KVd1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d5edbb25fefb626$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6d5edbb25fefb626$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sortByAssignee: {
            "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-assignee",
            "defaultMessage": "Assignee"
        },
        sortByDateCreated: {
            "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-date-created",
            "defaultMessage": "Date created"
        },
        sortByIssueKey: {
            "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-key",
            "defaultMessage": "Issue key"
        },
        sortByPriority: {
            "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-priority",
            "defaultMessage": "Priority"
        },
        sortByIssueStatusCategory: {
            "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-status-category",
            "defaultMessage": "Status category"
        },
        sortByIssueType: {
            "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-type",
            "defaultMessage": "Type"
        },
        ascending: {
            "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.ascending",
            "defaultMessage": "Ascending"
        },
        descending: {
            "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.descending",
            "defaultMessage": "Descending"
        },
        sortBy: {
            "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by",
            "defaultMessage": "Sort by"
        }
    });
});
parcelRegister("kEJPu", function(module, exports) {
    $parcel$export(module.exports, "sortOrderOptions", ()=>$cb0c4d13f7089bc2$export$2969b4c3e7255782);
    $parcel$export(module.exports, "sortByFieldOptions", ()=>$cb0c4d13f7089bc2$export$bdbfa34747bc5af);
    $parcel$export(module.exports, "useCurrentSortOptions", ()=>$cb0c4d13f7089bc2$export$43a8856ed2deb26e);
    var $1YU2V;
    var $1KVd1;
    const $cb0c4d13f7089bc2$export$2969b4c3e7255782 = [
        {
            id: 'ASC',
            label: (0, (0, parcelRequire("1KVd1")).default).ascending
        },
        {
            id: 'DESC',
            label: (0, (0, parcelRequire("1KVd1")).default).descending
        }
    ];
    const $cb0c4d13f7089bc2$export$bdbfa34747bc5af = [
        {
            id: 'CREATED',
            label: (0, (0, parcelRequire("1KVd1")).default).sortByDateCreated
        },
        {
            id: 'ASSIGNEE',
            label: (0, (0, parcelRequire("1KVd1")).default).sortByAssignee
        },
        {
            id: 'KEY',
            label: (0, (0, parcelRequire("1KVd1")).default).sortByIssueKey
        },
        {
            id: 'PRIORITY',
            label: (0, (0, parcelRequire("1KVd1")).default).sortByPriority
        },
        {
            id: 'STATUS',
            label: (0, (0, parcelRequire("1KVd1")).default).sortByIssueStatusCategory
        },
        {
            id: 'TYPE',
            label: (0, (0, parcelRequire("1KVd1")).default).sortByIssueType
        }
    ];
    const $cb0c4d13f7089bc2$export$43a8856ed2deb26e = ()=>{
        const { parsedQueryParams: parsedQueryParams } = (0, (0, parcelRequire("1YU2V")).useFilterSortingQueryParams)();
        const currentSortByOption = $cb0c4d13f7089bc2$export$bdbfa34747bc5af.find((option)=>option.id === parsedQueryParams[0, $5d187be87424268f$export$13d5b2891ca65cd6]) ?? $cb0c4d13f7089bc2$export$bdbfa34747bc5af[0];
        const currentSortOrderOption = $cb0c4d13f7089bc2$export$2969b4c3e7255782.find((option)=>option.id === parsedQueryParams[0, $5d187be87424268f$export$810a1f7ed2facfcb]) ?? $cb0c4d13f7089bc2$export$2969b4c3e7255782[0];
        return {
            currentSortByOption: currentSortByOption,
            currentSortOrderOption: currentSortOrderOption
        };
    };
});
parcelRegister("9VaPq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c682112e60e9021$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3c682112e60e9021$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issues: {
            "id": "software-releases-version-detail-issue-list.issues",
            "defaultMessage": "Issues"
        },
        addIssueIconLabel: {
            "id": "software-releases-version-detail-issue-list.add-issue-icon-label",
            "defaultMessage": "Add issues"
        }
    });
});
parcelRegister("fx0Tw", function(module, exports) {
    $parcel$export(module.exports, "IssueListScreenAnalytics", ()=>$447dd2b3ad70f9dc$export$44cca2bcabf50abc);
    var $iSQPt;
    var $7y8zI;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $4R6GH;
    var $5oFIy;
    var $9lAUN;
    const $447dd2b3ad70f9dc$export$44cca2bcabf50abc = ({ jiraIssueEdgesReference: jiraIssueEdgesReference, jiraVersionReference: jiraVersionReference })=>{
        const jiraIssueEdgeReferenceData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("7y8zI")).default), jiraIssueEdgesReference);
        const warningConfigFragment = (0, $8Uumt.useFragment)((0, (0, parcelRequire("iSQPt")).default), jiraVersionReference);
        const nodes = jiraIssueEdgeReferenceData.map((edge)=>edge.node).filter(Boolean);
        const hasBambooDeployment = nodes.some((node)=>(node.devSummaryCache?.devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0);
        const hasDeployments = nodes.some((node)=>(0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re') ? node.summarisedDeployments?.count != null && node.summarisedDeployments?.count > 0 : node.devOpsSummarisedEntities?.summarisedDeployments?.count != null && node.devOpsSummarisedEntities?.summarisedDeployments?.count > 0);
        const hasFeatureFlags = nodes.some((node)=>(0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re') ? (node.summarisedFeatureFlags?.totalCount ?? 0) > 0 : (node.devOpsSummarisedEntities?.summarisedFeatureFlags?.totalCount ?? 0) > 0);
        const hasCommits = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.commit?.overall?.count) > 0);
        const hasPullRequests = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.pullrequest?.overall?.count) > 0);
        const hasBranches = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.branch?.overall?.count) > 0);
        const hasBuilds = nodes.some((node)=>(0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re') ? Number(node.devSummaryCache?.devSummary?.build?.overall?.count) > 0 || Number(node.summarisedBuilds?.count) > 0 : Number(node.devSummaryCache?.devSummary?.build?.overall?.count) > 0 || Number(node.devOpsSummarisedEntities?.summarisedBuilds?.count) > 0);
        const hasReviews = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.review?.overall?.count) > 0);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9lAUN")).IssuesWarningCountProvider), {
            jiraVersion: warningConfigFragment,
            issueEdges: jiraIssueEdgeReferenceData
        }, (warningCount)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
                attributes: {
                    hasBamboo: hasBambooDeployment,
                    hasBranches: hasBranches,
                    hasBuilds: hasBuilds,
                    hasCommits: hasCommits,
                    hasDeployments: hasDeployments,
                    hasFeatureFlags: hasFeatureFlags,
                    hasPullRequests: hasPullRequests,
                    hasReviews: hasReviews,
                    warningCount: warningCount
                }
            }));
    };
});
parcelRegister("iSQPt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f7b2298df7f980ab$export$2e2bcd8739ae039);
    const $f7b2298df7f980ab$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion"
            }
        ],
        "type": "JiraVersion"
    };
    $f7b2298df7f980ab$var$node.hash = "2dad59bd036f7e19ca923546c2912289";
    var $f7b2298df7f980ab$export$2e2bcd8739ae039 = $f7b2298df7f980ab$var$node;
});
parcelRegister("7y8zI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4289ceabfb6dcbda$export$2e2bcd8739ae039);
    const $4289ceabfb6dcbda$var$node = function() {
        var v0 = [
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ], v1 = {
            "concreteType": "DevOpsSummarisedDeployments",
            "kind": "LinkedField",
            "name": "summarisedDeployments",
            "plural": false,
            "selections": v0
        }, v2 = {
            "concreteType": "DevOpsSummarisedFeatureFlags",
            "kind": "LinkedField",
            "name": "summarisedFeatureFlags",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ]
        }, v3 = {
            "concreteType": "DevOpsSummarisedBuilds",
            "kind": "LinkedField",
            "name": "summarisedBuilds",
            "plural": false,
            "selections": v0
        };
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "isDevopsFeatureDisabledInFedRamp"
                },
                {
                    "kind": "RootArgument",
                    "name": "isIssueSummarisedDeploymentsMigratedToAgs"
                },
                {
                    "kind": "RootArgument",
                    "name": "shouldIncludeDevOpsFieldsViaAgs"
                }
            ],
            "kind": "Fragment",
            "metadata": {
                "plural": true
            },
            "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isDevopsFeatureDisabledInFedRamp",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsSummarisedEntities",
                                    "kind": "LinkedField",
                                    "name": "devOpsSummarisedEntities",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                v1,
                                                v2,
                                                v3
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssueDevSummaryResult",
                                    "kind": "LinkedField",
                                    "name": "devSummaryCache",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueDevSummary",
                                            "kind": "LinkedField",
                                            "name": "devSummary",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "pullrequest",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "branch",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "review",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "commit",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "build",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "deploymentEnvironments",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                    "kind": "LinkedField",
                                                                    "name": "topEnvironments",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v1,
                                v3
                            ]
                        },
                        {
                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v2
                            ]
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges"
                }
            ],
            "type": "JiraIssueEdge"
        };
    }();
    $4289ceabfb6dcbda$var$node.hash = "ea60645c920c025333573ec5ba26fd4d";
    var $4289ceabfb6dcbda$export$2e2bcd8739ae039 = $4289ceabfb6dcbda$var$node;
});
parcelRegister("c8MHq", function(module, exports) {
    $parcel$export(module.exports, "useIntersectionObserver", ()=>$4f6fdaccd88726d3$export$a7395f9832c00176);
    var $5uXOq = parcelRequire("5uXOq");
    const $4f6fdaccd88726d3$export$a7395f9832c00176 = ({ margin: margin, onIntersection: onIntersection })=>{
        const [observedElement, setObservedElement] = (0, $5uXOq.useState)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (observedElement === null || window.IntersectionObserver === undefined) return undefined;
            const observerCallback = (entries)=>entries.forEach(({ isIntersecting: isIntersecting })=>{
                    if (isIntersecting) onIntersection();
                });
            const observer = new IntersectionObserver(observerCallback, {
                rootMargin: `${margin}px`,
                threshold: 0
            });
            observer.observe(observedElement);
            return ()=>{
                observer.disconnect();
            };
        }, [
            observedElement,
            onIntersection,
            margin
        ]);
        return setObservedElement;
    };
});
parcelRegister("4i4ip", function(module, exports) {
    $parcel$export(module.exports, "VersionRelatedWorkExperienceStart", ()=>$f0c12b7b4febbbb7$export$e99e651b72ab598a);
    $parcel$export(module.exports, "useViewVersionRelatedWorkExperienceFail", ()=>$f0c12b7b4febbbb7$export$ffb9ab4bec7b2f3c);
    $parcel$export(module.exports, "VersionRelatedWorkExperienceSuccessTracker", ()=>$f0c12b7b4febbbb7$export$4e4779a3c4cff596);
    var $5uXOq = parcelRequire("5uXOq");
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    const $f0c12b7b4febbbb7$var$VERSION_RELATED_WORK_EXPERIENCE_NAME = 'viewVersionRelatedWork';
    const $f0c12b7b4febbbb7$export$e99e651b72ab598a = ({ experienceId: experienceId })=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaHBi")).ExperienceStart), {
            experienceId: experienceId,
            experience: $f0c12b7b4febbbb7$var$VERSION_RELATED_WORK_EXPERIENCE_NAME,
            analyticsSource: "versionDetails",
            edition: appEditions.software,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE)
        });
    };
    const $f0c12b7b4febbbb7$export$ffb9ab4bec7b2f3c = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $f0c12b7b4febbbb7$var$VERSION_RELATED_WORK_EXPERIENCE_NAME
        });
    const $f0c12b7b4febbbb7$export$4e4779a3c4cff596 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: $f0c12b7b4febbbb7$var$VERSION_RELATED_WORK_EXPERIENCE_NAME
        });
});
parcelRegister("4MIM1", function(module, exports) {
    $parcel$export(module.exports, "RelatedWork", ()=>$c048d8a6986fd4e0$export$3200bfb79e9adbfb);
    var $cXDwW;
    var $ajHh6;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $l1N8i;
    var $7ymNM;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $5oFIy;
    var $24M80;
    var $a3dw0;
    var $fi7WV;
    var $ieDtd;
    var $e4M5y;
    var $aef30;
    var $23OBX;
    var $iaG90;
    var $hhood;
    var $gCsUv;
    const $c048d8a6986fd4e0$export$8beb67dd759bbe2 = 5;
    const $c048d8a6986fd4e0$export$3200bfb79e9adbfb = ({ queryRef: queryRef })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { jira: jira } = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("ajHh6")).default), queryRef);
        const versionFrag = jira.version;
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("cXDwW")).default), versionFrag);
        const [selectedCategory, setSelectedCategory] = (0, (0, parcelRequire("ieDtd")).useQueryParam)('relatedWorkCategory');
        const addRelatedWorkExpFailed = (0, (0, parcelRequire("24M80")).useAddRelatedWorkExperienceFail)();
        const allRelatedWork = version.relatedWorkV2.edges.filter(Boolean);
        const relatedWorkInCategory = selectedCategory === undefined ? allRelatedWork : allRelatedWork.filter(({ node: node })=>node?.category === selectedCategory);
        const body = allRelatedWork.length === 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaG90")).RelatedWorkEmptyState), {
            jiraVersion: version,
            relatedWorkEdges: allRelatedWork
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4M5y")).ErrorBoundary), {
            id: "relatedWorkCategoryFilter",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23OBX")).CategoryFilter), {
            relatedWorkEdges: allRelatedWork,
            selectedCategory: selectedCategory,
            onCategorySelected: (category)=>setSelectedCategory(category, 'replace')
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gCsUv")).RelatedWorkList), {
            jiraVersion: version,
            relatedWorkEdges: relatedWorkInCategory
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$ActionsContainer, null, version.status != null && version.status !== 'ARCHIVED' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4M5y")).ErrorBoundary), {
            id: "addRelatedPopup",
            fallback: "flag",
            onError: (location, error)=>{
                addRelatedWorkExpFailed(location, error);
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a3dw0")).AddRelatedWorkPopup), {
            jiraVersion: version,
            relatedWorkEdges: allRelatedWork,
            renderTrigger: ({ triggerProps: triggerProps, isLoading: isLoading, onClick: onClick, onMouseOver: onMouseOver })=>(0, ($parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$AddButtonContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$AddButton, {
                    ...triggerProps,
                    appearance: "subtle-link",
                    testId: isLoading ? undefined : 'software-releases-version-related-work.ui.add-button',
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$ActionIconContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7ymNM"))))), {
                        size: "small",
                        label: ""
                    })),
                    onClick: onClick,
                    onMouseOver: onMouseOver,
                    shouldFitContainer: true
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$ShowMoreTextContainer, null, formatMessage((0, (0, parcelRequire("hhood")).default).addRelatedWork))))
        }))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aef30")).default), {
            relatedWorkEdges: allRelatedWork
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fi7WV")).CollapsibleSection), {
            jiraVersion: version,
            uiType: "RELATED_WORK",
            renderHeader: (isCollapsed, onToggleClicked)=>(0, ($parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$HeaderWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$HeaderLeftWrapper, {
                    onClick: onToggleClicked
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
                    size: "small",
                    as: "h2"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $c048d8a6986fd4e0$var$sectionTitleStyles
                }, formatMessage((0, (0, parcelRequire("hhood")).default).relatedWorkHeading))), (0, ($parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$TotalCountLozenge, null, allRelatedWork.length), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fi7WV")).CollapsibleToggleButton), {
                    isCollapsed: isCollapsed
                })), (0, ($parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$HeaderRightWrapper, null, version.status !== 'ARCHIVED' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4M5y")).ErrorBoundary), {
                    key: "addRelatedWorkButton",
                    id: "addRelatedPopupHeaderPlusButton",
                    fallback: "flag",
                    onError: (location, error)=>{
                        addRelatedWorkExpFailed(location, error);
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a3dw0")).AddRelatedWorkPopup), {
                    jiraVersion: version,
                    relatedWorkEdges: allRelatedWork,
                    renderTrigger: ({ triggerProps: triggerProps, onClick: onClick, onMouseOver: onMouseOver })=>(0, ($parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$AddIconButtonContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                            ...triggerProps,
                            appearance: "subtle",
                            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7ymNM"))))), {
                                label: "",
                                size: "small"
                            }),
                            onClick: onClick,
                            onMouseOver: onMouseOver,
                            shouldFitContainer: true,
                            "aria-label": formatMessage((0, (0, parcelRequire("hhood")).default).addRelatedWork)
                        }))
                })))),
            renderBody: ()=>body
        }));
    };
    const $c048d8a6986fd4e0$var$ActionsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulppxbi _ca0qu2gc _19bv1b66",
                __cmplp.className
            ])
        });
    });
    const $c048d8a6986fd4e0$var$ActionIconContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_u5f3u2gc",
                __cmplp.className
            ])
        });
    });
    const $c048d8a6986fd4e0$var$ShowMoreTextContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p1nn1",
                __cmplp.className
            ])
        });
    });
    const $c048d8a6986fd4e0$var$AddButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _2rko14y2 _80omtlke _1yt4wo40 _10j7iw92 _irr3iw92",
                __cmplp.className
            ])
        });
    });
    const $c048d8a6986fd4e0$var$AddButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_14741e5h",
                __cmplp.className
            ])
        });
    });
    const $c048d8a6986fd4e0$var$sectionTitleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.300',
        marginBottom: 'space.300',
        marginRight: 'space.100'
    });
    const $c048d8a6986fd4e0$var$AddIconButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbxy5q _4t3ixy5q",
                __cmplp.className
            ])
        });
    });
    const $c048d8a6986fd4e0$var$HeaderWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o _19pk1ejb",
                __cmplp.className
            ])
        });
    });
    const $c048d8a6986fd4e0$var$HeaderLeftWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _80omtlke",
                __cmplp.className
            ])
        });
    });
    const $c048d8a6986fd4e0$var$HeaderRightWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $c048d8a6986fd4e0$var$TotalCountLozenge = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk4zhb _1wyb1skh _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ipxbi _2rkoftgi _19pkv77o _u5f31b66 _19bv1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cXDwW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$271daf69aa10b7d2$export$2e2bcd8739ae039);
    const $271daf69aa10b7d2$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "__typename"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "relatedWorkV2"
                        ]
                    }
                ]
            },
            "name": "ui_softwareReleasesVersionRelatedWork_RelatedWork",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "relatedWorkV2",
                        "concreteType": "JiraVersionRelatedWorkV2Connection",
                        "kind": "LinkedField",
                        "name": "__version_relatedWorkV2_connection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraVersionRelatedWorkV2Edge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v0,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "relatedWorkList_softwareReleasesVersionRelatedWork_relatedWorkEdges"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "categoryFilter_softwareReleasesVersionRelatedWork"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "async_softwareReleasesAddRelatedWorkToVersion_EditRelatedWorkPopup_jiraVersionRelatedWork"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                },
                                                v0
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "relatedWorkV2.edges"
                            },
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "endCursor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "relatedWorkV2"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "async_softwareReleasesAddRelatedWorkToVersion_EditRelatedWorkPopup_jiraVersion"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "relatedWorkList_softwareReleasesVersionRelatedWork_jiraVersion"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
                }
            ],
            "type": "JiraVersion"
        };
    }();
    $271daf69aa10b7d2$var$node.hash = "ee870a351f61b9ac907790203ed00950";
    var $271daf69aa10b7d2$export$2e2bcd8739ae039 = $271daf69aa10b7d2$var$node;
});
parcelRegister("24M80", function(module, exports) {
    $parcel$export(module.exports, "useAddRelatedWorkExperienceStart", ()=>$bbfb89cc55331a7a$export$2a84c09279dbc41e);
    $parcel$export(module.exports, "useAddRelatedWorkExperienceFail", ()=>$bbfb89cc55331a7a$export$b2970d2d64ed7236);
    $parcel$export(module.exports, "useAddRelatedWorkExperienceSuccess", ()=>$bbfb89cc55331a7a$export$f01728e86602e7e0);
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    const $bbfb89cc55331a7a$var$EXPERIENCE_NAME = 'addRelatedWork';
    const $bbfb89cc55331a7a$var$ANALYTICS_SOURCE = 'versionDetails';
    const $bbfb89cc55331a7a$export$2a84c09279dbc41e = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: $bbfb89cc55331a7a$var$EXPERIENCE_NAME,
            experienceId: `${Date.now()}`,
            analyticsSource: $bbfb89cc55331a7a$var$ANALYTICS_SOURCE,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE),
            edition: appEditions.software
        });
    };
    const $bbfb89cc55331a7a$export$b2970d2d64ed7236 = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $bbfb89cc55331a7a$var$EXPERIENCE_NAME
        });
    const $bbfb89cc55331a7a$export$f01728e86602e7e0 = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: $bbfb89cc55331a7a$var$EXPERIENCE_NAME
        });
});
parcelRegister("a3dw0", function(module, exports) {
    $parcel$export(module.exports, "AddRelatedWorkPopup", ()=>$7428db04b10b730a$export$7c8948b134dbfa2e);
    var $2VJK6;
    var $2CHAQ;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $lfTZh;
    var $kxZPA;
    const $7428db04b10b730a$var$LazyAddRelatedWorkPopup = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("7Zpj8")).then((module)=>module.AddRelatedWorkPopup), {
        moduleId: "./src/packages/releases/add-related-work-to-version/src/ui/add-related-work-popup/index.tsx"
    });
    const $7428db04b10b730a$export$7c8948b134dbfa2e = ({ jiraVersion: jiraVersion, renderTrigger: renderTrigger, relatedWorkEdges: relatedWorkEdges })=>{
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("2CHAQ")).default), jiraVersion);
        const edges = (0, $8Uumt.useFragment)((0, (0, parcelRequire("2VJK6")).default), relatedWorkEdges);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "add-related-work-popup",
            fallback: renderTrigger({
                triggerProps: {},
                onClick: ()=>undefined,
                onMouseOver: ()=>undefined,
                isLoading: true
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7428db04b10b730a$var$LazyAddRelatedWorkPopup, {
            jiraVersion: version,
            renderTrigger: renderTrigger,
            relatedWorkEdges: edges
        }));
    };
});
parcelRegister("2VJK6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bfaf71cfb4d5cd58$export$2e2bcd8739ae039);
    const $bfaf71cfb4d5cd58$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_relatedWorkEdges"
            }
        ],
        "type": "JiraVersionRelatedWorkV2Edge"
    };
    $bfaf71cfb4d5cd58$var$node.hash = "a1ee6f3b568b757ef42ae7c9484cb878";
    var $bfaf71cfb4d5cd58$export$2e2bcd8739ae039 = $bfaf71cfb4d5cd58$var$node;
});
parcelRegister("2CHAQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30c9f14cd20d8427$export$2e2bcd8739ae039);
    const $30c9f14cd20d8427$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
            }
        ],
        "type": "JiraVersion"
    };
    $30c9f14cd20d8427$var$node.hash = "61023dc51339302e0390200141db5335";
    var $30c9f14cd20d8427$export$2e2bcd8739ae039 = $30c9f14cd20d8427$var$node;
});
parcelRegister("7Zpj8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bOvjY").then(()=>parcelRequire('lhLRC'));
});
parcelRegister("e4M5y", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$ea3b3ec2dfca475e$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    const $ea3b3ec2dfca475e$export$e926676385687eaf = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "flag",
            ...props,
            packageName: "jiraSoftwareReleasesVersionRelatedWork",
            teamName: "fusion-solaris"
        });
});
parcelRegister("aef30", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$193339bde9da421a$export$2e2bcd8739ae039);
    var $10JTQ;
    var $5uXOq = parcelRequire("5uXOq");
    var $fn8B5 = parcelRequire("fn8B5");
    var $8Uumt = parcelRequire("8Uumt");
    var $iXVV6;
    var $8WUQl;
    const $193339bde9da421a$var$isFirstPartyLink = (url)=>new URL(url).hostname === window.location.hostname;
    const $193339bde9da421a$var$useAnalyticsAttributes = (relatedWorkItems)=>{
        const numberOfRelatedWorkItems = relatedWorkItems.length;
        const relatedWorkTypes = (0, ($parcel$interopDefault($fn8B5)))(relatedWorkItems, (item)=>item.node?.__typename);
        const hasNativeReleaseNotes = relatedWorkTypes.JiraVersionRelatedWorkNativeReleaseNotes?.length > 0;
        const numConfluenceReleaseNotes = relatedWorkTypes.JiraVersionRelatedWorkConfluenceReleaseNotes?.length ?? 0;
        const getIssueLinkingAttributes = ()=>{
            const numOfLinkedIssues = relatedWorkItems.filter((item)=>item.node?.issue !== null).length;
            return {
                numOfLinkedIssues: numOfLinkedIssues
            };
        };
        const formatCategoryName = (0, (0, parcelRequire("8WUQl")).useFormatCategoryName)();
        const getPlaceholderStateAttributes = ()=>{
            const genericLinks = relatedWorkTypes.JiraVersionRelatedWorkGenericLink ?? [];
            const numPlaceholderItems = genericLinks.filter((item)=>item.node?.url === null).length;
            const numNonPlaceholderItems = genericLinks.length - numPlaceholderItems;
            const numFirstPartyLinks = genericLinks.filter((item)=>item.node?.url != null && $193339bde9da421a$var$isFirstPartyLink(item.node.url)).length;
            const numThirdPartyLinks = numNonPlaceholderItems - numFirstPartyLinks;
            const itemsByCategories = (0, ($parcel$interopDefault($fn8B5)))(relatedWorkItems, (item)=>item.node?.category);
            const countItemsInCategory = (category)=>itemsByCategories[formatCategoryName(category)]?.length ?? 0;
            const defaultCategoryUsageCounts = (0, (0, parcelRequire("8WUQl")).DEFAULT_CATEGORIES).map((category)=>[
                    category.analyticsAttributeName,
                    countItemsInCategory(category)
                ]);
            const numItemsInDefaultCategories = defaultCategoryUsageCounts.reduce((runningTotal, [, itemsInCategory])=>runningTotal + itemsInCategory, 0);
            const numItemsInOtherCategories = numberOfRelatedWorkItems - numItemsInDefaultCategories;
            const numCategories = Object.keys(itemsByCategories).length;
            return {
                numPlaceholderItems: numPlaceholderItems,
                numNonPlaceholderItems: numNonPlaceholderItems,
                numFirstPartyLinks: numFirstPartyLinks,
                numThirdPartyLinks: numThirdPartyLinks,
                numItemsInOtherCategories: numItemsInOtherCategories,
                numCategories: numCategories,
                ...Object.fromEntries(defaultCategoryUsageCounts)
            };
        };
        return {
            numLinks: numberOfRelatedWorkItems,
            hasNativeReleaseNotes: hasNativeReleaseNotes,
            numConfluenceReleaseNotes: numConfluenceReleaseNotes,
            ...getPlaceholderStateAttributes(),
            ...getIssueLinkingAttributes()
        };
    };
    const $193339bde9da421a$export$e6de70608562a971 = ({ relatedWorkEdges: relatedWorkEdges, children: children })=>{
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("10JTQ")).default), relatedWorkEdges);
        const attributes = $193339bde9da421a$var$useAnalyticsAttributes(data);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "versionRelatedWork",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            attributes: attributes
        }, children);
    };
    var $193339bde9da421a$export$2e2bcd8739ae039 = $193339bde9da421a$export$e6de70608562a971;
});
parcelRegister("10JTQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08a25dc50161972b$export$2e2bcd8739ae039);
    const $08a25dc50161972b$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "__typename"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": {
                "plural": true
            },
            "name": "analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext",
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v0,
                        {
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issue",
                            "plural": false,
                            "selections": [
                                v0
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                }
                            ],
                            "type": "JiraVersionRelatedWorkGenericLink"
                        }
                    ]
                }
            ],
            "type": "JiraVersionRelatedWorkV2Edge"
        };
    }();
    $08a25dc50161972b$var$node.hash = "aa20d10ea14c3261013e36223676a0c8";
    var $08a25dc50161972b$export$2e2bcd8739ae039 = $08a25dc50161972b$var$node;
});
parcelRegister("8WUQl", function(module, exports) {
    $parcel$export(module.exports, "CommunicationCategory", ()=>$80ace99aab585afa$export$4c00bbfcc0ecf975);
    $parcel$export(module.exports, "RolloutCategory", ()=>$80ace99aab585afa$export$f4e280770913e10f);
    $parcel$export(module.exports, "TestingCategory", ()=>$80ace99aab585afa$export$a6d4661a542d168f);
    $parcel$export(module.exports, "AnalyticsCategory", ()=>$80ace99aab585afa$export$257af46c9923adf8);
    $parcel$export(module.exports, "DevelopmentCategory", ()=>$80ace99aab585afa$export$d3d779bdc5757c39);
    $parcel$export(module.exports, "SupportCategory", ()=>$80ace99aab585afa$export$1909a2cc48b27b53);
    $parcel$export(module.exports, "DEFAULT_CATEGORIES", ()=>$80ace99aab585afa$export$b101d8f25cc16679);
    $parcel$export(module.exports, "useFormatCategoryName", ()=>$80ace99aab585afa$export$890bc5a26a499c1d);
    $parcel$export(module.exports, "usePlaceholderIcon", ()=>$80ace99aab585afa$export$ec6234b435e23f80);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gCeEl;
    var $aSRxW;
    var $k17ll;
    var $kBmdu;
    const $80ace99aab585afa$export$4c00bbfcc0ecf975 = {
        i18nMessage: (0, (0, parcelRequire("kBmdu")).default).communicationCategory,
        placeholderIcon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gCeEl")).DocumentPlusGlyph), null),
        analyticsAttributeName: 'numLinksInCommunicationCategory'
    };
    const $80ace99aab585afa$export$f4e280770913e10f = {
        i18nMessage: (0, (0, parcelRequire("kBmdu")).default).rolloutCategory,
        placeholderIcon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aSRxW")).GenericPlusGlyph), null),
        analyticsAttributeName: 'numLinksInRolloutCategory'
    };
    const $80ace99aab585afa$export$a6d4661a542d168f = {
        i18nMessage: (0, (0, parcelRequire("kBmdu")).default).testingCategory,
        placeholderIcon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gCeEl")).DocumentPlusGlyph), null),
        analyticsAttributeName: 'numLinksInTestingCategory'
    };
    const $80ace99aab585afa$export$257af46c9923adf8 = {
        i18nMessage: (0, (0, parcelRequire("kBmdu")).default).analyticsCategory,
        placeholderIcon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k17ll")).PresentationPlusGlyph), null),
        analyticsAttributeName: 'numLinksInAnalyticsCategory'
    };
    const $80ace99aab585afa$export$d3d779bdc5757c39 = {
        i18nMessage: (0, (0, parcelRequire("kBmdu")).default).developmentCategory,
        placeholderIcon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aSRxW")).GenericPlusGlyph), null),
        analyticsAttributeName: 'numLinksInDevelopmentCategory'
    };
    const $80ace99aab585afa$export$1909a2cc48b27b53 = {
        i18nMessage: (0, (0, parcelRequire("kBmdu")).default).supportCategory,
        placeholderIcon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aSRxW")).GenericPlusGlyph), null),
        analyticsAttributeName: 'numLinksInSupportCategory'
    };
    const $80ace99aab585afa$export$b101d8f25cc16679 = [
        $80ace99aab585afa$export$4c00bbfcc0ecf975,
        $80ace99aab585afa$export$f4e280770913e10f,
        $80ace99aab585afa$export$a6d4661a542d168f,
        $80ace99aab585afa$export$257af46c9923adf8,
        $80ace99aab585afa$export$d3d779bdc5757c39,
        $80ace99aab585afa$export$1909a2cc48b27b53
    ];
    const $80ace99aab585afa$export$890bc5a26a499c1d = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (defaultCategoryInfo)=>formatMessage(defaultCategoryInfo.i18nMessage);
    };
    const $80ace99aab585afa$export$ec6234b435e23f80 = (categoryName)=>{
        const formatCategoryName = $80ace99aab585afa$export$890bc5a26a499c1d();
        const defaultCategory = $80ace99aab585afa$export$b101d8f25cc16679.find((category)=>formatCategoryName(category) === categoryName);
        return defaultCategory?.placeholderIcon ? defaultCategory.placeholderIcon : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aSRxW")).GenericPlusGlyph), null);
    };
});
parcelRegister("gCeEl", function(module, exports) {
    $parcel$export(module.exports, "DocumentPlusGlyph", ()=>$3512bc29c550fe45$export$95d5a31c5e54a0d2);
    var $5uXOq = parcelRequire("5uXOq");
    const $3512bc29c550fe45$export$95d5a31c5e54a0d2 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            width: "24px",
            height: "24px",
            viewBox: "7.5 0.5 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0_10645_15672)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "16",
            height: "16",
            transform: "translate(8 8)",
            fill: "white",
            fillOpacity: "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.0619 8H10C9.46957 8 8.96086 8.21071 8.58579 8.58579C8.21071 8.96086 8 9.46957 8 10V22C8 22.5304 8.21071 23.0391 8.58579 23.4142C8.96086 23.7893 9.46957 24 10 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V14.9381C22.365 14.7342 20.8832 14.037 19.7084 13H12C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12C11 11.7348 11.1054 11.4804 11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11H18.0703C17.5478 10.0968 17.1968 9.08194 17.0619 8ZM11.2929 15.2929C11.4804 15.1054 11.7348 15 12 15H20C20.2652 15 20.5196 15.1054 20.7071 15.2929C20.8946 15.4804 21 15.7348 21 16C21 16.2652 20.8946 16.5196 20.7071 16.7071C20.5196 16.8946 20.2652 17 20 17H12C11.7348 17 11.4804 16.8946 11.2929 16.7071C11.1054 16.5196 11 16.2652 11 16C11 15.7348 11.1054 15.4804 11.2929 15.2929ZM11.2929 19.2929C11.4804 19.1054 11.7348 19 12 19H16C16.2652 19 16.5196 19.1054 16.7071 19.2929C16.8946 19.4804 17 19.7348 17 20C17 20.2652 16.8946 20.5196 16.7071 20.7071C16.5196 20.8946 16.2652 21 16 21H12C11.7348 21 11.4804 20.8946 11.2929 20.7071C11.1054 20.5196 11 20.2652 11 20C11 19.7348 11.1054 19.4804 11.2929 19.2929Z",
            fill: "#0C66E4"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "19",
            y: "1",
            width: "12",
            height: "12",
            rx: "6",
            fill: "#22A06B"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0_10645_15672"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "16",
            height: "16",
            fill: "white",
            transform: "translate(8 8)"
        }))));
});
parcelRegister("aSRxW", function(module, exports) {
    $parcel$export(module.exports, "GenericPlusGlyph", ()=>$f5ae30733710816a$export$e68c0551132b814f);
    var $5uXOq = parcelRequire("5uXOq");
    const $f5ae30733710816a$export$e68c0551132b814f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            width: "24px",
            height: "24px",
            viewBox: "7.5 0.5 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0_10645_15679)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "16",
            height: "16",
            transform: "translate(8 8)",
            fill: "white",
            fillOpacity: "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.0619 8H9.994C8.895 8 8 8.893 8 9.994V22.006C8.00026 22.5348 8.21043 23.0418 8.58432 23.4157C8.95821 23.7896 9.46524 23.9997 9.994 24H22.006C22.5348 23.9997 23.0418 23.7896 23.4157 23.4157C23.7896 23.0418 23.9997 22.5348 24 22.006V14.9381C20.3813 14.4869 17.5131 11.6187 17.0619 8ZM13.333 11H16H16.782C16.9614 10.9998 17.139 11.0359 17.3041 11.106C17.4692 11.1761 17.6185 11.2788 17.743 11.408L19.907 13.658C19.9667 13.7201 20 13.8029 20 13.889V14.792C20 14.975 19.851 15.125 19.667 15.125H17.333C16.597 15.125 16 14.528 16 13.792V12.378H13.333V19.622H18.667V16H20V19.622C20 20.383 19.403 21 18.667 21H13.333C12.597 21 12 20.382 12 19.622V12.378C12 11.617 12.597 11 13.333 11Z",
            fill: "#5E6C84"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "19",
            y: "1",
            width: "12",
            height: "12",
            rx: "6",
            fill: "#22A06B"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0_10645_15679"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "16",
            height: "16",
            fill: "white",
            transform: "translate(8 8)"
        }))));
});
parcelRegister("k17ll", function(module, exports) {
    $parcel$export(module.exports, "PresentationPlusGlyph", ()=>$14cff13b7789db4e$export$4026a3889e667c70);
    var $5uXOq = parcelRequire("5uXOq");
    const $14cff13b7789db4e$export$4026a3889e667c70 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            width: "24px",
            height: "24px",
            viewBox: "7.5 0.5 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0_10645_15686)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "16",
            height: "16",
            transform: "translate(8 8)",
            fill: "white",
            fillOpacity: "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.0619 8H10C9.46957 8 8.96086 8.21071 8.58579 8.58579C8.21071 8.96086 8 9.46957 8 10V22C8 22.5304 8.21071 23.0391 8.58579 23.4142C8.96086 23.7893 9.46957 24 10 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V14.9381C22.9181 14.8032 21.9032 14.4522 21 13.9297V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21C19.7348 21 19.4804 20.8946 19.2929 20.7071C19.1054 20.5196 19 20.2652 19 20V12.2916C17.963 11.1168 17.2658 9.635 17.0619 8ZM15.2929 14.2929C15.4804 14.1054 15.7348 14 16 14C16.2652 14 16.5196 14.1054 16.7071 14.2929C16.8946 14.4804 17 14.7348 17 15V20C17 20.2652 16.8946 20.5196 16.7071 20.7071C16.5196 20.8946 16.2652 21 16 21C15.7348 21 15.4804 20.8946 15.2929 20.7071C15.1054 20.5196 15 20.2652 15 20V15C15 14.7348 15.1054 14.4804 15.2929 14.2929ZM11.2929 17.2929C11.4804 17.1054 11.7348 17 12 17C12.2652 17 12.5196 17.1054 12.7071 17.2929C12.8946 17.4804 13 17.7348 13 18V20C13 20.2652 12.8946 20.5196 12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21C11.7348 21 11.4804 20.8946 11.2929 20.7071C11.1054 20.5196 11 20.2652 11 20V18C11 17.7348 11.1054 17.4804 11.2929 17.2929Z",
            fill: "#8270DB"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "19",
            y: "1",
            width: "12",
            height: "12",
            rx: "6",
            fill: "#22A06B"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z",
            fill: "white"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0_10645_15686"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "16",
            height: "16",
            fill: "white",
            transform: "translate(8 8)"
        }))));
});
parcelRegister("kBmdu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1cd855af87b6eafb$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1cd855af87b6eafb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        testingCategory: {
            "id": "software-releases-version-related-work-categories.common.default-categories.testing-category",
            "defaultMessage": "Testing"
        },
        rolloutCategory: {
            "id": "software-releases-version-related-work-categories.common.default-categories.rollout-category",
            "defaultMessage": "Rollout"
        },
        analyticsCategory: {
            "id": "software-releases-version-related-work-categories.common.default-categories.analytics-category",
            "defaultMessage": "Analytics"
        },
        communicationCategory: {
            "id": "software-releases-version-related-work-categories.common.default-categories.communication-category",
            "defaultMessage": "Communication"
        },
        developmentCategory: {
            "id": "software-releases-version-related-work-categories.common.default-categories.development-category",
            "defaultMessage": "Development"
        },
        supportCategory: {
            "id": "software-releases-version-related-work-categories.common.default-categories.support-category",
            "defaultMessage": "Support"
        }
    });
});
parcelRegister("23OBX", function(module, exports) {
    $parcel$export(module.exports, "CategoryFilter", ()=>$de63c0a6daedd5ee$export$cb2cc3e02411c0f4);
    var $jWtjn;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fn8B5 = parcelRequire("fn8B5");
    var $8Uumt = parcelRequire("8Uumt");
    var $koVbs;
    var $hBvOQ;
    var $iZMIP;
    var $21BDB;
    const $de63c0a6daedd5ee$export$c50c7c4a5ff445b1 = 5;
    const $de63c0a6daedd5ee$export$cb2cc3e02411c0f4 = ({ relatedWorkEdges: relatedWorkEdges, selectedCategory: selectedCategory, onCategorySelected: onCategorySelected })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const edges = (0, $8Uumt.useFragment)((0, (0, parcelRequire("jWtjn")).default), relatedWorkEdges);
        const edgesByCategory = (0, ($parcel$interopDefault($fn8B5)))(edges, (edge)=>edge?.node.category);
        const sortedCategoriesWithCounts = Object.keys(edgesByCategory).map((category)=>[
                category,
                edgesByCategory[category].length
            ]).sort(([categoryA], [categoryB])=>categoryA.localeCompare(categoryB));
        const isknownCategory = selectedCategory === undefined || sortedCategoriesWithCounts.some(([category])=>category === selectedCategory);
        (0, $5uXOq.useEffect)(()=>{
            if (!isknownCategory) onCategorySelected(undefined);
        }, [
            isknownCategory,
            onCategorySelected
        ]);
        const categoriesWithCountWithinThreshold = sortedCategoriesWithCounts.slice(0, $de63c0a6daedd5ee$export$c50c7c4a5ff445b1);
        const categoriesWithCountAfterThreshold = sortedCategoriesWithCounts.slice($de63c0a6daedd5ee$export$c50c7c4a5ff445b1);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($de63c0a6daedd5ee$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBvOQ")).Lozenge), {
            label: formatMessage((0, (0, parcelRequire("iZMIP")).default).all),
            count: edges.length ?? 0,
            isSelected: selectedCategory === undefined,
            onClick: ()=>onCategorySelected(undefined)
        }), categoriesWithCountWithinThreshold.map(([category, count])=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hBvOQ")).Lozenge), {
                key: category,
                label: category,
                count: count,
                isSelected: category === selectedCategory,
                onClick: ()=>onCategorySelected(category)
            })), categoriesWithCountAfterThreshold.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("21BDB")).MoreLozengeAsync), {
            categories: categoriesWithCountAfterThreshold.map(([category, count])=>({
                    label: category,
                    count: count,
                    isSelected: category === selectedCategory,
                    onClick: ()=>onCategorySelected(category)
                }))
        }));
    };
    const $de63c0a6daedd5ee$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1n261g80 _zulpu2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jWtjn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e5c6a475ff71547$export$2e2bcd8739ae039);
    const $6e5c6a475ff71547$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "categoryFilter_softwareReleasesVersionRelatedWork",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "category"
                            },
                            "action": "NONE",
                            "path": "node.category"
                        }
                    ]
                },
                "action": "NONE",
                "path": "node"
            }
        ],
        "type": "JiraVersionRelatedWorkV2Edge"
    };
    $6e5c6a475ff71547$var$node.hash = "26b1d568eba141b6bfe3000d32fec7e5";
    var $6e5c6a475ff71547$export$2e2bcd8739ae039 = $6e5c6a475ff71547$var$node;
});
parcelRegister("hBvOQ", function(module, exports) {
    $parcel$export(module.exports, "Lozenge", ()=>$e48a18721cdfc1a2$export$a31cbe1bf5463979);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2NMNM;
    var $koVbs;
    var $8zOmE;
    const $e48a18721cdfc1a2$export$a31cbe1bf5463979 = ({ label: label, count: count, isSelected: isSelected, onClick: onClick })=>{
        const { formatNumber: formatNumber } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e48a18721cdfc1a2$var$Button, {
            title: label,
            isSelected: isSelected,
            onClick: ()=>{
                onClick();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'lozenge'
                }), 'relatedWorkCategory');
            },
            "data-testid": "software-releases-version-related-work.ui.category-filter.lozenge.button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e48a18721cdfc1a2$var$Label, null, label), (0, ($parcel$interopDefault($5uXOq))).createElement($e48a18721cdfc1a2$var$Count, null, formatNumber(count)));
    };
    const $e48a18721cdfc1a2$var$Button = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isSelected: isSelected, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2rkodlk8 _1yt418iy _1dqoglyw _80omtlke _k48p1nn1 _1wybw1gv _vwz4f6fq",
                __cmplp.isSelected ? "_bfhk29zg" : "_bfhk1s4m",
                __cmplp.isSelected ? "_syaz1fp7" : "_syaz1rr7",
                __cmplp.className
            ])
        });
    });
    const $e48a18721cdfc1a2$var$Label = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1o8l _p12f1kdj _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
    const $e48a18721cdfc1a2$var$Count = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48p1fw0 _19bv12x7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iZMIP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f4135e7ecbb3a6b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4f4135e7ecbb3a6b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        all: {
            "id": "software-releases-version-related-work.category-filter.all",
            "defaultMessage": "All"
        }
    });
});
parcelRegister("21BDB", function(module, exports) {
    $parcel$export(module.exports, "MoreLozengeAsync", ()=>$97665c1381d8292f$export$1e468fbbda90a7b4);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $lfTZh;
    var $kxZPA;
    var $4Qaas;
    var $lhsVB;
    const $97665c1381d8292f$var$LazyMoreLozenge = (0, (0, parcelRequire("kxZPA")).lazy)(()=>Promise.resolve((parcelRequire("4Qaas"))).then((mod)=>mod.MoreLozenge), {
        moduleId: "./src/packages/releases/version-related-work/src/ui/category-filter/more-lozenge/index.tsx"
    });
    const $97665c1381d8292f$export$1e468fbbda90a7b4 = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { categories: categories } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jira-software-releases-version-detail-related-work-more-lozenge",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Qaas")).LozengeButton), {
                isSelected: categories.some((category)=>category.isSelected)
            }, formatMessage((0, (0, parcelRequire("lhsVB")).default).moreButtonLabel, {
                count: categories.length
            }))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($97665c1381d8292f$var$LazyMoreLozenge, props));
    };
});
parcelRegister("4Qaas", function(module, exports) {
    $parcel$export(module.exports, "MoreLozenge", ()=>$844a27df9929e176$export$394f480a87f8efa7);
    $parcel$export(module.exports, "LozengeButton", ()=>$844a27df9929e176$export$2c8fc3c10740b2a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $2NMNM;
    var $BLPHT;
    var $a5n5E;
    var $b2TJP;
    var $koVbs;
    var $8zOmE;
    var $lhsVB;
    const $844a27df9929e176$export$394f480a87f8efa7 = ({ categories: categories, defaultOpen: defaultOpen = false })=>{
        const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            defaultOpen: defaultOpen,
            trigger: ({ triggerRef: triggerRef, ...otherProps })=>{
                const { isSelected: isDropdownOpen } = otherProps;
                return (0, ($parcel$interopDefault($5uXOq))).createElement($844a27df9929e176$export$2c8fc3c10740b2a5, {
                    ...otherProps,
                    isDropdownOpen: isDropdownOpen ?? false,
                    ref: triggerRef,
                    isSelected: categories.some((category)=>category.isSelected),
                    "data-testid": "software-releases-version-related-work.ui.category-filter.more-lozenge.dropdown-trigger"
                }, formatMessage((0, (0, parcelRequire("lhsVB")).default).moreButtonLabel, {
                    count: categories.length
                }));
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b2TJP")).default), {
            id: "categories"
        }, categories.map(({ label: label, count: count, onClick: onClick, isSelected: isSelected })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a5n5E")).default), {
                isSelected: isSelected,
                onClick: ()=>{
                    onClick();
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'lozenge'
                    }), 'relatedWorkCategory');
                },
                id: label,
                key: label,
                testId: "software-releases-version-related-work.ui.category-filter.more-lozenge.dropdown-item-button"
            }, label, " (", formatNumber(count), ")"))));
    };
    const $844a27df9929e176$export$2c8fc3c10740b2a5 = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isDropdownOpen: isDropdownOpen, isSelected: isSelected, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_24nxvd": (0, (0, parcelRequire("lD23V")).default)((()=>{
                    if (__cmplp.isDropdownOpen) return `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$exports).N700})`;
                    return __cmplp.isSelected ? `var(--ds-background-selected, ${(0, $829f609a65d26a98$exports).B50})` : `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N20})`;
                })()),
                "--_1by0n80": (0, (0, parcelRequire("lD23V")).default)((()=>{
                    if (__cmplp.isDropdownOpen) return `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`;
                    return __cmplp.isSelected ? `var(--ds-text-information, ${(0, $829f609a65d26a98$exports).B500})` : `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N500})`;
                })())
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2rkodlk8 _1yt418iy _1dqoglyw _80omtlke _bfhk3hhc _syazvaks _k48p1nn1 _1wybw1gv _vwz4f6fq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lhsVB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2adc7535873c8f8f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2adc7535873c8f8f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moreButtonLabel: {
            "id": "software-releases-version-related-work.category-filter.more-lozenge.more-button-label",
            "defaultMessage": "+{count} more"
        }
    });
});
parcelRegister("iaG90", function(module, exports) {
    $parcel$export(module.exports, "RelatedWorkEmptyState", ()=>$4bf624bf2d80822c$export$eeabb037f6ceac15);
    var $fFUyY;
    var $21azx;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $l1N8i;
    var $koVbs;
    var $24M80;
    var $a3dw0;
    var $e4M5y;
    var $4i4ip;
    var $kKaiv = parcelRequire("kKaiv");
    var $dZhCe;
    const $4bf624bf2d80822c$export$eeabb037f6ceac15 = ({ jiraVersion: jiraVersion, relatedWorkEdges: relatedWorkEdges })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const addRelatedWorkExpFailed = (0, (0, parcelRequire("24M80")).useAddRelatedWorkExperienceFail)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("21azx")).default), jiraVersion);
        const edges = (0, $8Uumt.useFragment)((0, (0, parcelRequire("fFUyY")).default), relatedWorkEdges);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($4bf624bf2d80822c$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4i4ip")).VersionRelatedWorkExperienceSuccessTracker), null), (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($kKaiv))),
            width: 80,
            height: 71.45,
            alt: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("section", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            as: "h3",
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("dZhCe")).default).emptyStateHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement($4bf624bf2d80822c$var$Description, null, formatMessage((0, (0, parcelRequire("dZhCe")).default).emptyStateDescription))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4M5y")).ErrorBoundary), {
            id: "addRelatedPopupInEmptyState",
            fallback: "unmount",
            onError: (location, error)=>{
                addRelatedWorkExpFailed(location, error);
            }
        }, version.status != null && version.status !== 'ARCHIVED' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a3dw0")).AddRelatedWorkPopup), {
            jiraVersion: version,
            relatedWorkEdges: edges,
            renderTrigger: ({ triggerProps: triggerProps, onClick: onClick, isLoading: isLoading, onMouseOver: onMouseOver })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...triggerProps,
                    onClick: onClick,
                    testId: isLoading ? undefined : 'software-releases-version-related-work.ui.empty-state.button',
                    onMouseOver: onMouseOver
                }, formatMessage((0, (0, parcelRequire("dZhCe")).default).add))
        })));
    };
    const $4bf624bf2d80822c$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _gy1p1ejb _19pkpxbi _1yt41ejb _2rkoftgi _189eyh40 _1dqogq9o _1h6dhloo",
                __cmplp.className
            ])
        });
    });
    const $4bf624bf2d80822c$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1rc1 _p12f1ffr",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fFUyY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dac88918497cff9c$export$2e2bcd8739ae039);
    const $dac88918497cff9c$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges"
            }
        ],
        "type": "JiraVersionRelatedWorkV2Edge"
    };
    $dac88918497cff9c$var$node.hash = "93018a8cf1d1d8516c9bb5d6c022ae78";
    var $dac88918497cff9c$export$2e2bcd8739ae039 = $dac88918497cff9c$var$node;
});
parcelRegister("21azx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$84b1a607716c4ff7$export$2e2bcd8739ae039);
    const $84b1a607716c4ff7$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ],
        "type": "JiraVersion"
    };
    $84b1a607716c4ff7$var$node.hash = "8330954195b2fe0fa1d89b6b61b53975";
    var $84b1a607716c4ff7$export$2e2bcd8739ae039 = $84b1a607716c4ff7$var$node;
});
parcelRegister("kKaiv", function(module, exports) {
    module.exports = new URL("documents-illustration.37d481a2.svg", import.meta.url).toString();
});
parcelRegister("dZhCe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b86761f81df3cdc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5b86761f81df3cdc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyStateHeading: {
            "id": "software-releases-version-related-work.empty-state.empty-state-heading",
            "defaultMessage": "Start adding some related work"
        },
        emptyStateDescription: {
            "id": "software-releases-version-related-work.empty-state.empty-state-description",
            "defaultMessage": "Add the work that's needed to get ready for your release like designs, release notes, analytics dashboards, and more!"
        },
        add: {
            "id": "software-releases-version-related-work.empty-state.add",
            "defaultMessage": "Add related work"
        }
    });
});
parcelRegister("hhood", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22c34e0f660d12bd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $22c34e0f660d12bd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        relatedWorkHeading: {
            "id": "software-releases-version-related-work.related-work-heading",
            "defaultMessage": "Related work"
        },
        addRelatedWork: {
            "id": "software-releases-version-related-work.add-related-work",
            "defaultMessage": "Add links, release notes, and more\u2026"
        },
        showMore: {
            "id": "software-releases-version-related-work.show-more",
            "defaultMessage": "Show {moreItemsCount} more"
        },
        showLess: {
            "id": "software-releases-version-related-work.show-less",
            "defaultMessage": "Show {moreItemsCount} less"
        }
    });
});
parcelRegister("gCsUv", function(module, exports) {
    $parcel$export(module.exports, "RelatedWorkList", ()=>$d31b32d43fc469e4$export$25137fc5a267c4a9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    var $2oFsx;
    const $d31b32d43fc469e4$var$LazyRelatedWorkList = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("cblNr")).then((module)=>module.RelatedWorkList), {
        moduleId: "./src/packages/releases/version-related-work/src/ui/related-work-list/index.tsx"
    });
    const $d31b32d43fc469e4$export$25137fc5a267c4a9 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "related-work-list",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oFsx")).SkeletonRelatedWorkList), {
                numLinks: props.relatedWorkEdges.length
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d31b32d43fc469e4$var$LazyRelatedWorkList, props));
});
parcelRegister("2oFsx", function(module, exports) {
    $parcel$export(module.exports, "SkeletonRelatedWorkList", ()=>$5b6f8fb86ef16639$export$98236437a8dbfc1c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $5b6f8fb86ef16639$export$98236437a8dbfc1c = ({ numLinks: numLinks })=>(0, ($parcel$interopDefault($5uXOq))).createElement($5b6f8fb86ef16639$var$TableWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($5b6f8fb86ef16639$var$RelatedWorkItemWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($5b6f8fb86ef16639$var$SkeletonRelatedWorkRowWrapper, null, [
            ...Array(numLinks)
        ].map((_, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5b6f8fb86ef16639$var$RelatedWorkItemWrapper, {
                key: i
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($5b6f8fb86ef16639$var$SkeletonRelatedWorkIcon, {
                opacity: 1 - i * 0.2
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($5b6f8fb86ef16639$var$SkeletonRelatedWorkItemLarge, {
                opacity: 1 - i * 0.2
            })))), (0, ($parcel$interopDefault($5uXOq))).createElement($5b6f8fb86ef16639$var$SkeletonRelatedWorkRowWrapper, null, [
            ...Array(numLinks)
        ].map((_, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5b6f8fb86ef16639$var$SkeletonRelatedWorkItemSmall, {
                key: i,
                opacity: 1 - i * 0.2
            })))));
    const $5b6f8fb86ef16639$var$shimmer = null;
    const $5b6f8fb86ef16639$var$SkeletonRelatedWorkItemStyles = null;
    const $5b6f8fb86ef16639$var$verticalMargin = 15;
    const $5b6f8fb86ef16639$var$SkeletonRelatedWorkIcon = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_kn3dj": (0, (0, parcelRequire("lD23V")).default)(__cmplp.opacity)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _4t3iqslr _bfhkqrzy _2rko1y44 _j7hqw3o4 _1bsbqslr _18s81vn1",
                __cmplp.opacity ? "_tzy41p15" : "_tzy4kb7n",
                __cmplp.className
            ])
        });
    });
    const $5b6f8fb86ef16639$var$SkeletonRelatedWorkItemLarge = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_kn3dj": (0, (0, parcelRequire("lD23V")).default)(__cmplp.opacity)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _4t3iqslr _bfhkqrzy _2rko1y44 _j7hqw3o4 _1bsbpo3b _19pko7ao _2hwxidpf _otyro7ao _18u0idpf",
                __cmplp.opacity ? "_tzy41p15" : "_tzy4kb7n",
                __cmplp.className
            ])
        });
    });
    const $5b6f8fb86ef16639$var$SkeletonRelatedWorkItemSmall = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_kn3dj": (0, (0, parcelRequire("lD23V")).default)(__cmplp.opacity)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _4t3iqslr _bfhkqrzy _2rko1y44 _j7hqw3o4 _1bsb1ex1 _18s81w5s",
                __cmplp.opacity ? "_tzy41p15" : "_tzy4kb7n",
                __cmplp.className
            ])
        });
    });
    const $5b6f8fb86ef16639$var$TableWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _1e0c1txw _kqswh2mm _2lx21bp4 _ca0qutpp",
                __cmplp.className
            ])
        });
    });
    const $5b6f8fb86ef16639$var$SkeletonRelatedWorkRowWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _1bah1yb4 _19bv1b66 _1p571b66",
                __cmplp.className
            ])
        });
    });
    const $5b6f8fb86ef16639$var$RelatedWorkItemWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cblNr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hvFAx")
    ]).then(()=>parcelRequire('dTy2j'));
});
parcelRegister("gvbk2", function(module, exports) {
    $parcel$export(module.exports, "RelatedWorkLoadingSkeleton", ()=>$b8c1865ca5df36e0$export$d1ea41fcd84767c8);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $1DVhQ;
    const $b8c1865ca5df36e0$var$RelatedWorkItemSkeleton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $b8c1865ca5df36e0$var$relatedWorkWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $b8c1865ca5df36e0$var$relatedWorkLeftWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "24px",
            height: "24px",
            isShimmering: true
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $b8c1865ca5df36e0$var$relatedWorkRightWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "350px",
            height: "24px",
            isShimmering: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "220px",
            height: "18px",
            isShimmering: true
        })));
    const $b8c1865ca5df36e0$export$d1ea41fcd84767c8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $b8c1865ca5df36e0$var$headerSkeletonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            width: "220px",
            height: "24px",
            isShimmering: true
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $b8c1865ca5df36e0$var$categoryFilterRowStlyes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            isShimmering: true,
            borderRadius: 14,
            width: "52px",
            height: "26px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            isShimmering: true,
            borderRadius: 14,
            width: "85px",
            height: "26px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            isShimmering: true,
            borderRadius: 14,
            width: "125px",
            height: "26px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            isShimmering: true,
            borderRadius: 14,
            width: "110px",
            height: "26px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            isShimmering: true,
            borderRadius: 14,
            width: "110",
            height: "26px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            isShimmering: true,
            borderRadius: 14,
            width: "70px",
            height: "26px"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($b8c1865ca5df36e0$var$RelatedWorkItemSkeleton, null)));
    const $b8c1865ca5df36e0$var$headerSkeletonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.500',
        marginBottom: 'space.250'
    });
    const $b8c1865ca5df36e0$var$categoryFilterRowStlyes = (0, (0, parcelRequire("8CUq3")).xcss)({
        gap: 'space.100',
        marginBottom: 'space.150'
    });
    const $b8c1865ca5df36e0$var$relatedWorkWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: 'space.800'
    });
    const $b8c1865ca5df36e0$var$relatedWorkRightWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 'space.150'
    });
    const $b8c1865ca5df36e0$var$relatedWorkLeftWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '64px',
        height: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
});
parcelRegister("iMhWR", function(module, exports) {
    $parcel$export(module.exports, "AsyncVersionRichTextSection", ()=>$865e37e6a4604790$export$6803497461260cfa);
    var $hP2RT;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $8Uumt = parcelRequire("8Uumt");
    var $lfTZh;
    var $kxZPA;
    const $865e37e6a4604790$var$LazyVersionRichTextSection = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("djvzL")).then((module)=>module.VersionRichTextSection), {
        moduleId: "./src/packages/releases/version-rich-text-section/src/ui/index.tsx"
    });
    const $865e37e6a4604790$export$6803497461260cfa = ({ jiraVersion: jiraVersion })=>{
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("hP2RT")).default), jiraVersion);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "rich-text-section",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($865e37e6a4604790$var$SkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($865e37e6a4604790$var$SkeletonItem, {
                width: "15%"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($865e37e6a4604790$var$SkeletonItem, {
                width: "45%"
            }))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($865e37e6a4604790$var$LazyVersionRichTextSection, {
            jiraVersion: version
        }));
    };
    const $865e37e6a4604790$var$SkeletonItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk1aqf _4t3idlk8 _1bsb1rkg _2rko1l7b _19pkutpp",
                __cmplp.className
            ])
        });
    });
    const $865e37e6a4604790$var$SkeletonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _1bah1y6m _19pk1ejb",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hP2RT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$158348738d9fccd5$export$2e2bcd8739ae039);
    const $158348738d9fccd5$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionRichTextSection_VersionRichTextSection"
            }
        ],
        "type": "JiraVersion"
    };
    $158348738d9fccd5$var$node.hash = "d5a19fe58067365a8d3ea1743ac2c96d";
    var $158348738d9fccd5$export$2e2bcd8739ae039 = $158348738d9fccd5$var$node;
});
parcelRegister("djvzL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hp5h3")
    ]).then(()=>parcelRequire('fphGU'));
});
parcelRegister("cCXos", function(module, exports) {
    $parcel$export(module.exports, "IssueAssociatedDesignsExperienceStart", ()=>$975d2344f76386e8$export$81d77c7d61cbddef);
    $parcel$export(module.exports, "IssueAssociatedDesignsExperienceSuccess", ()=>$975d2344f76386e8$export$709f489a7a70c461);
    $parcel$export(module.exports, "useIssueAssociatedDesignsExperienceFail", ()=>$975d2344f76386e8$export$715c37bd4d0b2cba);
    var $5uXOq = parcelRequire("5uXOq");
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    const $975d2344f76386e8$var$EXPERIENCE_NAME = 'issueAssociatedDesigns';
    const $975d2344f76386e8$var$ANALYTICS_SOURCE = 'versionDetails';
    const $975d2344f76386e8$export$81d77c7d61cbddef = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaHBi")).ExperienceStart), {
            experienceId: "jiraVersionDetailsIssueAssociatedDesigns",
            experience: $975d2344f76386e8$var$EXPERIENCE_NAME,
            analyticsSource: $975d2344f76386e8$var$ANALYTICS_SOURCE,
            edition: appEditions.software,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE)
        });
    };
    const $975d2344f76386e8$export$709f489a7a70c461 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: $975d2344f76386e8$var$EXPERIENCE_NAME
        });
    const $975d2344f76386e8$export$715c37bd4d0b2cba = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $975d2344f76386e8$var$EXPERIENCE_NAME
        });
});
parcelRegister("fCXaV", function(module, exports) {
    $parcel$export(module.exports, "IssueAssociatedDesigns", ()=>$0282686bbab839ac$export$891b244b5d2793aa);
    $parcel$export(module.exports, "DesignSectionSkeleton", ()=>$0282686bbab839ac$export$b6a2d0e3927c95cf);
    var $4UYYD;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $8Uumt = parcelRequire("8Uumt");
    var $16T6Y;
    var $l1N8i;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $fi7WV;
    var $hnsnI;
    var $cCXos;
    var $lbwou;
    var $fESpJ;
    var $bgc85;
    const $0282686bbab839ac$export$891b244b5d2793aa = ({ queryRef: queryRef })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { jira: { version: version } } = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("4UYYD")).default), queryRef);
        if (version.__typename !== 'JiraVersion') throw new Error('Version query result is not VersionResult');
        const { totalCount: totalCount } = version.issueAssociatedDesigns;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "versionIssueAssociatedDesigns",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            attributes: {
                designsCount: totalCount
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fi7WV")).CollapsibleSection), {
            jiraVersion: version,
            renderBody: ()=>{
                if (totalCount === 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fESpJ")).EmptyState), null);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lbwou")).DesignCarousel), {
                    jiraVersion: version
                });
            },
            renderHeader: (isCollapsed, onToggleClicked)=>(0, ($parcel$interopDefault($5uXOq))).createElement($0282686bbab839ac$var$HeaderWrapper, {
                    onClick: onToggleClicked
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
                    size: "small",
                    as: "h2"
                }, formatMessage((0, (0, parcelRequire("bgc85")).default).designSectionLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), null, totalCount), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fi7WV")).CollapsibleToggleButton), {
                    isCollapsed: isCollapsed,
                    onClick: onToggleClicked
                })),
            uiType: "ISSUE_ASSOCIATED_DESIGNS"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cCXos")).IssueAssociatedDesignsExperienceSuccess), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
    };
    const $0282686bbab839ac$export$b6a2d0e3927c95cf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($0282686bbab839ac$var$SkeletonItem, {
            width: "220px",
            height: "24px",
            margin: "44px 0 20px 0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $0282686bbab839ac$var$designCardsSkeletonWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hnsnI")).DesignCardSkeleton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hnsnI")).DesignCardSkeleton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hnsnI")).DesignCardSkeleton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hnsnI")).DesignCardSkeleton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hnsnI")).DesignCardSkeleton), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hnsnI")).DesignCardSkeleton), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $0282686bbab839ac$var$crouselCounterStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0282686bbab839ac$var$SkeletonItem, {
            width: "100px",
            height: "20px",
            margin: "20px 0 0 0"
        })));
    const $0282686bbab839ac$var$designCardsSkeletonWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        gap: 'space.200',
        width: '100%',
        overflow: 'hidden',
        padding: 'space.050',
        marginTop: 'space.100'
    });
    const $0282686bbab839ac$var$crouselCounterStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        justifyContent: 'center',
        alignItems: 'center',
        height: '20px'
    });
    const $0282686bbab839ac$var$animationOptionStyles = null;
    const $0282686bbab839ac$var$shimmer = null;
    const $0282686bbab839ac$var$SkeletonItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { margin: margin, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height),
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width),
                "--_146ducd": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.margin}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _j7hqw3o4 _bfhkqrzy _2rko1y44 _4t3i1474 _1bsb1rkg _18s8j3fp",
                __cmplp.className
            ])
        });
    });
    const $0282686bbab839ac$var$HeaderWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1y6m _zulpu2gc _80omtlke _19pk1jfw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("16T6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe7856b71523badd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $ehtcU;
    function $fe7856b71523badd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $fe7856b71523badd$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.200',
        display: 'inline-flex',
        blockSize: 'min-content',
        flexShrink: 0
    });
    const $fe7856b71523badd$var$neutral300 = '#DDDEE1';
    const $fe7856b71523badd$var$red300 = '#FD9891';
    const $fe7856b71523badd$var$blue300 = '#8FB8F6';
    const $fe7856b71523badd$var$neutral1000 = '#292A2E';
    const $fe7856b71523badd$var$styles = {
        root: {
            name: "85bcg3",
            styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
        },
        added: {
            name: "4x7cmh",
            styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
        },
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$neutral300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        important: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$red300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primary: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$blue300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primaryInverted: {
            name: "1425qmy",
            styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
        },
        removed: {
            name: "10hiq01",
            styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
        }
    };
    const $fe7856b71523badd$var$Badge = (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-testid": testId,
            css: [
                $fe7856b71523badd$var$styles.root,
                $fe7856b71523badd$var$styles[appearance]
            ],
            style: {
                background: style?.backgroundColor,
                color: style?.color
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            align: "center",
            color: "inherit"
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            as: "span",
            backgroundColor: $fe7856b71523badd$var$backgroundColors[appearance],
            xcss: $fe7856b71523badd$var$boxStyles,
            style: {
                background: style?.backgroundColor,
                color: style?.color
            },
            paddingInline: "space.075"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $fe7856b71523badd$var$textColors[appearance]
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
    });
    $fe7856b71523badd$var$Badge.displayName = 'Badge';
    var $fe7856b71523badd$export$2e2bcd8739ae039 = $fe7856b71523badd$var$Badge;
    const $fe7856b71523badd$var$backgroundColors = {
        added: 'color.background.success',
        default: 'color.background.neutral',
        important: 'color.background.danger.bold',
        primary: 'color.background.brand.bold',
        primaryInverted: 'elevation.surface',
        removed: 'color.background.danger'
    };
    const $fe7856b71523badd$var$textColors = {
        added: 'color.text.success',
        default: 'color.text',
        important: 'color.text.inverse',
        primary: 'color.text.inverse',
        primaryInverted: 'color.text.brand',
        removed: 'color.text.danger'
    };
});
parcelRegister("ehtcU", function(module, exports) {
    $parcel$export(module.exports, "formatValue", ()=>$24d41a560822020b$export$7c4d25c0c3217d8c);
    function $24d41a560822020b$var$getSafeValue(value = 0) {
        const numericValue = +value;
        if (numericValue < 0) return 0;
        return value;
    }
    function $24d41a560822020b$export$7c4d25c0c3217d8c(value, max) {
        const safeValue = $24d41a560822020b$var$getSafeValue(value);
        const safeMax = $24d41a560822020b$var$getSafeValue(max);
        if (safeMax && safeMax < safeValue) return `${safeMax}+`;
        if (safeValue === Infinity) return "\u221E";
        return safeValue.toString();
    }
});
parcelRegister("hnsnI", function(module, exports) {
    $parcel$export(module.exports, "DesignCardSkeleton", ()=>$eaa2c10cc8d93fbb$export$1743685a5725b0ae);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $lQYCz;
    const $eaa2c10cc8d93fbb$export$1743685a5725b0ae = ({ onVisible: onVisible })=>{
        const onSetElementRef = (0, (0, parcelRequire("lQYCz")).useIntersectionObserver)({
            margin: 0,
            onIntersection: ()=>onVisible?.()
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $eaa2c10cc8d93fbb$var$cardContainerStyles,
            ref: onSetElementRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($eaa2c10cc8d93fbb$var$SkeletonItem, {
            width: "24px",
            height: "24px",
            margin: "0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $eaa2c10cc8d93fbb$var$titleStackStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($eaa2c10cc8d93fbb$var$SkeletonItem, {
            width: "220px",
            height: "16px",
            margin: "2px 0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($eaa2c10cc8d93fbb$var$SkeletonItem, {
            width: "80px",
            height: "12px",
            margin: "2px 0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($eaa2c10cc8d93fbb$var$SkeletonItem, {
            width: "120px",
            height: "24px",
            margin: "12px 0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($eaa2c10cc8d93fbb$var$SkeletonItem, {
            width: "50px",
            height: "12px",
            margin: "2px 0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($eaa2c10cc8d93fbb$var$SkeletonItem, {
            width: "240px",
            height: "26px",
            margin: "5px 0"
        })));
    };
    const $eaa2c10cc8d93fbb$var$animationOptionStyles = null;
    const $eaa2c10cc8d93fbb$var$shimmer = null;
    const $eaa2c10cc8d93fbb$var$SkeletonItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { margin: margin, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height),
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width),
                "--_146ducd": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.margin}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1ipn _12vemgnk _j7hqw3o4 _bfhkqrzy _2rko1y44 _4t3i1474 _1bsb1rkg _18s8j3fp",
                __cmplp.className
            ])
        });
    });
    const $eaa2c10cc8d93fbb$var$cardContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        border: '3px',
        paddingTop: 'space.100',
        paddingBottom: 'space.100',
        paddingLeft: 'space.150',
        paddingRight: 'space.150',
        boxShadow: 'elevation.shadow.raised'
    });
    const $eaa2c10cc8d93fbb$var$titleStackStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: 1,
        marginLeft: 'space.100',
        overflow: 'hidden'
    });
});
parcelRegister("lQYCz", function(module, exports) {
    $parcel$export(module.exports, "useIntersectionObserver", ()=>$a631eb23b7c62b0c$export$a7395f9832c00176);
    var $5uXOq = parcelRequire("5uXOq");
    const $a631eb23b7c62b0c$export$a7395f9832c00176 = ({ margin: margin, threshold: threshold = 0, onIntersection: onIntersection })=>{
        const [observedElement, setObservedElement] = (0, $5uXOq.useState)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (observedElement === null || window.IntersectionObserver === undefined) return undefined;
            const observerCallback = (entries)=>entries.forEach(({ isIntersecting: isIntersecting, time: time })=>{
                    if (isIntersecting) onIntersection(time);
                });
            const observer = new IntersectionObserver(observerCallback, {
                rootMargin: `${margin}px`,
                threshold: threshold
            });
            observer.observe(observedElement);
            return ()=>{
                observer.disconnect();
            };
        }, [
            observedElement,
            onIntersection,
            margin,
            threshold
        ]);
        return setObservedElement;
    };
});
parcelRegister("lbwou", function(module, exports) {
    $parcel$export(module.exports, "DesignCarousel", ()=>$da5a6b112d157da9$export$f1038593ff0bfc1e);
    var $1Q5uL;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $iASWI = parcelRequire("iASWI");
    var $8Uumt = parcelRequire("8Uumt");
    var $2NMNM;
    var $dC5iT;
    var $8CUq3;
    var $gJlZe;
    var $koVbs;
    var $8zOmE;
    var $hnsnI;
    var $6glsJ;
    var $bslvg;
    var $7SORO;
    const $da5a6b112d157da9$var$getNumFullyRenderedCards = (carouselWidth)=>Math.floor(carouselWidth / (0, $6738210abd29fb18$export$2796973bb2f51929));
    const $da5a6b112d157da9$var$getCurPageStartEndNum = (fullyRenderedCardNum, curPageNum, totalCount)=>({
            currentStart: curPageNum * fullyRenderedCardNum + 1,
            currentEnd: totalCount >= (curPageNum + 1) * fullyRenderedCardNum ? (curPageNum + 1) * fullyRenderedCardNum : totalCount,
            lastPageNum: Math.ceil(totalCount / fullyRenderedCardNum) - 1
        });
    const $da5a6b112d157da9$export$f1038593ff0bfc1e = ({ jiraVersion: jiraVersion })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [carouselWidth, setCarouselWidth] = (0, $5uXOq.useState)(0);
        const [curPageNum, setCurPageNum] = (0, $5uXOq.useState)(0);
        const { data: data, hasNext: hasNext, loadNext: loadNext, isLoadingNext: isLoadingNext } = (0, $8Uumt.usePaginationFragment)((0, (0, parcelRequire("1Q5uL")).default), jiraVersion);
        const designEdges = data.issueAssociatedDesigns?.edges ?? [];
        const designNodes = designEdges.filter(Boolean).map((edge)=>edge.node).filter(Boolean);
        const totalCount = hasNext ? data.issueAssociatedDesigns.totalCount : designNodes?.length ?? 0;
        const numFullyRenderedCards = $da5a6b112d157da9$var$getNumFullyRenderedCards(carouselWidth);
        const carouselPageInfo = $da5a6b112d157da9$var$getCurPageStartEndNum(numFullyRenderedCards, curPageNum, totalCount);
        (0, $5uXOq.useEffect)(()=>{
            if (carouselPageInfo.lastPageNum < curPageNum) setCurPageNum(carouselPageInfo.lastPageNum);
        }, [
            carouselPageInfo.lastPageNum,
            curPageNum
        ]);
        if (totalCount === 0) return null;
        const numCardSkeleton = totalCount - designNodes.length;
        const firePaginationAnalytics = (direction)=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'designsPagination', {
                direction: direction
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $da5a6b112d157da9$var$wrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gJlZe")).WidthObserver), {
            setWidth: setCarouselWidth
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($da5a6b112d157da9$var$CarouselWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($da5a6b112d157da9$var$CarouselSlider, {
            widthOffset: curPageNum * numFullyRenderedCards * ((0, $6738210abd29fb18$export$2796973bb2f51929) + (0, $6738210abd29fb18$export$c73e9b0a14b3993b))
        }, designNodes.map((designNode)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bslvg")).DesignCard), {
                key: designNode.id ?? '',
                devOpsDesign: designNode,
                jiraVersion: data
            })), hasNext && (0, ($parcel$interopDefault($iASWI)))(numCardSkeleton).map((n)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hnsnI")).DesignCardSkeleton), {
                key: n,
                onVisible: ()=>{
                    if (!hasNext || isLoadingNext) return null;
                    loadNext(6);
                }
            })))), numFullyRenderedCards < Math.max(totalCount, designNodes.length) && (0, ($parcel$interopDefault($5uXOq))).createElement($da5a6b112d157da9$var$ArrowWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6glsJ")).Arrow), {
            direction: "LEFT",
            onClick: ()=>{
                if (curPageNum === 0) return;
                setCurPageNum(curPageNum - 1);
                firePaginationAnalytics('left');
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6glsJ")).Arrow), {
            direction: "RIGHT",
            onClick: ()=>{
                if (carouselPageInfo.currentEnd >= totalCount) return;
                setCurPageNum(curPageNum + 1);
                firePaginationAnalytics('right');
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o"
            ])
        }, formatMessage((0, (0, parcelRequire("7SORO")).default).carouselPageCount, {
            ...carouselPageInfo,
            totalCount: totalCount
        })));
    };
    const $da5a6b112d157da9$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        position: 'relative',
        marginTop: 'space.300'
    });
    const $da5a6b112d157da9$var$ArrowWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _lcxvglyw",
                __cmplp.className
            ])
        });
    });
    const $da5a6b112d157da9$var$CarouselWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq _1reo15vq _18m915vq _4cvr1fhb _1yt41b66 _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $da5a6b112d157da9$var$CarouselSlider = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { widthOffset: widthOffset, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_z0ie8w": (0, (0, parcelRequire("lD23V")).default)(`translateX(-${__cmplp.widthOffset}px)`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _zulppxbi _v5641cdp _t9ec1jj4",
                __cmplp.className
            ])
        });
    });
    const $da5a6b112d157da9$var$pageCounterStyles = null;
});
parcelRegister("1Q5uL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4de98e326a82dfd2$export$2e2bcd8739ae039);
    var $j4z9I;
    const $4de98e326a82dfd2$var$node = function() {
        var v0 = [
            "issueAssociatedDesigns"
        ], v1 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "argumentDefinitions": [
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "after"
                },
                {
                    "kind": "RootArgument",
                    "name": "cloudAri"
                },
                {
                    "defaultValue": 6,
                    "kind": "LocalArgument",
                    "name": "first"
                }
            ],
            "kind": "Fragment",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": v0
                    }
                ],
                "refetch": {
                    "connection": {
                        "forward": {
                            "count": "first",
                            "cursor": "after"
                        },
                        "backward": null,
                        "path": v0
                    },
                    "fragmentPathInResult": [
                        "node"
                    ],
                    "operation": (0, (0, parcelRequire("j4z9I")).default),
                    "identifierInfo": {
                        "identifierField": "id",
                        "identifierQueryVariableName": "id"
                    }
                }
            },
            "name": "designCarousel_versionIssueAssociatedDesigns",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "designCard_versionIssueAssociatedDesigns_jiraVersion"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "issueAssociatedDesigns",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "sort",
                                "value": {
                                    "createdAt": {
                                        "direction": "DESC",
                                        "priority": 1
                                    }
                                }
                            }
                        ],
                        "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                        "kind": "LinkedField",
                        "name": "__DesignSlider_issueAssociatedDesigns_connection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v1,
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "designCard_versionIssueAssociatedDesigns_devOpsDesign"
                                                    }
                                                ],
                                                "type": "DevOpsDesign"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "cursor"
                                    }
                                ]
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                "action": "THROW",
                                "path": "issueAssociatedDesigns.totalCount"
                            },
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "endCursor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "__DesignSlider_issueAssociatedDesigns_connection(sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                    },
                    "action": "THROW",
                    "path": "issueAssociatedDesigns"
                },
                v1
            ],
            "type": "JiraVersion"
        };
    }();
    $4de98e326a82dfd2$var$node.hash = "7979312fd2183c859bc266fe0defac6d";
    var $4de98e326a82dfd2$export$2e2bcd8739ae039 = $4de98e326a82dfd2$var$node;
});
parcelRegister("j4z9I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d043ba78f7fe7367$export$2e2bcd8739ae039);
    const $d043ba78f7fe7367$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudAri"
            },
            {
                "defaultValue": 6,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "id"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
            }
        ], v2 = {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        }, v3 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }, v4 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v5 = {
            "kind": "ScalarField",
            "name": "id"
        }, v6 = [
            v2,
            v3,
            {
                "kind": "Literal",
                "name": "sort",
                "value": {
                    "createdAt": {
                        "direction": "DESC",
                        "priority": 1
                    }
                }
            }
        ], v7 = {
            "kind": "InlineFragment",
            "selections": [
                v5
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "versionDetailsDesignRefetchableQuery",
                "selections": [
                    {
                        "args": v1,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    v2,
                                    v3
                                ],
                                "kind": "FragmentSpread",
                                "name": "designCarousel_versionIssueAssociatedDesigns"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "versionDetailsDesignRefetchableQuery",
                "selections": [
                    {
                        "args": v1,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v4,
                            v5,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v6,
                                        "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                        "kind": "LinkedField",
                                        "name": "issueAssociatedDesigns",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v4,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v5,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "url"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "displayName"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "lastUpdated"
                                                                    },
                                                                    {
                                                                        "args": [
                                                                            {
                                                                                "kind": "Variable",
                                                                                "name": "id",
                                                                                "variableName": "cloudAri"
                                                                            }
                                                                        ],
                                                                        "kind": "LinkedField",
                                                                        "name": "provider",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v4,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "logoUrl"
                                                                            },
                                                                            v5
                                                                        ]
                                                                    },
                                                                    {
                                                                        "args": [
                                                                            {
                                                                                "kind": "Literal",
                                                                                "name": "first",
                                                                                "value": 2
                                                                            }
                                                                        ],
                                                                        "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "associatedIssues",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "InlineFragment",
                                                                                                "selections": [
                                                                                                    v5,
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "key"
                                                                                                    },
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "webUrl"
                                                                                                    },
                                                                                                    {
                                                                                                        "args": [
                                                                                                            {
                                                                                                                "kind": "Literal",
                                                                                                                "name": "idsOrAliases",
                                                                                                                "value": [
                                                                                                                    "issuetype",
                                                                                                                    "summary"
                                                                                                                ]
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "Literal",
                                                                                                                "name": "ignoreMissingFields",
                                                                                                                "value": true
                                                                                                            }
                                                                                                        ],
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "fieldsByIdOrAlias",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            v4,
                                                                                                            {
                                                                                                                "kind": "InlineFragment",
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "concreteType": "JiraIssueType",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "issueType",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "ScalarField",
                                                                                                                                "name": "name"
                                                                                                                            },
                                                                                                                            {
                                                                                                                                "concreteType": "JiraAvatar",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "avatar",
                                                                                                                                "plural": false,
                                                                                                                                "selections": [
                                                                                                                                    {
                                                                                                                                        "kind": "ScalarField",
                                                                                                                                        "name": "xsmall"
                                                                                                                                    }
                                                                                                                                ]
                                                                                                                            },
                                                                                                                            v5
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ],
                                                                                                                "type": "JiraIssueTypeField"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "InlineFragment",
                                                                                                                "selections": [
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "text"
                                                                                                                    }
                                                                                                                ],
                                                                                                                "type": "JiraSingleLineTextField"
                                                                                                            },
                                                                                                            v5
                                                                                                        ],
                                                                                                        "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                                                                                    }
                                                                                                ],
                                                                                                "type": "JiraIssue"
                                                                                            },
                                                                                            v4,
                                                                                            v7
                                                                                        ]
                                                                                    },
                                                                                    v5
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "associatedIssues(first:2)"
                                                                    }
                                                                ],
                                                                "type": "DevOpsDesign"
                                                            },
                                                            v7
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "cursor"
                                                    },
                                                    v5
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "totalCount"
                                            },
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "endCursor"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "args": v6,
                                        "filters": [
                                            "sort"
                                        ],
                                        "handle": "connection",
                                        "key": "DesignSlider_issueAssociatedDesigns",
                                        "kind": "LinkedHandle",
                                        "name": "issueAssociatedDesigns"
                                    }
                                ],
                                "type": "JiraVersion"
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "3a775f0e0846c095fe7a545909336633e32a40abe3dbd41661e439df37e5d672",
                "metadata": {},
                "name": "versionDetailsDesignRefetchableQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $d043ba78f7fe7367$var$node.hash = "7979312fd2183c859bc266fe0defac6d";
    var $d043ba78f7fe7367$export$2e2bcd8739ae039 = $d043ba78f7fe7367$var$node;
});
parcelRegister("iASWI", function(module, exports) {
    var $irTmi = parcelRequire("irTmi");
    var $d89635f071f7433a$var$range = $irTmi();
    module.exports = $d89635f071f7433a$var$range;
});
parcelRegister("irTmi", function(module, exports) {
    var $7DMj9 = parcelRequire("7DMj9");
    var $4rDUz = parcelRequire("4rDUz");
    var $kJ0Lf = parcelRequire("kJ0Lf");
    function $d6e5b0af0cc26ead$var$createRange(fromRight) {
        return function(start, end, step) {
            if (step && typeof step != 'number' && $4rDUz(start, end, step)) end = step = undefined;
            start = $kJ0Lf(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = $kJ0Lf(end);
            step = step === undefined ? start < end ? 1 : -1 : $kJ0Lf(step);
            return $7DMj9(start, end, step, fromRight);
        };
    }
    module.exports = $d6e5b0af0cc26ead$var$createRange;
});
parcelRegister("7DMj9", function(module, exports) {
    var $5901a5dd7694a169$var$nativeCeil = Math.ceil, $5901a5dd7694a169$var$nativeMax = Math.max;
    function $5901a5dd7694a169$var$baseRange(start, end, step, fromRight) {
        var index = -1, length = $5901a5dd7694a169$var$nativeMax($5901a5dd7694a169$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
        while(length--){
            result[fromRight ? length : ++index] = start;
            start += step;
        }
        return result;
    }
    module.exports = $5901a5dd7694a169$var$baseRange;
});
const $6738210abd29fb18$export$2796973bb2f51929 = 360;
const $6738210abd29fb18$export$c73e9b0a14b3993b = 16;
parcelRegister("6glsJ", function(module, exports) {
    $parcel$export(module.exports, "Arrow", ()=>$a80d3a6c4b60d5c2$export$21b07c8f274aebd5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3gt3f;
    var $8RBk4;
    var $koVbs;
    var $jZgEb;
    const $a80d3a6c4b60d5c2$export$21b07c8f274aebd5 = ({ direction: direction, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a80d3a6c4b60d5c2$var$Wrapper, {
            onClick: onClick,
            direction: direction
        }, direction === 'LEFT' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3gt3f"))))), {
            label: formatMessage((0, (0, parcelRequire("jZgEb")).default).leftArrowlabel)
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
            label: formatMessage((0, (0, parcelRequire("jZgEb")).default).rightArrowlabel)
        }));
    };
    const $a80d3a6c4b60d5c2$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_lcxv1rj4 _kqswstnw _154ixncg _1bsb1ejb _4t3i1ejb _2rkoutpp _11q71j9a _syaz1fxt _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c81kw7 _80omtlke _12ji1r31 _1qu21kw7 _12y31o36 _16qsn3ow _1du216kg _19lc7zq1",
                __cmplp.direction === 'LEFT' ? "_1ltvxmi2" : "_1ltv1wug",
                __cmplp.direction === 'RIGHT' ? "_1xi2xmi2" : "_1xi21wug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8RBk4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
    function $6740397d4ba98b13$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>$6740397d4ba98b13$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
        }, props, {
            newIcon: $6740397d4ba98b13$var$_arrowRight.default
        }));
    $6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;
});
parcelRegister("h1TKi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c65dc59efb96b35a$var$_UNSAFE_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>$c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;
});
parcelRegister("jZgEb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8124d0d178a5b95$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b8124d0d178a5b95$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        leftArrowlabel: {
            "id": "version-issue-associated-designs.design-carousel.arrow.left-arrowlabel",
            "defaultMessage": "To next page"
        },
        rightArrowlabel: {
            "id": "version-issue-associated-designs.design-carousel.arrow.right-arrowlabel",
            "defaultMessage": "To previous page"
        }
    });
});
parcelRegister("bslvg", function(module, exports) {
    $parcel$export(module.exports, "DesignCard", ()=>$7bcd6555400bf07e$export$a0f819c247fd2165);
    var $k9Edn;
    var $iTare;
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $2NMNM;
    var $fVnbM;
    var $8sgpE;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $3bDjY;
    var $3Mzpf;
    var $47gW9;
    var $ivDCs;
    var $4mO32;
    var $koVbs;
    var $7IEKg;
    var $lfTZh;
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $7skxX;
    var $koeKL;
    var $lbXuZ;
    var $719Uq;
    var $i0rPK;
    var $7Tq5y;
    const $7bcd6555400bf07e$var$DATE_FORMAT = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    };
    const $7bcd6555400bf07e$var$runtimeProps = {};
    const $7bcd6555400bf07e$export$a0f819c247fd2165 = ({ devOpsDesign: devOpsDesign, jiraVersion: jiraVersion })=>{
        const { formatDate: formatDate, formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(false);
        const [designIssuesModalQueryRef, loadDesignIssuesModalQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("7skxX")).default));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const siteAri = (0, (0, parcelRequire("3Mzpf")).JiraSiteAri).create({
            siteId: cloudId
        }).toString();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("iTare")).default), devOpsDesign);
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("k9Edn")).default), jiraVersion);
        const onLoadDesignIssuesModalQuery = ()=>{
            if (designIssuesModalQueryRef == null) loadDesignIssuesModalQuery({
                cloudAri: siteAri,
                designAris: [
                    data.id
                ],
                versionId: version.id
            });
        };
        const associatedIssuesNodes = (data.associatedIssues?.edges ?? []).filter(Boolean).map((edge)=>edge.node).filter((node)=>node?.__typename === 'JiraIssue').filter(Boolean);
        const issues = associatedIssuesNodes.length === 1 && associatedIssuesNodes[0].__typename === 'JiraIssue' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lbXuZ")).SimpleIssueCard), {
            jiraIssue: associatedIssuesNodes[0],
            openIssueInSidebar: true
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            onMouseEnter: onLoadDesignIssuesModalQuery,
            onFocus: onLoadDesignIssuesModalQuery,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pku2gc _n3td1b66 _18u0xmi2"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            spacing: "compact",
            appearance: "subtle",
            onClick: (_, analyticsEvent)=>{
                onLoadDesignIssuesModalQuery();
                setIsModalOpen(true);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'designLinkedIssuesSeeAllModal');
            },
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8sgpE"))))), {
                primaryColor: `var(--ds-icon-accent-blue, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
                size: "small",
                label: formatMessage((0, (0, parcelRequire("i0rPK")).default).issueIconLabel)
            })
        }, formatMessage((0, (0, parcelRequire("i0rPK")).default).manyIssues))), designIssuesModalQueryRef != null && isModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "version-detaiols-design-issues-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("719Uq")).IssueModalLoading), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("719Uq")).IssuesModal), {
            queryRef: designIssuesModalQueryRef,
            onClose: ()=>setIsModalOpen(false)
        })));
        const representativeIssueAri = associatedIssuesNodes.length > 0 && associatedIssuesNodes[0].__typename === 'JiraIssue' ? associatedIssuesNodes[0].id : '';
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("7IEKg")).designModalEntryPoint), {
            siteAri: siteAri,
            issueAri: representativeIssueAri,
            designAri: data.id,
            cloudId: cloudId
        });
        const modalTriggerRef = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(entryPointActions);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "versionAssociatedDesignCard",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            attributes: {
                hasMultipleIssues: associatedIssuesNodes.length > 1
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $7bcd6555400bf07e$var$cardContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: data.provider.logoUrl,
            alt: "",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1tcg _1ul91tcg _19pk12x7"
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $7bcd6555400bf07e$var$titleStackStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: data.url,
            target: "_blank",
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'designTitleLink'),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1kw7 _k48pni7l _o5721q9c _1reo15vq _18m915vq _1bto1l2s _9oik18uv _1bnx8stv _jf4cnqa1 _30l31kw7"
            ])
        }, data.displayName), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatDate(data.lastUpdated, $7bcd6555400bf07e$var$DATE_FORMAT),
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1wyb1skh _syaz1ifp"
            ])
        }, (0, (0, parcelRequire("7Tq5y")).formatRelativeDate)(new Date(data.lastUpdated)))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb68cl _19pkutpp _otyrutpp"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ref: modalTriggerRef,
            shouldFitContainer: true,
            spacing: "compact",
            onClick: (_, analyticsEvent)=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'openDesignPreviewButton')
        }, formatMessage((0, (0, parcelRequire("i0rPK")).default).openPreview))), (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1wyb1skh _syaz1ifp"
            ])
        }, formatMessage((0, (0, parcelRequire("i0rPK")).default).linkedTo)), issues), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivDCs")).ModalEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jiraDesignModalInVersionDetailsPage",
            packageName: "design-modal",
            entryPointActions: entryPointActions,
            runtimeProps: $7bcd6555400bf07e$var$runtimeProps
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
    };
    const $7bcd6555400bf07e$var$cardContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        border: '3px',
        paddingTop: 'space.100',
        paddingBottom: 'space.100',
        paddingLeft: 'space.150',
        paddingRight: 'space.150',
        boxShadow: 'elevation.shadow.raised',
        minWidth: `${(0, $6738210abd29fb18$export$2796973bb2f51929)}px`,
        maxWidth: `${(0, $6738210abd29fb18$export$2796973bb2f51929)}px`
    });
    const $7bcd6555400bf07e$var$iconStyles = null;
    const $7bcd6555400bf07e$var$titleStackStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: 1,
        marginLeft: 'space.100',
        maxWidth: '312px'
    });
    const $7bcd6555400bf07e$var$lastUpdatedStyles = null;
    const $7bcd6555400bf07e$var$openPreviewStyles = null;
    const $7bcd6555400bf07e$var$linkedToStyles = null;
    const $7bcd6555400bf07e$var$titleStyles = null;
    const $7bcd6555400bf07e$var$manyIssuesButtonStyles = null;
});
parcelRegister("k9Edn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3a205f0a4296aac$export$2e2bcd8739ae039);
    const $d3a205f0a4296aac$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "designCard_versionIssueAssociatedDesigns_jiraVersion",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            }
        ],
        "type": "JiraVersion"
    };
    $d3a205f0a4296aac$var$node.hash = "574075efd4cf2b2db85cdf409e87e841";
    var $d3a205f0a4296aac$export$2e2bcd8739ae039 = $d3a205f0a4296aac$var$node;
});
parcelRegister("iTare", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f2c46de8466b2b55$export$2e2bcd8739ae039);
    const $f2c46de8466b2b55$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "cloudAri"
                }
            ],
            "kind": "Fragment",
            "name": "designCard_versionIssueAssociatedDesigns_devOpsDesign",
            "selections": [
                v0,
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "url"
                    },
                    "action": "THROW",
                    "path": "url"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "displayName"
                    },
                    "action": "THROW",
                    "path": "displayName"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "lastUpdated"
                    },
                    "action": "THROW",
                    "path": "lastUpdated"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "id",
                                "variableName": "cloudAri"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "provider",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "logoUrl"
                                },
                                "action": "THROW",
                                "path": "provider.logoUrl"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "provider"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 2
                        }
                    ],
                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                    "kind": "LinkedField",
                    "name": "associatedIssues",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v0,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "simpleIssueCard_versionIssueAssociatedDesigns"
                                                }
                                            ],
                                            "type": "JiraIssue"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "associatedIssues(first:2)"
                }
            ],
            "type": "DevOpsDesign"
        };
    }();
    $f2c46de8466b2b55$var$node.hash = "bb9498fa38fb746e3897ed942c1b67ca";
    var $f2c46de8466b2b55$export$2e2bcd8739ae039 = $f2c46de8466b2b55$var$node;
});
parcelRegister("7skxX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69efb06d34b4f404$export$2e2bcd8739ae039);
    const $69efb06d34b4f404$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "designAris"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionId"
        }, v3 = [
            {
                "kind": "Variable",
                "name": "ids",
                "variableName": "designAris"
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "url"
        }, v5 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v6 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "cloudAri"
            }
        ], v7 = {
            "kind": "ScalarField",
            "name": "logoUrl"
        }, v8 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v9 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2
                ],
                "kind": "Fragment",
                "name": "issuesModal_designIssueQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "DevOps",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v3,
                                        "concreteType": "DevOpsDesign",
                                        "kind": "LinkedField",
                                        "name": "designEntityDetails",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v4,
                                                "action": "THROW",
                                                "path": "devOps.designEntityDetails.url"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v5,
                                                "action": "THROW",
                                                "path": "devOps.designEntityDetails.displayName"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "args": v6,
                                                    "kind": "LinkedField",
                                                    "name": "provider",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v7,
                                                            "action": "THROW",
                                                            "path": "devOps.designEntityDetails.provider.logoUrl"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "devOps.designEntityDetails.provider"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "body_versionIssueAssociatedDesigns_IssuesModalBody"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "devOps.designEntityDetails"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "devOps"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v2,
                    v0
                ],
                "kind": "Operation",
                "name": "issuesModal_designIssueQuery",
                "selections": [
                    {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "DevOpsDesign",
                                "kind": "LinkedField",
                                "name": "designEntityDetails",
                                "plural": true,
                                "selections": [
                                    v4,
                                    v5,
                                    {
                                        "args": v6,
                                        "kind": "LinkedField",
                                        "name": "provider",
                                        "plural": false,
                                        "selections": [
                                            v8,
                                            v7,
                                            v9
                                        ]
                                    },
                                    {
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 100
                                            }
                                        ],
                                        "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                        "kind": "LinkedField",
                                        "name": "associatedIssues",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "key"
                                                                    },
                                                                    {
                                                                        "args": [
                                                                            {
                                                                                "kind": "Variable",
                                                                                "name": "versionId",
                                                                                "variableName": "versionId"
                                                                            }
                                                                        ],
                                                                        "kind": "ScalarField",
                                                                        "name": "hasRelationshipToVersion"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "webUrl"
                                                                    },
                                                                    {
                                                                        "args": [
                                                                            {
                                                                                "kind": "Literal",
                                                                                "name": "idsOrAliases",
                                                                                "value": [
                                                                                    "issuetype",
                                                                                    "summary"
                                                                                ]
                                                                            },
                                                                            {
                                                                                "kind": "Literal",
                                                                                "name": "ignoreMissingFields",
                                                                                "value": true
                                                                            }
                                                                        ],
                                                                        "kind": "LinkedField",
                                                                        "name": "fieldsByIdOrAlias",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v8,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueType",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "issueType",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "name"
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "JiraAvatar",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "avatar",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "xsmall"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            v9
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraIssueTypeField"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "text"
                                                                                    }
                                                                                ],
                                                                                "type": "JiraSingleLineTextField"
                                                                            },
                                                                            v9
                                                                        ],
                                                                        "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                                                    }
                                                                ],
                                                                "type": "JiraIssue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v9
                                                                ],
                                                                "type": "Node",
                                                                "abstractKey": "__isNode"
                                                            }
                                                        ]
                                                    },
                                                    v9
                                                ]
                                            }
                                        ],
                                        "storageKey": "associatedIssues(first:100)"
                                    },
                                    v9
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "24c11f2af60eb7a3e378df4c9e585d36a069016d8981c6f13ade2b717e96e9bf",
                "metadata": {},
                "name": "issuesModal_designIssueQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $69efb06d34b4f404$var$node.hash = "7de65187f74a740f22e361ae3bf58899";
    var $69efb06d34b4f404$export$2e2bcd8739ae039 = $69efb06d34b4f404$var$node;
});
parcelRegister("lbXuZ", function(module, exports) {
    $parcel$export(module.exports, "SimpleIssueCard", ()=>$ab628153c784343a$export$a6b6cb5c242d7ead);
    var $kDDKv;
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $2NMNM;
    var $jhmo0;
    var $f5TWP;
    var $8CUq3;
    var $8zOmE;
    var $2vbty;
    var $aLRqS = parcelRequire("aLRqS");
    const $ab628153c784343a$export$a6b6cb5c242d7ead = ({ jiraIssue: jiraIssue, openIssueInSidebar: openIssueInSidebar })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, sidebarActions] = (0, (0, parcelRequire("2vbty")).useSidebarStore)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("kDDKv")).default), jiraIssue);
        const fieldsData = data.fieldsByIdOrAlias.filter(Boolean);
        const issueTypeFieldData = fieldsData.reduce((acc, fieldData)=>{
            if (fieldData.__typename === 'JiraIssueTypeField') return {
                icon: fieldData.issueType.avatar?.xsmall ?? (0, ($parcel$interopDefault($aLRqS))),
                name: fieldData.issueType.name
            };
            return acc;
        }, {
            icon: (0, ($parcel$interopDefault($aLRqS))),
            name: ''
        });
        const summaryText = fieldsData.reduce((acc, fieldData)=>{
            if (fieldData.__typename === 'JiraSingleLineTextField') return fieldData.text;
            return acc;
        }, null);
        if (issueTypeFieldData == null) throw new Error(`issue data did not contain issuetype data(${issueTypeFieldData})`);
        if (summaryText === null) throw new Error('issue data did not contain summary data');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            href: data.webUrl,
            target: "_blank",
            xcss: $ab628153c784343a$var$wrapperStyles,
            onClick: (e)=>{
                const modifiersPressed = e.shiftKey || e.metaKey || e.ctrlKey;
                if (openIssueInSidebar && !modifiersPressed) {
                    e.preventDefault();
                    sidebarActions.showIssue(data.key);
                }
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'designLinkedIssue');
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $ab628153c784343a$var$inlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: issueTypeFieldData.icon,
            alt: issueTypeFieldData.name,
            title: issueTypeFieldData.name,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i7vkz _1bsb7vkz _18s81c8u _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _1bah1h6o _4cvr1h6o"
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1o9zidpf _syaz1wmz _u5f31ejb _9oik18uv _1bnxglyw _jf4cnqa1"
            ])
        }, data.key), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _syaz1fxt _9oik18uv _1bnx8stv _jf4cnqa1"
            ])
        }, summaryText)));
    };
    const $ab628153c784343a$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textDecoration: 'none',
        boxSizing: 'content-box',
        display: 'block',
        height: '20px',
        paddingTop: 'space.100',
        paddingBottom: 'space.100',
        ':hover': {
            textDecoration: 'none'
        }
    });
    const $ab628153c784343a$var$inlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        alignItems: 'center'
    });
    const $ab628153c784343a$var$issueTypeStyles = null;
    const $ab628153c784343a$var$issueKeyStyles = null;
    const $ab628153c784343a$var$issueSummaryStyles = null;
});
parcelRegister("kDDKv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55799206881c992b$export$2e2bcd8739ae039);
    const $55799206881c992b$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "simpleIssueCard_versionIssueAssociatedDesigns",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "key"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "webUrl"
                },
                "action": "THROW",
                "path": "webUrl"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "idsOrAliases",
                            "value": [
                                "issuetype",
                                "summary"
                            ]
                        },
                        {
                            "kind": "Literal",
                            "name": "ignoreMissingFields",
                            "value": true
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "fieldsByIdOrAlias",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                "action": "THROW",
                                                "path": "fieldsByIdOrAlias.issueType.name"
                                            },
                                            {
                                                "concreteType": "JiraAvatar",
                                                "kind": "LinkedField",
                                                "name": "avatar",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "xsmall"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "fieldsByIdOrAlias.issueType"
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "text"
                                    },
                                    "action": "THROW",
                                    "path": "fieldsByIdOrAlias.text"
                                }
                            ],
                            "type": "JiraSingleLineTextField"
                        }
                    ],
                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                },
                "action": "THROW",
                "path": "fieldsByIdOrAlias"
            }
        ],
        "type": "JiraIssue"
    };
    $55799206881c992b$var$node.hash = "293ef6f7a36c1d615e6dc27559c1d40e";
    var $55799206881c992b$export$2e2bcd8739ae039 = $55799206881c992b$var$node;
});
parcelRegister("aLRqS", function(module, exports) {
    module.exports = new URL("issue-type-avatar-fallback.a9f6df1b.svg", import.meta.url).toString();
});
parcelRegister("719Uq", function(module, exports) {
    $parcel$export(module.exports, "IssueModalLoading", ()=>$204935f075bf299f$export$30d178fad6e7652a);
    $parcel$export(module.exports, "IssuesModal", ()=>$204935f075bf299f$export$62000b4a046396b3);
    var $7skxX;
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $8sgpE;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $gofOI;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $eZJjh;
    var $pa9q9;
    var $koVbs;
    var $9N1TE;
    var $7To4V;
    const $204935f075bf299f$export$30d178fad6e7652a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $204935f075bf299f$var$modalBodyLoadingStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large"
        }))));
    const $204935f075bf299f$export$62000b4a046396b3 = ({ queryRef: queryRef, onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const data = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("7skxX")).default), queryRef);
        const designEntity = data.devOps.designEntityDetails[0];
        (0, $5uXOq.useEffect)(()=>{
            if (designEntity == null) showFlag({
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("7To4V")).default).errorFlagTitle),
                description: formatMessage((0, (0, parcelRequire("7To4V")).default).errorFlagDescription)
            });
        }, [
            designEntity,
            formatMessage,
            showFlag
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setTimeout(()=>{
                const modalElement = document.querySelector("[role='dialog']");
                modalElement?.focus();
            }, 50);
        }, []);
        if (designEntity == null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "small",
            onClose: ()=>onClose(),
            autoFocus: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.150",
            xcss: $204935f075bf299f$var$modalTitleStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: designEntity?.provider.logoUrl,
            alt: "",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1tcg _1ul97vkz _2hwxu2gc"
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: designEntity?.url,
            target: "_blank",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1kw7 _k48pni7l _9oik18uv _1bnx8stv _jf4cnqa1 _30l31kw7"
            ])
        }, designEntity?.displayName)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.075"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1wyb1skh _syaz1ifp"
            ])
        }, formatMessage((0, (0, parcelRequire("7To4V")).default).linkedTo)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            space: "space.050",
            xcss: $204935f075bf299f$var$multipleIssuesStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8sgpE"))))), {
            primaryColor: `var(--ds-icon-accent-blue, ${(0, $829f609a65d26a98$exports).B200})`,
            size: "small",
            label: ""
        }), formatMessage((0, (0, parcelRequire("7To4V")).default).manyIssues))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9N1TE")).IssuesModalBody), {
            devOpsDesign: designEntity
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "primary",
            onClick: ()=>onClose()
        }, formatMessage((0, (0, parcelRequire("7To4V")).default).modalCloseButtonLabel))));
    };
    const $204935f075bf299f$var$modalIconStyles = null;
    const $204935f075bf299f$var$titleStyles = null;
    const $204935f075bf299f$var$modalTitleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.300',
        paddingBottom: 'space.200',
        paddingLeft: 'space.300',
        paddingRight: 'space.300'
    });
    const $204935f075bf299f$var$modalBodyLoadingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '300px',
        height: '300px'
    });
    const $204935f075bf299f$var$linkedToStyles = null;
    const $204935f075bf299f$var$multipleIssuesStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        fontSize: '14px'
    });
});
parcelRegister("9N1TE", function(module, exports) {
    $parcel$export(module.exports, "IssuesModalBody", ()=>$8f007d88efbec807$export$fed5c8d395452c20);
    var $7kUt7;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $l1N8i;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $lbXuZ;
    var $lIuNX;
    var $2vFc4;
    const $8f007d88efbec807$export$fed5c8d395452c20 = ({ devOpsDesign: devOpsDesign })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const designEntity = (0, $8Uumt.useFragment)((0, (0, parcelRequire("7kUt7")).default), devOpsDesign);
        const associatedIssuesNodes = (designEntity?.associatedIssues?.edges ?? []).filter(Boolean).map((edge)=>edge.node).filter(Boolean);
        const issuesAssociatedToThisVersion = associatedIssuesNodes.filter((node)=>node.hasRelationshipToVersion);
        const issuesNotAssociatedToThisVersion = associatedIssuesNodes.filter((node)=>!node.hasRelationshipToVersion);
        (0, (0, parcelRequire("2vFc4")).useFireManyIssueTrackingAnalaytics)(associatedIssuesNodes.length);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "versionDesignAssociatedIssues",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            attributes: {
                issuesAssociatedTotalCount: associatedIssuesNodes.length,
                issuesAssociatedToVersionCount: issuesAssociatedToThisVersion.length,
                issuesNotAssociatedToVersionCount: issuesAssociatedToThisVersion.length
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.300",
            xcss: $8f007d88efbec807$var$modalBodyStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), null, issuesAssociatedToThisVersion.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $8f007d88efbec807$var$subTitleStyles
        }, formatMessage((0, (0, parcelRequire("lIuNX")).default).issuesInVersion), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $8f007d88efbec807$var$issueCountStyles
        }, "\xa0 (", issuesAssociatedToThisVersion.length, ")"))), issuesAssociatedToThisVersion.map((issueNode)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lbXuZ")).SimpleIssueCard), {
                key: issueNode.key,
                jiraIssue: issueNode
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), null, issuesNotAssociatedToThisVersion.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $8f007d88efbec807$var$subTitleStyles
        }, formatMessage((0, (0, parcelRequire("lIuNX")).default).otherIssues), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $8f007d88efbec807$var$issueCountStyles
        }, "\xa0 (", issuesNotAssociatedToThisVersion.length, ")"))), issuesNotAssociatedToThisVersion.map((issueNode)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lbXuZ")).SimpleIssueCard), {
                key: issueNode.key,
                jiraIssue: issueNode
            })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
    };
    const $8f007d88efbec807$var$modalBodyStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.025',
        paddingBottom: 'space.025'
    });
    const $8f007d88efbec807$var$subTitleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.100'
    });
    const $8f007d88efbec807$var$issueCountStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtlest',
        fontWeight: 400
    });
});
parcelRegister("7kUt7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66604be4facd5050$export$2e2bcd8739ae039);
    const $66604be4facd5050$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "versionId"
            }
        ],
        "kind": "Fragment",
        "name": "body_versionIssueAssociatedDesigns_IssuesModalBody",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                "kind": "LinkedField",
                "name": "associatedIssues",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                "action": "THROW",
                                                "path": "associatedIssues.edges.node.key"
                                            },
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "versionId",
                                                        "variableName": "versionId"
                                                    }
                                                ],
                                                "kind": "ScalarField",
                                                "name": "hasRelationshipToVersion"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "simpleIssueCard_versionIssueAssociatedDesigns"
                                            }
                                        ],
                                        "type": "JiraIssue"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "associatedIssues(first:100)"
            }
        ],
        "type": "DevOpsDesign"
    };
    $66604be4facd5050$var$node.hash = "145e33a9a0a82742e3ace6aa6c154644";
    var $66604be4facd5050$export$2e2bcd8739ae039 = $66604be4facd5050$var$node;
});
parcelRegister("lIuNX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea07c90e3dc719bc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ea07c90e3dc719bc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issuesInVersion: {
            "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.body.issues-in-version",
            "defaultMessage": "Current version"
        },
        otherIssues: {
            "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.body.other-issues",
            "defaultMessage": "Other"
        }
    });
});
parcelRegister("2vFc4", function(module, exports) {
    $parcel$export(module.exports, "useFireManyIssueTrackingAnalaytics", ()=>$e783f200345a5a2b$export$3ca4c107f1eff13e);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    const $e783f200345a5a2b$export$3ca4c107f1eff13e = (numIssues)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (numIssues > 100) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'designAssociatedIssues exceeded', {
                numIssues: numIssues
            });
        }, [
            createAnalyticsEvent,
            numIssues
        ]);
    };
});
parcelRegister("7To4V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e38aac1cfa69ceb1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e38aac1cfa69ceb1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        modalCloseButtonLabel: {
            "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.modal-close-button-label",
            "defaultMessage": "Close"
        },
        errorFlagTitle: {
            "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.error-flag-title",
            "defaultMessage": "Something went wrong"
        },
        errorFlagDescription: {
            "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.error-flag-description",
            "defaultMessage": "Please refresh the page."
        },
        linkedTo: {
            "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.linked-to",
            "defaultMessage": "Linked to"
        },
        manyIssues: {
            "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.many-issues",
            "defaultMessage": "Multiple issues"
        }
    });
});
parcelRegister("i0rPK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6fe13f760fed4b30$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6fe13f760fed4b30$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        openPreview: {
            "id": "version-issue-associated-designs.design-carousel.design-card.open-preview",
            "defaultMessage": "Open preview"
        },
        seeAll: {
            "id": "version-issue-associated-designs.design-carousel.design-card.see-all",
            "defaultMessage": "See all"
        },
        linkedTo: {
            "id": "version-issue-associated-designs.design-carousel.design-card.linked-to",
            "defaultMessage": "Linked to"
        },
        issueIconLabel: {
            "id": "version-issue-associated-designs.design-carousel.design-card.issue-icon-label",
            "defaultMessage": "Issue icon"
        },
        manyIssues: {
            "id": "version-issue-associated-designs.design-carousel.design-card.many-issues",
            "defaultMessage": "Multiple issues"
        }
    });
});
parcelRegister("7Tq5y", function(module, exports) {
    $parcel$export(module.exports, "formatRelativeDate", ()=>$05a1b9d1f2284a69$export$10da3a44394af1a6);
    var $7WuKQ;
    var $k7m40;
    var $54a0z;
    const $05a1b9d1f2284a69$var$SECONDS_IN_A_DAY = 86400;
    const $05a1b9d1f2284a69$export$10da3a44394af1a6 = (lastUpdatedDate)=>{
        const currentDate = new Date();
        const isDateFormatRelative = (0, (0, parcelRequire("7WuKQ")).default)(currentDate, lastUpdatedDate) <= $05a1b9d1f2284a69$var$SECONDS_IN_A_DAY;
        return isDateFormatRelative ? (0, (0, parcelRequire("54a0z")).default)(lastUpdatedDate, currentDate, {
            addSuffix: true,
            roundingMethod: 'floor'
        }) : (0, (0, parcelRequire("k7m40")).default)(lastUpdatedDate, 'd MMM, HH:mm');
    };
});
parcelRegister("7SORO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$815a0476c6388d25$export$2e2bcd8739ae039);
    var $7VHMR;
    var $815a0476c6388d25$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        carouselPageCount: {
            "id": "version-issue-associated-designs.design-carousel.carousel-page-count",
            "defaultMessage": "{currentStart}-{currentEnd} of {totalCount}"
        }
    });
});
parcelRegister("fESpJ", function(module, exports) {
    $parcel$export(module.exports, "EmptyState", ()=>$09b9d67b328c974a$export$fddf379e22a74b00);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $l1N8i;
    var $koVbs;
    var $4SYBf = parcelRequire("4SYBf");
    var $cVmNE;
    const $09b9d67b328c974a$export$fddf379e22a74b00 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($09b9d67b328c974a$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($4SYBf))),
            width: 80,
            alt: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("section", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            as: "h3",
            size: "xsmall"
        }, formatMessage((0, (0, parcelRequire("cVmNE")).default).title)), (0, ($parcel$interopDefault($5uXOq))).createElement($09b9d67b328c974a$var$Description, null, formatMessage((0, (0, parcelRequire("cVmNE")).default).desciption)), (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: "https://support.atlassian.com/jira-cloud-administration/docs/integrate-figma-with-jira/",
            target: "_blank"
        }, formatMessage((0, (0, parcelRequire("cVmNE")).default).learnMoreLabel))));
    };
    const $09b9d67b328c974a$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _gy1p1ejb _19pkpxbi _1yt41ejb _2rkoftgi _189eyh40 _1dqogq9o _1h6dhloo",
                __cmplp.className
            ])
        });
    });
    const $09b9d67b328c974a$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1rc1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4SYBf", function(module, exports) {
    module.exports = new URL("empty-icon.ef7b6c4a.svg", import.meta.url).toString();
});
parcelRegister("cVmNE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d47ddf15452c976a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d47ddf15452c976a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "version-issue-associated-designs.empty-state.title",
            "defaultMessage": "You\u2019ll see your linked designs here"
        },
        desciption: {
            "id": "version-issue-associated-designs.empty-state.desciption",
            "defaultMessage": "Get live updates and greater visibility of your team\u2019s design work."
        },
        learnMoreLabel: {
            "id": "version-issue-associated-designs.empty-state.learn-more-label",
            "defaultMessage": "Read more about linking designs to Jira issues"
        }
    });
});
parcelRegister("bgc85", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b677a3e5ccfe5d2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8b677a3e5ccfe5d2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        designSectionLabel: {
            "id": "version-issue-associated-designs.design-section-label",
            "defaultMessage": "Designs"
        }
    });
});
parcelRegister("gpsfL", function(module, exports) {
    $parcel$export(module.exports, "VersionProgress", ()=>$a2a9bbd9547db40a$export$f9ad2300f8258368);
    var $jQW4E;
    var $btxzI;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $l1N8i;
    var $koVbs;
    var $kfztd;
    var $fi7WV;
    var $76xXI;
    var $gA9bT;
    var $aPvTj;
    var $fyA65;
    var $jbc56;
    var $jMgdz;
    const $a2a9bbd9547db40a$export$f9ad2300f8258368 = ({ queryRef: queryRef })=>{
        const { jira: jira } = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("btxzI")).default), queryRef);
        const versionFrag = jira.version;
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("jQW4E")).default), versionFrag);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const edges = version.relatedWorkV2 ? version.relatedWorkV2.edges.filter(Boolean) : [];
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a2a9bbd9547db40a$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($a2a9bbd9547db40a$var$MainHeading, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall",
            as: "h3"
        }, formatMessage((0, (0, parcelRequire("fyA65")).messages).progressHeading))), !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jbc56")).RelatedWorkHeading), {
            relatedWorkEdges: edges
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jMgdz")).RelatedWorkProgressBar), {
            relatedWorkEdges: edges
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fi7WV")).CollapsibleSection), {
            jiraVersion: version,
            uiType: "PROGRESS_CARD",
            renderHeader: (isCollapsed, onToggleClicked)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aPvTj")).IssuesHeading), {
                    jiraVersion: version,
                    isCollapsed: isCollapsed,
                    onToggleClicked: onToggleClicked
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("76xXI")).IssuesProgressBar), {
                    jiraVersion: version
                })),
            renderBody: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gA9bT")).IssueProgressDetails), {
                    jiraVersion: version
                })
        })));
    };
    const $a2a9bbd9547db40a$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4q6zc _1e0c1txw _2lx21bp4 _zulppxbi",
                __cmplp.className
            ])
        });
    });
    const $a2a9bbd9547db40a$var$MainHeading = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4wo40",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jQW4E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49be98a29c3f6e08$export$2e2bcd8739ae039);
    const $49be98a29c3f6e08$var$node = {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "relatedWorkV2"
                    ]
                }
            ]
        },
        "name": "ui_versionProgress_VersionProgress",
        "selections": [
            {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "alias": "relatedWorkV2",
                            "concreteType": "JiraVersionRelatedWorkV2Connection",
                            "kind": "LinkedField",
                            "name": "__version_relatedWorkV2_connection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraVersionRelatedWorkV2Edge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "relatedWorkHeading_versionProgress"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "relatedWorkProgressBar_versionProgress"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "relatedWorkV2.edges"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "relatedWorkV2"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "issuesHeading_versionProgress"
            },
            {
                "kind": "FragmentSpread",
                "name": "issueProgressBar_versionProgress_IssuesProgressBar"
            },
            {
                "kind": "FragmentSpread",
                "name": "issueProgressDetails_versionProgress"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
            }
        ],
        "type": "JiraVersion"
    };
    $49be98a29c3f6e08$var$node.hash = "adad2bb30e02991a2dcfd9cb2046e4c9";
    var $49be98a29c3f6e08$export$2e2bcd8739ae039 = $49be98a29c3f6e08$var$node;
});
parcelRegister("76xXI", function(module, exports) {
    $parcel$export(module.exports, "IssuesProgressBar", ()=>$ddf4da5e852005e8$export$80217ccba75d7c95);
    var $5UYpC;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $3bDjY;
    var $gULOk;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $1YU2V;
    var $aEvzD;
    var $gZxFj;
    var $6MI5C;
    const $ddf4da5e852005e8$export$80217ccba75d7c95 = ({ jiraVersion: jiraVersion })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { showStatusCategoryIssues: showStatusCategoryIssues } = (0, (0, parcelRequire("1YU2V")).useFilterSortingQueryParams)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("5UYpC")).default), jiraVersion);
        const inProgressIssueCount = version.inProgressIssuesRedesignTemp.totalCount;
        const doneIssueCount = version.doneIssuesRedesignTemp.totalCount;
        const todoIssueCount = version.todoIssuesRedesignTemp.totalCount;
        const totalIssueCount = inProgressIssueCount + doneIssueCount + todoIssueCount;
        const createStatusClickHandler = (category)=>()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button'
                }), 'progressBarShortcutFilter', {
                    filter: category
                });
                const categoryId = String((0, (0, parcelRequire("gULOk")).categoryIdForStatusCategory)(category));
                showStatusCategoryIssues([
                    categoryId
                ]);
            };
        if (totalIssueCount === 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Container), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).ProgressBarContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).ProgressBarElementContainer), {
            totalCount: 1,
            portionCount: 1,
            isClickable: true,
            isLast: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Bar), {
            color: (0, (0, parcelRequire("aEvzD")).TODO_COLOR),
            isFirst: true,
            isLast: true
        }))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Container), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).ProgressBarContainer), null, doneIssueCount > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).ProgressBarElementContainer), {
            onClick: createStatusClickHandler((0, (0, parcelRequire("gULOk")).DONE)),
            totalCount: totalIssueCount,
            portionCount: doneIssueCount,
            isClickable: true,
            isLast: totalIssueCount === doneIssueCount
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "top",
            content: formatMessage((0, (0, parcelRequire("6MI5C")).default).doneIssuesTooltipText, {
                completedIssueCount: doneIssueCount,
                totalIssueCount: totalIssueCount
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Bar), {
            color: (0, (0, parcelRequire("aEvzD")).DONE_COLOR),
            isFirst: true,
            isLast: totalIssueCount === doneIssueCount
        }))), inProgressIssueCount > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).ProgressBarElementContainer), {
            totalCount: totalIssueCount,
            portionCount: inProgressIssueCount,
            onClick: createStatusClickHandler((0, (0, parcelRequire("gULOk")).IN_PROGRESS)),
            isClickable: true,
            isLast: todoIssueCount === 0
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "top",
            content: formatMessage((0, (0, parcelRequire("6MI5C")).default).inProgressIssuesTooltipText, {
                inProgressIssueCount: inProgressIssueCount,
                totalIssueCount: totalIssueCount
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Bar), {
            color: (0, (0, parcelRequire("aEvzD")).IN_PROGRESS_COLOR),
            isFirst: doneIssueCount === 0,
            isLast: todoIssueCount === 0
        }))), todoIssueCount > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).ProgressBarElementContainer), {
            isLast: true,
            totalCount: totalIssueCount,
            portionCount: todoIssueCount,
            onClick: createStatusClickHandler((0, (0, parcelRequire("gULOk")).TODO)),
            isClickable: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "top",
            content: formatMessage((0, (0, parcelRequire("6MI5C")).default).todoIssuesTooltipText, {
                todoIssueCount: todoIssueCount,
                totalIssueCount: totalIssueCount
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Bar), {
            color: (0, (0, parcelRequire("aEvzD")).TODO_COLOR),
            isFirst: totalIssueCount === todoIssueCount,
            isLast: true
        })))));
    };
});
parcelRegister("5UYpC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f687da9bbc10a3dc$export$2e2bcd8739ae039);
    const $f687da9bbc10a3dc$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "totalCount"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "issueProgressBar_versionProgress_IssuesProgressBar",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "doneIssuesRedesignTemp",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filters",
                                "value": {
                                    "statusCategories": [
                                        "DONE"
                                    ]
                                }
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "doneIssuesRedesignTemp.totalCount"
                            }
                        ],
                        "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                    },
                    "action": "THROW",
                    "path": "doneIssuesRedesignTemp"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "inProgressIssuesRedesignTemp",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filters",
                                "value": {
                                    "statusCategories": [
                                        "IN_PROGRESS"
                                    ]
                                }
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "inProgressIssuesRedesignTemp.totalCount"
                            }
                        ],
                        "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                    },
                    "action": "THROW",
                    "path": "inProgressIssuesRedesignTemp"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "todoIssuesRedesignTemp",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filters",
                                "value": {
                                    "statusCategories": [
                                        "TODO"
                                    ]
                                }
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "todoIssuesRedesignTemp.totalCount"
                            }
                        ],
                        "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                    },
                    "action": "THROW",
                    "path": "todoIssuesRedesignTemp"
                }
            ],
            "type": "JiraVersion"
        };
    }();
    $f687da9bbc10a3dc$var$node.hash = "9d79a458e2fb5db8bb37fec8334b2eed";
    var $f687da9bbc10a3dc$export$2e2bcd8739ae039 = $f687da9bbc10a3dc$var$node;
});
parcelRegister("aEvzD", function(module, exports) {
    $parcel$export(module.exports, "TODO_COLOR", ()=>$874a267084b6120b$export$9a2ce699a8e88c00);
    $parcel$export(module.exports, "IN_PROGRESS_COLOR", ()=>$874a267084b6120b$export$dc4e31a90347554e);
    $parcel$export(module.exports, "DONE_COLOR", ()=>$874a267084b6120b$export$f2a648c26a91297f);
    $parcel$export(module.exports, "WARNING_COLOR", ()=>$874a267084b6120b$export$2d5e5bd76a1e6a66);
    const $874a267084b6120b$export$9a2ce699a8e88c00 = `var(--ds-border, ${(0, $829f609a65d26a98$exports).N40A})`;
    const $874a267084b6120b$export$dc4e31a90347554e = `var(--ds-border-information, ${(0, $829f609a65d26a98$exports).B200})`;
    const $874a267084b6120b$export$f2a648c26a91297f = `var(--ds-border-success, ${(0, $829f609a65d26a98$exports).G300})`;
    const $874a267084b6120b$export$2d5e5bd76a1e6a66 = `var(--ds-background-warning-bold-hovered, ${(0, $829f609a65d26a98$exports).Y300})`;
});
parcelRegister("gZxFj", function(module, exports) {
    $parcel$export(module.exports, "Section", ()=>$1e08fe14c28adb64$export$6e2c8f0811a474ce);
    $parcel$export(module.exports, "Summary", ()=>$1e08fe14c28adb64$export$46453a0401d6cd1a);
    $parcel$export(module.exports, "Container", ()=>$1e08fe14c28adb64$export$42a852a2b6b56249);
    $parcel$export(module.exports, "ProgressBarContainer", ()=>$1e08fe14c28adb64$export$91fd6e064cf0bcf3);
    $parcel$export(module.exports, "ProgressBarElementContainer", ()=>$1e08fe14c28adb64$export$9148ffcd7ea9778);
    $parcel$export(module.exports, "Bar", ()=>$1e08fe14c28adb64$export$bbc6c6369b38e3d1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gwIPs;
    const $1e08fe14c28adb64$export$6e2c8f0811a474ce = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isCollapsible: isCollapsible, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o",
                __cmplp.isCollapsible ? "_80omtlke" : "_80om73ad",
                __cmplp.className
            ])
        });
    });
    const $1e08fe14c28adb64$export$46453a0401d6cd1a = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _syaz1rc1",
                __cmplp.className
            ])
        });
    });
    const $1e08fe14c28adb64$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _1e0c1txw _1yt4wo40",
                __cmplp.className
            ])
        });
    });
    const $1e08fe14c28adb64$export$91fd6e064cf0bcf3 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul91tcg _2hwxv77o _1e0c1txw _4cvr1fhb _16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $1e08fe14c28adb64$export$9148ffcd7ea9778 = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isLast: isLast, totalCount: totalCount, portionCount: portionCount, isClickable: isClickable, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1wknkfl": (0, (0, parcelRequire("lD23V")).default)(__cmplp.portionCount / __cmplp.totalCount * 100)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul91ejb _1e0c1txw _2lx21bp4 _4cvr1fhb _7cca15wb _11q7glyw _syaz1kw7 _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c81kw7 _12ji1r31 _1qu21kw7 _12y31o36 _qe84exuw _x2qs15x0",
                __cmplp.isLast ? "_2hwxze3t" : "_2hwxv77o",
                __cmplp.totalCount === 0 ? "_16jlkb7n" : "_16jl1hqj",
                __cmplp.isClickable ? "_80omtlke" : "_80om73ad",
                __cmplp.className
            ])
        });
    });
    const $1e08fe14c28adb64$export$bbc6c6369b38e3d1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isFirst: isFirst, isLast: isLast, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_xexnhp": (0, (0, parcelRequire("lD23V")).default)(__cmplp.color),
                "--_198gxfk": (0, (0, parcelRequire("lD23V")).default)((()=>{
                    if (__cmplp.isFirst && __cmplp.isLast) return `${0, (0, parcelRequire("gwIPs")).gridSize}px`;
                    if (__cmplp.isFirst) return `${0, (0, parcelRequire("gwIPs")).gridSize}px 0 0 ${0, (0, parcelRequire("gwIPs")).gridSize}px`;
                    if (__cmplp.isLast) return `0 ${0, (0, parcelRequire("gwIPs")).gridSize}px ${0, (0, parcelRequire("gwIPs")).gridSize}px 0`;
                    return 0;
                })())
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3iftgi _bfhk1cj8 _2rkocu40",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6MI5C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a38c2aee7f8205c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3a38c2aee7f8205c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inProgressIssuesTooltipText: {
            "id": "version-progress.issue-progress-bar.in-progress-issues-tooltip-text",
            "defaultMessage": "In Progress: {inProgressIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}"
        },
        doneIssuesTooltipText: {
            "id": "version-progress.issue-progress-bar.done-issues-tooltip-text",
            "defaultMessage": "Done: {completedIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}"
        },
        todoIssuesTooltipText: {
            "id": "version-progress.issue-progress-bar.todo-issues-tooltip-text",
            "defaultMessage": "To Do: {todoIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}"
        }
    });
});
parcelRegister("gA9bT", function(module, exports) {
    $parcel$export(module.exports, "IssueProgressDetails", ()=>$309ff130df5bcc16$export$d0720399ba8e473e);
    var $h1FvK;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $8Uumt = parcelRequire("8Uumt");
    var $gULOk;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $1YU2V;
    var $aEvzD;
    var $6vBfz;
    const $309ff130df5bcc16$export$d0720399ba8e473e = ({ jiraVersion: jiraVersion })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { showStatusCategoryIssues: showStatusCategoryIssues, showIssuesWithWarnings: showIssuesWithWarnings } = (0, (0, parcelRequire("1YU2V")).useFilterSortingQueryParams)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("h1FvK")).default), jiraVersion);
        const { doneIssuesRedesignTemp: doneIssues, inProgressIssuesRedesignTemp: inProgressIssues, todoIssuesRedesignTemp: todoIssues } = version;
        const { warningConfig: warningConfig } = version;
        const enabledWarningCategories = [];
        if (warningConfig?.failingBuild === 'ENABLED') enabledWarningCategories.push('FAILING_BUILD');
        if (warningConfig?.openPullRequest === 'ENABLED') enabledWarningCategories.push('OPEN_PULL_REQUEST');
        if (warningConfig?.openReview === 'ENABLED') enabledWarningCategories.push('OPEN_REVIEW');
        if (warningConfig?.unreviewedCode === 'ENABLED') enabledWarningCategories.push('UNREVIEWED_CODE');
        const messageFormatter = {
            b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$StatusCategoryName, null, chunks),
            s: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$IssueCount, null, chunks)
        };
        const createStatusClickHandler = (category)=>()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button'
                }), 'progressDetailsShortcutFilter', {
                    filter: category
                });
                const categoryId = String((0, (0, parcelRequire("gULOk")).categoryIdForStatusCategory)(category));
                showStatusCategoryIssues([
                    categoryId
                ]);
            };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$Row, {
            onClick: createStatusClickHandler((0, (0, parcelRequire("gULOk")).DONE))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$StatusCategoryColorIndicator, {
            color: (0, (0, parcelRequire("aEvzD")).DONE_COLOR)
        }), formatMessage((0, (0, parcelRequire("6vBfz")).messages).doneIssues, {
            ...messageFormatter,
            count: doneIssues.totalCount
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$Row, {
            onClick: createStatusClickHandler((0, (0, parcelRequire("gULOk")).IN_PROGRESS))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$StatusCategoryColorIndicator, {
            color: (0, (0, parcelRequire("aEvzD")).IN_PROGRESS_COLOR)
        }), formatMessage((0, (0, parcelRequire("6vBfz")).messages).inProgressIssues, {
            ...messageFormatter,
            count: inProgressIssues.totalCount
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$Row, {
            onClick: createStatusClickHandler((0, (0, parcelRequire("gULOk")).TODO))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$StatusCategoryColorIndicator, {
            color: (0, (0, parcelRequire("aEvzD")).TODO_COLOR)
        }), formatMessage((0, (0, parcelRequire("6vBfz")).messages).toDoIssues, {
            ...messageFormatter,
            count: todoIssues.totalCount
        })), enabledWarningCategories.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$Row, {
            "data-testid": "software-releases-version-detail-issue-list.ui.warning-filter-button",
            onClick: ()=>{
                showIssuesWithWarnings(enabledWarningCategories);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button'
                }), 'progressBarShortcutFilter', {
                    filter: 'warnings'
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$StatusCategoryColorIndicator, {
            color: (0, (0, parcelRequire("aEvzD")).WARNING_COLOR)
        }), formatMessage((0, (0, parcelRequire("6vBfz")).messages).warningIssues, {
            ...messageFormatter,
            count: version.warningsCount
        })));
    };
    const $309ff130df5bcc16$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _19pku2gc",
                __cmplp.className
            ])
        });
    });
    const $309ff130df5bcc16$var$StatusCategoryColorIndicator = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_xexnhp": (0, (0, parcelRequire("lD23V")).default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb19bv _4t3i19bv _bfhk1cj8 _2rko19bv _2hwxv47k _18u0u2gc",
                __cmplp.className
            ])
        });
    });
    const $309ff130df5bcc16$var$Row = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _80omtlke _2rko1l7b _1yt4u2gc _irr34mfv",
                __cmplp.className
            ])
        });
    });
    const $309ff130df5bcc16$var$StatusCategoryName = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_k48pni7l _o572qvpr",
                __cmplp.className
            ])
        });
    });
    const $309ff130df5bcc16$var$IssueCount = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1rc1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("h1FvK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d161c81870e6ba52$export$2e2bcd8739ae039);
    const $d161c81870e6ba52$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "totalCount"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "issueProgressDetails_versionProgress",
            "selections": [
                {
                    "concreteType": "JiraVersionWarningConfig",
                    "kind": "LinkedField",
                    "name": "warningConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "failingBuild"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "openPullRequest"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "openReview"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "unreviewedCode"
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "doneIssuesRedesignTemp",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filters",
                                "value": {
                                    "statusCategories": [
                                        "DONE"
                                    ]
                                }
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "doneIssuesRedesignTemp.totalCount"
                            }
                        ],
                        "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                    },
                    "action": "THROW",
                    "path": "doneIssuesRedesignTemp"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "inProgressIssuesRedesignTemp",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filters",
                                "value": {
                                    "statusCategories": [
                                        "IN_PROGRESS"
                                    ]
                                }
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "inProgressIssuesRedesignTemp.totalCount"
                            }
                        ],
                        "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                    },
                    "action": "THROW",
                    "path": "inProgressIssuesRedesignTemp"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "todoIssuesRedesignTemp",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filters",
                                "value": {
                                    "statusCategories": [
                                        "TODO"
                                    ]
                                }
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "todoIssuesRedesignTemp.totalCount"
                            }
                        ],
                        "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                    },
                    "action": "THROW",
                    "path": "todoIssuesRedesignTemp"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "warningsCount"
                    },
                    "action": "THROW",
                    "path": "warningsCount"
                }
            ],
            "type": "JiraVersion"
        };
    }();
    $d161c81870e6ba52$var$node.hash = "d8f802ed4e1d73fb8f14bafb9265439b";
    var $d161c81870e6ba52$export$2e2bcd8739ae039 = $d161c81870e6ba52$var$node;
});
parcelRegister("6vBfz", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$059c7c1fd302951a$export$defe85febe8b728c);
    var $7VHMR;
    const $059c7c1fd302951a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        doneIssues: {
            "id": "version-progress.issue-progress-details.done-issues",
            "defaultMessage": "<b>Done: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
        },
        inProgressIssues: {
            "id": "version-progress.issue-progress-details.in-progress-issues",
            "defaultMessage": "<b>In progress: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
        },
        toDoIssues: {
            "id": "version-progress.issue-progress-details.to-do-issues",
            "defaultMessage": "<b>To do: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
        },
        warningIssues: {
            "id": "version-progress.issue-progress-details.warning-issues",
            "defaultMessage": "<b>Warning: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
        }
    });
});
parcelRegister("aPvTj", function(module, exports) {
    $parcel$export(module.exports, "IssuesHeading", ()=>$65de343a8a110ebb$export$d7aca75aff5e9fe3);
    var $8PKAx;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $l1N8i;
    var $koVbs;
    var $fi7WV;
    var $gZxFj;
    var $fBtGA;
    const $65de343a8a110ebb$export$d7aca75aff5e9fe3 = ({ jiraVersion: jiraVersion, isCollapsed: isCollapsed, onToggleClicked: onToggleClicked })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("8PKAx")).default), jiraVersion);
        const inProgressIssueCount = version.inProgressIssuesRedesignTemp.totalCount;
        const doneIssueCount = version.doneIssuesRedesignTemp.totalCount;
        const todoIssueCount = version.todoIssuesRedesignTemp.totalCount;
        const totalIssueCount = inProgressIssueCount + doneIssueCount + todoIssueCount;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Section), {
            onClick: onToggleClicked,
            isCollapsible: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall",
            as: "h4"
        }, formatMessage((0, (0, parcelRequire("fBtGA")).default).issuesHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Summary), null, totalIssueCount === 0 ? formatMessage((0, (0, parcelRequire("fBtGA")).default).noIssues) : formatMessage((0, (0, parcelRequire("fBtGA")).default).doneIssues, {
            doneCount: doneIssueCount,
            totalCount: totalIssueCount
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fi7WV")).CollapsibleToggleButton), {
            isCollapsed: isCollapsed
        })));
    };
});
parcelRegister("8PKAx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f0466cb638e4bbc$export$2e2bcd8739ae039);
    const $1f0466cb638e4bbc$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "totalCount"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "issuesHeading_versionProgress",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "doneIssuesRedesignTemp",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filters",
                                "value": {
                                    "statusCategories": [
                                        "DONE"
                                    ]
                                }
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "doneIssuesRedesignTemp.totalCount"
                            }
                        ],
                        "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                    },
                    "action": "THROW",
                    "path": "doneIssuesRedesignTemp"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "inProgressIssuesRedesignTemp",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filters",
                                "value": {
                                    "statusCategories": [
                                        "IN_PROGRESS"
                                    ]
                                }
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "inProgressIssuesRedesignTemp.totalCount"
                            }
                        ],
                        "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                    },
                    "action": "THROW",
                    "path": "inProgressIssuesRedesignTemp"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "todoIssuesRedesignTemp",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filters",
                                "value": {
                                    "statusCategories": [
                                        "TODO"
                                    ]
                                }
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "todoIssuesRedesignTemp.totalCount"
                            }
                        ],
                        "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                    },
                    "action": "THROW",
                    "path": "todoIssuesRedesignTemp"
                }
            ],
            "type": "JiraVersion"
        };
    }();
    $1f0466cb638e4bbc$var$node.hash = "1894f7adb956d41d80dd7d309152870c";
    var $1f0466cb638e4bbc$export$2e2bcd8739ae039 = $1f0466cb638e4bbc$var$node;
});
parcelRegister("fBtGA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e26ad5b1e0b6b1f8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e26ad5b1e0b6b1f8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issuesHeading: {
            "id": "version-progress.issues-heading.issues-heading",
            "defaultMessage": "Issues"
        },
        doneIssues: {
            "id": "version-progress.issues-heading.done-issues",
            "defaultMessage": "{doneCount} of {totalCount} {totalCount, plural, one {done} other {done}}"
        },
        noIssues: {
            "id": "version-progress.issues-heading.no-issues",
            "defaultMessage": "No issues added"
        }
    });
});
parcelRegister("fyA65", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$13fbf51b0a1bc364$export$defe85febe8b728c);
    var $7VHMR;
    const $13fbf51b0a1bc364$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        progressHeading: {
            "id": "version-progress.progress-heading",
            "defaultMessage": "Progress"
        }
    });
});
parcelRegister("jbc56", function(module, exports) {
    $parcel$export(module.exports, "RelatedWorkHeading", ()=>$96f2971fe6b990b4$export$7705e89d52d14851);
    var $iHnWK;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $l1N8i;
    var $koVbs;
    var $gZxFj;
    var $aY8y9;
    const $96f2971fe6b990b4$export$7705e89d52d14851 = ({ relatedWorkEdges: relatedWorkEdges })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const edges = (0, $8Uumt.useFragment)((0, (0, parcelRequire("iHnWK")).default), relatedWorkEdges);
        const totalCount = edges.length;
        const numNonPlaceholders = totalCount ? edges.filter((edge)=>{
            switch(edge?.node.__typename){
                case 'JiraVersionRelatedWorkNativeReleaseNotes':
                    return true;
                case 'JiraVersionRelatedWorkGenericLink':
                case 'JiraVersionRelatedWorkConfluenceReleaseNotes':
                    return edge.node.url !== null;
                default:
                    return false;
            }
        }).length : 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Section), {
            isCollapsible: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall",
            as: "h4"
        }, formatMessage((0, (0, parcelRequire("aY8y9")).default).relatedWorkHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Summary), null, totalCount === 0 ? formatMessage((0, (0, parcelRequire("aY8y9")).default).noItems) : formatMessage((0, (0, parcelRequire("aY8y9")).default).summaryText, {
            numNonPlaceholders: numNonPlaceholders,
            totalCount: totalCount
        })));
    };
});
parcelRegister("iHnWK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d079d8334f42b59$export$2e2bcd8739ae039);
    const $6d079d8334f42b59$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v1 = [
            v0,
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ];
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": {
                "plural": true
            },
            "name": "relatedWorkHeading_versionProgress",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": v1,
                                "type": "JiraVersionRelatedWorkGenericLink"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": v1,
                                "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v0
                                ],
                                "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                            }
                        ]
                    },
                    "action": "NONE",
                    "path": "node"
                }
            ],
            "type": "JiraVersionRelatedWorkV2Edge"
        };
    }();
    $6d079d8334f42b59$var$node.hash = "211a6665d1a1915d987787889e12cca6";
    var $6d079d8334f42b59$export$2e2bcd8739ae039 = $6d079d8334f42b59$var$node;
});
parcelRegister("aY8y9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$846bed7c3363306b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $846bed7c3363306b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        relatedWorkHeading: {
            "id": "version-progress.related-work-heading.related-work-heading",
            "defaultMessage": "Related work"
        },
        summaryText: {
            "id": "version-progress.related-work-heading.summary-text",
            "defaultMessage": "{numNonPlaceholders} of {totalCount} added"
        },
        noItems: {
            "id": "version-progress.related-work-heading.no-items",
            "defaultMessage": "None added"
        }
    });
});
parcelRegister("jMgdz", function(module, exports) {
    $parcel$export(module.exports, "RelatedWorkProgressBar", ()=>$d9869db5ea59fe27$export$34d7439de9413789);
    var $19ZPd;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $3bDjY;
    var $koVbs;
    var $8zOmE;
    var $aEvzD;
    var $gZxFj;
    var $cTHUt;
    const $d9869db5ea59fe27$export$34d7439de9413789 = ({ relatedWorkEdges: relatedWorkEdges })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const edges = (0, $8Uumt.useFragment)((0, (0, parcelRequire("19ZPd")).default), relatedWorkEdges);
        const totalCount = edges.length;
        const numNonPlaceholders = totalCount ? edges.filter((edge)=>{
            switch(edge?.node.__typename){
                case 'JiraVersionRelatedWorkNativeReleaseNotes':
                    return true;
                case 'JiraVersionRelatedWorkGenericLink':
                case 'JiraVersionRelatedWorkConfluenceReleaseNotes':
                    return edge.node.url !== null;
                default:
                    return false;
            }
        }).length : 0;
        const numPlaceholders = totalCount - numNonPlaceholders;
        const fireAnalyticsEvent = (analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'relatedWorkProgressTooltip', {
                numOfItems: totalCount,
                numPlaceholders: numPlaceholders,
                numNonPlaceholders: numNonPlaceholders
            });
        };
        if (totalCount === 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Container), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).ProgressBarContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).ProgressBarElementContainer), {
            totalCount: 1,
            portionCount: 1,
            isLast: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Bar), {
            color: (0, (0, parcelRequire("aEvzD")).TODO_COLOR),
            isFirst: true,
            isLast: true
        }))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Container), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).ProgressBarContainer), null, numNonPlaceholders > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).ProgressBarElementContainer), {
            totalCount: totalCount,
            portionCount: numNonPlaceholders
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "top",
            content: formatMessage((0, (0, parcelRequire("cTHUt")).default).nonPlaceholdersSegmentTooltipText, {
                numNonPlaceholders: numNonPlaceholders
            }),
            onShow: (analyticsEvent)=>fireAnalyticsEvent(analyticsEvent)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Bar), {
            color: (0, (0, parcelRequire("aEvzD")).DONE_COLOR),
            isFirst: true,
            isLast: numPlaceholders === 0
        }))), numPlaceholders > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).ProgressBarElementContainer), {
            isLast: true,
            totalCount: totalCount,
            portionCount: numPlaceholders
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "top",
            content: formatMessage((0, (0, parcelRequire("cTHUt")).default).placeholdersSegmentTooltipText, {
                numPlaceholders: numPlaceholders
            }),
            onShow: (analyticsEvent)=>fireAnalyticsEvent(analyticsEvent)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gZxFj")).Bar), {
            color: (0, (0, parcelRequire("aEvzD")).TODO_COLOR),
            isFirst: numNonPlaceholders === 0,
            isLast: true
        })))));
    };
});
parcelRegister("19ZPd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$634121e3100e8331$export$2e2bcd8739ae039);
    const $634121e3100e8331$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v1 = [
            v0,
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ];
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": {
                "plural": true
            },
            "name": "relatedWorkProgressBar_versionProgress",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": v1,
                                "type": "JiraVersionRelatedWorkGenericLink"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": v1,
                                "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v0
                                ],
                                "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                            }
                        ]
                    },
                    "action": "NONE",
                    "path": "node"
                }
            ],
            "type": "JiraVersionRelatedWorkV2Edge"
        };
    }();
    $634121e3100e8331$var$node.hash = "c40509aabe2c6731ba0d792fff68b169";
    var $634121e3100e8331$export$2e2bcd8739ae039 = $634121e3100e8331$var$node;
});
parcelRegister("cTHUt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ace75de7f9cfb453$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ace75de7f9cfb453$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        nonPlaceholdersSegmentTooltipText: {
            "id": "version-progress.related-work-progress-bar.non-placeholders-segment-tooltip-text",
            "defaultMessage": "{numNonPlaceholders} added"
        },
        placeholdersSegmentTooltipText: {
            "id": "version-progress.related-work-progress-bar.placeholders-segment-tooltip-text",
            "defaultMessage": "{numPlaceholders} {numPlaceholders, plural, one {placeholder} other {placeholders}}"
        }
    });
});
parcelRegister("kHzKl", function(module, exports) {
    $parcel$export(module.exports, "NonCriticalErrorBoundary", ()=>$3be5a553cf5dc15b$export$1625b7ea4c7a5a23);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    const $3be5a553cf5dc15b$export$1625b7ea4c7a5a23 = ({ fallback: fallback, eventLocation: eventLocation, children: children, onError: onError })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: fallback,
            packageName: "jiraSoftwareReleasesVersionDetail",
            teamName: "fusion-solaris",
            id: eventLocation,
            onError: onError
        }, children);
});
parcelRegister("gl1Tm", function(module, exports) {
    $parcel$export(module.exports, "convertTabToQueryVariables", ()=>$8cb887ac98c983d8$export$4fc138bc768eeef1);
    const $8cb887ac98c983d8$export$4fc138bc768eeef1 = (tab)=>{
        switch(tab){
            case 'release-report-warnings':
                return {
                    filter: 'OPEN_PULL_REQUEST',
                    isShowWarnings: true
                };
            case 'release-report-all-issues':
                return {
                    filter: 'ALL',
                    isShowWarnings: false
                };
            case 'release-report-done':
                return {
                    filter: 'DONE',
                    isShowWarnings: false
                };
            case 'release-report-in-progress':
                return {
                    filter: 'IN_PROGRESS',
                    isShowWarnings: false
                };
            case 'release-report-todo':
                return {
                    filter: 'TODO',
                    isShowWarnings: false
                };
            default:
                return {
                    filter: 'ALL',
                    isShowWarnings: false
                };
        }
    };
});
parcelRegister("47ffb", function(module, exports) {
    $parcel$export(module.exports, "useCurrentTab", ()=>$94ff5b9d5e6937bf$export$49b7d3cc5222d699);
    var $bmKPg;
    const $94ff5b9d5e6937bf$var$toVersionTabId = (selectedTabId)=>{
        if (selectedTabId === undefined) return 0, $465fa0a3a0498e9a$export$88979a530e0a9348;
        switch(selectedTabId){
            case 0, $465fa0a3a0498e9a$export$53105de2008705e2:
                return 0, $465fa0a3a0498e9a$export$53105de2008705e2;
            case 0, $465fa0a3a0498e9a$export$88979a530e0a9348:
                return 0, $465fa0a3a0498e9a$export$88979a530e0a9348;
            case 0, $465fa0a3a0498e9a$export$d669607531cb7a9a:
                return 0, $465fa0a3a0498e9a$export$d669607531cb7a9a;
            case 0, $465fa0a3a0498e9a$export$d9e751b9469f77b3:
                return 0, $465fa0a3a0498e9a$export$d9e751b9469f77b3;
            case 0, $465fa0a3a0498e9a$export$5e552e58a93a50a5:
                return 0, $465fa0a3a0498e9a$export$5e552e58a93a50a5;
            default:
                return 0, $465fa0a3a0498e9a$export$88979a530e0a9348;
        }
    };
    const $94ff5b9d5e6937bf$export$49b7d3cc5222d699 = ()=>{
        const [selectedTabId, setSelectedTab] = (0, (0, parcelRequire("bmKPg")).usePathParam)('tab');
        const setCurrentTab = (tabId)=>{
            setSelectedTab(tabId);
        };
        return {
            currentTabId: $94ff5b9d5e6937bf$var$toVersionTabId(selectedTabId),
            setCurrentTab: setCurrentTab
        };
    };
});
const $465fa0a3a0498e9a$export$53105de2008705e2 = 'release-report-warnings';
const $465fa0a3a0498e9a$export$88979a530e0a9348 = 'release-report-all-issues';
const $465fa0a3a0498e9a$export$d669607531cb7a9a = 'release-report-done';
const $465fa0a3a0498e9a$export$d9e751b9469f77b3 = 'release-report-in-progress';
const $465fa0a3a0498e9a$export$5e552e58a93a50a5 = 'release-report-todo';
parcelRegister("greDE", function(module, exports) {
    $parcel$export(module.exports, "PerformanceTracker", ()=>$c3f0515a77b89a3d$export$57a2c9a4973f6a35);
    var $5uXOq = parcelRequire("5uXOq");
    var $dGrdR;
    var $5rqex;
    var $kHzKl;
    const $c3f0515a77b89a3d$var$versionDetailsPagePageLoad = (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
        key: 'software.version-details-page',
        ssr: {
            doneAsFmp: true
        },
        slo: {
            fmp: {
                initial: {
                    threshold: 1000
                },
                transition: {
                    threshold: 1000
                }
            },
            tti: {
                initial: {
                    threshold: 4000
                },
                transition: {
                    threshold: 4000
                }
            }
        }
    });
    const $c3f0515a77b89a3d$export$57a2c9a4973f6a35 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            fallback: "unmount",
            eventLocation: "performanceTracker"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), {
            appName: "jira-software-version-details-page",
            metric: $c3f0515a77b89a3d$var$versionDetailsPagePageLoad
        }));
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $aOr3t;
    var $1u4q7;
    var $co1wz;
    var $1AZST;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aOr3t")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("1u4q7")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $21pfT;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("21pfT")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1AZST;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $1u4q7;
    var $bFU4G;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $1u4q7;
    var $bFU4G;
    var $1AZST;
    var $49z18;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("49z18")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("jpznh", function(module, exports) {
    $parcel$export(module.exports, "AccessCheck", ()=>$f48e1ae7f8bcee8f$export$ad057184bf4c4ff2);
    var $8Hozt;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $cIy4l;
    var $7tQej;
    const $f48e1ae7f8bcee8f$var$getVersionIssuesUrl = (versionName, projectKey)=>{
        const jql = `project = ${(0, (0, parcelRequire("cIy4l")).toQuotedString)(projectKey)} AND fixVersion = ${(0, (0, parcelRequire("cIy4l")).toQuotedString)(versionName)}`;
        return (0, (0, parcelRequire("cIy4l")).createIssuesUrl)(jql);
    };
    const $f48e1ae7f8bcee8f$export$ad057184bf4c4ff2 = ({ jiraVersion: jiraVersion, children: children })=>{
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("8Hozt")).default), jiraVersion);
        if (version != null && !version.canViewVersionDetailsPage) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: $f48e1ae7f8bcee8f$var$getVersionIssuesUrl(version.name, version.project.key)
        });
        return children;
    };
});
parcelRegister("8Hozt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aaf769132d117138$export$2e2bcd8739ae039);
    const $aaf769132d117138$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "accessCheck_softwareReleasesVersionDetail",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "name"
                },
                "action": "NONE",
                "path": "name"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            "action": "NONE",
                            "path": "project.key"
                        }
                    ]
                },
                "action": "NONE",
                "path": "project"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "canViewVersionDetailsPage"
                },
                "action": "NONE",
                "path": "canViewVersionDetailsPage"
            }
        ],
        "type": "JiraVersion"
    };
    $aaf769132d117138$var$node.hash = "9b2c4488974a4d13577b85807b03079a";
    var $aaf769132d117138$export$2e2bcd8739ae039 = $aaf769132d117138$var$node;
});
parcelRegister("fs1tp", function(module, exports) {
    $parcel$export(module.exports, "Header", ()=>$d2a1664c6770ad79$export$8b251419efc915eb);
    var $hsUsT;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $ldJSL;
    var $i8Qvm;
    var $jS4lj;
    var $cS37j;
    var $93jKl;
    var $8oqHW;
    var $kfztd;
    var $6lgIC;
    var $dkXFD;
    var $kHzKl;
    var $je2ff;
    var $jsT1l;
    var $gOpVm;
    var $fbFR6;
    const $d2a1664c6770ad79$export$8b251419efc915eb = ({ jiraVersion: jiraVersion, shouldShowBreadcrumbs: shouldShowBreadcrumbs = true, shouldShowFeedbackButton: shouldShowFeedbackButton = true, shouldShowAutomationButton: shouldShowAutomationButton = true, shouldShowGraphButton: shouldShowGraphButton = true })=>{
        const breadcrumbs = shouldShowBreadcrumbs ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null) : null;
        const onConnectAppExpFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: (0, $81f82fb3b4517b74$export$af5e668651a80140)
        });
        const [warningsModalOpen, setWarningsModalOpen] = (0, $5uXOq.useState)(false);
        const [isEditing, setIsEditing] = (0, $5uXOq.useState)(false);
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("hsUsT")).default), jiraVersion);
        const issues = version.allIssues.totalCount;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), {
            breadcrumbs: breadcrumbs,
            truncateTitle: true,
            disableTitleStyles: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d2a1664c6770ad79$var$HeaderTitleLane, null, (0, ($parcel$interopDefault($5uXOq))).createElement($d2a1664c6770ad79$var$LeftContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($d2a1664c6770ad79$var$HeaderTitle, {
            "data-testid": "software-releases-version-detail.ui.header.title"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d2a1664c6770ad79$var$PageTitleContainer, {
            isOverflowEnabled: isEditing
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jsT1l")).AsyncEditableName), {
            isEditing: isEditing,
            setIsEditing: setIsEditing,
            jiraVersion: version
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement($d2a1664c6770ad79$var$RightContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, shouldShowGraphButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8oqHW")).default), {
            from: version.id
        }), shouldShowFeedbackButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            fallback: "flag",
            eventLocation: "feedbackButton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gOpVm")).FeedbackButton), null)), shouldShowAutomationButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            fallback: "unmount",
            eventLocation: "releaseAutomationMenu"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lgIC")).default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, warningsModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            fallback: "flag",
            eventLocation: "warningConfigModal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dkXFD")).ManageWarningsModal), {
            jiraVersion: version,
            setModalClosed: ()=>{
                setWarningsModalOpen(false);
            }
        }))), !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && issues > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fbFR6")).ReleaseNotesButton), {
            jiraVersion: version
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            fallback: "flag",
            eventLocation: "headerConnectApps",
            onError: onConnectAppExpFail
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d2a1664c6770ad79$var$MarketPlaceAddonLane, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("je2ff")).ConnectApps), {
            jiraVersion: version
        }))));
    };
    const $d2a1664c6770ad79$var$HeaderTitleLane = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1yb4 _1p57pxbi",
                __cmplp.className
            ])
        });
    });
    const $d2a1664c6770ad79$var$LeftContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _18u0x0bf _1ul9idpf",
                __cmplp.className
            ])
        });
    });
    const $d2a1664c6770ad79$var$RightContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1e0c1txw _1bahesu3 _1ul91mjv",
                __cmplp.className
            ])
        });
    });
    const $d2a1664c6770ad79$var$MarketPlaceAddonLane = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvresu3",
                __cmplp.className
            ])
        });
    });
    const $d2a1664c6770ad79$var$HeaderTitle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1ul9idpf _4t3ior1b",
                __cmplp.className
            ])
        });
    });
    const $d2a1664c6770ad79$var$PageTitleContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isOverflowEnabled: isOverflowEnabled, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkx0bf _1ul9idpf",
                __cmplp.isOverflowEnabled ? "_1reoewfl _18m9ewfl" : "_1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hsUsT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$909296b02fa53b8c$export$2e2bcd8739ae039);
    const $909296b02fa53b8c$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "header_softwareReleasesVersionDetail",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "allIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": "ALL"
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "totalCount"
                            },
                            "action": "THROW",
                            "path": "allIssues.totalCount"
                        }
                    ],
                    "storageKey": "issues(filter:\"ALL\")"
                },
                "action": "THROW",
                "path": "allIssues"
            },
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesVersionDetail_AsyncEditableName"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesManageWarnings_ManageWarningsModal"
            },
            {
                "kind": "FragmentSpread",
                "name": "connectApps_softwareReleasesVersionDetail"
            },
            {
                "kind": "FragmentSpread",
                "name": "releaseNotesButton_softwareReleasesVersionDetail"
            }
        ],
        "type": "JiraVersion"
    };
    $909296b02fa53b8c$var$node.hash = "f18c07820c274d0155b6bcd5afb8be06";
    var $909296b02fa53b8c$export$2e2bcd8739ae039 = $909296b02fa53b8c$var$node;
});
parcelRegister("cS37j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a15efb09f101ecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $57MwZ;
    const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57MwZ")).default), {
            ...props,
            actions: actions ? (0, ($parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
        });
    var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
    const $2a15efb09f101ecb$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("57MwZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9694e728fd1ea060$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eeGIy;
    const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;
});
parcelRegister("eeGIy", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$0c196d37a4e8266c$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$0c196d37a4e8266c$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$0c196d37a4e8266c$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$0c196d37a4e8266c$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$0c196d37a4e8266c$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$0c196d37a4e8266c$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $8CUq3;
    function $0c196d37a4e8266c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0c196d37a4e8266c$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $0c196d37a4e8266c$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $0c196d37a4e8266c$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $0c196d37a4e8266c$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $0c196d37a4e8266c$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $0c196d37a4e8266c$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $0c196d37a4e8266c$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $0c196d37a4e8266c$var$bottomBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$outerStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $0c196d37a4e8266c$var$titleStyles,
                truncateTitle && $0c196d37a4e8266c$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleWrapperStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleContainerStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$actionStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0c196d37a4e8266c$var$bottomBarStyles
        }, children);
    };
});
parcelRegister("8oqHW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$209121b8bab00e10$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $co1wz;
    var $7XYc4;
    var $koVbs;
    var $kfztd;
    var $9OXo1;
    var $iAsld;
    var $7jnfo;
    function $209121b8bab00e10$var$Graph({ from: from }) {
        const { environment: environment } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const graphURL = `${environment === 'staging' ? (0, $f4564a22dfe3f554$export$b1c73a3711ffd2e1) : (0, $f4564a22dfe3f554$export$b105bca7736ab247)}?ari=${from}`;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            href: graphURL,
            "aria-label": formatMessage((0, (0, parcelRequire("7jnfo")).default).graphButtonLabelNonFinal),
            target: "_blank",
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iAsld")).GraphIcon), null)
        });
    }
    var $209121b8bab00e10$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>!(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, (0, parcelRequire("co1wz")).ff)('otc.show-me-the-graph'), $209121b8bab00e10$var$Graph, ()=>null);
});
const $f4564a22dfe3f554$export$b105bca7736ab247 = 'https://atlassian-graph.prod-east.frontend.public.atl-paas.net/';
const $f4564a22dfe3f554$export$b1c73a3711ffd2e1 = 'https://atlassian-graph.stg-east.frontend.public.atl-paas.net/';
parcelRegister("iAsld", function(module, exports) {
    $parcel$export(module.exports, "GraphIcon", ()=>$b7531f203cb3100a$export$717a5ffb6a14ac74);
    var $5uXOq = parcelRequire("5uXOq");
    const $b7531f203cb3100a$export$717a5ffb6a14ac74 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            fill: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$exports).P500})`,
            viewBox: "0 0 256 256"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M200,152a31.84,31.84,0,0,0-19.53,6.68l-23.11-18A31.65,31.65,0,0,0,160,128c0-.74,0-1.48-.08-2.21l13.23-4.41A32,32,0,1,0,168,104c0,.74,0,1.48.08,2.21l-13.23,4.41A32,32,0,0,0,128,96a32.59,32.59,0,0,0-5.27.44L115.89,81A32,32,0,1,0,96,88a32.59,32.59,0,0,0,5.27-.44l6.84,15.4a31.92,31.92,0,0,0-8.57,39.64L73.83,165.44a32.06,32.06,0,1,0,10.63,12l25.71-22.84a31.91,31.91,0,0,0,37.36-1.24l23.11,18A31.65,31.65,0,0,0,168,184a32,32,0,1,0,32-32Zm0-64a16,16,0,1,1-16,16A16,16,0,0,1,200,88ZM80,56A16,16,0,1,1,96,72,16,16,0,0,1,80,56ZM56,208a16,16,0,1,1,16-16A16,16,0,0,1,56,208Zm144-8a16,16,0,1,1,16-16A16,16,0,0,1,200,200Z"
        }));
});
parcelRegister("7jnfo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$303612e9ffdead3d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $303612e9ffdead3d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        graphButtonLabelNonFinal: {
            "id": "graph.graph-button-label-non-final",
            "defaultMessage": "Open the graph"
        }
    });
});
parcelRegister("6lgIC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d512d39a9a2997e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $hrfsZ;
    var $lfTZh;
    var $kxZPA;
    var $8pnTj;
    const $8d512d39a9a2997e$var$AutomationMenu = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("7AEEN")), {
        moduleId: "./src/packages/releases/automation-menu/src/index.tsx"
    });
    const $8d512d39a9a2997e$var$fallback = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pnTj")).IconWrapper), {
        "data-testid": "jira-releases-automation-menu.ui.automation-button.disabled"
    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
        glyph: (0, (0, parcelRequire("hrfsZ")).AutomationGlyph),
        label: ""
    }));
    const $8d512d39a9a2997e$var$AsyncReleaseAutomationMenu = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "releases-automation-menu",
            fallback: $8d512d39a9a2997e$var$fallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8d512d39a9a2997e$var$AutomationMenu, null));
    var $8d512d39a9a2997e$export$2e2bcd8739ae039 = $8d512d39a9a2997e$var$AsyncReleaseAutomationMenu;
});
parcelRegister("hrfsZ", function(module, exports) {
    $parcel$export(module.exports, "AutomationGlyph", ()=>$7a6859ebc905c49b$export$3b6023946faff8bc);
    var $5uXOq = parcelRequire("5uXOq");
    const $7a6859ebc905c49b$export$3b6023946faff8bc = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14 5L10 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14 5L7 12H17L10 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }));
});
parcelRegister("8pnTj", function(module, exports) {
    $parcel$export(module.exports, "IconWrapper", ()=>$e5abf0a18ea0d111$export$be58b4326e23250f);
    $parcel$export(module.exports, "default", ()=>$e5abf0a18ea0d111$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jZ4fr;
    var $l1N8i;
    var $5LWLA;
    var $eZUJu;
    var $9UCCQ;
    var $imZsD;
    var $5Fk4Z;
    var $1I7E8;
    var $3bDjY;
    var $hrfsZ;
    var $jJ8Br;
    var $2vSU6;
    var $koVbs;
    var $98HlR;
    var $jNWbA;
    var $1OWKd;
    const $e5abf0a18ea0d111$var$automationIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
        glyph: (0, (0, parcelRequire("hrfsZ")).AutomationGlyph),
        label: ""
    });
    const $e5abf0a18ea0d111$var$AutomationMenuContent = (props)=>{
        const { projectType: projectType } = props;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) ? (0, ($parcel$interopDefault($5uXOq))).createElement($e5abf0a18ea0d111$var$MenuContentWrapper, {
            "data-testid": "jira-releases-automation-menu.ui.automation-menu-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e5abf0a18ea0d111$var$MenuTitle, null, intl.formatMessage((0, (0, parcelRequire("1OWKd")).default).automationMenuTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement($e5abf0a18ea0d111$var$MenuSubTitle, null, intl.formatMessage((0, (0, parcelRequire("1OWKd")).default).automationMenuSubTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNWbA")).AutomationMenuTemplateRules), props), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("98HlR")).AutomationMenuDeepLinks), {
            includeDiscoverAutomation: false,
            ...props
        })))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("98HlR")).AutomationMenuDeepLinks), {
            includeDiscoverAutomation: true,
            ...props
        });
    };
    const $e5abf0a18ea0d111$export$bf60e24e2fb3b05d = ({ isMenuEnabled: isMenuEnabled, projectProps: projectProps, isOpenByDefault: isOpenByDefault })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isOpenByDefault ?? false);
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return isMenuEnabled && projectProps ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).default), {
            blanketIsTinted: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: "fusionReleaseAutomationMenu"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-end",
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($e5abf0a18ea0d111$var$AutomationMenuContent, {
                    projectKey: projectProps.projectKey,
                    projectType: projectProps.projectType,
                    isSimplifiedProject: projectProps.isSimplifiedProject
                }),
            trigger: ({ ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    "data-testid": "jira-releases-automation-menu.ui.automation-button.enabled"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jJ8Br")).default), {
                    ...triggerProps,
                    onClick: ()=>setIsOpen(!isOpen),
                    isSelected: isOpen
                }))
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jZ4fr")).EngagementSpotlight), {
            name: "fusionReleaseAutomationMenu"
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement($e5abf0a18ea0d111$export$be58b4326e23250f, {
            "data-testid": "jira-releases-automation-menu.ui.automation-button.disabled"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "top",
            content: intl.formatMessage((0, (0, parcelRequire("1OWKd")).default).disabledAutomationMenuButtonTooltipMessage)
        }, $e5abf0a18ea0d111$var$automationIcon));
    };
    var $e5abf0a18ea0d111$export$2e2bcd8739ae039 = $e5abf0a18ea0d111$export$bf60e24e2fb3b05d;
    const $e5abf0a18ea0d111$var$MenuTitle = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e5abf0a18ea0d111$var$MenuTitleComponent, props));
    const $e5abf0a18ea0d111$var$MenuContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1kdj",
                __cmplp.className
            ])
        });
    });
    const $e5abf0a18ea0d111$var$MenuSubTitle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1rc1 _1yt41rml",
                __cmplp.className
            ])
        });
    });
    const $e5abf0a18ea0d111$export$be58b4326e23250f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _4t3i1f4h _1bsb1f4h _1bah1h6o _syaz15t7 _ca0q1b66 _d0al13gf",
                __cmplp.className
            ])
        });
    });
    const $e5abf0a18ea0d111$var$MenuTitleComponent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41jig",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jJ8Br", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff704efab144026a$export$2e2bcd8739ae039);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $5LWLA;
    var $4ldhu;
    var $3bDjY;
    var $4R6GH;
    var $koVbs;
    var $3HwlS;
    var $8zOmE;
    var $22OQR;
    var $dCm1o;
    var $hrfsZ;
    var $eBN2x;
    const $ff704efab144026a$var$MenuButton = (0, $5uXOq.forwardRef)(({ isSelected: isSelected, onClick: onClick }, ref)=>{
        const onClickWithAnalytics = (0, $5uXOq.useCallback)((event, analytics)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analytics, 'automationMenuButton');
            onClick();
        }, [
            onClick
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("eBN2x")).default).menuButtonTooltip),
            position: "top"
        }, (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            ref: ref,
            appearance: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? 'default' : 'subtle',
            onClick: onClickWithAnalytics,
            isSelected: isSelected,
            "data-testId": "automation-menu.ui.button.menu-button",
            id: "automation-menu.ui.popup",
            externalId: "automation-menu.ui.button.menu-button",
            "aria-label": formatMessage((0, (0, parcelRequire("eBN2x")).default).menuButtonTooltip),
            "aria-expanded": isSelected,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4ldhu"))))), {
                label: formatMessage((0, (0, parcelRequire("eBN2x")).default).automationsMenuButtonIcon),
                color: "currentColor",
                spacing: "spacious"
            })
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ref: ref,
            appearance: "subtle",
            spacing: "none",
            isSelected: isSelected,
            onClick: onClickWithAnalytics,
            "data-testId": "automation-menu.ui.button.menu-button",
            id: "automation-menu.ui.popup",
            externalId: "automation-menu.ui.button.menu-button",
            "aria-label": formatMessage((0, (0, parcelRequire("eBN2x")).default).menuButtonTooltip),
            "aria-expanded": isSelected,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($ff704efab144026a$var$IconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                size: "medium",
                glyph: (0, (0, parcelRequire("hrfsZ")).AutomationGlyph),
                label: formatMessage((0, (0, parcelRequire("eBN2x")).default).automationsMenuButtonIcon),
                primaryColor: isSelected ? `var(--ds-icon-selected, ${(0, $829f609a65d26a98$exports).N20})` : undefined,
                secondaryColor: "none"
            }))
        }));
    });
    var $ff704efab144026a$export$2e2bcd8739ae039 = $ff704efab144026a$var$MenuButton;
    const $ff704efab144026a$var$unselectedColor = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N500})`;
    const $ff704efab144026a$var$unselectedHoverColor = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})`;
    const $ff704efab144026a$var$multiplier = 4;
    const $ff704efab144026a$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_10u62xj": (0, (0, parcelRequire("lD23V")).default)($ff704efab144026a$var$unselectedColor),
                "--_1cs4a84": (0, (0, parcelRequire("lD23V")).default)($ff704efab144026a$var$unselectedHoverColor)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _syaz296t _30l31hcg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4ldhu", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $32936cf628dec798$var$_UNSAFE_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $32936cf628dec798$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $32936cf628dec798$var$AutomationIcon = (props)=>$32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m6 15.25-.723-.2a.75.75 0 0 0 1.253.73zM13.25 8l.53.53a.75.75 0 0 0-.53-1.28zM10 .75l.723.2A.75.75 0 0 0 9.47.22zM2.75 8l-.53-.53a.75.75 0 0 0 .53 1.28zm3.78 7.78 7.25-7.25-1.06-1.06-7.25 7.25zm6.72-8.53H8v1.5h5.25zm-4.527.95 2-7.25-1.446-.4-2 7.25zM9.47.22 2.22 7.47l1.06 1.06 7.25-7.25zM2.75 8.75H8v-1.5H2.75zm4.527-.95-2 7.25 1.446.4 2-7.25z"/>`
        }, props));
    $32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
    var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;
});
parcelRegister("22OQR", function(module, exports) {
    $parcel$export(module.exports, "ThemedButton", ()=>$87e6157378e1cf19$export$f67fb575035cc7d0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $2rqOp;
    const $87e6157378e1cf19$export$f67fb575035cc7d0 = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
            ...props,
            as: as,
            ref: ref
        })));
    const $87e6157378e1cf19$var$CustomButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("2rqOp")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("eBN2x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70fd4abbcff5ac1b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $70fd4abbcff5ac1b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        menuButtonTooltip: {
            "id": "automation-menu.button.menu-button-tooltip",
            "defaultMessage": "Automation"
        },
        automationsMenuButtonIcon: {
            "id": "automation-menu.button.automations-menu-button-icon",
            "defaultMessage": "automations-menu-button-icon"
        }
    });
});
parcelRegister("98HlR", function(module, exports) {
    $parcel$export(module.exports, "AutomationMenuDeepLinks", ()=>$fbf4dcc2f12a6c2c$export$fd3c4b1ddf70f790);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $hyEaJ;
    var $9lMrf;
    var $6uqJA;
    var $3Z96c;
    var $eZUJu;
    var $hrfsZ;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $6Wfoj;
    var $bLi0f;
    const $fbf4dcc2f12a6c2c$var$automationIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
        glyph: (0, (0, parcelRequire("hrfsZ")).AutomationGlyph),
        label: ""
    });
    const $fbf4dcc2f12a6c2c$export$fd3c4b1ddf70f790 = ({ isSimplifiedProject: isSimplifiedProject, projectKey: projectKey, projectType: projectType, includeDiscoverAutomation: includeDiscoverAutomation })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "jira-releases-automation-menu.ui.automation-menu-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, includeDiscoverAutomation ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            href: (0, (0, parcelRequire("6Wfoj")).buildDiscoverAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }),
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyEaJ"))))), {
                label: ""
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'discoverAutomationLink'),
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, (0, parcelRequire("bLi0f")).default).discoverAutomationMenuItemLabel)) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            href: (0, (0, parcelRequire("6Wfoj")).buildManageRulesAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }),
            iconBefore: $fbf4dcc2f12a6c2c$var$automationIcon,
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'manageRulesAutomationLink'),
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, (0, parcelRequire("bLi0f")).default).manageAutomationMenuItemLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            href: (0, (0, parcelRequire("6Wfoj")).buildNewRuleAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }),
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                label: ""
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'newRuleAutomationLink'),
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, (0, parcelRequire("bLi0f")).default).createAutomationMenuItemLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            href: (0, (0, parcelRequire("6Wfoj")).buildAuditLogAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }),
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6uqJA"))))), {
                label: ""
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'auditLogAutomationLink'),
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, (0, parcelRequire("bLi0f")).default).auditLogAutomationMenuItemLabel)))));
    };
});
parcelRegister("hyEaJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cc84c60139a91f28$var$_react = $cc84c60139a91f28$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $cc84c60139a91f28$var$_compass = $cc84c60139a91f28$var$_interopRequireDefault((parcelRequire("7ftyG")));
    function $cc84c60139a91f28$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cc84c60139a91f28$var$DiscoverIcon = (props)=>$cc84c60139a91f28$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0 2a9 9 0 1 1 0-18 9 9 0 0 1 0 18"/><path d="m10.86 10.186 3.896-1.948c1.11-.555 1.562-.108 1.005 1.006l-1.948 3.896c-.126.251-.426.55-.673.673l-3.897 1.948c-1.11.556-1.561.11-1.004-1.006l1.947-3.896c.126-.25.426-.55.673-.673M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/></g></svg>`
        }, props, {
            newIcon: $cc84c60139a91f28$var$_compass.default
        }));
    $cc84c60139a91f28$var$DiscoverIcon.displayName = 'DiscoverIcon';
    var $cc84c60139a91f28$var$_default = module.exports.default = $cc84c60139a91f28$var$DiscoverIcon;
});
parcelRegister("7ftyG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5470dcd3a4786f26$var$_react = $5470dcd3a4786f26$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5470dcd3a4786f26$var$_UNSAFE_baseNew = $5470dcd3a4786f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $5470dcd3a4786f26$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5470dcd3a4786f26$var$CompassIcon = (props)=>$5470dcd3a4786f26$var$_react.default.createElement($5470dcd3a4786f26$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.75 11.25 4.5-2-2.5-2.5z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m11.25 4.75-4.5 2 2.5 2.5z"/>`
        }, props));
    $5470dcd3a4786f26$var$CompassIcon.displayName = 'CompassIcon';
    var $5470dcd3a4786f26$var$_default = module.exports.default = $5470dcd3a4786f26$var$CompassIcon;
});
parcelRegister("6uqJA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b9a484973717fe2$var$_react = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4b9a484973717fe2$var$_clock = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("hyKRO")));
    function $4b9a484973717fe2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b9a484973717fe2$var$EmojiFrequentIcon = (props)=>$4b9a484973717fe2$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
        }, props, {
            newIcon: $4b9a484973717fe2$var$_clock.default
        }));
    $4b9a484973717fe2$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
    var $4b9a484973717fe2$var$_default = module.exports.default = $4b9a484973717fe2$var$EmojiFrequentIcon;
});
parcelRegister("6Wfoj", function(module, exports) {
    $parcel$export(module.exports, "buildNewRuleAutomationUrl", ()=>$cb0b6e6c85af8509$export$d6be0a6034032add);
    $parcel$export(module.exports, "buildManageRulesAutomationUrl", ()=>$cb0b6e6c85af8509$export$fb714f787469e8b0);
    $parcel$export(module.exports, "buildAuditLogAutomationUrl", ()=>$cb0b6e6c85af8509$export$7d1590b2fb4dd741);
    $parcel$export(module.exports, "buildDiscoverAutomationUrl", ()=>$cb0b6e6c85af8509$export$51ac1eeac37070f8);
    $parcel$export(module.exports, "buildTemplateRuleAutomationUrl", ()=>$cb0b6e6c85af8509$export$82ce8540ef209720);
    var $gOS29;
    const $cb0b6e6c85af8509$export$d6be0a6034032add = (projectProps)=>`${(0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)(projectProps)}#rule/new?componentFilterCriteria=RELEASE_MANAGEMENT_TRIGGERS`;
    const $cb0b6e6c85af8509$export$fb714f787469e8b0 = (projectProps)=>`${(0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)(projectProps)}#/rule-list`;
    const $cb0b6e6c85af8509$export$7d1590b2fb4dd741 = (projectProps)=>`${(0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)(projectProps)}#tab/audit-log`;
    const $cb0b6e6c85af8509$export$51ac1eeac37070f8 = (projectProps)=>`${(0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)(projectProps)}#/tab/rule-library`;
    const $cb0b6e6c85af8509$export$82ce8540ef209720 = (projectProps, templateId)=>`${(0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)(projectProps)}#/rule/template?templateId=${templateId}`;
});
parcelRegister("bLi0f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3f9241b4c0385fe$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b3f9241b4c0385fe$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        discoverAutomationMenuItemLabel: {
            "id": "software-releases-automation-menu.menu-contents.deep-links.discover-automation-menu-item-label",
            "defaultMessage": "Discover automation"
        },
        manageAutomationMenuItemLabel: {
            "id": "software-releases-automation-menu.menu-contents.deep-links.manage-automation-menu-item-label",
            "defaultMessage": "Manage automation"
        },
        createAutomationMenuItemLabel: {
            "id": "software-releases-automation-menu.menu-contents.deep-links.create-automation-menu-item-label",
            "defaultMessage": "Create automation"
        },
        auditLogAutomationMenuItemLabel: {
            "id": "software-releases-automation-menu.menu-contents.deep-links.audit-log-automation-menu-item-label",
            "defaultMessage": "Audit log"
        }
    });
});
parcelRegister("jNWbA", function(module, exports) {
    $parcel$export(module.exports, "AutomationMenuTemplateRules", ()=>$1ca33d1f3bafacb7$export$35643f531510af9e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $5LWLA;
    var $8RBk4;
    var $8sgpE;
    var $29YN9;
    var $3Z96c;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $jTNwC;
    var $j1oLQ;
    var $6Wfoj;
    var $2X0gE;
    const $1ca33d1f3bafacb7$var$jiraIssuesIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8sgpE"))))), {
        size: "medium",
        label: ""
    });
    const $1ca33d1f3bafacb7$var$slackIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
        size: "medium",
        glyph: (0, (0, parcelRequire("j1oLQ")).SlackGlyph),
        label: ""
    });
    const $1ca33d1f3bafacb7$var$launchDarklyGliph = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
        size: "medium",
        glyph: (0, (0, parcelRequire("jTNwC")).LaunchDarklyGlyph),
        label: ""
    });
    const $1ca33d1f3bafacb7$var$ActionAndTriggerIcons = ({ trigger: trigger })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$IconShadow, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("29YN9")).JiraIcon), {
            size: "small",
            appearance: "brand"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$IconShadow, null, trigger));
    const $1ca33d1f3bafacb7$export$35643f531510af9e = (props)=>{
        const { isSimplifiedProject: isSimplifiedProject, projectKey: projectKey, projectType: projectType } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            shouldTitleWrap: true,
            href: (0, (0, parcelRequire("6Wfoj")).buildTemplateRuleAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }, 'software_template_14'),
            target: "_blank",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$ActionAndTriggerIcons, {
                trigger: $1ca33d1f3bafacb7$var$jiraIssuesIcon
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'templateRuleAddVersionToInProgressIssue')
        }, formatMessage((0, (0, parcelRequire("2X0gE")).default).templateRuleAddIssueToVersionOnVersionCreate)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            shouldTitleWrap: true,
            href: (0, (0, parcelRequire("6Wfoj")).buildTemplateRuleAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }, 'devops_template_6'),
            target: "_blank",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$ActionAndTriggerIcons, {
                trigger: $1ca33d1f3bafacb7$var$launchDarklyGliph
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'templateRuleCreateLaunchDarklyFlag')
        }, formatMessage((0, (0, parcelRequire("2X0gE")).default).templateRuleCreateLaunchDarklyFlagOnVersionCreate)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            shouldTitleWrap: true,
            href: (0, (0, parcelRequire("6Wfoj")).buildTemplateRuleAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }, 'software_template_12'),
            target: "_blank",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$ActionAndTriggerIcons, {
                trigger: $1ca33d1f3bafacb7$var$slackIcon
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'templateSendSlackMessageOnVersionRelease')
        }, formatMessage((0, (0, parcelRequire("2X0gE")).default).templateRuleSendSlackMessageOnVersionRelease)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            shouldTitleWrap: true,
            href: (0, (0, parcelRequire("6Wfoj")).buildTemplateRuleAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }, 'software_template_13'),
            target: "_blank",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$ActionAndTriggerIcons, {
                trigger: $1ca33d1f3bafacb7$var$slackIcon
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'templateSendSlackMessageOnVersionUnRelease')
        }, formatMessage((0, (0, parcelRequire("2X0gE")).default).templateRuleSendSlackMessageOnVersionUnRelease)), (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$DiscoverAutomationLink, {
            href: (0, (0, parcelRequire("6Wfoj")).buildDiscoverAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'discoverAutomationLink')
        }, formatMessage((0, (0, parcelRequire("2X0gE")).default).discoverMoreAutomationMenuItemLabel)));
    };
    const $1ca33d1f3bafacb7$var$IconShadow = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3izwfg _1bsbzwfg _2rko1y44 _16qszucj _1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $1ca33d1f3bafacb7$var$DiscoverAutomationLink = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41nnp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jTNwC", function(module, exports) {
    $parcel$export(module.exports, "LaunchDarklyGlyph", ()=>$b864cf68c0dd1dc4$export$f1f691d73572fca1);
    var $5uXOq = parcelRequire("5uXOq");
    const $b864cf68c0dd1dc4$export$f1f691d73572fca1 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            transform: "matrix(0.11111112 0 0 0.11111112 -0 0.058888756)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M109.8 214.94C 107.997055 214.91039 106.35804 213.88696 105.54 212.28C 104.73658 210.72453 104.908226 208.84428 105.98 207.45999L105.98 207.45999L156.47 137.93L68 174.11C 67.40301 174.38016 66.75528 174.51993 66.1 174.52C 64.01144 174.4985 62.179775 173.12071 61.579998 171.12001C 60.985783 169.13066 61.80725 166.99075 63.579998 165.91L63.579998 165.91L141.33 120L4.41 112.13C 1.9438841 111.9687 0.026099205 109.92138 0.026099205 107.45C 0.026099205 104.978615 1.9438841 102.9313 4.41 102.77L4.41 102.77L141.41 94.899994L63.61 49C 61.861492 47.905083 61.065918 45.772614 61.670002 43.8C 62.260277 41.79695 64.09185 40.41616 66.18 40.399998C 66.83458 40.396626 67.482346 40.532997 68.08 40.8L68.08 40.8L156.5 77L106 7.48C 104.93831 6.087954 104.76732 4.210975 105.56 2.65C 106.37893 1.0358694 108.03006 0.013560295 109.84 0C 111.078804 0.0081067085 112.26174 0.516624 113.119995 1.41L113.119995 1.41L213.77 102.05C 216.74506 105.03536 216.74506 109.86465 213.77 112.850006L213.77 112.850006L113.08 213.53C 112.22175 214.42337 111.03882 214.93188 109.8 214.94z",
            stroke: "none",
            fill: "#282828",
            fillRule: "nonzero"
        })));
});
parcelRegister("j1oLQ", function(module, exports) {
    $parcel$export(module.exports, "SlackGlyph", ()=>$0a27994cdc8eb4fb$export$cbfabcc4325ad3ff);
    var $5uXOq = parcelRequire("5uXOq");
    const $0a27994cdc8eb4fb$export$cbfabcc4325ad3ff = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
            fill: "white",
            fillOpacity: "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M6.78559 14.3429C6.78559 15.3857 5.94273 16.2286 4.89987 16.2286C3.85702 16.2286 3.01416 15.3857 3.01416 14.3429C3.01416 13.3 3.85702 12.4572 4.89987 12.4572H6.78559V14.3429ZM7.72845 14.3429C7.72845 13.3 8.5713 12.4572 9.61416 12.4572C10.657 12.4572 11.4999 13.3 11.4999 14.3429V19.0572C11.4999 20.1 10.657 20.9429 9.61416 20.9429C8.5713 20.9429 7.72845 20.1 7.72845 19.0572V14.3429Z",
            fill: "#E01E5A"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.61429 6.77143C8.57143 6.77143 7.72857 5.92857 7.72857 4.88571C7.72857 3.84286 8.57143 3 9.61429 3C10.6571 3 11.5 3.84286 11.5 4.88571V6.77143H9.61429ZM9.61429 7.72857C10.6571 7.72857 11.5 8.57143 11.5 9.61429C11.5 10.6571 10.6571 11.5 9.61429 11.5H4.88571C3.84286 11.5 3 10.6571 3 9.61429C3 8.57143 3.84286 7.72857 4.88571 7.72857H9.61429Z",
            fill: "#36C5F0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M17.1713 9.61429C17.1713 8.57143 18.0142 7.72857 19.057 7.72857C20.0999 7.72857 20.9427 8.57143 20.9427 9.61429C20.9427 10.6571 20.0999 11.5 19.057 11.5H17.1713V9.61429ZM16.2285 9.61429C16.2285 10.6571 15.3856 11.5 14.3427 11.5C13.2999 11.5 12.457 10.6571 12.457 9.61429V4.88571C12.457 3.84286 13.2999 3 14.3427 3C15.3856 3 16.2285 3.84286 16.2285 4.88571V9.61429Z",
            fill: "#2EB67D"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14.3427 17.1714C15.3856 17.1714 16.2285 18.0143 16.2285 19.0572C16.2285 20.1 15.3856 20.9429 14.3427 20.9429C13.2999 20.9429 12.457 20.1 12.457 19.0572V17.1714H14.3427ZM14.3427 16.2286C13.2999 16.2286 12.457 15.3857 12.457 14.3429C12.457 13.3 13.2999 12.4572 14.3427 12.4572H19.0713C20.1142 12.4572 20.957 13.3 20.957 14.3429C20.957 15.3857 20.1142 16.2286 19.0713 16.2286H14.3427Z",
            fill: "#ECB22E"
        }));
});
parcelRegister("2X0gE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a203593cf7e2d1db$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a203593cf7e2d1db$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        discoverMoreAutomationMenuItemLabel: {
            "id": "software-releases-automation-menu.menu-contents.template-rules.discover-more-automation-menu-item-label",
            "defaultMessage": "Discover more automation"
        },
        templateRuleAddIssueToVersionOnVersionCreate: {
            "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-add-issue-to-version-on-version-create",
            "defaultMessage": "When a version is created \u2192 then add all In Progress issues without a fix version"
        },
        templateRuleCreateLaunchDarklyFlagOnVersionCreate: {
            "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-create-launch-darkly-flag-on-version-create",
            "defaultMessage": "When a version is created \u2192 then create a LaunchDarkly flag"
        },
        templateRuleSendSlackMessageOnVersionRelease: {
            "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-send-slack-message-on-version-release",
            "defaultMessage": "When a version is released \u2192 then send a Slack message"
        },
        templateRuleSendSlackMessageOnVersionUnRelease: {
            "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-send-slack-message-on-version-un-release",
            "defaultMessage": "When a version is unreleased \u2192 then send a Slack message"
        }
    });
});
parcelRegister("1OWKd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55aaaae2e5159e07$export$2e2bcd8739ae039);
    var $7VHMR;
    var $55aaaae2e5159e07$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        disabledAutomationMenuButtonTooltipMessage: {
            "id": "software-releases-automation-menu.disabled-automation-menu-button-tooltip-message",
            "defaultMessage": "You need to be a project admin to configure automation"
        },
        automationMenuTitle: {
            "id": "software-releases-automation-menu.automation-menu-title",
            "defaultMessage": "Automation"
        },
        automationMenuSubTitle: {
            "id": "software-releases-automation-menu.automation-menu-sub-title",
            "defaultMessage": "Setup your release automations from these templates, or create a new one of your own."
        }
    });
});
parcelRegister("7AEEN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bVPvc").then(()=>parcelRequire('4OeKH'));
});
parcelRegister("dkXFD", function(module, exports) {
    $parcel$export(module.exports, "ManageWarningsModal", ()=>$6a565e41de1f08b9$export$6e3078b1666e4828);
    var $cLMku;
    var $9tBnW;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $2rqOp;
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $dC5iT;
    var $8CUq3;
    var $92Z2l;
    var $9fuVs;
    var $koVbs;
    var $8zOmE;
    var $idOin;
    var $36AXO;
    var $gd85W;
    const $6a565e41de1f08b9$export$6e3078b1666e4828 = ({ setModalClosed: setModalClosed, jiraVersion: jiraVersion })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("9tBnW")).default), jiraVersion);
        const { warningConfig: warningConfig, __id: versionRecordId } = version;
        const { openPullRequest: openPullRequest, failingBuild: failingBuild, unreviewedCode: unreviewedCode, openReview: openReview } = warningConfig;
        const [updatedVersionWarningConfig, setUpdatedVersionWarningConfig] = (0, $5uXOq.useState)((0, (0, parcelRequire("gd85W")).convertStatusToBoolean)(warningConfig));
        const removeDisabledWarningFilters = (0, (0, parcelRequire("gd85W")).useRemoveDisabledWarningFilters)(updatedVersionWarningConfig);
        const [isSaveFailed, setIsSaveFailed] = (0, $5uXOq.useState)(false);
        const [updateVersionWarningConfig, isWarningConfigUpdating] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("cLMku")).default));
        const jiraProjectId = version.project.id;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            testId: "software-releases-manage-warnings.ui.modal-dialog"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, (0, parcelRequire("idOin")).default).manageWarnings))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($6a565e41de1f08b9$var$WarningDescription, null, formatMessage((0, (0, parcelRequire("idOin")).default).warningDescription)), isSaveFailed && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6a565e41de1f08b9$var$errorSectionMessageContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "error"
        }, formatMessage((0, (0, parcelRequire("idOin")).default).updateWarningConfigFailed))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "warning"
        }, formatMessage((0, (0, parcelRequire("idOin")).default).warningsSetForAllVersionsInThisProject)), openPullRequest !== 'NOT_APPLICABLE' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("36AXO")).Toggle), {
            testId: "software-releases-manage-warnings.ui.open-pull-request",
            isDisabled: isWarningConfigUpdating,
            initialValue: openPullRequest === 'ENABLED',
            onChange: (_, analyticsEvent)=>setUpdatedVersionWarningConfig((prev)=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                        warningType: 'openPullRequest',
                        isEnabled: !prev.isOpenPullRequestEnabled
                    });
                    return {
                        ...prev,
                        isOpenPullRequestEnabled: !prev.isOpenPullRequestEnabled
                    };
                }),
            headingTranslated: formatMessage((0, (0, parcelRequire("idOin")).default).openPullRequests),
            descriptionTranslated: formatMessage((0, (0, parcelRequire("idOin")).default).openPullRequestsDescription)
        }), openReview !== 'NOT_APPLICABLE' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("36AXO")).Toggle), {
            testId: "software-releases-manage-warnings.ui.open-review",
            isDisabled: isWarningConfigUpdating,
            initialValue: openReview === 'ENABLED',
            onChange: (_, analyticsEvent)=>setUpdatedVersionWarningConfig((prev)=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                        warningType: 'openReview',
                        isEnabled: !prev.isOpenReviewEnabled
                    });
                    return {
                        ...prev,
                        isOpenReviewEnabled: !prev.isOpenReviewEnabled
                    };
                }),
            headingTranslated: formatMessage((0, (0, parcelRequire("idOin")).default).openReviews),
            descriptionTranslated: formatMessage((0, (0, parcelRequire("idOin")).default).openReviewsDescription)
        }), unreviewedCode !== 'NOT_APPLICABLE' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("36AXO")).Toggle), {
            testId: "software-releases-manage-warnings.ui.unreviewed-code",
            isDisabled: isWarningConfigUpdating,
            initialValue: unreviewedCode === 'ENABLED',
            onChange: (_, analyticsEvent)=>{
                setUpdatedVersionWarningConfig((prev)=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                        warningType: 'unreviewedCode',
                        isEnabled: !prev.isUnreviewedCodeEnabled
                    });
                    return {
                        ...prev,
                        isUnreviewedCodeEnabled: !prev.isUnreviewedCodeEnabled
                    };
                });
            },
            headingTranslated: formatMessage((0, (0, parcelRequire("idOin")).default).unreviewedCode),
            descriptionTranslated: formatMessage((0, (0, parcelRequire("idOin")).default).unreviewedCodeDescription)
        }), failingBuild !== 'NOT_APPLICABLE' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("36AXO")).Toggle), {
            testId: "software-releases-manage-warnings.ui.failing-build",
            isDisabled: isWarningConfigUpdating,
            initialValue: failingBuild === 'ENABLED',
            onChange: (_, analyticsEvent)=>{
                setUpdatedVersionWarningConfig((prev)=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                        warningType: 'failingBuild',
                        isEnabled: !prev.isFailingBuildEnabled
                    });
                    return {
                        ...prev,
                        isFailingBuildEnabled: !prev.isFailingBuildEnabled
                    };
                });
            },
            headingTranslated: formatMessage((0, (0, parcelRequire("idOin")).default).failingBuilds),
            descriptionTranslated: formatMessage((0, (0, parcelRequire("idOin")).default).failingBuildsDescription)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            appearance: "primary",
            onClick: ()=>{
                updateVersionWarningConfig({
                    variables: {
                        input: {
                            jiraProjectId: jiraProjectId,
                            updatedVersionWarningConfig: updatedVersionWarningConfig
                        },
                        versionId: version.id
                    },
                    onCompleted: ({ jira: { updateVersionWarningConfig: { success: success } } })=>{
                        if (success) {
                            removeDisabledWarningFilters();
                            setModalClosed();
                            return;
                        }
                        setIsSaveFailed(true);
                    },
                    onError: ()=>{
                        setIsSaveFailed(true);
                    },
                    updater: (store)=>{
                        const versionRecord = store.get(versionRecordId);
                        if (versionRecord == null) return;
                        const existingWarningConfigRecord = versionRecord.getLinkedRecord('warningConfig');
                        if (existingWarningConfigRecord == null) return;
                        const newValues = (0, (0, parcelRequire("gd85W")).getNewWarningConfigValues)(updatedVersionWarningConfig, {
                            openPullRequest: openPullRequest,
                            openReview: openReview,
                            failingBuild: failingBuild,
                            unreviewedCode: unreviewedCode
                        });
                        existingWarningConfigRecord.setValue(newValues.openPullRequest, 'openPullRequest');
                        existingWarningConfigRecord.setValue(newValues.openReview, 'openReview');
                        existingWarningConfigRecord.setValue(newValues.unreviewedCode, 'unreviewedCode');
                        existingWarningConfigRecord.setValue(newValues.failingBuild, 'failingBuild');
                        versionRecord.setLinkedRecord(existingWarningConfigRecord, 'warningConfig');
                    }
                });
            },
            isLoading: isWarningConfigUpdating
        }, formatMessage((0, (0, parcelRequire("idOin")).default).modalSave)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            testId: "software-releases-manage-warnings.ui.cancel-manage-warnings",
            onClick: ()=>setModalClosed(),
            isDisabled: isWarningConfigUpdating
        }, formatMessage((0, (0, parcelRequire("idOin")).default).modalCancel)))));
    };
    const $6a565e41de1f08b9$var$errorSectionMessageContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.100'
    });
    const $6a565e41de1f08b9$var$WarningDescription = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyr1ejb _syazaj1x",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cLMku", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7aa36bf826ad7c2c$export$2e2bcd8739ae039);
    const $7aa36bf826ad7c2c$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "versionId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "versionId"
            }
        ], v4 = [
            {
                "kind": "ScalarField",
                "name": "totalCount"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionWarningConfigPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionWarningConfig",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "args": v3,
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "issueProgressDetails_versionProgress"
                                                    }
                                                ],
                                                "type": "JiraVersion"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionWarningConfigPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionWarningConfig",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "args": v3,
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersionWarningConfig",
                                                        "kind": "LinkedField",
                                                        "name": "warningConfig",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "failingBuild"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "openPullRequest"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "openReview"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "unreviewedCode"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "alias": "doneIssuesRedesignTemp",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "filters",
                                                                "value": {
                                                                    "statusCategories": [
                                                                        "DONE"
                                                                    ]
                                                                }
                                                            }
                                                        ],
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": v4,
                                                        "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                                                    },
                                                    {
                                                        "alias": "inProgressIssuesRedesignTemp",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "filters",
                                                                "value": {
                                                                    "statusCategories": [
                                                                        "IN_PROGRESS"
                                                                    ]
                                                                }
                                                            }
                                                        ],
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": v4,
                                                        "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                                                    },
                                                    {
                                                        "alias": "todoIssuesRedesignTemp",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "filters",
                                                                "value": {
                                                                    "statusCategories": [
                                                                        "TODO"
                                                                    ]
                                                                }
                                                            }
                                                        ],
                                                        "concreteType": "JiraIssueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issues",
                                                        "plural": false,
                                                        "selections": v4,
                                                        "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "warningsCount"
                                                    }
                                                ],
                                                "type": "JiraVersion"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    }
                                                ],
                                                "type": "Node",
                                                "abstractKey": "__isNode"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "bb3640928c5b9aa6b7fe35b78c841cf3c2e853010ab4e47e56966cc8e62de2ce",
                "metadata": {},
                "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $7aa36bf826ad7c2c$var$node.hash = "c4e2323c95f8ee01a7aae0a690ba4f89";
    var $7aa36bf826ad7c2c$export$2e2bcd8739ae039 = $7aa36bf826ad7c2c$var$node;
});
parcelRegister("9tBnW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1a037bbb24769f7$export$2e2bcd8739ae039);
    const $b1a037bbb24769f7$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ui_softwareReleasesManageWarnings_ManageWarningsModal",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "project.id"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "project"
                },
                v0,
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraVersionWarningConfig",
                        "kind": "LinkedField",
                        "name": "warningConfig",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "openPullRequest"
                                },
                                "action": "THROW",
                                "path": "warningConfig.openPullRequest"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "openReview"
                                },
                                "action": "THROW",
                                "path": "warningConfig.openReview"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "unreviewedCode"
                                },
                                "action": "THROW",
                                "path": "warningConfig.unreviewedCode"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "failingBuild"
                                },
                                "action": "THROW",
                                "path": "warningConfig.failingBuild"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "warningConfig"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__id"
                        }
                    ]
                }
            ],
            "type": "JiraVersion"
        };
    }();
    $b1a037bbb24769f7$var$node.hash = "e5eb838f9801c770bc5137a984a02776";
    var $b1a037bbb24769f7$export$2e2bcd8739ae039 = $b1a037bbb24769f7$var$node;
});
parcelRegister("idOin", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2622a8dd08ba55d1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2622a8dd08ba55d1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        manageWarnings: {
            "id": "software-releases-manage-warnings.manage-warnings",
            "defaultMessage": "Manage warnings"
        },
        modalSave: {
            "id": "software-releases-manage-warnings.modal-save",
            "defaultMessage": "Save"
        },
        modalCancel: {
            "id": "software-releases-manage-warnings.modal-cancel",
            "defaultMessage": "Cancel"
        },
        warningsSetForAllVersionsInThisProject: {
            "id": "software-releases-manage-warnings.warnings-set-for-all-versions-in-this-project",
            "defaultMessage": "These warning settings affect all existing and future versions in this project."
        },
        updateWarningConfigFailed: {
            "id": "software-releases-manage-warnings.update-warning-config-failed",
            "defaultMessage": "Something went wrong. Please try to save again."
        },
        openPullRequests: {
            "id": "software-releases-manage-warnings.open-pull-requests",
            "defaultMessage": "Open pull requests"
        },
        openPullRequestsDescription: {
            "id": "software-releases-manage-warnings.open-pull-requests-description",
            "defaultMessage": "These issues have been marked complete but have open pull requests."
        },
        openReviews: {
            "id": "software-releases-manage-warnings.open-reviews",
            "defaultMessage": "Open reviews"
        },
        openReviewsDescription: {
            "id": "software-releases-manage-warnings.open-reviews-description",
            "defaultMessage": "These issues have been marked complete but have open reviews."
        },
        unreviewedCode: {
            "id": "software-releases-manage-warnings.unreviewed-code",
            "defaultMessage": "Unreviewed code"
        },
        unreviewedCodeDescription: {
            "id": "software-releases-manage-warnings.unreviewed-code-description",
            "defaultMessage": "These issues have been marked complete but the commits are not part of a pull request or review."
        },
        failingBuilds: {
            "id": "software-releases-manage-warnings.failing-builds",
            "defaultMessage": "Failing builds"
        },
        failingBuildsDescription: {
            "id": "software-releases-manage-warnings.failing-builds-description",
            "defaultMessage": "These issues have been marked complete but have failing builds."
        },
        warningDescription: {
            "id": "software-releases-manage-warnings.warning-description",
            "defaultMessage": "Warnings will be displayed when the status of a Jira issue doesn't accurately reflect related development activity."
        }
    });
});
parcelRegister("36AXO", function(module, exports) {
    $parcel$export(module.exports, "Toggle", ()=>$e28ba2f9418c9d1c$export$bea8ebba691c5813);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $l1N8i;
    var $dC5iT;
    var $8CUq3;
    var $dTlW6;
    const $e28ba2f9418c9d1c$export$bea8ebba691c5813 = ({ initialValue: initialValue, headingTranslated: headingTranslated, descriptionTranslated: descriptionTranslated, onChange: onChange, testId: testId, isDisabled: isDisabled })=>(0, ($parcel$interopDefault($5uXOq))).createElement($e28ba2f9418c9d1c$var$WarningCategoryContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall"
        }, headingTranslated), (0, ($parcel$interopDefault($5uXOq))).createElement($e28ba2f9418c9d1c$var$Description, null, descriptionTranslated)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e28ba2f9418c9d1c$var$toggleContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dTlW6")).default), {
            testId: testId,
            defaultChecked: initialValue,
            onChange: onChange,
            isDisabled: isDisabled
        })));
    const $e28ba2f9418c9d1c$var$WarningCategoryContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq _1bah1yb4 _19pkpxbi",
                __cmplp.className
            ])
        });
    });
    const $e28ba2f9418c9d1c$var$toggleContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.200'
    });
    const $e28ba2f9418c9d1c$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syazaj1x",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dTlW6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3db77843cf29c460$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $9KnKW;
    var $7fA4P;
    var $aFYTH;
    var $lahQ6;
    var $hzG2v;
    const $3db77843cf29c460$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $3db77843cf29c460$var$analyticsAttributes = {
        componentName: 'toggle',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $3db77843cf29c460$var$iconSizeMap = {
        regular: 'small',
        large: 'medium'
    };
    const $3db77843cf29c460$var$Toggle = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)((props, ref)=>{
        const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
        const isControlled = typeof isChecked === 'undefined';
        const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
        const handleBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnBlur,
            action: 'blur',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const handleFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedFocus,
            action: 'focus',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const handleChange = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event, analyticsEvent)=>{
                if (isControlled) setChecked((checked)=>!checked);
                return providedChange(event, analyticsEvent);
            },
            action: 'change',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const shouldChecked = isControlled ? checked : isChecked;
        const controlProps = {
            'data-checked': shouldChecked ? shouldChecked : undefined,
            'data-disabled': isDisabled ? isDisabled : undefined,
            'data-size': size,
            'data-testid': testId ? testId : undefined
        };
        const toggleStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hzG2v")).getStyles)(size), [
            size
        ]);
        const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
        const labelId = (0, (0, parcelRequire("9KnKW")).useId)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            ...controlProps,
            css: toggleStyles
        }, label ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: labelId,
            hidden: true
        }, label) : null, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: ref,
            checked: shouldChecked,
            disabled: isDisabled,
            id: id,
            name: name,
            onBlur: handleBlur,
            onChange: handleChange,
            onFocus: handleFocus,
            type: "checkbox",
            value: value,
            "data-testid": testId && `${testId}--input`,
            "aria-labelledby": label ? labelId : undefined,
            "aria-describedby": descriptionId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lahQ6")).default), {
            size: size,
            isHidden: !shouldChecked,
            position: "left"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("7fA4P"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: legacyIconSize,
            testId: testId && `${testId}--toggle-check-icon`
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lahQ6")).default), {
            size: size,
            isHidden: shouldChecked,
            position: "right"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("aFYTH"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: legacyIconSize,
            testId: testId && `${testId}--toggle-cross-icon`
        }))));
    }));
    $3db77843cf29c460$var$Toggle.displayName = 'Toggle';
    var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;
});
parcelRegister("7fA4P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));
    var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
    function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>$5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
            LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
        }, props));
    $5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
    var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;
});
parcelRegister("f22iM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $af18d40ba5b744b4$var$_UNSAFE_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>$af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
            type: 'utility'
        }, props));
    $af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;
});
parcelRegister("4DXCl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
    function $36190cbd288fec69$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36190cbd288fec69$var$EditorDoneIcon = (props)=>$36190cbd288fec69$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
        }, props, {
            newIcon: $36190cbd288fec69$var$_checkMark.default
        }));
    $36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
    var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;
});
parcelRegister("aFYTH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c5cf8a572bea882$var$_react = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7c5cf8a572bea882$var$_cross = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("bjGSs")));
    var $7c5cf8a572bea882$var$_close = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("2C7j9")));
    function $7c5cf8a572bea882$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c5cf8a572bea882$var$CrossIcon = (props)=>$7c5cf8a572bea882$var$_react.default.createElement($7c5cf8a572bea882$var$_cross.default, Object.assign({
            LEGACY_fallbackIcon: $7c5cf8a572bea882$var$_close.default
        }, props));
    $7c5cf8a572bea882$var$CrossIcon.Name = 'CrossIconMigration';
    var $7c5cf8a572bea882$var$_default = module.exports.default = $7c5cf8a572bea882$var$CrossIcon;
});
parcelRegister("2C7j9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
    function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>$1e74cc92a54dd799$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
        }, props, {
            newIcon: $1e74cc92a54dd799$var$_close.default
        }));
    $1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
    var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;
});
parcelRegister("lahQ6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca1cdaa1eb34599d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    const $ca1cdaa1eb34599d$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'opacity 0.2s ease',
        position: 'absolute',
        insetBlockStart: 'space.025'
    });
    const $ca1cdaa1eb34599d$var$iconContainerRegularStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '16px',
        height: '16px'
    });
    const $ca1cdaa1eb34599d$var$iconContainerLargeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '20px',
        height: '20px'
    });
    const $ca1cdaa1eb34599d$var$hiddenStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        opacity: 0
    });
    const $ca1cdaa1eb34599d$var$leftStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineStart: '3px'
    });
    const $ca1cdaa1eb34599d$var$rightStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineEnd: '3px'
    });
    const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: [
                $ca1cdaa1eb34599d$var$iconContainerStyles,
                isHidden && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$hiddenStyles,
                size === 'regular' && $ca1cdaa1eb34599d$var$iconContainerRegularStyles,
                size === 'large' && $ca1cdaa1eb34599d$var$iconContainerLargeStyles,
                position === 'left' && $ca1cdaa1eb34599d$var$leftStyles,
                position === 'right' && $ca1cdaa1eb34599d$var$rightStyles
            ]
        }, children);
    };
    var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;
});
parcelRegister("hzG2v", function(module, exports) {
    $parcel$export(module.exports, "getStyles", ()=>$3af6a5b9114f4fd0$export$ffd58b7f6f099a57);
    var $f8Sb3;
    var $VSDnB;
    var $k5uoT;
    var $3VjLl;
    const $3af6a5b9114f4fd0$var$globalGridSize = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $3af6a5b9114f4fd0$var$dimensions = {
        regular: {
            height: $3af6a5b9114f4fd0$var$globalGridSize * 2,
            width: $3af6a5b9114f4fd0$var$globalGridSize * 4
        },
        large: {
            height: $3af6a5b9114f4fd0$var$globalGridSize * 2 + $3af6a5b9114f4fd0$var$globalGridSize / 2,
            width: $3af6a5b9114f4fd0$var$globalGridSize * 5
        }
    };
    const $3af6a5b9114f4fd0$var$getHeight = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].height;
    const $3af6a5b9114f4fd0$var$getWidth = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].width;
    const $3af6a5b9114f4fd0$var$borderWidth = 2;
    const $3af6a5b9114f4fd0$var$paddingUnitless = $3af6a5b9114f4fd0$var$globalGridSize / 4;
    const $3af6a5b9114f4fd0$var$transition = 'transform 0.2s ease';
    const $3af6a5b9114f4fd0$export$ffd58b7f6f099a57 = (size)=>{
        const colors = (0, (0, parcelRequire("3VjLl")).getColors)();
        return (0, (0, parcelRequire("f8Sb3")).css)({
            boxSizing: 'content-box',
            display: 'inline-block',
            padding: $3af6a5b9114f4fd0$var$borderWidth,
            margin: $3af6a5b9114f4fd0$var$borderWidth,
            backgroundClip: 'content-box',
            backgroundColor: colors.backgroundColorUnchecked,
            borderRadius: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            })}px`,
            border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid transparent`,
            height: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            })}px`,
            position: 'relative',
            transition: `${$3af6a5b9114f4fd0$var$transition}`,
            width: `${$3af6a5b9114f4fd0$var$getWidth({
                size: size
            })}px`,
            '&[data-checked]': {
                backgroundColor: colors.backgroundColorChecked,
                color: colors.iconColorChecked
            },
            '&[data-disabled]:not([data-checked])': {
                backgroundColor: colors.backgroundColorUncheckedDisabled
            },
            '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
                backgroundColor: colors.backgroundColorCheckedDisabled
            },
            '&:focus-within': {
                border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid ${colors.borderColorFocus}`
            },
            '&:hover': {
                backgroundColor: colors.backgroundColorUncheckedHover,
                cursor: 'pointer'
            },
            '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
                cursor: 'not-allowed'
            },
            '&[data-checked]:hover': {
                backgroundColor: colors.backgroundColorCheckedHover
            },
            '&:not([data-checked]):hover': {
                backgroundColor: colors.backgroundColorUncheckedHover
            },
            '&[data-disabled]:not([data-checked]):hover': {
                backgroundColor: colors.backgroundColorCheckedDisabled
            },
            color: colors.iconColorUnchecked,
            '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
                color: colors.iconColorDisabled
            },
            'input[type="checkbox"]': {
                opacity: 0,
                margin: 0,
                padding: 0,
                border: 'none',
                '&:focus': {
                    outline: 'none !important'
                }
            },
            '::before': {
                backgroundColor: colors.handleBackgroundColor,
                borderRadius: "var(--ds-border-radius-circle, 50%)",
                content: '""',
                position: 'absolute',
                transform: 'initial',
                transition: $3af6a5b9114f4fd0$var$transition,
                insetBlockEnd: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`,
                height: `${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
                width: `${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
                insetInlineStart: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`
            },
            '&[data-checked]::before': {
                backgroundColor: colors.handleBackgroundColorChecked,
                transform: `translateX(${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                })}px)`
            },
            '&[data-disabled]::before': {
                backgroundColor: colors.handleBackgroundColorDisabled,
                zIndex: 1
            },
            ...size === 'large' && !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && {
                '> span > span': {
                    height: '20px',
                    width: '20px'
                }
            },
            '@media screen and (forced-colors: active)': {
                '::before': {
                    filter: 'grayscale(100%) invert(1)'
                },
                '&:focus-within': {
                    outline: '1px solid'
                }
            }
        });
    };
});
parcelRegister("3VjLl", function(module, exports) {
    $parcel$export(module.exports, "getColors", ()=>$7761f9acd89472cc$export$6cee60e8aa85e528);
    const $7761f9acd89472cc$var$colorMap = {
        backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
        backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`,
        backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`,
        backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        borderColorFocus: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        iconColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        iconColorDisabled: `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    };
    const $7761f9acd89472cc$export$6cee60e8aa85e528 = ()=>$7761f9acd89472cc$var$colorMap;
});
parcelRegister("gd85W", function(module, exports) {
    $parcel$export(module.exports, "convertStatusToBoolean", ()=>$7aa02e643017c449$export$6a8a12d4b311feca);
    $parcel$export(module.exports, "getNewWarningConfigValues", ()=>$7aa02e643017c449$export$12511548bf3cb9c8);
    $parcel$export(module.exports, "useRemoveDisabledWarningFilters", ()=>$7aa02e643017c449$export$dfbaab0bbdd97fab);
    var $1YU2V;
    var $jPgXx;
    const $7aa02e643017c449$var$booleanToState = (value)=>value ? 'ENABLED' : 'DISABLED';
    const $7aa02e643017c449$export$6a8a12d4b311feca = ({ openPullRequest: openPullRequest, openReview: openReview, unreviewedCode: unreviewedCode, failingBuild: failingBuild })=>({
            isOpenPullRequestEnabled: openPullRequest !== 'DISABLED',
            isOpenReviewEnabled: openReview !== 'DISABLED',
            isUnreviewedCodeEnabled: unreviewedCode !== 'DISABLED',
            isFailingBuildEnabled: failingBuild !== 'DISABLED'
        });
    const $7aa02e643017c449$export$12511548bf3cb9c8 = (updatedBooleanValues, originalValues)=>({
            openPullRequest: originalValues.openPullRequest === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $7aa02e643017c449$var$booleanToState(updatedBooleanValues.isOpenPullRequestEnabled ?? true),
            openReview: originalValues.openReview === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $7aa02e643017c449$var$booleanToState(updatedBooleanValues.isOpenReviewEnabled ?? true),
            unreviewedCode: originalValues.unreviewedCode === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $7aa02e643017c449$var$booleanToState(updatedBooleanValues.isUnreviewedCodeEnabled ?? true),
            failingBuild: originalValues.failingBuild === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $7aa02e643017c449$var$booleanToState(updatedBooleanValues.isFailingBuildEnabled ?? true)
        });
    const $7aa02e643017c449$export$dfbaab0bbdd97fab = ({ isFailingBuildEnabled: isFailingBuildEnabled, isOpenPullRequestEnabled: isOpenPullRequestEnabled, isOpenReviewEnabled: isOpenReviewEnabled, isUnreviewedCodeEnabled: isUnreviewedCodeEnabled })=>{
        const { parsedQueryParams: parsedQueryParams, setWarningsFilterParam: setWarningsFilterParam } = (0, (0, parcelRequire("1YU2V")).useFilterSortingQueryParams)();
        return ()=>{
            const currentlySelectedWarningFilters = parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] ?? [];
            const result = [];
            if (isFailingBuildEnabled && currentlySelectedWarningFilters.includes('FAILING_BUILD')) result.push('FAILING_BUILD');
            if (isOpenPullRequestEnabled && currentlySelectedWarningFilters.includes('OPEN_PULL_REQUEST')) result.push('OPEN_PULL_REQUEST');
            if (isUnreviewedCodeEnabled && currentlySelectedWarningFilters.includes('UNREVIEWED_CODE')) result.push('UNREVIEWED_CODE');
            if (isOpenReviewEnabled && currentlySelectedWarningFilters.includes('OPEN_REVIEW')) result.push('OPEN_REVIEW');
            setWarningsFilterParam(result.filter((0, (0, parcelRequire("jPgXx")).isWarningsFilterValue)));
        };
    };
});
const $81f82fb3b4517b74$export$af5e668651a80140 = 'viewVersionDetailsConnectAppExtension';
parcelRegister("je2ff", function(module, exports) {
    $parcel$export(module.exports, "ConnectApps", ()=>$3c2c54251dd7c67a$export$4fff5b46ac23b268);
    var $hkhyi;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $7V5FW;
    var $93jKl;
    var $3bQtK;
    var $LJaTB;
    var $koVbs;
    var $9NzX0;
    var $8dG4L;
    const $3c2c54251dd7c67a$export$4fff5b46ac23b268 = ({ jiraVersion: jiraVersion })=>{
        const { connectAddonIframeData: connectAddonIframeData } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("hkhyi")).default), jiraVersion);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const hasConnectApps = connectAddonIframeData.length > 0;
        (0, (0, parcelRequire("8dG4L")).useConnectAppExtensionExperienceStart)(hasConnectApps);
        const { loading: loading, error: error } = (0, (0, parcelRequire("8dG4L")).useLoadConnectJs)(hasConnectApps);
        const onExpFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: (0, $81f82fb3b4517b74$export$af5e668651a80140),
            attributes: {
                errorMessage: error?.message ?? null,
                numConnectApps: connectAddonIframeData.length
            }
        });
        if (!hasConnectApps || loading) return null;
        if (error) {
            onExpFail('versionDetailsHeader', error);
            throw error;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: (0, $81f82fb3b4517b74$export$af5e668651a80140)
        }), connectAddonIframeData.filter((iframeData)=>iframeData != null && iframeData.options === null).map((iframeData)=>{
            if (iframeData == null) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("LJaTB")).FlagRenderer), {
                key: `error-flag-${iframeData.appName}`,
                flag: {
                    type: 'error',
                    title: formatMessage((0, (0, parcelRequire("9NzX0")).default).errorTitle, {
                        appName: iframeData.appName
                    }),
                    description: (0, (0, parcelRequire("9NzX0")).default).errorDescription
                }
            });
        }), connectAddonIframeData.filter((iframeData)=>iframeData != null && iframeData.options !== null).map((iframeData)=>{
            if (iframeData == null || iframeData.options == null) return null;
            const { appKey: appKey, moduleKey: moduleKey, options: options, appName: appName, location: location } = iframeData;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7V5FW")).EcosystemModuleAsync), {
                appKey: appKey,
                moduleKey: moduleKey,
                options: {
                    ...options,
                    hostOrigin: window.location.origin
                },
                appName: appName,
                key: `${appKey}-${moduleKey}`,
                location: location
            });
        }));
    };
});
parcelRegister("hkhyi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f41f920734248ae7$export$2e2bcd8739ae039);
    const $f41f920734248ae7$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "connectApps_softwareReleasesVersionDetail",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraVersionConnectAddonIframeData",
                    "kind": "LinkedField",
                    "name": "connectAddonIframeData",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "appKey"
                            },
                            "action": "THROW",
                            "path": "connectAddonIframeData.appKey"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "moduleKey"
                            },
                            "action": "THROW",
                            "path": "connectAddonIframeData.moduleKey"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "appName"
                            },
                            "action": "THROW",
                            "path": "connectAddonIframeData.appName"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "location"
                            },
                            "action": "THROW",
                            "path": "connectAddonIframeData.location"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "options"
                        }
                    ]
                },
                "action": "THROW",
                "path": "connectAddonIframeData"
            }
        ],
        "type": "JiraVersion"
    };
    $f41f920734248ae7$var$node.hash = "5b5aa6740e6a7342f336e876f3dce998";
    var $f41f920734248ae7$export$2e2bcd8739ae039 = $f41f920734248ae7$var$node;
});
parcelRegister("7V5FW", function(module, exports) {
    $parcel$export(module.exports, "EcosystemModuleAsync", ()=>$089ebe0f688adad3$export$75ae776ec6b96bba);
    $parcel$export(module.exports, "EcosystemTimeoutViewAsync", ()=>$089ebe0f688adad3$export$c800b42cc8eabb03);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $089ebe0f688adad3$var$EcosystemModule = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("2e8u5")), {
        ssr: true,
        moduleId: "./src/packages/connect-utils/connect-utils-async/src/index.tsx"
    });
    const $089ebe0f688adad3$var$EcosystemTimeoutView = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("3YOZG")), {
        ssr: true,
        moduleId: "./src/packages/connect-utils/connect-utils-async/src/common/ui/ecosystem-timeout-view/index.tsx"
    });
    const $089ebe0f688adad3$export$75ae776ec6b96bba = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "ecosystem-module-async",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($089ebe0f688adad3$var$EcosystemModule, props));
    const $089ebe0f688adad3$export$c800b42cc8eabb03 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "ecosystem-timeout-view-async",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($089ebe0f688adad3$var$EcosystemTimeoutView, props));
});
parcelRegister("2e8u5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g3nC3").then(()=>parcelRequire('djm2H'));
});
parcelRegister("3YOZG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8fpcr").then(()=>parcelRequire('cXmpj'));
});
parcelRegister("LJaTB", function(module, exports) {
    $parcel$export(module.exports, "FlagRenderer", ()=>$2de6889b93863972$export$7c38ebd1f7ca6a5a);
    var $hkhmi;
    var $34Vv8;
    const $2de6889b93863972$export$7c38ebd1f7ca6a5a = (0, (0, parcelRequire("34Vv8")).default)((0, (0, parcelRequire("hkhmi")).default));
});
parcelRegister("hkhmi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2971dd786c0add8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fHfPB;
    class $e2971dd786c0add8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { flagService: flagService, flag: flag } = this.props;
            if (flagService) this.flagId = flagService.showFlag(flag);
        }
        componentWillUnmount() {
            const { flagService: flagService } = this.props;
            if (flagService && this.flagId) flagService.dismissFlag((0, (0, parcelRequire("fHfPB")).dismissFlag)(this.flagId));
        }
        render() {
            return null;
        }
    }
});
parcelRegister("9NzX0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31f4628f575c2a4b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $31f4628f575c2a4b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorTitle: {
            "id": "software-releases-version-detail.header.connect-apps.error-title",
            "defaultMessage": "We weren't able to load {appName}."
        },
        errorDescription: {
            "id": "software-releases-version-detail.header.connect-apps.error-description",
            "defaultMessage": "Please refresh the page to try again."
        }
    });
});
parcelRegister("8dG4L", function(module, exports) {
    $parcel$export(module.exports, "useLoadConnectJs", ()=>$79b8f25ce2bada8b$export$ea4f866a08ef15ea);
    $parcel$export(module.exports, "useConnectAppExtensionExperienceStart", ()=>$79b8f25ce2bada8b$export$491da84e1e953d53);
    var $5uXOq = parcelRequire("5uXOq");
    var $hrlU6;
    var $kaHBi;
    var $koeKL;
    const $79b8f25ce2bada8b$export$ea4f866a08ef15ea = (shouldLoad)=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
        const [error, setError] = (0, $5uXOq.useState)(undefined);
        (0, $5uXOq.useEffect)(()=>{
            if (shouldLoad) (0, (0, parcelRequire("hrlU6")).withConnectHost)(()=>{
                setIsLoading(false);
            }).catch((e)=>{
                setIsLoading(false);
                setError(e);
            });
        }, [
            shouldLoad
        ]);
        return {
            loading: isLoading,
            error: error
        };
    };
    const $79b8f25ce2bada8b$export$491da84e1e953d53 = (hasConnectApps)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const onStart = (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: (0, $81f82fb3b4517b74$export$af5e668651a80140),
            experienceId: cloudId,
            analyticsSource: 'versionDetails'
        });
        (0, $5uXOq.useEffect)(()=>{
            if (hasConnectApps) onStart();
        }, [
            onStart,
            hasConnectApps
        ]);
    };
});
parcelRegister("jsT1l", function(module, exports) {
    $parcel$export(module.exports, "AsyncEditableName", ()=>$6dab25e02275a236$export$9fb8a15f1e2c2f6f);
    var $bEPU3;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $lfTZh;
    var $kxZPA;
    var $Ut4ud;
    var $iYRBg;
    const $6dab25e02275a236$var$LazyEditableName = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("fdSZX")).then((module)=>module.EditableName), {
        moduleId: "./src/packages/releases/version-detail/src/ui/header/editable-name/index.tsx"
    });
    const $6dab25e02275a236$export$9fb8a15f1e2c2f6f = ({ jiraVersion: jiraVersion, isEditing: isEditing, setIsEditing: setIsEditing })=>{
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("bEPU3")).default), jiraVersion);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "editable-name",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iYRBg")).InlineEditReadViewContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Ut4ud")).PageTitle), {
                size: "large",
                as: "h1"
            }, version.name))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6dab25e02275a236$var$LazyEditableName, {
            jiraVersion: version,
            isEditing: isEditing,
            setIsEditing: setIsEditing
        }));
    };
});
parcelRegister("bEPU3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c238223a566204ae$export$2e2bcd8739ae039);
    const $c238223a566204ae$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "async_softwareReleasesVersionDetail_AsyncEditableName",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "FragmentSpread",
                "name": "editableName_softwareReleasesVersionDetail"
            }
        ],
        "type": "JiraVersion"
    };
    $c238223a566204ae$var$node.hash = "72635c9ff5ceeb9dc0fc3b0d03ba28e8";
    var $c238223a566204ae$export$2e2bcd8739ae039 = $c238223a566204ae$var$node;
});
parcelRegister("Ut4ud", function(module, exports) {
    $parcel$export(module.exports, "PageTitle", ()=>$57179de1740dbac6$export$155581e8dc02007a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $l1N8i;
    const $57179de1740dbac6$export$155581e8dc02007a = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("l1N8i")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _19pkidpf _1yt4jjoz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iYRBg", function(module, exports) {
    $parcel$export(module.exports, "InlineEditReadViewContainer", ()=>$2aa25ea7843d2f00$export$408cb7913975dc96);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $2aa25ea7843d2f00$export$408cb7913975dc96 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pku2gc _189eyh40 _1dqonqa1 _1h6d3acm _vwz4kb7n",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fdSZX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("e3LZu").then(()=>parcelRequire('ljMmu'));
});
parcelRegister("gOpVm", function(module, exports) {
    $parcel$export(module.exports, "FeedbackButton", ()=>$4ea271359058491d$export$116fedbe5e2e2bd8);
    var $5uXOq = parcelRequire("5uXOq");
    var $7iULw;
    var $coTzA;
    var $kL4o0;
    const $4ea271359058491d$var$FEEDBACK_COLLECTOR_LOCATION = 'releases.version.detail';
    const $4ea271359058491d$export$116fedbe5e2e2bd8 = ()=>{
        const { simplified: simplified, isProjectAdmin: isProjectAdmin } = (0, (0, parcelRequire("kL4o0")).useProjectContext)();
        const additionalFeedbackEntries = [
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
                value: $4ea271359058491d$var$FEEDBACK_COLLECTOR_LOCATION
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_SIMPLIFIED_PROJECT,
                value: simplified.toString()
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_ADMIN,
                value: isProjectAdmin == null ? 'unknown' : isProjectAdmin.toString()
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("coTzA")).FeedbackCollectorButton), {
            entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
            feedbackContext: additionalFeedbackEntries
        });
    };
});
parcelRegister("coTzA", function(module, exports) {
    $parcel$export(module.exports, "FeedbackCollectorButton", ()=>$85f5e51eda76fbac$export$b39479f42d974760);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $aEHvW;
    var $3bDjY;
    var $koVbs;
    var $koeKL;
    var $7iULw;
    var $dseDh;
    var $4uMrp;
    const $85f5e51eda76fbac$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (appearance === 'icon') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: customLabel || formatMessage((0, (0, parcelRequire("4uMrp")).messages).leaveFeedback),
            position: "top"
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $85f5e51eda76fbac$export$b39479f42d974760 = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, ($parcel$interopDefault((0, parcelRequire("aEHvW"))))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { openFeedbackCollector: openFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const buttonRef = (0, $5uXOq.useRef)(null);
        const onOpen = (0, $5uXOq.useCallback)(()=>{
            const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, (0, parcelRequire("7iULw")).EntryKeys).CLOUD_ID);
            const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
                ...feedbackCollectorProps.feedbackContext || [],
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).CLOUD_ID,
                    value: cloudId
                }
            ];
            openFeedbackCollector({
                ...feedbackCollectorProps,
                feedbackContext: updatedFeedbackContext,
                triggerRef: buttonRef
            });
        }, [
            cloudId,
            feedbackCollectorProps,
            openFeedbackCollector
        ]);
        const displayAsLink = buttonAppearance === 'link';
        return (0, ($parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$TooltipWrapper, {
            appearance: buttonAppearance,
            customLabel: feedbackButtonCustomLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$StyledButton, {
            testId: testId,
            ref: buttonRef,
            appearance: displayAsLink ? 'link' : 'subtle',
            isHighlight: buttonAppearance === 'highlight',
            spacing: displayAsLink ? 'none' : 'default',
            onClick: onOpen,
            iconBefore: displayAsLink ? undefined : (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
                color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
                label: ""
            }),
            "aria-label": buttonAppearance === 'icon' && (feedbackButtonCustomLabel || formatMessage((0, (0, parcelRequire("4uMrp")).messages).leaveFeedback)) || ''
        }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, (0, parcelRequire("4uMrp")).messages).leaveFeedback))));
    };
    const $85f5e51eda76fbac$var$StyledButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.isHighlight && "_1w901gqr _16hg1y1p _1fh11gqr _u1mb1hhp _1l5a1gfe _r7sm8kjj",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aEHvW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));
    var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
    function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>$7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
            LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
        }, props));
    $7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
    var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;
});
parcelRegister("5dqGX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3cc2df171aca9493$var$_UNSAFE_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3cc2df171aca9493$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3cc2df171aca9493$var$FeedbackIcon = (props)=>$3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
        }, props));
    $3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;
});
parcelRegister("3g1Fk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
    function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>$25f4287f17f73dc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
        }, props, {
            newIcon: $25f4287f17f73dc4$var$_feedback.default
        }));
    $25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;
});
parcelRegister("4uMrp", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$0c42512912e196d1$export$defe85febe8b728c);
    var $7VHMR;
    const $0c42512912e196d1$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        leaveFeedback: {
            "id": "platform.feedback.feedback-collector.button.leave-feedback",
            "defaultMessage": "Give feedback"
        }
    });
});
parcelRegister("fbFR6", function(module, exports) {
    $parcel$export(module.exports, "ReleaseNotesButton", ()=>$0ca878f04b56ad47$export$760b84d5e0ebb5da);
    var $f8vkc;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $i8Qvm;
    var $koVbs;
    var $lfTZh;
    var $8zOmE;
    var $hlRDe;
    var $7yldd;
    var $kxZPA;
    var $kHzKl;
    var $8YkQZ;
    var $bfE9A;
    const $0ca878f04b56ad47$var$LazyReleaseNotesModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("aq2MC")).then((module)=>module.ReleaseNotesModal), {
        moduleId: "./src/packages/releases/release-notes-modal/src/index.tsx"
    });
    const $0ca878f04b56ad47$export$760b84d5e0ebb5da = ({ jiraVersion: jiraVersion })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("f8vkc")).default), jiraVersion);
        const [releaseNotesQueryReference, loadReleaseNotesQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("hlRDe")).default));
        const loadReleaseNoteModalResource = ()=>{
            loadReleaseNotesQuery({
                versionAri: version.id
            }, {
                fetchPolicy: 'store-and-network'
            });
            $0ca878f04b56ad47$var$LazyReleaseNotesModal.preload();
        };
        (0, (0, parcelRequire("bfE9A")).useRedirectAutoOpenReleaseModal)(()=>setIsOpen(true), loadReleaseNoteModalResource);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const experienceStart = (0, (0, parcelRequire("7yldd")).useCreateReleaseNotesExperienceStart)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHzKl")).NonCriticalErrorBoundary), {
            eventLocation: "releaseNotesModal",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "release-note-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, releaseNotesQueryReference && isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement($0ca878f04b56ad47$var$LazyReleaseNotesModal, {
            queryReference: releaseNotesQueryReference,
            onClose: ()=>setIsOpen(false)
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onMouseEnter: loadReleaseNoteModalResource,
            onClick: (_, analyticsEvent)=>{
                setIsOpen(true);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionReleaseNotesModal');
                experienceStart();
            }
        }, formatMessage((0, (0, parcelRequire("8YkQZ")).default).releaseNotesButton)));
    };
});
parcelRegister("f8vkc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$154e188d95821d4d$export$2e2bcd8739ae039);
    const $154e188d95821d4d$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "releaseNotesButton_softwareReleasesVersionDetail",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            }
        ],
        "type": "JiraVersion"
    };
    $154e188d95821d4d$var$node.hash = "05a2c1a8fb9ea7ab5acb19f863afe1aa";
    var $154e188d95821d4d$export$2e2bcd8739ae039 = $154e188d95821d4d$var$node;
});
parcelRegister("7yldd", function(module, exports) {
    $parcel$export(module.exports, "useCreateReleaseNotesExperienceStart", ()=>$0488380530c29ab5$export$dbc8ab93f701ba27);
    $parcel$export(module.exports, "useCreateReleaseNotesExperienceFail", ()=>$0488380530c29ab5$export$66c9cef2c6cdd99d);
    $parcel$export(module.exports, "useCreateReleaseNotesExperienceSuccess", ()=>$0488380530c29ab5$export$fe155a48cbacc64a);
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    const $0488380530c29ab5$export$52919046b94109dc = 'createReleaseNotes';
    const $0488380530c29ab5$var$ANALYTICS_SOURCE = 'versionDetails';
    const $0488380530c29ab5$export$dbc8ab93f701ba27 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: $0488380530c29ab5$export$52919046b94109dc,
            experienceId: `${Date.now()}`,
            analyticsSource: $0488380530c29ab5$var$ANALYTICS_SOURCE,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE),
            edition: appEditions.software
        });
    };
    const $0488380530c29ab5$export$66c9cef2c6cdd99d = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $0488380530c29ab5$export$52919046b94109dc
        });
    const $0488380530c29ab5$export$fe155a48cbacc64a = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: $0488380530c29ab5$export$52919046b94109dc
        });
});
parcelRegister("8YkQZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aaf783082c0affe3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $aaf783082c0affe3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        releaseNotesButton: {
            "id": "software-releases-version-detail.header.release-notes-button.release-notes-button",
            "defaultMessage": "Release notes"
        }
    });
});
parcelRegister("bfE9A", function(module, exports) {
    $parcel$export(module.exports, "useRedirectAutoOpenReleaseModal", ()=>$b894304b0fc5bd10$export$83b5462c8aa5c10f);
    var $5uXOq = parcelRequire("5uXOq");
    var $doZTA;
    const $b894304b0fc5bd10$export$83b5462c8aa5c10f = (openModal, loadReleaseNoteModal)=>{
        const [{ query: query }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const hasModalBeenOpened = (0, $5uXOq.useRef)(false);
        if (hasModalBeenOpened.current === false && query.isReleaseNoteModalOpen === 'true') {
            loadReleaseNoteModal();
            openModal();
            hasModalBeenOpened.current = true;
        }
    };
});
parcelRegister("aq2MC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bFKBL").then(()=>parcelRequire('1cnOa'));
});
parcelRegister("6rc5u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6515a95a5b7c8905$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6515a95a5b7c8905$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        browserTitle: {
            "id": "software-releases-version-detail.browser-title",
            "defaultMessage": "{projectName}: {versionName}"
        },
        issues: {
            "id": "software-releases-version-detail.issues",
            "defaultMessage": "Issues"
        }
    });
});
parcelRegister("dcsLh", function(module, exports) {
    $parcel$export(module.exports, "RightSidebar", ()=>$6823825372447de6$export$84d58c19c21f637f);
    var $7efmU;
    var $hoAFQ;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $ahdj0;
    var $ahdj0;
    var $3Tty1;
    var $ousew;
    var $8zOmE;
    var $2NMNM;
    var $2vbty;
    var $lQxdV;
    var $9RZj7;
    var $8Pham;
    const $6823825372447de6$var$getNewCollapsedUis = (currentState, isCurrentlyCollapsed)=>isCurrentlyCollapsed ? currentState.filter((value)=>value !== 'RIGHT_SIDEBAR') : [
            ...currentState,
            'RIGHT_SIDEBAR'
        ];
    const $6823825372447de6$export$84d58c19c21f637f = ({ jiraVersion: jiraVersion, children: children })=>{
        const [state] = (0, (0, parcelRequire("2vbty")).useSidebarStore)();
        const sidebarActions = (0, (0, parcelRequire("2vbty")).useSidebarActions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("hoAFQ")).default), jiraVersion);
        const [updateCollapsedUis] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("7efmU")).default));
        const onError = ()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)({
                meta: {
                    id: 'jira.releases.version.detail.collapsed-uis.user-preference.mutation.error.id',
                    packageName: 'jiraSoftwareReleasesVersionDetail',
                    teamName: 'fusion-solaris'
                },
                error: Error('Unable to update collapsed ui state'),
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const saveUserPreference = (newCollapsedUis)=>{
            updateCollapsedUis({
                variables: {
                    input: {
                        collapsedUis: newCollapsedUis,
                        versionId: version.id
                    }
                },
                onCompleted: (data)=>{
                    if (!data.jira?.saveVersionDetailsCollapsedUis?.success) onError();
                },
                onError: onError,
                optimisticResponse: {
                    jira: {
                        saveVersionDetailsCollapsedUis: {
                            success: true,
                            version: {
                                collapsedUis: newCollapsedUis,
                                id: version.id
                            }
                        }
                    }
                }
            });
        };
        const collapsedUis = (version.collapsedUis ?? []).filter(Boolean);
        const isIssueClosed = state.status === 'CLOSED';
        const isSidebarExpanded = !collapsedUis.includes('RIGHT_SIDEBAR') || !isIssueClosed;
        const keyboardShortcutPressedEvent = createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut'
        });
        const buttonClickedEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const handleChange = (analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionDetailsCollapsibleRightSidebar', {
                targetState: isSidebarExpanded ? 'collapsed' : 'expanded'
            });
            if (!isIssueClosed) sidebarActions.close();
            saveUserPreference($6823825372447de6$var$getNewCollapsedUis(collapsedUis, !isSidebarExpanded));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ahdj0")).default), {
            in: isSidebarExpanded,
            timeout: 100
        }, (transitionState)=>(0, ($parcel$interopDefault($5uXOq))).createElement($6823825372447de6$var$SidebarContainer, {
                isIssueClosed: isIssueClosed,
                transitionState: transitionState
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Tty1")).default), {
                keyMap: {
                    ']': {
                        callback: ()=>handleChange(keyboardShortcutPressedEvent),
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("9RZj7")).messages).resizeKeyboardShortcutLabel)
                    }
                }
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Pham")).ResizeBoundary), {
                isSidebarCollapsed: !isSidebarExpanded,
                onClick: ()=>handleChange(buttonClickedEvent)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Pham")).ResizeButton), {
                isSidebarCollapsed: !isSidebarExpanded,
                onClick: ()=>handleChange(buttonClickedEvent)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($6823825372447de6$var$SidebarContent, {
                isIssueClosed: isIssueClosed,
                transitionState: transitionState
            }, children)));
    };
    const $6823825372447de6$var$enteredTransitionContainerStyle = {
        flex: `0 0 ${(0, (0, parcelRequire("lQxdV")).RIGHT_SIDEBAR_WIDTH)}px`,
        width: `${(0, (0, parcelRequire("lQxdV")).RIGHT_SIDEBAR_WIDTH)}px`
    };
    const $6823825372447de6$var$exitedTransitionContainerStyle = {
        flex: '0 0 0',
        width: `${(0, (0, parcelRequire("lQxdV")).VERSION_DETAIL_PADDING)}px`
    };
    const $6823825372447de6$var$enteredTransitionContentStyle = {
        opacity: 1
    };
    const $6823825372447de6$var$exitedTransitionContentStyle = {
        opacity: 0
    };
    const $6823825372447de6$var$SidebarContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isIssueClosed: isIssueClosed, transitionState: transitionState, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl94b1 _ankwewfl _kqswh2mm _v5645o7y _1g3qkb7n",
                __cmplp.isIssueClosed ? "_1bsblti4" : "_1bsb1dft",
                __cmplp.transitionState === (0, (0, parcelRequire("ahdj0")).ENTERED) && "_16jlidpf _1o9zidpf _i0dl94b1 _1bsblti4",
                __cmplp.transitionState === (0, (0, parcelRequire("ahdj0")).EXITED) && "_16jlidpf _1o9zidpf _i0dlf1ug _1bsb1tcg",
                __cmplp.className
            ])
        });
    });
    const $6823825372447de6$var$SidebarContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isIssueClosed: isIssueClosed, transitionState: transitionState, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _zulppxbi _ca0q1tcg _n3td1tcg _c71l1osq _4t3i1osq _vchhusvi _18m91wug _v564g17y",
                __cmplp.isIssueClosed ? "_19bv1tcg" : "_19bvidpf",
                __cmplp.isIssueClosed ? "_u5f31tcg" : "_u5f3idpf",
                __cmplp.transitionState === (0, (0, parcelRequire("ahdj0")).ENTERED) && "_tzy4kb7n",
                __cmplp.transitionState === (0, (0, parcelRequire("ahdj0")).EXITED) && "_tzy4idpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7efmU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$77aeceef0b995a02$export$2e2bcd8739ae039);
    const $77aeceef0b995a02$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "kind": "ScalarField",
            "name": "collapsedUis"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                                "kind": "LinkedField",
                                "name": "saveVersionDetailsCollapsedUis",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                                "kind": "LinkedField",
                                "name": "saveVersionDetailsCollapsedUis",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "480e364865776dcd2811bc8565bcdbccd9b13a24e85ea6c62e923fb2209d69bf",
                "metadata": {},
                "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $77aeceef0b995a02$var$node.hash = "eae188b16f12cd7a08081363e9d8ba79";
    var $77aeceef0b995a02$export$2e2bcd8739ae039 = $77aeceef0b995a02$var$node;
});
parcelRegister("hoAFQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1ff94c5848b78ac1$export$2e2bcd8739ae039);
    const $1ff94c5848b78ac1$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "rightSidebar_softwareReleasesVersionDetail",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "collapsedUis"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            }
        ],
        "type": "JiraVersion"
    };
    $1ff94c5848b78ac1$var$node.hash = "f6b47df507b4f1c932a991a3cdcfb952";
    var $1ff94c5848b78ac1$export$2e2bcd8739ae039 = $1ff94c5848b78ac1$var$node;
});
parcelRegister("3Tty1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ba57d5dc6c0de0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9IeM0;
    var $4lkOX;
    var $h0GOb;
    var $k4r7E;
    var $9fuVs;
    var $kspvB;
    let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
    let $6ba57d5dc6c0de0a$var$subscription = null;
    const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
        const parentRegistry = (0, $5uXOq.useContext)((0, (0, parcelRequire("9fuVs")).ShortcutRegistryContext)) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                    keyMap: (0, (0, parcelRequire("kspvB")).bindKeyMapWithErrorHandling)(keyMap, location),
                    label: label
                })), [
            label,
            parentRegistry,
            keyMap,
            location
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
            const removeKeyMap = addKeyMap();
            return ()=>{
                removeKeyMap();
                $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
                if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                    $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                    $6ba57d5dc6c0de0a$var$subscription = null;
                }
            };
        }, [
            addKeyMap
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || (0, (0, parcelRequire("h0GOb")).default)().subscribe((0, (0, parcelRequire("4lkOX")).default));
        }, [
            parentRegistry,
            keyMap
        ]);
        return null;
    };
    var $6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, (0, parcelRequire("9IeM0")).useKeyboardShortcutsToggle), ...props })=>{
        const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
        return isEnabled && !false ? (0, ($parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
    };
});
parcelRegister("9IeM0", function(module, exports) {
    $parcel$export(module.exports, "useKeyboardShortcutsToggle", ()=>$dc712fc9bec05022$export$a33a81f1fc5458ad);
    var $jcw0u;
    var $eusud;
    var $j8DrX;
    var $8zOmE;
    var $3sQ5x;
    var $iXqE5;
    const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
    const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
            const currentState = getState().isEnabled;
            const status = currentState ? 'off' : 'on';
            const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)(url);
                setState({
                    isEnabled: !currentState,
                    error: null
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                    isEnabled: !currentState
                });
            } catch (err) {
                setState({
                    error: err
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'keyboardShortcutToggleFailure',
                        packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                    },
                    error: err
                });
            }
        };
    const $dc712fc9bec05022$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            isEnabled: false ? false : !((0, (0, parcelRequire("j8DrX")).default)('ajs-keyboard-shortcuts-enabled') === 'false'),
            error: null
        },
        actions: {
            toggle: $dc712fc9bec05022$export$b62f67be35e65859
        }
    });
    const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, (0, parcelRequire("3sQ5x")).createHook)($dc712fc9bec05022$var$Store);
});
parcelRegister("4lkOX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f11d50ddafbb6f85$export$2e2bcd8739ae039);
    var $h0GOb;
    var $k4r7E;
    const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
    var $f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
        const { sequence: sequence, e: e } = keySequence || {};
        const activeKeyMap = (0, (0, parcelRequire("k4r7E")).rootRegistry).getActiveKeyMap();
        if (sequence !== undefined && activeKeyMap[sequence]) {
            activeKeyMap[sequence].callback(e);
            (0, (0, parcelRequire("h0GOb")).flush)();
        } else {
            const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
            if (!isFutureMatchPossible) (0, (0, parcelRequire("h0GOb")).flush)();
        }
    };
});
parcelRegister("h0GOb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$849cd54ac4017470$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "flush", ()=>$849cd54ac4017470$export$4909b86c8034bf73);
    var $kVLXA = parcelRequire("kVLXA");
    var $cab1K = parcelRequire("cab1K");
    parcelRequire("jG6Un");
    parcelRequire("eSGL3");
    parcelRequire("1oQta");
    parcelRequire("4kRRr");
    parcelRequire("d0pqD");
    parcelRequire("iQCJJ");
    parcelRequire("fjPtF");
    parcelRequire("2R2to");
    var $lIZQG;
    const $849cd54ac4017470$var$ignoredKeys = {
        Control: true,
        Meta: true,
        Shift: true,
        Alt: true,
        AltGraph: true,
        CapsLock: true,
        Fn: true,
        FnLock: true,
        Hyper: true,
        NumLock: true,
        OS: true,
        ScrollLock: true,
        Super: true,
        Symbol: true,
        SymbolLock: true
    };
    const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
    const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
    const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
    const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
        const elBlankets = document.querySelectorAll('.aui-blanket');
        if (elBlankets.length === 0) return true;
        const isAllHidden = Array.from(elBlankets || []).every((el)=>{
            if (el.getAttribute('aria-hidden') === 'true' || el.getAttribute('hidden') !== null) return true;
            return false;
        });
        return isAllHidden;
    };
    let $849cd54ac4017470$var$key$;
    const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
    var $849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
        if (!$849cd54ac4017470$var$key$) {
            $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, (0, parcelRequire("lIZQG")).toKeyWithModifiers));
            const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
                if (!key || !seq) return undefined;
                return {
                    sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                    e: key.e
                };
            });
            $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
        }
        return $849cd54ac4017470$var$key$;
    };
    const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
        $849cd54ac4017470$var$flush$.next();
    };
});
parcelRegister("kspvB", function(module, exports) {
    $parcel$export(module.exports, "bindKeyMapWithErrorHandling", ()=>$f9e30ab2465f6f16$export$77477772a9b904da);
    var $dJl1T;
    const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
            try {
                callback(e);
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
            }
        };
    const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location)=>Object.keys(keyMap).reduce((map, key)=>({
                ...map,
                [key]: {
                    ...keyMap[key],
                    callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
                }
            }), {});
});
parcelRegister("lQxdV", function(module, exports) {
    $parcel$export(module.exports, "VERSION_DETAIL_PADDING", ()=>$75a58ff363b3b383$export$d5ba377dea81dc7b);
    $parcel$export(module.exports, "RIGHT_SIDEBAR_WIDTH", ()=>$75a58ff363b3b383$export$b44ab66843c05a69);
    $parcel$export(module.exports, "VERSION_DESCRIPTION_MAX_NUM_BYTES", ()=>$75a58ff363b3b383$export$4d8870de173841bc);
    var $gwIPs;
    const $75a58ff363b3b383$export$d5ba377dea81dc7b = (0, (0, parcelRequire("gwIPs")).gridSize) * 3;
    const $75a58ff363b3b383$export$b44ab66843c05a69 = 400 + $75a58ff363b3b383$export$d5ba377dea81dc7b * 2;
    const $75a58ff363b3b383$export$4d8870de173841bc = 16384;
});
parcelRegister("9RZj7", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$49119de22bfde519$export$defe85febe8b728c);
    var $7VHMR;
    const $49119de22bfde519$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        resizeKeyboardShortcutLabel: {
            "id": "software-releases-version-detail.right-sidebar.resize-keyboard-shortcut-label",
            "defaultMessage": "Keyboard shortcut \"]\" which used to expand and collapse version details right sidebar"
        }
    });
});
parcelRegister("8Pham", function(module, exports) {
    $parcel$export(module.exports, "ResizeButton", ()=>$1b9b3d6b2e30ce51$export$11aa56de814afc15);
    $parcel$export(module.exports, "ResizeBoundary", ()=>$1b9b3d6b2e30ce51$export$e1ead9bf8a6df70f);
    var $5uXOq = parcelRequire("5uXOq");
    var $nHhrH;
    var $ebd3R;
    var $3bDjY;
    var $koVbs;
    var $bMo05;
    var $eARV2;
    var $lELep;
    const $1b9b3d6b2e30ce51$export$680dc7b2ca125eea = ({ isSidebarCollapsed: isSidebarCollapsed, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const text = isSidebarCollapsed ? formatMessage((0, (0, parcelRequire("eARV2")).messages).expand) : formatMessage((0, (0, parcelRequire("eARV2")).messages).collapse);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lELep")).TooltipNode), {
                text: text,
                char: "]"
            }),
            hideTooltipOnClick: true,
            position: "left"
        }, children);
    };
    const $1b9b3d6b2e30ce51$export$11aa56de814afc15 = ({ isSidebarCollapsed: isSidebarCollapsed, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1b9b3d6b2e30ce51$export$680dc7b2ca125eea, {
            isSidebarCollapsed: isSidebarCollapsed
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lELep")).StyledResizeButton), {
            "aria-expanded": isSidebarCollapsed,
            "aria-label": formatMessage((0, (0, parcelRequire("eARV2")).messages).resizeButtonLabel),
            "data-component-selector": (0, (0, parcelRequire("bMo05")).SIDEBAR_RESIZE_BUTTON_SELECTOR),
            isSidebarCollapsed: isSidebarCollapsed,
            onClick: onClick,
            onMouseDown: (event)=>event.preventDefault()
        }, isSidebarCollapsed ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("nHhrH"))))), {
            label: ""
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ebd3R"))))), {
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lELep")).ExpandedHitArea), null)));
    };
    const $1b9b3d6b2e30ce51$export$e1ead9bf8a6df70f = ({ isSidebarCollapsed: isSidebarCollapsed, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lELep")).ResizeBoundaryButton), {
            "aria-expanded": isSidebarCollapsed,
            "aria-label": formatMessage((0, (0, parcelRequire("eARV2")).messages).resizeBoundaryLabel),
            onClick: onClick,
            onMouseDown: (event)=>event.preventDefault()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lELep")).ResizeBoundaryGrabArea), null));
    };
});
parcelRegister("nHhrH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0473b8ae11c957a6$var$_react = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $0473b8ae11c957a6$var$_chevronLeft = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $0473b8ae11c957a6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0473b8ae11c957a6$var$ChevronLeftIcon = (props)=>$0473b8ae11c957a6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
        }, props, {
            newIcon: $0473b8ae11c957a6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $0473b8ae11c957a6$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $0473b8ae11c957a6$var$_default = module.exports.default = $0473b8ae11c957a6$var$ChevronLeftIcon;
});
parcelRegister("bMo05", function(module, exports) {
    $parcel$export(module.exports, "SIDEBAR_RESIZE_BUTTON_SELECTOR", ()=>$10832837ab733035$export$95fb8edad0b1f6f3);
    var $gwIPs;
    const $10832837ab733035$export$a3e887bc10cd1d66 = 20;
    const $10832837ab733035$export$ee82d44a2323b4c4 = 50;
    const $10832837ab733035$export$b2bcceb1e1e560dd = 10;
    const $10832837ab733035$export$81ca0779fec5584d = 1000;
    const $10832837ab733035$export$d44734fdf1fc9e2d = (0, (0, parcelRequire("gwIPs")).gridSize) * 100;
    const $10832837ab733035$export$9542bc50a2f9f44a = (0, (0, parcelRequire("gwIPs")).gridSize) * 12;
    const $10832837ab733035$export$a3b96bc9b9fa1979 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N30})`;
    const $10832837ab733035$export$5b063914de767703 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N30})`;
    const $10832837ab733035$export$ffab47bcf4a11d42 = `var(--ds-border, ${(0, $829f609a65d26a98$exports).N30})`;
    const $10832837ab733035$export$c27cf3cf2ee81b07 = `var(--ds-background-information-bold, ${(0, $829f609a65d26a98$exports).B400})`;
    const $10832837ab733035$export$14dbcc9140a368ac = `var(--ds-border-information, ${(0, $829f609a65d26a98$exports).B200})`;
    const $10832837ab733035$export$53b2ee28ea173ab6 = `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$exports).G300})`;
    const $10832837ab733035$export$84649994e663ac1b = `var(--ds-border-success, ${(0, $829f609a65d26a98$exports).G300})`;
    const $10832837ab733035$export$bb29a81b503a982c = 'OPEN';
    const $10832837ab733035$export$2fda0856fe66a3c9 = 'DECLINED';
    const $10832837ab733035$export$26d1e2e6f089e8e4 = 'MERGED';
    const $10832837ab733035$export$c50c7c4a5ff445b1 = 5;
    const $10832837ab733035$export$8beb67dd759bbe2 = 5;
    const $10832837ab733035$export$c936349447a77fe0 = 'ARCHIVED';
    const $10832837ab733035$export$95fb8edad0b1f6f3 = 'VersionDetailsRightSidebarResizeButton';
});
parcelRegister("eARV2", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$445fd0de89b2d067$export$defe85febe8b728c);
    var $7VHMR;
    const $445fd0de89b2d067$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        expand: {
            "id": "software-releases-version-detail.right-sidebar.resize-control.expand",
            "defaultMessage": "Expand"
        },
        collapse: {
            "id": "software-releases-version-detail.right-sidebar.resize-control.collapse",
            "defaultMessage": "Collapse"
        },
        resizeButtonLabel: {
            "id": "software-releases-version-detail.right-sidebar.resize-control.resize-button-label",
            "defaultMessage": "Button which can be clicked to expand and collapse the version details right sidebar"
        },
        resizeBoundaryLabel: {
            "id": "software-releases-version-detail.right-sidebar.resize-control.resize-boundary-label",
            "defaultMessage": "Boundary line which can be clicked to expand and collapse the version details right sidebar"
        }
    });
});
parcelRegister("lELep", function(module, exports) {
    $parcel$export(module.exports, "TooltipNode", ()=>$1ee1f5162aea11e4$export$650cc9b24ce3a5c9);
    $parcel$export(module.exports, "StyledResizeButton", ()=>$1ee1f5162aea11e4$export$eaf8b2262a594734);
    $parcel$export(module.exports, "ExpandedHitArea", ()=>$1ee1f5162aea11e4$export$d1ffaae3f3b6a138);
    $parcel$export(module.exports, "ResizeBoundaryButton", ()=>$1ee1f5162aea11e4$export$9d71cd59238427a7);
    $parcel$export(module.exports, "ResizeBoundaryGrabArea", ()=>$1ee1f5162aea11e4$export$f4eedb955e46ab7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gwIPs;
    const $1ee1f5162aea11e4$var$TooltipWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4cvr1q9y _1e0c1txw _vwz4nqt0 _n3td1b66 _ca0q1b66",
                __cmplp.className
            ])
        });
    });
    const $1ee1f5162aea11e4$var$ShortcutWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk53wy _2rkoyh40 _vwz4cjiy _18u01b66 _1yt4rf60",
                __cmplp.className
            ])
        });
    });
    const $1ee1f5162aea11e4$export$650cc9b24ce3a5c9 = ({ text: text, char: char })=>(0, ($parcel$interopDefault($5uXOq))).createElement($1ee1f5162aea11e4$var$TooltipWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, text), (0, ($parcel$interopDefault($5uXOq))).createElement($1ee1f5162aea11e4$var$ShortcutWrapper, null, char));
    const $1ee1f5162aea11e4$var$buttonInteractionStyles = {
        ':hover': {
            backgroundColor: `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$exports).B100})`,
            color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            opacity: 1
        },
        ':active, :focus': {
            backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$exports).B200})`,
            color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            opacity: 1,
            outline: 'none'
        }
    };
    const $1ee1f5162aea11e4$export$eaf8b2262a594734 = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isSidebarCollapsed: isSidebarCollapsed, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_wim4ke": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("gwIPs")).layers).rightSidebar)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk1bhr _19itidpf _2rko1ssb _16qs16ex _syaz1thw _80omtlke _kqswstnw _1bsb1tcg _4t3i1tcg _154ioahv _1ltvxmi2 _12ji1r31 _1qu2glyw _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _t9ec1i34 _v564u1xf _1pbyader _irr315up _30l315cr _16l4kb7n _1di6qfk2 _jomrqfk2 _9h8h15cr _f8pj15cr _1y2zkb7n _1h7hkb7n _1q5t1r31 _nt751r31 _1ohyglyw _49pcglyw _1r9x1o36 _1hvw1o36",
                __cmplp.isSidebarCollapsed ? "_tzy4kb7n" : "_tzy4idpf",
                __cmplp.className
            ])
        });
    });
    const $1ee1f5162aea11e4$export$d1ffaae3f3b6a138 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154ix0bf _1xi2xmi2 _94n5x0bf _1ltvxmi2",
                __cmplp.className
            ])
        });
    });
    const $1ee1f5162aea11e4$export$9d71cd59238427a7 = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkhloo _19itidpf _80omtlke _kqswstnw _12ji1r31 _1qu2glyw _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3i1osq _1bsbyh40 _v5646cel _irr315up _30l315cr _16l4kb7n _1di6qfk2 _jomrqfk2 _9h8h15cr _f8pj15cr _1y2zkb7n _1h7hkb7n _1q5t1r31 _nt751r31 _1ohyglyw _49pcglyw _1r9x1o36 _1hvw1o36",
                __cmplp.className
            ])
        });
    });
    const $1ee1f5162aea11e4$export$f4eedb955e46ab7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_wim4ke": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("gwIPs")).layers).rightSidebar)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154ix0bf _1xi210v4 _94n5idpf _1ltvidpf _1pbyader",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("b6w0L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b4ed99d59324d3aa$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b4ed99d59324d3aa$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        releases: {
            "id": "spa-apps-software-releases-version-detail.releases",
            "defaultMessage": "Releases"
        }
    });
});
parcelRegister("49dAD", function(module, exports) {
    $parcel$export(module.exports, "isNetworkError", ()=>$394c35e901c35f3c$export$476aa014e2fd89d5);
    const $394c35e901c35f3c$var$ERROR_MESSAGE_CHROME = 'Failed to fetch';
    const $394c35e901c35f3c$var$ERROR_MESSAGE_FIREFOX = 'NetworkError when attempting to fetch resource.';
    const $394c35e901c35f3c$var$ERROR_MESSAGE_OTHER = 'Network request failed';
    const $394c35e901c35f3c$var$NetworkErrorMessages = new Set([
        $394c35e901c35f3c$var$ERROR_MESSAGE_CHROME,
        $394c35e901c35f3c$var$ERROR_MESSAGE_FIREFOX,
        $394c35e901c35f3c$var$ERROR_MESSAGE_OTHER
    ]);
    const $394c35e901c35f3c$export$476aa014e2fd89d5 = (error)=>typeof error === 'object' && $394c35e901c35f3c$var$NetworkErrorMessages.has(error.message.replace(/^Network error: (.*)/, '$1'));
});
